//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';
import 'moment-duration-format';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class NotificationPreferencesServiceProxy {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Optional() @Inject(API_BASE_URL) private baseUrl?: string
    ) {
        this.baseUrl = this.baseUrl ?? '';
    }

    obtenerPreferencias(): Observable<any[]> {
        const endpoint = `${this.baseUrl}/api/notification-preferences`;
        return this.http.get<any[]>(endpoint);
    }

    actualizarPreferencias(comando: any): Observable<void> {
        const endpoint = `${this.baseUrl}/api/notification-preferences`;
        return this.http.post<void>(endpoint, comando);
    }
}

@Injectable()
export class UserNotificationsServiceProxy {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Optional() @Inject(API_BASE_URL) private baseUrl?: string
    ) {
        this.baseUrl = this.baseUrl ?? '';
    }

    getNotifications(onlyUnread: boolean = false, take: number = 50): Observable<UserNotificationDto[]> {
        const endpoint = `${this.baseUrl}/api/user-notifications?onlyUnread=${onlyUnread}&take=${take}`;
        return this.http.get<UserNotificationDto[]>(endpoint);
    }

    getUnreadCount(): Observable<number> {
        const endpoint = `${this.baseUrl}/api/user-notifications/unread-count`;
        return this.http.get<number>(endpoint);
    }

    markAsRead(id: number): Observable<void> {
        const endpoint = `${this.baseUrl}/api/user-notifications/${id}/mark-as-read`;
        return this.http.post<void>(endpoint, {});
    }
}

export interface UserNotificationDto {
    id: number;
    alertType: string;
    message: string;
    isRead: boolean;
    createdAt: Date;
    readedAt?: Date;
}

@Injectable()
export class ProgramaProduccionBoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    import(command: { fileBase64: string }): Observable<ImportResultDto> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionBote/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportResultDto>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResultDto>(null as any);
    }

    getList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionBote/getList";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    exportProgramaProduccionBote(dto: ProgramaProduccionBoteExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionBote/Export";
        url_ = url_.replace(/[?&]$/, "");

        // Mapear correctamente usando el método toJSON() si está disponible
        const queryData = dto.toJSON ? dto.toJSON() : dto;
        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProgramaProduccionBote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProgramaProduccionBote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportProgramaProduccionBote(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

@Injectable()
export class LineaTransportistaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/getList";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    get(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/get";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify({ id: id });
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    create(command: any): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    update(command: any): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    delete(command: any): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    reactivate(command: any): Observable<any> {
        let url_ = this.baseUrl + "/api/LineaTransportista/reactivate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    // Procesamiento de la respuesta para reactivar
    protected processReactivate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Procesamiento de la respuesta para eliminar
    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    exportLineaTransportista(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/LineaTransportista/export";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportLineaTransportista(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLineaTransportista(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportLineaTransportista(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        
        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }
        
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

}

@Injectable()
export class PartMexiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getPartsMexiAutocompleterList(query: PartGetListAutocompleteQuery): Observable<PartForListResponse[]> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiAutocompleterList";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiAutocompleterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiAutocompleterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetPartsMexiAutocompleterList(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(null as any);
    }

    getPartsMexiList(query: PartGetListQuery): Observable<PagedResultDtoOfPartForListResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiList";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPartForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPartForListResponse>;
        }));
    }

    protected processGetPartsMexiList(response: HttpResponseBase): Observable<PagedResultDtoOfPartForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPartForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPartForListResponse>(null as any);
    }

    getPartsMexiForEdit(dto: PartGetForEditQuery): Observable<PartForEditResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiForEdit";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartForEditResponse>;
        }));
    }

    protected processGetPartsMexiForEdit(response: HttpResponseBase): Observable<PartForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartForEditResponse>(null as any);
    }

    createPartsMexi(dto: PartCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PartsMexi/CreatePartsMexi";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePartsMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePartsMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePartsMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updatePartsMexi(dto: PartUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PartsMexi/UpdatePartsMexi";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePartsMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartsMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePartsMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPartsMexiForAssortment(dto: PartGetForAssortmentQuery): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiForAssortment";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiForAssortment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiForAssortment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartsMexiForAssortment(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartsMexiById(dto: PartGetByIdQuery): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiById";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartsMexiById(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartsMexiByPartBase(dto: PartGetByPartBaseQuery2): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiByPartBase";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiByPartBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiByPartBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartsMexiByPartBase(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartsMexiLocationList(query: PartLocationGetListQuery): Observable<PagedResultDtoOfPartLocationForListResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiLocationList";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiLocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiLocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPartLocationForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPartLocationForListResponse>;
        }));
    }

    protected processGetPartsMexiLocationList(response: HttpResponseBase): Observable<PagedResultDtoOfPartLocationForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPartLocationForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPartLocationForListResponse>(null as any);
    }

    getPartsMexiLocationListByPart(query: PartLocationGetListByPartQuery): Observable<PartLocationForListResponse[]> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiLocationListByPart";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiLocationListByPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiLocationListByPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartLocationForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartLocationForListResponse[]>;
        }));
    }

    protected processGetPartsMexiLocationListByPart(response: HttpResponseBase): Observable<PartLocationForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartLocationForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartLocationForListResponse[]>(null as any);
    }

    getPartsMexiLocationForEdit(dto: PartLocationGetForEditQuery): Observable<PartLocationForEditResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiLocationForEdit";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartLocationForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartLocationForEditResponse>;
        }));
    }

    protected processGetPartsMexiLocationForEdit(response: HttpResponseBase): Observable<PartLocationForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartLocationForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartLocationForEditResponse>(null as any);
    }

    createPartsMexiLocation(dto: PartLocationCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PartsMexi/CreatePartsMexiLocation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePartsMexiLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePartsMexiLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePartsMexiLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deletePartsMexiLocation(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/PartsMexi/DeletePartsMexiLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePartsMexiLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePartsMexiLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePartsMexiLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPartsMexiPackagePattern(): Observable<PartPackagePatternResponse> {
        let url_ = this.baseUrl + "/api/PartsMexi/GetPartsMexiPackagePattern";
        url_ = url_.replace(/[?&]$/, "");
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartsMexiPackagePattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsMexiPackagePattern(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartPackagePatternResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartPackagePatternResponse>;
        }));
    }

    protected processGetPartsMexiPackagePattern(response: HttpResponseBase): Observable<PartPackagePatternResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartPackagePatternResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartPackagePatternResponse>(null as any);
    }

    importPartsMexi(request: PartImportCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PartsMexi/ImportPartsMexi";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportPartsMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPartsMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportPartsMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}
@Injectable()
export class TenancyDynamicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getAll(): Observable<{ [key: string]: string }> {
        let url_ = this.baseUrl + "/api/TenancyDynamic";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string }>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<{ [key: string]: string }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string }>(null as any);
    }
}
@Injectable()
export class AlertServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    sendAlertMaterialWithoutMovement(): Observable<number> {
        let url_ = this.baseUrl + "/api/Alert/SendAlertMaterialWithoutMovement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAlertMaterialWithoutMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAlertMaterialWithoutMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendAlertMaterialWithoutMovement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    sendAlertMaxMin(): Observable<number> {
        let url_ = this.baseUrl + "/api/Alert/SendAlertMaxMin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAlertMaxMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAlertMaxMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendAlertMaxMin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class AreaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getAreaList(query: AreaGetListQuery): Observable<PagedResultDtoOfAreaForListResponse> {
        let url_ = this.baseUrl + "/api/Area/GetAreaList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAreaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAreaForListResponse>;
        }));
    }

    protected processGetAreaList(response: HttpResponseBase): Observable<PagedResultDtoOfAreaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAreaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAreaForListResponse>(null as any);
    }

    getAreaForEdit(dto: AreaGetForEditQuery): Observable<AreaForEditResponse> {
        let url_ = this.baseUrl + "/api/Area/GetAreaForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaForEditResponse>;
        }));
    }

    protected processGetAreaForEdit(response: HttpResponseBase): Observable<AreaForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaForEditResponse>(null as any);
    }

    getAreaCombo(query: AreaGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Area/GetAreaCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetAreaCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createArea(dto: AreaCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Area/CreateArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateArea(dto: AreaUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Area/UpdateArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getAuditLogList(query: AuditLogGetListQuery): Observable<PagedResultDtoOfAuditLogListResponse> {
        let url_ = this.baseUrl + "/api/AuditLog/GetAuditLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListResponse>;
        }));
    }

    protected processGetAuditLogList(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListResponse>(null as any);
    }

    getAuditLogsToExcel(query: AuditLogGetExcelQuery): Observable<AuditLogExcelResponse> {
        let url_ = this.baseUrl + "/api/AuditLog/GetAuditLogsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogExcelResponse>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<AuditLogExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditLogExcelResponse>(null as any);
    }

    createAuditLogMobile(dto: AuditLogCreateMobileCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/AuditLog/CreateAuditLogMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuditLogMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuditLogMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAuditLogMobile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    login(query: UserLoginQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (query && query.tenancyName) {
            headers["X-Tenancy-Name"] = query.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionLoginResponseController>(null as any);
    }

    loginMovil(query: UserLoginMovilQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/loginmovil";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (query && query.tenancyName) {
            headers["X-Tenancy-Name"] = query.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginMovil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginMovil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processLoginMovil(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionLoginResponseController>(null as any);
    }

    isMovilAuthorizer(query: PermissionGetIsGrantedByTenantUserQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/ismovilauthorizer";
        url_ = url_.replace(/[?&]$/, "");


        const content_ = JSON.stringify(query);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (query && query.tenancyName) {
            headers["X-Tenancy-Name"] = query.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMovilAuthorizer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMovilAuthorizer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processIsMovilAuthorizer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    impersonalizeTenant(query: UserImpersonalizeQuery): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/impersonalizetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonalizeTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonalizeTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processImpersonalizeTenant(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionLoginResponseController>(null as any);
    }

    impersonalizeUser(user: number | undefined): Observable<SessionLoginResponseController> {
        let url_ = this.baseUrl + "/api/auth/impersonalizeuser?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonalizeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonalizeUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SessionLoginResponseController>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SessionLoginResponseController>;
        }));
    }

    protected processImpersonalizeUser(response: HttpResponseBase): Observable<SessionLoginResponseController> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionLoginResponseController.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionLoginResponseController>(null as any);
    }

    validateChangePassword(dto: UserChangePasswordValidateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/validatechangep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (dto && dto.tenancyName) {
            headers["X-Tenancy-Name"] = dto.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processValidateChangePassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    changePassword(dto: UserChangePasswordCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/changep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (dto && dto.tenancyName) {
            headers["X-Tenancy-Name"] = dto.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    resetPassword(dto: UserResetPasswordCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/auth/resetp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);
        
        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (dto && dto.tenancyName) {
            headers["X-Tenancy-Name"] = dto.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    confirmResetPassword(dto: ConfirmPasswordCommandReset): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/confirmresetp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirmResetPassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    isUserActiveMFA(dto: UserIsActiveMFAQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/auth/isuseractivemfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (dto && dto.tenancyName) {
            headers["X-Tenancy-Name"] = dto.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserActiveMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserActiveMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processIsUserActiveMFA(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    sendAuthenticationCode(query: AuthenticationCodeSendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (query && query.tenancyName) {
            headers["X-Tenancy-Name"] = query.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAuthenticationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAuthenticationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendAuthenticationCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getLastCodeSentTime(query: AuthenticationCodeSentTimeByUserIdRequest): Observable<AuthenticationCodeSentTimeResponse> {
        let url_ = this.baseUrl + "/api/auth/codes/last-sent";
        url_ = url_.replace(/[?&]$/, "");


        const content_ = JSON.stringify(query);

        const headers: any = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // Agregar header X-Tenancy-Name con el tenancyName del body
        if (query && query.tenancyName) {
            headers["X-Tenancy-Name"] = query.tenancyName;
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders(headers)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCodeSentTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCodeSentTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticationCodeSentTimeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticationCodeSentTimeResponse>;
        }));
    }

    protected processGetLastCodeSentTime(response: HttpResponseBase): Observable<AuthenticationCodeSentTimeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? AuthenticationCodeSentTimeResponse.fromJS(resultData200) : new AuthenticationCodeSentTimeResponse();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticationCodeSentTimeResponse>(null as any);
    }
}

@Injectable()
export class ChangeLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getChangeLogList(query: ChangeLogGetListQuery): Observable<PagedResultDtoOfChangeLogForListResponse> {
        let url_ = this.baseUrl + "/api/ChangeLog/GetChangeLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChangeLogForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChangeLogForListResponse>;
        }));
    }

    protected processGetChangeLogList(response: HttpResponseBase): Observable<PagedResultDtoOfChangeLogForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChangeLogForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfChangeLogForListResponse>(null as any);
    }
}

@Injectable()
export class CommodityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getCommodityList(query: CommodityGetListQuery): Observable<PagedResultDtoOfCommodityForListResponse> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCommodityForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCommodityForListResponse>;
        }));
    }

    protected processGetCommodityList(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityForListResponse>(null as any);
    }

    getCommodityForEdit(dto: CommodityGetForEditQuery): Observable<CommodityForEditResponse> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommodityForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommodityForEditResponse>;
        }));
    }

    protected processGetCommodityForEdit(response: HttpResponseBase): Observable<CommodityForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommodityForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityForEditResponse>(null as any);
    }

    getCommodityCombo(query: CommodityGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetCommodityCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createCommodity(dto: CommodityCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Commodity/CreateCommodity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCommodity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCommodity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCommodity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateCommodity(dto: CommodityUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Commodity/UpdateCommodity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommodity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommodity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCommodity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getCommodityForAssortment(dto: CommodityGetForAssortmentQuery): Observable<CommodityResponse> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityForAssortment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityForAssortment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityForAssortment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommodityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommodityResponse>;
        }));
    }

    protected processGetCommodityForAssortment(response: HttpResponseBase): Observable<CommodityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommodityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityResponse>(null as any);
    }

    getCommodityForDownloadJit(dto: CommodityGetForDownloadJitQuery): Observable<CommodityResponse> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityForDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityForDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityForDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommodityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommodityResponse>;
        }));
    }

    protected processGetCommodityForDownloadJit(response: HttpResponseBase): Observable<CommodityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommodityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityResponse>(null as any);
    }

    getCommodityById(dto: CommodityGetByIdQuery): Observable<CommodityResponse> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodityById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommodityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommodityResponse>;
        }));
    }

    protected processGetCommodityById(response: HttpResponseBase): Observable<CommodityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommodityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityResponse>(null as any);
    }

    updateCommodityJitSequence(dto: CommodityUpdateJitSequenceCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Commodity/UpdateCommodityJitSequence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommodityJitSequence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommodityJitSequence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCommodityJitSequence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    resetCommodityStockedSequence(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Commodity/ResetCommodityStockedSequence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCommodityStockedSequence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCommodityStockedSequence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResetCommodityStockedSequence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    resetCommodityJITSequence(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Commodity/ResetCommodityJITSequence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCommodityJITSequence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCommodityJITSequence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResetCommodityJITSequence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class CommodityMexiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getCommodityMexiList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/CommodityMexi/GetCommodityMexiList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityMexiList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityMexiList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetCommodityMexiList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    getCommodityMexiForEdit(dto: any): Observable<any> {
        let url_ = this.baseUrl + "/api/CommodityMexi/GetCommodityMexiForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityMexiForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityMexiForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetCommodityMexiForEdit(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    createCommodityMexi(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityMexi/CreateCommodityMexi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCommodityMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateCommodityMexi(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityMexi/UpdateCommodityMexi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCommodityMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteCommodityMexi(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityMexi/DeleteCommodityMexi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteCommodityMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reactivateCommodityMexi(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityMexi/ReactivateCommodityMexi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReactivateCommodityMexi(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportCommodityMexi(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/CommodityMexi/ExportCommodityMexi/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportCommodityMexi(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    importCommodityMexi(command: any): Observable<any> {
        let url_ = this.baseUrl + "/api/CommodityMexi/Import/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCommodityMexi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCommodityMexi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processImportCommodityMexi(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

@Injectable()
export class AlmacenServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getAlmacenList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/Almacen/GetAlmacenList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlmacenList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlmacenList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetAlmacenList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    getAlmacenForEdit(dto: any): Observable<GetAlmacenForEditOutput> {
        let url_ = this.baseUrl + "/api/Almacen/GetAlmacenForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlmacenForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlmacenForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlmacenForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlmacenForEditOutput>;
        }));
    }

    protected processGetAlmacenForEdit(response: HttpResponseBase): Observable<GetAlmacenForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: GetAlmacenForEditOutput = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAlmacenForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlmacenForEditOutput>(null as any);
    }

    createAlmacen(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/Almacen/CreateAlmacen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAlmacen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateAlmacen(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/Almacen/UpdateAlmacen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAlmacen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteAlmacen(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/Almacen/DeleteAlmacen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteAlmacen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reactivateAlmacen(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/Almacen/ReactivateAlmacen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReactivateAlmacen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportAlmacen(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Almacen/ExportAlmacen/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportAlmacen(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

@Injectable()
export class PickListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    generarPickList(commodityId: string | undefined, secuencia: string | undefined): Observable<PickListDataResponse> {
        let url_ = this.baseUrl + "/api/PickList/GenerarPickList?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&";
        if (secuencia === null)
            throw new Error("The parameter 'secuencia' cannot be null.");
        else if (secuencia !== undefined)
            url_ += "secuencia=" + encodeURIComponent("" + secuencia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickListDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickListDataResponse>;
        }));
    }

    protected processGenerarPickList(response: HttpResponseBase): Observable<PickListDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickListDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickListDataResponse>(null as any);
    }

    generarPickListPdf(commodityId: string | undefined, commodityIds: string | undefined, secuencia: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/PickList/Generar/pdf?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&";
        if (commodityIds === null)
            throw new Error("The parameter 'commodityIds' cannot be null.");
        else if (commodityIds !== undefined)
            url_ += "commodityIds=" + encodeURIComponent("" + commodityIds) + "&";
        if (secuencia === null)
            throw new Error("The parameter 'secuencia' cannot be null.");
        else if (secuencia !== undefined)
            url_ += "secuencia=" + encodeURIComponent("" + secuencia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarPickListPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarPickListPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGenerarPickListPdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    generarConteosWipPdf(commodityGrupoId: string | undefined, inventarioMinimo: number | undefined, inventarioMaximo: number | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/PickList/ConteosWIP/pdf?";
        if (commodityGrupoId === null)
            throw new Error("The parameter 'commodityGrupoId' cannot be null.");
        else if (commodityGrupoId !== undefined)
            url_ += "commodityGrupoId=" + encodeURIComponent("" + commodityGrupoId) + "&";
        if (inventarioMinimo === null)
            throw new Error("The parameter 'inventarioMinimo' cannot be null.");
        else if (inventarioMinimo !== undefined)
            url_ += "inventarioMinimo=" + encodeURIComponent("" + inventarioMinimo) + "&";
        if (inventarioMaximo === null)
            throw new Error("The parameter 'inventarioMaximo' cannot be null.");
        else if (inventarioMaximo !== undefined)
            url_ += "inventarioMaximo=" + encodeURIComponent("" + inventarioMaximo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarConteosWipPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarConteosWipPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGenerarConteosWipPdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    generarInventarioZonaCeroPdf(): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/InventarioZonaCero/pdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarInventarioZonaCeroPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarInventarioZonaCeroPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    lastLoads(): Observable<PickListGetLastLoadsResponse> {
        let url_ = this.baseUrl + "/api/PickList/LastLoads/info";

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLastLoads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLastLoads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickListGetLastLoadsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickListGetLastLoadsResponse>;
        }));
    }

    protected processLastLoads(response: HttpResponseBase): Observable<PickListGetLastLoadsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickListGetLastLoadsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickListGetLastLoadsResponse>(null as any);
    }

    protected processGenerarInventarioZonaCeroPdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    generarPickListExcel(commodityId: string | undefined, commodityIds: string | undefined, secuencia: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/PickList/GenerarExcel/excel?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&";
        if (commodityIds === null)
            throw new Error("The parameter 'commodityIds' cannot be null.");
        else if (commodityIds !== undefined)
            url_ += "commodityIds=" + encodeURIComponent("" + commodityIds) + "&";
        if (secuencia === null)
            throw new Error("The parameter 'secuencia' cannot be null.");
        else if (secuencia !== undefined)
            url_ += "secuencia=" + encodeURIComponent("" + secuencia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarPickListExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarPickListExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGenerarPickListExcel(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    generarInventarioDobleWip(commodityId: string | undefined, commodityIds: string | undefined, secuencia: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/PickList/GenerarInventarioDobleWip/inventario-doble-wip?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&";
        if (commodityIds === null)
            throw new Error("The parameter 'commodityIds' cannot be null.");
        else if (commodityIds !== undefined)
            url_ += "commodityIds=" + encodeURIComponent("" + commodityIds) + "&";
        if (secuencia === null)
            throw new Error("The parameter 'secuencia' cannot be null.");
        else if (secuencia !== undefined)
            url_ += "secuencia=" + encodeURIComponent("" + secuencia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerarInventarioDobleWip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarInventarioDobleWip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGenerarInventarioDobleWip(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

@Injectable()
export class CommodityGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getCommodityGroupList(filter: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfCommodityGroupForListResponse> {
        let url_ = this.baseUrl + "/api/CommodityGroup/GetCommodityGroupList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            filter: filter,
            pageNumber: pageNumber,
            pageSize: pageSize,
            sorting: sorting
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityGroupList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityGroupList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCommodityGroupForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCommodityGroupForListResponse>;
        }));
    }

    protected processGetCommodityGroupList(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityGroupForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityGroupForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityGroupForListResponse>(null as any);
    }

    getCommodityGroupForEdit(id: number): Observable<CommodityGroupForEditResponse> {
        let url_ = this.baseUrl + "/api/CommodityGroup/GetCommodityGroupForEdit";
        url_ = url_.replace(/[?&]$/, "");

        if (id === undefined || id === null)
            throw new Error("The parameter 'id' cannot be null.");

        const content_ = JSON.stringify({ id: id });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityGroupForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommodityGroupForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommodityGroupForEditResponse>;
        }));
    }

    protected processGetCommodityGroupForEdit(response: HttpResponseBase): Observable<CommodityGroupForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommodityGroupForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityGroupForEditResponse>(null as any);
    }

    createCommodityGroup(input: CreateCommodityGroupDto): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityGroup/CreateCommodityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCommodityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCommodityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCommodityGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateCommodityGroup(input: UpdateCommodityGroupDto): Observable<void> {
        let url_ = this.baseUrl + "/api/CommodityGroup/UpdateCommodityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommodityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommodityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCommodityGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteCommodityGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/CommodityGroup/DeleteCommodityGroup";
        url_ = url_.replace(/[?&]$/, "");

        if (id === undefined || id === null)
            throw new Error("The parameter 'id' cannot be null.");

        const content_ = JSON.stringify({ id: id });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommodityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommodityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCommodityGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    exportCommodityGroup(query?: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/CommodityGroup/ExportCommodityGroup/export";
        url_ = url_.replace(/[?&]$/, "");
        
        // Si no se proporciona query, usar objeto vacío para exportar todo
        const body = query || {};
        
        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            body: JSON.stringify(body)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommodityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommodityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportCommodityGroup(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    importCommodityGroup(base64: string, fileName: string): Observable<number> {
        let url_ = this.baseUrl + "/api/CommodityGroup/ImportCommodityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            base64: base64,
            fileName: fileName
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCommodityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCommodityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportCommodityGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class CajaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param isPaged (optional) 
     * @return Success
     */
    getCajaList(filter: string | undefined, sorting: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, isPaged: boolean | undefined): Observable<PagedResultDtoOfCajaForListResponse> {
        let url_ = this.baseUrl + "/api/cajas/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            filter: filter, 
            sorting: sorting, 
            pageSize: pageSize, 
            pageNumber: pageNumber,
            isPaged: isPaged 
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCajaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCajaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCajaForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCajaForListResponse>;
        }));
    }

    protected processCajaList(response: HttpResponseBase): Observable<PagedResultDtoOfCajaForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCajaForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCajaForListResponse>(null as any);
    }

    /**
     * @param id 
     * @return Success
     */
    getCajaForEdit(id: number): Observable<CajaForEditResponse> {
        let url_ = this.baseUrl + "/api/cajas/get-for-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ id: id });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCajaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCajaForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CajaForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CajaForEditResponse>;
        }));
    }

    protected processCajaForEdit(response: HttpResponseBase): Observable<CajaForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CajaForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CajaForEditResponse>(null as any);
    }

    /**
     * @param dto 
     * @return Success
     */
    createCaja(dto: CreateCajaDto): Observable<number> {
        let url_ = this.baseUrl + "/api/cajas/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCaja(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param dto 
     * @return Success
     */
    updateCaja(dto: UpdateCajaDto): Observable<number> {
        let url_ = this.baseUrl + "/api/cajas/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCaja(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id 
     * @return Success
     */
    deleteCaja(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/cajas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCaja(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getCajasDashboard(): Observable<CajaDashboardItem[]> {
        let url_ = this.baseUrl + "/api/cajas/dashboard";
        url_ = url_.replace(/[?&]$/, "");
        
        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        
        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCajasDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCajasDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CajaDashboardItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CajaDashboardItem[]>;
        }));
    }

    protected processCajasDashboard(response: HttpResponseBase): Observable<CajaDashboardItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CajaDashboardItem.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CajaDashboardItem[]>(null as any);
    }

    /**
     * Exportar histórico de cajas a Excel
     * @return Excel file as Blob
     */
    exportCajasDashboardToExcel(): Observable<Blob> {
        let url_ = this.baseUrl + "/api/cajas/dashboard/export";  
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCajasDashboardToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCajasDashboardToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportCajasDashboardToExcel(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

export interface IPagedResultDtoOfCajaForListResponse {
    totalCount: number;
    items: CajaForListResponse[] | undefined;
}

export class PagedResultDtoOfCajaForListResponse implements IPagedResultDtoOfCajaForListResponse {
    totalCount!: number;
    items!: CajaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCajaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CajaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCajaForListResponse {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfCajaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICajaForListResponse {
    id: number;
    descripcion: string | undefined;
    placa: string | undefined;
    estado: string | undefined;
    isActive: boolean;
    usuarioRegistroName: string | undefined;
    fechaRegistro: moment.Moment;
}

export class CajaForListResponse implements ICajaForListResponse {
    id!: number;
    descripcion!: string | undefined;
    placa!: string | undefined;
    estado!: string | undefined;
    isActive!: boolean;
    usuarioRegistroName!: string | undefined;
    fechaRegistro!: moment.Moment;

    constructor(data?: ICajaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.placa = _data["placa"];
            this.estado = _data["estado"];
            this.isActive = _data["isActive"];
            this.usuarioRegistroName = _data["usuarioRegistroName"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CajaForListResponse {
        data = typeof data === "object" ? data : {};
        let result = new CajaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["placa"] = this.placa;
        data["estado"] = this.estado;
        data["isActive"] = this.isActive;
        data["usuarioRegistroName"] = this.usuarioRegistroName;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICajaForEditResponse {
    id: number;
    descripcion: string | undefined;
    placa: string | undefined;
    estado: string | undefined;
    isActive: boolean;
    usuarioRegistroId: number;
    usuarioRegistroName: string | undefined;
    fechaRegistro: moment.Moment;
}

export class CajaForEditResponse implements ICajaForEditResponse {
    id!: number;
    descripcion!: string | undefined;
    placa!: string | undefined;
    estado!: string | undefined;
    isActive!: boolean;
    usuarioRegistroId!: number;
    usuarioRegistroName!: string | undefined;
    fechaRegistro!: moment.Moment;

    constructor(data?: ICajaForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.placa = _data["placa"];
            this.estado = _data["estado"];
            this.isActive = _data["isActive"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.usuarioRegistroName = _data["usuarioRegistroName"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CajaForEditResponse {
        data = typeof data === "object" ? data : {};
        let result = new CajaForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["placa"] = this.placa;
        data["estado"] = this.estado;
        data["isActive"] = this.isActive;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["usuarioRegistroName"] = this.usuarioRegistroName;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateCajaDto {
    descripcion: string | undefined;
    placa: string | undefined;
    estado: string | undefined;
    isActive: boolean;
}

export class CreateCajaDto implements ICreateCajaDto {
    descripcion!: string | undefined;
    placa!: string | undefined;
    estado!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateCajaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.placa = _data["placa"];
            this.estado = _data["estado"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateCajaDto {
        data = typeof data === "object" ? data : {};
        let result = new CreateCajaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["descripcion"] = this.descripcion;
        data["placa"] = this.placa;
        data["estado"] = this.estado;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateCajaDto {
    id: number;
    descripcion: string | undefined;
    placa: string | undefined;
    estado: string | undefined;
    isActive: boolean;
}

export class UpdateCajaDto implements IUpdateCajaDto {
    id!: number;
    descripcion!: string | undefined;
    placa!: string | undefined;
    estado!: string | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateCajaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.placa = _data["placa"];
            this.estado = _data["estado"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateCajaDto {
        data = typeof data === "object" ? data : {};
        let result = new UpdateCajaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["placa"] = this.placa;
        data["estado"] = this.estado;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICajaDashboardItem {
    idEmbarque: number;
    estatus: string | undefined;
    fechaEnvio: moment.Moment;
    tiempoTransito: number;
    nombre: string | undefined;
    descripcion: string | undefined;
}

export class CajaDashboardItem implements ICajaDashboardItem {
    idEmbarque!: number;
    estatus!: string | undefined;
    fechaEnvio!: moment.Moment;
    tiempoTransito!: number;
    nombre!: string | undefined;
    descripcion!: string | undefined;

    constructor(data?: ICajaDashboardItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idEmbarque = _data["idEmbarque"];
            this.estatus = _data["estatus"];
            this.fechaEnvio = _data["fechaEnvio"] ? moment(_data["fechaEnvio"].toString()) : <any>undefined;
            this.tiempoTransito = _data["tiempoTransito"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): CajaDashboardItem {
        data = typeof data === "object" ? data : {};
        let result = new CajaDashboardItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["idEmbarque"] = this.idEmbarque;
        data["estatus"] = this.estatus;
        data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : <any>undefined;
        data["tiempoTransito"] = this.tiempoTransito;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

@Injectable()
export class DynamicSelectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60143";
    }

    getOptions(request: DynamicSelectRequest): Observable<DynamicSelectResponse> {
        let url_ = this.baseUrl + "/api/dynamicselect/getoptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicSelectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicSelectResponse>;
        }));
    }

    protected processGetOptions(response: HttpResponseBase): Observable<DynamicSelectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicSelectResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicSelectResponse>(null as any);
    }
}

@Injectable()
export class DownloadScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getDownloadScheduleList(query: DownloadScheduleGetListQuery): Observable<PagedResultDtoOfDownloadScheduleForListResponse> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDownloadScheduleForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDownloadScheduleForListResponse>;
        }));
    }

    protected processGetDownloadScheduleList(response: HttpResponseBase): Observable<PagedResultDtoOfDownloadScheduleForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDownloadScheduleForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDownloadScheduleForListResponse>(null as any);
    }

    getDownloadScheduleForEdit(dto: DownloadScheduleGetForEditQuery): Observable<DownloadScheduleForEditResponse> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadScheduleForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadScheduleForEditResponse>;
        }));
    }

    protected processGetDownloadScheduleForEdit(response: HttpResponseBase): Observable<DownloadScheduleForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadScheduleForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadScheduleForEditResponse>(null as any);
    }

    createDownloadSchedule(dto: DownloadScheduleCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/CreateDownloadSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDownloadSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDownloadSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDownloadSchedule(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateDownloadSchedule(dto: DownloadScheduleUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/UpdateDownloadSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDownloadSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDownloadSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateDownloadSchedule(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getDownloadSchedulePlatformList(query: DownloadSchedulePlatformGetListQuery): Observable<PlatformForListResponse[]> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadSchedulePlatformList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadSchedulePlatformList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadSchedulePlatformList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatformForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatformForListResponse[]>;
        }));
    }

    protected processGetDownloadSchedulePlatformList(response: HttpResponseBase): Observable<PlatformForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlatformForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatformForListResponse[]>(null as any);
    }

    getDownloadSchedulePlatformByStatusList(query: DownloadSchedulePlatformByStatusGetListQuery): Observable<PlatformForListResponse[]> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadSchedulePlatformByStatusList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadSchedulePlatformByStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadSchedulePlatformByStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatformForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatformForListResponse[]>;
        }));
    }

    protected processGetDownloadSchedulePlatformByStatusList(response: HttpResponseBase): Observable<PlatformForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlatformForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatformForListResponse[]>(null as any);
    }

    getDownloadScheduleDetailWithUploadsList(query: DownloadScheduleWithUploadGetListQuery): Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleDetailWithUploadsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleDetailWithUploadsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleDetailWithUploadsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse>;
        }));
    }

    protected processGetDownloadScheduleDetailWithUploadsList(response: HttpResponseBase): Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDownloadScheduleDetailForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDownloadScheduleDetailForListResponse>(null as any);
    }

    getDownloadScheduleDetailWithUploadsByStatusList(query: DownloadScheduleWithUploadByStatusGetListQuery): Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleDetailWithUploadsByStatusList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleDetailWithUploadsByStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleDetailWithUploadsByStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse>;
        }));
    }

    protected processGetDownloadScheduleDetailWithUploadsByStatusList(response: HttpResponseBase): Observable<PagedResultDtoOfDownloadScheduleDetailForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDownloadScheduleDetailForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDownloadScheduleDetailForListResponse>(null as any);
    }

    getDownloadScheduleDetailToExcel(query: DownloadScheduleDetailGetExcelQuery): Observable<DownloadScheduleDetailExcelResponse> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleDetailToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleDetailToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleDetailToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadScheduleDetailExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadScheduleDetailExcelResponse>;
        }));
    }

    protected processGetDownloadScheduleDetailToExcel(response: HttpResponseBase): Observable<DownloadScheduleDetailExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadScheduleDetailExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadScheduleDetailExcelResponse>(null as any);
    }

    getDownloadScheduleDetailPendingGroupedList(query: DownloadScheduleDetailGetPendingGroupedListQuery): Observable<DownloadScheduleDetailForListResponse[]> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleDetailPendingGroupedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleDetailPendingGroupedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleDetailPendingGroupedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadScheduleDetailForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadScheduleDetailForListResponse[]>;
        }));
    }

    protected processGetDownloadScheduleDetailPendingGroupedList(response: HttpResponseBase): Observable<DownloadScheduleDetailForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownloadScheduleDetailForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadScheduleDetailForListResponse[]>(null as any);
    }

    getDownloadScheduleDetailPendingList(query: DownloadScheduleDetailGetPendingListQuery): Observable<DownloadScheduleDetailForListResponse[]> {
        let url_ = this.baseUrl + "/api/DownloadSchedule/GetDownloadScheduleDetailPendingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadScheduleDetailPendingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadScheduleDetailPendingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadScheduleDetailForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadScheduleDetailForListResponse[]>;
        }));
    }

    protected processGetDownloadScheduleDetailPendingList(response: HttpResponseBase): Observable<DownloadScheduleDetailForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownloadScheduleDetailForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadScheduleDetailForListResponse[]>(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getFile(uuid: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/GetFile?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    downloadFileByUUID(uuid: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/DownloadFileByUUID?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileByUUID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileByUUID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadFileByUUID(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    getFileB64(uuid: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/File/GetFileB64?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileB64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileB64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFileB64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    uploadTemp(file: FileParameter | null | undefined): Observable<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/File/UploadTemp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadResponse>;
        }));
    }

    protected processUploadTemp(response: HttpResponseBase): Observable<FileUploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileUploadResponse>(null as any);
    }

    getFileTemp(tempFileName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/GetFileTemp?";
        if (tempFileName !== undefined && tempFileName !== null)
            url_ += "tempFileName=" + encodeURIComponent("" + tempFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetFileTemp(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    downloadTempFile(fileName: string | null | undefined, fileType: string | null | undefined, fileToken: string | null | undefined, downloadName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/DownloadTempFile?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (fileToken !== undefined && fileToken !== null)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        if (downloadName !== undefined && downloadName !== null)
            url_ += "downloadName=" + encodeURIComponent("" + downloadName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadTempFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    downloadTempFilePDF(tempFileName: string | null | undefined, downloadName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/DownloadTempFilePDF?";
        if (tempFileName !== undefined && tempFileName !== null)
            url_ += "tempFileName=" + encodeURIComponent("" + tempFileName) + "&";
        if (downloadName !== undefined && downloadName !== null)
            url_ += "downloadName=" + encodeURIComponent("" + downloadName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFilePDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFilePDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadTempFilePDF(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    getFileList(fileName?: string | null, sorting?: string | null, filter?: string | null, pageSize?: number | null, pageNumber?: number | null, isPaged?: boolean | null, tipoArchivoId?: number | null): Observable<PagedResultDtoOfFileListItem> {
        let url_ = this.baseUrl + "/api/File/GetFileList?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (isPaged !== undefined && isPaged !== null)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (tipoArchivoId !== undefined && tipoArchivoId !== null)
            url_ += "TipoArchivoId=" + encodeURIComponent("" + tipoArchivoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFileListItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFileListItem>;
        }));
    }

    protected processGetFileList(response: HttpResponseBase): Observable<PagedResultDtoOfFileListItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfFileListItem.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFileListItem>(null as any);
    }

    getTipoArchivos(): Observable<PagedResultDtoOfTipoArchivoItem> {
        let url_ = this.baseUrl + "/api/File/GetTipoArchivos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTipoArchivos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipoArchivos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTipoArchivoItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTipoArchivoItem>;
        }));
    }

    protected processGetTipoArchivos(response: HttpResponseBase): Observable<PagedResultDtoOfTipoArchivoItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfTipoArchivoItem.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTipoArchivoItem>(null as any);
    }
}

@Injectable()
export class HelpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getHelpList(query: HelpGetListQuery): Observable<PagedResultDtoOfHelpForListResponse> {
        let url_ = this.baseUrl + "/api/Help/GetHelpList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelpForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelpForListResponse>;
        }));
    }

    protected processGetHelpList(response: HttpResponseBase): Observable<PagedResultDtoOfHelpForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelpForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfHelpForListResponse>(null as any);
    }

    getHelp(id: number): Observable<HelpResponse> {
        let url_ = this.baseUrl + "/api/Help/GetHelp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpResponse>;
        }));
    }

    protected processGetHelp(response: HttpResponseBase): Observable<HelpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HelpResponse>(null as any);
    }

    getHelpByKeyForCurrentUser(key: string | null): Observable<HelpResponse> {
        let url_ = this.baseUrl + "/api/Help/GetHelpByKeyForCurrentUser/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpByKeyForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpByKeyForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpResponse>;
        }));
    }

    protected processGetHelpByKeyForCurrentUser(response: HttpResponseBase): Observable<HelpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HelpResponse>(null as any);
    }

    getHelpForEdit(dto: HelpGetForEditQuery): Observable<HelpForEditResponse> {
        let url_ = this.baseUrl + "/api/Help/GetHelpForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpForEditResponse>;
        }));
    }

    protected processGetHelpForEdit(response: HttpResponseBase): Observable<HelpForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HelpForEditResponse>(null as any);
    }

    createHelp(dto: HelpCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Help/CreateHelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateHelp(dto: HelpUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Help/UpdateHelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteHelp(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Help/DeleteHelp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteHelp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getSettingsForEdit(dto: HostSettingsGetForEditQuery): Observable<HostSettingsForEditResponse> {
        let url_ = this.baseUrl + "/api/HostSettings/GetSettingsForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsForEditResponse>;
        }));
    }

    protected processGetSettingsForEdit(response: HttpResponseBase): Observable<HostSettingsForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsForEditResponse>(null as any);
    }

    updateAllSettings(dto: HostSettingsUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    sendTestEmail(dto: HostSettingsSendTestEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class InventoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getStock(location: number | undefined, part: number | undefined): Observable<StockResponse> {
        let url_ = this.baseUrl + "/api/Inventory/GetStock?";
        if (location === null)
            throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (part === null)
            throw new Error("The parameter 'part' cannot be null.");
        else if (part !== undefined)
            url_ += "part=" + encodeURIComponent("" + part) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockResponse>;
        }));
    }

    protected processGetStock(response: HttpResponseBase): Observable<StockResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockResponse>(null as any);
    }

    isLocationPackageSerieAvaliable(dto: LocationPackageIsSerieAvaliableQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Inventory/IsLocationPackageSerieAvaliable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLocationPackageSerieAvaliable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLocationPackageSerieAvaliable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsLocationPackageSerieAvaliable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getLocationPackageBySerie(dto: LocationPackageGetBySerieQuery): Observable<LocationPackageResponse> {
        let url_ = this.baseUrl + "/api/Inventory/GetLocationPackageBySerie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationPackageBySerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationPackageBySerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationPackageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationPackageResponse>;
        }));
    }

    protected processGetLocationPackageBySerie(response: HttpResponseBase): Observable<LocationPackageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationPackageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationPackageResponse>(null as any);
    }

    createInventoryAdjustment(dto: InventoryAdjustmentCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Inventory/CreateInventoryAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInventoryAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInventoryAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInventoryAdjustment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelInventoryAdjustment(dto: InventoryAdjustmentCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Inventory/CancelInventoryAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInventoryAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInventoryAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelInventoryAdjustment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLanguageList(query: LanguageGetListQuery): Observable<PagedResultDtoOfLanguageForListResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageForListResponse>;
        }));
    }

    protected processGetLanguageList(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageForListResponse>(null as any);
    }

    getLanguage(id: number): Observable<LanguageResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageResponse>;
        }));
    }

    protected processGetLanguage(response: HttpResponseBase): Observable<LanguageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LanguageResponse>(null as any);
    }

    getLanguageForEdit(dto: LanguageGetForEditQuery): Observable<LanguageForEditResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguageForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageForEditResponse>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<LanguageForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LanguageForEditResponse>(null as any);
    }

    createLanguage(dto: LanguageCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Language/CreateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateLanguage(dto: LanguageUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Language/UpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteLanguage(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Language/DeleteLanguage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    setLanguageDefault(language: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Language/SetLanguageDefault?";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLanguageDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLanguageDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetLanguageDefault(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getLanguageTextList(query: LanguageTextGetListQuery): Observable<PagedResultDtoOfLanguageTextForListResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguageTextList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextForListResponse>;
        }));
    }

    protected processGetLanguageTextList(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextForListResponse>(null as any);
    }

    getLanguageText(id: number): Observable<LanguageTextResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguageText/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextResponse>;
        }));
    }

    protected processGetLanguageText(response: HttpResponseBase): Observable<LanguageTextResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LanguageTextResponse>(null as any);
    }

    getLanguageTextForEdit(dto: LanguageTextGetForEditQuery): Observable<LanguageTextForEditResponse> {
        let url_ = this.baseUrl + "/api/Language/GetLanguageTextForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextForEditResponse>;
        }));
    }

    protected processGetLanguageTextForEdit(response: HttpResponseBase): Observable<LanguageTextForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LanguageTextForEditResponse>(null as any);
    }

    updateLanguageText(dto: LanguageTextUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLocationList(query: LocationGetListQuery): Observable<PagedResultDtoOfLocationForListResponse> {
        let url_ = this.baseUrl + "/api/Location/GetLocationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLocationForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLocationForListResponse>;
        }));
    }

    protected processGetLocationList(response: HttpResponseBase): Observable<PagedResultDtoOfLocationForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLocationForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLocationForListResponse>(null as any);
    }

    getLocationForEdit(dto: LocationGetForEditQuery): Observable<LocationForEditResponse> {
        let url_ = this.baseUrl + "/api/Location/GetLocationForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationForEditResponse>;
        }));
    }

    protected processGetLocationForEdit(response: HttpResponseBase): Observable<LocationForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationForEditResponse>(null as any);
    }

    getLocationCombo(query: LocationGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Location/GetLocationCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetLocationCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createLocation(dto: LocationCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Location/CreateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateLocation(dto: LocationUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Location/UpdateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getLocationValidByKey(dto: LocationGetValidByKeyQuery): Observable<LocationResponse> {
        let url_ = this.baseUrl + "/api/Location/GetLocationValidByKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationValidByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationValidByKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationResponse>;
        }));
    }

    protected processGetLocationValidByKey(response: HttpResponseBase): Observable<LocationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationResponse>(null as any);
    }

    getLocationById(dto: LocationGetByIdQuery): Observable<LocationResponse> {
        let url_ = this.baseUrl + "/api/Location/GetLocationById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationResponse>;
        }));
    }

    protected processGetLocationById(response: HttpResponseBase): Observable<LocationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationResponse>(null as any);
    }
}

@Injectable()
export class LocationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLocationTypeList(query: LocationTypeGetListQuery): Observable<PagedResultDtoOfLocationTypeForListResponse> {
        let url_ = this.baseUrl + "/api/LocationType/GetLocationTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLocationTypeForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLocationTypeForListResponse>;
        }));
    }

    protected processGetLocationTypeList(response: HttpResponseBase): Observable<PagedResultDtoOfLocationTypeForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLocationTypeForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLocationTypeForListResponse>(null as any);
    }

    getLocationTypeForEdit(dto: LocationTypeGetForEditQuery): Observable<LocationTypeForEditResponse> {
        let url_ = this.baseUrl + "/api/LocationType/GetLocationTypeForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTypeForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTypeForEditResponse>;
        }));
    }

    protected processGetLocationTypeForEdit(response: HttpResponseBase): Observable<LocationTypeForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTypeForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTypeForEditResponse>(null as any);
    }

    getLocationTypeCombo(query: LocationTypeGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/LocationType/GetLocationTypeCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetLocationTypeCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createLocationType(dto: LocationTypeCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LocationType/CreateLocationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLocationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLocationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateLocationType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateLocationType(dto: LocationTypeUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LocationType/UpdateLocationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateLocationType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    isLocationTypePermissionDelivery(dto: LocationTypeGetIsPermissionDeliveryQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/LocationType/IsLocationTypePermissionDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLocationTypePermissionDelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLocationTypePermissionDelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsLocationTypePermissionDelivery(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class LockServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLockList(query: LockGetListQuery): Observable<PagedResultDtoOfLockForListResponse> {
        let url_ = this.baseUrl + "/api/Lock/GetLockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLockList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLockForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLockForListResponse>;
        }));
    }

    protected processGetLockList(response: HttpResponseBase): Observable<PagedResultDtoOfLockForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLockForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLockForListResponse>(null as any);
    }

    lock(dto: LockCommand): Observable<LockForLockResponse> {
        let url_ = this.baseUrl + "/api/Lock/Lock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LockForLockResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LockForLockResponse>;
        }));
    }

    protected processLock(response: HttpResponseBase): Observable<LockForLockResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockForLockResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LockForLockResponse>(null as any);
    }

    isLockAvaliable(dto: LockIsAvaliableQuery): Observable<LockIsAvaliableResponse> {
        let url_ = this.baseUrl + "/api/Lock/IsLockAvaliable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLockAvaliable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLockAvaliable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LockIsAvaliableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LockIsAvaliableResponse>;
        }));
    }

    protected processIsLockAvaliable(response: HttpResponseBase): Observable<LockIsAvaliableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockIsAvaliableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LockIsAvaliableResponse>(null as any);
    }

    isLockedBySession(dto: LockIsLockedBySessionQuery): Observable<LockIsLockedBySessionResponse> {
        let url_ = this.baseUrl + "/api/Lock/IsLockedBySession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLockedBySession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLockedBySession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LockIsLockedBySessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LockIsLockedBySessionResponse>;
        }));
    }

    protected processIsLockedBySession(response: HttpResponseBase): Observable<LockIsLockedBySessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockIsLockedBySessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LockIsLockedBySessionResponse>(null as any);
    }

    unlock(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Lock/Unlock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUnlock(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    unlockLocked(dto: UnlockLockedCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Lock/UnlockLocked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUnlockLocked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getLockLogList(query: LockLogGetListQuery): Observable<PagedResultDtoOfLockLogForListResponse> {
        let url_ = this.baseUrl + "/api/Lock/GetLockLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLockLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLockLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLockLogForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLockLogForListResponse>;
        }));
    }

    protected processGetLockLogList(response: HttpResponseBase): Observable<PagedResultDtoOfLockLogForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLockLogForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLockLogForListResponse>(null as any);
    }

    getLockLogToExcel(query: LockLogGetExcelQuery): Observable<LockLogExcelResponse> {
        let url_ = this.baseUrl + "/api/Lock/GetLockLogToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLockLogToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLockLogToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LockLogExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LockLogExcelResponse>;
        }));
    }

    protected processGetLockLogToExcel(response: HttpResponseBase): Observable<LockLogExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockLogExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LockLogExcelResponse>(null as any);
    }
}

@Injectable()
export class MailGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getMailGroupList(query: MailGroupGetListQuery): Observable<PagedResultDtoOfMailGroupListResponse> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailGroupList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailGroupList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailGroupList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailGroupListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailGroupListResponse>;
        }));
    }

    protected processGetMailGroupList(response: HttpResponseBase): Observable<PagedResultDtoOfMailGroupListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailGroupListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMailGroupListResponse>(null as any);
    }

    createMailGroup(dto: MailGroupCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/CreateMailGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateMailGroup(dto: MailGroupUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/UpdateMailGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getMailGroupForEdit(dto: MailGroupGetForEditQuery): Observable<MailGroupForEditResponse> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailGroupForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailGroupForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailGroupForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailGroupForEditResponse>;
        }));
    }

    protected processGetMailGroupForEdit(response: HttpResponseBase): Observable<MailGroupForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailGroupForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MailGroupForEditResponse>(null as any);
    }

    copyMailGroup(dto: MailGroupCopyCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/CopyMailGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCopyMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    checkMailGroup(dto: MailGroupCheckCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/CheckMailGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    unCheckMailGroup(dto: MailGroupUnCheckCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/UnCheckMailGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnCheckMailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnCheckMailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnCheckMailGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getMailTemplateList(query: MailTemplateGetListQuery): Observable<PagedResultDtoOfMailTemplateListResponse> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailTemplateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailTemplateListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailTemplateListResponse>;
        }));
    }

    protected processGetMailTemplateList(response: HttpResponseBase): Observable<PagedResultDtoOfMailTemplateListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailTemplateListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMailTemplateListResponse>(null as any);
    }

    createMailTemplate(dto: MailTemplateCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/CreateMailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMailTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateMailTemplate(dto: MailTemplateUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/UpdateMailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getMailTemplateForEdit(dto: MailTemplateGetForEditQuery): Observable<MailTemplateForEditResponse> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailTemplateForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailTemplateForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailTemplateForEditResponse>;
        }));
    }

    protected processGetMailTemplateForEdit(response: HttpResponseBase): Observable<MailTemplateForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailTemplateForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MailTemplateForEditResponse>(null as any);
    }

    sendTestEmail(dto: MailTemplateSendTestCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MailGroup/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getMailTemplateGetBodyParamList(query: MailTemplateGetBodyParamListQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailTemplateGetBodyParamList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateGetBodyParamList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateGetBodyParamList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetMailTemplateGetBodyParamList(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(null as any);
    }

    getMailTemplateGetMailKeyAvailableList(query: MailTemplateGetMailKeyAvailableListQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/MailGroup/GetMailTemplateGetMailKeyAvailableList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailTemplateGetMailKeyAvailableList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailTemplateGetMailKeyAvailableList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetMailTemplateGetMailKeyAvailableList(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class OrgUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getOrgUnitList(query: OrgUnitGetListQuery): Observable<PagedResultDtoOfOrgUnitForListResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnitList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrgUnitForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrgUnitForListResponse>;
        }));
    }

    protected processGetOrgUnitList(response: HttpResponseBase): Observable<PagedResultDtoOfOrgUnitForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrgUnitForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrgUnitForListResponse>(null as any);
    }

    getOrgUnitByParentOUList(parentOU: number | undefined): Observable<OrgUnitForListResponse[]> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnitByParentOUList?";
        if (parentOU === null)
            throw new Error("The parameter 'parentOU' cannot be null.");
        else if (parentOU !== undefined)
            url_ += "parentOU=" + encodeURIComponent("" + parentOU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitByParentOUList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitByParentOUList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitForListResponse[]>;
        }));
    }

    protected processGetOrgUnitByParentOUList(response: HttpResponseBase): Observable<OrgUnitForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgUnitForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgUnitForListResponse[]>(null as any);
    }

    getOrgUnit(id: number): Observable<OrgUnitResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitResponse>;
        }));
    }

    protected processGetOrgUnit(response: HttpResponseBase): Observable<OrgUnitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrgUnitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgUnitResponse>(null as any);
    }

    getOrgUnitCombo(query: OrgUnitGetComboQuery): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnitCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetOrgUnitCombo(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(null as any);
    }

    getOrgUnitForEdit(dto: OrgUnitGetForEditQuery): Observable<OrgUnitForEditResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnitForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgUnitForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgUnitForEditResponse>;
        }));
    }

    protected processGetOrgUnitForEdit(response: HttpResponseBase): Observable<OrgUnitForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrgUnitForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgUnitForEditResponse>(null as any);
    }

    createOrgUnit(dto: OrgUnitCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/OrgUnit/CreateOrgUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateOrgUnit(dto: OrgUnitUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/OrgUnit/UpdateOrgUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteOrgUnit(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/OrgUnit/DeleteOrgUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrgUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrgUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteOrgUnit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getOrgUnitUserList(query: OrgUnitUserGetListQuery): Observable<PagedResultDtoOfOrgUnitUserForListResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/GetOrgUnitUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgUnitUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgUnitUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrgUnitUserForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrgUnitUserForListResponse>;
        }));
    }

    protected processGetOrgUnitUserList(response: HttpResponseBase): Observable<PagedResultDtoOfOrgUnitUserForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrgUnitUserForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrgUnitUserForListResponse>(null as any);
    }

    createOrgUnitUser(dto: OrgUnitUserCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/OrgUnit/CreateOrgUnitUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrgUnitUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrgUnitUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrgUnitUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteOrgUnitUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/OrgUnit/DeleteOrgUnitUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrgUnitUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrgUnitUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteOrgUnitUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getPermissionsTree(): Observable<Permission> {
        let url_ = this.baseUrl + "/api/Permission/GetPermissionsTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Permission>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Permission>;
        }));
    }

    protected processGetPermissionsTree(response: HttpResponseBase): Observable<Permission> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Permission>(null as any);
    }

    getPermissionIsGranted(query: PermissionGetIsGrantedQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Permission/GetPermissionIsGranted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionIsGranted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionIsGranted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetPermissionIsGranted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class PlatformServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getPlatformList(query: PlatformGetListQuery): Observable<PagedResultDtoOfPlatformForListResponse> {
        let url_ = this.baseUrl + "/api/Platform/GetPlatformList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPlatformForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPlatformForListResponse>;
        }));
    }

    protected processGetPlatformList(response: HttpResponseBase): Observable<PagedResultDtoOfPlatformForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlatformForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlatformForListResponse>(null as any);
    }

    getPlatformForEdit(dto: PlatformGetForEditQuery): Observable<PlatformForEditResponse> {
        let url_ = this.baseUrl + "/api/Platform/GetPlatformForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatformForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatformForEditResponse>;
        }));
    }

    protected processGetPlatformForEdit(response: HttpResponseBase): Observable<PlatformForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlatformForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatformForEditResponse>(null as any);
    }

    createPlatform(dto: PlatformCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Platform/CreatePlatform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlatform(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlatform(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updatePlatform(dto: PlatformUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Platform/UpdatePlatform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlatform(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePlatform(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPlatformCombo(query: PlatformGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Platform/GetPlatformCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetPlatformCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    getPlatformWindowCombo(query: PlatformWindowGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Platform/GetPlatformWindowCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformWindowCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformWindowCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetPlatformWindowCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    validatePlatformWindowForDelete(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Platform/ValidatePlatformWindowForDelete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePlatformWindowForDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePlatformWindowForDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processValidatePlatformWindowForDelete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ReasonRestartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getReasonRestartCombo(query: ReasonRestartGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/ReasonRestart/GetReasonRestartCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonRestartCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonRestartCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetReasonRestartCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    getReasonRestart(id: number): Observable<ReasonRestartResponse> {
        let url_ = this.baseUrl + "/api/ReasonRestart/GetReasonRestart/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonRestart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonRestart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReasonRestartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReasonRestartResponse>;
        }));
    }

    protected processGetReasonRestart(response: HttpResponseBase): Observable<ReasonRestartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReasonRestartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReasonRestartResponse>(null as any);
    }
}

@Injectable()
export class RegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    create(dto: TenantCreateRegistrationCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/register/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    confirm(dto: TenantConfirmRegistrationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/register/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getReportStockedList(query: ReportStockedGetListQuery): Observable<PagedResultDtoOfReportStockedForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportStockedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportStockedForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportStockedForListResponse>;
        }));
    }

    protected processGetReportStockedList(response: HttpResponseBase): Observable<PagedResultDtoOfReportStockedForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportStockedForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportStockedForListResponse>(null as any);
    }

    getReportStockedToExcel(query: ReportStockedGetExcelQuery): Observable<ReportStockedExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportStockedToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockedToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockedToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportStockedExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportStockedExcelResponse>;
        }));
    }

    protected processGetReportStockedToExcel(response: HttpResponseBase): Observable<ReportStockedExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportStockedExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportStockedExcelResponse>(null as any);
    }

    getReportDownloadList(query: ReportDownloadGetListQuery): Observable<PagedResultDtoOfReportDownloadForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportDownloadList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDownloadList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDownloadList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportDownloadForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportDownloadForListResponse>;
        }));
    }

    protected processGetReportDownloadList(response: HttpResponseBase): Observable<PagedResultDtoOfReportDownloadForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDownloadForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDownloadForListResponse>(null as any);
    }

    getReportDownloadToExcel(query: ReportDownloadGetExcelQuery): Observable<ReportDownloadExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportDownloadToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDownloadToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDownloadToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDownloadExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDownloadExcelResponse>;
        }));
    }

    protected processGetReportDownloadToExcel(response: HttpResponseBase): Observable<ReportDownloadExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDownloadExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDownloadExcelResponse>(null as any);
    }

    getReportPutawayList(query: ReportPutawayGetListQuery): Observable<PagedResultDtoOfReportPutawayForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportPutawayList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPutawayList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPutawayList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportPutawayForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportPutawayForListResponse>;
        }));
    }

    protected processGetReportPutawayList(response: HttpResponseBase): Observable<PagedResultDtoOfReportPutawayForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportPutawayForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportPutawayForListResponse>(null as any);
    }

    getReportPutawayToExcel(query: ReportPutawayGetExcelQuery): Observable<ReportPutawayExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportPutawayToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPutawayToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPutawayToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportPutawayExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportPutawayExcelResponse>;
        }));
    }

    protected processGetReportPutawayToExcel(response: HttpResponseBase): Observable<ReportPutawayExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPutawayExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportPutawayExcelResponse>(null as any);
    }

    getReportJITList(query: ReportJITGetListQuery): Observable<PagedResultDtoOfReportJITForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportJITList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportJITList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportJITList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportJITForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportJITForListResponse>;
        }));
    }

    protected processGetReportJITList(response: HttpResponseBase): Observable<PagedResultDtoOfReportJITForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportJITForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportJITForListResponse>(null as any);
    }

    getReportJITToExcel(query: ReportJITGetExcelQuery): Observable<ReportJITExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportJITToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportJITToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportJITToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportJITExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportJITExcelResponse>;
        }));
    }

    protected processGetReportJITToExcel(response: HttpResponseBase): Observable<ReportJITExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportJITExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportJITExcelResponse>(null as any);
    }

    getReportEmptyList(query: ReportEmptyGetListQuery): Observable<PagedResultDtoOfReportEmptyForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportEmptyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportEmptyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportEmptyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportEmptyForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportEmptyForListResponse>;
        }));
    }

    protected processGetReportEmptyList(response: HttpResponseBase): Observable<PagedResultDtoOfReportEmptyForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportEmptyForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportEmptyForListResponse>(null as any);
    }

    getReportEmptyToExcel(query: ReportEmptyGetExcelQuery): Observable<ReportEmptyExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportEmptyToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportEmptyToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportEmptyToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportEmptyExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportEmptyExcelResponse>;
        }));
    }

    protected processGetReportEmptyToExcel(response: HttpResponseBase): Observable<ReportEmptyExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportEmptyExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportEmptyExcelResponse>(null as any);
    }

    getReportLocationStockList(query: ReportLocationStockGetListQuery): Observable<PagedResultDtoOfReportLocationStockForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportLocationStockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportLocationStockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportLocationStockList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportLocationStockForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportLocationStockForListResponse>;
        }));
    }

    protected processGetReportLocationStockList(response: HttpResponseBase): Observable<PagedResultDtoOfReportLocationStockForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportLocationStockForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportLocationStockForListResponse>(null as any);
    }

    getReportLocationStockToExcel(query: ReportLocationStockGetExcelQuery): Observable<ReportLocationStockExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportLocationStockToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportLocationStockToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportLocationStockToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportLocationStockExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportLocationStockExcelResponse>;
        }));
    }

    protected processGetReportLocationStockToExcel(response: HttpResponseBase): Observable<ReportLocationStockExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportLocationStockExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportLocationStockExcelResponse>(null as any);
    }

    getReportWarehouseMovementList(query: ReportWarehouseMovementGetListQuery): Observable<PagedResultDtoOfReportWarehouseMovementForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportWarehouseMovementList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportWarehouseMovementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportWarehouseMovementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportWarehouseMovementForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportWarehouseMovementForListResponse>;
        }));
    }

    protected processGetReportWarehouseMovementList(response: HttpResponseBase): Observable<PagedResultDtoOfReportWarehouseMovementForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportWarehouseMovementForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportWarehouseMovementForListResponse>(null as any);
    }

    getReportWarehouseMovementToExcel(query: ReportWarehouseMovementGetExcelQuery): Observable<ReportWarehouseMovementExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportWarehouseMovementToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportWarehouseMovementToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportWarehouseMovementToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportWarehouseMovementExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportWarehouseMovementExcelResponse>;
        }));
    }

    protected processGetReportWarehouseMovementToExcel(response: HttpResponseBase): Observable<ReportWarehouseMovementExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportWarehouseMovementExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportWarehouseMovementExcelResponse>(null as any);
    }

    getReportTimeInStockList(query: ReportTimeInStockGetListQuery): Observable<PagedResultDtoOfReportTimeInStockForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportTimeInStockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTimeInStockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTimeInStockList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportTimeInStockForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportTimeInStockForListResponse>;
        }));
    }

    protected processGetReportTimeInStockList(response: HttpResponseBase): Observable<PagedResultDtoOfReportTimeInStockForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportTimeInStockForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportTimeInStockForListResponse>(null as any);
    }

    getReportTimeInStockToExcel(query: ReportTimeInStockGetExcelQuery): Observable<ReportTimeInStockExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportTimeInStockToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTimeInStockToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTimeInStockToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTimeInStockExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTimeInStockExcelResponse>;
        }));
    }

    protected processGetReportTimeInStockToExcel(response: HttpResponseBase): Observable<ReportTimeInStockExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportTimeInStockExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportTimeInStockExcelResponse>(null as any);
    }

    getReportMaxMinList(query: ReportMaxMinGetListQuery): Observable<PagedResultDtoOfReportMaxMinForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportMaxMinList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMaxMinList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMaxMinList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportMaxMinForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportMaxMinForListResponse>;
        }));
    }

    protected processGetReportMaxMinList(response: HttpResponseBase): Observable<PagedResultDtoOfReportMaxMinForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportMaxMinForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportMaxMinForListResponse>(null as any);
    }

    getReportMaxMinToExcel(query: ReportMaxMinGetExcelQuery): Observable<ReportMaxMinExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportMaxMinToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMaxMinToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMaxMinToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportMaxMinExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportMaxMinExcelResponse>;
        }));
    }

    protected processGetReportMaxMinToExcel(response: HttpResponseBase): Observable<ReportMaxMinExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportMaxMinExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportMaxMinExcelResponse>(null as any);
    }

    getReportActivityList(query: ReportActivityGetListQuery): Observable<PagedResultDtoOfReportActivityForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportActivityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportActivityForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportActivityForListResponse>;
        }));
    }

    protected processGetReportActivityList(response: HttpResponseBase): Observable<PagedResultDtoOfReportActivityForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportActivityForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportActivityForListResponse>(null as any);
    }

    getReportActivityToExcel(query: ReportActivityGetExcelQuery): Observable<ReportActivityExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportActivityToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportActivityToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportActivityToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportActivityExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportActivityExcelResponse>;
        }));
    }

    protected processGetReportActivityToExcel(response: HttpResponseBase): Observable<ReportActivityExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportActivityExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportActivityExcelResponse>(null as any);
    }

    getReportSupplyCardDeliveryList(query: ReportSupplyCardDeliveryGetListQuery): Observable<PagedResultDtoOfReportSupplyCardDeliveryForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportSupplyCardDeliveryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSupplyCardDeliveryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSupplyCardDeliveryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportSupplyCardDeliveryForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportSupplyCardDeliveryForListResponse>;
        }));
    }

    protected processGetReportSupplyCardDeliveryList(response: HttpResponseBase): Observable<PagedResultDtoOfReportSupplyCardDeliveryForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportSupplyCardDeliveryForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportSupplyCardDeliveryForListResponse>(null as any);
    }

    getReportSupplyCardDeliveryToExcel(query: ReportSupplyCardDeliveryGetExcelQuery): Observable<ReportSupplyCardDeliveryExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportSupplyCardDeliveryToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSupplyCardDeliveryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSupplyCardDeliveryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportSupplyCardDeliveryExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportSupplyCardDeliveryExcelResponse>;
        }));
    }

    protected processGetReportSupplyCardDeliveryToExcel(response: HttpResponseBase): Observable<ReportSupplyCardDeliveryExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportSupplyCardDeliveryExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportSupplyCardDeliveryExcelResponse>(null as any);
    }

    getReportReasonRestartLogList(query: ReportReasonRestartLogGetListQuery): Observable<PagedResultDtoOfReportReasonRestartLogForListResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportReasonRestartLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportReasonRestartLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportReasonRestartLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportReasonRestartLogForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportReasonRestartLogForListResponse>;
        }));
    }

    protected processGetReportReasonRestartLogList(response: HttpResponseBase): Observable<PagedResultDtoOfReportReasonRestartLogForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportReasonRestartLogForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportReasonRestartLogForListResponse>(null as any);
    }

    getReportReasonRestartLogToExcel(query: ReportReasonRestartLogGetExcelQuery): Observable<ReportReasonRestartLogExcelResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportReasonRestartLogToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportReasonRestartLogToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportReasonRestartLogToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportReasonRestartLogExcelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportReasonRestartLogExcelResponse>;
        }));
    }

    protected processGetReportReasonRestartLogToExcel(response: HttpResponseBase): Observable<ReportReasonRestartLogExcelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportReasonRestartLogExcelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportReasonRestartLogExcelResponse>(null as any);
    }

    getInventarioZonaCero(): Observable<InventarioZonaCeroResponse> {
        let url_ = this.baseUrl + "/api/Report/GetInventarioZonaCero/inventario-zona-cero";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventarioZonaCero(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventarioZonaCero(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventarioZonaCeroResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventarioZonaCeroResponse>;
        }));
    }

    protected processGetInventarioZonaCero(response: HttpResponseBase): Observable<InventarioZonaCeroResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventarioZonaCeroResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventarioZonaCeroResponse>(null as any);
    }

    getReporteFaltantesDolly(fechaInicio?: Date | undefined, fechaFin?: Date | undefined, secuenciaInicio?: string | undefined, secuenciaFin?: string | undefined, causaFaltanteId?: number | undefined, numeroParte?: string | undefined, commodity?: string | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, programaId?: number | undefined): Observable<FaltantesDollyResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReporteFaltantesDolly/faltantes-dolly?";
        if (fechaInicio === null)
            throw new Error("The parameter 'fechaInicio' cannot be null.");
        else if (fechaInicio !== undefined)
            url_ += "fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : "") + "&";
        if (fechaFin === null)
            throw new Error("The parameter 'fechaFin' cannot be null.");
        else if (fechaFin !== undefined)
            url_ += "fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : "") + "&";
        if (secuenciaInicio !== undefined)
            url_ += "secuenciaInicio=" + encodeURIComponent("" + secuenciaInicio) + "&";
        if (secuenciaFin !== undefined)
            url_ += "secuenciaFin=" + encodeURIComponent("" + secuenciaFin) + "&";
        if (causaFaltanteId !== undefined)
            url_ += "causaFaltanteId=" + encodeURIComponent("" + causaFaltanteId) + "&";
        if (numeroParte !== undefined)
            url_ += "numeroParte=" + encodeURIComponent("" + numeroParte) + "&";
        if (commodity !== undefined)
            url_ += "commodity=" + encodeURIComponent("" + commodity) + "&";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (programaId !== undefined)
            url_ += "programaId=" + encodeURIComponent("" + programaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReporteFaltantesDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReporteFaltantesDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaltantesDollyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaltantesDollyResponse>;
        }));
    }

    protected processGetReporteFaltantesDolly(response: HttpResponseBase): Observable<FaltantesDollyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FaltantesDollyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FaltantesDollyResponse>(null as any);
    }

    exportReporteFaltantesDolly(query: FaltantesDollyExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/ExportReporteFaltantesDolly/faltantes-dolly/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReporteFaltantesDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReporteFaltantesDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportReporteFaltantesDolly(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    getTablaProductividadList(desde?: Date | null, hasta?: Date | null, programa?: string | null, commodity?: string | null, secuenciaInicio?: string | null, secuenciaFin?: string | null, pageNumber?: number | null, pageSize?: number | null, sorting?: string | null): Observable<TablaProductividadResponse> {
        let url_ = this.baseUrl + "/api/Report/TablaProductividad/list?";
        
        if (desde !== undefined && desde !== null) {
            const fechaDesde = typeof desde === 'string' ? desde : desde.toISOString();
            url_ += "desde=" + encodeURIComponent(fechaDesde) + "&";
        }
        if (hasta !== undefined && hasta !== null) {
            const fechaHasta = typeof hasta === 'string' ? hasta : hasta.toISOString();
            url_ += "hasta=" + encodeURIComponent(fechaHasta) + "&";
        }
        if (programa !== undefined && programa !== null)
            url_ += "programa=" + encodeURIComponent("" + programa) + "&";
        if (commodity !== undefined && commodity !== null)
            url_ += "commodity=" + encodeURIComponent("" + commodity) + "&";
        if (secuenciaInicio !== undefined && secuenciaInicio !== null)
            url_ += "secuenciaInicio=" + encodeURIComponent("" + secuenciaInicio) + "&";
        if (secuenciaFin !== undefined && secuenciaFin !== null)
            url_ += "secuenciaFin=" + encodeURIComponent("" + secuenciaFin) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTablaProductividadList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTablaProductividadList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TablaProductividadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TablaProductividadResponse>;
        }));
    }

    protected processGetTablaProductividadList(response: HttpResponseBase): Observable<TablaProductividadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TablaProductividadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TablaProductividadResponse>(null as any);
    }

    exportProductividadToExcel(query: TablaProductividadExportQuery): Observable<TablaProductividadExportResponse> {
        let url_ = this.baseUrl + "/api/Report/Productividad/list/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportProductividadToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductividadToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TablaProductividadExportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TablaProductividadExportResponse>;
        }));
    }

    exportProductividadToExcelBlob(query: TablaProductividadExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/Productividad/list/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }),
            // Aumentar timeout para exportación blob de productividad de hasta 20 minutos
            timeout: 1200000
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportProductividadToExcelBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductividadToExcelBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportProductividadToExcel(response: HttpResponseBase): Observable<TablaProductividadExportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TablaProductividadExportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TablaProductividadExportResponse>(null as any);
    }

    protected processExportProductividadToExcelBlob(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    downloadProductividadExportBlob(jobId: string): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/Productividad/list/export-download";
        url_ = url_.replace(/[?&]$/, "");
        if (jobId !== undefined && jobId !== null) {
            url_ += "?jobId=" + encodeURIComponent("" + jobId);
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            const status = response_.status;
            const responseBlob = response_ instanceof HttpResponse ? response_.body : undefined;
            let _headers: any = {}; if (response_.headers) { for (let key of response_.headers.keys()) { _headers[key] = response_.headers.get(key); }}
            if (status === 200) {
                return _observableOf(responseBlob as Blob);
            } else {
                return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                }));
            }
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                const responseBlob = response_ instanceof HttpResponse ? response_.body :
                    (response_ as any).error instanceof Blob ? (response_ as any).error : undefined;
                return _observableOf(responseBlob as Blob);
            }
            return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    getCantidadSecuenciasProduccion(): Observable<CantidadSecuenciasProduccionResponse> {
        let url_ = this.baseUrl + "/api/Report/GetCantidadSecuenciasProduccion/opciones-produccion/cantidad-secuencias";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCantidadSecuenciasProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCantidadSecuenciasProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CantidadSecuenciasProduccionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CantidadSecuenciasProduccionResponse>;
        }));
    }

    protected processGetCantidadSecuenciasProduccion(response: HttpResponseBase): Observable<CantidadSecuenciasProduccionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CantidadSecuenciasProduccionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CantidadSecuenciasProduccionResponse>(null as any);
    }

    updateCantidadSecuenciasProduccion(cantidadSecuenciasProduccion: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/UpdateCantidadSecuenciasProduccion/opciones-produccion/cantidad-secuencias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ cantidadSecuenciasProduccion: cantidadSecuenciasProduccion });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCantidadSecuenciasProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCantidadSecuenciasProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    getRangoAlerta(): Observable<RangoAlertaDto[]> {
        let url_ = this.baseUrl + "/api/rangoalerta";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRangoAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangoAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RangoAlertaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RangoAlertaDto[]>;
        }));
    }

    protected processGetRangoAlerta(response: HttpResponseBase): Observable<RangoAlertaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RangoAlertaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RangoAlertaDto[]>(null as any);
    }

    updateRangoAlerta(updateRequest: UpdateRangoAlertaRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/rangoalerta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRangoAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRangoAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRangoAlerta(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    protected processUpdateCantidadSecuenciasProduccion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getHojasControlPdf(
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        chassis: string | undefined,
        commodityCode: string | undefined,
        descripcion: string | undefined,
        secuencia: string | undefined,
        escaneados: boolean | undefined
    ): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/SecuenciadoHojasControl/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const query = {
            fechaInicio: fechaInicio ? fechaInicio.toISOString() : undefined,
            fechaFin: fechaFin ? fechaFin.toISOString() : undefined,
            chassis: chassis,
            commodityCode: commodityCode,
            descripcion: descripcion,
            secuencia: secuencia,
            escaneados: escaneados
        };

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHojasControlPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHojasControlPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGetHojasControlPdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(<any>null);
    }

    validateCommodityMonoDolly(commodityCode: string | undefined): Observable<ValidateCommodityMonoDollyResponse> {
        let url_ = this.baseUrl + "/api/dolly/validate-commodity-monodolly";
        url_ = url_.replace(/[?&]$/, "");

        const query = {
            commodityCode: commodityCode
        };

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCommodityMonoDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCommodityMonoDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateCommodityMonoDollyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateCommodityMonoDollyResponse>;
        }));
    }

    protected processValidateCommodityMonoDolly(response: HttpResponseBase): Observable<ValidateCommodityMonoDollyResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateCommodityMonoDollyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateCommodityMonoDollyResponse>(<any>null);
    }

    getDetalladoPdf(
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        chassis: string | undefined,
        commodityCode: string | undefined,
        secuencia: string | undefined,
        numerosParte: string | undefined,
        escaneados: boolean | undefined
    ): Observable<Blob> {
        let url_ = this.baseUrl + "/api/report/detallado/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const query = {
            fechaInicio: fechaInicio ? fechaInicio.toISOString() : undefined,
            fechaFin: fechaFin ? fechaFin.toISOString() : undefined,
            chassis: chassis,
            commodityCode: commodityCode,
            secuencia: secuencia,
            numerosParte: numerosParte,
            escaneados: escaneados
        };

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetalladoPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetalladoPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGetDetalladoPdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(<any>null);
    }

    getDetalladoData(
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        chassis: string | undefined,
        commodityCode: string | undefined,
        secuencia: string | undefined,
        descripcion: string | undefined,
        escaneados: boolean | undefined
    ): Observable<DetalladoDataDto[]> {
        let url_ = this.baseUrl + "/api/report/detallado/data";
        url_ = url_.replace(/[?&]$/, "");

        const query = {
            fechaInicio: fechaInicio ? fechaInicio.toISOString() : undefined,
            fechaFin: fechaFin ? fechaFin.toISOString() : undefined,
            chassis: chassis,
            commodityCode: commodityCode,
            secuencia: secuencia,
            descripcion: descripcion,
            escaneados: escaneados
        };

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetalladoData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetalladoData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetalladoDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetalladoDataDto[]>;
        }));
    }

    protected processGetDetalladoData(response: HttpResponseBase): Observable<DetalladoDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DetalladoDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetalladoDataDto[]>(<any>null);
    }

    getSabanaDollys(commodityInventarioId?: number | null, codigoDolly?: string | null, fechaInicio?: string | null, fechaFin?: string | null, secuenciaInicio?: string | null, secuenciaFin?: string | null, commodity?: string | null, pageNumber?: number | null, pageSize?: number | null, sortBy?: string | null, sortDirection?: string | null): Observable<SabanaDollysResponse> {
        let url_ = this.baseUrl + "/api/reportes/sabana-dollys?";
        if (commodityInventarioId !== undefined && commodityInventarioId !== null) url_ += "commodityInventarioId=" + encodeURIComponent("" + commodityInventarioId) + "&";
        if (codigoDolly !== undefined && codigoDolly !== null) url_ += "codigoDolly=" + encodeURIComponent("" + codigoDolly) + "&";
        if (fechaInicio !== undefined && fechaInicio !== null) url_ += "fechaInicio=" + encodeURIComponent("" + fechaInicio) + "&";
        if (fechaFin !== undefined && fechaFin !== null) url_ += "fechaFin=" + encodeURIComponent("" + fechaFin) + "&";
        if (secuenciaInicio !== undefined && secuenciaInicio !== null) url_ += "secuenciaInicio=" + encodeURIComponent("" + secuenciaInicio) + "&";
        if (secuenciaFin !== undefined && secuenciaFin !== null) url_ += "secuenciaFin=" + encodeURIComponent("" + secuenciaFin) + "&";
        if (commodity !== undefined && commodity !== null) url_ += "commodity=" + encodeURIComponent("" + commodity) + "&";
        if (pageNumber !== undefined && pageNumber !== null) url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null) url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null) url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({ "Accept": "application/json" })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSabanaDollys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try { return this.processGetSabanaDollys(response_ as any); }
                catch (e) { return _observableThrow(e) as any as Observable<SabanaDollysResponse>; }
            } else return _observableThrow(response_) as any as Observable<SabanaDollysResponse>;
        }));
    }

    protected processGetSabanaDollys(response: HttpResponseBase): Observable<SabanaDollysResponse> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SabanaDollysResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SabanaDollysResponse>(null as any);
    }

    exportSabanaDollysBlob(query: SabanaDollysExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/reportes/sabana-dollys/export";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/octet-stream" })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSabanaDollysBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try { return this.processExportSabanaDollysBlob(response_ as any); }
                catch (e) { return _observableThrow(e) as any as Observable<Blob>; }
            } else return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportSabanaDollysBlob(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    getSabanaDollysResumen(grupoInventarioId?: number | null, commodityCode?: string | null, codigoDolly?: string | null, fechaInicio?: string | null, fechaFin?: string | null, secuenciaInicio?: string | null, secuenciaFin?: string | null, pageNumber?: number | null, pageSize?: number | null, sortBy?: string | null, sortDirection?: string | null): Observable<SabanaDollysResumenResponse> {
        let url_ = this.baseUrl + "/api/reportes/sabana-dollys-resumen?";
        if (grupoInventarioId !== undefined && grupoInventarioId !== null) url_ += "grupoInventarioId=" + encodeURIComponent("" + grupoInventarioId) + "&";
        if (commodityCode !== undefined && commodityCode !== null) url_ += "commodityCode=" + encodeURIComponent("" + commodityCode) + "&";
        if (codigoDolly !== undefined && codigoDolly !== null) url_ += "codigoDolly=" + encodeURIComponent("" + codigoDolly) + "&";
        if (fechaInicio !== undefined && fechaInicio !== null) url_ += "fechaInicio=" + encodeURIComponent("" + fechaInicio) + "&";
        if (fechaFin !== undefined && fechaFin !== null) url_ += "fechaFin=" + encodeURIComponent("" + fechaFin) + "&";
        if (secuenciaInicio !== undefined && secuenciaInicio !== null) url_ += "secuenciaInicio=" + encodeURIComponent("" + secuenciaInicio) + "&";
        if (secuenciaFin !== undefined && secuenciaFin !== null) url_ += "secuenciaFin=" + encodeURIComponent("" + secuenciaFin) + "&";
        if (pageNumber !== undefined && pageNumber !== null) url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null) url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null) url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({ "Accept": "application/json" })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSabanaDollysResumen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try { return this.processGetSabanaDollysResumen(response_ as any); }
                catch (e) { return _observableThrow(e) as any as Observable<SabanaDollysResumenResponse>; }
            } else return _observableThrow(response_) as any as Observable<SabanaDollysResumenResponse>;
        }));
    }

    protected processGetSabanaDollysResumen(response: HttpResponseBase): Observable<SabanaDollysResumenResponse> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SabanaDollysResumenResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SabanaDollysResumenResponse>(null as any);
    }

    exportSabanaDollysResumenBlob(query: SabanaDollysResumenExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/reportes/sabana-dollys-resumen/export";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/octet-stream" })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSabanaDollysResumenBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try { return this.processExportSabanaDollysResumenBlob(response_ as any); }
                catch (e) { return _observableThrow(e) as any as Observable<Blob>; }
            } else return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportSabanaDollysResumenBlob(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

@Injectable()
export class RolServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getRolList(query: RolGetListQuery): Observable<PagedResultDtoOfRolForListResponse> {
        let url_ = this.baseUrl + "/api/Rol/GetRolList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRolForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRolForListResponse>;
        }));
    }

    protected processGetRolList(response: HttpResponseBase): Observable<PagedResultDtoOfRolForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRolForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRolForListResponse>(null as any);
    }

    get(dto: RolGetByIdQuery): Observable<RolResponse> {
        let url_ = this.baseUrl + "/api/Rol/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RolResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolResponse>(null as any);
    }

    createRol(dto: RolCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Rol/CreateRol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRol(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateRol(dto: RolUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Rol/UpdateRol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateRol(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteRol(dto: RolDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Rol/DeleteRol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteRol(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getRolForEdit(dto: RolGetForEditQuery): Observable<RolForEditReponse> {
        let url_ = this.baseUrl + "/api/Rol/GetRolForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolForEditReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolForEditReponse>;
        }));
    }

    protected processGetRolForEdit(response: HttpResponseBase): Observable<RolForEditReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolForEditReponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolForEditReponse>(null as any);
    }

    getRolListActive(query: RolGetForListActiveQuery): Observable<RolForListActiveResponse[]> {
        let url_ = this.baseUrl + "/api/Rol/GetRolListActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolListActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolListActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolForListActiveResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolForListActiveResponse[]>;
        }));
    }

    protected processGetRolListActive(response: HttpResponseBase): Observable<RolForListActiveResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolForListActiveResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolForListActiveResponse[]>(null as any);
    }
}

@Injectable()
export class RouteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getRouteList(query: RouteGetListQuery): Observable<PagedResultDtoOfRouteForListResponse> {
        let url_ = this.baseUrl + "/api/Route/GetRouteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRouteForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRouteForListResponse>;
        }));
    }

    protected processGetRouteList(response: HttpResponseBase): Observable<PagedResultDtoOfRouteForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRouteForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRouteForListResponse>(null as any);
    }

    getRouteForEdit(dto: RouteGetForEditQuery): Observable<RouteForEditResponse> {
        let url_ = this.baseUrl + "/api/Route/GetRouteForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RouteForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RouteForEditResponse>;
        }));
    }

    protected processGetRouteForEdit(response: HttpResponseBase): Observable<RouteForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteForEditResponse>(null as any);
    }

    getRouteCombo(query: RouteGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Route/GetRouteCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetRouteCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createRoute(dto: RouteCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Route/CreateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateRoute(dto: RouteUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Route/UpdateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class SettingClientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    changeSettingClient(dto: SettingClientChangeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SettingClient/ChangeSettingClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeSettingClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSettingClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeSettingClient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class SupplyCardRouteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getSupplyCardRouteList(query: SupplyCardRouteGetListQuery): Observable<PagedResultDtoOfSupplyCardRouteForListResponse> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/GetSupplyCardRouteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardRouteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardRouteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSupplyCardRouteForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSupplyCardRouteForListResponse>;
        }));
    }

    protected processGetSupplyCardRouteList(response: HttpResponseBase): Observable<PagedResultDtoOfSupplyCardRouteForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSupplyCardRouteForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSupplyCardRouteForListResponse>(null as any);
    }

    getSupplyCardRouteForEdit(dto: SupplyCardRouteGetForEditQuery): Observable<SupplyCardRouteForEditResponse> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/GetSupplyCardRouteForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardRouteForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardRouteForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardRouteForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardRouteForEditResponse>;
        }));
    }

    protected processGetSupplyCardRouteForEdit(response: HttpResponseBase): Observable<SupplyCardRouteForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyCardRouteForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardRouteForEditResponse>(null as any);
    }

    getSupplyCardRouteCombo(query: SupplyCardRouteGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/GetSupplyCardRouteCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardRouteCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardRouteCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetSupplyCardRouteCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createSupplyCardRoute(dto: SupplyCardRouteCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/CreateSupplyCardRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyCardRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyCardRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSupplyCardRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateSupplyCardRoute(dto: SupplyCardRouteUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/UpdateSupplyCardRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplyCardRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplyCardRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateSupplyCardRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getSupplyCardRouteById(dto: SupplyCardRouteGetByIdQuery): Observable<SupplyCardRouteResponse> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/GetSupplyCardRouteById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardRouteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardRouteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardRouteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardRouteResponse>;
        }));
    }

    protected processGetSupplyCardRouteById(response: HttpResponseBase): Observable<SupplyCardRouteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyCardRouteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardRouteResponse>(null as any);
    }

    startSupplyCardRoute(dto: SupplyCardRouteStartCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/StartSupplyCardRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSupplyCardRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSupplyCardRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processStartSupplyCardRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishSupplyCardRoute(dto: SupplyCardRouteFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardRoute/FinishSupplyCardRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishSupplyCardRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishSupplyCardRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishSupplyCardRoute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getTenantById(id: number): Observable<TenantResponse> {
        let url_ = this.baseUrl + "/api/Tenant/GetTenantById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantResponse>;
        }));
    }

    protected processGetTenantById(response: HttpResponseBase): Observable<TenantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantResponse>(null as any);
    }

    createTenant(command: TenantCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateTenant(command: UpdateTenantCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getTenantsList(query: TenantGetListQuery): Observable<PagedResultDtoOfTenantListResponse> {
        let url_ = this.baseUrl + "/api/Tenant/GetTenantsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListResponse>;
        }));
    }

    protected processGetTenantsList(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListResponse>(null as any);
    }

    getTenantsListCompleter(query: TenantGetListCompleterQuery): Observable<TenantListResponse[]> {
        let url_ = this.baseUrl + "/api/Tenant/GetTenantsListCompleter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsListCompleter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsListCompleter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantListResponse[]>;
        }));
    }

    protected processGetTenantsListCompleter(response: HttpResponseBase): Observable<TenantListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantListResponse[]>(null as any);
    }

    deleteTenant(dto: TenantDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Tenant/DeleteTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getSettingsForEdit(dto: TenantSettingsGetForEditQuery): Observable<TenantSettingsForEditResponse> {
        let url_ = this.baseUrl + "/api/TenantSettings/GetSettingsForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsForEditResponse>;
        }));
    }

    protected processGetSettingsForEdit(response: HttpResponseBase): Observable<TenantSettingsForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsForEditResponse>(null as any);
    }

    updateAllSettings(dto: TenantSettingsUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    sendTestEmail(dto: TenantSettingsSendTestEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getSettingsMobile(): Observable<TenantSettingsMobileResponse> {
        let url_ = this.baseUrl + "/api/TenantSettings/GetSettingsMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsMobileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsMobileResponse>;
        }));
    }

    protected processGetSettingsMobile(response: HttpResponseBase): Observable<TenantSettingsMobileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsMobileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsMobileResponse>(null as any);
    }

    getSupplyCardsSettingsForEdit(dto: SupplyCardsSettingsGetForEditQuery): Observable<SupplyCardsSettingsForEditResponse> {
        let url_ = this.baseUrl + "/api/TenantSettings/GetSupplyCardsSettingsForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardsSettingsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardsSettingsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardsSettingsForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardsSettingsForEditResponse>;
        }));
    }

    protected processGetSupplyCardsSettingsForEdit(response: HttpResponseBase): Observable<SupplyCardsSettingsForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyCardsSettingsForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardsSettingsForEditResponse>(null as any);
    }

    getSupplyCardsSettings(): Observable<SupplyCardsSettingsResponse> {
        let url_ = this.baseUrl + "/api/TenantSettings/GetSupplyCardsSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardsSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardsSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardsSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardsSettingsResponse>;
        }));
    }

    protected processGetSupplyCardsSettings(response: HttpResponseBase): Observable<SupplyCardsSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyCardsSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardsSettingsResponse>(null as any);
    }

    updateSupplyCardsSettings(dto: SupplyCardsSettingsUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TenantSettings/UpdateSupplyCardsSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplyCardsSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplyCardsSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateSupplyCardsSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class UploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    deleteUploadMaterial(query: MaterialUploadDeleteCommand): Observable<MaterialDetailUploadForListResponse[]> {
        let url_ = this.baseUrl + "/api/Upload/DeleteUploadMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUploadMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUploadMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDetailUploadForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDetailUploadForListResponse[]>;
        }));
    }

    protected processDeleteUploadMaterial(response: HttpResponseBase): Observable<MaterialDetailUploadForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialDetailUploadForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDetailUploadForListResponse[]>(null as any);
    }

    uploadCampusScheduled(): Observable<number> {
        let url_ = this.baseUrl + "/api/Upload/UploadCampusScheduled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCampusScheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCampusScheduled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadCampusScheduled(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    uploadCampus(request: UploadCampusCommand): Observable<UploadResultResponse> {
        let url_ = this.baseUrl + "/api/Upload/UploadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResultResponse>;
        }));
    }

    protected processUploadCampus(response: HttpResponseBase): Observable<UploadResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResultResponse>(null as any);
    }

    getUploadLogErrorCampusList(query: UploadLogErrorCampusGetListQuery): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadLogErrorCampusList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadLogErrorCampusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadLogErrorCampusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
        }));
    }

    protected processGetUploadLogErrorCampusList(response: HttpResponseBase): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLogUploadErrorForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLogUploadErrorForListResponse>(null as any);
    }

    getUploadMaterialDetailCampusList(query: UploadMaterialDetailCampusGetListQuery): Observable<PagedResultDtoOfMaterialDetailUploadForListResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadMaterialDetailCampusList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadMaterialDetailCampusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadMaterialDetailCampusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMaterialDetailUploadForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMaterialDetailUploadForListResponse>;
        }));
    }

    protected processGetUploadMaterialDetailCampusList(response: HttpResponseBase): Observable<PagedResultDtoOfMaterialDetailUploadForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMaterialDetailUploadForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMaterialDetailUploadForListResponse>(null as any);
    }

    getUploadCampusPendingList(request: UploadCampusGetPendingListQuery): Observable<UploadCampusForListResponse[]> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadCampusPendingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadCampusPendingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadCampusPendingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadCampusForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadCampusForListResponse[]>;
        }));
    }

    protected processGetUploadCampusPendingList(response: HttpResponseBase): Observable<UploadCampusForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UploadCampusForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadCampusForListResponse[]>(null as any);
    }

    getUploadCampusById(request: UploadCampusGetByIdQuery): Observable<UploadCampusResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadCampusById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadCampusById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadCampusById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadCampusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadCampusResponse>;
        }));
    }

    protected processGetUploadCampusById(response: HttpResponseBase): Observable<UploadCampusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadCampusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadCampusResponse>(null as any);
    }

    uploadInboundScheduled(): Observable<number> {
        let url_ = this.baseUrl + "/api/Upload/UploadInboundScheduled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInboundScheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInboundScheduled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadInboundScheduled(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    uploadInbound(request: UploadInboundCommand): Observable<UploadResultResponse> {
        let url_ = this.baseUrl + "/api/Upload/UploadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResultResponse>;
        }));
    }

    protected processUploadInbound(response: HttpResponseBase): Observable<UploadResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResultResponse>(null as any);
    }

    getUploadLogErrorInboundList(query: UploadLogErrorInboundGetListQuery): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadLogErrorInboundList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadLogErrorInboundList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadLogErrorInboundList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
        }));
    }

    protected processGetUploadLogErrorInboundList(response: HttpResponseBase): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLogUploadErrorForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLogUploadErrorForListResponse>(null as any);
    }

    getUploadMaterialDetailInboundList(query: UploadMaterialDetailInboundGetListQuery): Observable<PagedResultDtoOfMaterialDetailUploadForListResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadMaterialDetailInboundList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadMaterialDetailInboundList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadMaterialDetailInboundList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMaterialDetailUploadForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMaterialDetailUploadForListResponse>;
        }));
    }

    protected processGetUploadMaterialDetailInboundList(response: HttpResponseBase): Observable<PagedResultDtoOfMaterialDetailUploadForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMaterialDetailUploadForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMaterialDetailUploadForListResponse>(null as any);
    }

    getUploadInboundByDownloadSchedule(request: UploadInboundGetByDownloadScheduleQuery): Observable<UploadInboundResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadInboundByDownloadSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadInboundByDownloadSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadInboundByDownloadSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadInboundResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadInboundResponse>;
        }));
    }

    protected processGetUploadInboundByDownloadSchedule(response: HttpResponseBase): Observable<UploadInboundResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadInboundResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadInboundResponse>(null as any);
    }

    getUploadInboundWithoutSchedulePendingList(request: UploadInboundGetWithoutSchedulePendingListQuery): Observable<UploadInboundForListResponse[]> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadInboundWithoutSchedulePendingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadInboundWithoutSchedulePendingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadInboundWithoutSchedulePendingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadInboundForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadInboundForListResponse[]>;
        }));
    }

    protected processGetUploadInboundWithoutSchedulePendingList(response: HttpResponseBase): Observable<UploadInboundForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UploadInboundForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadInboundForListResponse[]>(null as any);
    }

    getUploadInboundWithoutSchedule(request: UploadInboundGetWithoutScheduleQuery): Observable<UploadInboundResponse> {
        let url_ = this.baseUrl + "/api/Upload/GetUploadInboundWithoutSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadInboundWithoutSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadInboundWithoutSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadInboundResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadInboundResponse>;
        }));
    }

    protected processGetUploadInboundWithoutSchedule(response: HttpResponseBase): Observable<UploadInboundResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadInboundResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadInboundResponse>(null as any);
    }
}

@Injectable()
export class NumeroPartesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    uploadNumeroPartesFile(base64Content: string, fileName: string): Observable<ImportResultDto> {
        let url_ = this.baseUrl + "/api/numeropartes/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            // Aumentar timeout para archivos grandes de hasta 100MB (20 minutos)
            timeout: 1200000
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNumeroPartesFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNumeroPartesFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportResultDto>;
        }));
    }

    protected processUploadNumeroPartesFile(response: HttpResponseBase): Observable<ImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImportResultDto.fromJS(resultData200) : new ImportResultDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResultDto>(null as any);
    }

    getNumeroPartesList(filter?: string | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: string | undefined): Observable<PagedResultDtoOfCommodityDto> {
        let url_ = this.baseUrl + "/api/numeropartes/list";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            filter: filter || "",
            pageNumber: pageNumber || 1,
            pageSize: pageSize || 10,
            sorting: sorting || "CreatedDate DESC"
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumeroPartesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumeroPartesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCommodityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCommodityDto>;
        }));
    }

    protected processGetNumeroPartesList(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = PagedResultDtoOfCommodityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityDto>(null as any);
    }

    getNumeroPartesLogErrors(filter?: string | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: string | undefined, initialDate?: any, finalDate?: any, type?: number | undefined, esDetallado?: boolean | undefined): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        let url_ = this.baseUrl + "/api/numeropartes/log-errors";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            filter: filter || "",
            pageNumber: pageNumber || 1,
            pageSize: pageSize || 10,
            sorting: sorting || "fecha DESC",
            isPaged: true,
            initialDate: initialDate,
            finalDate: finalDate,
            type: type,
            esDetallado: esDetallado
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumeroPartesLogErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumeroPartesLogErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLogUploadErrorForListResponse>;
        }));
    }

    protected processGetNumeroPartesLogErrors(response: HttpResponseBase): Observable<PagedResultDtoOfLogUploadErrorForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLogUploadErrorForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLogUploadErrorForListResponse>(null as any);
    }

    exportNumeroPartes(query?: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/numeropartes/export";
        url_ = url_.replace(/[?&]$/, "");
         // Si no se proporciona query, usar objeto vacío para exportar todo
        const body = query || {};
        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            body: JSON.stringify(body),
            timeout: 0
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportNumeroPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportNumeroPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportNumeroPartes(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    exportNumeroPartesLogErrors(filter?: string | undefined, sorting?: string | undefined, type?: number | undefined, initialDate?: any, finalDate?: any, esDetallado?: boolean | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/numeropartes/export-log-errors";
        url_ = url_.replace(/[?&]$/, "");

        const body = {
            filter: filter,
            sorting: sorting,
            type: type,
            initialDate: initialDate,
            finalDate: finalDate,
            esDetallado: esDetallado
        };

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            body: JSON.stringify(body)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportNumeroPartesLogErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportNumeroPartesLogErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportNumeroPartesLogErrors(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    getNumeroPartes(id: number): Observable<{numeroPartes: CommodityDto}> {
        let url_ = this.baseUrl + "/api/numeropartes/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumeroPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumeroPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{numeroPartes: CommodityDto}>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{numeroPartes: CommodityDto}>;
        }));
    }

    protected processGetNumeroPartes(response: HttpResponseBase): Observable<{numeroPartes: CommodityDto}> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = {numeroPartes: CommodityDto.fromJS(resultData200.numeroPartes)};
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{numeroPartes: CommodityDto}>(null as any);
    }

    createNumeroPartes(data: any): Observable<number> {
        let url_ = this.baseUrl + "/api/numeropartes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNumeroPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNumeroPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateNumeroPartes(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateNumeroPartes(id: number, data: any): Observable<number> {
        let url_ = this.baseUrl + "/api/numeropartes/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNumeroPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNumeroPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateNumeroPartes(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteNumeroPartes(id: number): Observable<{message: string}> {
        let url_ = this.baseUrl + "/api/numeropartes/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNumeroPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNumeroPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{message: string}>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{message: string}>;
        }));
    }

    protected processDeleteNumeroPartes(response: HttpResponseBase): Observable<{message: string}> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{message: string}>(null as any);
    }
}

@Injectable()
export class UserConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getAll(dto: UserConfigurationGetAllQuery): Observable<UserConfigurationResponse> {
        let url_ = this.baseUrl + "/api/UserConfiguration/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfigurationResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserConfigurationResponse>(null as any);
    }
}

@Injectable()
export class ConfiguracionPDFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    get(): Observable<string> {
        let url_ = this.baseUrl + "/api/ConfiguracionPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: string;
                result200 = _responseText === "" ? null : _responseText;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getUserList(query: UserGetListQuery): Observable<PagedResultDtoOfUserListResponse> {
        let url_ = this.baseUrl + "/api/User/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListResponse>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<PagedResultDtoOfUserListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListResponse>(null as any);
    }

    getUserAutocompleteList(term: string | null | undefined): Observable<UserListResponse[]> {
        let url_ = this.baseUrl + "/api/User/GetUserAutocompleteList?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResponse[]>;
        }));
    }

    protected processGetUserAutocompleteList(response: HttpResponseBase): Observable<UserListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserListResponse[]>(null as any);
    }

    getUserForEditorAutocompleteList(term: string | null | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/User/GetUserForEditorAutocompleteList?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEditorAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEditorAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetUserForEditorAutocompleteList(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(null as any);
    }

    createUser(dto: UserCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateUser(dto: UserUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/User/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getUserForEdit(dto: UserGetForEditQuery): Observable<UserForEditResponse> {
        let url_ = this.baseUrl + "/api/User/GetUserForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserForEditResponse>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<UserForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserForEditResponse>(null as any);
    }

    getUserProfile(dto: UserProfileQuery): Observable<UserForEditResponse> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserForEditResponse>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserForEditResponse>(null as any);
    }

    updateUserProfile(dto: UserUpdateProfileCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/User/UpdateUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUserProfile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getUserById(dto: UserGetByIdQuery): Observable<UserResponse> {
        let url_ = this.baseUrl + "/api/User/GetUserById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResponse>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserResponse>(null as any);
    }

    getPictureProfile(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/GetPictureProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPictureProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPictureProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPictureProfile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    deleteUser(dto: UserDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/User/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    lockUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/User/LockUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLockUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    unlockUser(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/User/UnlockUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLatestWebLogs(query: WebLogGetLastestQuery): Observable<WebLogGetLastestResponse> {
        let url_ = this.baseUrl + "/api/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebLogGetLastestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebLogGetLastestResponse>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<WebLogGetLastestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebLogGetLastestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebLogGetLastestResponse>(null as any);
    }

    downloadWebLogs(query: WebLogDownloadZipQuery): Observable<WebLogDownloadZipResponse> {
        let url_ = this.baseUrl + "/api/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebLogDownloadZipResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebLogDownloadZipResponse>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<WebLogDownloadZipResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebLogDownloadZipResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebLogDownloadZipResponse>(null as any);
    }
}

@Injectable()
export class WorkShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getWorkShiftList(query: WorkShiftGetListQuery): Observable<PagedResultDtoOfWorkShiftForListResponse> {
        let url_ = this.baseUrl + "/api/WorkShift/GetWorkShiftList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkShiftList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkShiftList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWorkShiftForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWorkShiftForListResponse>;
        }));
    }

    protected processGetWorkShiftList(response: HttpResponseBase): Observable<PagedResultDtoOfWorkShiftForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWorkShiftForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWorkShiftForListResponse>(null as any);
    }

    getWorkShift(id: number): Observable<WorkShiftResponse> {
        let url_ = this.baseUrl + "/api/WorkShift/GetWorkShift/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkShiftResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkShiftResponse>;
        }));
    }

    protected processGetWorkShift(response: HttpResponseBase): Observable<WorkShiftResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkShiftResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkShiftResponse>(null as any);
    }

    getWorkShiftForEdit(dto: WorkShiftGetForEditQuery): Observable<WorkShiftForEditResponse> {
        let url_ = this.baseUrl + "/api/WorkShift/GetWorkShiftForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkShiftForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkShiftForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkShiftForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkShiftForEditResponse>;
        }));
    }

    protected processGetWorkShiftForEdit(response: HttpResponseBase): Observable<WorkShiftForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkShiftForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkShiftForEditResponse>(null as any);
    }

    getWorkShiftCombo(query: WorkShiftGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/WorkShift/GetWorkShiftCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkShiftCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkShiftCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetWorkShiftCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createWorkShift(dto: WorkShiftCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/WorkShift/CreateWorkShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateWorkShift(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateWorkShift(dto: WorkShiftUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/WorkShift/UpdateWorkShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateWorkShift(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ZoneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getZoneList(query: ZoneGetListQuery): Observable<PagedResultDtoOfZoneForListResponse> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfZoneForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfZoneForListResponse>;
        }));
    }

    protected processGetZoneList(response: HttpResponseBase): Observable<PagedResultDtoOfZoneForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfZoneForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfZoneForListResponse>(null as any);
    }

    getZoneForEdit(dto: ZoneGetForEditQuery): Observable<ZoneForEditResponse> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneForEditResponse>;
        }));
    }

    protected processGetZoneForEdit(response: HttpResponseBase): Observable<ZoneForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZoneForEditResponse>(null as any);
    }

    getZoneCombo(query: ZoneGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetZoneCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    getZoneById(dto: ZoneGetByIdQuery): Observable<ZoneResponse> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneResponse>;
        }));
    }

    protected processGetZoneById(response: HttpResponseBase): Observable<ZoneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZoneResponse>(null as any);
    }

    createZone(dto: ZoneCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Zone/CreateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateZone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateZone(dto: ZoneUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Zone/UpdateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateZone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getActivityActiveWorkshift(dto: ActivityGetActiveWorkshiftByUserQuery): Observable<ActivityResponse> {
        let url_ = this.baseUrl + "/api/Activity/GetActivityActiveWorkshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityActiveWorkshift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityActiveWorkshift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityResponse>;
        }));
    }

    protected processGetActivityActiveWorkshift(response: HttpResponseBase): Observable<ActivityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityResponse>(null as any);
    }

    createActivityStartWorkshift(dto: ActivityCreateStartWorkshiftCommand): Observable<ActivityCreateStartWorkshiftResponse> {
        let url_ = this.baseUrl + "/api/Activity/CreateActivityStartWorkshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityStartWorkshift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityStartWorkshift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityCreateStartWorkshiftResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityCreateStartWorkshiftResponse>;
        }));
    }

    protected processCreateActivityStartWorkshift(response: HttpResponseBase): Observable<ActivityCreateStartWorkshiftResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityCreateStartWorkshiftResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityCreateStartWorkshiftResponse>(null as any);
    }

    updateActivityFinishStartWorkshift(dto: ActivityFinishStartWorkshiftCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/UpdateActivityFinishStartWorkshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityFinishStartWorkshift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityFinishStartWorkshift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateActivityFinishStartWorkshift(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    createActivityStart(dto: ActivityStartCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/CreateActivityStart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateActivityStart(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateActivityFinish(dto: ActivityFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/UpdateActivityFinish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityFinish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateActivityFinish(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    createActivityDirect(dto: ActivityCreateDirectCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/CreateActivityDirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityDirect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityDirect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateActivityDirect(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getActivityByUserList(dto: ActivityGetByUserListQuery): Observable<ActivityForListResponse[]> {
        let url_ = this.baseUrl + "/api/Activity/GetActivityByUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityByUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityByUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityForListResponse[]>;
        }));
    }

    protected processGetActivityByUserList(response: HttpResponseBase): Observable<ActivityForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityForListResponse[]>(null as any);
    }

    keepActivityDirect(dto: ActivityKeepDirectCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/KeepActivityDirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepActivityDirect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepActivityDirect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processKeepActivityDirect(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishActivityActive(dto: ActivityFinishActiveCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/FinishActivityActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishActivityActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishActivityActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishActivityActive(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishActivityIndirectPdbreak(dto: ActivityFinishIndirectPdbreakCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Activity/FinishActivityIndirectPdbreak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishActivityIndirectPdbreak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishActivityIndirectPdbreak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishActivityIndirectPdbreak(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ActivityTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getActivityTypeForEdit(query: ActivityTypeGetForEditQuery): Observable<ActivityTypeForEditResponse> {
        let url_ = this.baseUrl + "/api/ActivityType/GetActivityTypeForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityTypeForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityTypeForEditResponse>;
        }));
    }

    protected processGetActivityTypeForEdit(response: HttpResponseBase): Observable<ActivityTypeForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityTypeForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityTypeForEditResponse>(null as any);
    }

    getActivityTypeList(query: ActivityTypeGetListQuery): Observable<PagedResultDtoOfActivityTypeForListResponse> {
        let url_ = this.baseUrl + "/api/ActivityType/GetActivityTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActivityTypeForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActivityTypeForListResponse>;
        }));
    }

    protected processGetActivityTypeList(response: HttpResponseBase): Observable<PagedResultDtoOfActivityTypeForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActivityTypeForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityTypeForListResponse>(null as any);
    }

    createActivityType(dto: ActivityTypeCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ActivityType/CreateActivityType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateActivityType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateActivityType(dto: ActivityTypeUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ActivityType/UpdateActivityType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateActivityType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getActivityTypeStartCombo(): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/ActivityType/GetActivityTypeStartCombo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypeStartCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypeStartCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetActivityTypeStartCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }
}

@Injectable()
export class AssortmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    createAssortment(dto: AssortmentCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Assortment/CreateAssortment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssortment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssortment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAssortment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelAssortment(dto: AssortmentCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Assortment/CancelAssortment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAssortment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAssortment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelAssortment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    isAssortmentSerieAvaliable(dto: AssortmentIsSerieAvaliableQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Assortment/IsAssortmentSerieAvaliable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAssortmentSerieAvaliable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAssortmentSerieAvaliable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAssortmentSerieAvaliable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class DamageTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getDamageTypeForEdit(query: DamageTypeGetForEditQuery): Observable<DamageTypeForEditResponse> {
        let url_ = this.baseUrl + "/api/DamageType/GetDamageTypeForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DamageTypeForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DamageTypeForEditResponse>;
        }));
    }

    protected processGetDamageTypeForEdit(response: HttpResponseBase): Observable<DamageTypeForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DamageTypeForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DamageTypeForEditResponse>(null as any);
    }

    getDamageTypeList(query: DamageTypeGetListQuery): Observable<PagedResultDtoOfDamageTypeForListResponse> {
        let url_ = this.baseUrl + "/api/DamageType/GetDamageTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDamageTypeForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDamageTypeForListResponse>;
        }));
    }

    protected processGetDamageTypeList(response: HttpResponseBase): Observable<PagedResultDtoOfDamageTypeForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDamageTypeForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDamageTypeForListResponse>(null as any);
    }

    getDamageTypeCombo(query: DamageTypeGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/DamageType/GetDamageTypeCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageTypeCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageTypeCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetDamageTypeCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }

    createDamageType(dto: DamageTypeCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DamageType/CreateDamageType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDamageType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDamageType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDamageType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateDamageType(dto: DamageTypeUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DamageType/UpdateDamageType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDamageType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDamageType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateDamageType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class DownloadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getPartByPartBase(dto: PartGetByPartBaseQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/GetPartByPartBase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartByPartBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartByPartBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPartByPartBase(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getDownloadSuspendedList(dto: DownloadGetSuspendedListQuery): Observable<DownloadForListResponse[]> {
        let url_ = this.baseUrl + "/api/Download/GetDownloadSuspendedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadSuspendedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadSuspendedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadForListResponse[]>;
        }));
    }

    protected processGetDownloadSuspendedList(response: HttpResponseBase): Observable<DownloadForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownloadForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadForListResponse[]>(null as any);
    }

    getDownloadForEdit(dto: DownloadGetForEditQuery): Observable<DownloadForEditResponse> {
        let url_ = this.baseUrl + "/api/Download/GetDownloadForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadForEditResponse>;
        }));
    }

    protected processGetDownloadForEdit(response: HttpResponseBase): Observable<DownloadForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadForEditResponse>(null as any);
    }

    isDownloadAvaliable(dto: DownloadIsAvaliableQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Download/IsDownloadAvaliable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDownloadAvaliable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDownloadAvaliable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDownloadAvaliable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    finishDownloadMetering(dto: DownloadMeteringFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/FinishDownloadMetering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDownloadMetering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDownloadMetering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishDownloadMetering(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    suspendDownloadMetering(dto: DownloadMeteringSuspendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/SuspendDownloadMetering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendDownloadMetering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendDownloadMetering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSuspendDownloadMetering(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelDownloadMetering(dto: DownloadMeteringCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/CancelDownloadMetering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDownloadMetering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDownloadMetering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelDownloadMetering(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    undoDownloadMetering(dto: DownloadMeteringUndoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/UndoDownloadMetering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDownloadMetering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDownloadMetering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUndoDownloadMetering(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    releaseDownloadMetering(dto: DownloadMeteringReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/ReleaseDownloadMetering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDownloadMetering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDownloadMetering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReleaseDownloadMetering(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishDownloadCampus(dto: DownloadCampusFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/FinishDownloadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDownloadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDownloadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishDownloadCampus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    suspendDownloadCampus(dto: DownloadCampusSuspendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/SuspendDownloadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendDownloadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendDownloadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSuspendDownloadCampus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelDownloadCampus(dto: DownloadCampusCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/CancelDownloadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDownloadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDownloadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelDownloadCampus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    undoDownloadCampus(dto: DownloadCampusUndoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/UndoDownloadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDownloadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDownloadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUndoDownloadCampus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    releaseDownloadCampus(dto: DownloadCampusReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/ReleaseDownloadCampus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDownloadCampus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDownloadCampus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReleaseDownloadCampus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishDownloadInbound(dto: DownloadInboundFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/FinishDownloadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDownloadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDownloadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishDownloadInbound(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    suspendDownloadInbound(dto: DownloadInboundSuspendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/SuspendDownloadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendDownloadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendDownloadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSuspendDownloadInbound(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelDownloadInbound(dto: DownloadInboundCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/CancelDownloadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDownloadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDownloadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelDownloadInbound(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    undoDownloadInbound(dto: DownloadInboundUndoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/UndoDownloadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDownloadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDownloadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUndoDownloadInbound(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    releaseDownloadInbound(dto: DownloadInboundReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/ReleaseDownloadInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDownloadInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDownloadInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReleaseDownloadInbound(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishDownloadSinDocumentacion(dto: DownloadSinDocumentacionFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/FinishDownloadSinDocumentacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDownloadSinDocumentacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDownloadSinDocumentacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishDownloadSinDocumentacion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    suspendDownloadSinDocumentacion(dto: DownloadSinDocumentacionSuspendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/SuspendDownloadSinDocumentacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendDownloadSinDocumentacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendDownloadSinDocumentacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSuspendDownloadSinDocumentacion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelDownloadSinDocumentacion(dto: DownloadSinDocumentacionCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/CancelDownloadSinDocumentacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDownloadSinDocumentacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDownloadSinDocumentacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelDownloadSinDocumentacion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    undoDownloadSinDocumentacion(dto: DownloadSinDocumentacionUndoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/UndoDownloadSinDocumentacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDownloadSinDocumentacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDownloadSinDocumentacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUndoDownloadSinDocumentacion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    releaseDownloadSinDocumentacion(dto: DownloadSinDocumentacionReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Download/ReleaseDownloadSinDocumentacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDownloadSinDocumentacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDownloadSinDocumentacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReleaseDownloadSinDocumentacion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getDownloadDetailPackageByDetailList(query: DownloadDetailPackageByDetailGetListQuery): Observable<DownloadDetailPackageForListResponse[]> {
        let url_ = this.baseUrl + "/api/Download/GetDownloadDetailPackageByDetailList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadDetailPackageByDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadDetailPackageByDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadDetailPackageForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadDetailPackageForListResponse[]>;
        }));
    }

    protected processGetDownloadDetailPackageByDetailList(response: HttpResponseBase): Observable<DownloadDetailPackageForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownloadDetailPackageForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadDetailPackageForListResponse[]>(null as any);
    }
}

@Injectable()
export class DownloadJitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getDownloadJitSuspendedList(dto: DownloadJitGetSuspendedListQuery): Observable<DownloadJitForListResponse[]> {
        let url_ = this.baseUrl + "/api/DownloadJit/GetDownloadJitSuspendedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadJitSuspendedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadJitSuspendedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadJitForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadJitForListResponse[]>;
        }));
    }

    protected processGetDownloadJitSuspendedList(response: HttpResponseBase): Observable<DownloadJitForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DownloadJitForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadJitForListResponse[]>(null as any);
    }

    getDownloadJitForEdit(dto: DownloadJitGetForEditQuery): Observable<DownloadJitForEditResponse> {
        let url_ = this.baseUrl + "/api/DownloadJit/GetDownloadJitForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadJitForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadJitForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadJitForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadJitForEditResponse>;
        }));
    }

    protected processGetDownloadJitForEdit(response: HttpResponseBase): Observable<DownloadJitForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadJitForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadJitForEditResponse>(null as any);
    }

    suspendDownloadJit(dto: DownloadJitSuspendCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadJit/SuspendDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSuspendDownloadJit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelDownloadJit(dto: DownloadJitCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadJit/CancelDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelDownloadJit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    finishDownloadJit(dto: DownloadJitFinishCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadJit/FinishDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinishDownloadJit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelSuspendedDownloadJit(dto: DownloadJitCancelSuspendedCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadJit/CancelSuspendedDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSuspendedDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSuspendedDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelSuspendedDownloadJit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    releaseDownloadJit(dto: DownloadJitReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DownloadJit/ReleaseDownloadJit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDownloadJit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDownloadJit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReleaseDownloadJit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    isDownloadJitAvaliable(dto: DownloadJitIsAvaliableQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DownloadJit/IsDownloadJitAvaliable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDownloadJitAvaliable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDownloadJitAvaliable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDownloadJitAvaliable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class EmptyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    createEmpty(dto: EmptyCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Empty/CreateEmpty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEmpty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelEmpty(dto: EmptyCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Empty/CancelEmpty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelEmpty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class MarketMaxAndMinServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getMarketMaxAndMinForEdit(query: MarketMaxAndMinGetForEditQuery): Observable<MarketMaxAndMinForEditResponse> {
        let url_ = this.baseUrl + "/api/MarketMaxAndMin/GetMarketMaxAndMinForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarketMaxAndMinForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketMaxAndMinForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketMaxAndMinForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketMaxAndMinForEditResponse>;
        }));
    }

    protected processGetMarketMaxAndMinForEdit(response: HttpResponseBase): Observable<MarketMaxAndMinForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketMaxAndMinForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarketMaxAndMinForEditResponse>(null as any);
    }

    getMarketMaxAndMinList(query: MarketMaxAndMinGetListQuery): Observable<PagedResultDtoOfMarketMaxAndMinForListResponse> {
        let url_ = this.baseUrl + "/api/MarketMaxAndMin/GetMarketMaxAndMinList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarketMaxAndMinList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketMaxAndMinList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketMaxAndMinForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketMaxAndMinForListResponse>;
        }));
    }

    protected processGetMarketMaxAndMinList(response: HttpResponseBase): Observable<PagedResultDtoOfMarketMaxAndMinForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketMaxAndMinForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMarketMaxAndMinForListResponse>(null as any);
    }

    createMarketMaxAndMin(dto: MarketMaxAndMinCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MarketMaxAndMin/CreateMarketMaxAndMin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMarketMaxAndMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMarketMaxAndMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMarketMaxAndMin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateMarketMaxAndMin(dto: MarketMaxAndMinUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MarketMaxAndMin/UpdateMarketMaxAndMin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMarketMaxAndMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMarketMaxAndMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMarketMaxAndMin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class MobileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getMobileForEdit(query: MobileGetForEditQuery): Observable<MobileForEditResponse> {
        let url_ = this.baseUrl + "/api/Mobile/GetMobileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MobileForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MobileForEditResponse>;
        }));
    }

    protected processGetMobileForEdit(response: HttpResponseBase): Observable<MobileForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileForEditResponse>(null as any);
    }

    getMobileList(query: MobileGetListQuery): Observable<PagedResultDtoOfMobileForListResponse> {
        let url_ = this.baseUrl + "/api/Mobile/GetMobileList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMobileForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMobileForListResponse>;
        }));
    }

    protected processGetMobileList(response: HttpResponseBase): Observable<PagedResultDtoOfMobileForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMobileForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMobileForListResponse>(null as any);
    }

    createMobile(dto: MobileCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Mobile/CreateMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMobile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateMobile(dto: MobileUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Mobile/UpdateMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMobile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getUsersForMobile(query: DynamicSelectGetUsersQuery): Observable<DynamicSelectGetUsersResponse> {
        let url_ = this.baseUrl + "/api/dynamicselect/getusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUsersForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicSelectGetUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicSelectGetUsersResponse>;
        }));
    }

    protected processGetUsersForMobile(response: HttpResponseBase): Observable<DynamicSelectGetUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let resultData = _responseText === "" ? null : JSON.parse(_responseText);
                let result = resultData ? DynamicSelectGetUsersResponse.fromJS(resultData) : new DynamicSelectGetUsersResponse();
                return _observableOf(result);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
    }

}

export class DynamicSelectGetUsersQuery {
    itemsSelected: number[];
    searchFilter: string;
    page: number;
    pageSize: number;

    constructor(data?: any) {
        if (data) {
            this.itemsSelected = data.itemsSelected || [];
            this.searchFilter = data.searchFilter || "";
            this.page = data.page || 0;
            this.pageSize = data.pageSize || 10;
        }
    }
}

export class DynamicSelectGetUsersResponse {
    totalCount: number;
    itemsSelected: number[];
    itemsSearch: DynamicSelectUserItem[];

    constructor(data?: any) {
        if (data) {
            this.totalCount = data.totalCount || 0;
            this.itemsSelected = data.itemsSelected || [];
            this.itemsSearch = (data.itemsSearch || []).map((v: any) => new DynamicSelectUserItem(v));
        }
    }

    static fromJS(data: any): DynamicSelectGetUsersResponse {
        return new DynamicSelectGetUsersResponse(data);
    }
}

export class DynamicSelectUserItem {
    id: number;
    userLogin: string;
    name: string;
    lastname: string;
    secondLastname: string;

    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.userLogin = data.userLogin;
            this.name = data.name;
            this.lastname = data.lastname;
            this.secondLastname = data.secondLastname;
        }
    }
}

@Injectable()
export class PartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getPartsAutocompleterList(query: PartGetListAutocompleteQuery): Observable<PartForListResponse[]> {
        let url_ = this.baseUrl + "/api/Part/GetPartsAutocompleterList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartsAutocompleterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartsAutocompleterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartForListResponse[]>;
        }));
    }

    protected processGetPartsAutocompleterList(response: HttpResponseBase): Observable<PartForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartForListResponse[]>(null as any);
    }

    getPartList(query: PartGetListQuery): Observable<PagedResultDtoOfPartForListResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPartForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPartForListResponse>;
        }));
    }

    protected processGetPartList(response: HttpResponseBase): Observable<PagedResultDtoOfPartForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPartForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPartForListResponse>(null as any);
    }

    getPartForEdit(dto: PartGetForEditQuery): Observable<PartForEditResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartForEditResponse>;
        }));
    }

    protected processGetPartForEdit(response: HttpResponseBase): Observable<PartForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartForEditResponse>(null as any);
    }

    createPart(dto: PartCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Part/CreatePart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePart(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updatePart(dto: PartUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Part/UpdatePart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePart(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPartForAssortment(dto: PartGetForAssortmentQuery): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartForAssortment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartForAssortment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartForAssortment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartForAssortment(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartById(dto: PartGetByIdQuery): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartById(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartByPartBase(dto: PartGetByPartBaseQuery2): Observable<PartResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartByPartBase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartByPartBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartByPartBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartResponse>;
        }));
    }

    protected processGetPartByPartBase(response: HttpResponseBase): Observable<PartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartResponse>(null as any);
    }

    getPartLocationList(query: PartLocationGetListQuery): Observable<PagedResultDtoOfPartLocationForListResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartLocationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartLocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartLocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPartLocationForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPartLocationForListResponse>;
        }));
    }

    protected processGetPartLocationList(response: HttpResponseBase): Observable<PagedResultDtoOfPartLocationForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPartLocationForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPartLocationForListResponse>(null as any);
    }

    getPartLocationListByPart(query: PartLocationGetListByPartQuery): Observable<PartLocationForListResponse[]> {
        let url_ = this.baseUrl + "/api/Part/GetPartLocationListByPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartLocationListByPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartLocationListByPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartLocationForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartLocationForListResponse[]>;
        }));
    }

    protected processGetPartLocationListByPart(response: HttpResponseBase): Observable<PartLocationForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartLocationForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartLocationForListResponse[]>(null as any);
    }

    getPartLocationForEdit(dto: PartLocationGetForEditQuery): Observable<PartLocationForEditResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartLocationForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartLocationForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartLocationForEditResponse>;
        }));
    }

    protected processGetPartLocationForEdit(response: HttpResponseBase): Observable<PartLocationForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartLocationForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartLocationForEditResponse>(null as any);
    }

    createPartLocation(dto: PartLocationCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Part/CreatePartLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePartLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePartLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePartLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deletePartLocation(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Part/DeletePartLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePartLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePartLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePartLocation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPartPackagePattern(): Observable<PartPackagePatternResponse> {
        let url_ = this.baseUrl + "/api/Part/GetPartPackagePattern";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartPackagePattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartPackagePattern(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartPackagePatternResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartPackagePatternResponse>;
        }));
    }

    protected processGetPartPackagePattern(response: HttpResponseBase): Observable<PartPackagePatternResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartPackagePatternResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartPackagePatternResponse>(null as any);
    }

    importPart(request: PartImportCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Part/ImportPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportPart(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getProviderForEdit(query: ProviderGetForEditQuery): Observable<ProviderForEditResponse> {
        let url_ = this.baseUrl + "/api/Provider/GetProviderForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderForEditResponse>;
        }));
    }

    protected processGetProviderForEdit(response: HttpResponseBase): Observable<ProviderForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderForEditResponse>(null as any);
    }

    getProviderList(query: ProviderGetListQuery): Observable<PagedResultDtoOfProviderForListResponse> {
        let url_ = this.baseUrl + "/api/Provider/GetProviderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProviderForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProviderForListResponse>;
        }));
    }

    protected processGetProviderList(response: HttpResponseBase): Observable<PagedResultDtoOfProviderForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProviderForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProviderForListResponse>(null as any);
    }

    createProvider(dto: ProviderCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Provider/CreateProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateProvider(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateProvider(dto: ProviderUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Provider/UpdateProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateProvider(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class PutawayServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    createPutaway(dto: PutawayCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Putaway/CreatePutaway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePutaway(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePutaway(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePutaway(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    cancelPutaway(dto: PutawayCancelCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Putaway/CancelPutaway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPutaway(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPutaway(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelPutaway(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class ReasonSuspensionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getReasonSuspensionForEdit(query: ReasonSuspensionGetForEditQuery): Observable<ReasonSuspensionForEditResponse> {
        let url_ = this.baseUrl + "/api/ReasonSuspension/GetReasonSuspensionForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonSuspensionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonSuspensionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReasonSuspensionForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReasonSuspensionForEditResponse>;
        }));
    }

    protected processGetReasonSuspensionForEdit(response: HttpResponseBase): Observable<ReasonSuspensionForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReasonSuspensionForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReasonSuspensionForEditResponse>(null as any);
    }

    getReasonSuspensionList(query: ReasonSuspensionGetListQuery): Observable<PagedResultDtoOfReasonSuspensionForListResponse> {
        let url_ = this.baseUrl + "/api/ReasonSuspension/GetReasonSuspensionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonSuspensionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonSuspensionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReasonSuspensionForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReasonSuspensionForListResponse>;
        }));
    }

    protected processGetReasonSuspensionList(response: HttpResponseBase): Observable<PagedResultDtoOfReasonSuspensionForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReasonSuspensionForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReasonSuspensionForListResponse>(null as any);
    }

    createReasonSuspension(dto: ReasonSuspensionCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ReasonSuspension/CreateReasonSuspension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReasonSuspension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReasonSuspension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateReasonSuspension(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateReasonSuspension(dto: ReasonSuspensionUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ReasonSuspension/UpdateReasonSuspension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReasonSuspension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReasonSuspension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateReasonSuspension(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getReasonSuspensionCombo(query: ReasonSuspensionGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/ReasonSuspension/GetReasonSuspensionCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonSuspensionCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonSuspensionCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetReasonSuspensionCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }
}

@Injectable()
export class ReturnableServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getReturnableForEdit(query: ReturnableGetForEditQuery): Observable<ReturnableForEditResponse> {
        let url_ = this.baseUrl + "/api/Returnable/GetReturnableForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReturnableForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReturnableForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnableForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnableForEditResponse>;
        }));
    }

    protected processGetReturnableForEdit(response: HttpResponseBase): Observable<ReturnableForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnableForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnableForEditResponse>(null as any);
    }

    getReturnableList(query: ReturnableGetListQuery): Observable<PagedResultDtoOfReturnableForListResponse> {
        let url_ = this.baseUrl + "/api/Returnable/GetReturnableList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReturnableList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReturnableList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReturnableForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReturnableForListResponse>;
        }));
    }

    protected processGetReturnableList(response: HttpResponseBase): Observable<PagedResultDtoOfReturnableForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReturnableForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReturnableForListResponse>(null as any);
    }

    createReturnable(dto: ReturnableCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Returnable/CreateReturnable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReturnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReturnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateReturnable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateReturnable(dto: ReturnableUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Returnable/UpdateReturnable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReturnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReturnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateReturnable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class StoreMovementTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getStoreMovementTypeForEdit(query: StoreMovementTypeGetForEditQuery): Observable<StoreMovementTypeForEditResponse> {
        let url_ = this.baseUrl + "/api/StoreMovementType/GetStoreMovementTypeForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreMovementTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreMovementTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreMovementTypeForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreMovementTypeForEditResponse>;
        }));
    }

    protected processGetStoreMovementTypeForEdit(response: HttpResponseBase): Observable<StoreMovementTypeForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreMovementTypeForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreMovementTypeForEditResponse>(null as any);
    }

    getStoreMovementTypeList(query: StoreMovementTypeGetListQuery): Observable<PagedResultDtoOfStoreMovementTypeForListResponse> {
        let url_ = this.baseUrl + "/api/StoreMovementType/GetStoreMovementTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreMovementTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreMovementTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfStoreMovementTypeForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfStoreMovementTypeForListResponse>;
        }));
    }

    protected processGetStoreMovementTypeList(response: HttpResponseBase): Observable<PagedResultDtoOfStoreMovementTypeForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStoreMovementTypeForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStoreMovementTypeForListResponse>(null as any);
    }

    getStoreMovementType(id: number): Observable<StoreMovementTypeResponse> {
        let url_ = this.baseUrl + "/api/StoreMovementType/GetStoreMovementType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreMovementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreMovementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreMovementTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreMovementTypeResponse>;
        }));
    }

    protected processGetStoreMovementType(response: HttpResponseBase): Observable<StoreMovementTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreMovementTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreMovementTypeResponse>(null as any);
    }

    createStoreMovementType(dto: StoreMovementTypeCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StoreMovementType/CreateStoreMovementType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStoreMovementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStoreMovementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateStoreMovementType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateStoreMovementType(dto: StoreMovementTypeUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StoreMovementType/UpdateStoreMovementType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStoreMovementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStoreMovementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateStoreMovementType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getStoreMovementTypeCombo(dto: StoreMovementTypeGetComboQuery): Observable<ComboboxItemDtoOfLong[]> {
        let url_ = this.baseUrl + "/api/StoreMovementType/GetStoreMovementTypeCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreMovementTypeCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreMovementTypeCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDtoOfLong[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDtoOfLong[]>;
        }));
    }

    protected processGetStoreMovementTypeCombo(response: HttpResponseBase): Observable<ComboboxItemDtoOfLong[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDtoOfLong[]>(null as any);
    }
}

@Injectable()
export class SupplyCardPartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getSupplyCardPartByRouteList(query: SupplyCardPartGetByRouteListQuery): Observable<SupplyCardPartForListResponse[]> {
        let url_ = this.baseUrl + "/api/SupplyCardPart/GetSupplyCardPartByRouteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardPartByRouteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardPartByRouteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardPartForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardPartForListResponse[]>;
        }));
    }

    protected processGetSupplyCardPartByRouteList(response: HttpResponseBase): Observable<SupplyCardPartForListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplyCardPartForListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardPartForListResponse[]>(null as any);
    }

    createSupplyCardEmpty(dto: SupplyCardEmptyCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardPart/CreateSupplyCardEmpty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyCardEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyCardEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSupplyCardEmpty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    createSupplyCardLoad(dto: SupplyCardLoadCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardPart/CreateSupplyCardLoad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyCardLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyCardLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSupplyCardLoad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getSupplyCardLoadPendingBySerie(input: SuppliCardLoadGetPendingBySerieQuery): Observable<SupplyCardLoadResponse> {
        let url_ = this.baseUrl + "/api/SupplyCardPart/GetSupplyCardLoadPendingBySerie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyCardLoadPendingBySerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyCardLoadPendingBySerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyCardLoadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyCardLoadResponse>;
        }));
    }

    protected processGetSupplyCardLoadPendingBySerie(response: HttpResponseBase): Observable<SupplyCardLoadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyCardLoadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyCardLoadResponse>(null as any);
    }

    createSupplyCardDelivery(dto: SupplyCardDeliveryCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SupplyCardPart/CreateSupplyCardDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyCardDelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyCardDelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSupplyCardDelivery(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getCurrentUTC(): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/Timing/GetCurrentUTC";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetCurrentUTC(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }
}

export class PagedResultDtoOfAreaForListResponse implements IPagedResultDtoOfAreaForListResponse {
    totalCount!: number;
    items?: AreaForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfAreaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AreaForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAreaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAreaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAreaForListResponse {
    totalCount: number;
    items?: AreaForListResponse[] | undefined;
}

export class AreaForListResponse implements IAreaForListResponse {
    id!: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IAreaForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zoneDesc = _data["zoneDesc"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): AreaForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AreaForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zoneDesc"] = this.zoneDesc;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IAreaForListResponse {
    id: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class PageListByDto implements IPageListByDto {
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged!: boolean;

    constructor(data?: IPageListByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPaged = _data["isPaged"];
        }
    }

    static fromJS(data: any): PageListByDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageListByDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPaged"] = this.isPaged;
        return data;
    }
}

export interface IPageListByDto {
    sorting?: string | undefined;
    filter?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPaged: boolean;
}

export class AreaGetListQuery extends PageListByDto implements IAreaGetListQuery {

    constructor(data?: IAreaGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AreaGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AreaGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAreaGetListQuery extends IPageListByDto {
}

export class AreaForEditResponse implements IAreaForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    isActive!: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IAreaForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AreaForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AreaForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAreaForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    isActive: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class ComboboxItemDtoOfLong implements IComboboxItemDtoOfLong {
    value!: number;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfLong {
    value: number;
    label?: string | undefined;
}

export class AreaGetForEditQuery implements IAreaGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IAreaGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AreaGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AreaGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAreaGetForEditQuery {
    id?: number | undefined;
}

export class AreaGetComboQuery implements IAreaGetComboQuery {
    filter?: string | undefined;
    zone?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAreaGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.zone = _data["zone"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AreaGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AreaGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["zone"] = this.zone;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAreaGetComboQuery {
    filter?: string | undefined;
    zone?: number | undefined;
    isActive?: boolean | undefined;
}

export class AreaCreateCommand implements IAreaCreateCommand {
    description?: string | undefined;
    zone?: number | undefined;
    isActive!: boolean;

    constructor(data?: IAreaCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AreaCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AreaCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAreaCreateCommand {
    description?: string | undefined;
    zone?: number | undefined;
    isActive: boolean;
}

export class AreaUpdateCommand implements IAreaUpdateCommand {
    id!: number;
    description?: string | undefined;
    zone?: number | undefined;
    isActive!: boolean;

    constructor(data?: IAreaUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AreaUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AreaUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAreaUpdateCommand {
    id: number;
    description?: string | undefined;
    zone?: number | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfAuditLogListResponse implements IPagedResultDtoOfAuditLogListResponse {
    totalCount!: number;
    items?: AuditLogListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListResponse {
    totalCount: number;
    items?: AuditLogListResponse[] | undefined;
}

export class AuditLogListResponse implements IAuditLogListResponse {
    id?: number | undefined;
    tenantName?: string | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    impersonalizerUserId?: number | undefined;
    impersonalizerUserName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    executionDuration?: number | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;

    constructor(data?: IAuditLogListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantName = _data["tenantName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonalizerUserId = _data["impersonalizerUserId"];
            this.impersonalizerUserName = _data["impersonalizerUserName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AuditLogListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonalizerUserId"] = this.impersonalizerUserId;
        data["impersonalizerUserName"] = this.impersonalizerUserName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAuditLogListResponse {
    id?: number | undefined;
    tenantName?: string | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    impersonalizerUserId?: number | undefined;
    impersonalizerUserName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    executionDuration?: number | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;
}

export class AuditLogGetListQuery extends PageListByDto implements IAuditLogGetListQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;

    constructor(data?: IAuditLogGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
        }
    }

    static fromJS(data: any): AuditLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogGetListQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
}

export class AuditLogExcelResponse implements IAuditLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IAuditLogExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): AuditLogExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IAuditLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class AuditLogGetExcelQuery extends PageListByDto implements IAuditLogGetExcelQuery {
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;

    constructor(data?: IAuditLogGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.tenantId = _data["tenantId"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
            this.severity = _data["severity"];
            this.onlyHost = _data["onlyHost"];
        }
    }

    static fromJS(data: any): AuditLogGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["tenantId"] = this.tenantId;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        data["severity"] = this.severity;
        data["onlyHost"] = this.onlyHost;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditLogGetExcelQuery extends IPageListByDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    userName?: string | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    browserInfo?: string | undefined;
    tenantId?: number | undefined;
    hasException?: boolean | undefined;
    minExecutionDuration?: number | undefined;
    maxExecutionDuration?: number | undefined;
    severity?: number | undefined;
    onlyHost?: boolean | undefined;
}

export class AuditLogCreateMobileCommand implements IAuditLogCreateMobileCommand {
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;

    constructor(data?: IAuditLogCreateMobileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AuditLogCreateMobileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogCreateMobileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAuditLogCreateMobileCommand {
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment | undefined;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    severity?: number | undefined;
}

export class SessionLoginResponse implements ISessionLoginResponse {
    tenantId?: number | undefined;
    tenancyName?: string | undefined;
    userId!: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    eMail?: string | undefined;
    isImpersonalized!: boolean;
    impersonalizerUserId?: number | undefined;

    constructor(data?: ISessionLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.eMail = _data["eMail"];
            this.isImpersonalized = _data["isImpersonalized"];
            this.impersonalizerUserId = _data["impersonalizerUserId"];
        }
    }

    static fromJS(data: any): SessionLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["eMail"] = this.eMail;
        data["isImpersonalized"] = this.isImpersonalized;
        data["impersonalizerUserId"] = this.impersonalizerUserId;
        return data;
    }
}

export interface ISessionLoginResponse {
    tenantId?: number | undefined;
    tenancyName?: string | undefined;
    userId: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    eMail?: string | undefined;
    isImpersonalized: boolean;
    impersonalizerUserId?: number | undefined;
}

export class SessionLoginResponseController extends SessionLoginResponse implements ISessionLoginResponseController {
    token?: string | undefined;

    constructor(data?: ISessionLoginResponseController) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SessionLoginResponseController {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLoginResponseController();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        super.toJSON(data);
        return data;
    }
}

export interface ISessionLoginResponseController extends ISessionLoginResponse {
    token?: string | undefined;
}

export class UserLoginQuery implements IUserLoginQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;

    constructor(data?: IUserLoginQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.tenancyName = _data["tenancyName"];
            this.authenticationCode = _data["authenticationCode"] ? AuthenticationCodeToValidateCommand.fromJS(_data["authenticationCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["tenancyName"] = this.tenancyName;
        data["authenticationCode"] = this.authenticationCode ? this.authenticationCode.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserLoginQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;
}

export class AuthenticationCodeToValidateCommand implements IAuthenticationCodeToValidateCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
    identificator?: string | undefined;
    origin!: AuthenticationCodeOrigin;
    code?: string | undefined;

    constructor(data?: IAuthenticationCodeToValidateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
            this.identificator = _data["identificator"];
            this.origin = _data["origin"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AuthenticationCodeToValidateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationCodeToValidateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        data["identificator"] = this.identificator;
        data["origin"] = this.origin;
        data["code"] = this.code;
        return data;
    }
}

export interface IAuthenticationCodeToValidateCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
    identificator?: string | undefined;
    origin: AuthenticationCodeOrigin;
    code?: string | undefined;
}

export enum AuthenticationCodeOrigin {
    Web = 1,
    Mobile = 2,
}

export class UserLoginMovilQuery implements IUserLoginMovilQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    deviceId?: string | undefined;
    version?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;

    constructor(data?: IUserLoginMovilQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.tenancyName = _data["tenancyName"];
            this.deviceId = _data["deviceId"];
            this.version = _data["version"];
            this.authenticationCode = _data["authenticationCode"] ? AuthenticationCodeToValidateCommand.fromJS(_data["authenticationCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginMovilQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginMovilQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["tenancyName"] = this.tenancyName;
        data["deviceId"] = this.deviceId;
        data["version"] = this.version;
        data["authenticationCode"] = this.authenticationCode ? this.authenticationCode.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserLoginMovilQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    deviceId?: string | undefined;
    version?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;
}

export class PermissionGetIsGrantedByTenantUserQuery implements IPermissionGetIsGrantedByTenantUserQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    permissionName?: string | undefined;

    constructor(data?: IPermissionGetIsGrantedByTenantUserQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.tenancyName = _data["tenancyName"];
            this.permissionName = _data["permissionName"];
        }
    }

    static fromJS(data: any): PermissionGetIsGrantedByTenantUserQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGetIsGrantedByTenantUserQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["tenancyName"] = this.tenancyName;
        data["permissionName"] = this.permissionName;
        return data;
    }
}

export interface IPermissionGetIsGrantedByTenantUserQuery {
    userName?: string | undefined;
    password?: string | undefined;
    tenancyName?: string | undefined;
    permissionName?: string | undefined;
}

export class UserImpersonalizeQuery implements IUserImpersonalizeQuery {
    tenant?: number | undefined;
    user!: number;

    constructor(data?: IUserImpersonalizeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): UserImpersonalizeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonalizeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["user"] = this.user;
        return data;
    }
}

export interface IUserImpersonalizeQuery {
    tenant?: number | undefined;
    user: number;
}

export class UserChangePasswordValidateCommand implements IUserChangePasswordValidateCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IUserChangePasswordValidateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): UserChangePasswordValidateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserChangePasswordValidateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IUserChangePasswordValidateCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export class UserChangePasswordCommand implements IUserChangePasswordCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;

    constructor(data?: IUserChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
            this.authenticationCode = _data["authenticationCode"] ? AuthenticationCodeToValidateCommand.fromJS(_data["authenticationCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["authenticationCode"] = this.authenticationCode ? this.authenticationCode.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserChangePasswordCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
    authenticationCode?: AuthenticationCodeToValidateCommand | undefined;
}

export class UserResetPasswordCommand implements IUserResetPasswordCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IUserResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): UserResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IUserResetPasswordCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
}

export class ConfirmPasswordCommandReset implements IConfirmPasswordCommandReset {
    confirmationCode?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IConfirmPasswordCommandReset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationCode = _data["confirmationCode"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ConfirmPasswordCommandReset {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordCommandReset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationCode"] = this.confirmationCode;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IConfirmPasswordCommandReset {
    confirmationCode?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class UserIsActiveMFAQuery implements IUserIsActiveMFAQuery {
    tenancyName?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IUserIsActiveMFAQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserIsActiveMFAQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserIsActiveMFAQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IUserIsActiveMFAQuery {
    tenancyName?: string | undefined;
    userName?: string | undefined;
}

export class AuthenticationCodeSendCommand implements IAuthenticationCodeSendCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
    identificator?: string | undefined;
    origin!: AuthenticationCodeOrigin;

    constructor(data?: IAuthenticationCodeSendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
            this.identificator = _data["identificator"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): AuthenticationCodeSendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationCodeSendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        data["identificator"] = this.identificator;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IAuthenticationCodeSendCommand {
    userName?: string | undefined;
    tenancyName?: string | undefined;
    identificator?: string | undefined;
    origin: AuthenticationCodeOrigin;
}

export class PagedResultDtoOfChangeLogForListResponse implements IPagedResultDtoOfChangeLogForListResponse {
    totalCount!: number;
    items?: ChangeLogForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChangeLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeLogForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChangeLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChangeLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChangeLogForListResponse {
    totalCount: number;
    items?: ChangeLogForListResponse[] | undefined;
}

export class ChangeLogForListResponse implements IChangeLogForListResponse {
    id?: number | undefined;
    user?: number | undefined;
    userDesc?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;

    constructor(data?: IChangeLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.datetime = _data["datetime"] ? moment(_data["datetime"].toString()) : <any>undefined;
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ChangeLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IChangeLogForListResponse {
    id?: number | undefined;
    user?: number | undefined;
    userDesc?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;
}

export class ChangeLogGetListQuery extends PageListByDto implements IChangeLogGetListQuery {
    table?: string | undefined;
    key?: string | undefined;

    constructor(data?: IChangeLogGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ChangeLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        data["key"] = this.key;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeLogGetListQuery extends IPageListByDto {
    table?: string | undefined;
    key?: string | undefined;
}

export class PagedResultDtoOfCommodityForListResponse implements IPagedResultDtoOfCommodityForListResponse {
    totalCount!: number;
    items?: CommodityForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommodityForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCommodityForListResponse {
    totalCount: number;
    items?: CommodityForListResponse[] | undefined;
}

export class CommodityForListResponse implements ICommodityForListResponse {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    supplierDesc?: string | undefined;
    routeDesc?: string | undefined;
    readModeDesc?: string | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ICommodityForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaDesc = _data["areaDesc"];
            this.supplierDesc = _data["supplierDesc"];
            this.routeDesc = _data["routeDesc"];
            this.readModeDesc = _data["readModeDesc"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
            this.rackSequence = _data["rackSequence"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): CommodityForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["zoneDesc"] = this.zoneDesc;
        data["areaDesc"] = this.areaDesc;
        data["supplierDesc"] = this.supplierDesc;
        data["routeDesc"] = this.routeDesc;
        data["readModeDesc"] = this.readModeDesc;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        data["rackSequence"] = this.rackSequence;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ICommodityForListResponse {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    supplierDesc?: string | undefined;
    routeDesc?: string | undefined;
    readModeDesc?: string | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class CommodityGetListQuery extends PageListByDto implements ICommodityGetListQuery {

    constructor(data?: ICommodityGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CommodityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICommodityGetListQuery extends IPageListByDto {
}

export class CommodityForEditResponse implements ICommodityForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    supplier?: number | undefined;
    supplierDesc?: string | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid!: boolean;
    isEmptyControl!: boolean;
    isValidateMarket!: boolean;
    isTandem!: boolean;
    isActive!: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    supplierCombo?: ComboboxItemDtoOfLong[] | undefined;
    routeCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: ICommodityForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.area = _data["area"];
            this.areaDesc = _data["areaDesc"];
            this.supplier = _data["supplier"];
            this.supplierDesc = _data["supplierDesc"];
            this.route = _data["route"];
            this.routeDesc = _data["routeDesc"];
            this.readMode = _data["readMode"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
            this.rackSequence = _data["rackSequence"];
            this.limitSequence = _data["limitSequence"];
            this.initialSequenceJIT = _data["initialSequenceJIT"];
            this.finalSequenceJIT = _data["finalSequenceJIT"];
            this.rackSequenceJIT = _data["rackSequenceJIT"];
            this.isValid = _data["isValid"];
            this.isEmptyControl = _data["isEmptyControl"];
            this.isValidateMarket = _data["isValidateMarket"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["supplierCombo"])) {
                this.supplierCombo = [] as any;
                for (let item of _data["supplierCombo"])
                    this.supplierCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["routeCombo"])) {
                this.routeCombo = [] as any;
                for (let item of _data["routeCombo"])
                    this.routeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommodityForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["area"] = this.area;
        data["areaDesc"] = this.areaDesc;
        data["supplier"] = this.supplier;
        data["supplierDesc"] = this.supplierDesc;
        data["route"] = this.route;
        data["routeDesc"] = this.routeDesc;
        data["readMode"] = this.readMode;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        data["rackSequence"] = this.rackSequence;
        data["limitSequence"] = this.limitSequence;
        data["initialSequenceJIT"] = this.initialSequenceJIT;
        data["finalSequenceJIT"] = this.finalSequenceJIT;
        data["rackSequenceJIT"] = this.rackSequenceJIT;
        data["isValid"] = this.isValid;
        data["isEmptyControl"] = this.isEmptyControl;
        data["isValidateMarket"] = this.isValidateMarket;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.supplierCombo)) {
            data["supplierCombo"] = [];
            for (let item of this.supplierCombo)
                data["supplierCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.routeCombo)) {
            data["routeCombo"] = [];
            for (let item of this.routeCombo)
                data["routeCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommodityForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    supplier?: number | undefined;
    supplierDesc?: string | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid: boolean;
    isEmptyControl: boolean;
    isValidateMarket: boolean;
    isTandem: boolean;
    isActive: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    supplierCombo?: ComboboxItemDtoOfLong[] | undefined;
    routeCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export enum CommodityReadMode {
    RackSequence = 1,
    RotationRange = 2,
}

export class CommodityGetForEditQuery implements ICommodityGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ICommodityGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommodityGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICommodityGetForEditQuery {
    id?: number | undefined;
}

export class CommodityGetComboQuery implements ICommodityGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ICommodityGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CommodityGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICommodityGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class CommodityCreateCommand implements ICommodityCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    area?: number | undefined;
    supplier?: number | undefined;
    route?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid!: boolean;
    isEmptyControl!: boolean;
    isValidateMarket!: boolean;
    isTandem!: boolean;
    isActive!: boolean;

    constructor(data?: ICommodityCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.area = _data["area"];
            this.supplier = _data["supplier"];
            this.route = _data["route"];
            this.readMode = _data["readMode"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
            this.rackSequence = _data["rackSequence"];
            this.limitSequence = _data["limitSequence"];
            this.initialSequenceJIT = _data["initialSequenceJIT"];
            this.finalSequenceJIT = _data["finalSequenceJIT"];
            this.rackSequenceJIT = _data["rackSequenceJIT"];
            this.isValid = _data["isValid"];
            this.isEmptyControl = _data["isEmptyControl"];
            this.isValidateMarket = _data["isValidateMarket"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CommodityCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["area"] = this.area;
        data["supplier"] = this.supplier;
        data["route"] = this.route;
        data["readMode"] = this.readMode;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        data["rackSequence"] = this.rackSequence;
        data["limitSequence"] = this.limitSequence;
        data["initialSequenceJIT"] = this.initialSequenceJIT;
        data["finalSequenceJIT"] = this.finalSequenceJIT;
        data["rackSequenceJIT"] = this.rackSequenceJIT;
        data["isValid"] = this.isValid;
        data["isEmptyControl"] = this.isEmptyControl;
        data["isValidateMarket"] = this.isValidateMarket;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICommodityCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    area?: number | undefined;
    supplier?: number | undefined;
    route?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid: boolean;
    isEmptyControl: boolean;
    isValidateMarket: boolean;
    isTandem: boolean;
    isActive: boolean;
}

export class CommodityUpdateCommand implements ICommodityUpdateCommand {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    area?: number | undefined;
    supplier?: number | undefined;
    route?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid!: boolean;
    isEmptyControl!: boolean;
    isValidateMarket!: boolean;
    isTandem!: boolean;
    isActive!: boolean;
    reasonRestart?: number | undefined;
    commentsRestart?: string | undefined;

    constructor(data?: ICommodityUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.area = _data["area"];
            this.supplier = _data["supplier"];
            this.route = _data["route"];
            this.readMode = _data["readMode"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
            this.rackSequence = _data["rackSequence"];
            this.limitSequence = _data["limitSequence"];
            this.initialSequenceJIT = _data["initialSequenceJIT"];
            this.finalSequenceJIT = _data["finalSequenceJIT"];
            this.rackSequenceJIT = _data["rackSequenceJIT"];
            this.isValid = _data["isValid"];
            this.isEmptyControl = _data["isEmptyControl"];
            this.isValidateMarket = _data["isValidateMarket"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
            this.reasonRestart = _data["reasonRestart"];
            this.commentsRestart = _data["commentsRestart"];
        }
    }

    static fromJS(data: any): CommodityUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["area"] = this.area;
        data["supplier"] = this.supplier;
        data["route"] = this.route;
        data["readMode"] = this.readMode;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        data["rackSequence"] = this.rackSequence;
        data["limitSequence"] = this.limitSequence;
        data["initialSequenceJIT"] = this.initialSequenceJIT;
        data["finalSequenceJIT"] = this.finalSequenceJIT;
        data["rackSequenceJIT"] = this.rackSequenceJIT;
        data["isValid"] = this.isValid;
        data["isEmptyControl"] = this.isEmptyControl;
        data["isValidateMarket"] = this.isValidateMarket;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        data["reasonRestart"] = this.reasonRestart;
        data["commentsRestart"] = this.commentsRestart;
        return data;
    }
}

export interface ICommodityUpdateCommand {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    area?: number | undefined;
    supplier?: number | undefined;
    route?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid: boolean;
    isEmptyControl: boolean;
    isValidateMarket: boolean;
    isTandem: boolean;
    isActive: boolean;
    reasonRestart?: number | undefined;
    commentsRestart?: string | undefined;
}

export class CommodityResponse implements ICommodityResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    supplier?: number | undefined;
    supplierDesc?: string | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid!: boolean;
    isEmptyControl!: boolean;
    isValidateMarket!: boolean;
    isTandem!: boolean;
    isActive!: boolean;

    constructor(data?: ICommodityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.area = _data["area"];
            this.areaDesc = _data["areaDesc"];
            this.supplier = _data["supplier"];
            this.supplierDesc = _data["supplierDesc"];
            this.route = _data["route"];
            this.routeDesc = _data["routeDesc"];
            this.readMode = _data["readMode"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
            this.rackSequence = _data["rackSequence"];
            this.limitSequence = _data["limitSequence"];
            this.initialSequenceJIT = _data["initialSequenceJIT"];
            this.finalSequenceJIT = _data["finalSequenceJIT"];
            this.rackSequenceJIT = _data["rackSequenceJIT"];
            this.isValid = _data["isValid"];
            this.isEmptyControl = _data["isEmptyControl"];
            this.isValidateMarket = _data["isValidateMarket"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CommodityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["area"] = this.area;
        data["areaDesc"] = this.areaDesc;
        data["supplier"] = this.supplier;
        data["supplierDesc"] = this.supplierDesc;
        data["route"] = this.route;
        data["routeDesc"] = this.routeDesc;
        data["readMode"] = this.readMode;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        data["rackSequence"] = this.rackSequence;
        data["limitSequence"] = this.limitSequence;
        data["initialSequenceJIT"] = this.initialSequenceJIT;
        data["finalSequenceJIT"] = this.finalSequenceJIT;
        data["rackSequenceJIT"] = this.rackSequenceJIT;
        data["isValid"] = this.isValid;
        data["isEmptyControl"] = this.isEmptyControl;
        data["isValidateMarket"] = this.isValidateMarket;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICommodityResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    supplier?: number | undefined;
    supplierDesc?: string | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    readMode?: CommodityReadMode | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
    rackSequence?: number | undefined;
    limitSequence?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
    isValid: boolean;
    isEmptyControl: boolean;
    isValidateMarket: boolean;
    isTandem: boolean;
    isActive: boolean;
}

export class CommodityGetForAssortmentQuery implements ICommodityGetForAssortmentQuery {
    clave?: string | undefined;

    constructor(data?: ICommodityGetForAssortmentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clave = _data["clave"];
        }
    }

    static fromJS(data: any): CommodityGetForAssortmentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetForAssortmentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clave"] = this.clave;
        return data;
    }
}

export interface ICommodityGetForAssortmentQuery {
    clave?: string | undefined;
}

export class PickListGenerarQuery implements IPickListGenerarQuery {
    commodityId?: string | undefined;
    secuencia?: string | undefined;

    constructor(data?: IPickListGenerarQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodityId = _data["commodityId"];
            this.secuencia = _data["secuencia"];
        }
    }

    static fromJS(data: any): PickListGenerarQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PickListGenerarQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityId"] = this.commodityId;
        data["secuencia"] = this.secuencia;
        return data;
    }
}

export interface IPickListGenerarQuery {
    commodityId?: string | undefined;
    secuencia?: string | undefined;
}

export class PickListDataResponse implements IPickListDataResponse {
    titulo?: string | undefined;
    subtitulo?: string | undefined;
    commodityDesc?: string | undefined;
    codigoBarras?: string | undefined;
    commodities?: string | undefined;
    wip?: string | undefined;
    secuenciaFinal?: string | undefined;
    numUnidades?: number | undefined;
    totalNumerosParteSurtir?: number | undefined;
    totalNumerosParteWIP?: number | undefined;
    horaInicio?: string | undefined;
    horaFin?: string | undefined;
    partes?: PickListParteItem[] | undefined;

    constructor(data?: IPickListDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titulo = _data["titulo"];
            this.subtitulo = _data["subtitulo"];
            this.commodityDesc = _data["commodityDesc"];
            this.codigoBarras = _data["codigoBarras"];
            this.commodities = _data["commodities"];
            this.wip = _data["wip"];
            this.secuenciaFinal = _data["secuenciaFinal"];
            this.numUnidades = _data["numUnidades"];
            this.totalNumerosParteSurtir = _data["totalNumerosParteSurtir"];
            this.totalNumerosParteWIP = _data["totalNumerosParteWIP"];
            this.horaInicio = _data["horaInicio"];
            this.horaFin = _data["horaFin"];
            if (Array.isArray(_data["partes"])) {
                this.partes = [] as any;
                for (let item of _data["partes"])
                    this.partes!.push(PickListParteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickListDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PickListDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titulo"] = this.titulo;
        data["subtitulo"] = this.subtitulo;
        data["commodityDesc"] = this.commodityDesc;
        data["codigoBarras"] = this.codigoBarras;
        data["commodities"] = this.commodities;
        data["wip"] = this.wip;
        data["secuenciaFinal"] = this.secuenciaFinal;
        data["numUnidades"] = this.numUnidades;
        data["totalNumerosParteSurtir"] = this.totalNumerosParteSurtir;
        data["totalNumerosParteWIP"] = this.totalNumerosParteWIP;
        data["horaInicio"] = this.horaInicio;
        data["horaFin"] = this.horaFin;
        if (Array.isArray(this.partes)) {
            data["partes"] = [];
            for (let item of this.partes)
                data["partes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPickListDataResponse {
    titulo?: string | undefined;
    subtitulo?: string | undefined;
    commodityDesc?: string | undefined;
    codigoBarras?: string | undefined;
    commodities?: string | undefined;
    wip?: string | undefined;
    secuenciaFinal?: string | undefined;
    numUnidades?: number | undefined;
    totalNumerosParteSurtir?: number | undefined;
    totalNumerosParteWIP?: number | undefined;
    horaInicio?: string | undefined;
    horaFin?: string | undefined;
    partes?: PickListParteItem[] | undefined;
}

export class PickListParteItem implements IPickListParteItem {
    numParte?: string | undefined;
    piezasUsar?: string | undefined;
    qtySurtir?: number | undefined;
    locacion?: string | undefined;
    qtyLoc?: string | undefined;
    fifo?: string | undefined;
    qtyWIP?: string | undefined;
    qtyWIPFinal?: string | undefined;
    qtySurtida?: string | undefined;
    posicion?: string | undefined;
    commodity?: string | undefined;
    coordenadas?: string | undefined;

    constructor(data?: IPickListParteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numParte = _data["numParte"];
            this.piezasUsar = _data["piezasUsar"];
            this.qtySurtir = _data["qtySurtir"];
            this.locacion = _data["locacion"];
            this.qtyLoc = _data["qtyLoc"];
            this.fifo = _data["fifo"];
            this.qtyWIP = _data["qtyWIP"];
            this.qtyWIPFinal = _data["qtyWIPFinal"];
            this.qtySurtida = _data["qtySurtida"];
            this.posicion = _data["posicion"];
            this.commodity = _data["commodity"];
            this.coordenadas = _data["coordenadas"];
        }
    }

    static fromJS(data: any): PickListParteItem {
        data = typeof data === 'object' ? data : {};
        let result = new PickListParteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numParte"] = this.numParte;
        data["piezasUsar"] = this.piezasUsar;
        data["qtySurtir"] = this.qtySurtir;
        data["locacion"] = this.locacion;
        data["qtyLoc"] = this.qtyLoc;
        data["fifo"] = this.fifo;
        data["qtyWIP"] = this.qtyWIP;
        data["qtyWIPFinal"] = this.qtyWIPFinal;
        data["qtySurtida"] = this.qtySurtida;
        data["posicion"] = this.posicion;
        data["commodity"] = this.commodity;
        data["coordenadas"] = this.coordenadas;
        return data;
    }
}

export interface IPickListParteItem {
    numParte?: string | undefined;
    piezasUsar?: string | undefined;
    qtySurtir?: number | undefined;
    locacion?: string | undefined;
    qtyLoc?: string | undefined;
    fifo?: string | undefined;
    qtyWIP?: string | undefined;
    qtyWIPFinal?: string | undefined;
    qtySurtida?: string | undefined;
    posicion?: string | undefined;
    commodity?: string | undefined;
    coordenadas?: string | undefined;
}

export class PickListGetLastLoadsResponse implements IPickListGetLastLoadsResponse {
    success?: boolean | undefined;
    errorMessage?: string | undefined;
    fechaUltimaCargaDetallado?: Date | undefined;
    fechaUltimaCargaInventario?: Date | undefined;
    fechaUltimaCargaSIC?: Date | undefined;

    constructor(data?: IPickListGetLastLoadsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.errorMessage = data["errorMessage"];
            this.fechaUltimaCargaDetallado = data["fechaUltimaCargaDetallado"] ? new Date(data["fechaUltimaCargaDetallado"].toString()) : <any>undefined;
            this.fechaUltimaCargaInventario = data["fechaUltimaCargaInventario"] ? new Date(data["fechaUltimaCargaInventario"].toString()) : <any>undefined;
            this.fechaUltimaCargaSIC = data["fechaUltimaCargaSIC"] ? new Date(data["fechaUltimaCargaSIC"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PickListGetLastLoadsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PickListGetLastLoadsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["fechaUltimaCargaDetallado"] = this.fechaUltimaCargaDetallado ? this.fechaUltimaCargaDetallado.toISOString() : <any>undefined;
        data["fechaUltimaCargaInventario"] = this.fechaUltimaCargaInventario ? this.fechaUltimaCargaInventario.toISOString() : <any>undefined;
        data["fechaUltimaCargaSIC"] = this.fechaUltimaCargaSIC ? this.fechaUltimaCargaSIC.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPickListGetLastLoadsResponse {
    success?: boolean | undefined;
    errorMessage?: string | undefined;
    fechaUltimaCargaDetallado?: Date | undefined;
    fechaUltimaCargaInventario?: Date | undefined;
    fechaUltimaCargaSIC?: Date | undefined;
}

export class CommodityGetForDownloadJitQuery implements ICommodityGetForDownloadJitQuery {
    clave?: string | undefined;
    anden?: number | undefined;

    constructor(data?: ICommodityGetForDownloadJitQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clave = _data["clave"];
            this.anden = _data["anden"];
        }
    }

    static fromJS(data: any): CommodityGetForDownloadJitQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetForDownloadJitQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clave"] = this.clave;
        data["anden"] = this.anden;
        return data;
    }
}

export interface ICommodityGetForDownloadJitQuery {
    clave?: string | undefined;
    anden?: number | undefined;
}

export class CommodityGetByIdQuery implements ICommodityGetByIdQuery {
    id!: number;

    constructor(data?: ICommodityGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommodityGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICommodityGetByIdQuery {
    id: number;
}

export class CommodityUpdateJitSequenceCommand implements ICommodityUpdateJitSequenceCommand {
    id?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;

    constructor(data?: ICommodityUpdateJitSequenceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initialSequenceJIT = _data["initialSequenceJIT"];
            this.finalSequenceJIT = _data["finalSequenceJIT"];
            this.rackSequenceJIT = _data["rackSequenceJIT"];
        }
    }

    static fromJS(data: any): CommodityUpdateJitSequenceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityUpdateJitSequenceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initialSequenceJIT"] = this.initialSequenceJIT;
        data["finalSequenceJIT"] = this.finalSequenceJIT;
        data["rackSequenceJIT"] = this.rackSequenceJIT;
        return data;
    }
}

export interface ICommodityUpdateJitSequenceCommand {
    id?: number | undefined;
    initialSequenceJIT?: number | undefined;
    finalSequenceJIT?: number | undefined;
    rackSequenceJIT?: number | undefined;
}

export class PagedResultDtoOfDownloadScheduleForListResponse implements IPagedResultDtoOfDownloadScheduleForListResponse {
    totalCount!: number;
    items?: DownloadScheduleForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfDownloadScheduleForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DownloadScheduleForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDownloadScheduleForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDownloadScheduleForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDownloadScheduleForListResponse {
    totalCount: number;
    items?: DownloadScheduleForListResponse[] | undefined;
}

export class DownloadScheduleForListResponse implements IDownloadScheduleForListResponse {
    id!: number;
    workShiftDesc?: string | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;

    constructor(data?: IDownloadScheduleForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadScheduleForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workShiftDesc"] = this.workShiftDesc;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadScheduleForListResponse {
    id: number;
    workShiftDesc?: string | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
}

export class DownloadScheduleGetListQuery extends PageListByDto implements IDownloadScheduleGetListQuery {

    constructor(data?: IDownloadScheduleGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DownloadScheduleGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDownloadScheduleGetListQuery extends IPageListByDto {
}

export class DownloadScheduleForEditResponse implements IDownloadScheduleForEditResponse {
    id?: number | undefined;
    workShift?: number | undefined;
    workShiftDesc?: string | undefined;
    user!: number;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    workShiftCombo?: ComboboxItemDtoOfLong[] | undefined;
    workShiftResponse?: WorkShiftResponse | undefined;

    constructor(data?: IDownloadScheduleForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workShift = _data["workShift"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["workShiftCombo"])) {
                this.workShiftCombo = [] as any;
                for (let item of _data["workShiftCombo"])
                    this.workShiftCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            this.workShiftResponse = _data["workShiftResponse"] ? WorkShiftResponse.fromJS(_data["workShiftResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadScheduleForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workShift"] = this.workShift;
        data["workShiftDesc"] = this.workShiftDesc;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.workShiftCombo)) {
            data["workShiftCombo"] = [];
            for (let item of this.workShiftCombo)
                data["workShiftCombo"].push(item.toJSON());
        }
        data["workShiftResponse"] = this.workShiftResponse ? this.workShiftResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDownloadScheduleForEditResponse {
    id?: number | undefined;
    workShift?: number | undefined;
    workShiftDesc?: string | undefined;
    user: number;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    workShiftCombo?: ComboboxItemDtoOfLong[] | undefined;
    workShiftResponse?: WorkShiftResponse | undefined;
}

export class WorkShiftResponse implements IWorkShiftResponse {
    id?: number | undefined;
    description?: string | undefined;
    startTime!: moment.Duration;
    endTime!: moment.Duration;
    isActive!: boolean;

    constructor(data?: IWorkShiftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment.duration(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment.duration(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WorkShiftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWorkShiftResponse {
    id?: number | undefined;
    description?: string | undefined;
    startTime: moment.Duration;
    endTime: moment.Duration;
    isActive: boolean;
}

export class DownloadScheduleGetForEditQuery implements IDownloadScheduleGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IDownloadScheduleGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadScheduleGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadScheduleGetForEditQuery {
    id?: number | undefined;
}

export class DownloadScheduleCreateCommand implements IDownloadScheduleCreateCommand {
    workShift?: number | undefined;
    date?: moment.Moment | undefined;
    details?: DownloadScheduleDetailCreateCommand[] | undefined;

    constructor(data?: IDownloadScheduleCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workShift = _data["workShift"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DownloadScheduleDetailCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadScheduleCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workShift"] = this.workShift;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadScheduleCreateCommand {
    workShift?: number | undefined;
    date?: moment.Moment | undefined;
    details?: DownloadScheduleDetailCreateCommand[] | undefined;
}

export class DownloadScheduleDetailCreateCommand implements IDownloadScheduleDetailCreateCommand {
    id?: number | undefined;
    materialUpload?: number | undefined;
    platformWindow?: number | undefined;
    downloadTime?: moment.Duration | undefined;
    comments?: string | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;

    constructor(data?: IDownloadScheduleDetailCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialUpload = _data["materialUpload"];
            this.platformWindow = _data["platformWindow"];
            this.downloadTime = _data["downloadTime"] ? moment.duration(_data["downloadTime"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.platformKey = _data["platformKey"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialUpload"] = this.materialUpload;
        data["platformWindow"] = this.platformWindow;
        data["downloadTime"] = this.downloadTime ? this.downloadTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["comments"] = this.comments;
        data["platformKey"] = this.platformKey;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        return data;
    }
}

export interface IDownloadScheduleDetailCreateCommand {
    id?: number | undefined;
    materialUpload?: number | undefined;
    platformWindow?: number | undefined;
    downloadTime?: moment.Duration | undefined;
    comments?: string | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
}

export class DownloadScheduleUpdateCommand implements IDownloadScheduleUpdateCommand {
    id!: number;
    date?: moment.Moment | undefined;
    details?: DownloadScheduleDetailCreateCommand[] | undefined;

    constructor(data?: IDownloadScheduleUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DownloadScheduleDetailCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadScheduleUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadScheduleUpdateCommand {
    id: number;
    date?: moment.Moment | undefined;
    details?: DownloadScheduleDetailCreateCommand[] | undefined;
}

export class PlatformForListResponse implements IPlatformForListResponse {
    id!: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;
    quantityOfWindows!: number;
    windows?: PlatformWindowResponse[] | undefined;

    constructor(data?: IPlatformForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zoneDesc = _data["zoneDesc"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.quantityOfWindows = _data["quantityOfWindows"];
            if (Array.isArray(_data["windows"])) {
                this.windows = [] as any;
                for (let item of _data["windows"])
                    this.windows!.push(PlatformWindowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zoneDesc"] = this.zoneDesc;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["quantityOfWindows"] = this.quantityOfWindows;
        if (Array.isArray(this.windows)) {
            data["windows"] = [];
            for (let item of this.windows)
                data["windows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformForListResponse {
    id: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
    quantityOfWindows: number;
    windows?: PlatformWindowResponse[] | undefined;
}

export class PlatformWindowResponse implements IPlatformWindowResponse {
    id?: number | undefined;
    platform?: number | undefined;
    location!: number;
    locationDesc?: string | undefined;
    number!: number;

    constructor(data?: IPlatformWindowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.location = _data["location"];
            this.locationDesc = _data["locationDesc"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): PlatformWindowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformWindowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["location"] = this.location;
        data["locationDesc"] = this.locationDesc;
        data["number"] = this.number;
        return data;
    }
}

export interface IPlatformWindowResponse {
    id?: number | undefined;
    platform?: number | undefined;
    location: number;
    locationDesc?: string | undefined;
    number: number;
}

export class DownloadSchedulePlatformGetListQuery implements IDownloadSchedulePlatformGetListQuery {
    downloadSchedule?: number | undefined;

    constructor(data?: IDownloadSchedulePlatformGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadSchedule = _data["downloadSchedule"];
        }
    }

    static fromJS(data: any): DownloadSchedulePlatformGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSchedulePlatformGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadSchedule"] = this.downloadSchedule;
        return data;
    }
}

export interface IDownloadSchedulePlatformGetListQuery {
    downloadSchedule?: number | undefined;
}

export class DownloadSchedulePlatformByStatusGetListQuery implements IDownloadSchedulePlatformByStatusGetListQuery {
    status?: MaterialUploadStatus[] | undefined;

    constructor(data?: IDownloadSchedulePlatformByStatusGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadSchedulePlatformByStatusGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSchedulePlatformByStatusGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        return data;
    }
}

export interface IDownloadSchedulePlatformByStatusGetListQuery {
    status?: MaterialUploadStatus[] | undefined;
}

export enum MaterialUploadStatus {
    Pending = 1,
    Finished = 2,
    Partial = 3,
    Cancelled = 4,
    Suspended = 5,
}

export class PagedResultDtoOfDownloadScheduleDetailForListResponse implements IPagedResultDtoOfDownloadScheduleDetailForListResponse {
    totalCount!: number;
    items?: DownloadScheduleDetailForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfDownloadScheduleDetailForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DownloadScheduleDetailForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDownloadScheduleDetailForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDownloadScheduleDetailForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDownloadScheduleDetailForListResponse {
    totalCount: number;
    items?: DownloadScheduleDetailForListResponse[] | undefined;
}

export class DownloadScheduleDetailForListResponse implements IDownloadScheduleDetailForListResponse {
    id?: number | undefined;
    downloadSchedule?: number | undefined;
    materialUpload?: number | undefined;
    platformWindow?: number | undefined;
    platformWindowNumber?: number | undefined;
    downloadTime?: moment.Duration | undefined;
    comments?: string | undefined;
    platform?: number | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    carrierKey?: string | undefined;
    vehicleStatus?: string | undefined;
    vehicleStatusDesc?: string | undefined;
    baseDate?: moment.Moment | undefined;
    arrivalTime?: moment.Moment | undefined;
    status?: MaterialUploadStatus | undefined;
    statusDesc?: string | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    supplierKey?: string | undefined;
    totalParts!: number;
    totalDownloadedParts?: number | undefined;
    isCritic!: boolean;
    critic?: number | undefined;
    container?: number | undefined;
    shipDays?: number | undefined;
    lastDownloadType?: DownloadTipo | undefined;

    constructor(data?: IDownloadScheduleDetailForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downloadSchedule = _data["downloadSchedule"];
            this.materialUpload = _data["materialUpload"];
            this.platformWindow = _data["platformWindow"];
            this.platformWindowNumber = _data["platformWindowNumber"];
            this.downloadTime = _data["downloadTime"] ? moment.duration(_data["downloadTime"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.platform = _data["platform"];
            this.platformKey = _data["platformKey"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.carrierKey = _data["carrierKey"];
            this.vehicleStatus = _data["vehicleStatus"];
            this.vehicleStatusDesc = _data["vehicleStatusDesc"];
            this.baseDate = _data["baseDate"] ? moment(_data["baseDate"].toString()) : <any>undefined;
            this.arrivalTime = _data["arrivalTime"] ? moment(_data["arrivalTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusDesc = _data["statusDesc"];
            this.partBase = _data["partBase"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.supplierKey = _data["supplierKey"];
            this.totalParts = _data["totalParts"];
            this.totalDownloadedParts = _data["totalDownloadedParts"];
            this.isCritic = _data["isCritic"];
            this.critic = _data["critic"];
            this.container = _data["container"];
            this.shipDays = _data["shipDays"];
            this.lastDownloadType = _data["lastDownloadType"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downloadSchedule"] = this.downloadSchedule;
        data["materialUpload"] = this.materialUpload;
        data["platformWindow"] = this.platformWindow;
        data["platformWindowNumber"] = this.platformWindowNumber;
        data["downloadTime"] = this.downloadTime ? this.downloadTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["comments"] = this.comments;
        data["platform"] = this.platform;
        data["platformKey"] = this.platformKey;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        data["carrierKey"] = this.carrierKey;
        data["vehicleStatus"] = this.vehicleStatus;
        data["vehicleStatusDesc"] = this.vehicleStatusDesc;
        data["baseDate"] = this.baseDate ? this.baseDate.toISOString() : <any>undefined;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusDesc"] = this.statusDesc;
        data["partBase"] = this.partBase;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["supplierKey"] = this.supplierKey;
        data["totalParts"] = this.totalParts;
        data["totalDownloadedParts"] = this.totalDownloadedParts;
        data["isCritic"] = this.isCritic;
        data["critic"] = this.critic;
        data["container"] = this.container;
        data["shipDays"] = this.shipDays;
        data["lastDownloadType"] = this.lastDownloadType;
        return data;
    }
}

export interface IDownloadScheduleDetailForListResponse {
    id?: number | undefined;
    downloadSchedule?: number | undefined;
    materialUpload?: number | undefined;
    platformWindow?: number | undefined;
    platformWindowNumber?: number | undefined;
    downloadTime?: moment.Duration | undefined;
    comments?: string | undefined;
    platform?: number | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    carrierKey?: string | undefined;
    vehicleStatus?: string | undefined;
    vehicleStatusDesc?: string | undefined;
    baseDate?: moment.Moment | undefined;
    arrivalTime?: moment.Moment | undefined;
    status?: MaterialUploadStatus | undefined;
    statusDesc?: string | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    supplierKey?: string | undefined;
    totalParts: number;
    totalDownloadedParts?: number | undefined;
    isCritic: boolean;
    critic?: number | undefined;
    container?: number | undefined;
    shipDays?: number | undefined;
    lastDownloadType?: DownloadTipo | undefined;
}

export enum DownloadTipo {
    Completa = 1,
    Parcial = 2,
}

export class DownloadScheduleWithUploadGetListQuery extends PageListByDto implements IDownloadScheduleWithUploadGetListQuery {
    downloadSchedule?: number | undefined;
    platform?: number | undefined;

    constructor(data?: IDownloadScheduleWithUploadGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.downloadSchedule = _data["downloadSchedule"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): DownloadScheduleWithUploadGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleWithUploadGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadSchedule"] = this.downloadSchedule;
        data["platform"] = this.platform;
        super.toJSON(data);
        return data;
    }
}

export interface IDownloadScheduleWithUploadGetListQuery extends IPageListByDto {
    downloadSchedule?: number | undefined;
    platform?: number | undefined;
}

export class DownloadScheduleWithUploadByStatusGetListQuery extends PageListByDto implements IDownloadScheduleWithUploadByStatusGetListQuery {
    downloadSchedule?: number | undefined;
    platform?: number | undefined;
    status?: MaterialUploadStatus[] | undefined;

    constructor(data?: IDownloadScheduleWithUploadByStatusGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.downloadSchedule = _data["downloadSchedule"];
            this.platform = _data["platform"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadScheduleWithUploadByStatusGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleWithUploadByStatusGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadSchedule"] = this.downloadSchedule;
        data["platform"] = this.platform;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDownloadScheduleWithUploadByStatusGetListQuery extends IPageListByDto {
    downloadSchedule?: number | undefined;
    platform?: number | undefined;
    status?: MaterialUploadStatus[] | undefined;
}

export class DownloadScheduleDetailExcelResponse implements IDownloadScheduleDetailExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IDownloadScheduleDetailExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IDownloadScheduleDetailExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class DownloadScheduleDetailGetExcelQuery implements IDownloadScheduleDetailGetExcelQuery {
    downloadSchedule!: number;
    platform?: number | undefined;

    constructor(data?: IDownloadScheduleDetailGetExcelQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadSchedule = _data["downloadSchedule"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadSchedule"] = this.downloadSchedule;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IDownloadScheduleDetailGetExcelQuery {
    downloadSchedule: number;
    platform?: number | undefined;
}

export class DownloadScheduleDetailGetPendingGroupedListQuery implements IDownloadScheduleDetailGetPendingGroupedListQuery {
    workshift!: number;
    platform!: number;

    constructor(data?: IDownloadScheduleDetailGetPendingGroupedListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workshift = _data["workshift"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailGetPendingGroupedListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailGetPendingGroupedListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workshift"] = this.workshift;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IDownloadScheduleDetailGetPendingGroupedListQuery {
    workshift: number;
    platform: number;
}

export class DownloadScheduleDetailGetPendingListQuery implements IDownloadScheduleDetailGetPendingListQuery {
    workshift!: number;
    boxNumber?: string | undefined;

    constructor(data?: IDownloadScheduleDetailGetPendingListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workshift = _data["workshift"];
            this.boxNumber = _data["boxNumber"];
        }
    }

    static fromJS(data: any): DownloadScheduleDetailGetPendingListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScheduleDetailGetPendingListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workshift"] = this.workshift;
        data["boxNumber"] = this.boxNumber;
        return data;
    }
}

export interface IDownloadScheduleDetailGetPendingListQuery {
    workshift: number;
    boxNumber?: string | undefined;
}

export class FileUploadResponse implements IFileUploadResponse {
    fileName?: string | undefined;
    fileSize!: number;
    tempFileName?: string | undefined;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.tempFileName = _data["tempFileName"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["tempFileName"] = this.tempFileName;
        return data;
    }
}

export interface IFileUploadResponse {
    fileName?: string | undefined;
    fileSize: number;
    tempFileName?: string | undefined;
}

export class PagedResultDtoOfHelpForListResponse implements IPagedResultDtoOfHelpForListResponse {
    totalCount!: number;
    items?: HelpForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfHelpForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HelpForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHelpForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHelpForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfHelpForListResponse {
    totalCount: number;
    items?: HelpForListResponse[] | undefined;
}

export class HelpForListResponse implements IHelpForListResponse {
    id!: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IHelpForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): HelpForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IHelpForListResponse {
    id: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class HelpGetListQuery extends PageListByDto implements IHelpGetListQuery {

    constructor(data?: IHelpGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HelpGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHelpGetListQuery extends IPageListByDto {
}

export class HelpResponse implements IHelpResponse {
    id?: number | undefined;
    language!: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpResponse {
    id?: number | undefined;
    language: number;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HelpForEditResponse implements IHelpForEditResponse {
    id?: number | undefined;
    language?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
    keyCombo?: ComboboxItemDto[] | undefined;

    constructor(data?: IHelpForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["keyCombo"])) {
                this.keyCombo = [] as any;
                for (let item of _data["keyCombo"])
                    this.keyCombo!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HelpForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.keyCombo)) {
            data["keyCombo"] = [];
            for (let item of this.keyCombo)
                data["keyCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHelpForEditResponse {
    id?: number | undefined;
    language?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
    keyCombo?: ComboboxItemDto[] | undefined;
}

export class ComboboxItemDtoOfString implements IComboboxItemDtoOfString {
    value?: string | undefined;
    label?: string | undefined;

    constructor(data?: IComboboxItemDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IComboboxItemDtoOfString {
    value?: string | undefined;
    label?: string | undefined;
}

export class ComboboxItemDto extends ComboboxItemDtoOfString implements IComboboxItemDto {

    constructor(data?: IComboboxItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IComboboxItemDto extends IComboboxItemDtoOfString {
}

export class HelpGetForEditQuery implements IHelpGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IHelpGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HelpGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HelpGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IHelpGetForEditQuery {
    id?: number | undefined;
}

export class HelpCreateCommand implements IHelpCreateCommand {
    language!: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HelpCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpCreateCommand {
    language: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HelpUpdateCommand implements IHelpUpdateCommand {
    id!: number;
    language!: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive!: boolean;

    constructor(data?: IHelpUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HelpUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HelpUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHelpUpdateCommand {
    id: number;
    language: number;
    key?: string | undefined;
    displayName?: string | undefined;
    body?: string | undefined;
    isActive: boolean;
}

export class HostSettingsForEditResponse implements IHostSettingsForEditResponse {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: HostSettingsPasswordComplexityResponse | undefined;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    enableTwoFactorLogin!: boolean;
    enableMailVerification!: boolean;
    enableSMSVerification!: boolean;
    enableBrowserRemenberMe!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod!: EmailSendMethod;
    grpcEmail?: HostGrpcEmailResponse | undefined;

    constructor(data?: IHostSettingsForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteRootAddress = _data["webSiteRootAddress"];
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? HostSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.passwordComplexityDefault = _data["passwordComplexityDefault"] ? HostSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexityDefault"]) : <any>undefined;
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.enableTwoFactorLogin = _data["enableTwoFactorLogin"];
            this.enableMailVerification = _data["enableMailVerification"];
            this.enableSMSVerification = _data["enableSMSVerification"];
            this.enableBrowserRemenberMe = _data["enableBrowserRemenberMe"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.emailSendMethod = _data["emailSendMethod"];
            this.grpcEmail = _data["grpcEmail"] ? HostGrpcEmailResponse.fromJS(_data["grpcEmail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteRootAddress"] = this.webSiteRootAddress;
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["passwordComplexityDefault"] = this.passwordComplexityDefault ? this.passwordComplexityDefault.toJSON() : <any>undefined;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["enableTwoFactorLogin"] = this.enableTwoFactorLogin;
        data["enableMailVerification"] = this.enableMailVerification;
        data["enableSMSVerification"] = this.enableSMSVerification;
        data["enableBrowserRemenberMe"] = this.enableBrowserRemenberMe;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["emailSendMethod"] = this.emailSendMethod;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsForEditResponse {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: HostSettingsPasswordComplexityResponse | undefined;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    enableTwoFactorLogin: boolean;
    enableMailVerification: boolean;
    enableSMSVerification: boolean;
    enableBrowserRemenberMe: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod: EmailSendMethod;
    grpcEmail?: HostGrpcEmailResponse | undefined;
}

export class HostSettingsPasswordComplexityResponse implements IHostSettingsPasswordComplexityResponse {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: IHostSettingsPasswordComplexityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): HostSettingsPasswordComplexityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsPasswordComplexityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface IHostSettingsPasswordComplexityResponse {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export enum EmailSendMethod {
    Normal = 0,
    Grpc = 1,
}

export class HostGrpcEmailResponse implements IHostGrpcEmailResponse {
    sendConfiguration!: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IHostGrpcEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendConfiguration = _data["sendConfiguration"];
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): HostGrpcEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostGrpcEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendConfiguration"] = this.sendConfiguration;
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IHostGrpcEmailResponse {
    sendConfiguration: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class HostSettingsGetForEditQuery implements IHostSettingsGetForEditQuery {

    constructor(data?: IHostSettingsGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): HostSettingsGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IHostSettingsGetForEditQuery {
}

export class HostSettingsUpdateCommand implements IHostSettingsUpdateCommand {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityCommand | undefined;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    enableTwoFactorLogin!: boolean;
    enableMailVerification!: boolean;
    enableSMSVerification!: boolean;
    enableBrowserRemenberMe!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: HostGrpcEmailCommand | undefined;

    constructor(data?: IHostSettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteRootAddress = _data["webSiteRootAddress"];
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? HostSettingsPasswordComplexityCommand.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.enableTwoFactorLogin = _data["enableTwoFactorLogin"];
            this.enableMailVerification = _data["enableMailVerification"];
            this.enableSMSVerification = _data["enableSMSVerification"];
            this.enableBrowserRemenberMe = _data["enableBrowserRemenberMe"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.grpcEmail = _data["grpcEmail"] ? HostGrpcEmailCommand.fromJS(_data["grpcEmail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteRootAddress"] = this.webSiteRootAddress;
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["enableTwoFactorLogin"] = this.enableTwoFactorLogin;
        data["enableMailVerification"] = this.enableMailVerification;
        data["enableSMSVerification"] = this.enableSMSVerification;
        data["enableBrowserRemenberMe"] = this.enableBrowserRemenberMe;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsUpdateCommand {
    webSiteRootAddress?: string | undefined;
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: HostSettingsPasswordComplexityCommand | undefined;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    enableTwoFactorLogin: boolean;
    enableMailVerification: boolean;
    enableSMSVerification: boolean;
    enableBrowserRemenberMe: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: HostGrpcEmailCommand | undefined;
}

export class HostSettingsPasswordComplexityCommand implements IHostSettingsPasswordComplexityCommand {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;

    constructor(data?: IHostSettingsPasswordComplexityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
        }
    }

    static fromJS(data: any): HostSettingsPasswordComplexityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsPasswordComplexityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        return data;
    }
}

export interface IHostSettingsPasswordComplexityCommand {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
}

export class HostGrpcEmailCommand implements IHostGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IHostGrpcEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): HostGrpcEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostGrpcEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IHostGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class HostSettingsSendTestEmailCommand implements IHostSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;

    constructor(data?: IHostSettingsSendTestEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): HostSettingsSendTestEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsSendTestEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IHostSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;
}

export class StockResponse implements IStockResponse {
    location?: number | undefined;
    part?: number | undefined;
    quantity!: number;

    constructor(data?: IStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.part = _data["part"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): StockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["part"] = this.part;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IStockResponse {
    location?: number | undefined;
    part?: number | undefined;
    quantity: number;
}

export class LocationPackageIsSerieAvaliableQuery implements ILocationPackageIsSerieAvaliableQuery {
    serie?: string | undefined;

    constructor(data?: ILocationPackageIsSerieAvaliableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): LocationPackageIsSerieAvaliableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPackageIsSerieAvaliableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serie"] = this.serie;
        return data;
    }
}

export interface ILocationPackageIsSerieAvaliableQuery {
    serie?: string | undefined;
}

export class LocationPackageResponse implements ILocationPackageResponse {
    id?: number | undefined;
    location?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: ILocationPackageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.part = _data["part"];
            this.serie = _data["serie"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): LocationPackageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPackageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["part"] = this.part;
        data["serie"] = this.serie;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ILocationPackageResponse {
    id?: number | undefined;
    location?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    quantity?: number | undefined;
}

export class LocationPackageGetBySerieQuery implements ILocationPackageGetBySerieQuery {
    serie?: string | undefined;

    constructor(data?: ILocationPackageGetBySerieQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): LocationPackageGetBySerieQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPackageGetBySerieQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serie"] = this.serie;
        return data;
    }
}

export interface ILocationPackageGetBySerieQuery {
    serie?: string | undefined;
}

export class InventoryAdjustmentCreateCommand implements IInventoryAdjustmentCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    ubicacionFinal?: number | undefined;
    fechaAjuste?: moment.Moment | undefined;
    fechaAjusteBase?: moment.Moment | undefined;
    detalleList?: InventoryAdjustmentDetailCreateCommand[] | undefined;
    actividadList?: InventoryAdjustmentActivityCreateCommand[] | undefined;

    constructor(data?: IInventoryAdjustmentCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ubicacionInicial = _data["ubicacionInicial"];
            this.ubicacionFinal = _data["ubicacionFinal"];
            this.fechaAjuste = _data["fechaAjuste"] ? moment(_data["fechaAjuste"].toString()) : <any>undefined;
            this.fechaAjusteBase = _data["fechaAjusteBase"] ? moment(_data["fechaAjusteBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(InventoryAdjustmentDetailCreateCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(InventoryAdjustmentActivityCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryAdjustmentCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ubicacionInicial"] = this.ubicacionInicial;
        data["ubicacionFinal"] = this.ubicacionFinal;
        data["fechaAjuste"] = this.fechaAjuste ? this.fechaAjuste.toISOString() : <any>undefined;
        data["fechaAjusteBase"] = this.fechaAjusteBase ? this.fechaAjusteBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInventoryAdjustmentCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    ubicacionFinal?: number | undefined;
    fechaAjuste?: moment.Moment | undefined;
    fechaAjusteBase?: moment.Moment | undefined;
    detalleList?: InventoryAdjustmentDetailCreateCommand[] | undefined;
    actividadList?: InventoryAdjustmentActivityCreateCommand[] | undefined;
}

export class InventoryAdjustmentDetailCreateCommand implements IInventoryAdjustmentDetailCreateCommand {
    ubicacionSistema?: number | undefined;
    ubicacionBulto?: number | undefined;
    parte?: number | undefined;
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;
    serie?: string | undefined;
    tipoMovimiento?: number | undefined;
    cantidad?: number | undefined;
    cantidadAjustada?: number | undefined;

    constructor(data?: IInventoryAdjustmentDetailCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubicacionSistema = _data["ubicacionSistema"];
            this.ubicacionBulto = _data["ubicacionBulto"];
            this.parte = _data["parte"];
            this.prefijo = _data["prefijo"];
            this.base = _data["base"];
            this.sufijo = _data["sufijo"];
            this.parteBase = _data["parteBase"];
            this.serie = _data["serie"];
            this.tipoMovimiento = _data["tipoMovimiento"];
            this.cantidad = _data["cantidad"];
            this.cantidadAjustada = _data["cantidadAjustada"];
        }
    }

    static fromJS(data: any): InventoryAdjustmentDetailCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentDetailCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubicacionSistema"] = this.ubicacionSistema;
        data["ubicacionBulto"] = this.ubicacionBulto;
        data["parte"] = this.parte;
        data["prefijo"] = this.prefijo;
        data["base"] = this.base;
        data["sufijo"] = this.sufijo;
        data["parteBase"] = this.parteBase;
        data["serie"] = this.serie;
        data["tipoMovimiento"] = this.tipoMovimiento;
        data["cantidad"] = this.cantidad;
        data["cantidadAjustada"] = this.cantidadAjustada;
        return data;
    }
}

export interface IInventoryAdjustmentDetailCreateCommand {
    ubicacionSistema?: number | undefined;
    ubicacionBulto?: number | undefined;
    parte?: number | undefined;
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;
    serie?: string | undefined;
    tipoMovimiento?: number | undefined;
    cantidad?: number | undefined;
    cantidadAjustada?: number | undefined;
}

export class InventoryAdjustmentActivityCreateCommand implements IInventoryAdjustmentActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IInventoryAdjustmentActivityCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryAdjustmentActivityCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentActivityCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInventoryAdjustmentActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class InventoryAdjustmentCancelCommand implements IInventoryAdjustmentCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaAjuste?: moment.Moment | undefined;
    fechaAjusteBase?: moment.Moment | undefined;
    detalleList?: InventoryAdjustmentDetailCancelCommand[] | undefined;
    actividadList?: InventoryAdjustmentActivityCancelCommand[] | undefined;

    constructor(data?: IInventoryAdjustmentCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ubicacionInicial = _data["ubicacionInicial"];
            this.fechaAjuste = _data["fechaAjuste"] ? moment(_data["fechaAjuste"].toString()) : <any>undefined;
            this.fechaAjusteBase = _data["fechaAjusteBase"] ? moment(_data["fechaAjusteBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(InventoryAdjustmentDetailCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(InventoryAdjustmentActivityCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryAdjustmentCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ubicacionInicial"] = this.ubicacionInicial;
        data["fechaAjuste"] = this.fechaAjuste ? this.fechaAjuste.toISOString() : <any>undefined;
        data["fechaAjusteBase"] = this.fechaAjusteBase ? this.fechaAjusteBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInventoryAdjustmentCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaAjuste?: moment.Moment | undefined;
    fechaAjusteBase?: moment.Moment | undefined;
    detalleList?: InventoryAdjustmentDetailCancelCommand[] | undefined;
    actividadList?: InventoryAdjustmentActivityCancelCommand[] | undefined;
}

export class InventoryAdjustmentDetailCancelCommand implements IInventoryAdjustmentDetailCancelCommand {
    ubicacionSistema?: number | undefined;
    ubicacionBulto?: number | undefined;
    parte?: number | undefined;
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;
    serie?: string | undefined;
    tipoMovimiento?: number | undefined;
    cantidad?: number | undefined;
    cantidadAjustada?: number | undefined;

    constructor(data?: IInventoryAdjustmentDetailCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubicacionSistema = _data["ubicacionSistema"];
            this.ubicacionBulto = _data["ubicacionBulto"];
            this.parte = _data["parte"];
            this.prefijo = _data["prefijo"];
            this.base = _data["base"];
            this.sufijo = _data["sufijo"];
            this.parteBase = _data["parteBase"];
            this.serie = _data["serie"];
            this.tipoMovimiento = _data["tipoMovimiento"];
            this.cantidad = _data["cantidad"];
            this.cantidadAjustada = _data["cantidadAjustada"];
        }
    }

    static fromJS(data: any): InventoryAdjustmentDetailCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentDetailCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubicacionSistema"] = this.ubicacionSistema;
        data["ubicacionBulto"] = this.ubicacionBulto;
        data["parte"] = this.parte;
        data["prefijo"] = this.prefijo;
        data["base"] = this.base;
        data["sufijo"] = this.sufijo;
        data["parteBase"] = this.parteBase;
        data["serie"] = this.serie;
        data["tipoMovimiento"] = this.tipoMovimiento;
        data["cantidad"] = this.cantidad;
        data["cantidadAjustada"] = this.cantidadAjustada;
        return data;
    }
}

export interface IInventoryAdjustmentDetailCancelCommand {
    ubicacionSistema?: number | undefined;
    ubicacionBulto?: number | undefined;
    parte?: number | undefined;
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;
    serie?: string | undefined;
    tipoMovimiento?: number | undefined;
    cantidad?: number | undefined;
    cantidadAjustada?: number | undefined;
}

export class InventoryAdjustmentActivityCancelCommand implements IInventoryAdjustmentActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IInventoryAdjustmentActivityCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryAdjustmentActivityCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdjustmentActivityCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInventoryAdjustmentActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class PagedResultDtoOfLanguageForListResponse implements IPagedResultDtoOfLanguageForListResponse {
    totalCount!: number;
    items?: LanguageForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageForListResponse {
    totalCount: number;
    items?: LanguageForListResponse[] | undefined;
}

export class LanguageForListResponse implements ILanguageForListResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ILanguageForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): LanguageForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ILanguageForListResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class LanguageGetListQuery extends PageListByDto implements ILanguageGetListQuery {

    constructor(data?: ILanguageGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LanguageGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageGetListQuery extends IPageListByDto {
}

export class LanguageResponse implements ILanguageResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class LanguageForEditResponse implements ILanguageForEditResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;

    constructor(data?: ILanguageForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILanguageForEditResponse {
    id?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
    languageCombo?: ComboboxItemDto[] | undefined;
}

export class LanguageGetForEditQuery implements ILanguageGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILanguageGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILanguageGetForEditQuery {
    id?: number | undefined;
}

export class LanguageCreateCommand implements ILanguageCreateCommand {
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageCreateCommand {
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class LanguageUpdateCommand implements ILanguageUpdateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILanguageUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageUpdateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfLanguageTextForListResponse implements IPagedResultDtoOfLanguageTextForListResponse {
    totalCount!: number;
    items?: LanguageTextForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextForListResponse {
    totalCount: number;
    items?: LanguageTextForListResponse[] | undefined;
}

export class LanguageTextForListResponse implements ILanguageTextForListResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextForListResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextGetListQuery extends PageListByDto implements ILanguageTextGetListQuery {
    languageId?: number | undefined;

    constructor(data?: ILanguageTextGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): LanguageTextGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageTextGetListQuery extends IPageListByDto {
    languageId?: number | undefined;
}

export class LanguageTextResponse implements ILanguageTextResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextForEditResponse implements ILanguageTextForEditResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.languageDesc = _data["languageDesc"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["languageDesc"] = this.languageDesc;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextForEditResponse {
    id?: number | undefined;
    languageId?: number | undefined;
    languageDesc?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class LanguageTextGetForEditQuery implements ILanguageTextGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILanguageTextGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageTextGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILanguageTextGetForEditQuery {
    id?: number | undefined;
}

export class LanguageTextUpdateCommand implements ILanguageTextUpdateCommand {
    id?: number | undefined;
    languageId!: number;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageTextUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageTextUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageTextUpdateCommand {
    id?: number | undefined;
    languageId: number;
    key?: string | undefined;
    value?: string | undefined;
}

export class PagedResultDtoOfLocationForListResponse implements IPagedResultDtoOfLocationForListResponse {
    totalCount!: number;
    items?: LocationForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLocationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLocationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLocationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLocationForListResponse {
    totalCount: number;
    items?: LocationForListResponse[] | undefined;
}

export class LocationForListResponse implements ILocationForListResponse {
    id!: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ILocationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaDesc = _data["areaDesc"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): LocationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zoneDesc"] = this.zoneDesc;
        data["areaDesc"] = this.areaDesc;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ILocationForListResponse {
    id: number;
    description?: string | undefined;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class LocationGetListQuery extends PageListByDto implements ILocationGetListQuery {

    constructor(data?: ILocationGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LocationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILocationGetListQuery extends IPageListByDto {
}

export class LocationForEditResponse implements ILocationForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone!: number;
    zoneDesc?: string | undefined;
    area!: number;
    areaDesc?: string | undefined;
    locationType!: number;
    locationTypeDesc?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    locationTypeCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: ILocationForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.area = _data["area"];
            this.areaDesc = _data["areaDesc"];
            this.locationType = _data["locationType"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["locationTypeCombo"])) {
                this.locationTypeCombo = [] as any;
                for (let item of _data["locationTypeCombo"])
                    this.locationTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["area"] = this.area;
        data["areaDesc"] = this.areaDesc;
        data["locationType"] = this.locationType;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.locationTypeCombo)) {
            data["locationTypeCombo"] = [];
            for (let item of this.locationTypeCombo)
                data["locationTypeCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone: number;
    zoneDesc?: string | undefined;
    area: number;
    areaDesc?: string | undefined;
    locationType: number;
    locationTypeDesc?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    locationTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class LocationGetForEditQuery implements ILocationGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILocationGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationGetForEditQuery {
    id?: number | undefined;
}

export class LocationGetComboQuery implements ILocationGetComboQuery {
    filter?: string | undefined;
    locationType?: number | undefined;
    locationTypeKey?: string | undefined;
    zone?: number | undefined;
    area?: number | undefined;
    isActive?: boolean | undefined;
    isStage?: boolean | undefined;

    constructor(data?: ILocationGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.locationType = _data["locationType"];
            this.locationTypeKey = _data["locationTypeKey"];
            this.zone = _data["zone"];
            this.area = _data["area"];
            this.isActive = _data["isActive"];
            this.isStage = _data["isStage"];
        }
    }

    static fromJS(data: any): LocationGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["locationType"] = this.locationType;
        data["locationTypeKey"] = this.locationTypeKey;
        data["zone"] = this.zone;
        data["area"] = this.area;
        data["isActive"] = this.isActive;
        data["isStage"] = this.isStage;
        return data;
    }
}

export interface ILocationGetComboQuery {
    filter?: string | undefined;
    locationType?: number | undefined;
    locationTypeKey?: string | undefined;
    zone?: number | undefined;
    area?: number | undefined;
    isActive?: boolean | undefined;
    isStage?: boolean | undefined;
}

export class LocationCreateCommand implements ILocationCreateCommand {
    description?: string | undefined;
    area!: number;
    locationType!: number;
    key?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILocationCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.area = _data["area"];
            this.locationType = _data["locationType"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["area"] = this.area;
        data["locationType"] = this.locationType;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationCreateCommand {
    description?: string | undefined;
    area: number;
    locationType: number;
    key?: string | undefined;
    isActive: boolean;
}

export class LocationUpdateCommand implements ILocationUpdateCommand {
    id!: number;
    description?: string | undefined;
    area!: number;
    locationType!: number;
    key?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILocationUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.area = _data["area"];
            this.locationType = _data["locationType"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LocationUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["area"] = this.area;
        data["locationType"] = this.locationType;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationUpdateCommand {
    id: number;
    description?: string | undefined;
    area: number;
    locationType: number;
    key?: string | undefined;
    isActive: boolean;
}

export class LocationResponse implements ILocationResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone!: number;
    zoneDesc?: string | undefined;
    area!: number;
    areaDesc?: string | undefined;
    locationType!: number;
    locationTypeDesc?: string | undefined;
    locationTypeKey?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;

    constructor(data?: ILocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.area = _data["area"];
            this.areaDesc = _data["areaDesc"];
            this.locationType = _data["locationType"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.locationTypeKey = _data["locationTypeKey"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["area"] = this.area;
        data["areaDesc"] = this.areaDesc;
        data["locationType"] = this.locationType;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["locationTypeKey"] = this.locationTypeKey;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone: number;
    zoneDesc?: string | undefined;
    area: number;
    areaDesc?: string | undefined;
    locationType: number;
    locationTypeDesc?: string | undefined;
    locationTypeKey?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
}

export class LocationGetValidByKeyQuery implements ILocationGetValidByKeyQuery {
    key?: string | undefined;

    constructor(data?: ILocationGetValidByKeyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): LocationGetValidByKeyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGetValidByKeyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }
}

export interface ILocationGetValidByKeyQuery {
    key?: string | undefined;
}

export class LocationGetByIdQuery implements ILocationGetByIdQuery {
    id!: number;

    constructor(data?: ILocationGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationGetByIdQuery {
    id: number;
}

export class PagedResultDtoOfLocationTypeForListResponse implements IPagedResultDtoOfLocationTypeForListResponse {
    totalCount!: number;
    items?: LocationTypeForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLocationTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationTypeForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLocationTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLocationTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLocationTypeForListResponse {
    totalCount: number;
    items?: LocationTypeForListResponse[] | undefined;
}

export class LocationTypeForListResponse implements ILocationTypeForListResponse {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isFinal!: boolean;
    isFinalDesc?: string | undefined;
    isProductive!: boolean;
    isProductiveDesc?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ILocationTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isFinal = _data["isFinal"];
            this.isFinalDesc = _data["isFinalDesc"];
            this.isProductive = _data["isProductive"];
            this.isProductiveDesc = _data["isProductiveDesc"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): LocationTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isFinal"] = this.isFinal;
        data["isFinalDesc"] = this.isFinalDesc;
        data["isProductive"] = this.isProductive;
        data["isProductiveDesc"] = this.isProductiveDesc;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ILocationTypeForListResponse {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isFinal: boolean;
    isFinalDesc?: string | undefined;
    isProductive: boolean;
    isProductiveDesc?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class LocationTypeGetListQuery extends PageListByDto implements ILocationTypeGetListQuery {

    constructor(data?: ILocationTypeGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LocationTypeGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILocationTypeGetListQuery extends IPageListByDto {
}

export class LocationTypeForEditResponse implements ILocationTypeForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isFinal!: boolean;
    isProductive!: boolean;
    isActive!: boolean;

    constructor(data?: ILocationTypeForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isFinal = _data["isFinal"];
            this.isProductive = _data["isProductive"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationTypeForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isFinal"] = this.isFinal;
        data["isProductive"] = this.isProductive;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationTypeForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isFinal: boolean;
    isProductive: boolean;
    isActive: boolean;
}

export class LocationTypeGetForEditQuery implements ILocationTypeGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ILocationTypeGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationTypeGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationTypeGetForEditQuery {
    id?: number | undefined;
}

export class LocationTypeGetComboQuery implements ILocationTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ILocationTypeGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationTypeGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class LocationTypeCreateCommand implements ILocationTypeCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isFinal!: boolean;
    isProductive!: boolean;
    isActive!: boolean;

    constructor(data?: ILocationTypeCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.isFinal = _data["isFinal"];
            this.isProductive = _data["isProductive"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationTypeCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["isFinal"] = this.isFinal;
        data["isProductive"] = this.isProductive;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationTypeCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isFinal: boolean;
    isProductive: boolean;
    isActive: boolean;
}

export class LocationTypeUpdateCommand implements ILocationTypeUpdateCommand {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isFinal!: boolean;
    isProductive!: boolean;
    isActive!: boolean;

    constructor(data?: ILocationTypeUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isFinal = _data["isFinal"];
            this.isProductive = _data["isProductive"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LocationTypeUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isFinal"] = this.isFinal;
        data["isProductive"] = this.isProductive;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILocationTypeUpdateCommand {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isFinal: boolean;
    isProductive: boolean;
    isActive: boolean;
}

export class LocationTypeGetIsPermissionDeliveryQuery implements ILocationTypeGetIsPermissionDeliveryQuery {
    locationTypeSource!: number;
    locationTypeTarget!: number;

    constructor(data?: ILocationTypeGetIsPermissionDeliveryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationTypeSource = _data["locationTypeSource"];
            this.locationTypeTarget = _data["locationTypeTarget"];
        }
    }

    static fromJS(data: any): LocationTypeGetIsPermissionDeliveryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeGetIsPermissionDeliveryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationTypeSource"] = this.locationTypeSource;
        data["locationTypeTarget"] = this.locationTypeTarget;
        return data;
    }
}

export interface ILocationTypeGetIsPermissionDeliveryQuery {
    locationTypeSource: number;
    locationTypeTarget: number;
}

export class PagedResultDtoOfLockForListResponse implements IPagedResultDtoOfLockForListResponse {
    totalCount!: number;
    items?: LockForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LockForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLockForListResponse {
    totalCount: number;
    items?: LockForListResponse[] | undefined;
}

export class LockForListResponse implements ILockForListResponse {
    id!: number;
    mobileSessionId?: number | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    movementId?: number | undefined;
    processDesc?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    boxNumber?: string | undefined;
    routeKey?: string | undefined;
    workshiftDesc?: string | undefined;
    mobileId?: number | undefined;
    mobileIMEI?: string | undefined;
    serie?: string | undefined;

    constructor(data?: ILockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mobileSessionId = _data["mobileSessionId"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.movementId = _data["movementId"];
            this.processDesc = _data["processDesc"];
            this.platformKey = _data["platformKey"];
            this.platformWindowNumber = _data["platformWindowNumber"];
            this.boxNumber = _data["boxNumber"];
            this.routeKey = _data["routeKey"];
            this.workshiftDesc = _data["workshiftDesc"];
            this.mobileId = _data["mobileId"];
            this.mobileIMEI = _data["mobileIMEI"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): LockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mobileSessionId"] = this.mobileSessionId;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["movementId"] = this.movementId;
        data["processDesc"] = this.processDesc;
        data["platformKey"] = this.platformKey;
        data["platformWindowNumber"] = this.platformWindowNumber;
        data["boxNumber"] = this.boxNumber;
        data["routeKey"] = this.routeKey;
        data["workshiftDesc"] = this.workshiftDesc;
        data["mobileId"] = this.mobileId;
        data["mobileIMEI"] = this.mobileIMEI;
        data["serie"] = this.serie;
        return data;
    }
}

export interface ILockForListResponse {
    id: number;
    mobileSessionId?: number | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    movementId?: number | undefined;
    processDesc?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    boxNumber?: string | undefined;
    routeKey?: string | undefined;
    workshiftDesc?: string | undefined;
    mobileId?: number | undefined;
    mobileIMEI?: string | undefined;
    serie?: string | undefined;
}

export class LockGetListQuery extends PageListByDto implements ILockGetListQuery {

    constructor(data?: ILockGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LockGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LockGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILockGetListQuery extends IPageListByDto {
}

export class LockForLockResponse implements ILockForLockResponse {
    success!: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;

    constructor(data?: ILockForLockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.mobileIMEI = _data["mobileIMEI"];
        }
    }

    static fromJS(data: any): LockForLockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockForLockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["mobileIMEI"] = this.mobileIMEI;
        return data;
    }
}

export interface ILockForLockResponse {
    success: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;
}

export class LockCommand implements ILockCommand {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process!: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;

    constructor(data?: ILockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSessionId = _data["mobileSessionId"];
            this.movementId = _data["movementId"];
            this.process = _data["process"];
            this.platform = _data["platform"];
            this.platformWindow = _data["platformWindow"];
            this.boxNumber = _data["boxNumber"];
            this.action = _data["action"];
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): LockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSessionId"] = this.mobileSessionId;
        data["movementId"] = this.movementId;
        data["process"] = this.process;
        data["platform"] = this.platform;
        data["platformWindow"] = this.platformWindow;
        data["boxNumber"] = this.boxNumber;
        data["action"] = this.action;
        data["route"] = this.route;
        return data;
    }
}

export interface ILockCommand {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;
}

export enum LockProcess {
    InboundDownload = 1,
    CampusDownload = 2,
    MeteringDownload = 3,
    BlankDownload = 4,
    JIT = 5,
    StockedCard = 6,
}

export class LockIsAvaliableResponse implements ILockIsAvaliableResponse {
    isAvaliable!: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;

    constructor(data?: ILockIsAvaliableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvaliable = _data["isAvaliable"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.mobileIMEI = _data["mobileIMEI"];
        }
    }

    static fromJS(data: any): LockIsAvaliableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockIsAvaliableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvaliable"] = this.isAvaliable;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["mobileIMEI"] = this.mobileIMEI;
        return data;
    }
}

export interface ILockIsAvaliableResponse {
    isAvaliable: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;
}

export class LockIsAvaliableQuery implements ILockIsAvaliableQuery {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process!: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;

    constructor(data?: ILockIsAvaliableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSessionId = _data["mobileSessionId"];
            this.movementId = _data["movementId"];
            this.process = _data["process"];
            this.platform = _data["platform"];
            this.platformWindow = _data["platformWindow"];
            this.boxNumber = _data["boxNumber"];
            this.action = _data["action"];
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): LockIsAvaliableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LockIsAvaliableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSessionId"] = this.mobileSessionId;
        data["movementId"] = this.movementId;
        data["process"] = this.process;
        data["platform"] = this.platform;
        data["platformWindow"] = this.platformWindow;
        data["boxNumber"] = this.boxNumber;
        data["action"] = this.action;
        data["route"] = this.route;
        return data;
    }
}

export interface ILockIsAvaliableQuery {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;
}

export class LockIsLockedBySessionResponse implements ILockIsLockedBySessionResponse {
    isLocked!: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;

    constructor(data?: ILockIsLockedBySessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLocked = _data["isLocked"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.mobileIMEI = _data["mobileIMEI"];
        }
    }

    static fromJS(data: any): LockIsLockedBySessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockIsLockedBySessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLocked"] = this.isLocked;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["mobileIMEI"] = this.mobileIMEI;
        return data;
    }
}

export interface ILockIsLockedBySessionResponse {
    isLocked: boolean;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    mobileIMEI?: string | undefined;
}

export class LockIsLockedBySessionQuery implements ILockIsLockedBySessionQuery {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process!: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;

    constructor(data?: ILockIsLockedBySessionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSessionId = _data["mobileSessionId"];
            this.movementId = _data["movementId"];
            this.process = _data["process"];
            this.platform = _data["platform"];
            this.platformWindow = _data["platformWindow"];
            this.boxNumber = _data["boxNumber"];
            this.action = _data["action"];
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): LockIsLockedBySessionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LockIsLockedBySessionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSessionId"] = this.mobileSessionId;
        data["movementId"] = this.movementId;
        data["process"] = this.process;
        data["platform"] = this.platform;
        data["platformWindow"] = this.platformWindow;
        data["boxNumber"] = this.boxNumber;
        data["action"] = this.action;
        data["route"] = this.route;
        return data;
    }
}

export interface ILockIsLockedBySessionQuery {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;
}

export class UnlockLockedCommand implements IUnlockLockedCommand {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process!: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;

    constructor(data?: IUnlockLockedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSessionId = _data["mobileSessionId"];
            this.movementId = _data["movementId"];
            this.process = _data["process"];
            this.platform = _data["platform"];
            this.platformWindow = _data["platformWindow"];
            this.boxNumber = _data["boxNumber"];
            this.action = _data["action"];
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): UnlockLockedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockLockedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSessionId"] = this.mobileSessionId;
        data["movementId"] = this.movementId;
        data["process"] = this.process;
        data["platform"] = this.platform;
        data["platformWindow"] = this.platformWindow;
        data["boxNumber"] = this.boxNumber;
        data["action"] = this.action;
        data["route"] = this.route;
        return data;
    }
}

export interface IUnlockLockedCommand {
    mobileSessionId?: number | undefined;
    movementId?: number | undefined;
    process: LockProcess;
    platform?: number | undefined;
    platformWindow?: number | undefined;
    boxNumber?: string | undefined;
    action?: string | undefined;
    route?: number | undefined;
}

export class PagedResultDtoOfLockLogForListResponse implements IPagedResultDtoOfLockLogForListResponse {
    totalCount!: number;
    items?: LockLogForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLockLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LockLogForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLockLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLockLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLockLogForListResponse {
    totalCount: number;
    items?: LockLogForListResponse[] | undefined;
}

export class LockLogForListResponse implements ILockLogForListResponse {
    id!: number;
    mobileSessionId?: number | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    movementId?: number | undefined;
    processDesc?: string | undefined;
    eventDesc?: string | undefined;
    statusDesc?: string | undefined;
    action?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    boxNumber?: string | undefined;
    routeKey?: string | undefined;
    workshiftDesc?: string | undefined;
    mobileId?: number | undefined;
    mobileIMEI?: string | undefined;
    serie?: string | undefined;

    constructor(data?: ILockLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mobileSessionId = _data["mobileSessionId"];
            this.userDesc = _data["userDesc"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.movementId = _data["movementId"];
            this.processDesc = _data["processDesc"];
            this.eventDesc = _data["eventDesc"];
            this.statusDesc = _data["statusDesc"];
            this.action = _data["action"];
            this.platformKey = _data["platformKey"];
            this.platformWindowNumber = _data["platformWindowNumber"];
            this.boxNumber = _data["boxNumber"];
            this.routeKey = _data["routeKey"];
            this.workshiftDesc = _data["workshiftDesc"];
            this.mobileId = _data["mobileId"];
            this.mobileIMEI = _data["mobileIMEI"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): LockLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mobileSessionId"] = this.mobileSessionId;
        data["userDesc"] = this.userDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["movementId"] = this.movementId;
        data["processDesc"] = this.processDesc;
        data["eventDesc"] = this.eventDesc;
        data["statusDesc"] = this.statusDesc;
        data["action"] = this.action;
        data["platformKey"] = this.platformKey;
        data["platformWindowNumber"] = this.platformWindowNumber;
        data["boxNumber"] = this.boxNumber;
        data["routeKey"] = this.routeKey;
        data["workshiftDesc"] = this.workshiftDesc;
        data["mobileId"] = this.mobileId;
        data["mobileIMEI"] = this.mobileIMEI;
        data["serie"] = this.serie;
        return data;
    }
}

export interface ILockLogForListResponse {
    id: number;
    mobileSessionId?: number | undefined;
    userDesc?: string | undefined;
    date?: moment.Moment | undefined;
    movementId?: number | undefined;
    processDesc?: string | undefined;
    eventDesc?: string | undefined;
    statusDesc?: string | undefined;
    action?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    boxNumber?: string | undefined;
    routeKey?: string | undefined;
    workshiftDesc?: string | undefined;
    mobileId?: number | undefined;
    mobileIMEI?: string | undefined;
    serie?: string | undefined;
}

export class LockLogGetListQuery extends PageListByDto implements ILockLogGetListQuery {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: ILockLogGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LockLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LockLogGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILockLogGetListQuery extends IPageListByDto {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class LockLogExcelResponse implements ILockLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: ILockLogExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): LockLogExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockLogExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ILockLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class LockLogGetExcelQuery extends PageListByDto implements ILockLogGetExcelQuery {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: ILockLogGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LockLogGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LockLogGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILockLogGetExcelQuery extends IPageListByDto {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class PagedResultDtoOfMailGroupListResponse implements IPagedResultDtoOfMailGroupListResponse {
    totalCount!: number;
    items?: MailGroupListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMailGroupListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailGroupListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailGroupListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailGroupListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailGroupListResponse {
    totalCount: number;
    items?: MailGroupListResponse[] | undefined;
}

export class MailGroupListResponse implements IMailGroupListResponse {
    id!: number;
    displayName?: string | undefined;
    isSelected?: boolean | undefined;

    constructor(data?: IMailGroupListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): MailGroupListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IMailGroupListResponse {
    id: number;
    displayName?: string | undefined;
    isSelected?: boolean | undefined;
}

export class MailGroupGetListQuery extends PageListByDto implements IMailGroupGetListQuery {

    constructor(data?: IMailGroupGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MailGroupGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMailGroupGetListQuery extends IPageListByDto {
}

export class MailGroupCreateCommand implements IMailGroupCreateCommand {
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupCreateCommand {
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupUpdateCommand implements IMailGroupUpdateCommand {
    id!: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupUpdateCommand {
    id: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupForEditResponse implements IMailGroupForEditResponse {
    id!: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;

    constructor(data?: IMailGroupForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.header = _data["header"];
            this.footer = _data["footer"];
        }
    }

    static fromJS(data: any): MailGroupForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["header"] = this.header;
        data["footer"] = this.footer;
        return data;
    }
}

export interface IMailGroupForEditResponse {
    id: number;
    displayName?: string | undefined;
    header?: string | undefined;
    footer?: string | undefined;
}

export class MailGroupGetForEditQuery implements IMailGroupGetForEditQuery {
    id!: number;

    constructor(data?: IMailGroupGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupGetForEditQuery {
    id: number;
}

export class MailGroupCopyCommand implements IMailGroupCopyCommand {
    id!: number;
    displayName?: string | undefined;

    constructor(data?: IMailGroupCopyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MailGroupCopyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCopyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMailGroupCopyCommand {
    id: number;
    displayName?: string | undefined;
}

export class MailGroupCheckCommand implements IMailGroupCheckCommand {
    id!: number;

    constructor(data?: IMailGroupCheckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupCheckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupCheckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupCheckCommand {
    id: number;
}

export class MailGroupUnCheckCommand implements IMailGroupUnCheckCommand {
    id!: number;

    constructor(data?: IMailGroupUnCheckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailGroupUnCheckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailGroupUnCheckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailGroupUnCheckCommand {
    id: number;
}

export class PagedResultDtoOfMailTemplateListResponse implements IPagedResultDtoOfMailTemplateListResponse {
    totalCount!: number;
    items?: MailTemplateListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMailTemplateListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailTemplateListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailTemplateListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailTemplateListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailTemplateListResponse {
    totalCount: number;
    items?: MailTemplateListResponse[] | undefined;
}

export class MailTemplateListResponse implements IMailTemplateListResponse {
    id!: number;
    mailKeyDesc?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IMailTemplateListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailKeyDesc = _data["mailKeyDesc"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MailTemplateListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailKeyDesc"] = this.mailKeyDesc;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMailTemplateListResponse {
    id: number;
    mailKeyDesc?: string | undefined;
    displayName?: string | undefined;
}

export class MailTemplateGetListQuery extends PageListByDto implements IMailTemplateGetListQuery {
    mailGroup!: number;

    constructor(data?: IMailTemplateGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailGroup = _data["mailGroup"];
        }
    }

    static fromJS(data: any): MailTemplateGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        super.toJSON(data);
        return data;
    }
}

export interface IMailTemplateGetListQuery extends IPageListByDto {
    mailGroup: number;
}

export class MailTemplateCreateCommand implements IMailTemplateCreateCommand {
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IMailTemplateCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MailTemplateCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMailTemplateCreateCommand {
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
}

export class MailTemplateUpdateCommand implements IMailTemplateUpdateCommand {
    id!: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IMailTemplateUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MailTemplateUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMailTemplateUpdateCommand {
    id: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
}

export class MailTemplateForEditResponse implements IMailTemplateForEditResponse {
    id!: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
    mailKeyList?: ComboboxItemDto[] | undefined;

    constructor(data?: IMailTemplateForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailGroup = _data["mailGroup"];
            this.mailKey = _data["mailKey"];
            this.displayName = _data["displayName"];
            this.sendTo = _data["sendTo"];
            this.copyTo = _data["copyTo"];
            this.blindCopyTo = _data["blindCopyTo"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["mailKeyList"])) {
                this.mailKeyList = [] as any;
                for (let item of _data["mailKeyList"])
                    this.mailKeyList!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailTemplateForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailGroup"] = this.mailGroup;
        data["mailKey"] = this.mailKey;
        data["displayName"] = this.displayName;
        data["sendTo"] = this.sendTo;
        data["copyTo"] = this.copyTo;
        data["blindCopyTo"] = this.blindCopyTo;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.mailKeyList)) {
            data["mailKeyList"] = [];
            for (let item of this.mailKeyList)
                data["mailKeyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailTemplateForEditResponse {
    id: number;
    mailGroup?: number | undefined;
    mailKey?: string | undefined;
    displayName?: string | undefined;
    sendTo?: string | undefined;
    copyTo?: string | undefined;
    blindCopyTo?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean | undefined;
    mailKeyList?: ComboboxItemDto[] | undefined;
}

export class MailTemplateGetForEditQuery implements IMailTemplateGetForEditQuery {
    id!: number;

    constructor(data?: IMailTemplateGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailTemplateGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMailTemplateGetForEditQuery {
    id: number;
}

export class MailTemplateSendTestCommand implements IMailTemplateSendTestCommand {
    mailGroup!: number;
    email?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IMailTemplateSendTestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
            this.email = _data["email"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): MailTemplateSendTestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateSendTestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        data["email"] = this.email;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IMailTemplateSendTestCommand {
    mailGroup: number;
    email?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class MailTemplateGetBodyParamListQuery implements IMailTemplateGetBodyParamListQuery {
    mailKey?: string | undefined;

    constructor(data?: IMailTemplateGetBodyParamListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailKey = _data["mailKey"];
        }
    }

    static fromJS(data: any): MailTemplateGetBodyParamListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetBodyParamListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailKey"] = this.mailKey;
        return data;
    }
}

export interface IMailTemplateGetBodyParamListQuery {
    mailKey?: string | undefined;
}

export class MailTemplateGetMailKeyAvailableListQuery implements IMailTemplateGetMailKeyAvailableListQuery {
    mailGroup!: number;

    constructor(data?: IMailTemplateGetMailKeyAvailableListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailGroup = _data["mailGroup"];
        }
    }

    static fromJS(data: any): MailTemplateGetMailKeyAvailableListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGetMailKeyAvailableListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailGroup"] = this.mailGroup;
        return data;
    }
}

export interface IMailTemplateGetMailKeyAvailableListQuery {
    mailGroup: number;
}

export class PagedResultDtoOfOrgUnitForListResponse implements IPagedResultDtoOfOrgUnitForListResponse {
    totalCount!: number;
    items?: OrgUnitForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgUnitForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrgUnitForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgUnitForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgUnitForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrgUnitForListResponse {
    totalCount: number;
    items?: OrgUnitForListResponse[] | undefined;
}

export class OrgUnitForListResponse implements IOrgUnitForListResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitForListResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetListQuery extends PageListByDto implements IOrgUnitGetListQuery {
    parentOU?: number | undefined;
    level?: number | undefined;

    constructor(data?: IOrgUnitGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentOU = _data["parentOU"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OrgUnitGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentOU"] = this.parentOU;
        data["level"] = this.level;
        super.toJSON(data);
        return data;
    }
}

export interface IOrgUnitGetListQuery extends IPageListByDto {
    parentOU?: number | undefined;
    level?: number | undefined;
}

export class OrgUnitResponse implements IOrgUnitResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetComboQuery implements IOrgUnitGetComboQuery {
    filter?: string | undefined;

    constructor(data?: IOrgUnitGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): OrgUnitGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IOrgUnitGetComboQuery {
    filter?: string | undefined;
}

export class OrgUnitForEditResponse implements IOrgUnitForEditResponse {
    id!: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;
    level!: number;
    hasChildren!: boolean;
    size!: number;

    constructor(data?: IOrgUnitForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOU = _data["parentOU"];
            this.parentOUDesc = _data["parentOUDesc"];
            this.name = _data["name"];
            this.correo = _data["correo"];
            this.telefono = _data["telefono"];
            this.enviarCodigosMFA = _data["enviarCodigosMFA"];
            this.level = _data["level"];
            this.hasChildren = _data["hasChildren"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): OrgUnitForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOU"] = this.parentOU;
        data["parentOUDesc"] = this.parentOUDesc;
        data["name"] = this.name;
        data["correo"] = this.correo;
        data["telefono"] = this.telefono;
        data["enviarCodigosMFA"] = this.enviarCodigosMFA;
        data["level"] = this.level;
        data["hasChildren"] = this.hasChildren;
        data["size"] = this.size;
        return data;
    }
}

export interface IOrgUnitForEditResponse {
    id: number;
    parentOU?: number | undefined;
    parentOUDesc?: string | undefined;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;
    level: number;
    hasChildren: boolean;
    size: number;
}

export class OrgUnitGetForEditQuery implements IOrgUnitGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IOrgUnitGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgUnitGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOrgUnitGetForEditQuery {
    id?: number | undefined;
}

export class OrgUnitCreateCommand implements IOrgUnitCreateCommand {
    parentOU?: number | undefined;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;
    level!: number;

    constructor(data?: IOrgUnitCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentOU = _data["parentOU"];
            this.name = _data["name"];
            this.correo = _data["correo"];
            this.telefono = _data["telefono"];
            this.enviarCodigosMFA = _data["enviarCodigosMFA"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OrgUnitCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentOU"] = this.parentOU;
        data["name"] = this.name;
        data["correo"] = this.correo;
        data["telefono"] = this.telefono;
        data["enviarCodigosMFA"] = this.enviarCodigosMFA;
        data["level"] = this.level;
        return data;
    }
}

export interface IOrgUnitCreateCommand {
    parentOU?: number | undefined;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;
    level: number;
}

export class OrgUnitUpdateCommand implements IOrgUnitUpdateCommand {
    id!: number;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;

    constructor(data?: IOrgUnitUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrgUnitUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["correo"] = this.correo;
        data["telefono"] = this.telefono;
        data["enviarCodigosMFA"] = this.enviarCodigosMFA;
        return data;
    }
}

export interface IOrgUnitUpdateCommand {
    id: number;
    name?: string | undefined;
    correo?: string | undefined;
    telefono?: string | undefined;
    enviarCodigosMFA?: boolean | undefined;
}

export class PagedResultDtoOfOrgUnitUserForListResponse implements IPagedResultDtoOfOrgUnitUserForListResponse {
    totalCount!: number;
    items?: OrgUnitUserForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgUnitUserForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrgUnitUserForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgUnitUserForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgUnitUserForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrgUnitUserForListResponse {
    totalCount: number;
    items?: OrgUnitUserForListResponse[] | undefined;
}

export class OrgUnitUserForListResponse implements IOrgUnitUserForListResponse {
    id!: number;
    orgUnit!: number;
    orgUnitDesc?: string | undefined;
    user!: number;
    userDesc?: string | undefined;

    constructor(data?: IOrgUnitUserForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgUnit = _data["orgUnit"];
            this.orgUnitDesc = _data["orgUnitDesc"];
            this.user = _data["user"];
            this.userDesc = _data["userDesc"];
        }
    }

    static fromJS(data: any): OrgUnitUserForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgUnit"] = this.orgUnit;
        data["orgUnitDesc"] = this.orgUnitDesc;
        data["user"] = this.user;
        data["userDesc"] = this.userDesc;
        return data;
    }
}

export interface IOrgUnitUserForListResponse {
    id: number;
    orgUnit: number;
    orgUnitDesc?: string | undefined;
    user: number;
    userDesc?: string | undefined;
}

export class OrgUnitUserGetListQuery extends PageListByDto implements IOrgUnitUserGetListQuery {
    orgUnit?: number | undefined;

    constructor(data?: IOrgUnitUserGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orgUnit = _data["orgUnit"];
        }
    }

    static fromJS(data: any): OrgUnitUserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnit"] = this.orgUnit;
        super.toJSON(data);
        return data;
    }
}

export interface IOrgUnitUserGetListQuery extends IPageListByDto {
    orgUnit?: number | undefined;
}

export class OrgUnitUserCreateCommand implements IOrgUnitUserCreateCommand {
    orgUnit!: number;
    user!: number;

    constructor(data?: IOrgUnitUserCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnit = _data["orgUnit"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): OrgUnitUserCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitUserCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnit"] = this.orgUnit;
        data["user"] = this.user;
        return data;
    }
}

export interface IOrgUnitUserCreateCommand {
    orgUnit: number;
    user: number;
}

export class Permission implements IPermission {
    parent?: Permission | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    multiTenancySides!: MultiTenancySides;
    children?: Permission[] | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"] ? Permission.fromJS(_data["parent"]) : <any>undefined;
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.multiTenancySides = _data["multiTenancySides"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["multiTenancySides"] = this.multiTenancySides;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermission {
    parent?: Permission | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    multiTenancySides: MultiTenancySides;
    children?: Permission[] | undefined;
}

export enum MultiTenancySides {
    Tenant = 1,
    Host = 2,
}

export class PermissionGetIsGrantedQuery implements IPermissionGetIsGrantedQuery {
    requiresAll!: boolean;
    permissionNames?: string[] | undefined;
    isTemplateProcess!: boolean;
    template?: number | undefined;

    constructor(data?: IPermissionGetIsGrantedQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiresAll = _data["requiresAll"];
            if (Array.isArray(_data["permissionNames"])) {
                this.permissionNames = [] as any;
                for (let item of _data["permissionNames"])
                    this.permissionNames!.push(item);
            }
            this.isTemplateProcess = _data["isTemplateProcess"];
            this.template = _data["template"];
        }
    }

    static fromJS(data: any): PermissionGetIsGrantedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGetIsGrantedQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiresAll"] = this.requiresAll;
        if (Array.isArray(this.permissionNames)) {
            data["permissionNames"] = [];
            for (let item of this.permissionNames)
                data["permissionNames"].push(item);
        }
        data["isTemplateProcess"] = this.isTemplateProcess;
        data["template"] = this.template;
        return data;
    }
}

export interface IPermissionGetIsGrantedQuery {
    requiresAll: boolean;
    permissionNames?: string[] | undefined;
    isTemplateProcess: boolean;
    template?: number | undefined;
}

export class PagedResultDtoOfPlatformForListResponse implements IPagedResultDtoOfPlatformForListResponse {
    totalCount!: number;
    items?: PlatformForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPlatformForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlatformForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlatformForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlatformForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPlatformForListResponse {
    totalCount: number;
    items?: PlatformForListResponse[] | undefined;
}

export class PlatformGetListQuery extends PageListByDto implements IPlatformGetListQuery {

    constructor(data?: IPlatformGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PlatformGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPlatformGetListQuery extends IPageListByDto {
}

export class PlatformForEditResponse implements IPlatformForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone!: number;
    zoneDesc?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    commodityCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IPlatformForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["windows"])) {
                this.windows = [] as any;
                for (let item of _data["windows"])
                    this.windows!.push(PlatformWindowResponse.fromJS(item));
            }
            if (Array.isArray(_data["commodities"])) {
                this.commodities = [] as any;
                for (let item of _data["commodities"])
                    this.commodities!.push(PlatformCommodityResponse.fromJS(item));
            }
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["commodityCombo"])) {
                this.commodityCombo = [] as any;
                for (let item of _data["commodityCombo"])
                    this.commodityCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.windows)) {
            data["windows"] = [];
            for (let item of this.windows)
                data["windows"].push(item.toJSON());
        }
        if (Array.isArray(this.commodities)) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.commodityCombo)) {
            data["commodityCombo"] = [];
            for (let item of this.commodityCombo)
                data["commodityCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    zone: number;
    zoneDesc?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    commodityCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class PlatformCommodityResponse implements IPlatformCommodityResponse {
    id?: number | undefined;
    platform?: number | undefined;
    commodity?: number | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;

    constructor(data?: IPlatformCommodityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.commodity = _data["commodity"];
            this.commodityKey = _data["commodityKey"];
            this.commodityDesc = _data["commodityDesc"];
        }
    }

    static fromJS(data: any): PlatformCommodityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformCommodityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["commodity"] = this.commodity;
        data["commodityKey"] = this.commodityKey;
        data["commodityDesc"] = this.commodityDesc;
        return data;
    }
}

export interface IPlatformCommodityResponse {
    id?: number | undefined;
    platform?: number | undefined;
    commodity?: number | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;
}

export class PlatformGetForEditQuery implements IPlatformGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IPlatformGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlatformGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPlatformGetForEditQuery {
    id?: number | undefined;
}

export class PlatformCreateCommand implements IPlatformCreateCommand {
    description?: string | undefined;
    zone!: number;
    key?: string | undefined;
    isActive!: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;

    constructor(data?: IPlatformCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["windows"])) {
                this.windows = [] as any;
                for (let item of _data["windows"])
                    this.windows!.push(PlatformWindowResponse.fromJS(item));
            }
            if (Array.isArray(_data["commodities"])) {
                this.commodities = [] as any;
                for (let item of _data["commodities"])
                    this.commodities!.push(PlatformCommodityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.windows)) {
            data["windows"] = [];
            for (let item of this.windows)
                data["windows"].push(item.toJSON());
        }
        if (Array.isArray(this.commodities)) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformCreateCommand {
    description?: string | undefined;
    zone: number;
    key?: string | undefined;
    isActive: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;
}

export class PlatformUpdateCommand implements IPlatformUpdateCommand {
    id!: number;
    description?: string | undefined;
    zone!: number;
    key?: string | undefined;
    isActive!: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;

    constructor(data?: IPlatformUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.zone = _data["zone"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["windows"])) {
                this.windows = [] as any;
                for (let item of _data["windows"])
                    this.windows!.push(PlatformWindowResponse.fromJS(item));
            }
            if (Array.isArray(_data["commodities"])) {
                this.commodities = [] as any;
                for (let item of _data["commodities"])
                    this.commodities!.push(PlatformCommodityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["zone"] = this.zone;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.windows)) {
            data["windows"] = [];
            for (let item of this.windows)
                data["windows"].push(item.toJSON());
        }
        if (Array.isArray(this.commodities)) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformUpdateCommand {
    id: number;
    description?: string | undefined;
    zone: number;
    key?: string | undefined;
    isActive: boolean;
    windows?: PlatformWindowResponse[] | undefined;
    commodities?: PlatformCommodityResponse[] | undefined;
}

export class PlatformGetComboQuery implements IPlatformGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IPlatformGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PlatformGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPlatformGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class PlatformWindowGetComboQuery implements IPlatformWindowGetComboQuery {
    filter?: string | undefined;
    platform?: number | undefined;

    constructor(data?: IPlatformWindowGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): PlatformWindowGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformWindowGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IPlatformWindowGetComboQuery {
    filter?: string | undefined;
    platform?: number | undefined;
}

export class ReasonRestartGetComboQuery implements IReasonRestartGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IReasonRestartGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReasonRestartGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonRestartGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReasonRestartGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class ReasonRestartResponse implements IReasonRestartResponse {
    id?: number | undefined;
    description?: string | undefined;
    key?: string | undefined;
    isActive!: boolean;

    constructor(data?: IReasonRestartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.key = _data["key"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReasonRestartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonRestartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["key"] = this.key;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReasonRestartResponse {
    id?: number | undefined;
    description?: string | undefined;
    key?: string | undefined;
    isActive: boolean;
}

export class TenantCreateRegistrationCommand implements ITenantCreateRegistrationCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ITenantCreateRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.tenantName = _data["tenantName"];
            this.password = _data["password"];
            this.passwordConfirm = _data["passwordConfirm"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantCreateRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["tenantName"] = this.tenantName;
        data["password"] = this.password;
        data["passwordConfirm"] = this.passwordConfirm;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantCreateRegistrationCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class TenantConfirmRegistrationCommand implements ITenantConfirmRegistrationCommand {
    code?: string | undefined;

    constructor(data?: ITenantConfirmRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): TenantConfirmRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantConfirmRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface ITenantConfirmRegistrationCommand {
    code?: string | undefined;
}

export class PagedResultDtoOfReportStockedForListResponse implements IPagedResultDtoOfReportStockedForListResponse {
    totalCount!: number;
    items?: ReportStockedForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportStockedForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportStockedForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportStockedForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportStockedForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportStockedForListResponse {
    totalCount: number;
    items?: ReportStockedForListResponse[] | undefined;
}

export class ReportStockedForListResponse implements IReportStockedForListResponse {
    id!: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    statusDesc?: string | undefined;
    routeKey?: string | undefined;
    partCommodityKey?: string | undefined;
    partCommodityDesc?: string | undefined;
    partCommodityQuantitySequenceDesc?: string | undefined;
    serie?: string | undefined;

    constructor(data?: IReportStockedForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.reasonSuspensionDesc = _data["reasonSuspensionDesc"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.statusDesc = _data["statusDesc"];
            this.routeKey = _data["routeKey"];
            this.partCommodityKey = _data["partCommodityKey"];
            this.partCommodityDesc = _data["partCommodityDesc"];
            this.partCommodityQuantitySequenceDesc = _data["partCommodityQuantitySequenceDesc"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): ReportStockedForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStockedForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["reasonSuspensionDesc"] = this.reasonSuspensionDesc;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["statusDesc"] = this.statusDesc;
        data["routeKey"] = this.routeKey;
        data["partCommodityKey"] = this.partCommodityKey;
        data["partCommodityDesc"] = this.partCommodityDesc;
        data["partCommodityQuantitySequenceDesc"] = this.partCommodityQuantitySequenceDesc;
        data["serie"] = this.serie;
        return data;
    }
}

export interface IReportStockedForListResponse {
    id: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    statusDesc?: string | undefined;
    routeKey?: string | undefined;
    partCommodityKey?: string | undefined;
    partCommodityDesc?: string | undefined;
    partCommodityQuantitySequenceDesc?: string | undefined;
    serie?: string | undefined;
}

export class ReportStockedGetListQuery extends PageListByDto implements IReportStockedGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: StockedStatus | undefined;
    workShift?: number | undefined;
    route?: number[] | undefined;
    part?: number | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportStockedGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.workShift = _data["workShift"];
            if (Array.isArray(_data["route"])) {
                this.route = [] as any;
                for (let item of _data["route"])
                    this.route!.push(item);
            }
            this.part = _data["part"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportStockedGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStockedGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["workShift"] = this.workShift;
        if (Array.isArray(this.route)) {
            data["route"] = [];
            for (let item of this.route)
                data["route"].push(item);
        }
        data["part"] = this.part;
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportStockedGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: StockedStatus | undefined;
    workShift?: number | undefined;
    route?: number[] | undefined;
    part?: number | undefined;
    quantity?: number | undefined;
}

export enum StockedStatus {
    Completed = 1,
    Cancelled = 2,
}

export class ReportStockedExcelResponse implements IReportStockedExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportStockedExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportStockedExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStockedExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportStockedExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportStockedGetExcelQuery extends PageListByDto implements IReportStockedGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: StockedStatus | undefined;
    workShift?: number | undefined;
    route?: number[] | undefined;
    part?: number | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportStockedGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.workShift = _data["workShift"];
            if (Array.isArray(_data["route"])) {
                this.route = [] as any;
                for (let item of _data["route"])
                    this.route!.push(item);
            }
            this.part = _data["part"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportStockedGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStockedGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["workShift"] = this.workShift;
        if (Array.isArray(this.route)) {
            data["route"] = [];
            for (let item of this.route)
                data["route"].push(item);
        }
        data["part"] = this.part;
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportStockedGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: StockedStatus | undefined;
    workShift?: number | undefined;
    route?: number[] | undefined;
    part?: number | undefined;
    quantity?: number | undefined;
}

export class PagedResultDtoOfReportDownloadForListResponse implements IPagedResultDtoOfReportDownloadForListResponse {
    totalCount!: number;
    items?: ReportDownloadForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportDownloadForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportDownloadForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportDownloadForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportDownloadForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportDownloadForListResponse {
    totalCount: number;
    items?: ReportDownloadForListResponse[] | undefined;
}

export class ReportDownloadForListResponse implements IReportDownloadForListResponse {
    id!: number;
    detail?: number | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    carrierKey?: string | undefined;
    scheduledTime?: moment.Duration | undefined;
    originDesc?: string | undefined;
    origin2Desc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    typeDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    isCriticDesc?: string | undefined;
    normalQuantity?: number | undefined;
    suspiciousQuantity?: number | undefined;
    damageTypeDesc?: string | undefined;
    downloadQuantity?: number | undefined;
    downloadedQuantity?: number | undefined;
    totalBatches?: number | undefined;
    result?: string | undefined;
    isCeilingDesc?: string | undefined;
    isWallsDesc?: string | undefined;
    isFloorDesc?: string | undefined;
    isFrameDesc?: string | undefined;
    stamp?: string | undefined;
    statusDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;

    constructor(data?: IReportDownloadForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.detail = _data["detail"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.carrierKey = _data["carrierKey"];
            this.scheduledTime = _data["scheduledTime"] ? moment.duration(_data["scheduledTime"].toString()) : <any>undefined;
            this.originDesc = _data["originDesc"];
            this.origin2Desc = _data["origin2Desc"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.platformKey = _data["platformKey"];
            this.platformWindowNumber = _data["platformWindowNumber"];
            this.typeDesc = _data["typeDesc"];
            this.partKey = _data["partKey"];
            this.partDesc = _data["partDesc"];
            this.isCriticDesc = _data["isCriticDesc"];
            this.normalQuantity = _data["normalQuantity"];
            this.suspiciousQuantity = _data["suspiciousQuantity"];
            this.damageTypeDesc = _data["damageTypeDesc"];
            this.downloadQuantity = _data["downloadQuantity"];
            this.downloadedQuantity = _data["downloadedQuantity"];
            this.totalBatches = _data["totalBatches"];
            this.result = _data["result"];
            this.isCeilingDesc = _data["isCeilingDesc"];
            this.isWallsDesc = _data["isWallsDesc"];
            this.isFloorDesc = _data["isFloorDesc"];
            this.isFrameDesc = _data["isFrameDesc"];
            this.stamp = _data["stamp"];
            this.statusDesc = _data["statusDesc"];
            this.reasonSuspensionDesc = _data["reasonSuspensionDesc"];
        }
    }

    static fromJS(data: any): ReportDownloadForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDownloadForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detail"] = this.detail;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["carrierKey"] = this.carrierKey;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["originDesc"] = this.originDesc;
        data["origin2Desc"] = this.origin2Desc;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        data["platformKey"] = this.platformKey;
        data["platformWindowNumber"] = this.platformWindowNumber;
        data["typeDesc"] = this.typeDesc;
        data["partKey"] = this.partKey;
        data["partDesc"] = this.partDesc;
        data["isCriticDesc"] = this.isCriticDesc;
        data["normalQuantity"] = this.normalQuantity;
        data["suspiciousQuantity"] = this.suspiciousQuantity;
        data["damageTypeDesc"] = this.damageTypeDesc;
        data["downloadQuantity"] = this.downloadQuantity;
        data["downloadedQuantity"] = this.downloadedQuantity;
        data["totalBatches"] = this.totalBatches;
        data["result"] = this.result;
        data["isCeilingDesc"] = this.isCeilingDesc;
        data["isWallsDesc"] = this.isWallsDesc;
        data["isFloorDesc"] = this.isFloorDesc;
        data["isFrameDesc"] = this.isFrameDesc;
        data["stamp"] = this.stamp;
        data["statusDesc"] = this.statusDesc;
        data["reasonSuspensionDesc"] = this.reasonSuspensionDesc;
        return data;
    }
}

export interface IReportDownloadForListResponse {
    id: number;
    detail?: number | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    carrierKey?: string | undefined;
    scheduledTime?: moment.Duration | undefined;
    originDesc?: string | undefined;
    origin2Desc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    platformKey?: string | undefined;
    platformWindowNumber?: number | undefined;
    typeDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    isCriticDesc?: string | undefined;
    normalQuantity?: number | undefined;
    suspiciousQuantity?: number | undefined;
    damageTypeDesc?: string | undefined;
    downloadQuantity?: number | undefined;
    downloadedQuantity?: number | undefined;
    totalBatches?: number | undefined;
    result?: string | undefined;
    isCeilingDesc?: string | undefined;
    isWallsDesc?: string | undefined;
    isFloorDesc?: string | undefined;
    isFrameDesc?: string | undefined;
    stamp?: string | undefined;
    statusDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
}

export class ReportDownloadGetListQuery extends PageListByDto implements IReportDownloadGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: DownloadEstatus | undefined;
    platform?: number | undefined;
    origin?: DownloadOrigen | undefined;
    workShift?: number | undefined;
    carrierKey?: string | undefined;
    boxNumber?: string | undefined;
    part?: number | undefined;
    isCritic?: boolean | undefined;
    scheduledTime?: moment.Duration | undefined;

    constructor(data?: IReportDownloadGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.platform = _data["platform"];
            this.origin = _data["origin"];
            this.workShift = _data["workShift"];
            this.carrierKey = _data["carrierKey"];
            this.boxNumber = _data["boxNumber"];
            this.part = _data["part"];
            this.isCritic = _data["isCritic"];
            this.scheduledTime = _data["scheduledTime"] ? moment.duration(_data["scheduledTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportDownloadGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDownloadGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["platform"] = this.platform;
        data["origin"] = this.origin;
        data["workShift"] = this.workShift;
        data["carrierKey"] = this.carrierKey;
        data["boxNumber"] = this.boxNumber;
        data["part"] = this.part;
        data["isCritic"] = this.isCritic;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReportDownloadGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: DownloadEstatus | undefined;
    platform?: number | undefined;
    origin?: DownloadOrigen | undefined;
    workShift?: number | undefined;
    carrierKey?: string | undefined;
    boxNumber?: string | undefined;
    part?: number | undefined;
    isCritic?: boolean | undefined;
    scheduledTime?: moment.Duration | undefined;
}

export enum DownloadEstatus {
    Terminado = 1,
    Cancelado = 2,
    Suspendido = 3,
}

export enum DownloadOrigen {
    Inbound = 1,
    Campus = 2,
    Metering = 3,
    SinDocumentacion = 4,
}

export class ReportDownloadExcelResponse implements IReportDownloadExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportDownloadExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportDownloadExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDownloadExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportDownloadExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportDownloadGetExcelQuery extends PageListByDto implements IReportDownloadGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: DownloadEstatus | undefined;
    platform?: number | undefined;
    origin?: DownloadOrigen | undefined;
    workShift?: number | undefined;
    carrierKey?: string | undefined;
    boxNumber?: string | undefined;
    part?: number | undefined;
    isCritic?: boolean | undefined;
    scheduledTime?: moment.Duration | undefined;

    constructor(data?: IReportDownloadGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.platform = _data["platform"];
            this.origin = _data["origin"];
            this.workShift = _data["workShift"];
            this.carrierKey = _data["carrierKey"];
            this.boxNumber = _data["boxNumber"];
            this.part = _data["part"];
            this.isCritic = _data["isCritic"];
            this.scheduledTime = _data["scheduledTime"] ? moment.duration(_data["scheduledTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportDownloadGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDownloadGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["platform"] = this.platform;
        data["origin"] = this.origin;
        data["workShift"] = this.workShift;
        data["carrierKey"] = this.carrierKey;
        data["boxNumber"] = this.boxNumber;
        data["part"] = this.part;
        data["isCritic"] = this.isCritic;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReportDownloadGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: DownloadEstatus | undefined;
    platform?: number | undefined;
    origin?: DownloadOrigen | undefined;
    workShift?: number | undefined;
    carrierKey?: string | undefined;
    boxNumber?: string | undefined;
    part?: number | undefined;
    isCritic?: boolean | undefined;
    scheduledTime?: moment.Duration | undefined;
}

export class PagedResultDtoOfReportPutawayForListResponse implements IPagedResultDtoOfReportPutawayForListResponse {
    totalCount!: number;
    items?: ReportPutawayForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportPutawayForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportPutawayForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportPutawayForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportPutawayForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportPutawayForListResponse {
    totalCount: number;
    items?: ReportPutawayForListResponse[] | undefined;
}

export class ReportPutawayForListResponse implements IReportPutawayForListResponse {
    id!: number;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    statusDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    quantity?: number | undefined;
    serie?: string | undefined;
    initialLocationDesc?: string | undefined;
    ilZoneDesc?: string | undefined;
    ilAreaDesc?: string | undefined;
    ilTypeDesc?: string | undefined;
    finalLocationDesc?: string | undefined;
    flZoneDesc?: string | undefined;
    flAreaDesc?: string | undefined;
    flTypeDesc?: string | undefined;

    constructor(data?: IReportPutawayForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.statusDesc = _data["statusDesc"];
            this.reasonSuspensionDesc = _data["reasonSuspensionDesc"];
            this.partKey = _data["partKey"];
            this.partDesc = _data["partDesc"];
            this.quantity = _data["quantity"];
            this.serie = _data["serie"];
            this.initialLocationDesc = _data["initialLocationDesc"];
            this.ilZoneDesc = _data["ilZoneDesc"];
            this.ilAreaDesc = _data["ilAreaDesc"];
            this.ilTypeDesc = _data["ilTypeDesc"];
            this.finalLocationDesc = _data["finalLocationDesc"];
            this.flZoneDesc = _data["flZoneDesc"];
            this.flAreaDesc = _data["flAreaDesc"];
            this.flTypeDesc = _data["flTypeDesc"];
        }
    }

    static fromJS(data: any): ReportPutawayForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPutawayForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["statusDesc"] = this.statusDesc;
        data["reasonSuspensionDesc"] = this.reasonSuspensionDesc;
        data["partKey"] = this.partKey;
        data["partDesc"] = this.partDesc;
        data["quantity"] = this.quantity;
        data["serie"] = this.serie;
        data["initialLocationDesc"] = this.initialLocationDesc;
        data["ilZoneDesc"] = this.ilZoneDesc;
        data["ilAreaDesc"] = this.ilAreaDesc;
        data["ilTypeDesc"] = this.ilTypeDesc;
        data["finalLocationDesc"] = this.finalLocationDesc;
        data["flZoneDesc"] = this.flZoneDesc;
        data["flAreaDesc"] = this.flAreaDesc;
        data["flTypeDesc"] = this.flTypeDesc;
        return data;
    }
}

export interface IReportPutawayForListResponse {
    id: number;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    statusDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    quantity?: number | undefined;
    serie?: string | undefined;
    initialLocationDesc?: string | undefined;
    ilZoneDesc?: string | undefined;
    ilAreaDesc?: string | undefined;
    ilTypeDesc?: string | undefined;
    finalLocationDesc?: string | undefined;
    flZoneDesc?: string | undefined;
    flAreaDesc?: string | undefined;
    flTypeDesc?: string | undefined;
}

export class ReportPutawayGetListQuery extends PageListByDto implements IReportPutawayGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: PutawayStatus | undefined;
    initialLocation?: number | undefined;
    finalLocation?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportPutawayGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.initialLocation = _data["initialLocation"];
            this.finalLocation = _data["finalLocation"];
            this.workShift = _data["workShift"];
            this.part = _data["part"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportPutawayGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPutawayGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["initialLocation"] = this.initialLocation;
        data["finalLocation"] = this.finalLocation;
        data["workShift"] = this.workShift;
        data["part"] = this.part;
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportPutawayGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: PutawayStatus | undefined;
    initialLocation?: number | undefined;
    finalLocation?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    quantity?: number | undefined;
}

export enum PutawayStatus {
    Completed = 1,
    Cancelled = 2,
}

export class ReportPutawayExcelResponse implements IReportPutawayExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportPutawayExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportPutawayExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPutawayExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportPutawayExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportPutawayGetExcelQuery extends PageListByDto implements IReportPutawayGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: PutawayStatus | undefined;
    initialLocation?: number | undefined;
    finalLocation?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportPutawayGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.status = _data["status"];
            this.initialLocation = _data["initialLocation"];
            this.finalLocation = _data["finalLocation"];
            this.workShift = _data["workShift"];
            this.part = _data["part"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportPutawayGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPutawayGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["status"] = this.status;
        data["initialLocation"] = this.initialLocation;
        data["finalLocation"] = this.finalLocation;
        data["workShift"] = this.workShift;
        data["part"] = this.part;
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportPutawayGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    status?: PutawayStatus | undefined;
    initialLocation?: number | undefined;
    finalLocation?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    quantity?: number | undefined;
}

export class PagedResultDtoOfReportJITForListResponse implements IPagedResultDtoOfReportJITForListResponse {
    totalCount!: number;
    items?: ReportJITForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportJITForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportJITForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportJITForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportJITForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportJITForListResponse {
    totalCount: number;
    items?: ReportJITForListResponse[] | undefined;
}

export class ReportJITForListResponse implements IReportJITForListResponse {
    id!: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    statusDesc?: string | undefined;
    stageDesc?: string | undefined;
    boxNumber?: string | undefined;
    platform?: number | undefined;
    platformKey?: string | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;
    readModeDesc?: string | undefined;
    sequenceDesc?: string | undefined;
    isValidateMarketDesc?: string | undefined;
    emptyQuantity!: number;
    isCeilingDesc?: string | undefined;
    isWallsDesc?: string | undefined;
    isFloorDesc?: string | undefined;
    isFrameDesc?: string | undefined;

    constructor(data?: IReportJITForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.reasonSuspensionDesc = _data["reasonSuspensionDesc"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.statusDesc = _data["statusDesc"];
            this.stageDesc = _data["stageDesc"];
            this.boxNumber = _data["boxNumber"];
            this.platform = _data["platform"];
            this.platformKey = _data["platformKey"];
            this.commodityKey = _data["commodityKey"];
            this.commodityDesc = _data["commodityDesc"];
            this.readModeDesc = _data["readModeDesc"];
            this.sequenceDesc = _data["sequenceDesc"];
            this.isValidateMarketDesc = _data["isValidateMarketDesc"];
            this.emptyQuantity = _data["emptyQuantity"];
            this.isCeilingDesc = _data["isCeilingDesc"];
            this.isWallsDesc = _data["isWallsDesc"];
            this.isFloorDesc = _data["isFloorDesc"];
            this.isFrameDesc = _data["isFrameDesc"];
        }
    }

    static fromJS(data: any): ReportJITForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJITForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["reasonSuspensionDesc"] = this.reasonSuspensionDesc;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["statusDesc"] = this.statusDesc;
        data["stageDesc"] = this.stageDesc;
        data["boxNumber"] = this.boxNumber;
        data["platform"] = this.platform;
        data["platformKey"] = this.platformKey;
        data["commodityKey"] = this.commodityKey;
        data["commodityDesc"] = this.commodityDesc;
        data["readModeDesc"] = this.readModeDesc;
        data["sequenceDesc"] = this.sequenceDesc;
        data["isValidateMarketDesc"] = this.isValidateMarketDesc;
        data["emptyQuantity"] = this.emptyQuantity;
        data["isCeilingDesc"] = this.isCeilingDesc;
        data["isWallsDesc"] = this.isWallsDesc;
        data["isFloorDesc"] = this.isFloorDesc;
        data["isFrameDesc"] = this.isFrameDesc;
        return data;
    }
}

export interface IReportJITForListResponse {
    id: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    reasonSuspensionDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    statusDesc?: string | undefined;
    stageDesc?: string | undefined;
    boxNumber?: string | undefined;
    platform?: number | undefined;
    platformKey?: string | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;
    readModeDesc?: string | undefined;
    sequenceDesc?: string | undefined;
    isValidateMarketDesc?: string | undefined;
    emptyQuantity: number;
    isCeilingDesc?: string | undefined;
    isWallsDesc?: string | undefined;
    isFloorDesc?: string | undefined;
    isFrameDesc?: string | undefined;
}

export class ReportJITGetListQuery extends PageListByDto implements IReportJITGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number[] | undefined;
    user?: number | undefined;
    status?: JITStatus | undefined;
    stage?: JITStage | undefined;
    workShift?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    rackSequence?: number | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;

    constructor(data?: IReportJITGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.user = _data["user"];
            this.status = _data["status"];
            this.stage = _data["stage"];
            this.workShift = _data["workShift"];
            this.readMode = _data["readMode"];
            this.rackSequence = _data["rackSequence"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
        }
    }

    static fromJS(data: any): ReportJITGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJITGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["user"] = this.user;
        data["status"] = this.status;
        data["stage"] = this.stage;
        data["workShift"] = this.workShift;
        data["readMode"] = this.readMode;
        data["rackSequence"] = this.rackSequence;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IReportJITGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number[] | undefined;
    user?: number | undefined;
    status?: JITStatus | undefined;
    stage?: JITStage | undefined;
    workShift?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    rackSequence?: number | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
}

export enum JITStatus {
    Completed = 1,
    Cancelled = 2,
    Suspended = 3,
}

export enum JITStage {
    UnloadDolly = 1,
    LoadEmpty = 2,
}

export class ReportJITExcelResponse implements IReportJITExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportJITExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportJITExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJITExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportJITExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportJITGetExcelQuery extends PageListByDto implements IReportJITGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number[] | undefined;
    user?: number | undefined;
    status?: JITStatus | undefined;
    stage?: JITStage | undefined;
    workShift?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    rackSequence?: number | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;

    constructor(data?: IReportJITGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.user = _data["user"];
            this.status = _data["status"];
            this.stage = _data["stage"];
            this.workShift = _data["workShift"];
            this.readMode = _data["readMode"];
            this.rackSequence = _data["rackSequence"];
            this.initialSequence = _data["initialSequence"];
            this.finalSequence = _data["finalSequence"];
        }
    }

    static fromJS(data: any): ReportJITGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJITGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["user"] = this.user;
        data["status"] = this.status;
        data["stage"] = this.stage;
        data["workShift"] = this.workShift;
        data["readMode"] = this.readMode;
        data["rackSequence"] = this.rackSequence;
        data["initialSequence"] = this.initialSequence;
        data["finalSequence"] = this.finalSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IReportJITGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number[] | undefined;
    user?: number | undefined;
    status?: JITStatus | undefined;
    stage?: JITStage | undefined;
    workShift?: number | undefined;
    readMode?: CommodityReadMode | undefined;
    rackSequence?: number | undefined;
    initialSequence?: number | undefined;
    finalSequence?: number | undefined;
}

export class PagedResultDtoOfReportEmptyForListResponse implements IPagedResultDtoOfReportEmptyForListResponse {
    totalCount!: number;
    items?: ReportEmptyForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportEmptyForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportEmptyForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportEmptyForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportEmptyForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportEmptyForListResponse {
    totalCount: number;
    items?: ReportEmptyForListResponse[] | undefined;
}

export class ReportEmptyForListResponse implements IReportEmptyForListResponse {
    id!: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    boxNumber?: string | undefined;
    platformKey?: string | undefined;
    quantity?: number | undefined;
    reasonSuspensionDesc?: string | undefined;
    statusDesc?: string | undefined;

    constructor(data?: IReportEmptyForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.boxNumber = _data["boxNumber"];
            this.platformKey = _data["platformKey"];
            this.quantity = _data["quantity"];
            this.reasonSuspensionDesc = _data["reasonSuspensionDesc"];
            this.statusDesc = _data["statusDesc"];
        }
    }

    static fromJS(data: any): ReportEmptyForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEmptyForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["boxNumber"] = this.boxNumber;
        data["platformKey"] = this.platformKey;
        data["quantity"] = this.quantity;
        data["reasonSuspensionDesc"] = this.reasonSuspensionDesc;
        data["statusDesc"] = this.statusDesc;
        return data;
    }
}

export interface IReportEmptyForListResponse {
    id: number;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    boxNumber?: string | undefined;
    platformKey?: string | undefined;
    quantity?: number | undefined;
    reasonSuspensionDesc?: string | undefined;
    statusDesc?: string | undefined;
}

export class ReportEmptyGetListQuery extends PageListByDto implements IReportEmptyGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    status?: EmptyStatus | undefined;

    constructor(data?: IReportEmptyGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.platform = _data["platform"];
            this.user = _data["user"];
            this.workShift = _data["workShift"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReportEmptyGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEmptyGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["platform"] = this.platform;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IReportEmptyGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    status?: EmptyStatus | undefined;
}

export enum EmptyStatus {
    Active = 1,
    Cancelled = 2,
}

export class ReportEmptyExcelResponse implements IReportEmptyExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportEmptyExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportEmptyExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEmptyExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportEmptyExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportEmptyGetExcelQuery extends PageListByDto implements IReportEmptyGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    status?: EmptyStatus | undefined;

    constructor(data?: IReportEmptyGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.platform = _data["platform"];
            this.user = _data["user"];
            this.workShift = _data["workShift"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReportEmptyGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEmptyGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["platform"] = this.platform;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IReportEmptyGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    platform?: number | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    status?: EmptyStatus | undefined;
}

export class PagedResultDtoOfReportLocationStockForListResponse implements IPagedResultDtoOfReportLocationStockForListResponse {
    totalCount!: number;
    items?: ReportLocationStockForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportLocationStockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportLocationStockForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportLocationStockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportLocationStockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportLocationStockForListResponse {
    totalCount: number;
    items?: ReportLocationStockForListResponse[] | undefined;
}

export class ReportLocationStockForListResponse implements IReportLocationStockForListResponse {
    id!: number;
    locationDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    isProductiveDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportLocationStockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationDesc = _data["locationDesc"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.isProductiveDesc = _data["isProductiveDesc"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.partDesc = _data["partDesc"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportLocationStockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLocationStockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationDesc"] = this.locationDesc;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["isProductiveDesc"] = this.isProductiveDesc;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["partDesc"] = this.partDesc;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IReportLocationStockForListResponse {
    id: number;
    locationDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    isProductiveDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    quantity?: number | undefined;
}

export class ReportLocationStockGetListQuery extends PageListByDto implements IReportLocationStockGetListQuery {
    zone?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;

    constructor(data?: IReportLocationStockGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
            this.locationType = _data["locationType"];
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): ReportLocationStockGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLocationStockGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["locationType"] = this.locationType;
        data["part"] = this.part;
        super.toJSON(data);
        return data;
    }
}

export interface IReportLocationStockGetListQuery extends IPageListByDto {
    zone?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
}

export class ReportLocationStockExcelResponse implements IReportLocationStockExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportLocationStockExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportLocationStockExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLocationStockExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportLocationStockExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportLocationStockGetExcelQuery extends PageListByDto implements IReportLocationStockGetExcelQuery {
    zone?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;

    constructor(data?: IReportLocationStockGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
            this.locationType = _data["locationType"];
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): ReportLocationStockGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLocationStockGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["locationType"] = this.locationType;
        data["part"] = this.part;
        super.toJSON(data);
        return data;
    }
}

export interface IReportLocationStockGetExcelQuery extends IPageListByDto {
    zone?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
}

export class PagedResultDtoOfReportWarehouseMovementForListResponse implements IPagedResultDtoOfReportWarehouseMovementForListResponse {
    totalCount!: number;
    items?: ReportWarehouseMovementForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportWarehouseMovementForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportWarehouseMovementForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportWarehouseMovementForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportWarehouseMovementForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportWarehouseMovementForListResponse {
    totalCount: number;
    items?: ReportWarehouseMovementForListResponse[] | undefined;
}

export class ReportWarehouseMovementForListResponse implements IReportWarehouseMovementForListResponse {
    id!: number;
    creationTime?: moment.Moment | undefined;
    locationDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    movementTypeDesc?: string | undefined;
    packageSerie?: string | undefined;
    typeDesc?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IReportWarehouseMovementForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.locationDesc = _data["locationDesc"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.partKey = _data["partKey"];
            this.partDesc = _data["partDesc"];
            this.movementTypeDesc = _data["movementTypeDesc"];
            this.packageSerie = _data["packageSerie"];
            this.typeDesc = _data["typeDesc"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ReportWarehouseMovementForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWarehouseMovementForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["locationDesc"] = this.locationDesc;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["partKey"] = this.partKey;
        data["partDesc"] = this.partDesc;
        data["movementTypeDesc"] = this.movementTypeDesc;
        data["packageSerie"] = this.packageSerie;
        data["typeDesc"] = this.typeDesc;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IReportWarehouseMovementForListResponse {
    id: number;
    creationTime?: moment.Moment | undefined;
    locationDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    partKey?: string | undefined;
    partDesc?: string | undefined;
    movementTypeDesc?: string | undefined;
    packageSerie?: string | undefined;
    typeDesc?: string | undefined;
    quantity?: number | undefined;
}

export class ReportWarehouseMovementGetListQuery extends PageListByDto implements IReportWarehouseMovementGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    location?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
    packageSerie?: string | undefined;

    constructor(data?: IReportWarehouseMovementGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
            this.part = _data["part"];
            this.packageSerie = _data["packageSerie"];
        }
    }

    static fromJS(data: any): ReportWarehouseMovementGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWarehouseMovementGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        data["part"] = this.part;
        data["packageSerie"] = this.packageSerie;
        super.toJSON(data);
        return data;
    }
}

export interface IReportWarehouseMovementGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    location?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
    packageSerie?: string | undefined;
}

export class ReportWarehouseMovementExcelResponse implements IReportWarehouseMovementExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportWarehouseMovementExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportWarehouseMovementExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWarehouseMovementExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportWarehouseMovementExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportWarehouseMovementGetExcelQuery extends PageListByDto implements IReportWarehouseMovementGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    location?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
    packageSerie?: string | undefined;

    constructor(data?: IReportWarehouseMovementGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
            this.part = _data["part"];
            this.packageSerie = _data["packageSerie"];
        }
    }

    static fromJS(data: any): ReportWarehouseMovementGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWarehouseMovementGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        data["part"] = this.part;
        data["packageSerie"] = this.packageSerie;
        super.toJSON(data);
        return data;
    }
}

export interface IReportWarehouseMovementGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    location?: number | undefined;
    locationType?: number | undefined;
    part?: number | undefined;
    packageSerie?: string | undefined;
}

export class PagedResultDtoOfReportTimeInStockForListResponse implements IPagedResultDtoOfReportTimeInStockForListResponse {
    totalCount!: number;
    items?: ReportTimeInStockForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportTimeInStockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportTimeInStockForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportTimeInStockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportTimeInStockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportTimeInStockForListResponse {
    totalCount: number;
    items?: ReportTimeInStockForListResponse[] | undefined;
}

export class ReportTimeInStockForListResponse implements IReportTimeInStockForListResponse {
    id!: number;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    locationDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    serie?: string | undefined;
    downloadBaseDate?: moment.Moment | undefined;
    daysInStock?: number | undefined;

    constructor(data?: IReportTimeInStockForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaDesc = _data["areaDesc"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.locationDesc = _data["locationDesc"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.partDesc = _data["partDesc"];
            this.serie = _data["serie"];
            this.downloadBaseDate = _data["downloadBaseDate"] ? moment(_data["downloadBaseDate"].toString()) : <any>undefined;
            this.daysInStock = _data["daysInStock"];
        }
    }

    static fromJS(data: any): ReportTimeInStockForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTimeInStockForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneDesc"] = this.zoneDesc;
        data["areaDesc"] = this.areaDesc;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["locationDesc"] = this.locationDesc;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["partDesc"] = this.partDesc;
        data["serie"] = this.serie;
        data["downloadBaseDate"] = this.downloadBaseDate ? this.downloadBaseDate.toISOString() : <any>undefined;
        data["daysInStock"] = this.daysInStock;
        return data;
    }
}

export interface IReportTimeInStockForListResponse {
    id: number;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    locationTypeDesc?: string | undefined;
    locationDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    serie?: string | undefined;
    downloadBaseDate?: moment.Moment | undefined;
    daysInStock?: number | undefined;
}

export class ReportTimeInStockGetListQuery extends PageListByDto implements IReportTimeInStockGetListQuery {
    zone?: number | undefined;
    part?: number | undefined;
    daysStart?: number | undefined;
    daysEnd?: number | undefined;

    constructor(data?: IReportTimeInStockGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
            this.part = _data["part"];
            this.daysStart = _data["daysStart"];
            this.daysEnd = _data["daysEnd"];
        }
    }

    static fromJS(data: any): ReportTimeInStockGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTimeInStockGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["part"] = this.part;
        data["daysStart"] = this.daysStart;
        data["daysEnd"] = this.daysEnd;
        super.toJSON(data);
        return data;
    }
}

export interface IReportTimeInStockGetListQuery extends IPageListByDto {
    zone?: number | undefined;
    part?: number | undefined;
    daysStart?: number | undefined;
    daysEnd?: number | undefined;
}

export class ReportTimeInStockExcelResponse implements IReportTimeInStockExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportTimeInStockExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportTimeInStockExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTimeInStockExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportTimeInStockExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportTimeInStockGetExcelQuery extends PageListByDto implements IReportTimeInStockGetExcelQuery {
    zone?: number | undefined;
    part?: number | undefined;
    daysStart?: number | undefined;
    daysEnd?: number | undefined;

    constructor(data?: IReportTimeInStockGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
            this.part = _data["part"];
            this.daysStart = _data["daysStart"];
            this.daysEnd = _data["daysEnd"];
        }
    }

    static fromJS(data: any): ReportTimeInStockGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTimeInStockGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["part"] = this.part;
        data["daysStart"] = this.daysStart;
        data["daysEnd"] = this.daysEnd;
        super.toJSON(data);
        return data;
    }
}

export interface IReportTimeInStockGetExcelQuery extends IPageListByDto {
    zone?: number | undefined;
    part?: number | undefined;
    daysStart?: number | undefined;
    daysEnd?: number | undefined;
}

export class PagedResultDtoOfReportMaxMinForListResponse implements IPagedResultDtoOfReportMaxMinForListResponse {
    totalCount!: number;
    items?: ReportMaxMinForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportMaxMinForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportMaxMinForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportMaxMinForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportMaxMinForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportMaxMinForListResponse {
    totalCount: number;
    items?: ReportMaxMinForListResponse[] | undefined;
}

export class ReportMaxMinForListResponse implements IReportMaxMinForListResponse {
    id!: number;
    areaDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    stock?: number | undefined;
    result?: number | undefined;

    constructor(data?: IReportMaxMinForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaDesc = _data["areaDesc"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.partDesc = _data["partDesc"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.stock = _data["stock"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): ReportMaxMinForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMaxMinForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaDesc"] = this.areaDesc;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["partDesc"] = this.partDesc;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["stock"] = this.stock;
        data["result"] = this.result;
        return data;
    }
}

export interface IReportMaxMinForListResponse {
    id: number;
    areaDesc?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    stock?: number | undefined;
    result?: number | undefined;
}

export class ReportMaxMinGetListQuery extends PageListByDto implements IReportMaxMinGetListQuery {
    zone?: number | undefined;

    constructor(data?: IReportMaxMinGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): ReportMaxMinGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMaxMinGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        super.toJSON(data);
        return data;
    }
}

export interface IReportMaxMinGetListQuery extends IPageListByDto {
    zone?: number | undefined;
}

export class ReportMaxMinExcelResponse implements IReportMaxMinExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportMaxMinExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportMaxMinExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMaxMinExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportMaxMinExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportMaxMinGetExcelQuery extends PageListByDto implements IReportMaxMinGetExcelQuery {
    zone?: number | undefined;

    constructor(data?: IReportMaxMinGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): ReportMaxMinGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMaxMinGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        super.toJSON(data);
        return data;
    }
}

export interface IReportMaxMinGetExcelQuery extends IPageListByDto {
    zone?: number | undefined;
}

export class PagedResultDtoOfReportActivityForListResponse implements IPagedResultDtoOfReportActivityForListResponse {
    totalCount!: number;
    items?: ReportActivityForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportActivityForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportActivityForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportActivityForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportActivityForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportActivityForListResponse {
    totalCount: number;
    items?: ReportActivityForListResponse[] | undefined;
}

export class ReportActivityForListResponse implements IReportActivityForListResponse {
    id!: number;
    reference?: number | undefined;
    workShiftDesc?: string | undefined;
    userDesc?: string | undefined;
    description?: string | undefined;
    estimatedTime?: moment.Duration | undefined;
    typeDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;

    constructor(data?: IReportActivityForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.userDesc = _data["userDesc"];
            this.description = _data["description"];
            this.estimatedTime = _data["estimatedTime"] ? moment.duration(_data["estimatedTime"].toString()) : <any>undefined;
            this.typeDesc = _data["typeDesc"];
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportActivityForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportActivityForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["workShiftDesc"] = this.workShiftDesc;
        data["userDesc"] = this.userDesc;
        data["description"] = this.description;
        data["estimatedTime"] = this.estimatedTime ? this.estimatedTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["typeDesc"] = this.typeDesc;
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReportActivityForListResponse {
    id: number;
    reference?: number | undefined;
    workShiftDesc?: string | undefined;
    userDesc?: string | undefined;
    description?: string | undefined;
    estimatedTime?: moment.Duration | undefined;
    typeDesc?: string | undefined;
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
}

export class ReportActivityGetListQuery extends PageListByDto implements IReportActivityGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;

    constructor(data?: IReportActivityGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.workShift = _data["workShift"];
        }
    }

    static fromJS(data: any): ReportActivityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportActivityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        super.toJSON(data);
        return data;
    }
}

export interface IReportActivityGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
}

export class ReportActivityExcelResponse implements IReportActivityExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportActivityExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportActivityExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportActivityExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportActivityExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportActivityGetExcelQuery extends PageListByDto implements IReportActivityGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;

    constructor(data?: IReportActivityGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.workShift = _data["workShift"];
        }
    }

    static fromJS(data: any): ReportActivityGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportActivityGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        super.toJSON(data);
        return data;
    }
}

export interface IReportActivityGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
}

export class PagedResultDtoOfReportSupplyCardDeliveryForListResponse implements IPagedResultDtoOfReportSupplyCardDeliveryForListResponse {
    totalCount!: number;
    items?: ReportSupplyCardDeliveryForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportSupplyCardDeliveryForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportSupplyCardDeliveryForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportSupplyCardDeliveryForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportSupplyCardDeliveryForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportSupplyCardDeliveryForListResponse {
    totalCount: number;
    items?: ReportSupplyCardDeliveryForListResponse[] | undefined;
}

export class ReportSupplyCardDeliveryForListResponse implements IReportSupplyCardDeliveryForListResponse {
    id!: number;
    deliveryDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    supplyCardRouteKey?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    deliveryLocationKey?: string | undefined;
    deliveryLocationDesc?: string | undefined;
    quantity!: number;
    serie?: string | undefined;

    constructor(data?: IReportSupplyCardDeliveryForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deliveryDateTime = _data["deliveryDateTime"] ? moment(_data["deliveryDateTime"].toString()) : <any>undefined;
            this.userDesc = _data["userDesc"];
            this.workShiftDesc = _data["workShiftDesc"];
            this.supplyCardRouteKey = _data["supplyCardRouteKey"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.partDesc = _data["partDesc"];
            this.deliveryLocationKey = _data["deliveryLocationKey"];
            this.deliveryLocationDesc = _data["deliveryLocationDesc"];
            this.quantity = _data["quantity"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): ReportSupplyCardDeliveryForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSupplyCardDeliveryForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["userDesc"] = this.userDesc;
        data["workShiftDesc"] = this.workShiftDesc;
        data["supplyCardRouteKey"] = this.supplyCardRouteKey;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["partDesc"] = this.partDesc;
        data["deliveryLocationKey"] = this.deliveryLocationKey;
        data["deliveryLocationDesc"] = this.deliveryLocationDesc;
        data["quantity"] = this.quantity;
        data["serie"] = this.serie;
        return data;
    }
}

export interface IReportSupplyCardDeliveryForListResponse {
    id: number;
    deliveryDateTime?: moment.Moment | undefined;
    userDesc?: string | undefined;
    workShiftDesc?: string | undefined;
    supplyCardRouteKey?: string | undefined;
    partBaseWithFormat?: string | undefined;
    partDesc?: string | undefined;
    deliveryLocationKey?: string | undefined;
    deliveryLocationDesc?: string | undefined;
    quantity: number;
    serie?: string | undefined;
}

export class ReportSupplyCardDeliveryGetListQuery extends PageListByDto implements IReportSupplyCardDeliveryGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    supplyCardRoute?: number | undefined;

    constructor(data?: IReportSupplyCardDeliveryGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.workShift = _data["workShift"];
            this.part = _data["part"];
            this.supplyCardRoute = _data["supplyCardRoute"];
        }
    }

    static fromJS(data: any): ReportSupplyCardDeliveryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSupplyCardDeliveryGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        data["part"] = this.part;
        data["supplyCardRoute"] = this.supplyCardRoute;
        super.toJSON(data);
        return data;
    }
}

export interface IReportSupplyCardDeliveryGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    supplyCardRoute?: number | undefined;
}

export class ReportSupplyCardDeliveryExcelResponse implements IReportSupplyCardDeliveryExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportSupplyCardDeliveryExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportSupplyCardDeliveryExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSupplyCardDeliveryExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportSupplyCardDeliveryExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportSupplyCardDeliveryGetExcelQuery extends PageListByDto implements IReportSupplyCardDeliveryGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    supplyCardRoute?: number | undefined;

    constructor(data?: IReportSupplyCardDeliveryGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.workShift = _data["workShift"];
            this.part = _data["part"];
            this.supplyCardRoute = _data["supplyCardRoute"];
        }
    }

    static fromJS(data: any): ReportSupplyCardDeliveryGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSupplyCardDeliveryGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["workShift"] = this.workShift;
        data["part"] = this.part;
        data["supplyCardRoute"] = this.supplyCardRoute;
        super.toJSON(data);
        return data;
    }
}

export interface IReportSupplyCardDeliveryGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    user?: number | undefined;
    workShift?: number | undefined;
    part?: number | undefined;
    supplyCardRoute?: number | undefined;
}

export class PagedResultDtoOfReportReasonRestartLogForListResponse implements IPagedResultDtoOfReportReasonRestartLogForListResponse {
    totalCount!: number;
    items?: ReportReasonRestartLogForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReportReasonRestartLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportReasonRestartLogForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportReasonRestartLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportReasonRestartLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReportReasonRestartLogForListResponse {
    totalCount: number;
    items?: ReportReasonRestartLogForListResponse[] | undefined;
}

export class ReportReasonRestartLogForListResponse implements IReportReasonRestartLogForListResponse {
    id!: number;
    userDesc?: string | undefined;
    key?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;

    constructor(data?: IReportReasonRestartLogForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDesc = _data["userDesc"];
            this.key = _data["key"];
            this.datetime = _data["datetime"] ? moment(_data["datetime"].toString()) : <any>undefined;
            this.detail = _data["detail"];
            this.commodityKey = _data["commodityKey"];
            this.commodityDesc = _data["commodityDesc"];
        }
    }

    static fromJS(data: any): ReportReasonRestartLogForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportReasonRestartLogForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDesc"] = this.userDesc;
        data["key"] = this.key;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["detail"] = this.detail;
        data["commodityKey"] = this.commodityKey;
        data["commodityDesc"] = this.commodityDesc;
        return data;
    }
}

export interface IReportReasonRestartLogForListResponse {
    id: number;
    userDesc?: string | undefined;
    key?: string | undefined;
    datetime?: moment.Moment | undefined;
    detail?: string | undefined;
    commodityKey?: string | undefined;
    commodityDesc?: string | undefined;
}

export class ReportReasonRestartLogGetListQuery extends PageListByDto implements IReportReasonRestartLogGetListQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    commodity?: number | undefined;

    constructor(data?: IReportReasonRestartLogGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.commodity = _data["commodity"];
        }
    }

    static fromJS(data: any): ReportReasonRestartLogGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportReasonRestartLogGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["commodity"] = this.commodity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportReasonRestartLogGetListQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    commodity?: number | undefined;
}

export class ReportReasonRestartLogExcelResponse implements IReportReasonRestartLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IReportReasonRestartLogExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): ReportReasonRestartLogExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportReasonRestartLogExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IReportReasonRestartLogExcelResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class ReportReasonRestartLogGetExcelQuery extends PageListByDto implements IReportReasonRestartLogGetExcelQuery {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    commodity?: number | undefined;

    constructor(data?: IReportReasonRestartLogGetExcelQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDateTime = _data["initialDateTime"] ? moment(_data["initialDateTime"].toString()) : <any>undefined;
            this.finalDateTime = _data["finalDateTime"] ? moment(_data["finalDateTime"].toString()) : <any>undefined;
            this.commodity = _data["commodity"];
        }
    }

    static fromJS(data: any): ReportReasonRestartLogGetExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReportReasonRestartLogGetExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDateTime"] = this.initialDateTime ? this.initialDateTime.toISOString() : <any>undefined;
        data["finalDateTime"] = this.finalDateTime ? this.finalDateTime.toISOString() : <any>undefined;
        data["commodity"] = this.commodity;
        super.toJSON(data);
        return data;
    }
}

export interface IReportReasonRestartLogGetExcelQuery extends IPageListByDto {
    initialDateTime?: moment.Moment | undefined;
    finalDateTime?: moment.Moment | undefined;
    commodity?: number | undefined;
}

export interface ITablaProductividadResponse {
    items?: ProductividadDto[] | undefined;
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TablaProductividadResponse implements ITablaProductividadResponse {
    items?: ProductividadDto[] | undefined;
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: ITablaProductividadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductividadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): TablaProductividadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TablaProductividadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IProductividadDto {
    secuenciaReal?: string | undefined;
    horaInicio?: string | undefined;
    horaTermino?: string | undefined;
    tiempoEfectivo?: string | undefined;
    fechaEscaneo?: moment.Moment | undefined;
    turnoDescr?: string | undefined;
    noParte?: string | undefined;
    cantidad?: number;
    cantidadEscaneada?: number;
    completo?: boolean;
    causaFaltanteDescr?: string | undefined;
    commodityCode?: string | undefined;
    commodityNombre?: string | undefined;
    nombre?: string | undefined;
    usuarioIdEmpleado?: string | undefined;
    esRecuperado?: boolean | null;
}

export class ProductividadDto implements IProductividadDto {
    secuenciaReal?: string | undefined;
    horaInicio?: string | undefined;
    horaTermino?: string | undefined;
    tiempoEfectivo?: string | undefined;
    fechaEscaneo?: moment.Moment | undefined;
    turnoDescr?: string | undefined;
    noParte?: string | undefined;
    cantidad?: number;
    cantidadEscaneada?: number;
    completo?: boolean;
    causaFaltanteDescr?: string | undefined;
    commodityCode?: string | undefined;
    commodityNombre?: string | undefined;
    nombre?: string | undefined;
    usuarioIdEmpleado?: string | undefined;
    esRecuperado?: boolean | null;

    constructor(data?: IProductividadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secuenciaReal = _data["secuenciaReal"];
            this.horaInicio = _data["horaInicio"];
            this.horaTermino = _data["horaTermino"];
            this.tiempoEfectivo = _data["tiempoEfectivo"];
            this.fechaEscaneo = _data["fechaEscaneo"] ? moment(_data["fechaEscaneo"].toString()) : <any>undefined;
            this.turnoDescr = _data["turnoDescr"];
            this.noParte = _data["noParte"];
            this.cantidad = _data["cantidad"];
            this.cantidadEscaneada = _data["cantidadEscaneada"];
            this.completo = _data["completo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.commodityCode = _data["commodityCode"];
            this.commodityNombre = _data["commodityNombre"];
            this.nombre = _data["nombre"];
            this.usuarioIdEmpleado = _data["usuarioIdEmpleado"];
            this.esRecuperado = _data["esRecuperado"];
        }
    }

    static fromJS(data: any): ProductividadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductividadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuenciaReal"] = this.secuenciaReal;
        data["horaInicio"] = this.horaInicio;
        data["horaTermino"] = this.horaTermino;
        data["tiempoEfectivo"] = this.tiempoEfectivo;
        data["fechaEscaneo"] = this.fechaEscaneo ? this.fechaEscaneo.toISOString() : <any>undefined;
        data["turnoDescr"] = this.turnoDescr;
        data["noParte"] = this.noParte;
        data["cantidad"] = this.cantidad;
        data["cantidadEscaneada"] = this.cantidadEscaneada;
        data["completo"] = this.completo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["commodityCode"] = this.commodityCode;
        data["commodityNombre"] = this.commodityNombre;
        data["nombre"] = this.nombre;
        data["usuarioIdEmpleado"] = this.usuarioIdEmpleado;
        data["esRecuperado"] = this.esRecuperado;
        return data;
    }
}

export interface ITablaProductividadExportQuery {
    desde?: string | undefined;
    hasta?: string | undefined;
    programa?: string | undefined;
    commodity?: string | undefined;
    secuenciaInicio?: string | undefined;
    secuenciaFin?: string | undefined;
    formato?: string | undefined;
}

export class TablaProductividadExportQuery implements ITablaProductividadExportQuery {
    desde?: string| undefined;
    hasta?: string | undefined;
    programa?: string | undefined;
    commodity?: string | undefined;
    secuenciaInicio?: string | undefined;
    secuenciaFin?: string | undefined;
    formato?: string | undefined;

    constructor(data?: ITablaProductividadExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desde = _data["desde"] ? moment(_data["desde"].toString()) : <any>undefined;
            this.hasta = _data["hasta"] ? moment(_data["hasta"].toString()) : <any>undefined;
            this.programa = _data["programa"];
            this.commodity = _data["commodity"];
            this.secuenciaInicio = _data["secuenciaInicio"];
            this.secuenciaFin = _data["secuenciaFin"];
            this.formato = _data["formato"];
        }
    }

    static fromJS(data: any): TablaProductividadExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TablaProductividadExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desde"] = this.desde ? this.desde : <any>undefined;
        data["hasta"] = this.hasta ? this.hasta : <any>undefined;
        data["programa"] = this.programa;
        data["commodity"] = this.commodity;
        data["secuenciaInicio"] = this.secuenciaInicio;
        data["secuenciaFin"] = this.secuenciaFin;
        data["formato"] = this.formato;
        return data;
    }
}

export interface ITablaProductividadExportResponse {
    success?: boolean;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
    errorMessage?: string | undefined;
}

export class TablaProductividadExportResponse implements ITablaProductividadExportResponse {
    success?: boolean;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ITablaProductividadExportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): TablaProductividadExportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TablaProductividadExportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export class PagedResultDtoOfRolForListResponse implements IPagedResultDtoOfRolForListResponse {
    totalCount!: number;
    items?: RolForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfRolForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RolForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRolForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRolForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRolForListResponse {
    totalCount: number;
    items?: RolForListResponse[] | undefined;
}

export class RolForListResponse implements IRolForListResponse {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;

    constructor(data?: IRolForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): RolForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IRolForListResponse {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
}

export class RolGetListQuery extends PageListByDto implements IRolGetListQuery {

    constructor(data?: IRolGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RolGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RolGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRolGetListQuery extends IPageListByDto {
}

export class RolResponse implements IRolResponse {
    id!: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IRolResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RolResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IRolResponse {
    id: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;
}

export class RolGetByIdQuery implements IRolGetByIdQuery {
    id!: number;

    constructor(data?: IRolGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RolGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RolGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRolGetByIdQuery {
    id: number;
}

export class RolCreateCommand implements IRolCreateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    grantedPermissionNames?: string[] | undefined;

    constructor(data?: IRolCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): RolCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RolCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IRolCreateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    grantedPermissionNames?: string[] | undefined;
}

export class RolUpdateCommand implements IRolUpdateCommand {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;
    grantedPermissionNames?: string[] | undefined;

    constructor(data?: IRolUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): RolUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RolUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IRolUpdateCommand {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    isDeleted?: boolean | undefined;
    grantedPermissionNames?: string[] | undefined;
}

export class RolDeleteCommand implements IRolDeleteCommand {
    id!: number;

    constructor(data?: IRolDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RolDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RolDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRolDeleteCommand {
    id: number;
}

export class RolForEditReponse implements IRolForEditReponse {
    id!: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    permisoList?: RolPermisoResponse[] | undefined;

    constructor(data?: IRolForEditReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["permisoList"])) {
                this.permisoList = [] as any;
                for (let item of _data["permisoList"])
                    this.permisoList!.push(RolPermisoResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolForEditReponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolForEditReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.permisoList)) {
            data["permisoList"] = [];
            for (let item of this.permisoList)
                data["permisoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRolForEditReponse {
    id: number;
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean | undefined;
    permisoList?: RolPermisoResponse[] | undefined;
}

export class RolPermisoResponse implements IRolPermisoResponse {
    id!: number;
    name?: string | undefined;

    constructor(data?: IRolPermisoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RolPermisoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolPermisoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRolPermisoResponse {
    id: number;
    name?: string | undefined;
}

export class RolGetForEditQuery implements IRolGetForEditQuery {
    id!: number;

    constructor(data?: IRolGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RolGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RolGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRolGetForEditQuery {
    id: number;
}

export class RolForListActiveResponse implements IRolForListActiveResponse {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IRolForListActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RolForListActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolForListActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRolForListActiveResponse {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
}

export class RolGetForListActiveQuery implements IRolGetForListActiveQuery {

    constructor(data?: IRolGetForListActiveQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RolGetForListActiveQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RolGetForListActiveQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRolGetForListActiveQuery {
}

export class PagedResultDtoOfRouteForListResponse implements IPagedResultDtoOfRouteForListResponse {
    totalCount!: number;
    items?: RouteForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfRouteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RouteForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRouteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRouteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRouteForListResponse {
    totalCount: number;
    items?: RouteForListResponse[] | undefined;
}

export class RouteForListResponse implements IRouteForListResponse {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IRouteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): RouteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IRouteForListResponse {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class RouteGetListQuery extends PageListByDto implements IRouteGetListQuery {

    constructor(data?: IRouteGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RouteGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRouteGetListQuery extends IPageListByDto {
}

export class RouteForEditResponse implements IRouteForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IRouteForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RouteForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRouteForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class RouteGetForEditQuery implements IRouteGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IRouteGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RouteGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRouteGetForEditQuery {
    id?: number | undefined;
}

export class RouteGetComboQuery implements IRouteGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IRouteGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RouteGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRouteGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class RouteCreateCommand implements IRouteCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IRouteCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RouteCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RouteCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRouteCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class RouteUpdateCommand implements IRouteUpdateCommand {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IRouteUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RouteUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RouteUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRouteUpdateCommand {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class SettingClientChangeCommand implements ISettingClientChangeCommand {
    id!: number;
    clientType?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISettingClientChangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientType = _data["clientType"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SettingClientChangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SettingClientChangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientType"] = this.clientType;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISettingClientChangeCommand {
    id: number;
    clientType?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
}

export class PagedResultDtoOfSupplyCardRouteForListResponse implements IPagedResultDtoOfSupplyCardRouteForListResponse {
    totalCount!: number;
    items?: SupplyCardRouteForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfSupplyCardRouteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SupplyCardRouteForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSupplyCardRouteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSupplyCardRouteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSupplyCardRouteForListResponse {
    totalCount: number;
    items?: SupplyCardRouteForListResponse[] | undefined;
}

export class SupplyCardRouteForListResponse implements ISupplyCardRouteForListResponse {
    id!: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ISupplyCardRouteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationDesc = _data["locationDesc"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): SupplyCardRouteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationDesc"] = this.locationDesc;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ISupplyCardRouteForListResponse {
    id: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class SupplyCardRouteGetListQuery extends PageListByDto implements ISupplyCardRouteGetListQuery {

    constructor(data?: ISupplyCardRouteGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SupplyCardRouteGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISupplyCardRouteGetListQuery extends IPageListByDto {
}

export class SupplyCardRouteForEditResponse implements ISupplyCardRouteForEditResponse {
    id?: number | undefined;
    location!: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    locationCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: ISupplyCardRouteForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.locationDesc = _data["locationDesc"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["locationCombo"])) {
                this.locationCombo = [] as any;
                for (let item of _data["locationCombo"])
                    this.locationCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplyCardRouteForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["locationDesc"] = this.locationDesc;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.locationCombo)) {
            data["locationCombo"] = [];
            for (let item of this.locationCombo)
                data["locationCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplyCardRouteForEditResponse {
    id?: number | undefined;
    location: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    locationCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class SupplyCardRouteGetForEditQuery implements ISupplyCardRouteGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ISupplyCardRouteGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplyCardRouteGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISupplyCardRouteGetForEditQuery {
    id?: number | undefined;
}

export class SupplyCardRouteGetComboQuery implements ISupplyCardRouteGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ISupplyCardRouteGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SupplyCardRouteGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISupplyCardRouteGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class SupplyCardRouteCreateCommand implements ISupplyCardRouteCreateCommand {
    location!: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ISupplyCardRouteCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SupplyCardRouteCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISupplyCardRouteCreateCommand {
    location: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class SupplyCardRouteUpdateCommand implements ISupplyCardRouteUpdateCommand {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ISupplyCardRouteUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SupplyCardRouteUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISupplyCardRouteUpdateCommand {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class SupplyCardRouteResponse implements ISupplyCardRouteResponse {
    id?: number | undefined;
    location!: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ISupplyCardRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.locationDesc = _data["locationDesc"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SupplyCardRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["locationDesc"] = this.locationDesc;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISupplyCardRouteResponse {
    id?: number | undefined;
    location: number;
    locationDesc?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class SupplyCardRouteGetByIdQuery implements ISupplyCardRouteGetByIdQuery {
    id!: number;

    constructor(data?: ISupplyCardRouteGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplyCardRouteGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISupplyCardRouteGetByIdQuery {
    id: number;
}

export class SupplyCardRouteStartCommand implements ISupplyCardRouteStartCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;

    constructor(data?: ISupplyCardRouteStartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
        }
    }

    static fromJS(data: any): SupplyCardRouteStartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteStartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        return data;
    }
}

export interface ISupplyCardRouteStartCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
}

export class SupplyCardRouteFinishCommand implements ISupplyCardRouteFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;

    constructor(data?: ISupplyCardRouteFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
        }
    }

    static fromJS(data: any): SupplyCardRouteFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardRouteFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        return data;
    }
}

export interface ISupplyCardRouteFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
}

export class TenantResponse implements ITenantResponse {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive!: boolean;
    isDeleted!: boolean;

    constructor(data?: ITenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITenantResponse {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
}

export class TenantCreateCommand implements ITenantCreateCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ITenantCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.tenantName = _data["tenantName"];
            this.password = _data["password"];
            this.passwordConfirm = _data["passwordConfirm"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["tenantName"] = this.tenantName;
        data["password"] = this.password;
        data["passwordConfirm"] = this.passwordConfirm;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantCreateCommand {
    tenancyName?: string | undefined;
    tenantName?: string | undefined;
    password?: string | undefined;
    passwordConfirm?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTenantCommand {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfTenantListResponse implements IPagedResultDtoOfTenantListResponse {
    totalCount!: number;
    items?: TenantListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListResponse {
    totalCount: number;
    items?: TenantListResponse[] | undefined;
}

export class TenantListResponse implements ITenantListResponse {
    id!: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: ITenantListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.largeName = _data["largeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): TenantListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["largeName"] = this.largeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ITenantListResponse {
    id: number;
    tenancyName?: string | undefined;
    name?: string | undefined;
    largeName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class TenantGetListQuery extends PageListByDto implements ITenantGetListQuery {

    constructor(data?: ITenantGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TenantGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITenantGetListQuery extends IPageListByDto {
}

export class TenantGetListCompleterQuery implements ITenantGetListCompleterQuery {
    filter?: string | undefined;

    constructor(data?: ITenantGetListCompleterQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): TenantGetListCompleterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGetListCompleterQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface ITenantGetListCompleterQuery {
    filter?: string | undefined;
}

export class TenantDeleteCommand implements ITenantDeleteCommand {
    id!: number;

    constructor(data?: ITenantDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantDeleteCommand {
    id: number;
}

export class TenantSettingsForEditResponse implements ITenantSettingsForEditResponse {
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: TenantSettingsPasswordComplexityResponse | undefined;
    enablePasswordReuseValidation!: boolean;
    passwordReuseDays?: number | undefined;
    passwordValidDays!: number;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    preventConcurrentSesions!: boolean;
    userBlockingDuration!: number;
    mfaFailedAttemptsToBlockUser!: number;
    mfaUserBlockingDuration!: number;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod!: EmailSendMethod;
    grpcEmail?: GrpcEmailResponse | undefined;
    downloadJitEmptyMax?: number | undefined;
    enablePasswordChangeReminder!: boolean;
    passwordChangeReminderDays?: number | undefined;
    authenticationCodeValidityDays!: number;
    authenticationCodeExpirationMinutes!: number;
    configuracionPDF?: string | undefined;
    smsActive!: boolean;
    smsCountryCode?: string | undefined;
    smsRegionCode?: string | undefined;
    awsIdentityPoolId?: string | undefined;
    awsCognitoRegion?: string | undefined;
    awsSnsRegion?: string | undefined;

    constructor(data?: ITenantSettingsForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? TenantSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.passwordComplexityDefault = _data["passwordComplexityDefault"] ? TenantSettingsPasswordComplexityResponse.fromJS(_data["passwordComplexityDefault"]) : <any>undefined;
            this.enablePasswordReuseValidation = _data["enablePasswordReuseValidation"];
            this.passwordReuseDays = _data["passwordReuseDays"];
            this.passwordValidDays = _data["passwordValidDays"];
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.preventConcurrentSesions = _data["preventConcurrentSesions"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.mfaFailedAttemptsToBlockUser = _data["mfaFailedAttemptsToBlockUser"];
            this.mfaUserBlockingDuration = _data["mfaUserBlockingDuration"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.emailSendMethod = _data["emailSendMethod"];
            this.grpcEmail = _data["grpcEmail"] ? GrpcEmailResponse.fromJS(_data["grpcEmail"]) : <any>undefined;
            this.downloadJitEmptyMax = _data["downloadJitEmptyMax"];
            this.enablePasswordChangeReminder = _data["enablePasswordChangeReminder"];
            this.passwordChangeReminderDays = _data["passwordChangeReminderDays"];
            this.authenticationCodeValidityDays = _data["authenticationCodeValidityDays"];
            this.authenticationCodeExpirationMinutes = _data["authenticationCodeExpirationMinutes"];
            this.configuracionPDF = _data["configuracionPDF"];
            this.smsActive = _data["smsActive"];
            this.smsCountryCode = _data["smsCountryCode"];
            this.smsRegionCode = _data["smsRegionCode"];
            this.awsIdentityPoolId = _data["awsIdentityPoolId"];
            this.awsCognitoRegion = _data["awsCognitoRegion"];
            this.awsSnsRegion = _data["awsSnsRegion"];
        }
    }

    static fromJS(data: any): TenantSettingsForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["passwordComplexityDefault"] = this.passwordComplexityDefault ? this.passwordComplexityDefault.toJSON() : <any>undefined;
        data["enablePasswordReuseValidation"] = this.enablePasswordReuseValidation;
        data["passwordReuseDays"] = this.passwordReuseDays;
        data["passwordValidDays"] = this.passwordValidDays;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["preventConcurrentSesions"] = this.preventConcurrentSesions;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["mfaFailedAttemptsToBlockUser"] = this.mfaFailedAttemptsToBlockUser;
        data["mfaUserBlockingDuration"] = this.mfaUserBlockingDuration;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["emailSendMethod"] = this.emailSendMethod;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        data["downloadJitEmptyMax"] = this.downloadJitEmptyMax;
        data["enablePasswordChangeReminder"] = this.enablePasswordChangeReminder;
        data["passwordChangeReminderDays"] = this.passwordChangeReminderDays;
        data["authenticationCodeValidityDays"] = this.authenticationCodeValidityDays;
        data["authenticationCodeExpirationMinutes"] = this.authenticationCodeExpirationMinutes;
        data["configuracionPDF"] = this.configuracionPDF;
        data["smsActive"] = this.smsActive;
        data["smsCountryCode"] = this.smsCountryCode;
        data["smsRegionCode"] = this.smsRegionCode;
        data["awsIdentityPoolId"] = this.awsIdentityPoolId;
        data["awsCognitoRegion"] = this.awsCognitoRegion;
        data["awsSnsRegion"] = this.awsSnsRegion;
        return data;
    }
}

export interface ITenantSettingsForEditResponse {
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityResponse | undefined;
    passwordComplexityDefault?: TenantSettingsPasswordComplexityResponse | undefined;
    enablePasswordReuseValidation: boolean;
    passwordReuseDays?: number | undefined;
    passwordValidDays: number;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    preventConcurrentSesions: boolean;
    userBlockingDuration: number;
    mfaFailedAttemptsToBlockUser: number;
    mfaUserBlockingDuration: number;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    emailSendMethod: EmailSendMethod;
    grpcEmail?: GrpcEmailResponse | undefined;
    downloadJitEmptyMax?: number | undefined;
    enablePasswordChangeReminder: boolean;
    passwordChangeReminderDays?: number | undefined;
    authenticationCodeValidityDays: number;
    authenticationCodeExpirationMinutes: number;
    configuracionPDF?: string | undefined;
    smsActive: boolean;
    smsCountryCode?: string | undefined;
    smsRegionCode?: string | undefined;
    awsIdentityPoolId?: string | undefined;
    awsCognitoRegion?: string | undefined;
    awsSnsRegion?: string | undefined;
}

export class TenantSettingsPasswordComplexityResponse implements ITenantSettingsPasswordComplexityResponse {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;
    avoidSequence!: boolean;

    constructor(data?: ITenantSettingsPasswordComplexityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
            this.avoidSequence = _data["avoidSequence"];
        }
    }

    static fromJS(data: any): TenantSettingsPasswordComplexityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsPasswordComplexityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        data["avoidSequence"] = this.avoidSequence;
        return data;
    }
}

export interface ITenantSettingsPasswordComplexityResponse {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
    avoidSequence: boolean;
}

export class GrpcEmailResponse implements IGrpcEmailResponse {
    sendConfiguration!: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IGrpcEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendConfiguration = _data["sendConfiguration"];
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GrpcEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrpcEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendConfiguration"] = this.sendConfiguration;
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IGrpcEmailResponse {
    sendConfiguration: boolean;
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class TenantSettingsGetForEditQuery implements ITenantSettingsGetForEditQuery {

    constructor(data?: ITenantSettingsGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TenantSettingsGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITenantSettingsGetForEditQuery {
}

export class TenantSettingsUpdateCommand implements ITenantSettingsUpdateCommand {
    passwordUseDefaultConfiguration!: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityCommand | undefined;
    enablePasswordReuseValidation!: boolean;
    passwordReuseDays?: number | undefined;
    passwordValidDays!: number;
    enableUserBlocking!: boolean;
    failedAttemptsToBlockUser!: number;
    userBlockingDuration!: number;
    mfaFailedAttemptsToBlockUser!: number;
    mfaUserBlockingDuration!: number;
    preventConcurrentSesions!: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL!: boolean;
    mailUseDefaultCredentials!: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: GrpcEmailCommand | undefined;
    downloadJitEmptyMax?: number | undefined;
    enablePasswordChangeReminder!: boolean;
    passwordChangeReminderDays?: number | undefined;
    authenticationCodeValidityDays!: number;
    authenticationCodeExpirationMinutes!: number;
    // PDF Configuration
    configuracionPDF?: string | undefined;
    // SMS Settings
    smsActive!: boolean;
    smsCountryCode?: string | undefined;
    smsRegionCode?: string | undefined;
    awsIdentityPoolId?: string | undefined;
    awsCognitoRegion?: string | undefined;
    awsSnsRegion?: string | undefined;

    constructor(data?: ITenantSettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordUseDefaultConfiguration = _data["passwordUseDefaultConfiguration"];
            this.passwordComplexity = _data["passwordComplexity"] ? TenantSettingsPasswordComplexityCommand.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.enablePasswordReuseValidation = _data["enablePasswordReuseValidation"];
            this.passwordReuseDays = _data["passwordReuseDays"];
            this.passwordValidDays = _data["passwordValidDays"];
            this.enableUserBlocking = _data["enableUserBlocking"];
            this.failedAttemptsToBlockUser = _data["failedAttemptsToBlockUser"];
            this.userBlockingDuration = _data["userBlockingDuration"];
            this.mfaFailedAttemptsToBlockUser = _data["mfaFailedAttemptsToBlockUser"];
            this.mfaUserBlockingDuration = _data["mfaUserBlockingDuration"];
            this.preventConcurrentSesions = _data["preventConcurrentSesions"];
            this.mailSMTPSenderDefault = _data["mailSMTPSenderDefault"];
            this.mailSMTPSenderDefaultDisplayName = _data["mailSMTPSenderDefaultDisplayName"];
            this.mailSMTPHost = _data["mailSMTPHost"];
            this.mailSMTPPort = _data["mailSMTPPort"];
            this.mailEnableSSL = _data["mailEnableSSL"];
            this.mailUseDefaultCredentials = _data["mailUseDefaultCredentials"];
            this.mailDomainName = _data["mailDomainName"];
            this.mailUserName = _data["mailUserName"];
            this.mailUserPassword = _data["mailUserPassword"];
            this.grpcEmail = _data["grpcEmail"] ? GrpcEmailCommand.fromJS(_data["grpcEmail"]) : <any>undefined;
            this.downloadJitEmptyMax = _data["downloadJitEmptyMax"];
            this.enablePasswordChangeReminder = _data["enablePasswordChangeReminder"];
            this.passwordChangeReminderDays = _data["passwordChangeReminderDays"];
            this.authenticationCodeValidityDays = _data["authenticationCodeValidityDays"];
            this.authenticationCodeExpirationMinutes = _data["authenticationCodeExpirationMinutes"];
            // PDF Configuration
            this.configuracionPDF = _data["configuracionPDF"];
            // SMS Settings
            this.smsActive = _data["smsActive"];
            this.smsCountryCode = _data["smsCountryCode"];
            this.smsRegionCode = _data["smsRegionCode"];
            this.awsIdentityPoolId = _data["awsIdentityPoolId"];
            this.awsCognitoRegion = _data["awsCognitoRegion"];
            this.awsSnsRegion = _data["awsSnsRegion"];
        }
    }

    static fromJS(data: any): TenantSettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordUseDefaultConfiguration"] = this.passwordUseDefaultConfiguration;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["enablePasswordReuseValidation"] = this.enablePasswordReuseValidation;
        data["passwordReuseDays"] = this.passwordReuseDays;
        data["passwordValidDays"] = this.passwordValidDays;
        data["enableUserBlocking"] = this.enableUserBlocking;
        data["failedAttemptsToBlockUser"] = this.failedAttemptsToBlockUser;
        data["userBlockingDuration"] = this.userBlockingDuration;
        data["mfaFailedAttemptsToBlockUser"] = this.mfaFailedAttemptsToBlockUser;
        data["mfaUserBlockingDuration"] = this.mfaUserBlockingDuration;
        data["preventConcurrentSesions"] = this.preventConcurrentSesions;
        data["mailSMTPSenderDefault"] = this.mailSMTPSenderDefault;
        data["mailSMTPSenderDefaultDisplayName"] = this.mailSMTPSenderDefaultDisplayName;
        data["mailSMTPHost"] = this.mailSMTPHost;
        data["mailSMTPPort"] = this.mailSMTPPort;
        data["mailEnableSSL"] = this.mailEnableSSL;
        data["mailUseDefaultCredentials"] = this.mailUseDefaultCredentials;
        data["mailDomainName"] = this.mailDomainName;
        data["mailUserName"] = this.mailUserName;
        data["mailUserPassword"] = this.mailUserPassword;
        data["grpcEmail"] = this.grpcEmail ? this.grpcEmail.toJSON() : <any>undefined;
        data["downloadJitEmptyMax"] = this.downloadJitEmptyMax;
        data["enablePasswordChangeReminder"] = this.enablePasswordChangeReminder;
        data["passwordChangeReminderDays"] = this.passwordChangeReminderDays;
        data["authenticationCodeValidityDays"] = this.authenticationCodeValidityDays;
        data["authenticationCodeExpirationMinutes"] = this.authenticationCodeExpirationMinutes;
        // PDF Configuration
        data["configuracionPDF"] = this.configuracionPDF;
        // SMS Settings
        data["smsActive"] = this.smsActive;
        data["smsCountryCode"] = this.smsCountryCode;
        data["smsRegionCode"] = this.smsRegionCode;
        data["awsIdentityPoolId"] = this.awsIdentityPoolId;
        data["awsCognitoRegion"] = this.awsCognitoRegion;
        data["awsSnsRegion"] = this.awsSnsRegion;
        return data;
    }
}

export interface ITenantSettingsUpdateCommand {
    passwordUseDefaultConfiguration: boolean;
    passwordComplexity?: TenantSettingsPasswordComplexityCommand | undefined;
    enablePasswordReuseValidation: boolean;
    passwordReuseDays?: number | undefined;
    passwordValidDays: number;
    enableUserBlocking: boolean;
    failedAttemptsToBlockUser: number;
    userBlockingDuration: number;
    mfaFailedAttemptsToBlockUser: number;
    mfaUserBlockingDuration: number;
    preventConcurrentSesions: boolean;
    mailSMTPSenderDefault?: string | undefined;
    mailSMTPSenderDefaultDisplayName?: string | undefined;
    mailSMTPHost?: string | undefined;
    mailSMTPPort?: number | undefined;
    mailEnableSSL: boolean;
    mailUseDefaultCredentials: boolean;
    mailDomainName?: string | undefined;
    mailUserName?: string | undefined;
    mailUserPassword?: string | undefined;
    grpcEmail?: GrpcEmailCommand | undefined;
    downloadJitEmptyMax?: number | undefined;
    enablePasswordChangeReminder: boolean;
    passwordChangeReminderDays?: number | undefined;
    authenticationCodeValidityDays: number;
    authenticationCodeExpirationMinutes: number;
    // PDF Configuration
    configuracionPDF?: string | undefined;
    // SMS Settings
    smsActive: boolean;
    smsCountryCode?: string | undefined;
    smsRegionCode?: string | undefined;
    awsIdentityPoolId?: string | undefined;
    awsCognitoRegion?: string | undefined;
    awsSnsRegion?: string | undefined;
}

export class TenantSettingsPasswordComplexityCommand implements ITenantSettingsPasswordComplexityCommand {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;
    avoidSequence!: boolean;

    constructor(data?: ITenantSettingsPasswordComplexityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
            this.avoidSequence = _data["avoidSequence"];
        }
    }

    static fromJS(data: any): TenantSettingsPasswordComplexityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsPasswordComplexityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        data["avoidSequence"] = this.avoidSequence;
        return data;
    }
}

export interface ITenantSettingsPasswordComplexityCommand {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
    avoidSequence: boolean;
}

export class GrpcEmailCommand implements IGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IGrpcEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GrpcEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrpcEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IGrpcEmailCommand {
    tenancyName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class TenantSettingsSendTestEmailCommand implements ITenantSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;

    constructor(data?: ITenantSettingsSendTestEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TenantSettingsSendTestEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsSendTestEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITenantSettingsSendTestEmailCommand {
    emailAddress?: string | undefined;
}

export class TenantSettingsMobileResponse implements ITenantSettingsMobileResponse {
    downloadJitEmptyMax!: number;

    constructor(data?: ITenantSettingsMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadJitEmptyMax = _data["downloadJitEmptyMax"];
        }
    }

    static fromJS(data: any): TenantSettingsMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadJitEmptyMax"] = this.downloadJitEmptyMax;
        return data;
    }
}

export interface ITenantSettingsMobileResponse {
    downloadJitEmptyMax: number;
}

export class SupplyCardsSettingsForEditResponse implements ISupplyCardsSettingsForEditResponse {
    locationSmallPieces?: number | undefined;
    locationCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: ISupplyCardsSettingsForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationSmallPieces = _data["locationSmallPieces"];
            if (Array.isArray(_data["locationCombo"])) {
                this.locationCombo = [] as any;
                for (let item of _data["locationCombo"])
                    this.locationCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplyCardsSettingsForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardsSettingsForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationSmallPieces"] = this.locationSmallPieces;
        if (Array.isArray(this.locationCombo)) {
            data["locationCombo"] = [];
            for (let item of this.locationCombo)
                data["locationCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplyCardsSettingsForEditResponse {
    locationSmallPieces?: number | undefined;
    locationCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class SupplyCardsSettingsGetForEditQuery implements ISupplyCardsSettingsGetForEditQuery {

    constructor(data?: ISupplyCardsSettingsGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SupplyCardsSettingsGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardsSettingsGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISupplyCardsSettingsGetForEditQuery {
}

export class SupplyCardsSettingsResponse implements ISupplyCardsSettingsResponse {
    locationSmallPieces?: number | undefined;

    constructor(data?: ISupplyCardsSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationSmallPieces = _data["locationSmallPieces"];
        }
    }

    static fromJS(data: any): SupplyCardsSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardsSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationSmallPieces"] = this.locationSmallPieces;
        return data;
    }
}

export interface ISupplyCardsSettingsResponse {
    locationSmallPieces?: number | undefined;
}

export class SupplyCardsSettingsUpdateCommand implements ISupplyCardsSettingsUpdateCommand {
    locationSmallPieces!: number;

    constructor(data?: ISupplyCardsSettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationSmallPieces = _data["locationSmallPieces"];
        }
    }

    static fromJS(data: any): SupplyCardsSettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardsSettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationSmallPieces"] = this.locationSmallPieces;
        return data;
    }
}

export interface ISupplyCardsSettingsUpdateCommand {
    locationSmallPieces: number;
}

export class MaterialDetailUploadForListResponse implements IMaterialDetailUploadForListResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    userDesc?: string | undefined;
    muBoxNumber?: string | undefined;
    muShipmentNumber?: string | undefined;
    muPlatformDesc?: string | undefined;
    muPlatformKey?: string | undefined;
    muVehicleStatus?: string | undefined;
    muDownloadDateTime?: moment.Moment | undefined;
    muCreationDateTime?: moment.Moment | undefined;
    muArrivalTime?: moment.Moment | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    supplierKey?: string | undefined;
    critic?: number | undefined;
    isCritic!: boolean;
    totalParts!: number;
    totalDownloadedParts?: number | undefined;
    container?: number | undefined;
    shipDays?: number | undefined;

    constructor(data?: IMaterialDetailUploadForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialUpload = _data["materialUpload"];
            this.userDesc = _data["userDesc"];
            this.muBoxNumber = _data["muBoxNumber"];
            this.muShipmentNumber = _data["muShipmentNumber"];
            this.muPlatformDesc = _data["muPlatformDesc"];
            this.muPlatformKey = _data["muPlatformKey"];
            this.muVehicleStatus = _data["muVehicleStatus"];
            this.muDownloadDateTime = _data["muDownloadDateTime"] ? moment(_data["muDownloadDateTime"].toString()) : <any>undefined;
            this.muCreationDateTime = _data["muCreationDateTime"] ? moment(_data["muCreationDateTime"].toString()) : <any>undefined;
            this.muArrivalTime = _data["muArrivalTime"] ? moment(_data["muArrivalTime"].toString()) : <any>undefined;
            this.partBase = _data["partBase"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.supplierKey = _data["supplierKey"];
            this.critic = _data["critic"];
            this.isCritic = _data["isCritic"];
            this.totalParts = _data["totalParts"];
            this.totalDownloadedParts = _data["totalDownloadedParts"];
            this.container = _data["container"];
            this.shipDays = _data["shipDays"];
        }
    }

    static fromJS(data: any): MaterialDetailUploadForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDetailUploadForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialUpload"] = this.materialUpload;
        data["userDesc"] = this.userDesc;
        data["muBoxNumber"] = this.muBoxNumber;
        data["muShipmentNumber"] = this.muShipmentNumber;
        data["muPlatformDesc"] = this.muPlatformDesc;
        data["muPlatformKey"] = this.muPlatformKey;
        data["muVehicleStatus"] = this.muVehicleStatus;
        data["muDownloadDateTime"] = this.muDownloadDateTime ? this.muDownloadDateTime.toISOString() : <any>undefined;
        data["muCreationDateTime"] = this.muCreationDateTime ? this.muCreationDateTime.toISOString() : <any>undefined;
        data["muArrivalTime"] = this.muArrivalTime ? this.muArrivalTime.toISOString() : <any>undefined;
        data["partBase"] = this.partBase;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["supplierKey"] = this.supplierKey;
        data["critic"] = this.critic;
        data["isCritic"] = this.isCritic;
        data["totalParts"] = this.totalParts;
        data["totalDownloadedParts"] = this.totalDownloadedParts;
        data["container"] = this.container;
        data["shipDays"] = this.shipDays;
        return data;
    }
}

export interface IMaterialDetailUploadForListResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    userDesc?: string | undefined;
    muBoxNumber?: string | undefined;
    muShipmentNumber?: string | undefined;
    muPlatformDesc?: string | undefined;
    muPlatformKey?: string | undefined;
    muVehicleStatus?: string | undefined;
    muDownloadDateTime?: moment.Moment | undefined;
    muCreationDateTime?: moment.Moment | undefined;
    muArrivalTime?: moment.Moment | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    supplierKey?: string | undefined;
    critic?: number | undefined;
    isCritic: boolean;
    totalParts: number;
    totalDownloadedParts?: number | undefined;
    container?: number | undefined;
    shipDays?: number | undefined;
}

export class MaterialUploadDeleteCommand implements IMaterialUploadDeleteCommand {
    ids?: number[] | undefined;

    constructor(data?: IMaterialUploadDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): MaterialUploadDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialUploadDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IMaterialUploadDeleteCommand {
    ids?: number[] | undefined;
}

export class UploadResultResponse implements IUploadResultResponse {
    succesfullRecords?: MaterialDetailUploadForListResponse[] | undefined;
    errors?: LogUploadErrorForListResponse[] | undefined;

    constructor(data?: IUploadResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["succesfullRecords"])) {
                this.succesfullRecords = [] as any;
                for (let item of _data["succesfullRecords"])
                    this.succesfullRecords!.push(MaterialDetailUploadForListResponse.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(LogUploadErrorForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.succesfullRecords)) {
            data["succesfullRecords"] = [];
            for (let item of this.succesfullRecords)
                data["succesfullRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadResultResponse {
    succesfullRecords?: MaterialDetailUploadForListResponse[] | undefined;
    errors?: LogUploadErrorForListResponse[] | undefined;
}

export class LogUploadErrorForListResponse implements ILogUploadErrorForListResponse {
    id?: number | undefined;
    userDesc?: string | undefined;
    dateTime?: moment.Moment | undefined;
    description?: string | undefined;

    constructor(data?: ILogUploadErrorForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDesc = _data["userDesc"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LogUploadErrorForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LogUploadErrorForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDesc"] = this.userDesc;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ILogUploadErrorForListResponse {
    id?: number | undefined;
    userDesc?: string | undefined;
    dateTime?: moment.Moment | undefined;
    description?: string | undefined;
}

export class UploadCampusCommand implements IUploadCampusCommand {
    base64?: string | undefined;

    constructor(data?: IUploadCampusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): UploadCampusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IUploadCampusCommand {
    base64?: string | undefined;
}

export class PagedResultDtoOfLogUploadErrorForListResponse implements IPagedResultDtoOfLogUploadErrorForListResponse {
    totalCount!: number;
    items?: LogUploadErrorForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfLogUploadErrorForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LogUploadErrorForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLogUploadErrorForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLogUploadErrorForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLogUploadErrorForListResponse {
    totalCount: number;
    items?: LogUploadErrorForListResponse[] | undefined;
}

export class UploadLogErrorCampusGetListQuery extends PageListByDto implements IUploadLogErrorCampusGetListQuery {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: IUploadLogErrorCampusGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadLogErrorCampusGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLogErrorCampusGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadLogErrorCampusGetListQuery extends IPageListByDto {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class PagedResultDtoOfMaterialDetailUploadForListResponse implements IPagedResultDtoOfMaterialDetailUploadForListResponse {
    totalCount!: number;
    items?: MaterialDetailUploadForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMaterialDetailUploadForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaterialDetailUploadForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMaterialDetailUploadForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMaterialDetailUploadForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMaterialDetailUploadForListResponse {
    totalCount: number;
    items?: MaterialDetailUploadForListResponse[] | undefined;
}

export class UploadMaterialDetailCampusGetListQuery extends PageListByDto implements IUploadMaterialDetailCampusGetListQuery {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: IUploadMaterialDetailCampusGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadMaterialDetailCampusGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMaterialDetailCampusGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadMaterialDetailCampusGetListQuery extends IPageListByDto {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class UploadCampusForListResponse implements IUploadCampusForListResponse {
    id!: number;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    estatus?: MaterialUploadStatus | undefined;

    constructor(data?: IUploadCampusForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anden = _data["anden"];
            this.andenDesc = _data["andenDesc"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): UploadCampusForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anden"] = this.anden;
        data["andenDesc"] = this.andenDesc;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IUploadCampusForListResponse {
    id: number;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    estatus?: MaterialUploadStatus | undefined;
}

export class UploadCampusGetPendingListQuery implements IUploadCampusGetPendingListQuery {
    anden?: number | undefined;
    numeroCaja?: string | undefined;

    constructor(data?: IUploadCampusGetPendingListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anden = _data["anden"];
            this.numeroCaja = _data["numeroCaja"];
        }
    }

    static fromJS(data: any): UploadCampusGetPendingListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusGetPendingListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anden"] = this.anden;
        data["numeroCaja"] = this.numeroCaja;
        return data;
    }
}

export interface IUploadCampusGetPendingListQuery {
    anden?: number | undefined;
    numeroCaja?: string | undefined;
}

export class UploadCampusResponse implements IUploadCampusResponse {
    id?: number | undefined;
    user?: number | undefined;
    lastDownload?: number | undefined;
    platform?: number | undefined;
    platformDesc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    detailList?: UploadCampusDetailResponse[] | undefined;

    constructor(data?: IUploadCampusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.lastDownload = _data["lastDownload"];
            this.platform = _data["platform"];
            this.platformDesc = _data["platformDesc"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["detailList"])) {
                this.detailList = [] as any;
                for (let item of _data["detailList"])
                    this.detailList!.push(UploadCampusDetailResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadCampusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["lastDownload"] = this.lastDownload;
        data["platform"] = this.platform;
        data["platformDesc"] = this.platformDesc;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        data["status"] = this.status;
        if (Array.isArray(this.detailList)) {
            data["detailList"] = [];
            for (let item of this.detailList)
                data["detailList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadCampusResponse {
    id?: number | undefined;
    user?: number | undefined;
    lastDownload?: number | undefined;
    platform?: number | undefined;
    platformDesc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    detailList?: UploadCampusDetailResponse[] | undefined;
}

export class UploadCampusDetailResponse implements IUploadCampusDetailResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    totalParts!: number;
    totalDownloadedParts?: number | undefined;
    status?: MaterialDetailUploadStatus | undefined;

    constructor(data?: IUploadCampusDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialUpload = _data["materialUpload"];
            this.part = _data["part"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.totalParts = _data["totalParts"];
            this.totalDownloadedParts = _data["totalDownloadedParts"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UploadCampusDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialUpload"] = this.materialUpload;
        data["part"] = this.part;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["totalParts"] = this.totalParts;
        data["totalDownloadedParts"] = this.totalDownloadedParts;
        data["status"] = this.status;
        return data;
    }
}

export interface IUploadCampusDetailResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    totalParts: number;
    totalDownloadedParts?: number | undefined;
    status?: MaterialDetailUploadStatus | undefined;
}

export enum MaterialDetailUploadStatus {
    Pending = 1,
    Partial = 2,
    Complete = 3,
}

export class UploadCampusGetByIdQuery implements IUploadCampusGetByIdQuery {
    id!: number;

    constructor(data?: IUploadCampusGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UploadCampusGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCampusGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUploadCampusGetByIdQuery {
    id: number;
}

export class UploadInboundCommand implements IUploadInboundCommand {
    base64?: string | undefined;

    constructor(data?: IUploadInboundCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): UploadInboundCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IUploadInboundCommand {
    base64?: string | undefined;
}

export class UploadLogErrorInboundGetListQuery extends PageListByDto implements IUploadLogErrorInboundGetListQuery {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: IUploadLogErrorInboundGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadLogErrorInboundGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLogErrorInboundGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadLogErrorInboundGetListQuery extends IPageListByDto {
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class UploadMaterialDetailInboundGetListQuery extends PageListByDto implements IUploadMaterialDetailInboundGetListQuery {
    materialUpload?: number | undefined;
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;

    constructor(data?: IUploadMaterialDetailInboundGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.materialUpload = _data["materialUpload"];
            this.initialDate = _data["initialDate"] ? moment(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? moment(_data["finalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadMaterialDetailInboundGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMaterialDetailInboundGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialUpload"] = this.materialUpload;
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadMaterialDetailInboundGetListQuery extends IPageListByDto {
    materialUpload?: number | undefined;
    initialDate?: moment.Moment | undefined;
    finalDate?: moment.Moment | undefined;
}

export class UploadInboundResponse implements IUploadInboundResponse {
    id?: number | undefined;
    user?: number | undefined;
    lastDownload?: number | undefined;
    platform?: number | undefined;
    platformDesc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    detailList?: UploadInboundDetailResponse[] | undefined;

    constructor(data?: IUploadInboundResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.lastDownload = _data["lastDownload"];
            this.platform = _data["platform"];
            this.platformDesc = _data["platformDesc"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["detailList"])) {
                this.detailList = [] as any;
                for (let item of _data["detailList"])
                    this.detailList!.push(UploadInboundDetailResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadInboundResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["lastDownload"] = this.lastDownload;
        data["platform"] = this.platform;
        data["platformDesc"] = this.platformDesc;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        data["status"] = this.status;
        if (Array.isArray(this.detailList)) {
            data["detailList"] = [];
            for (let item of this.detailList)
                data["detailList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadInboundResponse {
    id?: number | undefined;
    user?: number | undefined;
    lastDownload?: number | undefined;
    platform?: number | undefined;
    platformDesc?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    detailList?: UploadInboundDetailResponse[] | undefined;
}

export class UploadInboundDetailResponse implements IUploadInboundDetailResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    totalParts!: number;
    totalDownloadedParts?: number | undefined;
    status?: MaterialDetailUploadStatus | undefined;
    isCritic!: boolean;

    constructor(data?: IUploadInboundDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialUpload = _data["materialUpload"];
            this.part = _data["part"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.totalParts = _data["totalParts"];
            this.totalDownloadedParts = _data["totalDownloadedParts"];
            this.status = _data["status"];
            this.isCritic = _data["isCritic"];
        }
    }

    static fromJS(data: any): UploadInboundDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialUpload"] = this.materialUpload;
        data["part"] = this.part;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["totalParts"] = this.totalParts;
        data["totalDownloadedParts"] = this.totalDownloadedParts;
        data["status"] = this.status;
        data["isCritic"] = this.isCritic;
        return data;
    }
}

export interface IUploadInboundDetailResponse {
    id?: number | undefined;
    materialUpload?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    totalParts: number;
    totalDownloadedParts?: number | undefined;
    status?: MaterialDetailUploadStatus | undefined;
    isCritic: boolean;
}

export class UploadInboundGetByDownloadScheduleQuery implements IUploadInboundGetByDownloadScheduleQuery {
    id!: number;
    downloadSchedule!: number;

    constructor(data?: IUploadInboundGetByDownloadScheduleQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downloadSchedule = _data["downloadSchedule"];
        }
    }

    static fromJS(data: any): UploadInboundGetByDownloadScheduleQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundGetByDownloadScheduleQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downloadSchedule"] = this.downloadSchedule;
        return data;
    }
}

export interface IUploadInboundGetByDownloadScheduleQuery {
    id: number;
    downloadSchedule: number;
}

export class UploadInboundForListResponse implements IUploadInboundForListResponse {
    id!: number;
    platform?: number | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    carrierKey?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    lastDownloadType?: DownloadTipo | undefined;

    constructor(data?: IUploadInboundForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.platformKey = _data["platformKey"];
            this.boxNumber = _data["boxNumber"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.carrierKey = _data["carrierKey"];
            this.status = _data["status"];
            this.lastDownloadType = _data["lastDownloadType"];
        }
    }

    static fromJS(data: any): UploadInboundForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["platformKey"] = this.platformKey;
        data["boxNumber"] = this.boxNumber;
        data["shipmentNumber"] = this.shipmentNumber;
        data["carrierKey"] = this.carrierKey;
        data["status"] = this.status;
        data["lastDownloadType"] = this.lastDownloadType;
        return data;
    }
}

export interface IUploadInboundForListResponse {
    id: number;
    platform?: number | undefined;
    platformKey?: string | undefined;
    boxNumber?: string | undefined;
    shipmentNumber?: string | undefined;
    carrierKey?: string | undefined;
    status?: MaterialUploadStatus | undefined;
    lastDownloadType?: DownloadTipo | undefined;
}

export class UploadInboundGetWithoutSchedulePendingListQuery implements IUploadInboundGetWithoutSchedulePendingListQuery {
    workshift!: number;
    boxNumber?: string | undefined;

    constructor(data?: IUploadInboundGetWithoutSchedulePendingListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workshift = _data["workshift"];
            this.boxNumber = _data["boxNumber"];
        }
    }

    static fromJS(data: any): UploadInboundGetWithoutSchedulePendingListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundGetWithoutSchedulePendingListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workshift"] = this.workshift;
        data["boxNumber"] = this.boxNumber;
        return data;
    }
}

export interface IUploadInboundGetWithoutSchedulePendingListQuery {
    workshift: number;
    boxNumber?: string | undefined;
}

export class UploadInboundGetWithoutScheduleQuery implements IUploadInboundGetWithoutScheduleQuery {
    workshift!: number;
    id!: number;

    constructor(data?: IUploadInboundGetWithoutScheduleQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workshift = _data["workshift"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UploadInboundGetWithoutScheduleQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UploadInboundGetWithoutScheduleQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workshift"] = this.workshift;
        data["id"] = this.id;
        return data;
    }
}

export interface IUploadInboundGetWithoutScheduleQuery {
    workshift: number;
    id: number;
}

export class UserConfigurationResponse implements IUserConfigurationResponse {
    localization?: UserLocalizationConfigResponse | undefined;
    permission?: UserPermissionConfigResponse | undefined;
    settingsClient?: { [key: string]: string; } | undefined;
    multiTenancyConfig?: MultiTenancyConfigResponse | undefined;
    passwordComplexity?: PasswordComplexityDto | undefined;

    constructor(data?: IUserConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localization = _data["localization"] ? UserLocalizationConfigResponse.fromJS(_data["localization"]) : <any>undefined;
            this.permission = _data["permission"] ? UserPermissionConfigResponse.fromJS(_data["permission"]) : <any>undefined;
            if (_data["settingsClient"]) {
                this.settingsClient = {} as any;
                for (let key in _data["settingsClient"]) {
                    if (_data["settingsClient"].hasOwnProperty(key))
                        (<any>this.settingsClient)![key] = _data["settingsClient"][key];
                }
            }
            this.multiTenancyConfig = _data["multiTenancyConfig"] ? MultiTenancyConfigResponse.fromJS(_data["multiTenancyConfig"]) : <any>undefined;
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexityDto.fromJS(_data["passwordComplexity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        if (this.settingsClient) {
            data["settingsClient"] = {};
            for (let key in this.settingsClient) {
                if (this.settingsClient.hasOwnProperty(key))
                    (<any>data["settingsClient"])[key] = this.settingsClient[key];
            }
        }
        data["multiTenancyConfig"] = this.multiTenancyConfig ? this.multiTenancyConfig.toJSON() : <any>undefined;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserConfigurationResponse {
    localization?: UserLocalizationConfigResponse | undefined;
    permission?: UserPermissionConfigResponse | undefined;
    settingsClient?: { [key: string]: string; } | undefined;
    multiTenancyConfig?: MultiTenancyConfigResponse | undefined;
    passwordComplexity?: PasswordComplexityDto | undefined;
}

export class UserLocalizationConfigResponse implements IUserLocalizationConfigResponse {
    defaultLanguage?: LanguageInfoResponse | undefined;
    currentLanguage?: LanguageInfoResponse | undefined;
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IUserLocalizationConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageInfoResponse.fromJS(_data["defaultLanguage"]) : <any>undefined;
            this.currentLanguage = _data["currentLanguage"] ? LanguageInfoResponse.fromJS(_data["currentLanguage"]) : <any>undefined;
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserLocalizationConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocalizationConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        data["currentLanguage"] = this.currentLanguage ? this.currentLanguage.toJSON() : <any>undefined;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface IUserLocalizationConfigResponse {
    defaultLanguage?: LanguageInfoResponse | undefined;
    currentLanguage?: LanguageInfoResponse | undefined;
    values?: { [key: string]: string; } | undefined;
}

export class LanguageInfoResponse implements ILanguageInfoResponse {
    name?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ILanguageInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LanguageInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ILanguageInfoResponse {
    name?: string | undefined;
    displayName?: string | undefined;
}

export class UserPermissionConfigResponse implements IUserPermissionConfigResponse {
    values?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUserPermissionConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserPermissionConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface IUserPermissionConfigResponse {
    values?: { [key: string]: boolean; } | undefined;
}

export class MultiTenancyConfigResponse implements IMultiTenancyConfigResponse {
    enabled!: boolean;
    tenancyNameDefault?: string | undefined;

    constructor(data?: IMultiTenancyConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.tenancyNameDefault = _data["tenancyNameDefault"];
        }
    }

    static fromJS(data: any): MultiTenancyConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenancyConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["tenancyNameDefault"] = this.tenancyNameDefault;
        return data;
    }
}

export interface IMultiTenancyConfigResponse {
    enabled: boolean;
    tenancyNameDefault?: string | undefined;
}

export class PasswordComplexityDto implements IPasswordComplexityDto {
    minimumLength!: number;
    maximumLength!: number;
    useNumbers!: boolean;
    useUppercase!: boolean;
    useLowercase!: boolean;
    usePunctuationSymbols!: boolean;
    avoidSequence!: boolean;

    constructor(data?: IPasswordComplexityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLength = _data["minimumLength"];
            this.maximumLength = _data["maximumLength"];
            this.useNumbers = _data["useNumbers"];
            this.useUppercase = _data["useUppercase"];
            this.useLowercase = _data["useLowercase"];
            this.usePunctuationSymbols = _data["usePunctuationSymbols"];
            this.avoidSequence = _data["avoidSequence"];
        }
    }

    static fromJS(data: any): PasswordComplexityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLength"] = this.minimumLength;
        data["maximumLength"] = this.maximumLength;
        data["useNumbers"] = this.useNumbers;
        data["useUppercase"] = this.useUppercase;
        data["useLowercase"] = this.useLowercase;
        data["usePunctuationSymbols"] = this.usePunctuationSymbols;
        data["avoidSequence"] = this.avoidSequence;
        return data;
    }
}

export interface IPasswordComplexityDto {
    minimumLength: number;
    maximumLength: number;
    useNumbers: boolean;
    useUppercase: boolean;
    useLowercase: boolean;
    usePunctuationSymbols: boolean;
    avoidSequence: boolean;
}

export class UserConfigurationGetAllQuery implements IUserConfigurationGetAllQuery {
    clientType?: string | undefined;

    constructor(data?: IUserConfigurationGetAllQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientType = _data["clientType"];
        }
    }

    static fromJS(data: any): UserConfigurationGetAllQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigurationGetAllQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientType"] = this.clientType;
        return data;
    }
}

export interface IUserConfigurationGetAllQuery {
    clientType?: string | undefined;
}

export class PagedResultDtoOfUserListResponse implements IPagedResultDtoOfUserListResponse {
    totalCount!: number;
    items?: UserListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListResponse {
    totalCount: number;
    items?: UserListResponse[] | undefined;
}

export class UserListResponse implements IUserListResponse {
    id!: number;
    login?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    userLocked?: boolean | undefined;
    userLockedDesc?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    fullName?: string | undefined;
    imei?: string | undefined;

    constructor(data?: IUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.login = _data["login"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.userLocked = _data["userLocked"];
            this.userLockedDesc = _data["userLockedDesc"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.imei = _data["imei"];
        }
    }

    static fromJS(data: any): UserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["login"] = this.login;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["userLocked"] = this.userLocked;
        data["userLockedDesc"] = this.userLockedDesc;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imei"] = this.imei;
        return data;
    }
}

export interface IUserListResponse {
    id: number;
    login?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    isEmailConfirmed?: boolean | undefined;
    userLocked?: boolean | undefined;
    userLockedDesc?: string | undefined;
    isActive?: boolean | undefined;
    isActiveDesc?: string | undefined;
    creationTime?: moment.Moment | undefined;
    fullName?: string | undefined;
    imei?: string | undefined;
}

export class UserGetListQuery extends PageListByDto implements IUserGetListQuery {
    tenant?: number | undefined;

    constructor(data?: IUserGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): UserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetListQuery extends IPageListByDto {
    tenant?: number | undefined;
}

export class UserCreateCommand implements IUserCreateCommand {
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail!: boolean;
    isNotifiesSMS!: boolean;
    isNotifiesMeansEmail!: boolean;
    isNotifiesMeansSMS!: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isActiveMFA?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    zones?: UserZoneResponse[] | undefined;

    constructor(data?: IUserCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.passwordRepeat = _data["passwordRepeat"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.isNotifiesEmail = _data["isNotifiesEmail"];
            this.isNotifiesSMS = _data["isNotifiesSMS"];
            this.isNotifiesMeansEmail = _data["isNotifiesMeansEmail"];
            this.isNotifiesMeansSMS = _data["isNotifiesMeansSMS"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isActiveMFA = _data["isActiveMFA"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(UserZoneResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["passwordRepeat"] = this.passwordRepeat;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["isNotifiesEmail"] = this.isNotifiesEmail;
        data["isNotifiesSMS"] = this.isNotifiesSMS;
        data["isNotifiesMeansEmail"] = this.isNotifiesMeansEmail;
        data["isNotifiesMeansSMS"] = this.isNotifiesMeansSMS;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isActiveMFA"] = this.isActiveMFA;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserCreateCommand {
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail: boolean;
    isNotifiesSMS: boolean;
    isNotifiesMeansEmail: boolean;
    isNotifiesMeansSMS: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isActiveMFA?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    zones?: UserZoneResponse[] | undefined;
}

export enum UserType {
    Internal = 1,
    Client = 2,
    Supplier = 3,
}

export class UserZoneResponse implements IUserZoneResponse {
    id?: number | undefined;
    user?: number | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;

    constructor(data?: IUserZoneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
        }
    }

    static fromJS(data: any): UserZoneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserZoneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        return data;
    }
}

export interface IUserZoneResponse {
    id?: number | undefined;
    user?: number | undefined;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
}

export class UserUpdateCommand implements IUserUpdateCommand {
    id!: number;
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail!: boolean;
    isNotifiesSMS!: boolean;
    isNotifiesMeansEmail!: boolean;
    isNotifiesMeansSMS!: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isActiveMFA?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    zones?: UserZoneResponse[] | undefined;

    constructor(data?: IUserUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.passwordRepeat = _data["passwordRepeat"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.isNotifiesEmail = _data["isNotifiesEmail"];
            this.isNotifiesSMS = _data["isNotifiesSMS"];
            this.isNotifiesMeansEmail = _data["isNotifiesMeansEmail"];
            this.isNotifiesMeansSMS = _data["isNotifiesMeansSMS"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isActiveMFA = _data["isActiveMFA"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(UserZoneResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["passwordRepeat"] = this.passwordRepeat;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["isNotifiesEmail"] = this.isNotifiesEmail;
        data["isNotifiesSMS"] = this.isNotifiesSMS;
        data["isNotifiesMeansEmail"] = this.isNotifiesMeansEmail;
        data["isNotifiesMeansSMS"] = this.isNotifiesMeansSMS;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isActiveMFA"] = this.isActiveMFA;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserUpdateCommand {
    id: number;
    userName?: string | undefined;
    password?: string | undefined;
    passwordRepeat?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail: boolean;
    isNotifiesSMS: boolean;
    isNotifiesMeansEmail: boolean;
    isNotifiesMeansSMS: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    isActiveMFA?: boolean | undefined;
    assignedRoleNames?: string[] | undefined;
    zones?: UserZoneResponse[] | undefined;
}

export class UserForEditResponse implements IUserForEditResponse {
    id!: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail!: boolean;
    isNotifiesSMS!: boolean;
    isNotifiesMeansEmail!: boolean;
    isNotifiesMeansSMS!: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    language?: number | undefined;
    preferences?: { [key: string]: string; } | undefined;
    isActiveMFA?: boolean | undefined;
    rolList?: UserRolResponse[] | undefined;
    zones?: UserZoneResponse[] | undefined;
    languageCombo?: ComboboxItemDto[] | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IUserForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.isNotifiesEmail = _data["isNotifiesEmail"];
            this.isNotifiesSMS = _data["isNotifiesSMS"];
            this.isNotifiesMeansEmail = _data["isNotifiesMeansEmail"];
            this.isNotifiesMeansSMS = _data["isNotifiesMeansSMS"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.language = _data["language"];
            if (_data["preferences"]) {
                this.preferences = {} as any;
                for (let key in _data["preferences"]) {
                    if (_data["preferences"].hasOwnProperty(key))
                        (<any>this.preferences)![key] = _data["preferences"][key];
                }
            }
            this.isActiveMFA = _data["isActiveMFA"];
            if (Array.isArray(_data["rolList"])) {
                this.rolList = [] as any;
                for (let item of _data["rolList"])
                    this.rolList!.push(UserRolResponse.fromJS(item));
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(UserZoneResponse.fromJS(item));
            }
            if (Array.isArray(_data["languageCombo"])) {
                this.languageCombo = [] as any;
                for (let item of _data["languageCombo"])
                    this.languageCombo!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["isNotifiesEmail"] = this.isNotifiesEmail;
        data["isNotifiesSMS"] = this.isNotifiesSMS;
        data["isNotifiesMeansEmail"] = this.isNotifiesMeansEmail;
        data["isNotifiesMeansSMS"] = this.isNotifiesMeansSMS;
        data["setRandomPassword"] = this.setRandomPassword;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["language"] = this.language;
        if (this.preferences) {
            data["preferences"] = {};
            for (let key in this.preferences) {
                if (this.preferences.hasOwnProperty(key))
                    (<any>data["preferences"])[key] = this.preferences[key];
            }
        }
        data["isActiveMFA"] = this.isActiveMFA;
        if (Array.isArray(this.rolList)) {
            data["rolList"] = [];
            for (let item of this.rolList)
                data["rolList"].push(item.toJSON());
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        if (Array.isArray(this.languageCombo)) {
            data["languageCombo"] = [];
            for (let item of this.languageCombo)
                data["languageCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserForEditResponse {
    id: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean | undefined;
    type?: UserType | undefined;
    isNotifiesEmail: boolean;
    isNotifiesSMS: boolean;
    isNotifiesMeansEmail: boolean;
    isNotifiesMeansSMS: boolean;
    setRandomPassword?: boolean | undefined;
    shouldChangePasswordOnNextLogin?: boolean | undefined;
    sendActivationEmail?: boolean | undefined;
    language?: number | undefined;
    preferences?: { [key: string]: string; } | undefined;
    isActiveMFA?: boolean | undefined;
    rolList?: UserRolResponse[] | undefined;
    zones?: UserZoneResponse[] | undefined;
    languageCombo?: ComboboxItemDto[] | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class UserRolResponse implements IUserRolResponse {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;

    constructor(data?: IUserRolResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
        }
    }

    static fromJS(data: any): UserRolResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRolResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        return data;
    }
}

export interface IUserRolResponse {
    roleId?: number | undefined;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;
}

export class UserGetForEditQuery implements IUserGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IUserGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserGetForEditQuery {
    id?: number | undefined;
}

export class UserProfileQuery implements IUserProfileQuery {
    id!: number;
    clientType?: string | undefined;

    constructor(data?: IUserProfileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientType = _data["clientType"];
        }
    }

    static fromJS(data: any): UserProfileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientType"] = this.clientType;
        return data;
    }
}

export interface IUserProfileQuery {
    id: number;
    clientType?: string | undefined;
}

export class UserUpdateProfileCommand implements IUserUpdateProfileCommand {
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    pictureName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
    language?: number | undefined;
    clientType?: string | undefined;
    preferences?: { [key: string]: string; } | undefined;

    constructor(data?: IUserUpdateProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.pictureName = _data["pictureName"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.newPasswordConfirm = _data["newPasswordConfirm"];
            this.language = _data["language"];
            this.clientType = _data["clientType"];
            if (_data["preferences"]) {
                this.preferences = {} as any;
                for (let key in _data["preferences"]) {
                    if (_data["preferences"].hasOwnProperty(key))
                        (<any>this.preferences)![key] = _data["preferences"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserUpdateProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["pictureName"] = this.pictureName;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["newPasswordConfirm"] = this.newPasswordConfirm;
        data["language"] = this.language;
        data["clientType"] = this.clientType;
        if (this.preferences) {
            data["preferences"] = {};
            for (let key in this.preferences) {
                if (this.preferences.hasOwnProperty(key))
                    (<any>data["preferences"])[key] = this.preferences[key];
            }
        }
        return data;
    }
}

export interface IUserUpdateProfileCommand {
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    pictureName?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
    language?: number | undefined;
    clientType?: string | undefined;
    preferences?: { [key: string]: string; } | undefined;
}

export class UserResponse implements IUserResponse {
    id!: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isNotifiesEmail!: boolean;
    isNotifiesSMS!: boolean;
    isNotifiesMeansEmail!: boolean;
    isNotifiesMeansSMS!: boolean;
    isActive?: boolean | undefined;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.secondLastName = _data["secondLastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isNotifiesEmail = _data["isNotifiesEmail"];
            this.isNotifiesSMS = _data["isNotifiesSMS"];
            this.isNotifiesMeansEmail = _data["isNotifiesMeansEmail"];
            this.isNotifiesMeansSMS = _data["isNotifiesMeansSMS"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["secondLastName"] = this.secondLastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isNotifiesEmail"] = this.isNotifiesEmail;
        data["isNotifiesSMS"] = this.isNotifiesSMS;
        data["isNotifiesMeansEmail"] = this.isNotifiesMeansEmail;
        data["isNotifiesMeansSMS"] = this.isNotifiesMeansSMS;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserResponse {
    id: number;
    userName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    secondLastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isNotifiesEmail: boolean;
    isNotifiesSMS: boolean;
    isNotifiesMeansEmail: boolean;
    isNotifiesMeansSMS: boolean;
    isActive?: boolean | undefined;
}

export class UserGetByIdQuery implements IUserGetByIdQuery {
    id!: number;

    constructor(data?: IUserGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserGetByIdQuery {
    id: number;
}

export class UserDeleteCommand implements IUserDeleteCommand {
    id!: number;

    constructor(data?: IUserDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDeleteCommand {
    id: number;
}

export class WebLogGetLastestResponse implements IWebLogGetLastestResponse {
    latesWebLogLines?: string[] | undefined;

    constructor(data?: IWebLogGetLastestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latesWebLogLines"])) {
                this.latesWebLogLines = [] as any;
                for (let item of _data["latesWebLogLines"])
                    this.latesWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): WebLogGetLastestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogGetLastestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latesWebLogLines)) {
            data["latesWebLogLines"] = [];
            for (let item of this.latesWebLogLines)
                data["latesWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IWebLogGetLastestResponse {
    latesWebLogLines?: string[] | undefined;
}

export class WebLogGetLastestQuery implements IWebLogGetLastestQuery {

    constructor(data?: IWebLogGetLastestQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WebLogGetLastestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogGetLastestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWebLogGetLastestQuery {
}

export class WebLogDownloadZipResponse implements IWebLogDownloadZipResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IWebLogDownloadZipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): WebLogDownloadZipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogDownloadZipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IWebLogDownloadZipResponse {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export class WebLogDownloadZipQuery implements IWebLogDownloadZipQuery {

    constructor(data?: IWebLogDownloadZipQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WebLogDownloadZipQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogDownloadZipQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWebLogDownloadZipQuery {
}

export class PagedResultDtoOfWorkShiftForListResponse implements IPagedResultDtoOfWorkShiftForListResponse {
    totalCount!: number;
    items?: WorkShiftForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfWorkShiftForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WorkShiftForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWorkShiftForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWorkShiftForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWorkShiftForListResponse {
    totalCount: number;
    items?: WorkShiftForListResponse[] | undefined;
}

export class WorkShiftForListResponse implements IWorkShiftForListResponse {
    id!: number;
    description?: string | undefined;
    startTime!: moment.Duration;
    endTime!: moment.Duration;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IWorkShiftForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment.duration(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment.duration(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): WorkShiftForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IWorkShiftForListResponse {
    id: number;
    description?: string | undefined;
    startTime: moment.Duration;
    endTime: moment.Duration;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class WorkShiftGetListQuery extends PageListByDto implements IWorkShiftGetListQuery {

    constructor(data?: IWorkShiftGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): WorkShiftGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWorkShiftGetListQuery extends IPageListByDto {
}

export class WorkShiftForEditResponse implements IWorkShiftForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    startTime!: moment.Duration;
    endTime!: moment.Duration;
    isActive!: boolean;

    constructor(data?: IWorkShiftForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment.duration(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment.duration(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WorkShiftForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWorkShiftForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    startTime: moment.Duration;
    endTime: moment.Duration;
    isActive: boolean;
}

export class WorkShiftGetForEditQuery implements IWorkShiftGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IWorkShiftGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkShiftGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkShiftGetForEditQuery {
    id?: number | undefined;
}

export class WorkShiftGetComboQuery implements IWorkShiftGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IWorkShiftGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WorkShiftGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWorkShiftGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class WorkShiftCreateCommand implements IWorkShiftCreateCommand {
    description?: string | undefined;
    startTime!: moment.Duration;
    endTime!: moment.Duration;
    isActive!: boolean;

    constructor(data?: IWorkShiftCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment.duration(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment.duration(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WorkShiftCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWorkShiftCreateCommand {
    description?: string | undefined;
    startTime: moment.Duration;
    endTime: moment.Duration;
    isActive: boolean;
}

export class WorkShiftUpdateCommand implements IWorkShiftUpdateCommand {
    id!: number;
    description?: string | undefined;
    startTime!: moment.Duration;
    endTime!: moment.Duration;
    isActive!: boolean;

    constructor(data?: IWorkShiftUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment.duration(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment.duration(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WorkShiftUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWorkShiftUpdateCommand {
    id: number;
    description?: string | undefined;
    startTime: moment.Duration;
    endTime: moment.Duration;
    isActive: boolean;
}

export class PagedResultDtoOfZoneForListResponse implements IPagedResultDtoOfZoneForListResponse {
    totalCount!: number;
    items?: ZoneForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfZoneForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZoneForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfZoneForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfZoneForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfZoneForListResponse {
    totalCount: number;
    items?: ZoneForListResponse[] | undefined;
}

export class ZoneForListResponse implements IZoneForListResponse {
    id!: number;
    description?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;

    constructor(data?: IZoneForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): ZoneForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IZoneForListResponse {
    id: number;
    description?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
}

export class ZoneGetListQuery extends PageListByDto implements IZoneGetListQuery {

    constructor(data?: IZoneGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ZoneGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IZoneGetListQuery extends IPageListByDto {
}

export class ZoneForEditResponse implements IZoneForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IZoneForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoneForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoneForEditResponse {
    id?: number | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class ZoneGetForEditQuery implements IZoneGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IZoneGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZoneGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IZoneGetForEditQuery {
    id?: number | undefined;
}

export class ZoneGetComboQuery implements IZoneGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IZoneGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoneGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoneGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class ZoneResponse implements IZoneResponse {
    id?: number | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IZoneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoneResponse {
    id?: number | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class ZoneGetByIdQuery implements IZoneGetByIdQuery {
    id!: number;

    constructor(data?: IZoneGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZoneGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IZoneGetByIdQuery {
    id: number;
}

export class ZoneCreateCommand implements IZoneCreateCommand {
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IZoneCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoneCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoneCreateCommand {
    description?: string | undefined;
    isActive: boolean;
}

export class ZoneUpdateCommand implements IZoneUpdateCommand {
    id!: number;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IZoneUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoneUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoneUpdateCommand {
    id: number;
    description?: string | undefined;
    isActive: boolean;
}

export class ActivityResponse implements IActivityResponse {
    id?: number | undefined;
    usuario?: number | undefined;
    tipoActividad?: number | undefined;
    tipoActividadDesc?: string | undefined;
    turno?: number | undefined;
    turnoDesc?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.usuario = _data["usuario"];
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadDesc = _data["tipoActividadDesc"];
            this.turno = _data["turno"];
            this.turnoDesc = _data["turnoDesc"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["usuario"] = this.usuario;
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadDesc"] = this.tipoActividadDesc;
        data["turno"] = this.turno;
        data["turnoDesc"] = this.turnoDesc;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivityResponse {
    id?: number | undefined;
    usuario?: number | undefined;
    tipoActividad?: number | undefined;
    tipoActividadDesc?: string | undefined;
    turno?: number | undefined;
    turnoDesc?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class ActivityGetActiveWorkshiftByUserQuery implements IActivityGetActiveWorkshiftByUserQuery {
    mobileSession!: number;

    constructor(data?: IActivityGetActiveWorkshiftByUserQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSession = _data["mobileSession"];
        }
    }

    static fromJS(data: any): ActivityGetActiveWorkshiftByUserQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGetActiveWorkshiftByUserQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSession"] = this.mobileSession;
        return data;
    }
}

export interface IActivityGetActiveWorkshiftByUserQuery {
    mobileSession: number;
}

export class ActivityCreateStartWorkshiftResponse implements IActivityCreateStartWorkshiftResponse {
    id!: number;
    mobileSession!: number;

    constructor(data?: IActivityCreateStartWorkshiftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mobileSession = _data["mobileSession"];
        }
    }

    static fromJS(data: any): ActivityCreateStartWorkshiftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCreateStartWorkshiftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mobileSession"] = this.mobileSession;
        return data;
    }
}

export interface IActivityCreateStartWorkshiftResponse {
    id: number;
    mobileSession: number;
}

export class ActivityCreateStartWorkshiftCommand implements IActivityCreateStartWorkshiftCommand {
    turno?: number | undefined;
    deviceId?: string | undefined;

    constructor(data?: IActivityCreateStartWorkshiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turno = _data["turno"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): ActivityCreateStartWorkshiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCreateStartWorkshiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turno"] = this.turno;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IActivityCreateStartWorkshiftCommand {
    turno?: number | undefined;
    deviceId?: string | undefined;
}

export class ActivityFinishStartWorkshiftCommand implements IActivityFinishStartWorkshiftCommand {
    id?: number | undefined;

    constructor(data?: IActivityFinishStartWorkshiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityFinishStartWorkshiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFinishStartWorkshiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IActivityFinishStartWorkshiftCommand {
    id?: number | undefined;
}

export class ActivityStartCommand implements IActivityStartCommand {
    tipoActividad?: number | undefined;
    sesionMovil?: number | undefined;

    constructor(data?: IActivityStartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.sesionMovil = _data["sesionMovil"];
        }
    }

    static fromJS(data: any): ActivityStartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["sesionMovil"] = this.sesionMovil;
        return data;
    }
}

export interface IActivityStartCommand {
    tipoActividad?: number | undefined;
    sesionMovil?: number | undefined;
}

export class ActivityFinishCommand implements IActivityFinishCommand {
    id?: number | undefined;

    constructor(data?: IActivityFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IActivityFinishCommand {
    id?: number | undefined;
}

export class ActivityCreateDirectCommand implements IActivityCreateDirectCommand {
    claveInterna?: string | undefined;
    sesionMovil?: number | undefined;
    tipo?: number | undefined;
    referencia?: number | undefined;

    constructor(data?: IActivityCreateDirectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claveInterna = _data["claveInterna"];
            this.sesionMovil = _data["sesionMovil"];
            this.tipo = _data["tipo"];
            this.referencia = _data["referencia"];
        }
    }

    static fromJS(data: any): ActivityCreateDirectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCreateDirectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claveInterna"] = this.claveInterna;
        data["sesionMovil"] = this.sesionMovil;
        data["tipo"] = this.tipo;
        data["referencia"] = this.referencia;
        return data;
    }
}

export interface IActivityCreateDirectCommand {
    claveInterna?: string | undefined;
    sesionMovil?: number | undefined;
    tipo?: number | undefined;
    referencia?: number | undefined;
}

export class ActivityForListResponse implements IActivityForListResponse {
    id!: number;
    usuario?: number | undefined;
    tipoActividad?: number | undefined;
    tipoActividadDesc?: string | undefined;
    turno?: number | undefined;
    turnoDesc?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
    canTerminarManual?: boolean | undefined;

    constructor(data?: IActivityForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.usuario = _data["usuario"];
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadDesc = _data["tipoActividadDesc"];
            this.turno = _data["turno"];
            this.turnoDesc = _data["turnoDesc"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
            this.canTerminarManual = _data["canTerminarManual"];
        }
    }

    static fromJS(data: any): ActivityForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["usuario"] = this.usuario;
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadDesc"] = this.tipoActividadDesc;
        data["turno"] = this.turno;
        data["turnoDesc"] = this.turnoDesc;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        data["canTerminarManual"] = this.canTerminarManual;
        return data;
    }
}

export interface IActivityForListResponse {
    id: number;
    usuario?: number | undefined;
    tipoActividad?: number | undefined;
    tipoActividadDesc?: string | undefined;
    turno?: number | undefined;
    turnoDesc?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
    canTerminarManual?: boolean | undefined;
}

export class ActivityGetByUserListQuery implements IActivityGetByUserListQuery {
    mobileSession!: number;

    constructor(data?: IActivityGetByUserListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileSession = _data["mobileSession"];
        }
    }

    static fromJS(data: any): ActivityGetByUserListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGetByUserListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileSession"] = this.mobileSession;
        return data;
    }
}

export interface IActivityGetByUserListQuery {
    mobileSession: number;
}

export class ActivityKeepDirectCommand implements IActivityKeepDirectCommand {
    sesionMovil?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: number | undefined;
    referencia?: number | undefined;

    constructor(data?: IActivityKeepDirectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.claveInterna = _data["claveInterna"];
            this.tipo = _data["tipo"];
            this.referencia = _data["referencia"];
        }
    }

    static fromJS(data: any): ActivityKeepDirectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityKeepDirectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["claveInterna"] = this.claveInterna;
        data["tipo"] = this.tipo;
        data["referencia"] = this.referencia;
        return data;
    }
}

export interface IActivityKeepDirectCommand {
    sesionMovil?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: number | undefined;
    referencia?: number | undefined;
}

export class ActivityFinishActiveCommand implements IActivityFinishActiveCommand {
    sesionMovil?: number | undefined;

    constructor(data?: IActivityFinishActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
        }
    }

    static fromJS(data: any): ActivityFinishActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFinishActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        return data;
    }
}

export interface IActivityFinishActiveCommand {
    sesionMovil?: number | undefined;
}

export class ActivityFinishIndirectPdbreakCommand implements IActivityFinishIndirectPdbreakCommand {
    sesionMovil?: number | undefined;

    constructor(data?: IActivityFinishIndirectPdbreakCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
        }
    }

    static fromJS(data: any): ActivityFinishIndirectPdbreakCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFinishIndirectPdbreakCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        return data;
    }
}

export interface IActivityFinishIndirectPdbreakCommand {
    sesionMovil?: number | undefined;
}

export class ActivityTypeForEditResponse implements IActivityTypeForEditResponse {
    id?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    tipoCombo?: ComboboxItemDto[] | undefined;

    constructor(data?: IActivityTypeForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claveInterna = _data["claveInterna"];
            this.tipo = _data["tipo"];
            this.tiempoEstimado = _data["tiempoEstimado"] ? moment.duration(_data["tiempoEstimado"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["tipoCombo"])) {
                this.tipoCombo = [] as any;
                for (let item of _data["tipoCombo"])
                    this.tipoCombo!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityTypeForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claveInterna"] = this.claveInterna;
        data["tipo"] = this.tipo;
        data["tiempoEstimado"] = this.tiempoEstimado ? this.tiempoEstimado.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["orden"] = this.orden;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.tipoCombo)) {
            data["tipoCombo"] = [];
            for (let item of this.tipoCombo)
                data["tipoCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityTypeForEditResponse {
    id?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    tipoCombo?: ComboboxItemDto[] | undefined;
}

export enum ActivityTypeTipo {
    Directa = 1,
    PDBreak = 2,
    Indirecta = 3,
}

export class ActivityTypeGetForEditQuery implements IActivityTypeGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IActivityTypeGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityTypeGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IActivityTypeGetForEditQuery {
    id?: number | undefined;
}

export class PagedResultDtoOfActivityTypeForListResponse implements IPagedResultDtoOfActivityTypeForListResponse {
    totalCount!: number;
    items?: ActivityTypeForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfActivityTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityTypeForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActivityTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfActivityTypeForListResponse {
    totalCount: number;
    items?: ActivityTypeForListResponse[] | undefined;
}

export class ActivityTypeForListResponse implements IActivityTypeForListResponse {
    id!: number;
    claveInterna?: string | undefined;
    tipoDesc?: string | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive!: boolean;

    constructor(data?: IActivityTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claveInterna = _data["claveInterna"];
            this.tipoDesc = _data["tipoDesc"];
            this.tiempoEstimado = _data["tiempoEstimado"] ? moment.duration(_data["tiempoEstimado"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivityTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claveInterna"] = this.claveInterna;
        data["tipoDesc"] = this.tipoDesc;
        data["tiempoEstimado"] = this.tiempoEstimado ? this.tiempoEstimado.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["orden"] = this.orden;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivityTypeForListResponse {
    id: number;
    claveInterna?: string | undefined;
    tipoDesc?: string | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive: boolean;
}

export class ActivityTypeGetListQuery extends PageListByDto implements IActivityTypeGetListQuery {

    constructor(data?: IActivityTypeGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActivityTypeGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IActivityTypeGetListQuery extends IPageListByDto {
}

export class ActivityTypeCreateCommand implements IActivityTypeCreateCommand {
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IActivityTypeCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claveInterna = _data["claveInterna"];
            this.tipo = _data["tipo"];
            this.tiempoEstimado = _data["tiempoEstimado"] ? moment.duration(_data["tiempoEstimado"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivityTypeCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claveInterna"] = this.claveInterna;
        data["tipo"] = this.tipo;
        data["tiempoEstimado"] = this.tiempoEstimado ? this.tiempoEstimado.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["orden"] = this.orden;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivityTypeCreateCommand {
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class ActivityTypeUpdateCommand implements IActivityTypeUpdateCommand {
    id?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IActivityTypeUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claveInterna = _data["claveInterna"];
            this.tipo = _data["tipo"];
            this.tiempoEstimado = _data["tiempoEstimado"] ? moment.duration(_data["tiempoEstimado"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivityTypeUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claveInterna"] = this.claveInterna;
        data["tipo"] = this.tipo;
        data["tiempoEstimado"] = this.tiempoEstimado ? this.tiempoEstimado.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["orden"] = this.orden;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivityTypeUpdateCommand {
    id?: number | undefined;
    claveInterna?: string | undefined;
    tipo?: ActivityTypeTipo | undefined;
    tiempoEstimado?: moment.Duration | undefined;
    orden?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class AssortmentCreateCommand implements IAssortmentCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: AssortmentDetailCreateCommand[] | undefined;
    secuenciadoDetalleList?: AssortmentSecuencedDetailCreateCommand[] | undefined;
    actividadList?: AssortmentActivityCreateCommand[] | undefined;

    constructor(data?: IAssortmentCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(AssortmentDetailCreateCommand.fromJS(item));
            }
            if (Array.isArray(_data["secuenciadoDetalleList"])) {
                this.secuenciadoDetalleList = [] as any;
                for (let item of _data["secuenciadoDetalleList"])
                    this.secuenciadoDetalleList!.push(AssortmentSecuencedDetailCreateCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(AssortmentActivityCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssortmentCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.secuenciadoDetalleList)) {
            data["secuenciadoDetalleList"] = [];
            for (let item of this.secuenciadoDetalleList)
                data["secuenciadoDetalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssortmentCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: AssortmentDetailCreateCommand[] | undefined;
    secuenciadoDetalleList?: AssortmentSecuencedDetailCreateCommand[] | undefined;
    actividadList?: AssortmentActivityCreateCommand[] | undefined;
}

export class AssortmentDetailCreateCommand implements IAssortmentDetailCreateCommand {
    ubicacion?: number | undefined;
    parte?: number | undefined;
    ruta?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;

    constructor(data?: IAssortmentDetailCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubicacion = _data["ubicacion"];
            this.parte = _data["parte"];
            this.ruta = _data["ruta"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): AssortmentDetailCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentDetailCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubicacion"] = this.ubicacion;
        data["parte"] = this.parte;
        data["ruta"] = this.ruta;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        return data;
    }
}

export interface IAssortmentDetailCreateCommand {
    ubicacion?: number | undefined;
    parte?: number | undefined;
    ruta?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
}

export class AssortmentSecuencedDetailCreateCommand implements IAssortmentSecuencedDetailCreateCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    secuenciaVacio?: number | undefined;
    secuenciaInicioVacio?: number | undefined;
    secuenciaFinVacio?: number | undefined;

    constructor(data?: IAssortmentSecuencedDetailCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.secuenciaVacio = _data["secuenciaVacio"];
            this.secuenciaInicioVacio = _data["secuenciaInicioVacio"];
            this.secuenciaFinVacio = _data["secuenciaFinVacio"];
        }
    }

    static fromJS(data: any): AssortmentSecuencedDetailCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentSecuencedDetailCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["secuenciaVacio"] = this.secuenciaVacio;
        data["secuenciaInicioVacio"] = this.secuenciaInicioVacio;
        data["secuenciaFinVacio"] = this.secuenciaFinVacio;
        return data;
    }
}

export interface IAssortmentSecuencedDetailCreateCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    secuenciaVacio?: number | undefined;
    secuenciaInicioVacio?: number | undefined;
    secuenciaFinVacio?: number | undefined;
}

export class AssortmentActivityCreateCommand implements IAssortmentActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IAssortmentActivityCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssortmentActivityCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentActivityCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssortmentActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class AssortmentCancelCommand implements IAssortmentCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: AssortmentDetailCancelCommand[] | undefined;
    secuenciadoDetalleList?: AssortmentSecuencedDetailCancelCommand[] | undefined;
    actividadList?: AssortmentActivityCancelCommand[] | undefined;

    constructor(data?: IAssortmentCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(AssortmentDetailCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["secuenciadoDetalleList"])) {
                this.secuenciadoDetalleList = [] as any;
                for (let item of _data["secuenciadoDetalleList"])
                    this.secuenciadoDetalleList!.push(AssortmentSecuencedDetailCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(AssortmentActivityCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssortmentCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.secuenciadoDetalleList)) {
            data["secuenciadoDetalleList"] = [];
            for (let item of this.secuenciadoDetalleList)
                data["secuenciadoDetalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssortmentCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: AssortmentDetailCancelCommand[] | undefined;
    secuenciadoDetalleList?: AssortmentSecuencedDetailCancelCommand[] | undefined;
    actividadList?: AssortmentActivityCancelCommand[] | undefined;
}

export class AssortmentDetailCancelCommand implements IAssortmentDetailCancelCommand {
    ubicacion?: number | undefined;
    parte?: number | undefined;
    ruta?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;

    constructor(data?: IAssortmentDetailCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubicacion = _data["ubicacion"];
            this.parte = _data["parte"];
            this.ruta = _data["ruta"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): AssortmentDetailCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentDetailCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubicacion"] = this.ubicacion;
        data["parte"] = this.parte;
        data["ruta"] = this.ruta;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        return data;
    }
}

export interface IAssortmentDetailCancelCommand {
    ubicacion?: number | undefined;
    parte?: number | undefined;
    ruta?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
}

export class AssortmentSecuencedDetailCancelCommand implements IAssortmentSecuencedDetailCancelCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    secuenciaVacio?: number | undefined;
    secuenciaInicioVacio?: number | undefined;
    secuenciaFinVacio?: number | undefined;

    constructor(data?: IAssortmentSecuencedDetailCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.secuenciaVacio = _data["secuenciaVacio"];
            this.secuenciaInicioVacio = _data["secuenciaInicioVacio"];
            this.secuenciaFinVacio = _data["secuenciaFinVacio"];
        }
    }

    static fromJS(data: any): AssortmentSecuencedDetailCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentSecuencedDetailCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["secuenciaVacio"] = this.secuenciaVacio;
        data["secuenciaInicioVacio"] = this.secuenciaInicioVacio;
        data["secuenciaFinVacio"] = this.secuenciaFinVacio;
        return data;
    }
}

export interface IAssortmentSecuencedDetailCancelCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    secuenciaVacio?: number | undefined;
    secuenciaInicioVacio?: number | undefined;
    secuenciaFinVacio?: number | undefined;
}

export class AssortmentActivityCancelCommand implements IAssortmentActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IAssortmentActivityCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssortmentActivityCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentActivityCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssortmentActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class AssortmentIsSerieAvaliableQuery implements IAssortmentIsSerieAvaliableQuery {
    serie?: string | undefined;

    constructor(data?: IAssortmentIsSerieAvaliableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): AssortmentIsSerieAvaliableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AssortmentIsSerieAvaliableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serie"] = this.serie;
        return data;
    }
}

export interface IAssortmentIsSerieAvaliableQuery {
    serie?: string | undefined;
}

export class DamageTypeForEditResponse implements IDamageTypeForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;

    constructor(data?: IDamageTypeForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.isCardboard = _data["isCardboard"];
        }
    }

    static fromJS(data: any): DamageTypeForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["isCardboard"] = this.isCardboard;
        return data;
    }
}

export interface IDamageTypeForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;
}

export class DamageTypeGetForEditQuery implements IDamageTypeGetForEditQuery {
    id!: number;

    constructor(data?: IDamageTypeGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DamageTypeGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDamageTypeGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfDamageTypeForListResponse implements IPagedResultDtoOfDamageTypeForListResponse {
    totalCount!: number;
    items?: DamageTypeForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfDamageTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DamageTypeForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDamageTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDamageTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDamageTypeForListResponse {
    totalCount: number;
    items?: DamageTypeForListResponse[] | undefined;
}

export class DamageTypeForListResponse implements IDamageTypeForListResponse {
    id!: number;
    descripcion?: string | undefined;
    isActive!: boolean;
    isCardboard!: boolean;

    constructor(data?: IDamageTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.isCardboard = _data["isCardboard"];
        }
    }

    static fromJS(data: any): DamageTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["isCardboard"] = this.isCardboard;
        return data;
    }
}

export interface IDamageTypeForListResponse {
    id: number;
    descripcion?: string | undefined;
    isActive: boolean;
    isCardboard: boolean;
}

export class DamageTypeGetListQuery extends PageListByDto implements IDamageTypeGetListQuery {

    constructor(data?: IDamageTypeGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DamageTypeGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDamageTypeGetListQuery extends IPageListByDto {
}

export class DamageTypeGetComboQuery implements IDamageTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IDamageTypeGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DamageTypeGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IDamageTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class DamageTypeCreateCommand implements IDamageTypeCreateCommand {
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;

    constructor(data?: IDamageTypeCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.isCardboard = _data["isCardboard"];
        }
    }

    static fromJS(data: any): DamageTypeCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["isCardboard"] = this.isCardboard;
        return data;
    }
}

export interface IDamageTypeCreateCommand {
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;
}

export class DamageTypeUpdateCommand implements IDamageTypeUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;

    constructor(data?: IDamageTypeUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.isCardboard = _data["isCardboard"];
        }
    }

    static fromJS(data: any): DamageTypeUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DamageTypeUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["isCardboard"] = this.isCardboard;
        return data;
    }
}

export interface IDamageTypeUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    isCardboard?: boolean | undefined;
}

export class PartGetByPartBaseQuery implements IPartGetByPartBaseQuery {
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;

    constructor(data?: IPartGetByPartBaseQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefijo = _data["prefijo"];
            this.base = _data["base"];
            this.sufijo = _data["sufijo"];
            this.parteBase = _data["parteBase"];
        }
    }

    static fromJS(data: any): PartGetByPartBaseQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetByPartBaseQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefijo"] = this.prefijo;
        data["base"] = this.base;
        data["sufijo"] = this.sufijo;
        data["parteBase"] = this.parteBase;
        return data;
    }
}

export interface IPartGetByPartBaseQuery {
    prefijo?: string | undefined;
    base?: string | undefined;
    sufijo?: string | undefined;
    parteBase?: string | undefined;
}

export class DownloadForListResponse implements IDownloadForListResponse {
    id!: number;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    ventana?: number | undefined;
    ventanaDesc?: string | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;

    constructor(data?: IDownloadForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anden = _data["anden"];
            this.andenDesc = _data["andenDesc"];
            this.ventana = _data["ventana"];
            this.ventanaDesc = _data["ventanaDesc"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
        }
    }

    static fromJS(data: any): DownloadForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anden"] = this.anden;
        data["andenDesc"] = this.andenDesc;
        data["ventana"] = this.ventana;
        data["ventanaDesc"] = this.ventanaDesc;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        return data;
    }
}

export interface IDownloadForListResponse {
    id: number;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    ventana?: number | undefined;
    ventanaDesc?: string | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
}

export enum DownloadTipoSinDocumento {
    Inbound = 1,
    Campus = 2,
}

export class DownloadGetSuspendedListQuery implements IDownloadGetSuspendedListQuery {
    origen?: DownloadOrigen | undefined;

    constructor(data?: IDownloadGetSuspendedListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origen = _data["origen"];
        }
    }

    static fromJS(data: any): DownloadGetSuspendedListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadGetSuspendedListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origen"] = this.origen;
        return data;
    }
}

export interface IDownloadGetSuspendedListQuery {
    origen?: DownloadOrigen | undefined;
}

export class DownloadForEditResponse implements IDownloadForEditResponse {
    id!: number;
    programacionDescarga?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    ventana?: number | undefined;
    ventanaDesc?: string | undefined;
    turno?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    estatus?: DownloadEstatus | undefined;
    detalleList?: DownloadDetailDto[] | undefined;

    constructor(data?: IDownloadForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programacionDescarga = _data["programacionDescarga"];
            this.anden = _data["anden"];
            this.andenDesc = _data["andenDesc"];
            this.ventana = _data["ventana"];
            this.ventanaDesc = _data["ventanaDesc"];
            this.turno = _data["turno"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.enProgramacion = _data["enProgramacion"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.estatus = _data["estatus"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programacionDescarga"] = this.programacionDescarga;
        data["anden"] = this.anden;
        data["andenDesc"] = this.andenDesc;
        data["ventana"] = this.ventana;
        data["ventanaDesc"] = this.ventanaDesc;
        data["turno"] = this.turno;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["enProgramacion"] = this.enProgramacion;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["estatus"] = this.estatus;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadForEditResponse {
    id: number;
    programacionDescarga?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    ventana?: number | undefined;
    ventanaDesc?: string | undefined;
    turno?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    estatus?: DownloadEstatus | undefined;
    detalleList?: DownloadDetailDto[] | undefined;
}

export class DownloadDetailDto implements IDownloadDetailDto {
    id?: number | undefined;
    descarga?: number | undefined;
    cargaMaterialDetalle?: number | undefined;
    parte?: number | undefined;
    parteDesc?: string | undefined;
    parteBaseDesc?: string | undefined;
    tipoDanio?: number | undefined;
    tipoDanioDesc?: string | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadDetailPackageDto[] | undefined;

    constructor(data?: IDownloadDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descarga = _data["descarga"];
            this.cargaMaterialDetalle = _data["cargaMaterialDetalle"];
            this.parte = _data["parte"];
            this.parteDesc = _data["parteDesc"];
            this.parteBaseDesc = _data["parteBaseDesc"];
            this.tipoDanio = _data["tipoDanio"];
            this.tipoDanioDesc = _data["tipoDanioDesc"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadDetailPackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descarga"] = this.descarga;
        data["cargaMaterialDetalle"] = this.cargaMaterialDetalle;
        data["parte"] = this.parte;
        data["parteDesc"] = this.parteDesc;
        data["parteBaseDesc"] = this.parteBaseDesc;
        data["tipoDanio"] = this.tipoDanio;
        data["tipoDanioDesc"] = this.tipoDanioDesc;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailDto {
    id?: number | undefined;
    descarga?: number | undefined;
    cargaMaterialDetalle?: number | undefined;
    parte?: number | undefined;
    parteDesc?: string | undefined;
    parteBaseDesc?: string | undefined;
    tipoDanio?: number | undefined;
    tipoDanioDesc?: string | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadDetailPackageDto[] | undefined;
}

export class DownloadDetailPackageDto implements IDownloadDetailPackageDto {
    id?: number | undefined;
    detalle?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
    isSospechosoDesc?: string | undefined;

    constructor(data?: IDownloadDetailPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.detalle = _data["detalle"];
            this.part = _data["part"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
            this.isSospechosoDesc = _data["isSospechosoDesc"];
        }
    }

    static fromJS(data: any): DownloadDetailPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detalle"] = this.detalle;
        data["part"] = this.part;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        data["isSospechosoDesc"] = this.isSospechosoDesc;
        return data;
    }
}

export interface IDownloadDetailPackageDto {
    id?: number | undefined;
    detalle?: number | undefined;
    part?: number | undefined;
    partBaseWithFormat?: string | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
    isSospechosoDesc?: string | undefined;
}

export class DownloadGetForEditQuery implements IDownloadGetForEditQuery {
    id!: number;

    constructor(data?: IDownloadGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadGetForEditQuery {
    id: number;
}

export class DownloadIsAvaliableQuery implements IDownloadIsAvaliableQuery {
    source?: DownloadOrigen | undefined;
    platform?: number | undefined;
    boxNumber?: string | undefined;

    constructor(data?: IDownloadIsAvaliableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.platform = _data["platform"];
            this.boxNumber = _data["boxNumber"];
        }
    }

    static fromJS(data: any): DownloadIsAvaliableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadIsAvaliableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["platform"] = this.platform;
        data["boxNumber"] = this.boxNumber;
        return data;
    }
}

export interface IDownloadIsAvaliableQuery {
    source?: DownloadOrigen | undefined;
    platform?: number | undefined;
    boxNumber?: string | undefined;
}

export class DownloadMeteringFinishCommand implements IDownloadMeteringFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    codigoCajaVacia?: string | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailMeteringFinishCommand[] | undefined;
    actividadList?: DownloadActivityMeteringFinishCommand[] | undefined;

    constructor(data?: IDownloadMeteringFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.isTecho = _data["isTecho"];
            this.isParedes = _data["isParedes"];
            this.isPiso = _data["isPiso"];
            this.isMarco = _data["isMarco"];
            this.codigoCajaVacia = _data["codigoCajaVacia"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailMeteringFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityMeteringFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadMeteringFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMeteringFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["isTecho"] = this.isTecho;
        data["isParedes"] = this.isParedes;
        data["isPiso"] = this.isPiso;
        data["isMarco"] = this.isMarco;
        data["codigoCajaVacia"] = this.codigoCajaVacia;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadMeteringFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    codigoCajaVacia?: string | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailMeteringFinishCommand[] | undefined;
    actividadList?: DownloadActivityMeteringFinishCommand[] | undefined;
}

export class DownloadDetailMeteringFinishCommand implements IDownloadDetailMeteringFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringFinishCommand[] | undefined;

    constructor(data?: IDownloadDetailMeteringFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageMeteringFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailMeteringFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailMeteringFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailMeteringFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringFinishCommand[] | undefined;
}

export class DownloadPackageMeteringFinishCommand implements IDownloadPackageMeteringFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageMeteringFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageMeteringFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageMeteringFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageMeteringFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityMeteringFinishCommand implements IDownloadActivityMeteringFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityMeteringFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityMeteringFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityMeteringFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityMeteringFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadMeteringSuspendCommand implements IDownloadMeteringSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: DownloadDetailMeteringSuspendCommand[] | undefined;
    actividadList?: DownloadActivityMeteringSuspendCommand[] | undefined;

    constructor(data?: IDownloadMeteringSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailMeteringSuspendCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityMeteringSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadMeteringSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMeteringSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadMeteringSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: DownloadDetailMeteringSuspendCommand[] | undefined;
    actividadList?: DownloadActivityMeteringSuspendCommand[] | undefined;
}

export class DownloadDetailMeteringSuspendCommand implements IDownloadDetailMeteringSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringSuspendCommand[] | undefined;

    constructor(data?: IDownloadDetailMeteringSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageMeteringSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailMeteringSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailMeteringSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailMeteringSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringSuspendCommand[] | undefined;
}

export class DownloadPackageMeteringSuspendCommand implements IDownloadPackageMeteringSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageMeteringSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageMeteringSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageMeteringSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageMeteringSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityMeteringSuspendCommand implements IDownloadActivityMeteringSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityMeteringSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityMeteringSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityMeteringSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityMeteringSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadMeteringCancelCommand implements IDownloadMeteringCancelCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailMeteringCancelCommand[] | undefined;
    actividadList?: DownloadActivityMeteringCancelCommand[] | undefined;

    constructor(data?: IDownloadMeteringCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailMeteringCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityMeteringCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadMeteringCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMeteringCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadMeteringCancelCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailMeteringCancelCommand[] | undefined;
    actividadList?: DownloadActivityMeteringCancelCommand[] | undefined;
}

export class DownloadDetailMeteringCancelCommand implements IDownloadDetailMeteringCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringCancelCommand[] | undefined;

    constructor(data?: IDownloadDetailMeteringCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageMeteringCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailMeteringCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailMeteringCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailMeteringCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringCancelCommand[] | undefined;
}

export class DownloadPackageMeteringCancelCommand implements IDownloadPackageMeteringCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageMeteringCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageMeteringCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageMeteringCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageMeteringCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityMeteringCancelCommand implements IDownloadActivityMeteringCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityMeteringCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityMeteringCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityMeteringCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityMeteringCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadMeteringUndoCommand implements IDownloadMeteringUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;

    constructor(data?: IDownloadMeteringUndoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.motivoSuspension = _data["motivoSuspension"];
        }
    }

    static fromJS(data: any): DownloadMeteringUndoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMeteringUndoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["motivoSuspension"] = this.motivoSuspension;
        return data;
    }
}

export interface IDownloadMeteringUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;
}

export class DownloadMeteringReleaseCommand implements IDownloadMeteringReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadDetailMeteringReleaseCommand[] | undefined;
    actividadList?: DownloadActivityMeteringReleaseCommand[] | undefined;

    constructor(data?: IDownloadMeteringReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailMeteringReleaseCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityMeteringReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadMeteringReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMeteringReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadMeteringReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadDetailMeteringReleaseCommand[] | undefined;
    actividadList?: DownloadActivityMeteringReleaseCommand[] | undefined;
}

export class DownloadDetailMeteringReleaseCommand implements IDownloadDetailMeteringReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringReleaseCommand[] | undefined;

    constructor(data?: IDownloadDetailMeteringReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageMeteringReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailMeteringReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailMeteringReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailMeteringReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageMeteringReleaseCommand[] | undefined;
}

export class DownloadPackageMeteringReleaseCommand implements IDownloadPackageMeteringReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageMeteringReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageMeteringReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageMeteringReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageMeteringReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityMeteringReleaseCommand implements IDownloadActivityMeteringReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityMeteringReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityMeteringReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityMeteringReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityMeteringReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadCampusFinishCommand implements IDownloadCampusFinishCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailCampusFinishCommand[] | undefined;
    actividadList?: DownloadActivityCampusFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationCampusFinishCommand[] | undefined;

    constructor(data?: IDownloadCampusFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.isTecho = _data["isTecho"];
            this.isParedes = _data["isParedes"];
            this.isPiso = _data["isPiso"];
            this.isMarco = _data["isMarco"];
            this.sello = _data["sello"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailCampusFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityCampusFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["conciliacionList"])) {
                this.conciliacionList = [] as any;
                for (let item of _data["conciliacionList"])
                    this.conciliacionList!.push(DownloadConciliationCampusFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadCampusFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCampusFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["isTecho"] = this.isTecho;
        data["isParedes"] = this.isParedes;
        data["isPiso"] = this.isPiso;
        data["isMarco"] = this.isMarco;
        data["sello"] = this.sello;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        if (Array.isArray(this.conciliacionList)) {
            data["conciliacionList"] = [];
            for (let item of this.conciliacionList)
                data["conciliacionList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadCampusFinishCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailCampusFinishCommand[] | undefined;
    actividadList?: DownloadActivityCampusFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationCampusFinishCommand[] | undefined;
}

export class DownloadDetailCampusFinishCommand implements IDownloadDetailCampusFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusFinishCommand[] | undefined;

    constructor(data?: IDownloadDetailCampusFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageCampusFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailCampusFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailCampusFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailCampusFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusFinishCommand[] | undefined;
}

export class DownloadPackageCampusFinishCommand implements IDownloadPackageCampusFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageCampusFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageCampusFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageCampusFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageCampusFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityCampusFinishCommand implements IDownloadActivityCampusFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityCampusFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityCampusFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityCampusFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityCampusFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadConciliationCampusFinishCommand implements IDownloadConciliationCampusFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;

    constructor(data?: IDownloadConciliationCampusFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.cantidadDescarga = _data["cantidadDescarga"];
            this.cantidadDescargaReal = _data["cantidadDescargaReal"];
        }
    }

    static fromJS(data: any): DownloadConciliationCampusFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadConciliationCampusFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["cantidadDescarga"] = this.cantidadDescarga;
        data["cantidadDescargaReal"] = this.cantidadDescargaReal;
        return data;
    }
}

export interface IDownloadConciliationCampusFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;
}

export class DownloadCampusSuspendCommand implements IDownloadCampusSuspendCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailCampusSuspendCommand[] | undefined;
    actividadList?: DownloadActivityCampusSuspendCommand[] | undefined;

    constructor(data?: IDownloadCampusSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailCampusSuspendCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityCampusSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadCampusSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCampusSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadCampusSuspendCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailCampusSuspendCommand[] | undefined;
    actividadList?: DownloadActivityCampusSuspendCommand[] | undefined;
}

export class DownloadDetailCampusSuspendCommand implements IDownloadDetailCampusSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusSuspendCommand[] | undefined;

    constructor(data?: IDownloadDetailCampusSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageCampusSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailCampusSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailCampusSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailCampusSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusSuspendCommand[] | undefined;
}

export class DownloadPackageCampusSuspendCommand implements IDownloadPackageCampusSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageCampusSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageCampusSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageCampusSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageCampusSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityCampusSuspendCommand implements IDownloadActivityCampusSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityCampusSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityCampusSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityCampusSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityCampusSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadCampusCancelCommand implements IDownloadCampusCancelCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailCampusCancelCommand[] | undefined;
    actividadList?: DownloadActivityCampusCancelCommand[] | undefined;

    constructor(data?: IDownloadCampusCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailCampusCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityCampusCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadCampusCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCampusCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadCampusCancelCommand {
    id?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailCampusCancelCommand[] | undefined;
    actividadList?: DownloadActivityCampusCancelCommand[] | undefined;
}

export class DownloadDetailCampusCancelCommand implements IDownloadDetailCampusCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusCancelCommand[] | undefined;

    constructor(data?: IDownloadDetailCampusCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageCampusCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailCampusCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailCampusCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailCampusCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusCancelCommand[] | undefined;
}

export class DownloadPackageCampusCancelCommand implements IDownloadPackageCampusCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageCampusCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageCampusCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageCampusCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageCampusCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityCampusCancelCommand implements IDownloadActivityCampusCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityCampusCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityCampusCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityCampusCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityCampusCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadCampusUndoCommand implements IDownloadCampusUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;

    constructor(data?: IDownloadCampusUndoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.motivoSuspension = _data["motivoSuspension"];
        }
    }

    static fromJS(data: any): DownloadCampusUndoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCampusUndoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["motivoSuspension"] = this.motivoSuspension;
        return data;
    }
}

export interface IDownloadCampusUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;
}

export class DownloadCampusReleaseCommand implements IDownloadCampusReleaseCommand {
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailCampusReleaseCommand[] | undefined;
    actividadList?: DownloadActivityCampusReleaseCommand[] | undefined;

    constructor(data?: IDownloadCampusReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailCampusReleaseCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityCampusReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadCampusReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCampusReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadCampusReleaseCommand {
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailCampusReleaseCommand[] | undefined;
    actividadList?: DownloadActivityCampusReleaseCommand[] | undefined;
}

export class DownloadDetailCampusReleaseCommand implements IDownloadDetailCampusReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusReleaseCommand[] | undefined;

    constructor(data?: IDownloadDetailCampusReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageCampusReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailCampusReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailCampusReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailCampusReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageCampusReleaseCommand[] | undefined;
}

export class DownloadPackageCampusReleaseCommand implements IDownloadPackageCampusReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageCampusReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageCampusReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageCampusReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageCampusReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityCampusReleaseCommand implements IDownloadActivityCampusReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityCampusReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityCampusReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityCampusReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityCampusReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadInboundFinishCommand implements IDownloadInboundFinishCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    detalleList?: DownloadDetailInboundFinishCommand[] | undefined;
    actividadList?: DownloadActivityInboundFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationInboundFinishCommand[] | undefined;

    constructor(data?: IDownloadInboundFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programacionDescarga = _data["programacionDescarga"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.isTecho = _data["isTecho"];
            this.isParedes = _data["isParedes"];
            this.isPiso = _data["isPiso"];
            this.isMarco = _data["isMarco"];
            this.sello = _data["sello"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            this.tipo = _data["tipo"];
            this.enProgramacion = _data["enProgramacion"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailInboundFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityInboundFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["conciliacionList"])) {
                this.conciliacionList = [] as any;
                for (let item of _data["conciliacionList"])
                    this.conciliacionList!.push(DownloadConciliationInboundFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadInboundFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInboundFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programacionDescarga"] = this.programacionDescarga;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["isTecho"] = this.isTecho;
        data["isParedes"] = this.isParedes;
        data["isPiso"] = this.isPiso;
        data["isMarco"] = this.isMarco;
        data["sello"] = this.sello;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        data["tipo"] = this.tipo;
        data["enProgramacion"] = this.enProgramacion;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        if (Array.isArray(this.conciliacionList)) {
            data["conciliacionList"] = [];
            for (let item of this.conciliacionList)
                data["conciliacionList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadInboundFinishCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    detalleList?: DownloadDetailInboundFinishCommand[] | undefined;
    actividadList?: DownloadActivityInboundFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationInboundFinishCommand[] | undefined;
}

export class DownloadDetailInboundFinishCommand implements IDownloadDetailInboundFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundFinishCommand[] | undefined;

    constructor(data?: IDownloadDetailInboundFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageInboundFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailInboundFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailInboundFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailInboundFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundFinishCommand[] | undefined;
}

export class DownloadPackageInboundFinishCommand implements IDownloadPackageInboundFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageInboundFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageInboundFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageInboundFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageInboundFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityInboundFinishCommand implements IDownloadActivityInboundFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityInboundFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityInboundFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityInboundFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityInboundFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadConciliationInboundFinishCommand implements IDownloadConciliationInboundFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;

    constructor(data?: IDownloadConciliationInboundFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.cantidadDescarga = _data["cantidadDescarga"];
            this.cantidadDescargaReal = _data["cantidadDescargaReal"];
        }
    }

    static fromJS(data: any): DownloadConciliationInboundFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadConciliationInboundFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["cantidadDescarga"] = this.cantidadDescarga;
        data["cantidadDescargaReal"] = this.cantidadDescargaReal;
        return data;
    }
}

export interface IDownloadConciliationInboundFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;
}

export class DownloadInboundSuspendCommand implements IDownloadInboundSuspendCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailInboundSuspendCommand[] | undefined;
    actividadList?: DownloadActivityInboundSuspendCommand[] | undefined;

    constructor(data?: IDownloadInboundSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programacionDescarga = _data["programacionDescarga"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.tipo = _data["tipo"];
            this.enProgramacion = _data["enProgramacion"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailInboundSuspendCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityInboundSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadInboundSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInboundSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programacionDescarga"] = this.programacionDescarga;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["tipo"] = this.tipo;
        data["enProgramacion"] = this.enProgramacion;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadInboundSuspendCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailInboundSuspendCommand[] | undefined;
    actividadList?: DownloadActivityInboundSuspendCommand[] | undefined;
}

export class DownloadDetailInboundSuspendCommand implements IDownloadDetailInboundSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundSuspendCommand[] | undefined;

    constructor(data?: IDownloadDetailInboundSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageInboundSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailInboundSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailInboundSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailInboundSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundSuspendCommand[] | undefined;
}

export class DownloadPackageInboundSuspendCommand implements IDownloadPackageInboundSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageInboundSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageInboundSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageInboundSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageInboundSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityInboundSuspendCommand implements IDownloadActivityInboundSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityInboundSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityInboundSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityInboundSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityInboundSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadInboundCancelCommand implements IDownloadInboundCancelCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailInboundCancelCommand[] | undefined;
    actividadList?: DownloadActivityInboundCancelCommand[] | undefined;

    constructor(data?: IDownloadInboundCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programacionDescarga = _data["programacionDescarga"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.tipo = _data["tipo"];
            this.enProgramacion = _data["enProgramacion"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailInboundCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityInboundCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadInboundCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInboundCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programacionDescarga"] = this.programacionDescarga;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["tipo"] = this.tipo;
        data["enProgramacion"] = this.enProgramacion;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadInboundCancelCommand {
    id?: number | undefined;
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailInboundCancelCommand[] | undefined;
    actividadList?: DownloadActivityInboundCancelCommand[] | undefined;
}

export class DownloadDetailInboundCancelCommand implements IDownloadDetailInboundCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundCancelCommand[] | undefined;

    constructor(data?: IDownloadDetailInboundCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageInboundCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailInboundCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailInboundCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailInboundCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundCancelCommand[] | undefined;
}

export class DownloadPackageInboundCancelCommand implements IDownloadPackageInboundCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageInboundCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageInboundCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageInboundCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageInboundCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityInboundCancelCommand implements IDownloadActivityInboundCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityInboundCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityInboundCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityInboundCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityInboundCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadInboundUndoCommand implements IDownloadInboundUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;

    constructor(data?: IDownloadInboundUndoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.motivoSuspension = _data["motivoSuspension"];
        }
    }

    static fromJS(data: any): DownloadInboundUndoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInboundUndoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["motivoSuspension"] = this.motivoSuspension;
        return data;
    }
}

export interface IDownloadInboundUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;
}

export class DownloadInboundReleaseCommand implements IDownloadInboundReleaseCommand {
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailInboundReleaseCommand[] | undefined;
    actividadList?: DownloadActivityInboundReleaseCommand[] | undefined;

    constructor(data?: IDownloadInboundReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programacionDescarga = _data["programacionDescarga"];
            this.cargaMaterial = _data["cargaMaterial"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.numeroEmbarque = _data["numeroEmbarque"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.enProgramacion = _data["enProgramacion"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailInboundReleaseCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivityInboundReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadInboundReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInboundReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programacionDescarga"] = this.programacionDescarga;
        data["cargaMaterial"] = this.cargaMaterial;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["numeroEmbarque"] = this.numeroEmbarque;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["enProgramacion"] = this.enProgramacion;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadInboundReleaseCommand {
    programacionDescarga?: number | undefined;
    cargaMaterial?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    numeroEmbarque?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipo?: DownloadTipo | undefined;
    enProgramacion?: boolean | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailInboundReleaseCommand[] | undefined;
    actividadList?: DownloadActivityInboundReleaseCommand[] | undefined;
}

export class DownloadDetailInboundReleaseCommand implements IDownloadDetailInboundReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundReleaseCommand[] | undefined;

    constructor(data?: IDownloadDetailInboundReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageInboundReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailInboundReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailInboundReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailInboundReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageInboundReleaseCommand[] | undefined;
}

export class DownloadPackageInboundReleaseCommand implements IDownloadPackageInboundReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageInboundReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageInboundReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageInboundReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageInboundReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivityInboundReleaseCommand implements IDownloadActivityInboundReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivityInboundReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivityInboundReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivityInboundReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivityInboundReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadSinDocumentacionFinishCommand implements IDownloadSinDocumentacionFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionFinishCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationSinDocumentacionFinishCommand[] | undefined;

    constructor(data?: IDownloadSinDocumentacionFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.isTecho = _data["isTecho"];
            this.isParedes = _data["isParedes"];
            this.isPiso = _data["isPiso"];
            this.isMarco = _data["isMarco"];
            this.sello = _data["sello"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailSinDocumentacionFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivitySinDocumentacionFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["conciliacionList"])) {
                this.conciliacionList = [] as any;
                for (let item of _data["conciliacionList"])
                    this.conciliacionList!.push(DownloadConciliationSinDocumentacionFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadSinDocumentacionFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSinDocumentacionFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["isTecho"] = this.isTecho;
        data["isParedes"] = this.isParedes;
        data["isPiso"] = this.isPiso;
        data["isMarco"] = this.isMarco;
        data["sello"] = this.sello;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        if (Array.isArray(this.conciliacionList)) {
            data["conciliacionList"] = [];
            for (let item of this.conciliacionList)
                data["conciliacionList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadSinDocumentacionFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    sello?: string | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionFinishCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionFinishCommand[] | undefined;
    conciliacionList?: DownloadConciliationSinDocumentacionFinishCommand[] | undefined;
}

export class DownloadDetailSinDocumentacionFinishCommand implements IDownloadDetailSinDocumentacionFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionFinishCommand[] | undefined;

    constructor(data?: IDownloadDetailSinDocumentacionFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageSinDocumentacionFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailSinDocumentacionFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailSinDocumentacionFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailSinDocumentacionFinishCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionFinishCommand[] | undefined;
}

export class DownloadPackageSinDocumentacionFinishCommand implements IDownloadPackageSinDocumentacionFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageSinDocumentacionFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageSinDocumentacionFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageSinDocumentacionFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageSinDocumentacionFinishCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivitySinDocumentacionFinishCommand implements IDownloadActivitySinDocumentacionFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivitySinDocumentacionFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivitySinDocumentacionFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivitySinDocumentacionFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivitySinDocumentacionFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadConciliationSinDocumentacionFinishCommand implements IDownloadConciliationSinDocumentacionFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;

    constructor(data?: IDownloadConciliationSinDocumentacionFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.cantidadDescarga = _data["cantidadDescarga"];
            this.cantidadDescargaReal = _data["cantidadDescargaReal"];
        }
    }

    static fromJS(data: any): DownloadConciliationSinDocumentacionFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadConciliationSinDocumentacionFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["cantidadDescarga"] = this.cantidadDescarga;
        data["cantidadDescargaReal"] = this.cantidadDescargaReal;
        return data;
    }
}

export interface IDownloadConciliationSinDocumentacionFinishCommand {
    parte?: number | undefined;
    cantidadDescarga?: number | undefined;
    cantidadDescargaReal?: number | undefined;
}

export class DownloadSinDocumentacionSuspendCommand implements IDownloadSinDocumentacionSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionSuspendCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionSuspendCommand[] | undefined;

    constructor(data?: IDownloadSinDocumentacionSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailSinDocumentacionSuspendCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivitySinDocumentacionSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadSinDocumentacionSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSinDocumentacionSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadSinDocumentacionSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionSuspendCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionSuspendCommand[] | undefined;
}

export class DownloadDetailSinDocumentacionSuspendCommand implements IDownloadDetailSinDocumentacionSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionSuspendCommand[] | undefined;

    constructor(data?: IDownloadDetailSinDocumentacionSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageSinDocumentacionSuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailSinDocumentacionSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailSinDocumentacionSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailSinDocumentacionSuspendCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionSuspendCommand[] | undefined;
}

export class DownloadPackageSinDocumentacionSuspendCommand implements IDownloadPackageSinDocumentacionSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageSinDocumentacionSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageSinDocumentacionSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageSinDocumentacionSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageSinDocumentacionSuspendCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivitySinDocumentacionSuspendCommand implements IDownloadActivitySinDocumentacionSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivitySinDocumentacionSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivitySinDocumentacionSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivitySinDocumentacionSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivitySinDocumentacionSuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadSinDocumentacionCancelCommand implements IDownloadSinDocumentacionCancelCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionCancelCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionCancelCommand[] | undefined;

    constructor(data?: IDownloadSinDocumentacionCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailSinDocumentacionCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivitySinDocumentacionCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadSinDocumentacionCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSinDocumentacionCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["autorizadorAnden"] = this.autorizadorAnden;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadSinDocumentacionCancelCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionCancelCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionCancelCommand[] | undefined;
}

export class DownloadDetailSinDocumentacionCancelCommand implements IDownloadDetailSinDocumentacionCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionCancelCommand[] | undefined;

    constructor(data?: IDownloadDetailSinDocumentacionCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageSinDocumentacionCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailSinDocumentacionCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailSinDocumentacionCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailSinDocumentacionCancelCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionCancelCommand[] | undefined;
}

export class DownloadPackageSinDocumentacionCancelCommand implements IDownloadPackageSinDocumentacionCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageSinDocumentacionCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageSinDocumentacionCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageSinDocumentacionCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageSinDocumentacionCancelCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivitySinDocumentacionCancelCommand implements IDownloadActivitySinDocumentacionCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivitySinDocumentacionCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivitySinDocumentacionCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivitySinDocumentacionCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivitySinDocumentacionCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadSinDocumentacionUndoCommand implements IDownloadSinDocumentacionUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    motivoSuspension?: number | undefined;

    constructor(data?: IDownloadSinDocumentacionUndoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.motivoSuspension = _data["motivoSuspension"];
        }
    }

    static fromJS(data: any): DownloadSinDocumentacionUndoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSinDocumentacionUndoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["motivoSuspension"] = this.motivoSuspension;
        return data;
    }
}

export interface IDownloadSinDocumentacionUndoCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    motivoSuspension?: number | undefined;
}

export class DownloadSinDocumentacionReleaseCommand implements IDownloadSinDocumentacionReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionReleaseCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionReleaseCommand[] | undefined;

    constructor(data?: IDownloadSinDocumentacionReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.tipoSinDocumento = _data["tipoSinDocumento"];
            this.autorizadorAnden = _data["autorizadorAnden"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadDetailSinDocumentacionReleaseCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadActivitySinDocumentacionReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadSinDocumentacionReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSinDocumentacionReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["tipoSinDocumento"] = this.tipoSinDocumento;
        data["autorizadorAnden"] = this.autorizadorAnden;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadSinDocumentacionReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    tipoSinDocumento?: DownloadTipoSinDocumento | undefined;
    autorizadorAnden?: number | undefined;
    detalleList?: DownloadDetailSinDocumentacionReleaseCommand[] | undefined;
    actividadList?: DownloadActivitySinDocumentacionReleaseCommand[] | undefined;
}

export class DownloadDetailSinDocumentacionReleaseCommand implements IDownloadDetailSinDocumentacionReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionReleaseCommand[] | undefined;

    constructor(data?: IDownloadDetailSinDocumentacionReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parte = _data["parte"];
            this.tipoDanio = _data["tipoDanio"];
            this.cantidadNormal = _data["cantidadNormal"];
            this.cantidadSospechosa = _data["cantidadSospechosa"];
            if (Array.isArray(_data["bultoList"])) {
                this.bultoList = [] as any;
                for (let item of _data["bultoList"])
                    this.bultoList!.push(DownloadPackageSinDocumentacionReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDetailSinDocumentacionReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailSinDocumentacionReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parte"] = this.parte;
        data["tipoDanio"] = this.tipoDanio;
        data["cantidadNormal"] = this.cantidadNormal;
        data["cantidadSospechosa"] = this.cantidadSospechosa;
        if (Array.isArray(this.bultoList)) {
            data["bultoList"] = [];
            for (let item of this.bultoList)
                data["bultoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadDetailSinDocumentacionReleaseCommand {
    parte?: number | undefined;
    tipoDanio?: number | undefined;
    cantidadNormal?: number | undefined;
    cantidadSospechosa?: number | undefined;
    bultoList?: DownloadPackageSinDocumentacionReleaseCommand[] | undefined;
}

export class DownloadPackageSinDocumentacionReleaseCommand implements IDownloadPackageSinDocumentacionReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;

    constructor(data?: IDownloadPackageSinDocumentacionReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
        }
    }

    static fromJS(data: any): DownloadPackageSinDocumentacionReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPackageSinDocumentacionReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        return data;
    }
}

export interface IDownloadPackageSinDocumentacionReleaseCommand {
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso?: boolean | undefined;
}

export class DownloadActivitySinDocumentacionReleaseCommand implements IDownloadActivitySinDocumentacionReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadActivitySinDocumentacionReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadActivitySinDocumentacionReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadActivitySinDocumentacionReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadActivitySinDocumentacionReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadDetailPackageForListResponse implements IDownloadDetailPackageForListResponse {
    id!: number;
    detalle!: number;
    part!: number;
    partBaseWithFormat?: string | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso!: boolean;
    isSospechosoDesc?: string | undefined;

    constructor(data?: IDownloadDetailPackageForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.detalle = _data["detalle"];
            this.part = _data["part"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.isSospechoso = _data["isSospechoso"];
            this.isSospechosoDesc = _data["isSospechosoDesc"];
        }
    }

    static fromJS(data: any): DownloadDetailPackageForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailPackageForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detalle"] = this.detalle;
        data["part"] = this.part;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["isSospechoso"] = this.isSospechoso;
        data["isSospechosoDesc"] = this.isSospechosoDesc;
        return data;
    }
}

export interface IDownloadDetailPackageForListResponse {
    id: number;
    detalle: number;
    part: number;
    partBaseWithFormat?: string | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    isSospechoso: boolean;
    isSospechosoDesc?: string | undefined;
}

export class DownloadDetailPackageByDetailGetListQuery implements IDownloadDetailPackageByDetailGetListQuery {
    detail!: number;

    constructor(data?: IDownloadDetailPackageByDetailGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): DownloadDetailPackageByDetailGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDetailPackageByDetailGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detail"] = this.detail;
        return data;
    }
}

export interface IDownloadDetailPackageByDetailGetListQuery {
    detail: number;
}

export class DownloadJitForListResponse implements IDownloadJitForListResponse {
    id?: number | undefined;
    jit?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    cantidadDollys?: number | undefined;
    ultUsuarioSuspendio?: string | undefined;

    constructor(data?: IDownloadJitForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jit = _data["jit"];
            this.anden = _data["anden"];
            this.andenDesc = _data["andenDesc"];
            this.etapa = _data["etapa"];
            this.numeroCaja = _data["numeroCaja"];
            this.cantidadDollys = _data["cantidadDollys"];
            this.ultUsuarioSuspendio = _data["ultUsuarioSuspendio"];
        }
    }

    static fromJS(data: any): DownloadJitForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jit"] = this.jit;
        data["anden"] = this.anden;
        data["andenDesc"] = this.andenDesc;
        data["etapa"] = this.etapa;
        data["numeroCaja"] = this.numeroCaja;
        data["cantidadDollys"] = this.cantidadDollys;
        data["ultUsuarioSuspendio"] = this.ultUsuarioSuspendio;
        return data;
    }
}

export interface IDownloadJitForListResponse {
    id?: number | undefined;
    jit?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    cantidadDollys?: number | undefined;
    ultUsuarioSuspendio?: string | undefined;
}

export enum DownloadJitEtapa {
    DescargaDollys = 1,
    CargaVacios = 2,
}

export class DownloadJitGetSuspendedListQuery implements IDownloadJitGetSuspendedListQuery {
    platform!: number;

    constructor(data?: IDownloadJitGetSuspendedListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): DownloadJitGetSuspendedListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitGetSuspendedListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        return data;
    }
}

export interface IDownloadJitGetSuspendedListQuery {
    platform: number;
}

export class DownloadJitForEditResponse implements IDownloadJitForEditResponse {
    id?: number | undefined;
    jit?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    etapa?: DownloadJitEtapa | undefined;
    estatus?: DownloadJitEstatus | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadJitDetailDto[] | undefined;

    constructor(data?: IDownloadJitForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jit = _data["jit"];
            this.turno = _data["turno"];
            this.anden = _data["anden"];
            this.andenDesc = _data["andenDesc"];
            this.etapa = _data["etapa"];
            this.estatus = _data["estatus"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadJitDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadJitForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jit"] = this.jit;
        data["turno"] = this.turno;
        data["anden"] = this.anden;
        data["andenDesc"] = this.andenDesc;
        data["etapa"] = this.etapa;
        data["estatus"] = this.estatus;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadJitForEditResponse {
    id?: number | undefined;
    jit?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    andenDesc?: string | undefined;
    etapa?: DownloadJitEtapa | undefined;
    estatus?: DownloadJitEstatus | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadJitDetailDto[] | undefined;
}

export enum DownloadJitEstatus {
    Terminado = 1,
    Cancelado = 2,
    Suspendido = 3,
}

export class DownloadJitDetailDto implements IDownloadJitDetailDto {
    id?: number | undefined;
    descargaJit?: number | undefined;
    commodity?: number | undefined;
    commodityClave?: string | undefined;
    commodityDesc?: string | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion?: boolean | undefined;
    isValidado?: boolean | undefined;

    constructor(data?: IDownloadJitDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descargaJit = _data["descargaJit"];
            this.commodity = _data["commodity"];
            this.commodityClave = _data["commodityClave"];
            this.commodityDesc = _data["commodityDesc"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.isRequiereValidacion = _data["isRequiereValidacion"];
            this.isValidado = _data["isValidado"];
        }
    }

    static fromJS(data: any): DownloadJitDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descargaJit"] = this.descargaJit;
        data["commodity"] = this.commodity;
        data["commodityClave"] = this.commodityClave;
        data["commodityDesc"] = this.commodityDesc;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["isRequiereValidacion"] = this.isRequiereValidacion;
        data["isValidado"] = this.isValidado;
        return data;
    }
}

export interface IDownloadJitDetailDto {
    id?: number | undefined;
    descargaJit?: number | undefined;
    commodity?: number | undefined;
    commodityClave?: string | undefined;
    commodityDesc?: string | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion?: boolean | undefined;
    isValidado?: boolean | undefined;
}

export class DownloadJitGetForEditQuery implements IDownloadJitGetForEditQuery {
    id!: number;

    constructor(data?: IDownloadJitGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadJitGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadJitGetForEditQuery {
    id: number;
}

export class DownloadJitSuspendCommand implements IDownloadJitSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: DownloadJitDetailSuspendCommand[] | undefined;
    actividadList?: DownloadJitActivitySuspendCommand[] | undefined;

    constructor(data?: IDownloadJitSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.anden = _data["anden"];
            this.etapa = _data["etapa"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadJitDetailSuspendCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadJitActivitySuspendCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadJitSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["anden"] = this.anden;
        data["etapa"] = this.etapa;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadJitSuspendCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    detalleList?: DownloadJitDetailSuspendCommand[] | undefined;
    actividadList?: DownloadJitActivitySuspendCommand[] | undefined;
}

export class DownloadJitDetailSuspendCommand implements IDownloadJitDetailSuspendCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion!: boolean;
    isValidado!: boolean;

    constructor(data?: IDownloadJitDetailSuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.isRequiereValidacion = _data["isRequiereValidacion"];
            this.isValidado = _data["isValidado"];
        }
    }

    static fromJS(data: any): DownloadJitDetailSuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitDetailSuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["isRequiereValidacion"] = this.isRequiereValidacion;
        data["isValidado"] = this.isValidado;
        return data;
    }
}

export interface IDownloadJitDetailSuspendCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion: boolean;
    isValidado: boolean;
}

export class DownloadJitActivitySuspendCommand implements IDownloadJitActivitySuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadJitActivitySuspendCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadJitActivitySuspendCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitActivitySuspendCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadJitActivitySuspendCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadJitCancelCommand implements IDownloadJitCancelCommand {
    id?: number | undefined;

    constructor(data?: IDownloadJitCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadJitCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadJitCancelCommand {
    id?: number | undefined;
}

// GrupoInventario Service Proxy
@Injectable()
export class GrupoInventarioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getGrupoInventarioList(query: GrupoInventarioGetListQuery): Observable<PagedResultDtoOfGrupoInventarioForListResponse> {
        let url_ = this.baseUrl + "/api/GrupoInventario/GetGrupoInventarioList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGrupoInventarioList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrupoInventarioList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGrupoInventarioForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGrupoInventarioForListResponse>;
        }));
    }

    protected processGetGrupoInventarioList(response: HttpResponseBase): Observable<PagedResultDtoOfGrupoInventarioForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGrupoInventarioForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGrupoInventarioForListResponse>(null as any);
    }

    getGrupoInventarioForEdit(dto: GrupoInventarioGetForEditQuery): Observable<GrupoInventarioForEditResponse> {
        let url_ = this.baseUrl + "/api/GrupoInventario/GetGrupoInventarioForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGrupoInventarioForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrupoInventarioForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrupoInventarioForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrupoInventarioForEditResponse>;
        }));
    }

    protected processGetGrupoInventarioForEdit(response: HttpResponseBase): Observable<GrupoInventarioForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrupoInventarioForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrupoInventarioForEditResponse>(null as any);
    }

    createGrupoInventario(dto: GrupoInventarioCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GrupoInventario/CreateGrupoInventario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateGrupoInventario(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateGrupoInventario(dto: GrupoInventarioUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GrupoInventario/UpdateGrupoInventario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateGrupoInventario(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteGrupoInventario(command: GrupoInventarioDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GrupoInventario/DeleteGrupoInventario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteGrupoInventario(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reactivateGrupoInventario(command: GrupoInventarioReactivateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GrupoInventario/ReactivateGrupoInventario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReactivateGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReactivateGrupoInventario(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getGrupoInventarioAutocompleterList(text: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/GrupoInventario/GetGrupoInventarioAutocompleterList?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGrupoInventarioAutocompleterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrupoInventarioAutocompleterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetGrupoInventarioAutocompleterList(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(null as any);
    }

    importGrupoInventario(base64Content: string): Observable<number> {
        let url_ = this.baseUrl + "/api/GrupoInventario/ImportGrupoInventario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ base64: base64Content });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportGrupoInventario(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportGrupoInventario(query?: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/GrupoInventario/ExportGrupoInventario/export";
        url_ = url_.replace(/[?&]$/, "");
        
        // Si no se proporciona query, usar objeto vacío para exportar todo
        const body = query || {};
        
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            body: JSON.stringify(body)
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGrupoInventario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGrupoInventario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportGrupoInventario(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

// GrupoInventario DTOs and Response Types
export class GrupoInventarioGetListQuery implements IGrupoInventarioGetListQuery {
    filter?: string | undefined;
    id?: number | undefined;
    descripcion?: string | undefined;
    estatus?: string | undefined;
    sorting?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPagedBy?: boolean | undefined;

    constructor(data?: IGrupoInventarioGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.estatus = _data["estatus"];
            this.sorting = _data["sorting"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPagedBy = _data["isPagedBy"];
        }
    }

    static fromJS(data: any): GrupoInventarioGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["estatus"] = this.estatus;
        data["sorting"] = this.sorting;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPagedBy"] = this.isPagedBy;
        return data;
    }
}

export interface IGrupoInventarioGetListQuery {
    filter?: string | undefined;
    id?: number | undefined;
    descripcion?: string | undefined;
    estatus?: string | undefined;
    sorting?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    isPagedBy?: boolean | undefined;
}

export class PagedResultDtoOfGrupoInventarioForListResponse implements IPagedResultDtoOfGrupoInventarioForListResponse {
    totalCount?: number | undefined;
    items?: GrupoInventarioForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGrupoInventarioForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GrupoInventarioForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGrupoInventarioForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGrupoInventarioForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGrupoInventarioForListResponse {
    totalCount?: number | undefined;
    items?: GrupoInventarioForListResponse[] | undefined;
}

export class GrupoInventarioForListResponse implements IGrupoInventarioForListResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    estatus?: string | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IGrupoInventarioForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.estatus = _data["estatus"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GrupoInventarioForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["estatus"] = this.estatus;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGrupoInventarioForListResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    estatus?: string | undefined;
    isDeleted?: boolean | undefined;
}

export class GrupoInventarioGetForEditQuery implements IGrupoInventarioGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IGrupoInventarioGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GrupoInventarioGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGrupoInventarioGetForEditQuery {
    id?: number | undefined;
}

export class GrupoInventarioForEditResponse implements IGrupoInventarioForEditResponse {
    id?: number | undefined;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;

    constructor(data?: IGrupoInventarioForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            // Check if the response has a nested grupoInventario object
            if (_data.grupoInventario) {
                // Handle nested structure: { grupoInventario: { id, descripcion, ... } }
                const grupoData = _data.grupoInventario;
                this.id = grupoData["id"];
                this.codigo = grupoData["codigo"];
                this.descripcion = grupoData["descripcion"];
                this.activo = grupoData["activo"];
            } else {
                // Handle flat structure: { id, descripcion, ... }
                this.id = _data["id"];
                this.codigo = _data["codigo"];
                this.descripcion = _data["descripcion"];
                this.activo = _data["activo"];
            }
        }
    }

    static fromJS(data: any): GrupoInventarioForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codigo"] = this.codigo;
        data["descripcion"] = this.descripcion;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IGrupoInventarioForEditResponse {
    id?: number | undefined;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;
}

export class GrupoInventarioCreateCommand implements IGrupoInventarioCreateCommand {
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;

    constructor(data?: IGrupoInventarioCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descripcion = _data["descripcion"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): GrupoInventarioCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descripcion"] = this.descripcion;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IGrupoInventarioCreateCommand {
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;
}

export class GrupoInventarioUpdateCommand implements IGrupoInventarioUpdateCommand {
    id?: number | undefined;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;

    constructor(data?: IGrupoInventarioUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codigo = _data["codigo"];
            this.descripcion = _data["descripcion"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): GrupoInventarioUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codigo"] = this.codigo;
        data["descripcion"] = this.descripcion;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IGrupoInventarioUpdateCommand {
    id?: number | undefined;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    activo?: boolean | undefined;
}

export class GrupoInventarioDeleteCommand implements IGrupoInventarioDeleteCommand {
    id?: number | undefined;

    constructor(data?: IGrupoInventarioDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GrupoInventarioDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGrupoInventarioDeleteCommand {
    id?: number | undefined;
}

export class GrupoInventarioReactivateCommand implements IGrupoInventarioReactivateCommand {
    id?: number | undefined;

    constructor(data?: IGrupoInventarioReactivateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GrupoInventarioReactivateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioReactivateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGrupoInventarioReactivateCommand {
    id?: number | undefined;
}

export class GrupoInventarioImportCommand implements IGrupoInventarioImportCommand {
    fileBase64?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IGrupoInventarioImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileBase64 = _data["fileBase64"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): GrupoInventarioImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoInventarioImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBase64"] = this.fileBase64;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IGrupoInventarioImportCommand {
    fileBase64?: string | undefined;
    fileName?: string | undefined;
}

export class DownloadJitActivityCancelCommand implements IDownloadJitActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadJitActivityCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadJitActivityCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitActivityCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadJitActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadJitFinishCommand implements IDownloadJitFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    codigoPluma?: string | undefined;
    cantidadVacio?: number | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    detalleList?: DownloadJitDetailFinishCommand[] | undefined;
    actividadList?: DownloadJitActivityFinishCommand[] | undefined;

    constructor(data?: IDownloadJitFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.anden = _data["anden"];
            this.etapa = _data["etapa"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.codigoPluma = _data["codigoPluma"];
            this.cantidadVacio = _data["cantidadVacio"];
            this.isTecho = _data["isTecho"];
            this.isParedes = _data["isParedes"];
            this.isPiso = _data["isPiso"];
            this.isMarco = _data["isMarco"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadJitDetailFinishCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadJitActivityFinishCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadJitFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["anden"] = this.anden;
        data["etapa"] = this.etapa;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["codigoPluma"] = this.codigoPluma;
        data["cantidadVacio"] = this.cantidadVacio;
        data["isTecho"] = this.isTecho;
        data["isParedes"] = this.isParedes;
        data["isPiso"] = this.isPiso;
        data["isMarco"] = this.isMarco;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadJitFinishCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    codigoPluma?: string | undefined;
    cantidadVacio?: number | undefined;
    isTecho?: boolean | undefined;
    isParedes?: boolean | undefined;
    isPiso?: boolean | undefined;
    isMarco?: boolean | undefined;
    detalleList?: DownloadJitDetailFinishCommand[] | undefined;
    actividadList?: DownloadJitActivityFinishCommand[] | undefined;
}

export class DownloadJitDetailFinishCommand implements IDownloadJitDetailFinishCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion!: boolean;
    isValidado!: boolean;

    constructor(data?: IDownloadJitDetailFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.isRequiereValidacion = _data["isRequiereValidacion"];
            this.isValidado = _data["isValidado"];
        }
    }

    static fromJS(data: any): DownloadJitDetailFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitDetailFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["isRequiereValidacion"] = this.isRequiereValidacion;
        data["isValidado"] = this.isValidado;
        return data;
    }
}

export interface IDownloadJitDetailFinishCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion: boolean;
    isValidado: boolean;
}

export class DownloadJitActivityFinishCommand implements IDownloadJitActivityFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadJitActivityFinishCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadJitActivityFinishCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitActivityFinishCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadJitActivityFinishCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadJitCancelSuspendedCommand implements IDownloadJitCancelSuspendedCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;
    usuarioAutorizador?: number | undefined;

    constructor(data?: IDownloadJitCancelSuspendedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.motivoSuspension = _data["motivoSuspension"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
        }
    }

    static fromJS(data: any): DownloadJitCancelSuspendedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitCancelSuspendedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["motivoSuspension"] = this.motivoSuspension;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        return data;
    }
}

export interface IDownloadJitCancelSuspendedCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    motivoSuspension?: number | undefined;
    usuarioAutorizador?: number | undefined;
}

export class DownloadJitReleaseCommand implements IDownloadJitReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadJitDetailReleaseCommand[] | undefined;
    actividadList?: DownloadJitActivityReleaseCommand[] | undefined;

    constructor(data?: IDownloadJitReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.anden = _data["anden"];
            this.etapa = _data["etapa"];
            this.numeroCaja = _data["numeroCaja"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(DownloadJitDetailReleaseCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(DownloadJitActivityReleaseCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadJitReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["anden"] = this.anden;
        data["etapa"] = this.etapa;
        data["numeroCaja"] = this.numeroCaja;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadJitReleaseCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    anden?: number | undefined;
    etapa?: DownloadJitEtapa | undefined;
    numeroCaja?: string | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    detalleList?: DownloadJitDetailReleaseCommand[] | undefined;
    actividadList?: DownloadJitActivityReleaseCommand[] | undefined;
}

export class DownloadJitDetailReleaseCommand implements IDownloadJitDetailReleaseCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion!: boolean;
    isValidado!: boolean;

    constructor(data?: IDownloadJitDetailReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.ruta = _data["ruta"];
            this.tipoLectura = _data["tipoLectura"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.secuenciaInicioDolly = _data["secuenciaInicioDolly"];
            this.secuenciaFinDolly = _data["secuenciaFinDolly"];
            this.secuenciaCommodity = _data["secuenciaCommodity"];
            this.secuenciaInicioCommodity = _data["secuenciaInicioCommodity"];
            this.secuenciaFinCommodity = _data["secuenciaFinCommodity"];
            this.isRequiereValidacion = _data["isRequiereValidacion"];
            this.isValidado = _data["isValidado"];
        }
    }

    static fromJS(data: any): DownloadJitDetailReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitDetailReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["ruta"] = this.ruta;
        data["tipoLectura"] = this.tipoLectura;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["secuenciaInicioDolly"] = this.secuenciaInicioDolly;
        data["secuenciaFinDolly"] = this.secuenciaFinDolly;
        data["secuenciaCommodity"] = this.secuenciaCommodity;
        data["secuenciaInicioCommodity"] = this.secuenciaInicioCommodity;
        data["secuenciaFinCommodity"] = this.secuenciaFinCommodity;
        data["isRequiereValidacion"] = this.isRequiereValidacion;
        data["isValidado"] = this.isValidado;
        return data;
    }
}

export interface IDownloadJitDetailReleaseCommand {
    commodity?: number | undefined;
    ruta?: number | undefined;
    tipoLectura?: CommodityReadMode | undefined;
    secuenciaDolly?: number | undefined;
    secuenciaInicioDolly?: number | undefined;
    secuenciaFinDolly?: number | undefined;
    secuenciaCommodity?: number | undefined;
    secuenciaInicioCommodity?: number | undefined;
    secuenciaFinCommodity?: number | undefined;
    isRequiereValidacion: boolean;
    isValidado: boolean;
}

export class DownloadJitActivityReleaseCommand implements IDownloadJitActivityReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IDownloadJitActivityReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadJitActivityReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitActivityReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDownloadJitActivityReleaseCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class DownloadJitIsAvaliableQuery implements IDownloadJitIsAvaliableQuery {
    platform?: number | undefined;
    boxNumber?: string | undefined;

    constructor(data?: IDownloadJitIsAvaliableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.boxNumber = _data["boxNumber"];
        }
    }

    static fromJS(data: any): DownloadJitIsAvaliableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadJitIsAvaliableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["boxNumber"] = this.boxNumber;
        return data;
    }
}

export interface IDownloadJitIsAvaliableQuery {
    platform?: number | undefined;
    boxNumber?: string | undefined;
}

export class EmptyCreateCommand implements IEmptyCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    cantidad?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    actividadList?: EmptyActivityCreateCommand[] | undefined;

    constructor(data?: IEmptyCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.cantidad = _data["cantidad"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(EmptyActivityCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmptyCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["cantidad"] = this.cantidad;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmptyCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    cantidad?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    actividadList?: EmptyActivityCreateCommand[] | undefined;
}

export class EmptyActivityCreateCommand implements IEmptyActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IEmptyActivityCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyActivityCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyActivityCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmptyActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class EmptyCancelCommand implements IEmptyCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    cantidad?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    actividadList?: EmptyActivityCancelCommand[] | undefined;

    constructor(data?: IEmptyCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ventana = _data["ventana"];
            this.numeroCaja = _data["numeroCaja"];
            this.cantidad = _data["cantidad"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(EmptyActivityCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmptyCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ventana"] = this.ventana;
        data["numeroCaja"] = this.numeroCaja;
        data["cantidad"] = this.cantidad;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmptyCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ventana?: number | undefined;
    numeroCaja?: string | undefined;
    cantidad?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    actividadList?: EmptyActivityCancelCommand[] | undefined;
}

export class EmptyActivityCancelCommand implements IEmptyActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IEmptyActivityCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyActivityCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyActivityCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmptyActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class MarketMaxAndMinForEditResponse implements IMarketMaxAndMinForEditResponse {
    id?: number | undefined;
    zoneId!: number;
    zoneDesc?: string | undefined;
    areaId!: number;
    areaDesc?: string | undefined;
    partId!: number;
    partDesc?: string | undefined;
    max!: number;
    min!: number;
    isActive!: boolean;
    partBase?: string | undefined;

    constructor(data?: IMarketMaxAndMinForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaId = _data["areaId"];
            this.areaDesc = _data["areaDesc"];
            this.partId = _data["partId"];
            this.partDesc = _data["partDesc"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.isActive = _data["isActive"];
            this.partBase = _data["partBase"];
        }
    }

    static fromJS(data: any): MarketMaxAndMinForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["zoneDesc"] = this.zoneDesc;
        data["areaId"] = this.areaId;
        data["areaDesc"] = this.areaDesc;
        data["partId"] = this.partId;
        data["partDesc"] = this.partDesc;
        data["max"] = this.max;
        data["min"] = this.min;
        data["isActive"] = this.isActive;
        data["partBase"] = this.partBase;
        return data;
    }
}

export interface IMarketMaxAndMinForEditResponse {
    id?: number | undefined;
    zoneId: number;
    zoneDesc?: string | undefined;
    areaId: number;
    areaDesc?: string | undefined;
    partId: number;
    partDesc?: string | undefined;
    max: number;
    min: number;
    isActive: boolean;
    partBase?: string | undefined;
}

export class MarketMaxAndMinGetForEditQuery implements IMarketMaxAndMinGetForEditQuery {
    id!: number;

    constructor(data?: IMarketMaxAndMinGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MarketMaxAndMinGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMarketMaxAndMinGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfMarketMaxAndMinForListResponse implements IPagedResultDtoOfMarketMaxAndMinForListResponse {
    totalCount!: number;
    items?: MarketMaxAndMinForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMarketMaxAndMinForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketMaxAndMinForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketMaxAndMinForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketMaxAndMinForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMarketMaxAndMinForListResponse {
    totalCount: number;
    items?: MarketMaxAndMinForListResponse[] | undefined;
}

export class MarketMaxAndMinForListResponse implements IMarketMaxAndMinForListResponse {
    id?: number | undefined;
    zoneId!: number;
    zoneDesc?: string | undefined;
    areaId!: number;
    areaDesc?: string | undefined;
    partId!: number;
    partDesc?: string | undefined;
    max!: number;
    min!: number;
    isActive!: boolean;

    constructor(data?: IMarketMaxAndMinForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaId = _data["areaId"];
            this.areaDesc = _data["areaDesc"];
            this.partId = _data["partId"];
            this.partDesc = _data["partDesc"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MarketMaxAndMinForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["zoneDesc"] = this.zoneDesc;
        data["areaId"] = this.areaId;
        data["areaDesc"] = this.areaDesc;
        data["partId"] = this.partId;
        data["partDesc"] = this.partDesc;
        data["max"] = this.max;
        data["min"] = this.min;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMarketMaxAndMinForListResponse {
    id?: number | undefined;
    zoneId: number;
    zoneDesc?: string | undefined;
    areaId: number;
    areaDesc?: string | undefined;
    partId: number;
    partDesc?: string | undefined;
    max: number;
    min: number;
    isActive: boolean;
}

export class MarketMaxAndMinGetListQuery extends PageListByDto implements IMarketMaxAndMinGetListQuery {

    constructor(data?: IMarketMaxAndMinGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MarketMaxAndMinGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMarketMaxAndMinGetListQuery extends IPageListByDto {
}

export class MarketMaxAndMinCreateCommand implements IMarketMaxAndMinCreateCommand {
    id?: number | undefined;
    zoneId?: number | undefined;
    areaId?: number | undefined;
    partId?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IMarketMaxAndMinCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.areaId = _data["areaId"];
            this.partId = _data["partId"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MarketMaxAndMinCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["areaId"] = this.areaId;
        data["partId"] = this.partId;
        data["max"] = this.max;
        data["min"] = this.min;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMarketMaxAndMinCreateCommand {
    id?: number | undefined;
    zoneId?: number | undefined;
    areaId?: number | undefined;
    partId?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    isActive?: boolean | undefined;
}

export class MarketMaxAndMinUpdateCommand implements IMarketMaxAndMinUpdateCommand {
    id?: number | undefined;
    zoneId?: number | undefined;
    areaId?: number | undefined;
    partId?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IMarketMaxAndMinUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.areaId = _data["areaId"];
            this.partId = _data["partId"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MarketMaxAndMinUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MarketMaxAndMinUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["areaId"] = this.areaId;
        data["partId"] = this.partId;
        data["max"] = this.max;
        data["min"] = this.min;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMarketMaxAndMinUpdateCommand {
    id?: number | undefined;
    zoneId?: number | undefined;
    areaId?: number | undefined;
    partId?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    isActive?: boolean | undefined;
}

export class MobileForEditResponse implements IMobileForEditResponse {
    id?: number | undefined;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    usuarios?: number[];

    constructor(data?: IMobileForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imei = _data["imei"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.usuarios = _data["usuarios"] || [];
        }
    }

    static fromJS(data: any): MobileForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MobileForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imei"] = this.imei;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["usuarios"] = this.usuarios;
        return data;
    }
}

export interface IMobileForEditResponse {
    id?: number | undefined;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    usuarios?: number[];
}

export class MobileGetForEditQuery implements IMobileGetForEditQuery {
    id!: number;

    constructor(data?: IMobileGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MobileGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MobileGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMobileGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfMobileForListResponse implements IPagedResultDtoOfMobileForListResponse {
    totalCount!: number;
    items?: MobileForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfMobileForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MobileForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMobileForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMobileForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMobileForListResponse {
    totalCount: number;
    items?: MobileForListResponse[] | undefined;
}

export class MobileForListResponse implements IMobileForListResponse {
    id!: number;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive!: boolean;

    constructor(data?: IMobileForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imei = _data["imei"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MobileForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MobileForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imei"] = this.imei;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMobileForListResponse {
    id: number;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive: boolean;
}

export class MobileGetListQuery extends PageListByDto implements IMobileGetListQuery {

    constructor(data?: IMobileGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MobileGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MobileGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMobileGetListQuery extends IPageListByDto {
}

export class MobileCreateCommand implements IMobileCreateCommand {
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    usuarios?: number[];

    constructor(data?: IMobileCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imei = _data["imei"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.usuarios = _data["usuarios"];
        }
    }

    static fromJS(data: any): MobileCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MobileCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imei"] = this.imei;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["usuarios"] = this.usuarios;
        return data;
    }
}

export interface IMobileCreateCommand {
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class MobileUpdateCommand implements IMobileUpdateCommand {
    id?: number | undefined;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    usuarios?: number[] | [];

    constructor(data?: IMobileUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imei = _data["imei"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
            this.usuarios = _data["usuarios"];
        }
    }

    static fromJS(data: any): MobileUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MobileUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imei"] = this.imei;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        data["usuarios"] = this.usuarios;
        return data;
    }
}

export interface IMobileUpdateCommand {
    id?: number | undefined;
    imei?: string | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
    usuarios?: number[] | [];
}

export class PartForListResponse implements IPartForListResponse {
    id?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    description?: string | undefined;
    fullDescription?: string | undefined;
    isPending!: boolean;
    isPendingDesc?: string | undefined;
    isValidDesc?: string | undefined;
    isConfirmationSupplyDesc?: string | undefined;
    isActive!: boolean;
    isActiveDesc?: string | undefined;
    isTandem!: boolean;

    constructor(data?: IPartForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeDesc = _data["routeDesc"];
            this.prefix = _data["prefix"];
            this.base = _data["base"];
            this.sufix = _data["sufix"];
            this.pieceInspection = _data["pieceInspection"];
            this.partBase = _data["partBase"];
            this.partBaseWithFormat = _data["partBaseWithFormat"];
            this.description = _data["description"];
            this.fullDescription = _data["fullDescription"];
            this.isPending = _data["isPending"];
            this.isPendingDesc = _data["isPendingDesc"];
            this.isValidDesc = _data["isValidDesc"];
            this.isConfirmationSupplyDesc = _data["isConfirmationSupplyDesc"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
            this.isTandem = _data["isTandem"];
        }
    }

    static fromJS(data: any): PartForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeDesc"] = this.routeDesc;
        data["prefix"] = this.prefix;
        data["base"] = this.base;
        data["sufix"] = this.sufix;
        data["pieceInspection"] = this.pieceInspection;
        data["partBase"] = this.partBase;
        data["partBaseWithFormat"] = this.partBaseWithFormat;
        data["description"] = this.description;
        data["fullDescription"] = this.fullDescription;
        data["isPending"] = this.isPending;
        data["isPendingDesc"] = this.isPendingDesc;
        data["isValidDesc"] = this.isValidDesc;
        data["isConfirmationSupplyDesc"] = this.isConfirmationSupplyDesc;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        data["isTandem"] = this.isTandem;
        return data;
    }
}

export interface IPartForListResponse {
    id?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    partBaseWithFormat?: string | undefined;
    description?: string | undefined;
    fullDescription?: string | undefined;
    isPending: boolean;
    isPendingDesc?: string | undefined;
    isValidDesc?: string | undefined;
    isConfirmationSupplyDesc?: string | undefined;
    isActive: boolean;
    isActiveDesc?: string | undefined;
    isTandem: boolean;
}

export class PartGetListAutocompleteQuery implements IPartGetListAutocompleteQuery {
    filter?: string | undefined;

    constructor(data?: IPartGetListAutocompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): PartGetListAutocompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetListAutocompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IPartGetListAutocompleteQuery {
    filter?: string | undefined;
}

export class PagedResultDtoOfPartForListResponse implements IPagedResultDtoOfPartForListResponse {
    totalCount!: number;
    items?: PartForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPartForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPartForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPartForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPartForListResponse {
    totalCount: number;
    items?: PartForListResponse[] | undefined;
}

export class PartGetListQuery extends PageListByDto implements IPartGetListQuery {
    isPending?: boolean | undefined;

    constructor(data?: IPartGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isPending = _data["isPending"];
        }
    }

    static fromJS(data: any): PartGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPending"] = this.isPending;
        super.toJSON(data);
        return data;
    }
}

export interface IPartGetListQuery extends IPageListByDto {
    isPending?: boolean | undefined;
}

export class PartForEditResponse implements IPartForEditResponse {
    id?: number | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    returnableDesc?: string | undefined;
    monitoringDays?: number | undefined;
    isPending!: boolean;
    isValid!: boolean;
    isConfirmationSupply!: boolean;
    isTandem!: boolean;
    isActive!: boolean;
    routeCombo?: ComboboxItemDtoOfLong[] | undefined;
    returnableCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IPartForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.route = _data["route"];
            this.routeDesc = _data["routeDesc"];
            this.prefix = _data["prefix"];
            this.base = _data["base"];
            this.sufix = _data["sufix"];
            this.pieceInspection = _data["pieceInspection"];
            this.partBase = _data["partBase"];
            this.description = _data["description"];
            this.returnable = _data["returnable"];
            this.returnableDesc = _data["returnableDesc"];
            this.monitoringDays = _data["monitoringDays"];
            this.isPending = _data["isPending"];
            this.isValid = _data["isValid"];
            this.isConfirmationSupply = _data["isConfirmationSupply"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["routeCombo"])) {
                this.routeCombo = [] as any;
                for (let item of _data["routeCombo"])
                    this.routeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["returnableCombo"])) {
                this.returnableCombo = [] as any;
                for (let item of _data["returnableCombo"])
                    this.returnableCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["route"] = this.route;
        data["routeDesc"] = this.routeDesc;
        data["prefix"] = this.prefix;
        data["base"] = this.base;
        data["sufix"] = this.sufix;
        data["pieceInspection"] = this.pieceInspection;
        data["partBase"] = this.partBase;
        data["description"] = this.description;
        data["returnable"] = this.returnable;
        data["returnableDesc"] = this.returnableDesc;
        data["monitoringDays"] = this.monitoringDays;
        data["isPending"] = this.isPending;
        data["isValid"] = this.isValid;
        data["isConfirmationSupply"] = this.isConfirmationSupply;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.routeCombo)) {
            data["routeCombo"] = [];
            for (let item of this.routeCombo)
                data["routeCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.returnableCombo)) {
            data["returnableCombo"] = [];
            for (let item of this.returnableCombo)
                data["returnableCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartForEditResponse {
    id?: number | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    returnableDesc?: string | undefined;
    monitoringDays?: number | undefined;
    isPending: boolean;
    isValid: boolean;
    isConfirmationSupply: boolean;
    isTandem: boolean;
    isActive: boolean;
    routeCombo?: ComboboxItemDtoOfLong[] | undefined;
    returnableCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class PartGetForEditQuery implements IPartGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IPartGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PartGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPartGetForEditQuery {
    id?: number | undefined;
}

export class PartCreateCommand implements IPartCreateCommand {
    route?: number | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    monitoringDays?: number | undefined;
    isValid!: boolean;
    isConfirmationSupply!: boolean;
    isTandem!: boolean;
    isActive!: boolean;

    constructor(data?: IPartCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"];
            this.prefix = _data["prefix"];
            this.base = _data["base"];
            this.sufix = _data["sufix"];
            this.pieceInspection = _data["pieceInspection"];
            this.description = _data["description"];
            this.returnable = _data["returnable"];
            this.monitoringDays = _data["monitoringDays"];
            this.isValid = _data["isValid"];
            this.isConfirmationSupply = _data["isConfirmationSupply"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PartCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PartCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route;
        data["prefix"] = this.prefix;
        data["base"] = this.base;
        data["sufix"] = this.sufix;
        data["pieceInspection"] = this.pieceInspection;
        data["description"] = this.description;
        data["returnable"] = this.returnable;
        data["monitoringDays"] = this.monitoringDays;
        data["isValid"] = this.isValid;
        data["isConfirmationSupply"] = this.isConfirmationSupply;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPartCreateCommand {
    route?: number | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    monitoringDays?: number | undefined;
    isValid: boolean;
    isConfirmationSupply: boolean;
    isTandem: boolean;
    isActive: boolean;
}

export class PartUpdateCommand implements IPartUpdateCommand {
    id!: number;
    route?: number | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    monitoringDays?: number | undefined;
    isValid!: boolean;
    isConfirmationSupply!: boolean;
    isTandem!: boolean;
    isActive!: boolean;

    constructor(data?: IPartUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.route = _data["route"];
            this.prefix = _data["prefix"];
            this.base = _data["base"];
            this.sufix = _data["sufix"];
            this.pieceInspection = _data["pieceInspection"];
            this.description = _data["description"];
            this.returnable = _data["returnable"];
            this.monitoringDays = _data["monitoringDays"];
            this.isValid = _data["isValid"];
            this.isConfirmationSupply = _data["isConfirmationSupply"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PartUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PartUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["route"] = this.route;
        data["prefix"] = this.prefix;
        data["base"] = this.base;
        data["sufix"] = this.sufix;
        data["pieceInspection"] = this.pieceInspection;
        data["description"] = this.description;
        data["returnable"] = this.returnable;
        data["monitoringDays"] = this.monitoringDays;
        data["isValid"] = this.isValid;
        data["isConfirmationSupply"] = this.isConfirmationSupply;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPartUpdateCommand {
    id: number;
    route?: number | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    monitoringDays?: number | undefined;
    isValid: boolean;
    isConfirmationSupply: boolean;
    isTandem: boolean;
    isActive: boolean;
}

export class PartResponse implements IPartResponse {
    id?: number | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    returnableDesc?: string | undefined;
    monitoringDays?: number | undefined;
    isPending!: boolean;
    isValid!: boolean;
    isConfirmationSupply!: boolean;
    isTandem!: boolean;
    isActive!: boolean;

    constructor(data?: IPartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.route = _data["route"];
            this.routeDesc = _data["routeDesc"];
            this.prefix = _data["prefix"];
            this.base = _data["base"];
            this.sufix = _data["sufix"];
            this.pieceInspection = _data["pieceInspection"];
            this.partBase = _data["partBase"];
            this.description = _data["description"];
            this.returnable = _data["returnable"];
            this.returnableDesc = _data["returnableDesc"];
            this.monitoringDays = _data["monitoringDays"];
            this.isPending = _data["isPending"];
            this.isValid = _data["isValid"];
            this.isConfirmationSupply = _data["isConfirmationSupply"];
            this.isTandem = _data["isTandem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["route"] = this.route;
        data["routeDesc"] = this.routeDesc;
        data["prefix"] = this.prefix;
        data["base"] = this.base;
        data["sufix"] = this.sufix;
        data["pieceInspection"] = this.pieceInspection;
        data["partBase"] = this.partBase;
        data["description"] = this.description;
        data["returnable"] = this.returnable;
        data["returnableDesc"] = this.returnableDesc;
        data["monitoringDays"] = this.monitoringDays;
        data["isPending"] = this.isPending;
        data["isValid"] = this.isValid;
        data["isConfirmationSupply"] = this.isConfirmationSupply;
        data["isTandem"] = this.isTandem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPartResponse {
    id?: number | undefined;
    route?: number | undefined;
    routeDesc?: string | undefined;
    prefix?: string | undefined;
    base?: string | undefined;
    sufix?: string | undefined;
    pieceInspection?: string | undefined;
    partBase?: string | undefined;
    description?: string | undefined;
    returnable?: number | undefined;
    returnableDesc?: string | undefined;
    monitoringDays?: number | undefined;
    isPending: boolean;
    isValid: boolean;
    isConfirmationSupply: boolean;
    isTandem: boolean;
    isActive: boolean;
}

export class PartGetForAssortmentQuery implements IPartGetForAssortmentQuery {
    ubicacion?: number | undefined;
    parteBase?: string | undefined;

    constructor(data?: IPartGetForAssortmentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ubicacion = _data["ubicacion"];
            this.parteBase = _data["parteBase"];
        }
    }

    static fromJS(data: any): PartGetForAssortmentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetForAssortmentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ubicacion"] = this.ubicacion;
        data["parteBase"] = this.parteBase;
        return data;
    }
}

export interface IPartGetForAssortmentQuery {
    ubicacion?: number | undefined;
    parteBase?: string | undefined;
}

export class PartGetByIdQuery implements IPartGetByIdQuery {
    id!: number;

    constructor(data?: IPartGetByIdQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PartGetByIdQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetByIdQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPartGetByIdQuery {
    id: number;
}

export class PartGetByPartBaseQuery2 implements IPartGetByPartBaseQuery2 {
    partBase?: string | undefined;

    constructor(data?: IPartGetByPartBaseQuery2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partBase = _data["partBase"];
        }
    }

    static fromJS(data: any): PartGetByPartBaseQuery2 {
        data = typeof data === 'object' ? data : {};
        let result = new PartGetByPartBaseQuery2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partBase"] = this.partBase;
        return data;
    }
}

export interface IPartGetByPartBaseQuery2 {
    partBase?: string | undefined;
}

export class PagedResultDtoOfPartLocationForListResponse implements IPagedResultDtoOfPartLocationForListResponse {
    totalCount!: number;
    items?: PartLocationForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfPartLocationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartLocationForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPartLocationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPartLocationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPartLocationForListResponse {
    totalCount: number;
    items?: PartLocationForListResponse[] | undefined;
}

export class PartLocationForListResponse implements IPartLocationForListResponse {
    id?: number | undefined;
    part!: number;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    location!: number;
    locationTypeDesc?: string | undefined;
    locationDesc?: string | undefined;
    locationKey?: string | undefined;

    constructor(data?: IPartLocationForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.part = _data["part"];
            this.zoneDesc = _data["zoneDesc"];
            this.areaDesc = _data["areaDesc"];
            this.location = _data["location"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.locationDesc = _data["locationDesc"];
            this.locationKey = _data["locationKey"];
        }
    }

    static fromJS(data: any): PartLocationForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["part"] = this.part;
        data["zoneDesc"] = this.zoneDesc;
        data["areaDesc"] = this.areaDesc;
        data["location"] = this.location;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["locationDesc"] = this.locationDesc;
        data["locationKey"] = this.locationKey;
        return data;
    }
}

export interface IPartLocationForListResponse {
    id?: number | undefined;
    part: number;
    zoneDesc?: string | undefined;
    areaDesc?: string | undefined;
    location: number;
    locationTypeDesc?: string | undefined;
    locationDesc?: string | undefined;
    locationKey?: string | undefined;
}

export class PartLocationGetListQuery extends PageListByDto implements IPartLocationGetListQuery {
    part?: number | undefined;

    constructor(data?: IPartLocationGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): PartLocationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["part"] = this.part;
        super.toJSON(data);
        return data;
    }
}

export interface IPartLocationGetListQuery extends IPageListByDto {
    part?: number | undefined;
}

export class PartLocationGetListByPartQuery implements IPartLocationGetListByPartQuery {
    part!: number;

    constructor(data?: IPartLocationGetListByPartQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): PartLocationGetListByPartQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationGetListByPartQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["part"] = this.part;
        return data;
    }
}

export interface IPartLocationGetListByPartQuery {
    part: number;
}

export class PartLocationForEditResponse implements IPartLocationForEditResponse {
    id?: number | undefined;
    part!: number;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    locationType!: number;
    locationTypeDesc?: string | undefined;
    location!: number;
    locationDesc?: string | undefined;
    locationKey?: string | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    locationTypeCombo?: ComboboxItemDtoOfLong[] | undefined;

    constructor(data?: IPartLocationForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.part = _data["part"];
            this.zone = _data["zone"];
            this.zoneDesc = _data["zoneDesc"];
            this.area = _data["area"];
            this.areaDesc = _data["areaDesc"];
            this.locationType = _data["locationType"];
            this.locationTypeDesc = _data["locationTypeDesc"];
            this.location = _data["location"];
            this.locationDesc = _data["locationDesc"];
            this.locationKey = _data["locationKey"];
            if (Array.isArray(_data["zoneCombo"])) {
                this.zoneCombo = [] as any;
                for (let item of _data["zoneCombo"])
                    this.zoneCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
            if (Array.isArray(_data["locationTypeCombo"])) {
                this.locationTypeCombo = [] as any;
                for (let item of _data["locationTypeCombo"])
                    this.locationTypeCombo!.push(ComboboxItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartLocationForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["part"] = this.part;
        data["zone"] = this.zone;
        data["zoneDesc"] = this.zoneDesc;
        data["area"] = this.area;
        data["areaDesc"] = this.areaDesc;
        data["locationType"] = this.locationType;
        data["locationTypeDesc"] = this.locationTypeDesc;
        data["location"] = this.location;
        data["locationDesc"] = this.locationDesc;
        data["locationKey"] = this.locationKey;
        if (Array.isArray(this.zoneCombo)) {
            data["zoneCombo"] = [];
            for (let item of this.zoneCombo)
                data["zoneCombo"].push(item.toJSON());
        }
        if (Array.isArray(this.locationTypeCombo)) {
            data["locationTypeCombo"] = [];
            for (let item of this.locationTypeCombo)
                data["locationTypeCombo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartLocationForEditResponse {
    id?: number | undefined;
    part: number;
    zone?: number | undefined;
    zoneDesc?: string | undefined;
    area?: number | undefined;
    areaDesc?: string | undefined;
    locationType: number;
    locationTypeDesc?: string | undefined;
    location: number;
    locationDesc?: string | undefined;
    locationKey?: string | undefined;
    zoneCombo?: ComboboxItemDtoOfLong[] | undefined;
    locationTypeCombo?: ComboboxItemDtoOfLong[] | undefined;
}

export class PartLocationGetForEditQuery implements IPartLocationGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IPartLocationGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PartLocationGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPartLocationGetForEditQuery {
    id?: number | undefined;
}

export class PartLocationCreateCommand implements IPartLocationCreateCommand {
    part!: number;
    location!: number;

    constructor(data?: IPartLocationCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.part = _data["part"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): PartLocationCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["part"] = this.part;
        data["location"] = this.location;
        return data;
    }
}

export interface IPartLocationCreateCommand {
    part: number;
    location: number;
}

export class PartPackagePatternResponse implements IPartPackagePatternResponse {
    partList?: string[] | undefined;
    quantityList?: string[] | undefined;
    dateList?: string[] | undefined;
    serieList?: string[] | undefined;

    constructor(data?: IPartPackagePatternResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partList"])) {
                this.partList = [] as any;
                for (let item of _data["partList"])
                    this.partList!.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList!.push(item);
            }
            if (Array.isArray(_data["dateList"])) {
                this.dateList = [] as any;
                for (let item of _data["dateList"])
                    this.dateList!.push(item);
            }
            if (Array.isArray(_data["serieList"])) {
                this.serieList = [] as any;
                for (let item of _data["serieList"])
                    this.serieList!.push(item);
            }
        }
    }

    static fromJS(data: any): PartPackagePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartPackagePatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partList)) {
            data["partList"] = [];
            for (let item of this.partList)
                data["partList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        if (Array.isArray(this.dateList)) {
            data["dateList"] = [];
            for (let item of this.dateList)
                data["dateList"].push(item);
        }
        if (Array.isArray(this.serieList)) {
            data["serieList"] = [];
            for (let item of this.serieList)
                data["serieList"].push(item);
        }
        return data;
    }
}

export interface IPartPackagePatternResponse {
    partList?: string[] | undefined;
    quantityList?: string[] | undefined;
    dateList?: string[] | undefined;
    serieList?: string[] | undefined;
}

export class PartImportCommand implements IPartImportCommand {
    base64?: string | undefined;

    constructor(data?: IPartImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): PartImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PartImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IPartImportCommand {
    base64?: string | undefined;
}

export class ProviderForEditResponse implements IProviderForEditResponse {
    id?: number | undefined;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound!: boolean;
    isCampus!: boolean;
    isActive?: boolean | undefined;

    constructor(data?: IProviderForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clave = _data["clave"];
            this.descripcion = _data["descripcion"];
            this.isInbound = _data["isInbound"];
            this.isCampus = _data["isCampus"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProviderForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clave"] = this.clave;
        data["descripcion"] = this.descripcion;
        data["isInbound"] = this.isInbound;
        data["isCampus"] = this.isCampus;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProviderForEditResponse {
    id?: number | undefined;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound: boolean;
    isCampus: boolean;
    isActive?: boolean | undefined;
}

export class ProviderGetForEditQuery implements IProviderGetForEditQuery {
    id!: number;

    constructor(data?: IProviderGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProviderGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProviderGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfProviderForListResponse implements IPagedResultDtoOfProviderForListResponse {
    totalCount!: number;
    items?: ProviderForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfProviderForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProviderForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProviderForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProviderForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfProviderForListResponse {
    totalCount: number;
    items?: ProviderForListResponse[] | undefined;
}

export class ProviderForListResponse implements IProviderForListResponse {
    id!: number;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isActive!: boolean;

    constructor(data?: IProviderForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clave = _data["clave"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProviderForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clave"] = this.clave;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProviderForListResponse {
    id: number;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isActive: boolean;
}

export class ProviderGetListQuery extends PageListByDto implements IProviderGetListQuery {

    constructor(data?: IProviderGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProviderGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProviderGetListQuery extends IPageListByDto {
}

export class ProviderCreateCommand implements IProviderCreateCommand {
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound!: boolean;
    isCampus!: boolean;
    isActive?: boolean | undefined;

    constructor(data?: IProviderCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clave = _data["clave"];
            this.descripcion = _data["descripcion"];
            this.isInbound = _data["isInbound"];
            this.isCampus = _data["isCampus"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProviderCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clave"] = this.clave;
        data["descripcion"] = this.descripcion;
        data["isInbound"] = this.isInbound;
        data["isCampus"] = this.isCampus;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProviderCreateCommand {
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound: boolean;
    isCampus: boolean;
    isActive?: boolean | undefined;
}

export class ProviderUpdateCommand implements IProviderUpdateCommand {
    id?: number | undefined;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound!: boolean;
    isCampus!: boolean;
    isActive?: boolean | undefined;

    constructor(data?: IProviderUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clave = _data["clave"];
            this.descripcion = _data["descripcion"];
            this.isInbound = _data["isInbound"];
            this.isCampus = _data["isCampus"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProviderUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clave"] = this.clave;
        data["descripcion"] = this.descripcion;
        data["isInbound"] = this.isInbound;
        data["isCampus"] = this.isCampus;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProviderUpdateCommand {
    id?: number | undefined;
    clave?: string | undefined;
    descripcion?: string | undefined;
    isInbound: boolean;
    isCampus: boolean;
    isActive?: boolean | undefined;
}

export class PutawayCreateCommand implements IPutawayCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    autorizadorUbicacion?: number | undefined;
    fechaAutorizacionUbicacion?: moment.Moment | undefined;
    fechaBaseAutorizacionUbicacion?: moment.Moment | undefined;
    detalleList?: PutawayDetailCreateCommand[] | undefined;
    actividadList?: PutawayActivityCreateCommand[] | undefined;

    constructor(data?: IPutawayCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ubicacionInicial = _data["ubicacionInicial"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.autorizadorUbicacion = _data["autorizadorUbicacion"];
            this.fechaAutorizacionUbicacion = _data["fechaAutorizacionUbicacion"] ? moment(_data["fechaAutorizacionUbicacion"].toString()) : <any>undefined;
            this.fechaBaseAutorizacionUbicacion = _data["fechaBaseAutorizacionUbicacion"] ? moment(_data["fechaBaseAutorizacionUbicacion"].toString()) : <any>undefined;
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(PutawayDetailCreateCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(PutawayActivityCreateCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PutawayCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ubicacionInicial"] = this.ubicacionInicial;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["autorizadorUbicacion"] = this.autorizadorUbicacion;
        data["fechaAutorizacionUbicacion"] = this.fechaAutorizacionUbicacion ? this.fechaAutorizacionUbicacion.toISOString() : <any>undefined;
        data["fechaBaseAutorizacionUbicacion"] = this.fechaBaseAutorizacionUbicacion ? this.fechaBaseAutorizacionUbicacion.toISOString() : <any>undefined;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPutawayCreateCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    autorizadorUbicacion?: number | undefined;
    fechaAutorizacionUbicacion?: moment.Moment | undefined;
    fechaBaseAutorizacionUbicacion?: moment.Moment | undefined;
    detalleList?: PutawayDetailCreateCommand[] | undefined;
    actividadList?: PutawayActivityCreateCommand[] | undefined;
}

export class PutawayDetailCreateCommand implements IPutawayDetailCreateCommand {
    usuarioEntrego?: number | undefined;
    ubicacionFinal?: number | undefined;
    parte?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    usuarioAutorizador?: number | undefined;
    fechaAutorizacion?: moment.Moment | undefined;
    fechaBaseAutorizacion?: moment.Moment | undefined;

    constructor(data?: IPutawayDetailCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usuarioEntrego = _data["usuarioEntrego"];
            this.ubicacionFinal = _data["ubicacionFinal"];
            this.parte = _data["parte"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            this.fechaAutorizacion = _data["fechaAutorizacion"] ? moment(_data["fechaAutorizacion"].toString()) : <any>undefined;
            this.fechaBaseAutorizacion = _data["fechaBaseAutorizacion"] ? moment(_data["fechaBaseAutorizacion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PutawayDetailCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayDetailCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usuarioEntrego"] = this.usuarioEntrego;
        data["ubicacionFinal"] = this.ubicacionFinal;
        data["parte"] = this.parte;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        data["fechaAutorizacion"] = this.fechaAutorizacion ? this.fechaAutorizacion.toISOString() : <any>undefined;
        data["fechaBaseAutorizacion"] = this.fechaBaseAutorizacion ? this.fechaBaseAutorizacion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPutawayDetailCreateCommand {
    usuarioEntrego?: number | undefined;
    ubicacionFinal?: number | undefined;
    parte?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    usuarioAutorizador?: number | undefined;
    fechaAutorizacion?: moment.Moment | undefined;
    fechaBaseAutorizacion?: moment.Moment | undefined;
}

export class PutawayActivityCreateCommand implements IPutawayActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IPutawayActivityCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PutawayActivityCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayActivityCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPutawayActivityCreateCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class PutawayCancelCommand implements IPutawayCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorUbicacion?: number | undefined;
    fechaAutorizacionUbicacion?: moment.Moment | undefined;
    fechaBaseAutorizacionUbicacion?: moment.Moment | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: PutawayDetailCancelCommand[] | undefined;
    actividadList?: PutawayActivityCancelCommand[] | undefined;

    constructor(data?: IPutawayCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.turno = _data["turno"];
            this.ubicacionInicial = _data["ubicacionInicial"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.motivoSuspension = _data["motivoSuspension"];
            this.autorizadorUbicacion = _data["autorizadorUbicacion"];
            this.fechaAutorizacionUbicacion = _data["fechaAutorizacionUbicacion"] ? moment(_data["fechaAutorizacionUbicacion"].toString()) : <any>undefined;
            this.fechaBaseAutorizacionUbicacion = _data["fechaBaseAutorizacionUbicacion"] ? moment(_data["fechaBaseAutorizacionUbicacion"].toString()) : <any>undefined;
            this.usuarioAutorizador = _data["usuarioAutorizador"];
            if (Array.isArray(_data["detalleList"])) {
                this.detalleList = [] as any;
                for (let item of _data["detalleList"])
                    this.detalleList!.push(PutawayDetailCancelCommand.fromJS(item));
            }
            if (Array.isArray(_data["actividadList"])) {
                this.actividadList = [] as any;
                for (let item of _data["actividadList"])
                    this.actividadList!.push(PutawayActivityCancelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PutawayCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["turno"] = this.turno;
        data["ubicacionInicial"] = this.ubicacionInicial;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["motivoSuspension"] = this.motivoSuspension;
        data["autorizadorUbicacion"] = this.autorizadorUbicacion;
        data["fechaAutorizacionUbicacion"] = this.fechaAutorizacionUbicacion ? this.fechaAutorizacionUbicacion.toISOString() : <any>undefined;
        data["fechaBaseAutorizacionUbicacion"] = this.fechaBaseAutorizacionUbicacion ? this.fechaBaseAutorizacionUbicacion.toISOString() : <any>undefined;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        if (Array.isArray(this.detalleList)) {
            data["detalleList"] = [];
            for (let item of this.detalleList)
                data["detalleList"].push(item.toJSON());
        }
        if (Array.isArray(this.actividadList)) {
            data["actividadList"] = [];
            for (let item of this.actividadList)
                data["actividadList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPutawayCancelCommand {
    sesionMovil?: number | undefined;
    turno?: number | undefined;
    ubicacionInicial?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    motivoSuspension?: number | undefined;
    autorizadorUbicacion?: number | undefined;
    fechaAutorizacionUbicacion?: moment.Moment | undefined;
    fechaBaseAutorizacionUbicacion?: moment.Moment | undefined;
    usuarioAutorizador?: number | undefined;
    detalleList?: PutawayDetailCancelCommand[] | undefined;
    actividadList?: PutawayActivityCancelCommand[] | undefined;
}

export class PutawayDetailCancelCommand implements IPutawayDetailCancelCommand {
    usuarioEntrego?: number | undefined;
    ubicacionFinal?: number | undefined;
    parte?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    usuarioAutorizador?: number | undefined;

    constructor(data?: IPutawayDetailCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usuarioEntrego = _data["usuarioEntrego"];
            this.ubicacionFinal = _data["ubicacionFinal"];
            this.parte = _data["parte"];
            this.cantidad = _data["cantidad"];
            this.serie = _data["serie"];
            this.usuarioAutorizador = _data["usuarioAutorizador"];
        }
    }

    static fromJS(data: any): PutawayDetailCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayDetailCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usuarioEntrego"] = this.usuarioEntrego;
        data["ubicacionFinal"] = this.ubicacionFinal;
        data["parte"] = this.parte;
        data["cantidad"] = this.cantidad;
        data["serie"] = this.serie;
        data["usuarioAutorizador"] = this.usuarioAutorizador;
        return data;
    }
}

export interface IPutawayDetailCancelCommand {
    usuarioEntrego?: number | undefined;
    ubicacionFinal?: number | undefined;
    parte?: number | undefined;
    cantidad?: number | undefined;
    serie?: string | undefined;
    usuarioAutorizador?: number | undefined;
}

export class PutawayActivityCancelCommand implements IPutawayActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;

    constructor(data?: IPutawayActivityCancelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoActividad = _data["tipoActividad"];
            this.tipoActividadClaveInterna = _data["tipoActividadClaveInterna"];
            this.turno = _data["turno"];
            this.fechaInicio = _data["fechaInicio"] ? moment(_data["fechaInicio"].toString()) : <any>undefined;
            this.fechaInicioBase = _data["fechaInicioBase"] ? moment(_data["fechaInicioBase"].toString()) : <any>undefined;
            this.fechaFin = _data["fechaFin"] ? moment(_data["fechaFin"].toString()) : <any>undefined;
            this.fechaFinBase = _data["fechaFinBase"] ? moment(_data["fechaFinBase"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PutawayActivityCancelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutawayActivityCancelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoActividad"] = this.tipoActividad;
        data["tipoActividadClaveInterna"] = this.tipoActividadClaveInterna;
        data["turno"] = this.turno;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["fechaInicioBase"] = this.fechaInicioBase ? this.fechaInicioBase.toISOString() : <any>undefined;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : <any>undefined;
        data["fechaFinBase"] = this.fechaFinBase ? this.fechaFinBase.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPutawayActivityCancelCommand {
    tipoActividad?: number | undefined;
    tipoActividadClaveInterna?: string | undefined;
    turno?: number | undefined;
    fechaInicio?: moment.Moment | undefined;
    fechaInicioBase?: moment.Moment | undefined;
    fechaFin?: moment.Moment | undefined;
    fechaFinBase?: moment.Moment | undefined;
}

export class ReasonSuspensionForEditResponse implements IReasonSuspensionForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isDefaultLock!: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;

    constructor(data?: IReasonSuspensionForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isDefaultLock = _data["isDefaultLock"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["proceses"])) {
                this.proceses = [] as any;
                for (let item of _data["proceses"])
                    this.proceses!.push(ReasonSuspensionProcessResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReasonSuspensionForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isDefaultLock"] = this.isDefaultLock;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.proceses)) {
            data["proceses"] = [];
            for (let item of this.proceses)
                data["proceses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReasonSuspensionForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isDefaultLock: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;
}

export class ReasonSuspensionProcessResponse implements IReasonSuspensionProcessResponse {
    id?: number | undefined;
    reason!: number;
    process!: number;
    processDesc?: string | undefined;

    constructor(data?: IReasonSuspensionProcessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.process = _data["process"];
            this.processDesc = _data["processDesc"];
        }
    }

    static fromJS(data: any): ReasonSuspensionProcessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionProcessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["process"] = this.process;
        data["processDesc"] = this.processDesc;
        return data;
    }
}

export interface IReasonSuspensionProcessResponse {
    id?: number | undefined;
    reason: number;
    process: number;
    processDesc?: string | undefined;
}

export class ReasonSuspensionGetForEditQuery implements IReasonSuspensionGetForEditQuery {
    id?: number | undefined;

    constructor(data?: IReasonSuspensionGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReasonSuspensionGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IReasonSuspensionGetForEditQuery {
    id?: number | undefined;
}

export class PagedResultDtoOfReasonSuspensionForListResponse implements IPagedResultDtoOfReasonSuspensionForListResponse {
    totalCount!: number;
    items?: ReasonSuspensionForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReasonSuspensionForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReasonSuspensionForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReasonSuspensionForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReasonSuspensionForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReasonSuspensionForListResponse {
    totalCount: number;
    items?: ReasonSuspensionForListResponse[] | undefined;
}

export class ReasonSuspensionForListResponse implements IReasonSuspensionForListResponse {
    id!: number;
    descripcion?: string | undefined;
    isDefaultLock!: boolean;
    isDefaultLockDesc?: string | undefined;
    isActive!: boolean;

    constructor(data?: IReasonSuspensionForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isDefaultLock = _data["isDefaultLock"];
            this.isDefaultLockDesc = _data["isDefaultLockDesc"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReasonSuspensionForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isDefaultLock"] = this.isDefaultLock;
        data["isDefaultLockDesc"] = this.isDefaultLockDesc;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReasonSuspensionForListResponse {
    id: number;
    descripcion?: string | undefined;
    isDefaultLock: boolean;
    isDefaultLockDesc?: string | undefined;
    isActive: boolean;
}

export class ReasonSuspensionGetListQuery extends PageListByDto implements IReasonSuspensionGetListQuery {

    constructor(data?: IReasonSuspensionGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReasonSuspensionGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReasonSuspensionGetListQuery extends IPageListByDto {
}

export class ReasonSuspensionCreateCommand implements IReasonSuspensionCreateCommand {
    descripcion?: string | undefined;
    isDefaultLock!: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;

    constructor(data?: IReasonSuspensionCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.isDefaultLock = _data["isDefaultLock"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["proceses"])) {
                this.proceses = [] as any;
                for (let item of _data["proceses"])
                    this.proceses!.push(ReasonSuspensionProcessResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReasonSuspensionCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        data["isDefaultLock"] = this.isDefaultLock;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.proceses)) {
            data["proceses"] = [];
            for (let item of this.proceses)
                data["proceses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReasonSuspensionCreateCommand {
    descripcion?: string | undefined;
    isDefaultLock: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;
}

export class ReasonSuspensionUpdateCommand implements IReasonSuspensionUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isDefaultLock!: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;

    constructor(data?: IReasonSuspensionUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isDefaultLock = _data["isDefaultLock"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["proceses"])) {
                this.proceses = [] as any;
                for (let item of _data["proceses"])
                    this.proceses!.push(ReasonSuspensionProcessResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReasonSuspensionUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isDefaultLock"] = this.isDefaultLock;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.proceses)) {
            data["proceses"] = [];
            for (let item of this.proceses)
                data["proceses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReasonSuspensionUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isDefaultLock: boolean;
    isActive?: boolean | undefined;
    proceses?: ReasonSuspensionProcessResponse[] | undefined;
}

export class ReasonSuspensionGetComboQuery implements IReasonSuspensionGetComboQuery {
    filter?: string | undefined;
    processSuspensionKey?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IReasonSuspensionGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.processSuspensionKey = _data["processSuspensionKey"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReasonSuspensionGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSuspensionGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["processSuspensionKey"] = this.processSuspensionKey;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReasonSuspensionGetComboQuery {
    filter?: string | undefined;
    processSuspensionKey?: number | undefined;
    isActive?: boolean | undefined;
}

export class ReturnableForEditResponse implements IReturnableForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IReturnableForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReturnableForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReturnableForEditResponse {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
}

export class ReturnableGetForEditQuery implements IReturnableGetForEditQuery {
    id!: number;

    constructor(data?: IReturnableGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReturnableGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IReturnableGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfReturnableForListResponse implements IPagedResultDtoOfReturnableForListResponse {
    totalCount!: number;
    items?: ReturnableForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfReturnableForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReturnableForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReturnableForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReturnableForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReturnableForListResponse {
    totalCount: number;
    items?: ReturnableForListResponse[] | undefined;
}

export class ReturnableForListResponse implements IReturnableForListResponse {
    id!: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IReturnableForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReturnableForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReturnableForListResponse {
    id: number;
    key?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export class ReturnableGetListQuery extends PageListByDto implements IReturnableGetListQuery {

    constructor(data?: IReturnableGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReturnableGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReturnableGetListQuery extends IPageListByDto {
}

export class ReturnableCreateCommand implements IReturnableCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IReturnableCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReturnableCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReturnableCreateCommand {
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
}

export class ReturnableUpdateCommand implements IReturnableUpdateCommand {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IReturnableUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ReturnableUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnableUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IReturnableUpdateCommand {
    id?: number | undefined;
    key?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
}

export class StoreMovementTypeForEditResponse implements IStoreMovementTypeForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStoreMovementTypeForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeForEditResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class StoreMovementTypeGetForEditQuery implements IStoreMovementTypeGetForEditQuery {
    id!: number;

    constructor(data?: IStoreMovementTypeGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StoreMovementTypeGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IStoreMovementTypeGetForEditQuery {
    id: number;
}

export class PagedResultDtoOfStoreMovementTypeForListResponse implements IPagedResultDtoOfStoreMovementTypeForListResponse {
    totalCount!: number;
    items?: StoreMovementTypeForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfStoreMovementTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StoreMovementTypeForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStoreMovementTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStoreMovementTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStoreMovementTypeForListResponse {
    totalCount: number;
    items?: StoreMovementTypeForListResponse[] | undefined;
}

export class StoreMovementTypeForListResponse implements IStoreMovementTypeForListResponse {
    id!: number;
    descripcion?: string | undefined;
    isActive!: boolean;

    constructor(data?: IStoreMovementTypeForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeForListResponse {
    id: number;
    descripcion?: string | undefined;
    isActive: boolean;
}

export class StoreMovementTypeGetListQuery extends PageListByDto implements IStoreMovementTypeGetListQuery {

    constructor(data?: IStoreMovementTypeGetListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StoreMovementTypeGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStoreMovementTypeGetListQuery extends IPageListByDto {
}

export class StoreMovementTypeResponse implements IStoreMovementTypeResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStoreMovementTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeResponse {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class StoreMovementTypeCreateCommand implements IStoreMovementTypeCreateCommand {
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStoreMovementTypeCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeCreateCommand {
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class StoreMovementTypeUpdateCommand implements IStoreMovementTypeUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStoreMovementTypeUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeUpdateCommand {
    id?: number | undefined;
    descripcion?: string | undefined;
    isActive?: boolean | undefined;
}

export class StoreMovementTypeGetComboQuery implements IStoreMovementTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStoreMovementTypeGetComboQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StoreMovementTypeGetComboQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMovementTypeGetComboQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStoreMovementTypeGetComboQuery {
    filter?: string | undefined;
    isActive?: boolean | undefined;
}

export class SupplyCardPartForListResponse implements ISupplyCardPartForListResponse {
    id!: number;
    route!: number;
    routeDesc?: string | undefined;
    part!: number;
    partDesc?: string | undefined;
    partBase?: string | undefined;
    totalEmpty!: number;
    totalLoaded!: number;
    totalDelivered!: number;

    constructor(data?: ISupplyCardPartForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.route = _data["route"];
            this.routeDesc = _data["routeDesc"];
            this.part = _data["part"];
            this.partDesc = _data["partDesc"];
            this.partBase = _data["partBase"];
            this.totalEmpty = _data["totalEmpty"];
            this.totalLoaded = _data["totalLoaded"];
            this.totalDelivered = _data["totalDelivered"];
        }
    }

    static fromJS(data: any): SupplyCardPartForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardPartForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["route"] = this.route;
        data["routeDesc"] = this.routeDesc;
        data["part"] = this.part;
        data["partDesc"] = this.partDesc;
        data["partBase"] = this.partBase;
        data["totalEmpty"] = this.totalEmpty;
        data["totalLoaded"] = this.totalLoaded;
        data["totalDelivered"] = this.totalDelivered;
        return data;
    }
}

export interface ISupplyCardPartForListResponse {
    id: number;
    route: number;
    routeDesc?: string | undefined;
    part: number;
    partDesc?: string | undefined;
    partBase?: string | undefined;
    totalEmpty: number;
    totalLoaded: number;
    totalDelivered: number;
}

export class SupplyCardPartGetByRouteListQuery implements ISupplyCardPartGetByRouteListQuery {
    route!: number;

    constructor(data?: ISupplyCardPartGetByRouteListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): SupplyCardPartGetByRouteListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardPartGetByRouteListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route;
        return data;
    }
}

export interface ISupplyCardPartGetByRouteListQuery {
    route: number;
}

export class SupplyCardEmptyCreateCommand implements ISupplyCardEmptyCreateCommand {
    sesionMovil?: number | undefined;
    route?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    workShift?: number | undefined;

    constructor(data?: ISupplyCardEmptyCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.route = _data["route"];
            this.part = _data["part"];
            this.serie = _data["serie"];
            this.workShift = _data["workShift"];
        }
    }

    static fromJS(data: any): SupplyCardEmptyCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardEmptyCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["route"] = this.route;
        data["part"] = this.part;
        data["serie"] = this.serie;
        data["workShift"] = this.workShift;
        return data;
    }
}

export interface ISupplyCardEmptyCreateCommand {
    sesionMovil?: number | undefined;
    route?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    workShift?: number | undefined;
}

export class SupplyCardLoadCreateCommand implements ISupplyCardLoadCreateCommand {
    sesionMovil?: number | undefined;
    route?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    workShift?: number | undefined;
    quantity?: number | undefined;

    constructor(data?: ISupplyCardLoadCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sesionMovil = _data["sesionMovil"];
            this.route = _data["route"];
            this.part = _data["part"];
            this.serie = _data["serie"];
            this.workShift = _data["workShift"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SupplyCardLoadCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardLoadCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sesionMovil"] = this.sesionMovil;
        data["route"] = this.route;
        data["part"] = this.part;
        data["serie"] = this.serie;
        data["workShift"] = this.workShift;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ISupplyCardLoadCreateCommand {
    sesionMovil?: number | undefined;
    route?: number | undefined;
    part?: number | undefined;
    serie?: string | undefined;
    workShift?: number | undefined;
    quantity?: number | undefined;
}

export class SupplyCardLoadResponse implements ISupplyCardLoadResponse {
    id!: number;
    supplyCardPart!: number;
    workShift!: number;
    user!: number;
    locationPackage!: number;
    loadDate!: moment.Moment;
    loadDateBase!: moment.Moment;
    quantity!: number;
    status?: SupplyCardLoadStatus | undefined;
    serie?: string | undefined;

    constructor(data?: ISupplyCardLoadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplyCardPart = _data["supplyCardPart"];
            this.workShift = _data["workShift"];
            this.user = _data["user"];
            this.locationPackage = _data["locationPackage"];
            this.loadDate = _data["loadDate"] ? moment(_data["loadDate"].toString()) : <any>undefined;
            this.loadDateBase = _data["loadDateBase"] ? moment(_data["loadDateBase"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.status = _data["status"];
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): SupplyCardLoadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardLoadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplyCardPart"] = this.supplyCardPart;
        data["workShift"] = this.workShift;
        data["user"] = this.user;
        data["locationPackage"] = this.locationPackage;
        data["loadDate"] = this.loadDate ? this.loadDate.toISOString() : <any>undefined;
        data["loadDateBase"] = this.loadDateBase ? this.loadDateBase.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["serie"] = this.serie;
        return data;
    }
}

export interface ISupplyCardLoadResponse {
    id: number;
    supplyCardPart: number;
    workShift: number;
    user: number;
    locationPackage: number;
    loadDate: moment.Moment;
    loadDateBase: moment.Moment;
    quantity: number;
    status?: SupplyCardLoadStatus | undefined;
    serie?: string | undefined;
}

export enum SupplyCardLoadStatus {
    Pending = 1,
    Delivered = 2,
    Cancelled = 3,
}

export class SuppliCardLoadGetPendingBySerieQuery implements ISuppliCardLoadGetPendingBySerieQuery {
    serie?: string | undefined;

    constructor(data?: ISuppliCardLoadGetPendingBySerieQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serie = _data["serie"];
        }
    }

    static fromJS(data: any): SuppliCardLoadGetPendingBySerieQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliCardLoadGetPendingBySerieQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serie"] = this.serie;
        return data;
    }
}

export interface ISuppliCardLoadGetPendingBySerieQuery {
    serie?: string | undefined;
}

export class SupplyCardDeliveryCreateCommand implements ISupplyCardDeliveryCreateCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    route?: number | undefined;
    location?: number | undefined;
    workShift?: number | undefined;

    constructor(data?: ISupplyCardDeliveryCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sesionMovil = _data["sesionMovil"];
            this.route = _data["route"];
            this.location = _data["location"];
            this.workShift = _data["workShift"];
        }
    }

    static fromJS(data: any): SupplyCardDeliveryCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyCardDeliveryCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sesionMovil"] = this.sesionMovil;
        data["route"] = this.route;
        data["location"] = this.location;
        data["workShift"] = this.workShift;
        return data;
    }
}
export interface IComboItemVm {
    value: string | undefined;
    text: string | undefined;
}

export interface ISupplyCardDeliveryCreateCommand {
    id?: number | undefined;
    sesionMovil?: number | undefined;
    route?: number | undefined;
    location?: number | undefined;
    workShift?: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class CausaFaltanteGetListQuery implements ICausaFaltanteGetListQuery {
    pageNumber!: number;
    pageSize!: number;
    filter?: string | undefined;
    sorting?: string | undefined;
    estatus?: boolean | undefined;
    causaFaltanteCodigo?: string | undefined;
    causaFaltanteDescr?: string | undefined;

    constructor(data?: ICausaFaltanteGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.estatus = _data["estatus"];
            this.causaFaltanteCodigo = _data["causaFaltanteCodigo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
        }
    }

    static fromJS(data: any): CausaFaltanteGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["estatus"] = this.estatus;
        data["causaFaltanteCodigo"] = this.causaFaltanteCodigo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        return data;
    }
}

export interface ICausaFaltanteGetListQuery {
    pageNumber: number;
    pageSize: number;
    filter?: string | undefined;
    sorting?: string | undefined;
    estatus?: boolean | undefined;
    causaFaltanteCodigo?: string | undefined;
    causaFaltanteDescr?: string | undefined;
}

export class ValidateCommodityMonoDollyResponse implements IValidateCommodityMonoDollyResponse {
    isMonoDolly: boolean;
    success: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IValidateCommodityMonoDollyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMonoDolly = _data["isMonoDolly"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidateCommodityMonoDollyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCommodityMonoDollyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMonoDolly"] = this.isMonoDolly;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IValidateCommodityMonoDollyResponse {
    isMonoDolly: boolean;
    success: boolean;
    errorMessage?: string | undefined;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

export class CommodityDto implements ICommodityDto {
    id!: number;
    commodityCode!: string;
    description!: string;
    partNumber!: string;
    description2!: string;
    programa!: string;
    almacen!: string;
    supplier?: string;
    planner?: string;
    locacionDestino?: string;
    alerta?: string;
    ubicaciones?: UbicacionDto[];
    createdDate?: moment.Moment;
    createdDateString!: string;
    createdByName!: string;
    userId!: number;
    userName!: string;
    isActive!: boolean;
    isActiveDesc!: string;

    constructor(data?: ICommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commodityCode = _data["commodityCode"];
            this.description = _data["description"];
            this.partNumber = _data["partNumber"];
            this.description2 = _data["description2"];
            this.programa = _data["programa"];
            this.almacen = _data["almacen"];
            this.supplier = _data["supplier"];
            this.planner = _data["planner"];
            this.locacionDestino = _data["locacionDestino"];
            this.alerta = _data["alerta"];
            if (Array.isArray(_data["ubicaciones"])) {
                this.ubicaciones = [] as any;
                for (let item of _data["ubicaciones"])
                    this.ubicaciones!.push(UbicacionDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.createdDateString = _data["createdDateString"];
            this.createdByName = _data["createdByName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): CommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commodityCode"] = this.commodityCode;
        data["description"] = this.description;
        data["partNumber"] = this.partNumber;
        data["description2"] = this.description2;
        data["programa"] = this.programa;
        data["almacen"] = this.almacen;
        data["supplier"] = this.supplier;
        data["planner"] = this.planner;
        data["locacionDestino"] = this.locacionDestino;
        data["alerta"] = this.alerta;
        if (Array.isArray(this.ubicaciones)) {
            data["ubicaciones"] = [];
            for (let item of this.ubicaciones)
                data["ubicaciones"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdDateString"] = this.createdDateString;
        data["createdByName"] = this.createdByName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ICommodityDto {
    id: number;
    commodityCode: string;
    description: string;
    partNumber: string;
    description2: string;
    programa: string;
    almacen: string;
    supplier?: string;
    planner?: string;
    locacionDestino?: string;
    alerta?: string;
    ubicaciones?: UbicacionDto[];
    createdDate?: moment.Moment;
    createdDateString: string;
    createdByName: string;
    userId: number;
    userName: string;
    isActive: boolean;
    isActiveDesc: string;
}

export class UbicacionDto implements IUbicacionDto {
    locacion!: string;
    cantidad!: number;

    constructor(data?: IUbicacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locacion = _data["locacion"];
            this.cantidad = _data["cantidad"];
        }
    }

    static fromJS(data: any): UbicacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UbicacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locacion"] = this.locacion;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface IUbicacionDto {
    locacion: string;
    cantidad: number;
}

export class PagedResultDtoOfCommodityDto implements IPagedResultDtoOfCommodityDto {
    totalCount!: number;
    items!: CommodityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommodityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCommodityDto {
    totalCount: number;
    items: CommodityDto[] | undefined;
}

export class NumeroPartesDto implements INumeroPartesDto {
    fileName!: string;
    uploadDate?: moment.Moment;
    processed!: boolean;
    status!: string;
    totalRecords!: number;
    successRecords!: number;
    errorRecords!: number;
    errors?: string | undefined;
    id!: number;

    constructor(data?: INumeroPartesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : <any>undefined;
            this.processed = _data["processed"];
            this.status = _data["status"];
            this.totalRecords = _data["totalRecords"];
            this.successRecords = _data["successRecords"];
            this.errorRecords = _data["errorRecords"];
            this.errors = _data["errors"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NumeroPartesDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumeroPartesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        data["processed"] = this.processed;
        data["status"] = this.status;
        data["totalRecords"] = this.totalRecords;
        data["successRecords"] = this.successRecords;
        data["errorRecords"] = this.errorRecords;
        data["errors"] = this.errors;
        data["id"] = this.id;
        return data;
    }
}

export interface INumeroPartesDto {
    fileName: string;
    uploadDate?: moment.Moment;
    processed: boolean;
    status: string;
    totalRecords: number;
    successRecords: number;
    errorRecords: number;
    errors?: string | undefined;
    id: number;
}

export class PagedResultDtoOfNumeroPartesDto implements IPagedResultDtoOfNumeroPartesDto {
    totalCount!: number;
    items!: NumeroPartesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNumeroPartesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NumeroPartesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNumeroPartesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNumeroPartesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNumeroPartesDto {
    totalCount: number;
    items: NumeroPartesDto[] | undefined;
}

@Injectable()
export class TaktTimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getTaktTimeList(filter?: string | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: string | undefined): Observable<PagedResultDtoOfTaktTimeDto> {
        let url_ = this.baseUrl + "/api/takttime/list";
        url_ = url_.replace(/[?&]$/, "");
        
        const query = {
            filter: filter,
            pageNumber: pageNumber,
            pageSize: pageSize,
            sorting: sorting
        };
        
        const content_ = JSON.stringify(query);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaktTimeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaktTimeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTaktTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTaktTimeDto>;
        }));
    }

    protected processGetTaktTimeList(response: HttpResponseBase): Observable<PagedResultDtoOfTaktTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTaktTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTaktTimeDto>(null as any);
    }

    getTaktTimeForEdit(id: number): Observable<TaktTimeDto> {
        let url_ = this.baseUrl + "/api/takttime/get-for-edit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        
        const content_ = JSON.stringify({ id: id });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaktTimeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaktTimeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaktTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaktTimeDto>;
        }));
    }

    protected processGetTaktTimeForEdit(response: HttpResponseBase): Observable<TaktTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaktTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaktTimeDto>(null as any);
    }

    createTaktTime(input: CreateTaktTimeDto): Observable<TaktTimeDto> {
        let url_ = this.baseUrl + "/api/takttime/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTaktTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaktTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaktTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaktTimeDto>;
        }));
    }

    protected processCreateTaktTime(response: HttpResponseBase): Observable<TaktTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaktTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaktTimeDto>(null as any);
    }

    updateTaktTime(input: UpdateTaktTimeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/takttime/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTaktTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaktTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTaktTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }





    deleteTaktTime(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/takttime/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteTaktTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaktTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTaktTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class TaktTimeDto implements ITaktTimeDto {
    id!: number;
    taktTimeDescr!: string | undefined;
    taktTimeValor!: number;
    usuarioRegistroName!: string | undefined;
    fechaRegistro!: moment.Moment;
    isActive!: boolean;

    constructor(data?: ITaktTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taktTimeDescr = _data["taktTimeDescr"];
            this.taktTimeValor = _data["taktTimeValor"];
            this.usuarioRegistroName = _data["usuarioRegistroName"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : true;
        }
    }

    static fromJS(data: any): TaktTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaktTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taktTimeDescr"] = this.taktTimeDescr;
        data["taktTimeValor"] = this.taktTimeValor;
        data["usuarioRegistroName"] = this.usuarioRegistroName;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITaktTimeDto {
    id: number;
    taktTimeDescr: string | undefined;
    taktTimeValor: number;
    usuarioRegistroName: string | undefined;
    fechaRegistro: moment.Moment;
    isActive: boolean;
}

export class CreateTaktTimeDto implements ICreateTaktTimeDto {
    taktTimeDescr!: string | undefined;
    taktTimeValor!: number;
    isActive!: boolean;

    constructor(data?: ICreateTaktTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taktTimeDescr = _data["taktTimeDescr"];
            this.taktTimeValor = _data["taktTimeValor"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTaktTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaktTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taktTimeDescr"] = this.taktTimeDescr;
        data["taktTimeValor"] = this.taktTimeValor;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTaktTimeDto {
    taktTimeDescr: string | undefined;
    taktTimeValor: number;
    isActive: boolean;
}

export class UpdateTaktTimeDto implements IUpdateTaktTimeDto {
    id!: number;
    taktTimeDescr!: string | undefined;
    taktTimeValor!: number;
    isActive!: boolean;

    constructor(data?: IUpdateTaktTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taktTimeDescr = _data["taktTimeDescr"];
            this.taktTimeValor = _data["taktTimeValor"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTaktTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaktTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taktTimeDescr"] = this.taktTimeDescr;
        data["taktTimeValor"] = this.taktTimeValor;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTaktTimeDto {
    id: number;
    taktTimeDescr: string | undefined;
    taktTimeValor: number;
    isActive: boolean;
}

export class PagedResultDtoOfTaktTimeDto implements IPagedResultDtoOfTaktTimeDto {
    totalCount!: number;
    items!: TaktTimeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTaktTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaktTimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTaktTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTaktTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTaktTimeDto {
    totalCount: number;
    items: TaktTimeDto[] | undefined;
}

// Modelo Service Proxy
@Injectable()
export class ModeloServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getModeloList(query: ModeloGetListQuery): Observable<PagedResultDtoOfModeloForListResponse> {
        let url_ = this.baseUrl + "/api/Modelo/GetModeloList";
        url_ = url_.replace(/[?&]$/, "");

        // Mapear correctamente usando el método toJSON()
        const queryData = query.toJSON ? query.toJSON() : query;
        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModeloList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModeloList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfModeloForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfModeloForListResponse>;
        }));
    }

    protected processGetModeloList(response: HttpResponseBase): Observable<PagedResultDtoOfModeloForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfModeloForListResponse.fromJS(resultData200) : new PagedResultDtoOfModeloForListResponse();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfModeloForListResponse>(null as any);
    }

    getModeloForEdit(dto: ModeloGetForEditQuery): Observable<ModeloForEditResponse> {
        let url_ = this.baseUrl + "/api/Modelo/GetModeloForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModeloForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModeloForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModeloForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModeloForEditResponse>;
        }));
    }

    protected processGetModeloForEdit(response: HttpResponseBase): Observable<ModeloForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ModeloForEditResponse.fromJS(resultData200) : new ModeloForEditResponse();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModeloForEditResponse>(null as any);
    }

    createModelo(dto: ModeloCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Modelo/CreateModelo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateModelo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateModelo(dto: ModeloUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Modelo/UpdateModelo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateModelo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteModelo(dto: ModeloDeleteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Modelo/DeleteModelo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteModelo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reactivateModelo(dto: ModeloReactivateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Modelo/ReactivateModelo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReactivateModelo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportModelo(query: ModeloExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Modelo/ExportModelo/export";
        url_ = url_.replace(/[?&]$/, "");

        // Mapear correctamente usando el método toJSON()
        const queryData = query.toJSON ? query.toJSON() : query;
        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportModelo(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    importModelo(command: ModeloImportCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Modelo/ImportModelo/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportModelo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportModelo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportModelo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf<void>(null as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

// DTOs and Interfaces for Modelo
export class ModeloGetListQuery implements IModeloGetListQuery {
    sorting!: string | undefined;
    filter!: string | undefined;
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    isPaged!: boolean | undefined;
    id!: number | undefined;
    modeloDescr!: string | undefined;
    estatus!: string | undefined;
    orden!: number | undefined;
    turno1!: number | undefined;
    turno2!: number | undefined;
    turno3!: number | undefined;
    unidades!: number | undefined;

    constructor(data?: IModeloGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.isPaged = _data["isPaged"];
            this.id = _data["id"];
            this.modeloDescr = _data["modeloDescr"];
            this.estatus = _data["estatus"];
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
            this.unidades = _data["unidades"];
        }
    }

    static fromJS(data: any): ModeloGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["isPaged"] = this.isPaged;
        data["id"] = this.id;
        data["modeloDescr"] = this.modeloDescr;
        data["estatus"] = this.estatus;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        data["unidades"] = this.unidades;
        return data;
    }
}

export interface IModeloGetListQuery {
    sorting: string | undefined;
    filter: string | undefined;
    pageNumber: number | undefined;
    pageSize: number | undefined;
    isPaged: boolean | undefined;
    id: number | undefined;
    modeloDescr: string | undefined;
    estatus: string | undefined;
    orden: number | undefined;
    turno1: number | undefined;
    turno2: number | undefined;
    turno3: number | undefined;
    unidades: number | undefined;
}

export class ModeloForListResponse implements IModeloForListResponse {
    id!: number;
    modeloDescr!: string | undefined;
    orden!: number | undefined;
    turno1!: number;
    turno2!: number;
    turno3!: number;
    unidades!: number | undefined;
    estatus!: string | undefined;
    isActive!: boolean;
    isActiveDesc!: string | undefined;

    constructor(data?: IModeloForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modeloDescr = _data["modeloDescr"];
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
            this.unidades = _data["unidades"];
            this.estatus = _data["estatus"];
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): ModeloForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modeloDescr"] = this.modeloDescr;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        data["unidades"] = this.unidades;
        data["estatus"] = this.estatus;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface IModeloForListResponse {
    id: number;
    modeloDescr: string | undefined;
    orden: number | undefined;
    turno1: number;
    turno2: number;
    turno3: number;
    unidades: number | undefined;
    estatus: string | undefined;
    isActive: boolean;
    isActiveDesc: string | undefined;
}

export class PagedResultDtoOfModeloForListResponse implements IPagedResultDtoOfModeloForListResponse {
    totalCount!: number;
    items!: ModeloForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfModeloForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ModeloForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfModeloForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfModeloForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfModeloForListResponse {
    totalCount: number;
    items: ModeloForListResponse[] | undefined;
}

export class ModeloGetForEditQuery implements IModeloGetForEditQuery {
    id!: number;

    constructor(data?: IModeloGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModeloGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IModeloGetForEditQuery {
    id: number;
}

export class ModeloForEditResponse implements IModeloForEditResponse {
    modelo!: ModeloDto | undefined;

    constructor(data?: IModeloForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelo = _data["modelo"] ? ModeloDto.fromJS(_data["modelo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModeloForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelo"] = this.modelo ? this.modelo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IModeloForEditResponse {
    modelo: ModeloDto | undefined;
}

export class ModeloDto implements IModeloDto {
    id!: number;
    modeloDescr!: string | undefined;
    modelFrames!: string | undefined;
    usuarioRegistroId!: number | undefined;
    fechaRegistro!: moment.Moment | undefined;
    orden!: number;
    turno1!: number;
    turno2!: number;
    turno3!: number;
    unidades!: number | undefined;
    estatus!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    registerDate!: moment.Moment | undefined;

    constructor(data?: IModeloDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modeloDescr = _data["modeloDescr"];
            this.modelFrames = _data["modelFrames"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
            this.unidades = _data["unidades"];
            this.estatus = _data["estatus"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.registerDate = _data["registerDate"] ? moment(_data["registerDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ModeloDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modeloDescr"] = this.modeloDescr;
        data["modelFrames"] = this.modelFrames;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        data["unidades"] = this.unidades;
        data["estatus"] = this.estatus;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IModeloDto {
    id: number;
    modeloDescr: string | undefined;
    modelFrames: string | undefined;
    usuarioRegistroId: number | undefined;
    fechaRegistro: moment.Moment | undefined;
    orden: number;
    turno1: number;
    turno2: number;
    turno3: number;
    unidades: number | undefined;
    estatus: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    registerDate: moment.Moment | undefined;
}

export class ModeloCreateCommand implements IModeloCreateCommand {
    modeloDescr!: string | undefined;
    modelFrames!: string | undefined;
    usuarioRegistroId!: number | undefined;
    fechaRegistro!: moment.Moment | undefined;
    orden!: number;
    turno1!: number;
    turno2!: number;
    turno3!: number;
    unidades!: number | undefined;
    estatus!: string | undefined;

    constructor(data?: IModeloCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modeloDescr = _data["modeloDescr"];
            this.modelFrames = _data["modelFrames"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
            this.unidades = _data["unidades"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ModeloCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modeloDescr"] = this.modeloDescr;
        data["modelFrames"] = this.modelFrames;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        data["unidades"] = this.unidades;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IModeloCreateCommand {
    modeloDescr: string | undefined;
    modelFrames: string | undefined;
    usuarioRegistroId: number | undefined;
    fechaRegistro: moment.Moment | undefined;
    orden: number;
    turno1: number;
    turno2: number;
    turno3: number;
    unidades: number | undefined;
    estatus: string | undefined;
}

export class ModeloUpdateCommand implements IModeloUpdateCommand {
    id!: number;
    modeloDescr!: string | undefined;
    modelFrames!: string | undefined;
    usuarioRegistroId!: number | undefined;
    fechaRegistro!: moment.Moment | undefined;
    orden!: number;
    turno1!: number;
    turno2!: number;
    turno3!: number;
    unidades!: number | undefined;
    estatus!: string | undefined;

    constructor(data?: IModeloUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modeloDescr = _data["modeloDescr"];
            this.modelFrames = _data["modelFrames"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
            this.unidades = _data["unidades"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ModeloUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modeloDescr"] = this.modeloDescr;
        data["modelFrames"] = this.modelFrames;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        data["unidades"] = this.unidades;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IModeloUpdateCommand {
    id: number;
    modeloDescr: string | undefined;
    modelFrames: string | undefined;
    usuarioRegistroId: number | undefined;
    fechaRegistro: moment.Moment | undefined;
    orden: number;
    turno1: number;
    turno2: number;
    turno3: number;
    unidades: number | undefined;
    estatus: string | undefined;
}

export class ModeloDeleteCommand implements IModeloDeleteCommand {
    id!: number;

    constructor(data?: IModeloDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModeloDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IModeloDeleteCommand {
    id: number;
}

export class ModeloReactivateCommand implements IModeloReactivateCommand {
    id!: number;

    constructor(data?: IModeloReactivateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModeloReactivateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloReactivateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IModeloReactivateCommand {
    id: number;
}

export class ModeloExportQuery implements IModeloExportQuery {
    filter!: string | undefined;
    id!: number | undefined;
    modeloDescr!: string | undefined;
    estatus!: string | undefined;
    orden!: number | undefined;
    turno1!: number | undefined;
    turno2!: number | undefined;
    turno3!: number | undefined;

    constructor(data?: IModeloExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.id = _data["id"];
            this.modeloDescr = _data["modeloDescr"];
            this.estatus = _data["estatus"];
            this.orden = _data["orden"];
            this.turno1 = _data["turno1"];
            this.turno2 = _data["turno2"];
            this.turno3 = _data["turno3"];
        }
    }

    static fromJS(data: any): ModeloExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["id"] = this.id;
        data["modeloDescr"] = this.modeloDescr;
        data["estatus"] = this.estatus;
        data["orden"] = this.orden;
        data["turno1"] = this.turno1;
        data["turno2"] = this.turno2;
        data["turno3"] = this.turno3;
        return data;
    }
}

export interface IModeloExportQuery {
    filter: string | undefined;
    id: number | undefined;
    modeloDescr: string | undefined;
    estatus: string | undefined;
    orden: number | undefined;
    turno1: number | undefined;
    turno2: number | undefined;
    turno3: number | undefined;
}

export class ModeloImportCommand implements IModeloImportCommand {
    base64!: string | undefined;

    constructor(data?: IModeloImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): ModeloImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IModeloImportCommand {
    base64: string | undefined;
}

// ProgramaProduccionFrames Service Proxy and DTOs
@Injectable()
export class ProgramaProduccionFramesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60143";
        

    }

    getProgramaProduccionFramesList(query: ProgramaProduccionFramesGetListQuery): Observable<PagedResultDtoOfProgramaProduccionFramesForListResponse> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/GetProgramaProduccionFramesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {

            return this.processGetProgramaProduccionFramesList(response_);
        })).pipe(_observableCatch((response_: any) => {

            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramaProduccionFramesList(response_ as any);
                } catch (e) {

                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProgramaProduccionFramesForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProgramaProduccionFramesForListResponse>;
        }));
    }

    protected processGetProgramaProduccionFramesList(response: HttpResponseBase): Observable<PagedResultDtoOfProgramaProduccionFramesForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            // ✨ LOGGING: Capturar datos RAW antes de la conversión TypeScript
            if (resultData200 && resultData200.items && resultData200.items.length > 0) {

            }
            
                result200 = resultData200 ? PagedResultDtoOfProgramaProduccionFramesForListResponse.fromJS(resultData200) : new PagedResultDtoOfProgramaProduccionFramesForListResponse();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProgramaProduccionFramesForListResponse>(null as any);
    }

    getProgramaProduccionFramesForEdit(dto: ProgramaProduccionFramesGetForEditQuery): Observable<ProgramaProduccionFramesForEditResponse> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/GetProgramaProduccionFramesForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramaProduccionFramesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramaProduccionFramesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramaProduccionFramesForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramaProduccionFramesForEditResponse>;
        }));
    }

    protected processGetProgramaProduccionFramesForEdit(response: HttpResponseBase): Observable<ProgramaProduccionFramesForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ProgramaProduccionFramesForEditResponse.fromJS(resultData200) : new ProgramaProduccionFramesForEditResponse();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProgramaProduccionFramesForEditResponse>(null as any);
    }

    createProgramaProduccionFrames(dto: ProgramaProduccionFramesCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/CreateProgramaProduccionFrames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateProgramaProduccionFrames(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateProgramaProduccionFrames(dto: ProgramaProduccionFramesUpdateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/UpdateProgramaProduccionFrames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProgramaProduccionFrames(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    reactivateProgramaProduccionFrames(dto: ProgramaProduccionFramesReactivateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/ReactivateProgramaProduccionFrames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivateProgramaProduccionFrames(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    exportProgramaProduccionFrames(dto: ProgramaProduccionFramesExportQuery): Observable<Blob> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/ExportProgramaProduccionFrames/export";
        url_ = url_.replace(/[?&]$/, "");

        // Mapear correctamente usando el método toJSON() si está disponible
        const queryData = dto.toJSON ? dto.toJSON() : dto;
        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportProgramaProduccionFrames(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    deleteProgramaProduccionFrames(dto: ProgramaProduccionFramesDeleteCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/DeleteProgramaProduccionFrames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProgramaProduccionFrames(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    importProgramaProduccionFrames(command: ProgramaProduccionFramesImportCommand): Observable<ImportResultDto> {
        let url_ = this.baseUrl + "/api/ProgramaProduccionFrames/ImportProgramaProduccionFrames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportProgramaProduccionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportProgramaProduccionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportResultDto>;
        }));
    }

    protected processImportProgramaProduccionFrames(response: HttpResponseBase): Observable<ImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImportResultDto.fromJS(resultData200) : new ImportResultDto();
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResultDto>(null as any);
    }
    
}

// ProgramaProduccionFrames DTOs and Queries
export class ProgramaProduccionFramesGetListQuery implements IProgramaProduccionFramesGetListQuery {
    sorting!: string | undefined;
    filter!: string | undefined;
    pageSize!: number | undefined;
    pageNumber!: number | undefined;
    isPaged!: boolean | undefined;
    id!: number | undefined;
    semana!: number | undefined;
    fechaInicio!: string | undefined;
    fechaFin!: string | undefined;
    numero!: number | undefined;
    chassis!: string | undefined;
    secuencia!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;

    constructor(data?: IProgramaProduccionFramesGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPaged = _data["isPaged"];
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.fechaInicio = _data["fechaInicio"];
            this.fechaFin = _data["fechaFin"];
            this.numero = _data["numero"];
            this.chassis = _data["chassis"];
            this.secuencia = _data["secuencia"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPaged"] = this.isPaged;
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["fechaInicio"] = this.fechaInicio;
        data["fechaFin"] = this.fechaFin;
        data["numero"] = this.numero;
        data["chassis"] = this.chassis;
        data["secuencia"] = this.secuencia;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IProgramaProduccionFramesGetListQuery {
    sorting: string | undefined;
    filter: string | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    isPaged: boolean | undefined;
    id: number | undefined;
    semana: number | undefined;
    fechaInicio: string | undefined;
    fechaFin: string | undefined;
    numero: number | undefined;
    chassis: string | undefined;
    secuencia: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
}

export class PagedResultDtoOfProgramaProduccionFramesForListResponse implements IPagedResultDtoOfProgramaProduccionFramesForListResponse {
    totalCount!: number | undefined;
    items!: ProgramaProduccionFramesForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfProgramaProduccionFramesForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
           
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"]) {
                    this.items!.push(ProgramaProduccionFramesForListResponse.fromJS(item));
                }
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProgramaProduccionFramesForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProgramaProduccionFramesForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfProgramaProduccionFramesForListResponse {
    totalCount: number | undefined;
    items: ProgramaProduccionFramesForListResponse[] | undefined;
}

export class ProgramaProduccionFramesForListResponse implements IProgramaProduccionFramesForListResponse {
    id!: number | undefined;
    semana!: number | undefined;
    fecha!: Date | undefined;
    fechaFormatted!: string | undefined;  // Agregar fechaFormatted del API
    numero!: number | undefined;
    chassis!: string | undefined;
    secuencia!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;

    constructor(data?: IProgramaProduccionFramesForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.fecha = _data["fecha"] ? new Date(_data["fecha"].toString()) : <any>undefined;
            this.fechaFormatted = _data["fechaFormatted"];  // Mapear fechaFormatted
            this.numero = _data["numero"];
            this.chassis = _data["chassis"];
            this.secuencia = _data["secuencia"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
        
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["fechaFormatted"] = this.fechaFormatted;  // Incluir fechaFormatted en JSON
        data["numero"] = this.numero;
        data["chassis"] = this.chassis;
        data["secuencia"] = this.secuencia;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IProgramaProduccionFramesForListResponse {
    id: number | undefined;
    semana: number | undefined;
    fecha: Date | undefined;
    fechaFormatted: string | undefined;  // Agregar fechaFormatted a la interfaz
    numero: number | undefined;
    chassis: string | undefined;
    secuencia: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
}

export class ProgramaProduccionFramesGetForEditQuery implements IProgramaProduccionFramesGetForEditQuery {
    id!: number | undefined;

    constructor(data?: IProgramaProduccionFramesGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramaProduccionFramesGetForEditQuery {
    id: number | undefined;
}

export class ProgramaProduccionFramesForEditResponse implements IProgramaProduccionFramesForEditResponse {
    programaProduccionFrames!: ProgramaProduccionFramesDto | undefined;

    constructor(data?: IProgramaProduccionFramesForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programaProduccionFrames = _data["programaProduccionFrames"] ? ProgramaProduccionFramesDto.fromJS(_data["programaProduccionFrames"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programaProduccionFrames"] = this.programaProduccionFrames ? this.programaProduccionFrames.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProgramaProduccionFramesForEditResponse {
    programaProduccionFrames: ProgramaProduccionFramesDto | undefined;
}

export class ProgramaProduccionFramesDto implements IProgramaProduccionFramesDto {
    id!: number | undefined;
    semana!: number | undefined;
    fecha!: Date | undefined;
    numero!: number | undefined;
    secuencia!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;
    createdDate!: Date | undefined;
    lastModifiedDate!: Date | undefined;

    constructor(data?: IProgramaProduccionFramesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.fecha = _data["fecha"] ? new Date(_data["fecha"].toString()) : <any>undefined;
            this.numero = _data["numero"];
            this.secuencia = _data["secuencia"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["numero"] = this.numero;
        data["secuencia"] = this.secuencia;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramaProduccionFramesDto {
    id: number | undefined;
    semana: number | undefined;
    fecha: Date | undefined;
    numero: number | undefined;
    secuencia: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
    createdDate: Date | undefined;
    lastModifiedDate: Date | undefined;
}

export class ProgramaProduccionFramesCreateCommand implements IProgramaProduccionFramesCreateCommand {
    semana!: number | undefined;
    fecha!: string | undefined;
    numero!: number | undefined;
    secuencia!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;

    constructor(data?: IProgramaProduccionFramesCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.semana = _data["semana"];
            this.fecha = _data["fecha"];
            this.numero = _data["numero"];
            this.secuencia = _data["secuencia"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semana"] = this.semana;
        data["fecha"] = this.fecha;
        data["numero"] = this.numero;
        data["secuencia"] = this.secuencia;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IProgramaProduccionFramesCreateCommand {
    semana: number | undefined;
    fecha: string | undefined;
    numero: number | undefined;
    secuencia: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
}

export class ProgramaProduccionFramesUpdateCommand implements IProgramaProduccionFramesUpdateCommand {
    id!: number | undefined;
    semana!: number | undefined;
    fecha!: string | undefined;
    numero!: number | undefined;
    secuencia!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;

    constructor(data?: IProgramaProduccionFramesUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.fecha = _data["fecha"];
            this.numero = _data["numero"];
            this.secuencia = _data["secuencia"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["fecha"] = this.fecha;
        data["numero"] = this.numero;
        data["secuencia"] = this.secuencia;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IProgramaProduccionFramesUpdateCommand {
    id: number | undefined;
    semana: number | undefined;
    fecha: string | undefined;
    numero: number | undefined;
    secuencia: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
}

export class ProgramaProduccionFramesReactivateCommand implements IProgramaProduccionFramesReactivateCommand {
    id!: number | undefined;

    constructor(data?: IProgramaProduccionFramesReactivateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesReactivateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesReactivateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramaProduccionFramesReactivateCommand {
    id: number | undefined;
}

export class ProgramaProduccionFramesDeleteCommand implements IProgramaProduccionFramesDeleteCommand {
    id!: number | undefined;

    constructor(data?: IProgramaProduccionFramesDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramaProduccionFramesDeleteCommand {
    id: number | undefined;
}

export class ProgramaProduccionFramesExportQuery implements IProgramaProduccionFramesExportQuery {
    filter!: string | undefined;
    id!: number | undefined;
    semana!: number | undefined;
    chassis!: string | undefined;
    modeloInicies!: string | undefined;
    market!: string | undefined;
    modeloId!: number | undefined;
    estatus!: string | undefined;

    constructor(data?: IProgramaProduccionFramesExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.chassis = _data["chassis"];
            this.modeloInicies = _data["modeloInicies"];
            this.market = _data["market"];
            this.modeloId = _data["modeloId"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["chassis"] = this.chassis;
        data["modeloInicies"] = this.modeloInicies;
        data["market"] = this.market;
        data["modeloId"] = this.modeloId;
        data["estatus"] = this.estatus;
        return data;
    }
}

export class ProgramaProduccionFramesImportCommand implements IProgramaProduccionFramesImportCommand {
    base64!: string | undefined;
    fileName!: string | undefined;


    constructor(data?: IProgramaProduccionFramesImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ProgramaProduccionFramesImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionFramesImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IProgramaProduccionFramesImportCommand {
    base64: string | undefined;
    fileName?: string | undefined;
}

export class FileDto implements IFileDto {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileToken?: string | undefined;
}

export interface IProgramaProduccionFramesExportQuery {
    filter: string | undefined;
    id: number | undefined;
    semana: number | undefined;
    chassis: string | undefined;
    modeloInicies: string | undefined;
    market: string | undefined;
    modeloId: number | undefined;
    estatus: string | undefined;
}

export class DynamicSelectRequest implements IDynamicSelectRequest {
    tableName!: string;
    searchColumn!: string;
    searchFilter?: string;
    page?: number;
    pageSize?: number;
    script?: string; // 🆕 Campo opcional para acciones específicas

    constructor(data?: IDynamicSelectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            this.searchColumn = _data["searchColumn"];
            this.searchFilter = _data["searchFilter"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.script = _data["script"]; // 🆕 Inicializar script
        }
    }

    static fromJS(data: any): DynamicSelectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSelectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["searchColumn"] = this.searchColumn;
        data["searchFilter"] = this.searchFilter;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        // 🆕 Solo agregar script si tiene valor
        if (this.script !== undefined && this.script !== null && this.script.trim() !== '') {
            data["script"] = this.script;
        }
        return data;
    }
}

export interface IDynamicSelectRequest {
    tableName: string;
    searchColumn: string;
    searchFilter?: string;
    page?: number;
    pageSize?: number;
    script?: string; // 🆕 Campo opcional para acciones específicas
}

export class DynamicSelectResponse implements IDynamicSelectResponse {
    items!: DynamicSelectItem[];
    totalCount!: number;

    constructor(data?: IDynamicSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicSelectItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            // If hasMore is not provided by API, calculate it based on items length and totalCount
        }
    }

    static fromJS(data: any): DynamicSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDynamicSelectResponse {
    items: DynamicSelectItem[];
    totalCount: number;
}

export class DynamicSelectItem implements IDynamicSelectItem {
    id!: number;
    text!: string;
    isLastPage!: boolean;
    tipo?: string;

    constructor(data?: IDynamicSelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            // Handle both formats: {id, text} and {value, display}
            this.id = _data["id"] || _data["value"];
            this.text = _data["text"] || _data["display"];
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : false;
            this.tipo = _data["tipo"]; // Mapear el campo tipo del response
        }
    }

    static fromJS(data: any): DynamicSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["tipo"] = this.tipo;
        return data;
    }
}

export interface IDynamicSelectItem {
    id: number;
    text: string;
    isLastPage: boolean;
    tipo?: string;
}

// ====================
// DollyClasificacion Service Proxy
// ====================

@Injectable()
export class DollyClasificacionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDollyClasificacionList(filter: string | undefined, sorting: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Observable<PagedResultDtoOfDollyClasificacionDto> {
        let url_ = this.baseUrl + "/api/dollyclasificacion/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            sorting: sorting !== undefined ? sorting : undefined,
            filter: filter !== undefined ? filter : undefined,
            pageSize: pageSize !== undefined ? pageSize : 10,
            pageNumber: pageNumber !== undefined ? pageNumber : 0,
            isPaged: true
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyClasificacionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyClasificacionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDollyClasificacionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDollyClasificacionDto>;
        }));
    }

    protected processGetDollyClasificacionList(response: HttpResponseBase): Observable<PagedResultDtoOfDollyClasificacionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfDollyClasificacionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id 
     * @return Success
     */
    getDollyClasificacionForEdit(id: number, isBin: boolean = false): Observable<DollyClasificacionDto> {
        let url_ = this.baseUrl + "/api/dollyclasificacion/get-for-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ Id: id !== undefined ? id : undefined, IsBin: isBin !== undefined ? isBin : undefined });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyClasificacionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyClasificacionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DollyClasificacionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DollyClasificacionDto>;
        }));
    }

    protected processGetDollyClasificacionForEdit(response: HttpResponseBase): Observable<DollyClasificacionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DollyClasificacionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDollyClasificacion(body: CreateDollyClasificacionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dollyclasificacion/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDollyClasificacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDollyClasificacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDollyClasificacion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDollyClasificacion(body: UpdateDollyClasificacionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dollyclasificacion/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDollyClasificacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDollyClasificacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDollyClasificacion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id 
     * @return Success
     */
    deleteDollyClasificacion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dollyclasificacion/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ id: id !== undefined ? id : undefined });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDollyClasificacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDollyClasificacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDollyClasificacion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

// ====================
// DollyClasificacion DTOs
// ====================

export class DollyClasificacionDto implements IDollyClasificacionDto {
    id!: number;
    dollyDescr!: string;
    commodityGrupoId!: number;
    commodityGrupoDescr!: string | undefined;
    isActive!: boolean;
    width!: number;
    height!: number;
    area!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    cantidadDolly!: number | undefined;
    creatorUserName!: string | undefined;

    constructor(data?: IDollyClasificacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dollyDescr = _data["dollyDescr"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.isActive = _data["isActive"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.area = _data["area"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.cantidadDolly = _data["cantidadDolly"];
        }
    }

    static fromJS(data: any): DollyClasificacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DollyClasificacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dollyDescr"] = this.dollyDescr;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["isActive"] = this.isActive;
        data["width"] = this.width;
        data["height"] = this.height;
        data["area"] = this.area;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["cantidadDolly"] = this.cantidadDolly;
        return data;
    }
}

export interface IDollyClasificacionDto {
    id: number;
    dollyDescr: string;
    commodityGrupoId: number;
    commodityGrupoDescr: string | undefined;
    isActive: boolean;
    width: number;
    height: number;
    area: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    cantidadDolly: number;
}

export class PagedResultDtoOfDollyClasificacionDto implements IPagedResultDtoOfDollyClasificacionDto {
    totalCount!: number;
    items!: DollyClasificacionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDollyClasificacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DollyClasificacionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDollyClasificacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDollyClasificacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDollyClasificacionDto {
    totalCount: number;
    items: DollyClasificacionDto[] | undefined;
}

export class CreateDollyClasificacionDto implements ICreateDollyClasificacionDto {
    dollyDescr!: string;
    commodityGrupoId!: number;
    isActive!: boolean;
    width!: number;
    height!: number;
    area!: number;

    constructor(data?: ICreateDollyClasificacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dollyDescr = _data["dollyDescr"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.isActive = _data["isActive"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): CreateDollyClasificacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDollyClasificacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dollyDescr"] = this.dollyDescr;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["isActive"] = this.isActive;
        data["width"] = this.width;
        data["height"] = this.height;
        data["area"] = this.area;
        return data;
    }
}

export interface ICreateDollyClasificacionDto {
    dollyDescr: string;
    commodityGrupoId: number;
    isActive: boolean;
    width: number;
    height: number;
    area: number;
}

export class UpdateDollyClasificacionDto implements IUpdateDollyClasificacionDto {
    id!: number;
    dollyDescr!: string;
    commodityGrupoId!: number;
    isActive!: boolean;
    width!: number;
    height!: number;
    area!: number;

    constructor(data?: IUpdateDollyClasificacionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dollyDescr = _data["dollyDescr"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.isActive = _data["isActive"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): UpdateDollyClasificacionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDollyClasificacionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dollyDescr"] = this.dollyDescr;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["isActive"] = this.isActive;
        data["width"] = this.width;
        data["height"] = this.height;
        data["area"] = this.area;
        return data;
    }
}

export interface IUpdateDollyClasificacionDto {
    id: number;
    dollyDescr: string;
    commodityGrupoId: number;
    isActive: boolean;
    width: number;
    height: number;
    area: number;
}


/////////
// ====================
//  Dolly Dimension DTO
// ====================

export interface IDollyDimensionDto {
    name: string;
    width: number;
    height: number;
    area: number;
    claveDolly: string;
    commodityGrupoId: number;
}

export class DollyDimensionDto implements IDollyDimensionDto {
    name!: string;
    width!: number;
    height!: number;
    area!: number;
    claveDolly!: string;
    commodityGrupoId!: number;

    constructor(data?: IDollyDimensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.area = _data["area"];
            this.claveDolly = _data["claveDolly"];
            this.commodityGrupoId = _data["commodityGrupoId"];
        }
    }

    static fromJS(data: any): DollyDimensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DollyDimensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["width"] = this.width;
        data["height"] = this.height;
        data["area"] = this.area;
        data["claveDolly"] = this.claveDolly;
        data["commodityGrupoId"] = this.commodityGrupoId;
        return data;
    }
}

// ====================
//  Dolly Estatus DTO
// ====================

export interface IDollyEstatusDto {
    id: number;
    codigo: string;
    nombre: string;
    programa: string;
    commodityGrupoId: number;
    estatus: string;
    fechaCreacion: string;
    secuencia?: number;
}

export class DollyEstatusDto implements IDollyEstatusDto {
    id!: number;
    codigo!: string;
    nombre!: string;
    programa!: string;
    commodityGrupoId!: number;
    estatus!: string;
    fechaCreacion!: string;
    secuencia?: number;

    constructor(data?: IDollyEstatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codigo = _data["codigo"];
            this.nombre = _data["nombre"];
            this.programa = _data["programa"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.estatus = _data["estatus"];
            this.fechaCreacion = _data["fechaCreacion"];
            this.secuencia = _data["secuencia"];
        }
    }

    static fromJS(data: any): DollyEstatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DollyEstatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codigo"] = this.codigo;
        data["nombre"] = this.nombre;
        data["programa"] = this.programa;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["estatus"] = this.estatus;
        data["fechaCreacion"] = this.fechaCreacion;
        data["secuencia"] = this.secuencia;
        return data;
    }
}

/////////
// ====================
//  Dolly Service Proxy
// ====================

@Injectable()
export class DollyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDollyList(filter: string | undefined, sorting: string | undefined,
         pageSize: number | undefined, pageNumber: number | undefined, dollyClasificacionId: number | undefined): Observable<PagedResultDtoOfDollyDto> {
        let url_ = this.baseUrl + "/api/dollys";
        
        // Construir parámetros de consulta
        const params = new URLSearchParams();
        
        if (filter !== undefined && filter !== null && filter !== '') {
            params.append('filter', filter);
        }
        if (sorting !== undefined && sorting !== null && sorting !== '') {
            params.append('sorting', sorting);
        }
        if (pageSize !== undefined && pageSize !== null) {
            params.append('pageSize', pageSize.toString());
        } else {
            params.append('pageSize', '10');
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            params.append('pageNumber', pageNumber.toString());
        } else {
            params.append('pageNumber', '0');
        }
        if (dollyClasificacionId !== undefined && dollyClasificacionId !== null) {
            params.append('dollyClasificacionId', dollyClasificacionId.toString());
        }
        params.append('isPaged', 'true');
        
        // Agregar parámetros a la URL
        const queryString = params.toString();
        if (queryString) {
            url_ += '?' + queryString;
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDollyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDollyDto>;
        }));
    }

    protected processGetDollyList(response: HttpResponseBase): Observable<PagedResultDtoOfDollyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfDollyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDolly(body: CreateDollyDto | undefined): Observable<CreateDollyResponseDto> {
        let url_ = this.baseUrl + "/api/dolly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDollyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDollyResponseDto>;
        }));
    }

    protected processCreateDolly(response: HttpResponseBase): Observable<CreateDollyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateDollyResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDollyResponseDto>(null as any);
    }

    /**
     * @param id 
     * @return Success
     */
    deleteDolly(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dolly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ id: id !== undefined ? id : undefined });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDolly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param estatus 
     * @param nelson1 (optional) 
     * @param nelson2 (optional) 
     * @return Success
     */
    getDollyByEstatus(estatus: string, nelson1?: boolean, nelson2?: boolean): Observable<DollyEstatusDto[]> {
        let url_ = this.baseUrl + "/api/dollys/estatus/" + encodeURIComponent("" + estatus);
        url_ = url_.replace(/[?&]$/, "");
        
        // Agregar query parameters para nelson1 y nelson2
        const queryParams: string[] = [];
        if (nelson1 !== undefined) {
            queryParams.push("nelson1=" + encodeURIComponent("" + nelson1));
        }
        if (nelson2 !== undefined) {
            queryParams.push("nelson2=" + encodeURIComponent("" + nelson2));
        }
        
        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyByEstatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyByEstatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetDollyByEstatus(response: HttpResponseBase): Observable<DollyEstatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param estatus 
     * @param pageNumber (optional) Page number for pagination
     * @param pageSize (optional) Page size for pagination  
     * @param filter (optional) Filter string for search
     * @param sorting (optional) Sorting criteria
     * @return Success
     */
    getDollyByEstatusWithQuery(estatus: string, pageNumber?: number, pageSize?: number, filter?: string, sorting?: string, programa?: string, dolly?: string, secuencia?: string, fechaInicio?: moment.Moment, fechaFin?: moment.Moment, modoEdit?: boolean, nelson1?: boolean, nelson2?: boolean, uncovered?: boolean, nelson3?: boolean): Observable<any[]> {
        let url_ = this.baseUrl + "/api/dollys/estatus/" + encodeURIComponent("" + estatus);
        
        // Agregar parámetros de query
        let queryParams: string[] = [];
        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (filter !== undefined && filter !== null && filter !== "")
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (sorting !== undefined && sorting !== null && sorting !== "")
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));
        if (programa !== undefined && programa !== null && programa !== "")
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        if (dolly !== undefined && dolly !== null && dolly !== "")
            queryParams.push("dolly=" + encodeURIComponent("" + dolly));
        if (secuencia !== undefined && secuencia !== null && secuencia !== "")
            queryParams.push("secuencia=" + encodeURIComponent("" + secuencia));
        if (fechaInicio !== undefined && fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (modoEdit !== undefined && modoEdit !== null)
            queryParams.push("modoEdit=" + encodeURIComponent("" + modoEdit));
        if (nelson1 !== undefined && nelson1 !== null)
            queryParams.push("nelson1=" + encodeURIComponent("" + nelson1));
        if (nelson2 !== undefined && nelson2 !== null)
            queryParams.push("nelson2=" + encodeURIComponent("" + nelson2));
        if (uncovered !== undefined && uncovered !== null)
            queryParams.push("uncovered=" + encodeURIComponent("" + uncovered));
        if (nelson3 !== undefined && nelson3 !== null)
            queryParams.push("nelson3=" + encodeURIComponent("" + nelson3));

        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyByEstatusWithQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyByEstatusWithQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetDollyByEstatusWithQuery(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDollyPriorities(): Observable<GetDollyPrioritiesResponse> {
        let url_ = this.baseUrl + "/api/dollys/priorities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyPriorities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyPriorities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDollyPrioritiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDollyPrioritiesResponse>;
        }));
    }

    protected processGetDollyPriorities(response: HttpResponseBase): Observable<GetDollyPrioritiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDollyPrioritiesResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get dolly dimensions for capacity calculation
     * @return Success
     */
    getDollyDimensions(): Observable<DollyDimensionDto[]> {
        let url_ = this.baseUrl + "/api/dollys/dimensiones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDollyDimensions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDollyDimensions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DollyDimensionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DollyDimensionDto[]>;
        }));
    }

    protected processGetDollyDimensions(response: HttpResponseBase): Observable<DollyDimensionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DollyDimensionDto.fromJS(item));
                } else {
                    result200 = [] as any;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate packaging plan before creating it
     * @param body Object with dollyList to validate
     * @return Validation result
     */
    validatePackagingPlan(body: { dollyList?: string[], embarqueEditandoId?: number }): Observable<ValidatePackagingPlanResponse> {
        let url_ = this.baseUrl + "/api/dollys/validate-packaging-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePackagingPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePackagingPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidatePackagingPlanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidatePackagingPlanResponse>;
        }));
    }

    protected processValidatePackagingPlan(response: HttpResponseBase): Observable<ValidatePackagingPlanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let resultData = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result: ValidatePackagingPlanResponse = { esValido: resultData?.esValido ?? false, mensaje: resultData?.mensaje ?? '' };
                return _observableOf(result);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
    }

    /**
     * Create packaging plan (change dolly status to PENDIENTE)
     * @param body Command with dolly list and embarque information
     * @return Success
     */
    createPackagingPlan(body: UpdateDollyStatusToPendingCommand | undefined): Observable<UpdateDollyStatusToPendingResponse> {
        let url_ = this.baseUrl + "/api/dollys/create-packaging-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePackagingPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePackagingPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDollyStatusToPendingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDollyStatusToPendingResponse>;
        }));
    }

    protected processCreatePackagingPlan(response: HttpResponseBase): Observable<UpdateDollyStatusToPendingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateDollyStatusToPendingResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Performs partial unloading of selected dollies from a shipment
     * @param body Command with embarque ID, dolly IDs and user ID
     * @return Success
     */
    descargaParcialDollies(body: DescargaParcialDolliesCommand | undefined): Observable<DescargaParcialDolliesResponse> {
        let url_ = this.baseUrl + "/api/dollys/descarga-parcial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDescargaParcialDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDescargaParcialDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescargaParcialDolliesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescargaParcialDolliesResponse>;
        }));
    }

    /**
     * Validates if a shipment has advanced sequences that should be sent first
     * @param embarqueId ID of the shipment to validate
     * @return Validation result with proceed flag and message
     */
    validarSecuenciaAdelantada(embarqueId: string, esEnvio: boolean = false): Observable<ValidacionSecuenciaResponse> {
        let url_ = this.baseUrl + "/api/dollys/validar-secuencia-adelanta/" + encodeURIComponent("" + embarqueId);
        if (embarqueId === undefined || embarqueId === null)
            throw new Error("El parámetro 'embarqueId' no puede ser nulo o indefinido.");
        
        // Agregar parámetro esEnvio como query parameter
        url_ += "?esEnvio=" + encodeURIComponent("" + esEnvio);
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidarSecuenciaAdelantada(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarSecuenciaAdelantada(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidacionSecuenciaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidacionSecuenciaResponse>;
        }));
    }

    protected processDescargaParcialDollies(response: HttpResponseBase): Observable<DescargaParcialDolliesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DescargaParcialDolliesResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    protected processValidarSecuenciaAdelantada(response: HttpResponseBase): Observable<ValidacionSecuenciaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidacionSecuenciaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param programa (optional) 
     * @param secuencia (optional) 
     * @param dolly (optional) 
     * @return Success
     */
    getAsignaDollyList(sorting: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, programa?: string, secuencia?: string, commodity?: string): Observable<PagedResultDtoOfAsignaDollyDto> {
        let url_ = this.baseUrl + "/api/dollys/asigna-dolly";

        const params: string[] = [];
        if (sorting !== undefined && sorting !== null && sorting !== '')
            params.push("sorting=" + encodeURIComponent("" + sorting));
        if (pageSize !== undefined && pageSize !== null)
            params.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            params.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (programa !== undefined && programa !== null && programa !== '')
            params.push("programa=" + encodeURIComponent("" + programa));
        if (secuencia !== undefined && secuencia !== null && secuencia !== '')
            params.push("secuencia=" + encodeURIComponent("" + secuencia));
        if (commodity !== undefined && commodity !== null && commodity !== '')
            params.push("commodity=" + encodeURIComponent("" + commodity));

        if (params.length > 0)
            url_ += "?" + params.join("&");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAsignaDollyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAsignaDollyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAsignaDollyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAsignaDollyDto>;
        }));
    }

    protected processGetAsignaDollyList(response: HttpResponseBase): Observable<PagedResultDtoOfAsignaDollyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfAsignaDollyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

// ====================
// Dolly DTOs
// ====================

export interface IAsignaDollyDto {
    id?: number;
    secuencia?: string | undefined;
    commodity?: string | undefined;
    programa?: string | undefined;
    dollyId?: number;
    estatusSecuenciado?: number;
    fechaInicio?: Date | undefined;
}

export class AsignaDollyDto implements IAsignaDollyDto {
    id?: number;
    secuencia?: string | undefined;
    commodity?: string | undefined;
    programa?: string | undefined;
    dollyId?: number;
    estatusSecuenciado?: number;
    fechaInicio?: Date | undefined;

    constructor(data?: IAsignaDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.secuencia = _data["secuencia"];
            this.commodity = _data["commodity"];
            this.programa = _data["programa"];
            this.dollyId = _data["dollyId"];
            this.estatusSecuenciado = _data["estatusSecuenciado"];
            this.fechaInicio = _data["fechaInicio"] ? new Date(_data["fechaInicio"]) : undefined;
        }
    }

    static fromJS(data: any): AsignaDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AsignaDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["secuencia"] = this.secuencia;
        data["commodity"] = this.commodity;
        data["programa"] = this.programa;
        data["dollyId"] = this.dollyId;
        data["estatusSecuenciado"] = this.estatusSecuenciado;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : undefined;
        return data;
    }
}

export interface IPagedResultDtoOfAsignaDollyDto {
    totalCount?: number;
    items?: AsignaDollyDto[] | undefined;
}

export class PagedResultDtoOfAsignaDollyDto implements IPagedResultDtoOfAsignaDollyDto {
    totalCount?: number;
    items?: AsignaDollyDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAsignaDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AsignaDollyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAsignaDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAsignaDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDollyPrioritiesResponse {
    priorities?: DollyPriorityDto[] | undefined;
}

export class GetDollyPrioritiesResponse implements IGetDollyPrioritiesResponse {
    priorities?: DollyPriorityDto[] | undefined;

    constructor(data?: IGetDollyPrioritiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(DollyPriorityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDollyPrioritiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDollyPrioritiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDollyPriorityDto {
    dollyDescr?: string | undefined;
    commodityGrupoDescr?: string | undefined;
    taktTimeValor?: number;
    priority?: number;
}

export class DollyPriorityDto implements IDollyPriorityDto {
    dollyDescr?: string | undefined;
    commodityGrupoDescr?: string | undefined;
    taktTimeValor?: number;
    priority?: number;

    constructor(data?: IDollyPriorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dollyDescr = _data["dollyDescr"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.taktTimeValor = _data["taktTimeValor"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): DollyPriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DollyPriorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dollyDescr"] = this.dollyDescr;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["taktTimeValor"] = this.taktTimeValor;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ValidatePackagingPlanResponse {
    esValido: boolean;
    mensaje: string;
}

export interface IUpdateDollyStatusToPendingCommand {
    dollyList?: string[] | undefined;
    embarqueDescr?: string | undefined;
    cajaId?: number | undefined;
    embarqueEditandoId?: number | undefined;
}

export class UpdateDollyStatusToPendingCommand implements IUpdateDollyStatusToPendingCommand {
    dollyList?: string[] | undefined;
    embarqueDescr?: string | undefined;
    cajaId?: number | undefined;
    embarqueEditandoId?: number | undefined;

    constructor(data?: IUpdateDollyStatusToPendingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dollyList"])) {
                this.dollyList = [] as any;
                for (let item of _data["dollyList"])
                    this.dollyList!.push(item);
            }
            this.embarqueDescr = _data["embarqueDescr"];
            this.cajaId = _data["cajaId"];
            this.embarqueEditandoId = _data["embarqueEditandoId"];
        }
    }

    static fromJS(data: any): UpdateDollyStatusToPendingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDollyStatusToPendingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dollyList)) {
            data["dollyList"] = [];
            for (let item of this.dollyList)
                data["dollyList"].push(item);
        }
        data["embarqueDescr"] = this.embarqueDescr;
        data["cajaId"] = this.cajaId;
        data["embarqueEditandoId"] = this.embarqueEditandoId;
        return data;
    }
}

export interface IUpdateDollyStatusToPendingResponse {
    success?: boolean;
    message?: string | undefined;
    updatedDollysCount?: number;
    updatedDollys?: string[] | undefined;
    embarqueId?: number;
    embarqueDescr?: string | undefined;
    advertencias?: string[] | undefined;
}

export class UpdateDollyStatusToPendingResponse implements IUpdateDollyStatusToPendingResponse {
    success?: boolean;
    message?: string | undefined;
    updatedDollysCount?: number;
    updatedDollys?: string[] | undefined;
    embarqueId?: number;
    embarqueDescr?: string | undefined;
    advertencias?: string[] | undefined;

    constructor(data?: IUpdateDollyStatusToPendingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.updatedDollysCount = _data["updatedDollysCount"];
            if (Array.isArray(_data["updatedDollys"])) {
                this.updatedDollys = [] as any;
                for (let item of _data["updatedDollys"])
                    this.updatedDollys!.push(item);
            }
            this.embarqueId = _data["embarqueId"];
            this.embarqueDescr = _data["embarqueDescr"];
            if (Array.isArray(_data["advertencias"])) {
                this.advertencias = [] as any;
                for (let item of _data["advertencias"])
                    this.advertencias!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDollyStatusToPendingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDollyStatusToPendingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["updatedDollysCount"] = this.updatedDollysCount;
        if (Array.isArray(this.updatedDollys)) {
            data["updatedDollys"] = [];
            for (let item of this.updatedDollys)
                data["updatedDollys"].push(item);
        }
        data["embarqueId"] = this.embarqueId;
        data["embarqueDescr"] = this.embarqueDescr;
        if (Array.isArray(this.advertencias)) {
            data["advertencias"] = [];
            for (let item of this.advertencias)
                data["advertencias"].push(item);
        }
        return data;
    }
}

export interface IDescargaParcialDolliesCommand {
    embarqueId?: number;
    dollyIds?: number[] | undefined;
}

export class DescargaParcialDolliesCommand implements IDescargaParcialDolliesCommand {
    embarqueId?: number;
    dollyIds?: number[] | undefined;

    constructor(data?: IDescargaParcialDolliesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.embarqueId = _data["embarqueId"];
            if (Array.isArray(_data["dollyIds"])) {
                this.dollyIds = [] as any;
                for (let item of _data["dollyIds"])
                    this.dollyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DescargaParcialDolliesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaParcialDolliesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embarqueId"] = this.embarqueId;
        if (Array.isArray(this.dollyIds)) {
            data["dollyIds"] = [];
            for (let item of this.dollyIds)
                data["dollyIds"].push(item);
        }
        return data;
    }
}

export interface IDescargaParcialDolliesResponse {
    success?: boolean;
    message?: string | undefined;
    descargadosCount?: number;
    dollyIdsDescargados?: number[] | undefined;
    embarqueId?: number;
}

export class DescargaParcialDolliesResponse implements IDescargaParcialDolliesResponse {
    success?: boolean;
    message?: string | undefined;
    descargadosCount?: number;
    dollyIdsDescargados?: number[] | undefined;
    embarqueId?: number;

    constructor(data?: IDescargaParcialDolliesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.descargadosCount = _data["descargadosCount"];
            if (Array.isArray(_data["dollyIdsDescargados"])) {
                this.dollyIdsDescargados = [] as any;
                for (let item of _data["dollyIdsDescargados"])
                    this.dollyIdsDescargados!.push(item);
            }
            this.embarqueId = _data["embarqueId"];
        }
    }

    static fromJS(data: any): DescargaParcialDolliesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaParcialDolliesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["descargadosCount"] = this.descargadosCount;
        if (Array.isArray(this.dollyIdsDescargados)) {
            data["dollyIdsDescargados"] = [];
            for (let item of this.dollyIdsDescargados)
                data["dollyIdsDescargados"].push(item);
        }
        data["embarqueId"] = this.embarqueId;
        return data;
    }
}

export interface IValidacionSecuenciaResponse {
    puedeProceder?: boolean;
    estatusEnvio?: boolean;
    mensaje?: string | undefined;
}

export class ValidacionSecuenciaResponse implements IValidacionSecuenciaResponse {
    puedeProceder?: boolean;
    estatusEnvio?: boolean;
    mensaje?: string | undefined;

    constructor(data?: IValidacionSecuenciaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.puedeProceder = _data["puedeProceder"];
            this.estatusEnvio = _data["estatusEnvio"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): ValidacionSecuenciaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidacionSecuenciaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["puedeProceder"] = this.puedeProceder;
        data["estatusEnvio"] = this.estatusEnvio;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export class DollyDto implements IDollyDto {
    id!: number;
    dollyClasificacionId!: number;
    dollyDescr!: string;
    commodityGrupoId!: number;
    commodityGrupoDescr!: string;
    cantidadDolly!: number;
    isActive!: boolean;

    constructor(data?: IDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dollyClasificacionId = _data["dollyClasificacionId"];
            this.dollyDescr = _data["dollyDescr"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.cantidadDolly = _data["cantidadDolly"];
            this.isActive = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dollyClasificacionId"] = this.dollyClasificacionId;
        data["dollyDescr"] = this.dollyDescr;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["cantidadDolly"] = this.cantidadDolly;
        data["isDeleted"] = this.isActive;
        return data;
    }
}

export interface IDollyDto {
    id: number;
    dollyClasificacionId: number;
    dollyDescr: string;
    commodityGrupoId: number;
    commodityGrupoDescr: string;
    cantidadDolly: number;
    isActive: boolean;
}

export class PagedResultDtoOfDollyDto implements IPagedResultDtoOfDollyDto {
    totalCount!: number;
    items!: DollyDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DollyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDollyDto {
    totalCount: number;
    items: DollyDto[] | undefined;
}

export class CreateDollyDto implements ICreateDollyDto {
    dollyClasificacionId!: number;
    commodityGrupoId!: number;
    cantidadCrear!: number | undefined;
   

    constructor(data?: ICreateDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dollyClasificacionId = _data["dollyClasificacionId"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.cantidadCrear = _data["cantidadCrear"];
        }
    }

    static fromJS(data: any): CreateDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dollyClasificacionId"] = this.dollyClasificacionId;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["cantidadCrear"] = this.cantidadCrear;
        return data;
    }
}

export interface ICreateDollyDto {
    dollyClasificacionId: number;
    commodityGrupoId: number;
    cantidadCrear: number;
}

export class CreateDollyResponseDto implements ICreateDollyResponseDto {
    cantidadCreada!: number;
    lista!: string[] | undefined;

    constructor(data?: ICreateDollyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantidadCreada = _data["cantidadCreada"];
            if (Array.isArray(_data["lista"])) {
                this.lista = [] as any;
                for (let item of _data["lista"])
                    this.lista!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDollyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDollyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantidadCreada"] = this.cantidadCreada;
        if (Array.isArray(this.lista)) {
            data["lista"] = [];
            for (let item of this.lista)
                data["lista"].push(item);
        }
        return data;
    }
}

export interface ICreateDollyResponseDto {
    cantidadCreada: number;
    lista: string[] | undefined;
}

// ====================
// CommodityGroup DTOs (UPDATED)
// ====================

export class CommodityGroupForListResponse implements ICommodityGroupForListResponse {
    id!: number;
    commodityGrupoDescr!: string;
    esMonoDolly!: boolean;
    tipo!: string;
    cantidadSecuenciasDolly!: number;
    modeloId!: number | undefined;
    modeloDesc!: string | undefined;
    tiempoConstruccionSecuencia!: number | undefined;
    esProgramaAbortaUnidades!: boolean;
    bufferDesc!: string | undefined;
    porcentajeUso!: number | undefined;
    taktTimeId!: number | undefined;
    taktTimeDesc!: string | undefined;
    grupoInventarioId!: number | undefined;
    grupoInventarioDesc!: string | undefined;
    buffer!: number | undefined;
    secuenciaDolly!: string | undefined;
    isActive!: boolean;
    SecuenciaInvertida!: boolean;
    dobleOrdenamiento!: boolean;

    constructor(data?: ICommodityGroupForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.esMonoDolly = _data["esMonoDolly"];
            this.tipo = _data["tipo"];
            this.cantidadSecuenciasDolly = _data["cantidadSecuenciasDolly"];
            this.modeloId = _data["modeloId"];
            this.modeloDesc = _data["modeloDesc"];
            this.tiempoConstruccionSecuencia = _data["tiempoConstruccionSecuencia"];
            this.esProgramaAbortaUnidades = _data["esProgramaAbortaUnidades"];
            this.bufferDesc = _data["bufferDesc"];
            this.porcentajeUso = _data["porcentajeUso"];
            this.taktTimeId = _data["taktTimeId"];
            this.taktTimeDesc = _data["taktTimeDesc"];
            this.grupoInventarioId = _data["grupoInventarioId"];
            this.grupoInventarioDesc = _data["grupoInventarioDesc"];
            this.buffer = _data["buffer"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.isActive = _data["isActive"];
            this.SecuenciaInvertida = _data["secuenciaInvertida"];
            this.dobleOrdenamiento = _data["dobleOrdenamiento"];
        }
    }

    static fromJS(data: any): CommodityGroupForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGroupForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["esMonoDolly"] = this.esMonoDolly;
        data["tipo"] = this.tipo;
        data["cantidadSecuenciasDolly"] = this.cantidadSecuenciasDolly;
        data["modeloId"] = this.modeloId;
        data["modeloDesc"] = this.modeloDesc;
        data["tiempoConstruccionSecuencia"] = this.tiempoConstruccionSecuencia;
        data["esProgramaAbortaUnidades"] = this.esProgramaAbortaUnidades;
        data["bufferDesc"] = this.bufferDesc;
        data["porcentajeUso"] = this.porcentajeUso;
        data["taktTimeId"] = this.taktTimeId;
        data["taktTimeDesc"] = this.taktTimeDesc;
        data["grupoInventarioId"] = this.grupoInventarioId;
        data["grupoInventarioDesc"] = this.grupoInventarioDesc;
        data["buffer"] = this.buffer;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["isActive"] = this.isActive;
        data["secuenciaInvertida"] = this.SecuenciaInvertida;
        data["dobleOrdenamiento"] = this.dobleOrdenamiento;
        return data;
    }
}

export interface ICommodityGroupForListResponse {
    id: number;
    commodityGrupoDescr: string;
    esMonoDolly: boolean;
    tipo: string;
    cantidadSecuenciasDolly: number;
    modeloId: number | undefined;
    modeloDesc: string | undefined;
    tiempoConstruccionSecuencia: number | undefined;
    esProgramaAbortaUnidades: boolean;
    bufferDesc: string | undefined;
    porcentajeUso: number | undefined;
    taktTimeId: number | undefined;
    taktTimeDesc: string | undefined;
    grupoInventarioId: number | undefined;
    grupoInventarioDesc: string | undefined;
    buffer: number | undefined;
    secuenciaDolly: string | undefined;
    isActive: boolean;
    SecuenciaInvertida: boolean;
    dobleOrdenamiento: boolean;
}

export class PagedResultDtoOfCommodityGroupForListResponse implements IPagedResultDtoOfCommodityGroupForListResponse {
    totalCount!: number;
    items!: CommodityGroupForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityGroupForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommodityGroupForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityGroupForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityGroupForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCommodityGroupForListResponse {
    totalCount: number;
    items: CommodityGroupForListResponse[] | undefined;
}

export class CommodityGroupForEditResponse implements ICommodityGroupForEditResponse {
    id!: number;
    commodityGrupoDescr!: string;
    usuarioRegistroId!: number | undefined;
    usuarioRegistroName!: string | undefined;
    fechaRegistro!: moment.Moment | undefined;
    esMonoDolly!: boolean;
    cantidadSecuenciasDolly!: number | undefined;
    taktTimeId!: number | undefined;
    taktTimeDesc!: string | undefined;
    taktTimeValor!: number | undefined;;
    tiempoConstruccionSecuencia!: number | undefined;
    porcentajeUso!: number | undefined;
    esProgramaAbortaUnidades!: boolean;
    limiteDolliesZona0!: number | undefined;
    modeloId!: number | undefined;
    modeloDesc!: string | undefined;
    grupoInventarioId!: number | undefined;
    grupoInventarioDesc!: string | undefined;
    buffer!: number | undefined;
    secuenciaDolly!: string | undefined;
    anio!: number | undefined;
    isActive!: boolean;
    SecuenciaInvertida!: boolean;
    dobleOrdenamiento!: boolean;
    usabote!: boolean;

    constructor(data?: ICommodityGroupForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.usuarioRegistroName = _data["usuarioRegistroName"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.esMonoDolly = _data["esMonoDolly"];
            this.cantidadSecuenciasDolly = _data["cantidadSecuenciasDolly"];
            this.taktTimeId = _data["taktTimeId"];
            this.taktTimeDesc = _data["taktTimeDesc"];
            this.taktTimeValor = _data["taktTimeValor"];
            this.tiempoConstruccionSecuencia = _data["tiempoConstruccionSecuencia"];
            this.porcentajeUso = _data["porcentajeUso"];
            this.esProgramaAbortaUnidades = _data["esProgramaAbortaUnidades"];
            this.limiteDolliesZona0 = _data["limiteDolliesZona0"];
            this.modeloId = _data["modeloId"];
            this.modeloDesc = _data["modeloDesc"];
            this.grupoInventarioId = _data["grupoInventarioId"];
            this.grupoInventarioDesc = _data["grupoInventarioDesc"];
            this.buffer = _data["buffer"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.anio = _data["anio"];
            this.isActive = _data["isActive"];
            this.SecuenciaInvertida = _data["secuenciaInvertida"];
            this.dobleOrdenamiento = _data["dobleOrdenamiento"];
            this.usabote = _data["usaBote"] || false;
        }
    }

    static fromJS(data: any): CommodityGroupForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGroupForEditResponse();
        // Handle nested structure where data comes as {commodityGroup: {...}}
        let commodityData = data.commodityGroup || data;
        result.init(commodityData);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["usuarioRegistroName"] = this.usuarioRegistroName;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["esMonoDolly"] = this.esMonoDolly;
        data["cantidadSecuenciasDolly"] = this.cantidadSecuenciasDolly;
        data["taktTimeId"] = this.taktTimeId;
        data["taktTimeDesc"] = this.taktTimeDesc;
        data["taktTimeValor"] = this.taktTimeValor;
        data["tiempoConstruccionSecuencia"] = this.tiempoConstruccionSecuencia;
        data["porcentajeUso"] = this.porcentajeUso;
        data["esProgramaAbortaUnidades"] = this.esProgramaAbortaUnidades;
        data["limiteDolliesZona0"] = this.limiteDolliesZona0;
        data["modeloId"] = this.modeloId;
        data["modeloDesc"] = this.modeloDesc;
        data["grupoInventarioId"] = this.grupoInventarioId;
        data["grupoInventarioDesc"] = this.grupoInventarioDesc;
        data["buffer"] = this.buffer;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["anio"] = this.anio;
        data["isActive"] = this.isActive;
        data["secuenciaInvertida"] = this.SecuenciaInvertida;
        data["dobleOrdenamiento"] = this.dobleOrdenamiento;
        data["usaBote"] = this.usabote;
        return data;
    }
}

export interface ICommodityGroupForEditResponse {
    id: number;
    commodityGrupoDescr: string;
    usuarioRegistroId: number | undefined;
    usuarioRegistroName: string | undefined;
    fechaRegistro: moment.Moment | undefined;
    esMonoDolly: boolean;
    cantidadSecuenciasDolly: number | undefined;
    taktTimeId: number | undefined;
    taktTimeDesc: string | undefined;
    tiempoConstruccionSecuencia: number | undefined;
    porcentajeUso: number | undefined;
    esProgramaAbortaUnidades: boolean;
    limiteDolliesZona0: number | undefined;
    modeloId: number | undefined;
    modeloDesc: string | undefined;
    grupoInventarioId: number | undefined;
    grupoInventarioDesc: string | undefined;
    buffer: number | undefined;
    secuenciaDolly: string | undefined;
    anio: number | undefined;
    isActive: boolean;
    SecuenciaInvertida: boolean;
    dobleOrdenamiento: boolean;
    usabote: boolean;
}

export class CreateCommodityGroupDto implements ICreateCommodityGroupDto {
    commodityGrupoDescr!: string;
    esMonoDolly!: boolean;
    cantidadSecuenciasDolly!: number | undefined;
    taktTimeId!: number | undefined;
    buffer!: number | undefined;
    secuenciaDolly!: string | undefined;
    tiempoConstruccionSecuencia!: number | undefined;
    porcentajeUso!: number | undefined;
    esProgramaAbortaUnidades!: boolean;
    limiteDolliesZona0!: number | undefined;
    modeloId!: number | undefined;
    grupoInventarioId!: number | undefined;
    anio!: number | undefined;
    isActive!: boolean;
    SecuenciaInvertida!: boolean;
    dobleOrdenamiento!: boolean;
    usabote!: boolean;

    constructor(data?: ICreateCommodityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.esMonoDolly = _data["esMonoDolly"];
            this.cantidadSecuenciasDolly = _data["cantidadSecuenciasDolly"];
            this.taktTimeId = _data["taktTimeId"];
            this.buffer = _data["buffer"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.tiempoConstruccionSecuencia = _data["tiempoConstruccionSecuencia"];
            this.porcentajeUso = _data["porcentajeUso"];
            this.esProgramaAbortaUnidades = _data["esProgramaAbortaUnidades"];
            this.limiteDolliesZona0 = _data["limiteDolliesZona0"];
            this.modeloId = _data["modeloId"];
            this.grupoInventarioId = _data["grupoInventarioId"];
            this.anio = _data["anio"];
            this.isActive = _data["isActive"];
            this.SecuenciaInvertida = _data["secuenciaInvertida"];
            this.dobleOrdenamiento = _data["dobleOrdenamiento"];
            this.usabote = _data["usaBote"] || false;
        }
    }

    static fromJS(data: any): CreateCommodityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommodityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["esMonoDolly"] = this.esMonoDolly;
        data["cantidadSecuenciasDolly"] = this.cantidadSecuenciasDolly;
        data["taktTimeId"] = this.taktTimeId;
        data["buffer"] = this.buffer;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["tiempoConstruccionSecuencia"] = this.tiempoConstruccionSecuencia;
        data["porcentajeUso"] = this.porcentajeUso;
        data["esProgramaAbortaUnidades"] = this.esProgramaAbortaUnidades;
        data["limiteDolliesZona0"] = this.limiteDolliesZona0;
        data["modeloId"] = this.modeloId;
        data["grupoInventarioId"] = this.grupoInventarioId;
        data["anio"] = this.anio;
        data["isActive"] = this.isActive;
        data["secuenciaInvertida"] = this.SecuenciaInvertida;
        data["dobleOrdenamiento"] = this.dobleOrdenamiento;
        data["usaBote"] = this.usabote;
        return data;
    }
}

export interface ICreateCommodityGroupDto {
    commodityGrupoDescr: string;
    esMonoDolly: boolean;
    cantidadSecuenciasDolly: number | undefined;
    taktTimeId: number | undefined;
    buffer: number | undefined;
    secuenciaDolly: string | undefined;
    tiempoConstruccionSecuencia: number | undefined;
    porcentajeUso: number | undefined;
    esProgramaAbortaUnidades: boolean;
    limiteDolliesZona0: number | undefined;
    modeloId: number | undefined;
    grupoInventarioId: number | undefined;
    isActive: boolean;
    anio: number | undefined;
    SecuenciaInvertida: boolean;
    dobleOrdenamiento: boolean;
    usabote: boolean;
}

export class UpdateCommodityGroupDto implements IUpdateCommodityGroupDto {
    id!: number;
    commodityGrupoDescr!: string;
    esMonoDolly!: boolean;
    cantidadSecuenciasDolly!: number | undefined;
    taktTimeId!: number | undefined;
    buffer!: number | undefined;
    secuenciaDolly!: string | undefined;
    tiempoConstruccionSecuencia!: number | undefined;
    porcentajeUso!: number | undefined;
    esProgramaAbortaUnidades!: boolean;
    limiteDolliesZona0!: number | undefined;
    modeloId!: number | undefined;
    grupoInventarioId!: number | undefined;
    anio!: number | undefined;
    isActive!: boolean;
    SecuenciaInvertida!: boolean;
    dobleOrdenamiento!: boolean;
    usabote!: boolean;

    constructor(data?: IUpdateCommodityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.esMonoDolly = _data["esMonoDolly"];
            this.cantidadSecuenciasDolly = _data["cantidadSecuenciasDolly"];
            this.taktTimeId = _data["taktTimeId"];
            this.buffer = _data["buffer"];
            this.secuenciaDolly = _data["secuenciaDolly"];
            this.tiempoConstruccionSecuencia = _data["tiempoConstruccionSecuencia"];
            this.porcentajeUso = _data["porcentajeUso"];
            this.esProgramaAbortaUnidades = _data["esProgramaAbortaUnidades"];
            this.limiteDolliesZona0 = _data["limiteDolliesZona0"];
            this.modeloId = _data["modeloId"];
            this.grupoInventarioId = _data["grupoInventarioId"];
            this.anio = _data["anio"];
            this.isActive = _data["isActive"];
            this.SecuenciaInvertida = _data["secuenciaInvertida"];
            this.dobleOrdenamiento = _data["dobleOrdenamiento"];
            this.usabote = _data["usaBote"] || false;
        }
    }

    static fromJS(data: any): UpdateCommodityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommodityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["esMonoDolly"] = this.esMonoDolly;
        data["cantidadSecuenciasDolly"] = this.cantidadSecuenciasDolly;
        data["taktTimeId"] = this.taktTimeId;
        data["buffer"] = this.buffer;
        data["secuenciaDolly"] = this.secuenciaDolly;
        data["tiempoConstruccionSecuencia"] = this.tiempoConstruccionSecuencia;
        data["porcentajeUso"] = this.porcentajeUso;
        data["esProgramaAbortaUnidades"] = this.esProgramaAbortaUnidades;
        data["limiteDolliesZona0"] = this.limiteDolliesZona0;
        data["modeloId"] = this.modeloId;
        data["grupoInventarioId"] = this.grupoInventarioId;
        data["anio"] = this.anio;
        data["isActive"] = this.isActive;
        data["secuenciaInvertida"] = this.SecuenciaInvertida;
        data["dobleOrdenamiento"] = this.dobleOrdenamiento;
        data["usaBote"] = this.usabote;
        return data;
    }
}

export interface IUpdateCommodityGroupDto {
    id: number;
    commodityGrupoDescr: string;
    esMonoDolly: boolean;
    cantidadSecuenciasDolly: number | undefined;
    taktTimeId: number | undefined;
    buffer: number | undefined;
    secuenciaDolly: string | undefined;
    tiempoConstruccionSecuencia: number | undefined;
    porcentajeUso: number | undefined;
    esProgramaAbortaUnidades: boolean;
    limiteDolliesZona0: number | undefined;
    modeloId: number | undefined;
    grupoInventarioId: number | undefined;
    isActive: boolean;
    SecuenciaInvertida: boolean;
    dobleOrdenamiento: boolean;
    usabote: boolean;
}

export class GetAlmacenForEditOutput implements IGetAlmacenForEditOutput {
    id!: number;
    tenantId!: number;
    descripcion!: string;
    nomenclatura!: string;
    isZona0!: boolean;
    isActive!: boolean;

    constructor(data?: IGetAlmacenForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.descripcion = _data["descripcion"];
            this.nomenclatura = _data["nomenclatura"];
            this.isZona0 = _data["isZona0"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetAlmacenForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlmacenForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["descripcion"] = this.descripcion;
        data["nomenclatura"] = this.nomenclatura;
        data["isZona0"] = this.isZona0;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetAlmacenForEditOutput {
    id: number;
    tenantId: number;
    descripcion: string;
    nomenclatura: string;
    isZona0: boolean;
    isActive: boolean;
}

export class ProgramaProduccionBoteExportQuery implements IProgramaProduccionBoteExportQuery {
    filter!: string | undefined;
    id!: number | undefined;
    semana!: number | undefined;
    secuenciaBast!: string | undefined;
    secuenciaCabina!: string | undefined;
    modelo!: string | undefined;
    estatus!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;

    constructor(data?: IProgramaProduccionBoteExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.id = _data["id"];
            this.semana = _data["semana"];
            this.secuenciaBast = _data["secuenciaBast"];
            this.secuenciaCabina = _data["secuenciaCabina"];
            this.modelo = _data["modelo"];
            this.estatus = _data["estatus"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): ProgramaProduccionBoteExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaProduccionBoteExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["id"] = this.id;
        data["semana"] = this.semana;
        data["secuenciaBast"] = this.secuenciaBast;
        data["secuenciaCabina"] = this.secuenciaCabina;
        data["modelo"] = this.modelo;
        data["estatus"] = this.estatus;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IProgramaProduccionBoteExportQuery {
    filter: string | undefined;
    id: number | undefined;
    semana: number | undefined;
    secuenciaBast: string | undefined;
    secuenciaCabina: string | undefined;
    modelo: string | undefined;
    estatus: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

@Injectable()
export class LineaProduccionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getLineaProduccionList(filter: string | undefined, sorting: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Observable<PagedResultDtoOfLineaProduccionDto> {
        let url_ = this.baseUrl + "/api/LineaProduccion/GetLineaProduccionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            filter: filter,
            sorting: sorting,
            pageSize: pageSize,
            pageNumber: pageNumber,
            isPaged: true
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLineaProduccionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLineaProduccionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLineaProduccionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLineaProduccionDto>;
        }));
    }

    protected processGetLineaProduccionList(response: HttpResponseBase): Observable<PagedResultDtoOfLineaProduccionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLineaProduccionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLineaProduccionDto>(null as any);
    }

    getLineaProduccionForEdit(id: number): Observable<LineaProduccionForEditDto> {
        let url_ = this.baseUrl + "/api/LineaProduccion/GetLineaProduccionForEdit";
        url_ = url_.replace(/[?&]$/, "");

        if (id === undefined || id === null)
            throw new Error("The parameter 'id' cannot be null.");

        const content_ = JSON.stringify({ id: id });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLineaProduccionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLineaProduccionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LineaProduccionForEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LineaProduccionForEditDto>;
        }));
    }

    protected processGetLineaProduccionForEdit(response: HttpResponseBase): Observable<LineaProduccionForEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineaProduccionForEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LineaProduccionForEditDto>(null as any);
    }

    createLineaProduccion(command: CreateLineaProduccionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/LineaProduccion/CreateLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLineaProduccion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateLineaProduccion(command: UpdateLineaProduccionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/LineaProduccion/UpdateLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLineaProduccion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteLineaProduccion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/LineaProduccion/DeleteLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        if (id === undefined || id === null)
            throw new Error("The parameter 'id' cannot be null.");

        const content_ = JSON.stringify({ id: id });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLineaProduccion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class PagedResultDtoOfLineaProduccionDto implements IPagedResultDtoOfLineaProduccionDto {
    totalCount!: number;
    items!: LineaProduccionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLineaProduccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LineaProduccionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLineaProduccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLineaProduccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLineaProduccionDto {
    totalCount: number;
    items: LineaProduccionDto[] | undefined;
}

export class LineaProduccionDto implements ILineaProduccionDto {
    id!: number;
    lineaProduccionDescr!: string;
    usuarioRegistroName!: string | undefined;
    fechaRegistro!: moment.Moment;
    isActive!: boolean;
    isActiveDesc!: string | undefined;

    constructor(data?: ILineaProduccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineaProduccionDescr = _data["lineaProduccionDescr"];
            this.usuarioRegistroName = _data["usuarioRegistroName"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isActiveDesc = _data["isActiveDesc"];
        }
    }

    static fromJS(data: any): LineaProduccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineaProduccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineaProduccionDescr"] = this.lineaProduccionDescr;
        data["usuarioRegistroName"] = this.usuarioRegistroName;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isActiveDesc"] = this.isActiveDesc;
        return data;
    }
}

export interface ILineaProduccionDto {
    id: number;
    lineaProduccionDescr: string;
    usuarioRegistroName: string | undefined;
    fechaRegistro: moment.Moment;
    isActive: boolean;
    isActiveDesc: string | undefined;
}

export class LineaProduccionForEditDto implements ILineaProduccionForEditDto {
    id!: number;
    lineaProduccionDescr!: string;
    isActive!: boolean;

    constructor(data?: ILineaProduccionForEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineaProduccionDescr = _data["lineaProduccionDescr"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LineaProduccionForEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineaProduccionForEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineaProduccionDescr"] = this.lineaProduccionDescr;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILineaProduccionForEditDto {
    id: number;
    lineaProduccionDescr: string;
    isActive: boolean;
}

export class CreateLineaProduccionDto implements ICreateLineaProduccionDto {
    lineaProduccionDescr!: string;
    isActive!: boolean;

    constructor(data?: ICreateLineaProduccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineaProduccionDescr = _data["lineaProduccionDescr"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateLineaProduccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLineaProduccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineaProduccionDescr"] = this.lineaProduccionDescr;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateLineaProduccionDto {
    lineaProduccionDescr: string;
    isActive: boolean;
}

export class UpdateLineaProduccionDto implements IUpdateLineaProduccionDto {
    id!: number;
    lineaProduccionDescr!: string;
    isActive!: boolean;

    constructor(data?: IUpdateLineaProduccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineaProduccionDescr = _data["lineaProduccionDescr"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateLineaProduccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLineaProduccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineaProduccionDescr"] = this.lineaProduccionDescr;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateLineaProduccionDto {
    id: number;
    lineaProduccionDescr: string;
    isActive: boolean;
}

@Injectable()
export class DetalladoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    uploadDetalladoFile(base64Content: string, fileName: string): Observable<DetalladoUploadResultDto> {
        let url_ = this.baseUrl + "/api/detallado/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDetalladoFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDetalladoFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetalladoUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetalladoUploadResultDto>;
        }));
    }

    protected processUploadDetalladoFile(response: HttpResponseBase): Observable<DetalladoUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = DetalladoUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetalladoUploadResultDto>(null as any);
    }

    getDetalladoList(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        isPaged: boolean | undefined,
        chassis: string | undefined,
        secuencia: string | undefined,
        numeroParte: string | undefined,
        cantidad: number | undefined,
        isActive: boolean | undefined,
        fechaRegistroDesde: moment.Moment | undefined,
        fechaRegistroHasta: moment.Moment | undefined
    ): Observable<PagedResultDtoOfDetalladoDto> {
        let url_ = this.baseUrl + "/api/detallado/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            sorting: sorting,
            filter: filter,
            pageSize: pageSize,
            pageNumber: pageNumber,
            isPaged: isPaged,
            chassis: chassis,
            secuencia: secuencia,
            numeroParte: numeroParte,
            cantidad: cantidad,
            isActive: isActive,
            fechaRegistroDesde: fechaRegistroDesde ? fechaRegistroDesde.toISOString() : <any>undefined,
            fechaRegistroHasta: fechaRegistroHasta ? fechaRegistroHasta.toISOString() : <any>undefined
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetalladoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetalladoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDetalladoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDetalladoDto>;
        }));
    }

    protected processGetDetalladoList(response: HttpResponseBase): Observable<PagedResultDtoOfDetalladoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDetalladoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDetalladoDto>(null as any);
    }

        getProgramasGrouped(filter: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/detallado/list";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify({ filter: filter || "" });
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramasGrouped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramasGrouped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else {
                return _observableThrow(response_) as any as Observable<any[]>;
            }
        }));
    }
    protected processGetProgramasGrouped(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(Array.isArray(resultData200) ? resultData200 : []);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>([]);
    }
    getCommodityDetalles(
        commodityCode: string,
        filter: string | undefined,
        pageNumber: number,
        pageSize: number
    ): Observable<any> {
        let url_ = this.baseUrl + "/api/detallado/commodity-detalles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify({
            commodityCode: commodityCode,
            filter: filter || "",
            pageNumber: pageNumber,
            pageSize: pageSize
        });
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommodityDetalles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityDetalles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else {
                return _observableThrow(response_) as any as Observable<any>;
            }
        }));
    }
    protected processGetCommodityDetalles(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null);
    }

    
    getProgramasEscaneados(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        isPaged: boolean | undefined,
        escaneados: boolean | undefined
    ): Observable<PagedResultDtoOfSecuenciaDto> {
        let url_ = this.baseUrl + "/api/detallado/programas-escaneados";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            sorting: sorting,
            filter: filter,
            pageSize: pageSize,
            pageNumber: pageNumber,
            isPaged: isPaged,
            escaneados: escaneados
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramasEscaneados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramasEscaneados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSecuenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSecuenciaDto>;
        }));
    }

    protected processGetProgramasEscaneados(response: HttpResponseBase): Observable<PagedResultDtoOfSecuenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSecuenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fusionDetallado(actual: string, anterior: string): Observable<DetalladoFusionResultDto> {
        let url_ = this.baseUrl + "/api/detallado/fusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            actual: actual,
            anterior: anterior
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFusionDetallado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFusionDetallado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetalladoFusionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetalladoFusionResultDto>;
        }));
    }

    protected processFusionDetallado(response: HttpResponseBase): Observable<DetalladoFusionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetalladoFusionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBitacoraDetallado(
        commodityCode: string,
        fechaCarga?: moment.Moment | undefined,
        rangoFecha?: string | undefined,
        secuenciaMinima?: string | undefined,
        secuenciaMaxima?: string | undefined
    ): Observable<BitacoraDetalladoResponse> {
        let url_ = this.baseUrl + "/api/detallado/BitacoraDetallado/" + encodeURIComponent("" + commodityCode);
        url_ = url_.replace(/[?&]$/, "");

        let urlParams = new URLSearchParams();
        if (fechaCarga !== undefined && fechaCarga !== null)
            urlParams.set("fechaCarga", fechaCarga.toISOString());
        if (rangoFecha !== undefined && rangoFecha !== null)
            urlParams.set("rangoFecha", rangoFecha.toString());
        if (secuenciaMinima !== undefined && secuenciaMinima !== null)
            urlParams.set("secuenciaMinima", secuenciaMinima.toString());
        if (secuenciaMaxima !== undefined && secuenciaMaxima !== null)
            urlParams.set("secuenciaMaxima", secuenciaMaxima.toString());
        
        if (urlParams.toString()) {
            url_ += "?" + urlParams.toString();
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBitacoraDetallado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBitacoraDetallado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BitacoraDetalladoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BitacoraDetalladoResponse>;
        }));
    }

    protected processGetBitacoraDetallado(response: HttpResponseBase): Observable<BitacoraDetalladoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BitacoraDetalladoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BitacoraDetalladoResponse>(null as any);
    }

    getFramesFiltered(commodityCode: string, rangoFecha: string, fecha: moment.Moment): Observable<FramesFilteredResponse> {
        let url_ = this.baseUrl + "/api/detallado/frames-filtered";
        url_ = url_.replace(/[?&]$/, "");

        let urlParams = new URLSearchParams();
        if (commodityCode !== undefined && commodityCode !== null)
            urlParams.set("commoditycode", commodityCode.toString());
        if (rangoFecha !== undefined && rangoFecha !== null)
            urlParams.set("rangoFecha", rangoFecha.toString());
        if (fecha !== undefined && fecha !== null)
            urlParams.set("fecha", fecha.toISOString());
        
        if (urlParams.toString()) {
            url_ += "?" + urlParams.toString();
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFramesFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFramesFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FramesFilteredResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FramesFilteredResponse>;
        }));
    }

    protected processGetFramesFiltered(response: HttpResponseBase): Observable<FramesFilteredResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FramesFilteredResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FramesFilteredResponse>(null as any);
    }

    getProgramasSecuenciados(request: ProgramasSecuenciadosRequest): Observable<ProgramasSecuenciadosResponse> {
        let url_ = this.baseUrl + "/api/programas/secuenciados";
        url_ = url_.replace(/[?&]$/, "");

        // Construir los query parameters
        const params = new URLSearchParams();
        
        if (request.fechaInicio) {
            params.set('fechaInicio', request.fechaInicio.toISOString());
        } else {
            params.set('fechaInicio', '');
        }
        
        if (request.fechaFin) {
            params.set('fechaFin', request.fechaFin.toISOString());
        } else {
            params.set('fechaFin', '');
        }
        
        params.set('chasis', request.chasis || '');
        params.set('codigoCommodity', request.codigoCommodity || '');
        params.set('secuenciaDesde', request.secuenciaDesde || '');
        params.set('secuenciaHasta', request.secuenciaHasta || '');
        params.set('descripcion', request.descripcion || '');
        params.set('noEscaneados', (request.noEscaneados || false).toString());
        
        // Agregar los nuevos campos
        if (request.fechaUltimoSecuenciado) {
            params.set('fechaUltimoSecuenciado', request.fechaUltimoSecuenciado.format('YYYY-MM-DD'));
        } else {
            params.set('fechaUltimoSecuenciado', '');
        }
        params.set('ultimaSecuenciaCargada', request.ultimaSecuenciaCargada || '');
        
        params.set('pagina', (request.pagina || 0).toString());
        params.set('tamanoPagina', (request.tamanoPagina || 100).toString());
        params.set('campoOrden', request.campoOrden || '');
        params.set('direccionOrden', request.direccionOrden || '');

        // Agregar los parámetros a la URL
        if (params.toString()) {
            url_ += '?' + params.toString();
        }


        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {

            return this.processGetProgramasSecuenciados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramasSecuenciados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramasSecuenciadosResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramasSecuenciadosResponse>;
        }));
    }

    protected processGetProgramasSecuenciados(response: HttpResponseBase): Observable<ProgramasSecuenciadosResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramasSecuenciadosResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProgramasSecuenciadosResponse>(null as any);
    }
}
export class DetalladoFusionResultDto implements IDetalladoFusionResultDto {
    archivoFusionadoBase64!: string | undefined;
    exitoso!: boolean;
    mensaje!: string | undefined;

    constructor(data?: IDetalladoFusionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archivoFusionadoBase64 = _data["archivoFusionadoBase64"];
            this.exitoso = _data["exitoso"];
            this.mensaje = _data["mensaje"];
        }
    }

    static fromJS(data: any): DetalladoFusionResultDto {
        data = typeof data === "object" ? data : {};
        let result = new DetalladoFusionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["archivoFusionadoBase64"] = this.archivoFusionadoBase64;
        data["exitoso"] = this.exitoso;
        data["mensaje"] = this.mensaje;
        return data;
    }
}

export interface IDetalladoFusionResultDto {
    archivoFusionadoBase64: string | undefined;
    exitoso: boolean;
    mensaje: string | undefined;
}

export class ImportResultDto implements IImportResultDto {
    success!: boolean;
    message!: string | undefined;
    errorDetails!: string | undefined;
    processedRecords!: number;
    headerValidationPassed!: boolean;

    constructor(data?: ImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.errorDetails = _data["errorDetails"];
            this.processedRecords = _data["processedRecords"];
            this.headerValidationPassed = _data["headerValidationPassed"];
        }
    }

    static fromJS(data: any):ImportResultDto {
        data = typeof data === "object" ? data : {};
        let result = new ImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["errorDetails"] = this.errorDetails;
        data["processedRecords"] = this.processedRecords;
        data["headerValidationPassed"] = this.headerValidationPassed;
        return data;
    }
}

export interface IImportResultDto {
    success: boolean;
    message: string | undefined;
    errorDetails: string | undefined;
    processedRecords: number;
    headerValidationPassed: boolean;
}
export class PagedResultDtoOfSecuenciaDto implements IPagedResultDtoOfSecuenciaDto {
    totalCount!: number;
    items!: SecuenciaDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSecuenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SecuenciaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSecuenciaDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfSecuenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSecuenciaDto {
    totalCount: number;
    items: SecuenciaDto[] | undefined;
}

export class SecuenciaDto implements ISecuenciaDto {
    secuencia!: string | undefined;

    constructor(data?: ISecuenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secuencia = _data["secuencia"];
        }
    }

    static fromJS(data: any): SecuenciaDto {
        data = typeof data === "object" ? data : {};
        let result = new SecuenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["secuencia"] = this.secuencia;
        return data;
    }
}
export interface ISecuenciaDto {
    secuencia: string | undefined;
}
export class DetalladoUploadResultDto implements IDetalladoUploadResultDto {
    succesfullRecords!: any[] | undefined;
    errors!: string[] | undefined;
    totalRecords!: number;
    successfulRecords!: number;
    hasErrors!: boolean;

    constructor(data?: IDetalladoUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succesfullRecords = _data["succesfullRecords"] !== undefined ? _data["succesfullRecords"] : <any>undefined;
            this.errors = _data["errors"] !== undefined ? _data["errors"] : <any>undefined;
            this.totalRecords = _data["totalRecords"] !== undefined ? _data["totalRecords"] : <any>undefined;
            this.successfulRecords = _data["successfulRecords"] !== undefined ? _data["successfulRecords"] : <any>undefined;
            this.hasErrors = _data["hasErrors"] !== undefined ? _data["hasErrors"] : <any>undefined;
        }
    }

    static fromJS(data: any): DetalladoUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetalladoUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succesfullRecords"] = this.succesfullRecords;
        data["errors"] = this.errors;
        data["totalRecords"] = this.totalRecords;
        data["successfulRecords"] = this.successfulRecords;
        data["hasErrors"] = this.hasErrors;
        return data;
    }
}

export interface IDetalladoUploadResultDto {
    succesfullRecords: any[] | undefined;
    errors: string[] | undefined;
    totalRecords: number;
    successfulRecords: number;
    hasErrors: boolean;
}

export class PagedResultDtoOfDetalladoDto implements IPagedResultDtoOfDetalladoDto {
    totalCount!: number;
    items!: DetalladoDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDetalladoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DetalladoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDetalladoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDetalladoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDetalladoDto {
    totalCount: number;
    items: DetalladoDto[] | undefined;
}

export class DetalladoDto implements IDetalladoDto {
    id!: number;
    chassis!: string;
    secuencia!: string;
    numeroParte!: string;
    cantidad!: number;
    isActive!: boolean;
    userId!: number;
    userName!: string;
    registerDate!: moment.Moment;

    constructor(data?: IDetalladoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chassis = _data["chassis"];
            this.secuencia = _data["secuencia"];
            this.numeroParte = _data["numeroParte"];
            this.cantidad = _data["cantidad"];
            this.isActive = _data["isActive"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.registerDate = _data["registerDate"] ? moment(_data["registerDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DetalladoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetalladoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chassis"] = this.chassis;
        data["secuencia"] = this.secuencia;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["isActive"] = this.isActive;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDetalladoDto {
    id: number;
    chassis: string;
    secuencia: string;
    numeroParte: string;
    cantidad: number;
    isActive: boolean;
    userId: number;
    userName: string;
    registerDate: moment.Moment;
}

@Injectable()
export class EtiquetasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getEtiquetasList(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        isPaged: boolean | undefined,
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        chassis: string | undefined,
        commodityCode: string | undefined,
        secuencia: string | undefined,
        descripcion: string | undefined,
        escaneados: boolean | undefined,
        imprimirEtiquetas: boolean | undefined
    ): Observable<PagedResultDtoOfEtiquetaDto> {
        let url_ = this.baseUrl + "/api/detallado/frames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            sorting: sorting,
            filter: filter,
            pageSize: pageSize,
            pageNumber: pageNumber,
            isPaged: isPaged,
            fechaInicio: fechaInicio ? fechaInicio.toISOString() : <any>undefined,
            fechaFin: fechaFin ? fechaFin.toISOString() : <any>undefined,
            chassis: chassis,
            commodityCode: commodityCode,
            secuencia: secuencia,
            descripcion: descripcion,
            escaneados: escaneados,
            imprimirEtiquetas: imprimirEtiquetas
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEtiquetasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEtiquetasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEtiquetaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEtiquetaDto>;
        }));
    }

    protected processGetEtiquetasList(response: HttpResponseBase): Observable<PagedResultDtoOfEtiquetaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEtiquetaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEtiquetaDto>(null as any);
    }

    getEtiquetasConNumerosPartePdf(
        chassis: string | undefined,
        commodityCode: string | undefined,
        descripcion: string | undefined,
        escaneados: boolean | undefined,
        filter: string | undefined,
        imprimirEtiquetas: boolean | undefined,
        secuencia: string | undefined
    ): Observable<Blob> {
        let url_ = this.baseUrl + "/api/Report/EtiquetasConNumerosParte/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            chassis: chassis,
            commodityCode: commodityCode,
            descripcion: descripcion,
            escaneados: escaneados,
            filter: filter,
            imprimirEtiquetas: imprimirEtiquetas,
            secuencia: secuencia
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEtiquetasConNumerosPartePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEtiquetasConNumerosPartePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGetEtiquetasConNumerosPartePdf(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    getEtiquetasConNumerosParteList(
        chassis: string | undefined,
        commodityCode: string | undefined,
        descripcion: string | undefined,
        escaneados: boolean | undefined,
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        filter: string | undefined,
        imprimirEtiquetas: boolean | undefined,
        secuencia: string | undefined
    ): Observable<EtiquetaConNumerosParteDto[]> {
        let url_ = this.baseUrl + "/api/Report/EtiquetasConNumerosParte/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            chassis: chassis,
            commodityCode: commodityCode,
            descripcion: descripcion,
            escaneados: escaneados,
            fechaInicio: fechaInicio ? fechaInicio.toISOString() : undefined,
            fechaFin: fechaFin ? fechaFin.toISOString() : undefined,
            filter: filter,
            imprimirEtiquetas: imprimirEtiquetas,
            secuencia: secuencia
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEtiquetasConNumerosParteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEtiquetasConNumerosParteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EtiquetaConNumerosParteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EtiquetaConNumerosParteDto[]>;
        }));
    }

    protected processGetEtiquetasConNumerosParteList(response: HttpResponseBase): Observable<EtiquetaConNumerosParteDto[]> {
        const status = response.status;
        let responseBody: any;
        
        if (response instanceof HttpResponse) {
            responseBody = response.body;
        } else {
            responseBody = (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }
        
        if (status === 200) {
            // Si el responseBody ya es un objeto (JSON), usarlo directamente
            if (typeof responseBody === 'object' && responseBody !== null) {
                let result200: any = null;
                if (Array.isArray(responseBody)) {
                    result200 = [] as any;
                    for (let item of responseBody)
                        result200!.push(EtiquetaConNumerosParteDto.fromJS(item));
                } else {
                    result200 = <EtiquetaConNumerosParteDto[]><any>responseBody;
                }
                return _observableOf(result200);
            } else {
                // Si es un Blob, convertir a texto y parsear
                return blobToText(responseBody).pipe(_observableMergeMap(_responseText => {
                    let result200: any = null;
                    let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200)
                            result200!.push(EtiquetaConNumerosParteDto.fromJS(item));
                    } else {
                        result200 = <EtiquetaConNumerosParteDto[]><any>resultData200;
                    }
                    return _observableOf(result200);
                }));
            }
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBody).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EtiquetaConNumerosParteDto[]>(null as any);
    }
}

export class PagedResultDtoOfEtiquetaDto implements IPagedResultDtoOfEtiquetaDto {
    totalCount!: number;
    items!: EtiquetaDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEtiquetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EtiquetaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEtiquetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEtiquetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEtiquetaDto {
    totalCount: number;
    items: EtiquetaDto[] | undefined;
}

export class EtiquetaDto implements IEtiquetaDto {
    fecha!: moment.Moment;
    chassis!: string | undefined;
    commodityCode!: string | undefined;
    secuencia!: string | undefined;
    numeroParte!: string | undefined;
    descripcion!: string | undefined;
    faldonDescr!: string | undefined;
    esFantasma!: boolean;
    esReimpresion!: boolean | undefined;
    constructor(data?: IEtiquetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
            this.chassis = _data["chassis"];
            this.commodityCode = _data["commodityCode"];
            this.secuencia = _data["secuencia"];
            this.numeroParte = _data["numeroParte"];
            this.descripcion = _data["descripcion"];
            this.faldonDescr = _data["faldonDescr"];
            this.esFantasma = _data["esFantasma"];
            this.esReimpresion = _data["esReimpresion"];
        }
    }

    static fromJS(data: any): EtiquetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EtiquetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["chassis"] = this.chassis;
        data["commodityCode"] = this.commodityCode;
        data["secuencia"] = this.secuencia;
        data["numeroParte"] = this.numeroParte;
        data["descripcion"] = this.descripcion;
        data["faldonDescr"] = this.faldonDescr;
        data["esFantasma"] = this.esFantasma;
        data["esReimpresion"] = this.esReimpresion;
        return data;
    }
}

export interface IEtiquetaDto {
    fecha: moment.Moment;
    chassis: string | undefined;
    commodityCode: string | undefined;
    secuencia: string | undefined;
    numeroParte: string | undefined;
    descripcion: string;
    faldonDescr: string | undefined;
    esFantasma: boolean;
    esReimpresion: boolean | undefined;
}

export class EtiquetaConNumerosParteDto implements IEtiquetaConNumerosParteDto {
    fecha!: moment.Moment | undefined;
    secuencia!: string | undefined;
    commodityCode!: string | undefined;
    descripcion!: string | undefined;
    faldonDescr!: string | undefined;
    esFantasma!: boolean;
    fechaRegistro!: moment.Moment | undefined;
    esReimpresion!: boolean | undefined;
    numerosParte!: string[] | undefined;
    numerosParteConCantidades!: { [key: string]: number } | undefined;
    chassis!: string | undefined;
    
    // Propiedades computadas para compatibilidad con el frontend existente
    get programa(): string | undefined {
        return this.commodityCode;
    }
    
    get numerosParteString(): string | undefined {
        return this.numerosParte ? this.numerosParte.join(', ') : undefined;
    }

    constructor(data?: IEtiquetaConNumerosParteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
            this.secuencia = _data["secuencia"];
            this.commodityCode = _data["commodityCode"];
            this.descripcion = _data["descripcion"];
            this.faldonDescr = _data["faldonDescr"];
            this.esFantasma = _data["esFantasma"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.esReimpresion = _data["esReimpresion"];
            this.numerosParte = _data["numerosParte"] && Array.isArray(_data["numerosParte"]) ? _data["numerosParte"] : [];
            this.numerosParteConCantidades = _data["numerosParteConCantidades"] || {};
            this.chassis = _data["chassis"];
        }
    }

    static fromJS(data: any): EtiquetaConNumerosParteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EtiquetaConNumerosParteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["secuencia"] = this.secuencia;
        data["commodityCode"] = this.commodityCode;
        data["descripcion"] = this.descripcion;
        data["faldonDescr"] = this.faldonDescr;
        data["esFantasma"] = this.esFantasma;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["esReimpresion"] = this.esReimpresion;
        data["numerosParte"] = this.numerosParte;
        data["numerosParteConCantidades"] = this.numerosParteConCantidades;
        data["chassis"] = this.chassis;
        return data;
    }
}

export interface IEtiquetaConNumerosParteDto {
    fecha: moment.Moment | undefined;
    secuencia: string | undefined;
    commodityCode: string | undefined;
    descripcion: string | undefined;
    faldonDescr: string | undefined;
    esFantasma: boolean;
    fechaRegistro: moment.Moment | undefined;
    esReimpresion: boolean | undefined;
    numerosParte: string[] | undefined;
    numerosParteConCantidades: { [key: string]: number } | undefined;
    chassis: string | undefined;
}

// Chofer Service Proxy and DTOs
@Injectable()
export class ChoferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getChoferList(filter?: string | null, pageNumber?: number | null, pageSize?: number | null, sorting?: string | null): Observable<PagedResultDtoOfChoferForListResponse> {
        let url_ = this.baseUrl + "/api/chofer/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            filter: filter,
            pageNumber: pageNumber,
            pageSize: pageSize,
            sorting: sorting
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChoferList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChoferList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChoferForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChoferForListResponse>;
        }));
    }

    protected processGetChoferList(response: HttpResponseBase): Observable<PagedResultDtoOfChoferForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfChoferForListResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfChoferForListResponse>(<any>null);
    }

    getChofer(id: number): Observable<GetChoferForEditResponse> {
        let url_ = this.baseUrl + "/api/chofer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChofer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChofer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChoferForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChoferForEditResponse>;
        }));
    }

    protected processGetChofer(response: HttpResponseBase): Observable<GetChoferForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                
                // Fix: El backend devuelve directamente el objeto chofer, no envuelto
                // Necesitamos crear la estructura esperada por GetChoferForEditResponse
                if (resultData200 && !resultData200.chofer && resultData200.id) {
                    // Si resultData200 es directamente el chofer, lo envolvemos
                    resultData200 = { chofer: resultData200 };
                }
                
                result200 = GetChoferForEditResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChoferForEditResponse>(<any>null);
    }

    createChofer(input: CreateChoferDto): Observable<number> {
        let url_ = this.baseUrl + "/api/chofer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateChofer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChofer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateChofer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    updateChofer(id: number, input: UpdateChoferDto): Observable<number> {
        let url_ = this.baseUrl + "/api/chofer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateChofer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChofer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateChofer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    deleteChofer(id: number): Observable<DeleteChoferResponse> {
        let url_ = this.baseUrl + "/api/chofer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteChofer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChofer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteChoferResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteChoferResponse>;
        }));
    }

    protected processDeleteChofer(response: HttpResponseBase): Observable<DeleteChoferResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteChoferResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteChoferResponse>(<any>null);
    }

    exportChofer(filter?: string | null, sorting?: string | null): Observable<Blob> {
        let url_ = this.baseUrl + "/api/chofer/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            filter: filter,
            sorting: sorting
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportChofer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChofer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportChofer(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(<any>null);
    }
}

// DTOs for Chofer
export class PagedResultDtoOfChoferForListResponse implements IPagedResultDtoOfChoferForListResponse {
    totalCount!: number;
    items!: ChoferForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChoferForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChoferForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChoferForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChoferForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChoferForListResponse {
    totalCount: number;
    items: ChoferForListResponse[] | undefined;
}

export class ChoferForListResponse implements IChoferForListResponse {
    id!: number;
    nombreCompleto!: string | undefined;
    rfc!: string | undefined;
    telefono!: string | undefined;
    numeroLicencia!: string | undefined;
    fechaRegistro!: moment.Moment;
    usuarioRegistroNombre!: string | undefined;
    activo!: boolean;

    constructor(data?: IChoferForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.rfc = _data["rfc"];
            this.telefono = _data["telefono"];
            this.numeroLicencia = _data["numeroLicencia"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.usuarioRegistroNombre = _data["usuarioRegistroNombre"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): ChoferForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChoferForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombreCompleto"] = this.nombreCompleto;
        data["rfc"] = this.rfc;
        data["telefono"] = this.telefono;
        data["numeroLicencia"] = this.numeroLicencia;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["usuarioRegistroNombre"] = this.usuarioRegistroNombre;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IChoferForListResponse {
    id: number;
    nombreCompleto: string | undefined;
    rfc: string | undefined;
    telefono: string | undefined;
    numeroLicencia: string | undefined;
    fechaRegistro: moment.Moment;
    usuarioRegistroNombre: string | undefined;
    activo: boolean;
}

export class GetChoferForEditResponse implements IGetChoferForEditResponse {
    chofer!: ChoferDto | undefined;

    constructor(data?: IGetChoferForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chofer = _data["chofer"] ? ChoferDto.fromJS(_data["chofer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChoferForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChoferForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chofer"] = this.chofer ? this.chofer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChoferForEditResponse {
    chofer: ChoferDto | undefined;
}

export class ChoferDto implements IChoferDto {
    id!: number;
    nombre!: string | undefined;
    apellidoPaterno!: string | undefined;
    apellidoMaterno!: string | undefined;
    rfc!: string | undefined;
    telefono!: string | undefined;
    numeroLicencia!: string | undefined;
    activo!: boolean;

    constructor(data?: IChoferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.rfc = _data["rfc"];
            this.telefono = _data["telefono"];
            this.numeroLicencia = _data["numeroLicencia"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): ChoferDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["rfc"] = this.rfc;
        data["telefono"] = this.telefono;
        data["numeroLicencia"] = this.numeroLicencia;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IChoferDto {
    id: number;
    nombre: string | undefined;
    apellidoPaterno: string | undefined;
    apellidoMaterno: string | undefined;
    rfc: string | undefined;
    telefono: string | undefined;
    numeroLicencia: string | undefined;
    activo: boolean;
}

export class CreateChoferDto implements ICreateChoferDto {
    nombre!: string;
    apellidoPaterno!: string;
    apellidoMaterno!: string | undefined;
    rfc!: string;
    telefono!: string;
    numeroLicencia!: string;
    activo!: boolean;

    constructor(data?: ICreateChoferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.rfc = _data["rfc"];
            this.telefono = _data["telefono"];
            this.numeroLicencia = _data["numeroLicencia"];
            this.activo = _data["activo"] !== undefined ? _data["activo"] : true;
        }
    }

    static fromJS(data: any): CreateChoferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChoferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["rfc"] = this.rfc;
        data["telefono"] = this.telefono;
        data["numeroLicencia"] = this.numeroLicencia;
        data["activo"] = this.activo;
        return data;
    }
}

export interface ICreateChoferDto {
    nombre: string;
    apellidoPaterno: string;
    apellidoMaterno: string | undefined;
    rfc: string;
    telefono: string;
    numeroLicencia: string;
    activo: boolean;
}

export class UpdateChoferDto implements IUpdateChoferDto {
    nombre!: string;
    apellidoPaterno!: string;
    apellidoMaterno!: string | undefined;
    rfc!: string;
    telefono!: string;
    numeroLicencia!: string;
    activo!: boolean;

    constructor(data?: IUpdateChoferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nombre = _data["nombre"];
            this.apellidoPaterno = _data["apellidoPaterno"];
            this.apellidoMaterno = _data["apellidoMaterno"];
            this.rfc = _data["rfc"];
            this.telefono = _data["telefono"];
            this.numeroLicencia = _data["numeroLicencia"];
            this.activo = _data["activo"];
        }
    }

    static fromJS(data: any): UpdateChoferDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChoferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nombre"] = this.nombre;
        data["apellidoPaterno"] = this.apellidoPaterno;
        data["apellidoMaterno"] = this.apellidoMaterno;
        data["rfc"] = this.rfc;
        data["telefono"] = this.telefono;
        data["numeroLicencia"] = this.numeroLicencia;
        data["activo"] = this.activo;
        return data;
    }
}

export interface IUpdateChoferDto {
    nombre: string;
    apellidoPaterno: string;
    apellidoMaterno: string | undefined;
    rfc: string;
    telefono: string;
    numeroLicencia: string;
    activo: boolean;
}

export class DeleteChoferResponse implements IDeleteChoferResponse {
    message!: string | undefined;

    constructor(data?: IDeleteChoferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteChoferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChoferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IDeleteChoferResponse {
    message: string | undefined;
}

// Tractor DTOs
export class TractorDto implements ITractorDto {
    id!: number;
    tractorDescr!: string;
    placas?: string | undefined;
    estatus!: boolean;
    estado?: string | undefined;
    estatusDesc!: string;
    userName!: string;
    userId!: number;
    fechaRegistro?: moment.Moment;
    fechaRegistroString!: string;
    modifiedDate?: moment.Moment;

    constructor(data?: ITractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tractorDescr = _data["tractorDescr"];
            this.placas = _data["placas"];
            this.estatus = _data["estatus"];
            this.estado = _data["estado"];
            this.estatusDesc = _data["estatusDesc"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.fechaRegistroString = _data["fechaRegistroString"];
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tractorDescr"] = this.tractorDescr;
        data["placas"] = this.placas;
        data["estatus"] = this.estatus;
        data["estado"] = this.estado;
        data["estatusDesc"] = this.estatusDesc;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["fechaRegistroString"] = this.fechaRegistroString;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITractorDto {
    id: number;
    tractorDescr: string;
    placas?: string | undefined;
    estatus: boolean;
    estado?: string | undefined;
    estatusDesc: string;
    userName: string;
    userId: number;
    fechaRegistro?: moment.Moment;
    fechaRegistroString: string;
    modifiedDate?: moment.Moment;
}

export class PagedResultDtoOfTractorDto implements IPagedResultDtoOfTractorDto {
    totalCount!: number;
    unFilteredCount!: number;
    items!: TractorDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.unFilteredCount = _data["unFilteredCount"];
            if (Array.isArray(_data["result"])) {
                this.items = [] as any;
                for (let item of _data["result"])
                    this.items!.push(TractorDto.fromJS(item));
            } else if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TractorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["unFilteredCount"] = this.unFilteredCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTractorDto {
    totalCount: number;
    unFilteredCount: number;
    items: TractorDto[] | undefined;
}

export class TractorGetListQuery implements ITractorGetListQuery {
    filter?: string | undefined;
    sorting?: string | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    isPaged?: boolean | undefined;
    tractorDescr?: string | undefined;
    placas?: string | undefined;
    estatus?: boolean | undefined;

    constructor(data?: ITractorGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageNumber = 1;
            this.pageSize = 10;
            this.isPaged = true;
            this.sorting = "fechaRegistro DESC";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.isPaged = _data["isPaged"];
            this.tractorDescr = _data["tractorDescr"];
            this.placas = _data["placas"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): TractorGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TractorGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["isPaged"] = this.isPaged;
        data["tractorDescr"] = this.tractorDescr;
        data["placas"] = this.placas;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ITractorGetListQuery {
    filter?: string | undefined;
    sorting?: string | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    isPaged?: boolean | undefined;
    tractorDescr?: string | undefined;
    placas?: string | undefined;
    estatus?: boolean | undefined;
}

export class TractorForEditResponse implements ITractorForEditResponse {
    tractor?: TractorDto | undefined;

    constructor(data?: ITractorForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tractor = _data["tractor"] ? TractorDto.fromJS(_data["tractor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TractorForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TractorForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tractor"] = this.tractor ? this.tractor.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITractorForEditResponse {
    tractor?: TractorDto | undefined;
}

export class TractorGetForEditQuery implements ITractorGetForEditQuery {
    id?: number | undefined;

    constructor(data?: ITractorGetForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TractorGetForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TractorGetForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITractorGetForEditQuery {
    id?: number | undefined;
}

export class TractorCreateCommand implements ITractorCreateCommand {
    tractorDescr!: string;
    placas?: string | undefined;
    estatus!: boolean;

    constructor(data?: ITractorCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tractorDescr = _data["tractorDescr"];
            this.placas = _data["placas"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): TractorCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TractorCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tractorDescr"] = this.tractorDescr;
        data["placas"] = this.placas;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ITractorCreateCommand {
    tractorDescr: string;
    placas?: string | undefined;
    estatus: boolean;
}

export class TractorUpdateCommand implements ITractorUpdateCommand {
    id!: number;
    tractorDescr!: string;
    placas?: string | undefined;
    estatus!: boolean;

    constructor(data?: ITractorUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tractorDescr = _data["tractorDescr"];
            this.placas = _data["placas"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): TractorUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TractorUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tractorDescr"] = this.tractorDescr;
        data["placas"] = this.placas;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ITractorUpdateCommand {
    id: number;
    tractorDescr: string;
    placas?: string | undefined;
    estatus: boolean;
}

export class TractorDeleteCommand implements ITractorDeleteCommand {
    id!: number;

    constructor(data?: ITractorDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TractorDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TractorDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITractorDeleteCommand {
    id: number;
}

export class TractorReactivateCommand implements ITractorReactivateCommand {
    id!: number;

    constructor(data?: ITractorReactivateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TractorReactivateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TractorReactivateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITractorReactivateCommand {
    id: number;
}

export class TractorExportQuery implements ITractorExportQuery {
    filter?: string | undefined;
    sorting?: string | undefined;
    tractorDescr: string;
    estatus: boolean;

    constructor(data?: ITractorExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): TractorExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TractorExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["tractorDescr"] = this.tractorDescr;
        data["estatus"] = this.estatus;

        return data;
    }
}

export interface ITractorExportQuery {
    filter?: string | undefined;
    sorting?: string | undefined;
    tractorDescr?: string;
    estatus?: boolean;
}

export interface FileResult {
    data: Blob;
    fileName?: string;
}

// TractorServiceProxy
@Injectable()
export class TractorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getTractorList(query: TractorGetListQuery): Observable<PagedResultDtoOfTractorDto> {
        let url_ = this.baseUrl + "/api/tractor/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTractorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTractorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTractorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTractorDto>;
        }));
    }

    protected processGetTractorList(response: HttpResponseBase): Observable<PagedResultDtoOfTractorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = PagedResultDtoOfTractorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTractorDto>(null as any);
    }

    getTractorForEdit(query: TractorGetForEditQuery): Observable<TractorForEditResponse> {
        let url_ = this.baseUrl + "/api/tractor/get-for-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTractorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTractorForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TractorForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TractorForEditResponse>;
        }));
    }

    protected processGetTractorForEdit(response: HttpResponseBase): Observable<TractorForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = TractorForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TractorForEditResponse>(null as any);
    }

    createTractor(command: TractorCreateCommand): Observable<any> {
        let url_ = this.baseUrl + "/api/tractor/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCreateTractor(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    updateTractor(command: TractorUpdateCommand): Observable<any> {
        let url_ = this.baseUrl + "/api/tractor/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateTractor(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    deleteTractor(command: TractorDeleteCommand): Observable<any> {
        let url_ = this.baseUrl + "/api/tractor/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteTractor(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    reactivateTractor(command: TractorReactivateCommand): Observable<any> {
        let url_ = this.baseUrl + "/api/tractor/reactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateTractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateTractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processReactivateTractor(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    exportTractor(query: TractorExportQuery): Observable<FileResult> {
        let url_ = this.baseUrl + "/api/tractor/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResult>;
        }));
    }

    protected processExportTractor(response: HttpResponseBase): Observable<FileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch[1] ? fileNameMatch[1].replace(/['"]/g, '') : "tractors_export.xlsx";
            
            return _observableOf({data: responseBlob, fileName: fileName});
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResult>(null as any);
    }
}

// CausaFaltante DTOs
export class CausaFaltanteForListResponse implements ICausaFaltanteForListResponse {
    id!: number;
    causaFaltanteCodigo!: string;
    causaFaltanteDescr!: string;
    estatus!: boolean;
    usuarioRegistroId!: number;
    fechaRegistro!: moment.Moment;
    usuarioRegistroDesc!: string;

    constructor(data?: ICausaFaltanteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.causaFaltanteCodigo = _data["causaFaltanteCodigo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.estatus = _data["estatus"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.usuarioRegistroDesc = _data["usuarioRegistroDesc"];
        }
    }

    static fromJS(data: any): CausaFaltanteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["causaFaltanteCodigo"] = this.causaFaltanteCodigo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["estatus"] = this.estatus;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["usuarioRegistroDesc"] = this.usuarioRegistroDesc;
        return data;
    }
}

export interface ICausaFaltanteForListResponse {
    id: number;
    causaFaltanteCodigo: string;
    causaFaltanteDescr: string;
    estatus: boolean;
    usuarioRegistroId: number;
    fechaRegistro: moment.Moment;
    usuarioRegistroDesc: string;
}

export class PagedResultDtoOfCausaFaltanteForListResponse implements IPagedResultDtoOfCausaFaltanteForListResponse {
    totalCount!: number;
    items!: CausaFaltanteForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfCausaFaltanteForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CausaFaltanteForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCausaFaltanteForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCausaFaltanteForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCausaFaltanteForListResponse {
    totalCount: number;
    items: CausaFaltanteForListResponse[] | undefined;
}

export class CausaFaltanteForEditResponse implements ICausaFaltanteForEditResponse {
    id!: number;
    causaFaltanteCodigo!: string;
    causaFaltanteDescr!: string;
    estatus!: boolean;

    constructor(data?: ICausaFaltanteForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.causaFaltanteCodigo = _data["causaFaltanteCodigo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): CausaFaltanteForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["causaFaltanteCodigo"] = this.causaFaltanteCodigo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ICausaFaltanteForEditResponse {
    id: number;
    causaFaltanteCodigo: string;
    causaFaltanteDescr: string;
    estatus: boolean;
}

export class CausaFaltanteCreateCommand implements ICausaFaltanteCreateCommand {
    causaFaltanteCodigo!: string;
    causaFaltanteDescr!: string;
    estatus!: boolean;

    constructor(data?: ICausaFaltanteCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.causaFaltanteCodigo = _data["causaFaltanteCodigo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): CausaFaltanteCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causaFaltanteCodigo"] = this.causaFaltanteCodigo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ICausaFaltanteCreateCommand {
    causaFaltanteCodigo: string;
    causaFaltanteDescr: string;
    estatus: boolean;
}

export class CausaFaltanteUpdateCommand implements ICausaFaltanteUpdateCommand {
    id!: number;
    causaFaltanteCodigo!: string;
    causaFaltanteDescr!: string;
    estatus!: boolean;

    constructor(data?: ICausaFaltanteUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.causaFaltanteCodigo = _data["causaFaltanteCodigo"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.estatus = _data["estatus"];
        }
    }

    static fromJS(data: any): CausaFaltanteUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["causaFaltanteCodigo"] = this.causaFaltanteCodigo;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface ICausaFaltanteUpdateCommand {
    id: number;
    causaFaltanteCodigo: string;
    causaFaltanteDescr: string;
    estatus: boolean;
}

@Injectable()
export class CausaFaltanteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getCausaFaltanteList(query: CausaFaltanteGetListQuery): Observable<PagedResultDtoOfCausaFaltanteForListResponse>;
    getCausaFaltanteList(maxResultCount?: number | undefined, skipCount?: number | undefined, sorting?: string | undefined, filter?: string | undefined, estatus?: boolean | undefined, causaFaltanteCodigo?: string | undefined, causaFaltanteDescr?: string | undefined): Observable<PagedResultDtoOfCausaFaltanteForListResponse>;
    getCausaFaltanteList(queryOrMaxResultCount?: CausaFaltanteGetListQuery | number | undefined, skipCount?: number | undefined, sorting?: string | undefined, filter?: string | undefined, estatus?: boolean | undefined, causaFaltanteCodigo?: string | undefined, causaFaltanteDescr?: string | undefined): Observable<PagedResultDtoOfCausaFaltanteForListResponse> {
        let url_ = this.baseUrl + "/api/causa-faltante/list";
        url_ = url_.replace(/[?&]$/, "");

        let requestData: any;
        if (queryOrMaxResultCount instanceof CausaFaltanteGetListQuery) {
            // Using query object - send the object directly to match backend expectations
            requestData = {
                pageNumber: queryOrMaxResultCount.pageNumber || 1,
                pageSize: queryOrMaxResultCount.pageSize || 10,
                sorting: queryOrMaxResultCount.sorting || "FechaRegistro DESC",
                filter: queryOrMaxResultCount.filter || "",
                estatus: queryOrMaxResultCount.estatus,
                causaFaltanteCodigo: queryOrMaxResultCount.causaFaltanteCodigo || "",
                causaFaltanteDescr: queryOrMaxResultCount.causaFaltanteDescr || ""
            };
        } else {
            // Using individual parameters
            requestData = {
                maxResultCount: queryOrMaxResultCount || 10,
                skipCount: skipCount || 0,
                sorting: sorting || "FechaRegistro DESC",
                filter: filter || "",
                estatus: estatus,
                causaFaltanteCodigo: causaFaltanteCodigo || "",
                causaFaltanteDescr: causaFaltanteDescr || ""
            };
        }

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausaFaltanteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausaFaltanteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCausaFaltanteForListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCausaFaltanteForListResponse>;
        }));
    }

    protected processGetCausaFaltanteList(response: HttpResponseBase): Observable<PagedResultDtoOfCausaFaltanteForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = PagedResultDtoOfCausaFaltanteForListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCausaFaltanteForListResponse>(null as any);
    }

    getCausaFaltanteForEdit(id: number): Observable<CausaFaltanteForEditResponse> {
        let url_ = this.baseUrl + "/api/causa-faltante/get-for-edit";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            id: id
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausaFaltanteForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausaFaltanteForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CausaFaltanteForEditResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CausaFaltanteForEditResponse>;
        }));
    }

    protected processGetCausaFaltanteForEdit(response: HttpResponseBase): Observable<CausaFaltanteForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = CausaFaltanteForEditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CausaFaltanteForEditResponse>(null as any);
    }

    createCausaFaltante(dto: CausaFaltanteCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/causa-faltante/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCausaFaltante(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    updateCausaFaltante(dto: CausaFaltanteUpdateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/causa-faltante/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCausaFaltante(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteCausaFaltante(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/causa-faltante/delete";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            id: id
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteCausaFaltante(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reactivateCausaFaltante(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/causa-faltante/reactivate";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            id: id
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReactivateCausaFaltante(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportCausaFaltante(sorting?: string | undefined, filter?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, isPaged?: boolean | undefined, estatus?: boolean | undefined, causaFaltanteCodigo?: string | undefined, causaFaltanteDescr?: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/causa-faltante/export";
        url_ = url_.replace(/[?&]$/, "");

        const requestData = {
            sorting: sorting || "",
            filter: filter || "",
            pageSize: pageSize || 0,
            pageNumber: pageNumber || 0,
            isPaged: isPaged || false,
            estatus: estatus,
            causaFaltanteCodigo: causaFaltanteCodigo || "",
            causaFaltanteDescr: causaFaltanteDescr || ""
        };

        const content_ = JSON.stringify(requestData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportCausaFaltante(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    getCausasFaltantes(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: string | undefined, commodity?: string | undefined, secuencia?: string | undefined, numeroParte?: string | undefined, causaFaltante?: string | undefined, fechaInicio?: moment.Moment | undefined, fechaFin?: moment.Moment | undefined, programa?: number | undefined): Observable<PagedResultDtoOfCausaFaltanteItem> {
        let url_ = this.baseUrl + "/api/causas/faltantes";
        url_ = url_.replace(/[?&]$/, "");

        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "?pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (commodity === null)
            throw new Error("The parameter 'commodity' cannot be null.");
        else if (commodity !== undefined)
            url_ += "commodity=" + encodeURIComponent("" + commodity) + "&";
        if (secuencia === null)
            throw new Error("The parameter 'secuencia' cannot be null.");
        else if (secuencia !== undefined)
            url_ += "secuencia=" + encodeURIComponent("" + secuencia) + "&";
        if (numeroParte === null)
            throw new Error("The parameter 'numeroParte' cannot be null.");
        else if (numeroParte !== undefined)
            url_ += "numeroParte=" + encodeURIComponent("" + numeroParte) + "&";
        if (causaFaltante === null)
            throw new Error("The parameter 'causaFaltante' cannot be null.");
        else if (causaFaltante !== undefined)
            url_ += "causaFaltante=" + encodeURIComponent("" + causaFaltante) + "&";
        if (fechaInicio === null)
            throw new Error("The parameter 'fechaInicio' cannot be null.");
        else if (fechaInicio !== undefined)
            url_ += "fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : "") + "&";
        if (fechaFin === null)
            throw new Error("The parameter 'fechaFin' cannot be null.");
        else if (fechaFin !== undefined)
            url_ += "fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : "") + "&";
        if (programa === null)
            throw new Error("The parameter 'programa' cannot be null.");
        else if (programa !== undefined)
            url_ += "programa=" + encodeURIComponent("" + programa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCausasFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausasFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCausaFaltanteItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCausaFaltanteItem>;
        }));
    }

    protected processGetCausasFaltantes(response: HttpResponseBase): Observable<PagedResultDtoOfCausaFaltanteItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = PagedResultDtoOfCausaFaltanteItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCausaFaltanteItem>(null as any);
    }

    exportCausasFaltantes(sorting?: string | undefined, commodity?: string | undefined, secuencia?: string | undefined, numeroParte?: string | undefined, causaFaltante?: string | undefined, fechaInicio?: moment.Moment | undefined, fechaFin?: moment.Moment | undefined, programa?: number | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/causas/faltantes/export";
        url_ = url_.replace(/[?&]$/, "");

        if (sorting !== undefined && sorting !== null)
            url_ += "?Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (commodity !== undefined && commodity !== null)
            url_ += "Commodity=" + encodeURIComponent("" + commodity) + "&";
        if (secuencia !== undefined && secuencia !== null)
            url_ += "Secuencia=" + encodeURIComponent("" + secuencia) + "&";
        if (numeroParte !== undefined && numeroParte !== null)
            url_ += "NumeroParte=" + encodeURIComponent("" + numeroParte) + "&";
        if (causaFaltante !== undefined && causaFaltante !== null)
            url_ += "CausaFaltante=" + encodeURIComponent("" + causaFaltante) + "&";
        if (fechaInicio !== undefined && fechaInicio !== null)
            url_ += "FechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : "") + "&";
        if (fechaFin !== undefined && fechaFin !== null)
            url_ += "FechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : "") + "&";
        if (programa !== undefined && programa !== null)
            url_ += "Programa=" + encodeURIComponent("" + programa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCausasFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCausasFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportCausasFaltantes(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    updateCausasFaltantes(request: UpdateCausasFaltantesRequest): Observable<UpdateCausasFaltantesResponse> {
        let url_ = this.baseUrl + "/api/causas/faltantes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCausasFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCausasFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCausasFaltantesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCausasFaltantesResponse>;
        }));
    }

    protected processUpdateCausasFaltantes(response: HttpResponseBase): Observable<UpdateCausasFaltantesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            
            result200 = UpdateCausasFaltantesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCausasFaltantesResponse>(null as any);
    }
}

// LineaProduccionCommodityGrupo
// =============================

@Injectable()
export class LineaProduccionCommodityGrupoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getList(request: LineaProduccionCommodityGrupoGetListRequest): Observable<PagedResultDtoOfLineaProduccionCommodityGrupoListDto> {
        let url_ = this.baseUrl + "/api/lineaproduccioncommoditygrupo/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLineaProduccionCommodityGrupoListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLineaProduccionCommodityGrupoListDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfLineaProduccionCommodityGrupoListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfLineaProduccionCommodityGrupoListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLineaProduccionCommodityGrupoListDto>(null as any);
    }

    create(request: LineaProduccionCommodityGrupoCreateDto): Observable<number> {
        let url_ = this.baseUrl + "/api/lineaproduccioncommoditygrupo/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    delete(request: LineaProduccionCommodityGrupoDeleteDto): Observable<void> {
        let url_ = this.baseUrl + "/api/lineaproduccioncommoditygrupo/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

// DTOs
export class LineaProduccionCommodityGrupoGetListRequest implements ILineaProduccionCommodityGrupoGetListRequest {
    sorting!: string | undefined;
    filter!: string | undefined;
    pageSize!: number;
    pageNumber!: number;
    isPaged!: boolean;
    lineaProduccionId!: number;

    constructor(data?: ILineaProduccionCommodityGrupoGetListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.isPaged = _data["isPaged"];
            this.lineaProduccionId = _data["lineaProduccionId"];
        }
    }

    static fromJS(data: any): LineaProduccionCommodityGrupoGetListRequest {
        data = typeof data === "object" ? data : {};
        let result = new LineaProduccionCommodityGrupoGetListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["isPaged"] = this.isPaged;
        data["lineaProduccionId"] = this.lineaProduccionId;
        return data;
    }
}

export interface ILineaProduccionCommodityGrupoGetListRequest {
    sorting: string | undefined;
    filter: string | undefined;
    pageSize: number;
    pageNumber: number;
    isPaged: boolean;
    lineaProduccionId: number;
}

export class PagedResultDtoOfLineaProduccionCommodityGrupoListDto implements IPagedResultDtoOfLineaProduccionCommodityGrupoListDto {
    totalCount!: number;
    items!: LineaProduccionCommodityGrupoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLineaProduccionCommodityGrupoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LineaProduccionCommodityGrupoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLineaProduccionCommodityGrupoListDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfLineaProduccionCommodityGrupoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLineaProduccionCommodityGrupoListDto {
    totalCount: number;
    items: LineaProduccionCommodityGrupoListDto[] | undefined;
}

export class LineaProduccionCommodityGrupoListDto implements ILineaProduccionCommodityGrupoListDto {
    id!: number;
    commodityGrupoDescr!: string | undefined;
    orden!: number;
    isActive!: boolean;
    
    constructor(data?: ILineaProduccionCommodityGrupoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.orden = _data["orden"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LineaProduccionCommodityGrupoListDto {
        data = typeof data === "object" ? data : {};
        let result = new LineaProduccionCommodityGrupoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["orden"] = this.orden;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILineaProduccionCommodityGrupoListDto {
    id: number;
    commodityGrupoDescr: string | undefined;
    orden: number;
    isActive: boolean;
}

export class LineaProduccionCommodityGrupoCreateDto implements ILineaProduccionCommodityGrupoCreateDto {
    lineaProduccionId!: number;
    commodityGrupoId!: number;
    orden!: number;
    isActive!: boolean;

    constructor(data?: ILineaProduccionCommodityGrupoCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineaProduccionId = _data["lineaProduccionId"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.orden = _data["orden"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LineaProduccionCommodityGrupoCreateDto {
        data = typeof data === "object" ? data : {};
        let result = new LineaProduccionCommodityGrupoCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["lineaProduccionId"] = this.lineaProduccionId;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["orden"] = this.orden;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILineaProduccionCommodityGrupoCreateDto {
    lineaProduccionId: number;
    commodityGrupoId: number;
    orden: number;
    isActive: boolean;
}

export class LineaProduccionCommodityGrupoDeleteDto implements ILineaProduccionCommodityGrupoDeleteDto {
    id!: number;

    constructor(data?: ILineaProduccionCommodityGrupoDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LineaProduccionCommodityGrupoDeleteDto {
        data = typeof data === "object" ? data : {};
        let result = new LineaProduccionCommodityGrupoDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILineaProduccionCommodityGrupoDeleteDto {
    id: number;
}

export interface ICreateSecuenciaActualLineaProduccionDto {
    secuencia: string;
    lineaProduccionId: number;
    forceUpdate: number;
}

@Injectable()
export class SecuenciaActualLineaProduccionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getSecuenciaActualLineaProduccionList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/GetSecuenciaActualLineaProduccionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecuenciaActualLineaProduccionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecuenciaActualLineaProduccionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetSecuenciaActualLineaProduccionList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    createSecuenciaActualLineaProduccion(dto: ICreateSecuenciaActualLineaProduccionDto): Observable<number> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/CreateSecuenciaActualLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    createSecuenciaActualLineaProduccionWithoutInterceptor(dto: ICreateSecuenciaActualLineaProduccionDto): Observable<number> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/CreateSecuenciaActualLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "skip-error-interceptor": "true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSecuenciaActualLineaProduccion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteSecuenciaActualLineaProduccion(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/DeleteSecuenciaActualLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSecuenciaActualLineaProduccion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    activateSecuenciaActualLineaProduccion(dto: any): Observable<number> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/ActivateSecuenciaActualLineaProduccion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processActivateSecuenciaActualLineaProduccion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    exportSecuenciaActualLineaProduccion(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/ExportSecuenciaActualLineaProduccion/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportSecuenciaActualLineaProduccion(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    /**
     * Actualizar secuencia actual de línea de producción
     * @param dto - Objeto con lineaProduccionId y secuencia
     * @returns Observable<any>
     */
    updateSecuenciaActualLineaProduccion(dto: { lineaProduccionId: string | number, secuencia: string }): Observable<any> {
        let url_ = this.baseUrl + "/api/lineas-produccion/secuencias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response", 
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSecuenciaActualLineaProduccion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecuenciaActualLineaProduccion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateSecuenciaActualLineaProduccion(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    cargaMasiva(file: File): Observable<any> {
        let url_ = this.baseUrl + "/api/SecuenciaActualLineaProduccion/carga-masiva";
        url_ = url_.replace(/[?&]$/, "");

        const formData = new FormData();
        formData.append('Archivo', file, file.name);

        let options_: any = {
            body: formData,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCargaMasiva(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargaMasiva(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCargaMasiva(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            // Para cualquier otro status, intentar parsear el body como JSON
            // El backend puede devolver {esValido, errores} con status 400/422
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                try {
                    const parsedBody = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (parsedBody !== null && parsedBody.errores !== undefined) {
                        return _observableOf(parsedBody);
                    }
                } catch { }
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
    }
}

@Injectable()
export class EscanearMarcarFaltantesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    // Nuevo método para obtener la lista simplificada de partes faltantes
    getEscanearMarcarFaltantesList(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        isPaged: boolean | undefined,
        commodity: string | undefined,
        secuencia: string | undefined,
        chasis: string | undefined,
        numeroParte: string | undefined,
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        commodityGrupoDescr: string | undefined,
        causaFaltanteId: number | undefined,
        todos: boolean | undefined,
        programa: number | undefined
    ): Observable<PagedResultDtoOfEscanearFaltanteSimpleDto> {
        let url_ = this.baseUrl + "/api/escanear/partes-faltantes";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (sorting !== undefined && sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (isPaged !== undefined && isPaged !== null)
            queryParams.push("isPaged=" + encodeURIComponent("" + isPaged));
        if (commodity !== undefined && commodity !== null)
            queryParams.push("commodity=" + encodeURIComponent("" + commodity));
        if (secuencia !== undefined && secuencia !== null)
            queryParams.push("secuencia=" + encodeURIComponent("" + secuencia));
        if (chasis !== undefined && chasis !== null)
            queryParams.push("chasis=" + encodeURIComponent("" + chasis));
        if (numeroParte !== undefined && numeroParte !== null)
            queryParams.push("numeroParte=" + encodeURIComponent("" + numeroParte));
        if (fechaInicio !== undefined && fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (commodityGrupoDescr !== undefined && commodityGrupoDescr !== null)
            queryParams.push("commodityGrupoDescr=" + encodeURIComponent("" + commodityGrupoDescr));
        if (causaFaltanteId !== undefined && causaFaltanteId !== null)
            queryParams.push("causaFaltanteId=" + encodeURIComponent("" + causaFaltanteId));
        if (todos !== undefined && todos !== null)
            queryParams.push("todos=" + encodeURIComponent("" + todos));
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEscanearMarcarFaltantesListSimple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEscanearMarcarFaltantesListSimple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEscanearFaltanteSimpleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEscanearFaltanteSimpleDto>;
        }));
    }

    protected processGetEscanearMarcarFaltantesListSimple(response: HttpResponseBase): Observable<PagedResultDtoOfEscanearFaltanteSimpleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEscanearFaltanteSimpleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEscanearFaltanteSimpleDto>(null as any);
    }

    updateCausaFaltante(
        secuenciaFaltanteIds: number[],
        causaFaltanteId: number
    ): Observable<number> {
        let url_ = this.baseUrl + "/api/escanear-marcar-faltantes/cause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            secuenciaFaltanteIds: secuenciaFaltanteIds,
            causaFaltanteId: causaFaltanteId
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCausaFaltante(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCausaFaltante(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCausaFaltante(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    // Nuevo método PUT para actualizar la lista de partes faltantes
    updateEscanearMarcarFaltantesList(data: any): Observable<IEscanearFaltantesUpdateResponse> {
        let url_ = this.baseUrl + "/api/escanear/partes-faltantes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEscanearMarcarFaltantesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEscanearMarcarFaltantesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IEscanearFaltantesUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IEscanearFaltantesUpdateResponse>;
        }));
    }

    protected processUpdateEscanearMarcarFaltantesList(response: HttpResponseBase): Observable<IEscanearFaltantesUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IEscanearFaltantesUpdateResponse>(null as any);
    }

    // Nuevo método para obtener commodities por grupo
    getCommoditiesPorGrupo(grupoId: number | undefined, filter: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/escanear/partes-faltantes/commodities-por-grupo";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (grupoId !== undefined && grupoId !== null)
            queryParams.push("GrupoId=" + encodeURIComponent("" + grupoId));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommoditiesPorGrupo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommoditiesPorGrupo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetCommoditiesPorGrupo(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(null as any);
    }
}

@Injectable()
export class ReiniciarSecuenciaGrupoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    // Método para obtener la lista de secuencias a reiniciar
    getList(request: any): Observable<PagedResultDtoOfReiniciarSecuenciaSimpleDto> {
        let url_ = this.baseUrl + "/api/reiniciar/secuencias";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (request.sorting !== undefined && request.sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + request.sorting));
        if (request.filter !== undefined && request.filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + request.filter));
        if (request.pageSize !== undefined && request.pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + request.pageSize));
        if (request.pageNumber !== undefined && request.pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + request.pageNumber));
        if (request.isPaged !== undefined && request.isPaged !== null)
            queryParams.push("isPaged=" + encodeURIComponent("" + request.isPaged));
        if (request.commodity !== undefined && request.commodity !== null)
            queryParams.push("commodity=" + encodeURIComponent("" + request.commodity));
        if (request.programa !== undefined && request.programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + request.programa));
        if (request.secuencia !== undefined && request.secuencia !== null)
            queryParams.push("secuencia=" + encodeURIComponent("" + request.secuencia));
        if (request.fechaInicio !== undefined && request.fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent(request.fechaInicio ? "" + request.fechaInicio.toISOString() : ""));
        if (request.fechaFin !== undefined && request.fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent(request.fechaFin ? "" + request.fechaFin.toISOString() : ""));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReiniciarSecuenciasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReiniciarSecuenciasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReiniciarSecuenciaSimpleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReiniciarSecuenciaSimpleDto>;
        }));
    }

    protected processGetReiniciarSecuenciasList(response: HttpResponseBase): Observable<PagedResultDtoOfReiniciarSecuenciaSimpleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReiniciarSecuenciaSimpleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReiniciarSecuenciaSimpleDto>(null as any);
    }

    // Método para actualizar secuencias
    updateSecuencias(data: any): Observable<IReiniciarSecuenciaUpdateResponse> {
        let url_ = this.baseUrl + "/api/reiniciar/secuencias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReiniciarSecuencias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReiniciarSecuencias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IReiniciarSecuenciaUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IReiniciarSecuenciaUpdateResponse>;
        }));
    }

    protected processUpdateReiniciarSecuencias(response: HttpResponseBase): Observable<IReiniciarSecuenciaUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IReiniciarSecuenciaUpdateResponse>(null as any);
    }

    // Método para obtener commodities por grupo (reutilizando el mismo endpoint)
    getCommoditiesPorGrupo(grupoId: number | undefined, filter: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/escanear/partes-faltantes/commodities-por-grupo";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (grupoId !== undefined && grupoId !== null)
            queryParams.push("GrupoId=" + encodeURIComponent("" + grupoId));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommoditiesPorGrupoReinicio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommoditiesPorGrupoReinicio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetCommoditiesPorGrupoReinicio(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(null as any);
    }
}

export class SecuenciaPausableDto implements ISecuenciaPausableDto {
    secuencia!: string;
    programaId!: number;
    commodityGrupoDescr!: string;

    constructor(data?: ISecuenciaPausableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secuencia = _data["secuencia"];
            this.programaId = _data["programaId"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
        }
    }

    static fromJS(data: any): SecuenciaPausableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciaPausableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuencia"] = this.secuencia;
        data["programaId"] = this.programaId;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        return data;
    }
}

export interface ISecuenciaPausableDto {
    secuencia: string;
    programaId: number;
    commodityGrupoDescr: string;
}

export class SecuenciasPausablesResponseDto implements ISecuenciasPausablesResponseDto {
    secuencias!: SecuenciaPausableDto[] | undefined;
    totalRecords!: number;

    constructor(data?: ISecuenciasPausablesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secuencias"])) {
                this.secuencias = [] as any;
                for (let item of _data["secuencias"])
                    this.secuencias!.push(SecuenciaPausableDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): SecuenciasPausablesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciasPausablesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secuencias)) {
            data["secuencias"] = [];
            for (let item of this.secuencias)
                data["secuencias"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface ISecuenciasPausablesResponseDto {
    secuencias: SecuenciaPausableDto[] | undefined;
    totalRecords: number;
}

export interface IPausarSecuenciasMasivoResponse {
    completed: boolean;
    message: string;
    errorCode: string;
    title: string;
    statusCode: number;
    secuenciasActualizadas?: number;
    filasActualizadas?: number;
}

@Injectable()
export class SequencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    // Método para obtener las secuencias pausables/pausadas de un programa
    getPausables(request: any): Observable<SecuenciasPausablesResponseDto> {
        let url_ = this.baseUrl + "/api/sequences/pausable";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (request.programa !== undefined && request.programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + request.programa));
        if (request.secuenciaInicio !== undefined && request.secuenciaInicio !== null)
            queryParams.push("secuenciaInicio=" + encodeURIComponent("" + request.secuenciaInicio));
        if (request.secuenciaFin !== undefined && request.secuenciaFin !== null)
            queryParams.push("secuenciaFin=" + encodeURIComponent("" + request.secuenciaFin));
        if (request.fechaInicio !== undefined && request.fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent("" + request.fechaInicio));
        if (request.fechaFin !== undefined && request.fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent("" + request.fechaFin));
        if (request.pageNumber !== undefined && request.pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + request.pageNumber));
        if (request.pageSize !== undefined && request.pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + request.pageSize));
        if (request.sortField !== undefined && request.sortField !== null)
            queryParams.push("sortField=" + encodeURIComponent("" + request.sortField));
        if (request.sortDirection !== undefined && request.sortDirection !== null)
            queryParams.push("sortDirection=" + encodeURIComponent("" + request.sortDirection));
        if (request.soloPausadas !== undefined && request.soloPausadas !== null)
            queryParams.push("soloPausadas=" + encodeURIComponent("" + request.soloPausadas));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPausables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPausables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecuenciasPausablesResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecuenciasPausablesResponseDto>;
        }));
    }

    protected processGetPausables(response: HttpResponseBase): Observable<SecuenciasPausablesResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecuenciasPausablesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecuenciasPausablesResponseDto>(null as any);
    }

    // Método para pausar o reactivar secuencias de forma masiva
    pausarReactivarMasivo(data: any): Observable<IPausarSecuenciasMasivoResponse> {
        let url_ = this.baseUrl + "/api/sequences/pausar-masivo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausarReactivarMasivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausarReactivarMasivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPausarSecuenciasMasivoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPausarSecuenciasMasivoResponse>;
        }));
    }

    protected processPausarReactivarMasivo(response: HttpResponseBase): Observable<IPausarSecuenciasMasivoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IPausarSecuenciasMasivoResponse>(null as any);
    }
}


// Nueva interfaz simplificada para la respuesta del API
export class EscanearFaltanteSimpleDto implements IEscanearFaltanteSimpleDto {
    commodityCode!: string;
    secuencia!: string;
    partNumber!: string;
    grupo!: string;

    constructor(data?: IEscanearFaltanteSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodityCode = _data["commodityCode"];
            this.secuencia = _data["secuencia"];
            this.partNumber = _data["partNumber"];
            this.grupo = _data["grupo"];
        }
    }

    static fromJS(data: any): EscanearFaltanteSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EscanearFaltanteSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityCode"] = this.commodityCode;
        data["secuencia"] = this.secuencia;
        data["partNumber"] = this.partNumber;
        data["grupo"] = this.grupo;
        return data;
    }
}

export interface IEscanearFaltanteSimpleDto {
    commodityCode: string;
    secuencia: string;
    partNumber: string;
    grupo: string;
}

// Respuesta paginada para la nueva estructura simplificada
export class PagedResultDtoOfEscanearFaltanteSimpleDto implements IPagedResultDtoOfEscanearFaltanteSimpleDto {
    totalCount!: number;
    items!: EscanearFaltanteSimpleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEscanearFaltanteSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EscanearFaltanteSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEscanearFaltanteSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEscanearFaltanteSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEscanearFaltanteSimpleDto {
    totalCount: number;
    items: EscanearFaltanteSimpleDto[] | undefined;
}

// Interfaz para la respuesta del PUT /api/escanear/partes-faltantes
export interface IEscanearFaltantesUpdateResponse {
    secuenciasProcesadas: number;
    partesOK: number;
    partesFaltantes: number;
    erroresValidacion: string[];
}

// Interfaces y clases para ReiniciarSecuenciaGrupo
export class ReiniciarSecuenciaSimpleDto implements IReiniciarSecuenciaSimpleDto {
    id!: number;
    commodity!: string;
    secuencia!: string;
    programa!: string;
    enAuditoria!: boolean;

    constructor(data?: IReiniciarSecuenciaSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["secuenciaTrabajoId"];
            this.commodity = _data["commodity"];
            this.secuencia = _data["secuencia"];
            this.programa = _data["programa"];
            this.enAuditoria = _data["enAuditoria"];
        }
    }

    static fromJS(data: any): ReiniciarSecuenciaSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReiniciarSecuenciaSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuenciaTrabajoId"] = this.id;
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["programa"] = this.programa;
        data["enAuditoria"] = this.enAuditoria;
        return data;
    }
}

export interface IReiniciarSecuenciaSimpleDto {
    id: number;
    commodity: string;
    secuencia: string;
    programa: string;
    enAuditoria: boolean;
}

export class PagedResultDtoOfReiniciarSecuenciaSimpleDto implements IPagedResultDtoOfReiniciarSecuenciaSimpleDto {
    totalCount!: number;
    items!: ReiniciarSecuenciaSimpleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReiniciarSecuenciaSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReiniciarSecuenciaSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReiniciarSecuenciaSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReiniciarSecuenciaSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReiniciarSecuenciaSimpleDto {
    totalCount: number;
    items: ReiniciarSecuenciaSimpleDto[] | undefined;
}

export interface IReiniciarSecuenciaUpdateResponse {
    success: boolean;
    message: string;
    updatedCount: number;
}

@Injectable()
export class ConsultaDollyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getConsultaDollyList(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        isPaged: boolean | undefined,
        programa: string | undefined,
        dolly: string | undefined,
        caja: string | undefined,
        estatus: string | undefined,
        enAuditoria: boolean | undefined,
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        tractor: string | undefined,
        secuencia: string | undefined
    ): Observable<PagedResultDtoOfConsultaDollyForListResponseDto> {
        let url_ = this.baseUrl + "/api/consulta-dolly/list";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (sorting !== undefined && sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (isPaged !== undefined && isPaged !== null)
            queryParams.push("isPaged=" + encodeURIComponent("" + isPaged));
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        if (dolly !== undefined && dolly !== null)
            queryParams.push("dolly=" + encodeURIComponent("" + dolly));
        if (caja !== undefined && caja !== null)
            queryParams.push("caja=" + encodeURIComponent("" + caja));
        if (estatus !== undefined && estatus !== null)
            queryParams.push("estatus=" + encodeURIComponent("" + estatus));
        if (enAuditoria !== undefined && enAuditoria !== null)
            queryParams.push("enAuditoria=" + encodeURIComponent("" + enAuditoria));
        if (fechaInicio !== undefined && fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (tractor !== undefined && tractor !== null)
            queryParams.push("tractor=" + encodeURIComponent("" + tractor));
        if (secuencia !== undefined && secuencia !== null)
            queryParams.push("secuencia=" + encodeURIComponent("" + secuencia));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultaDollyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultaDollyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfConsultaDollyForListResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfConsultaDollyForListResponseDto>;
        }));
    }

    protected processGetConsultaDollyList(response: HttpResponseBase): Observable<PagedResultDtoOfConsultaDollyForListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfConsultaDollyForListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfConsultaDollyForListResponseDto>(null as any);
    }

    getConsultaDollyDetalle(url: string): Observable<ConsultaDollyDetalleResponseDto[]> {
        let url_ = this.baseUrl + "/api/consulta-dolly/detalle" + url;
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultaDollyDetalle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultaDollyDetalle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDollyDetalleResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDollyDetalleResponseDto[]>;
        }));
    }

    protected processGetConsultaDollyDetalle(response: HttpResponseBase): Observable<ConsultaDollyDetalleResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultaDollyDetalleResponseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDollyDetalleResponseDto[]>(null as any);
    }

    getConsultaDollyBitacora(dollyId: number, embarqueId?: number): Observable<ConsultaDollyBitacoraResponseDto[]> {
        let url_ = this.baseUrl + "/api/consulta-dolly/" + encodeURIComponent("" + dollyId) + "/bitacora";
        if (embarqueId !== null && embarqueId !== undefined)
            url_ += "?embarqueId=" + encodeURIComponent("" + embarqueId);
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultaDollyBitacora(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultaDollyBitacora(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDollyBitacoraResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDollyBitacoraResponseDto[]>;
        }));
    }

    protected processGetConsultaDollyBitacora(response: HttpResponseBase): Observable<ConsultaDollyBitacoraResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultaDollyBitacoraResponseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDollyBitacoraResponseDto[]>(null as any);
    }

    exportConsultaDolly(
        filter: string | undefined,
        programa: string | undefined,
        dolly: string | undefined,
        caja: string | undefined,
        estatus: string | undefined,
        fechaInicio: moment.Moment | undefined,
        fechaFin: moment.Moment | undefined,
        tractor: string | undefined,
        sorting: string | undefined
    ): Observable<Blob> {
        let url_ = this.baseUrl + "/api/consulta-dolly/export";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        if (dolly !== undefined && dolly !== null)
            queryParams.push("dolly=" + encodeURIComponent("" + dolly));
        if (caja !== undefined && caja !== null)
            queryParams.push("caja=" + encodeURIComponent("" + caja));
        if (estatus !== undefined && estatus !== null)
            queryParams.push("estatus=" + encodeURIComponent("" + estatus));
        if (fechaInicio !== undefined && fechaInicio !== null)
            queryParams.push("fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            queryParams.push("fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (tractor !== undefined && tractor !== null)
            queryParams.push("tractor=" + encodeURIComponent("" + tractor));
        if (sorting !== undefined && sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportConsultaDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportConsultaDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportConsultaDolly(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    exportDetalleDolly(dollyId: number, embarqueId?: number | undefined, dolly?: string | undefined, programa?: string | undefined, secuenciaInicial?: string | undefined, secuenciaFinal?: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/consulta-dolly/detalle/export";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        queryParams.push("dollyId=" + encodeURIComponent("" + dollyId));
        if (embarqueId !== undefined && embarqueId !== null)
            queryParams.push("embarqueId=" + encodeURIComponent("" + embarqueId));
        if (dolly !== undefined && dolly !== null)
            queryParams.push("dolly=" + encodeURIComponent("" + dolly));
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        if (secuenciaInicial !== undefined && secuenciaInicial !== null)
            queryParams.push("secuenciaInicial=" + encodeURIComponent("" + secuenciaInicial));
        if (secuenciaFinal !== undefined && secuenciaFinal !== null)
            queryParams.push("secuenciaFinal=" + encodeURIComponent("" + secuenciaFinal));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportDetalleDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDetalleDolly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportDetalleDolly(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

export class PagedResultDtoOfConsultaDollyForListResponseDto implements IPagedResultDtoOfConsultaDollyForListResponseDto {
    totalCount!: number;
    items!: ConsultaDollyForListResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfConsultaDollyForListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsultaDollyForListResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfConsultaDollyForListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfConsultaDollyForListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfConsultaDollyForListResponseDto {
    totalCount: number;
    items: ConsultaDollyForListResponseDto[] | undefined;
}

export class ConsultaDollyForListResponseDto implements IConsultaDollyForListResponseDto {
    dollyId!: number;
    dollyDescr!: string | undefined;
    programa!: string | undefined;
    secuenciaInicial!: string | undefined;
    secuenciaFinal!: string | undefined;
    estatus!: string | undefined;
    usuarioRegistro!: string | undefined;
    fechaInicioEstatus!: moment.Moment | undefined;
    fechaInicioDolly!: moment.Moment | undefined;
    commoditysFaltantes!: string | undefined;
    commoditysPendientesAsignar!: string | undefined;
    commoditysPendientesSecuenciar!: string | undefined;
    caja!: string | undefined;
    tieneFaltantes!: string | undefined;
    enAuditoria!: string | undefined;
    cobertura!: string | undefined;
    chasis!: string | undefined;
    tractor!: string | undefined;
    embarqueId!: number | undefined;
    secuencias!: string[];
    cantidadSecuencias!: number;

    constructor(data?: IConsultaDollyForListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dollyId = _data["dollyId"];
            this.dollyDescr = _data["dollyDescr"];
            this.programa = _data["programa"];
            this.secuenciaInicial = _data["secuenciaInicial"];
            this.secuenciaFinal = _data["secuenciaFinal"];
            this.estatus = _data["estatus"];
            this.usuarioRegistro = _data["usuarioRegistro"];
            this.fechaInicioEstatus = _data["fechaInicioEstatus"] ? moment(_data["fechaInicioEstatus"].toString()) : <any>undefined;
            this.fechaInicioDolly = _data["fechaInicioDolly"] ? moment(_data["fechaInicioDolly"].toString()) : <any>undefined;
            this.commoditysFaltantes = _data["commoditysFaltantes"];
            this.commoditysPendientesAsignar = _data["commoditysPendientesAsignar"];
            this.commoditysPendientesSecuenciar = _data["commoditysPendientesSecuenciar"];
            this.caja = _data["caja"];
            this.tieneFaltantes = _data["tieneFaltantes"];
            this.enAuditoria = _data["enAuditoria"];
            this.cobertura = _data["cobertura"];
            this.chasis = _data["chasis"];
            this.tractor = _data["tractor"];
            this.embarqueId = _data["embarqueId"];
            this.secuencias = _data["secuencias"] ? _data["secuencias"] : [];
            this.cantidadSecuencias = _data["cantidadSecuencias"] || 0;
        }
    }

    static fromJS(data: any): ConsultaDollyForListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultaDollyForListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dollyId"] = this.dollyId;
        data["dollyDescr"] = this.dollyDescr;
        data["programa"] = this.programa;
        data["secuenciaInicial"] = this.secuenciaInicial;
        data["secuenciaFinal"] = this.secuenciaFinal;
        data["estatus"] = this.estatus;
        data["usuarioRegistro"] = this.usuarioRegistro;
        data["fechaInicioEstatus"] = this.fechaInicioEstatus ? this.fechaInicioEstatus.toISOString() : <any>undefined;
        data["fechaInicioDolly"] = this.fechaInicioDolly ? this.fechaInicioDolly.toISOString() : <any>undefined;
        data["commoditysFaltantes"] = this.commoditysFaltantes;
        data["commoditysPendientesAsignar"] = this.commoditysPendientesAsignar;
        data["commoditysPendientesSecuenciar"] = this.commoditysPendientesSecuenciar;
        data["caja"] = this.caja;
        data["tieneFaltantes"] = this.tieneFaltantes;
        data["enAuditoria"] = this.enAuditoria;
        data["cobertura"] = this.cobertura;
        data["chasis"] = this.chasis;
        data["tractor"] = this.tractor;
        data["embarqueId"] = this.embarqueId;
        data["secuencias"] = this.secuencias;
        data["cantidadSecuencias"] = this.cantidadSecuencias;
        return data;
    }
}

export interface IConsultaDollyForListResponseDto {
    dollyId: number;
    dollyDescr: string | undefined;
    programa: string | undefined;
    secuenciaInicial: string | undefined;
    secuenciaFinal: string | undefined;
    estatus: string | undefined;
    usuarioRegistro: string | undefined;
    fechaInicioEstatus: moment.Moment | undefined;
    fechaInicioDolly: moment.Moment | undefined;
    commoditysFaltantes: string | undefined;
    commoditysPendientesAsignar: string | undefined;
    commoditysPendientesSecuenciar: string | undefined;
    caja: string | undefined;
    tieneFaltantes: string | undefined;
    enAuditoria: string | undefined;
    cobertura: string | undefined;
    chasis: string | undefined;
    tractor: string | undefined;
    embarqueId: number | undefined;
    secuencias: string[];
    cantidadSecuencias: number;
}

export class ConsultaDollyDetalleResponseDto implements IConsultaDollyDetalleResponseDto {
    commodity!: string | undefined;
    secuencia!: string | undefined;
    fechaEscaneo!: moment.Moment | undefined;
    noParte!: string | undefined;
    cantidad!: number;
    cantidadEscaneada!: number;
    completo!: string | undefined;
    secuenciaTrabajoId!: number;
    secuenciaTrabajoParteId!: number;

    constructor(data?: IConsultaDollyDetalleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commodity = _data["commodity"];
            this.secuencia = _data["secuencia"];
            this.fechaEscaneo = _data["fechaEscaneo"] ? moment(_data["fechaEscaneo"].toString()) : <any>undefined;
            this.noParte = _data["noParte"];
            this.cantidad = _data["cantidad"];
            this.cantidadEscaneada = _data["cantidadEscaneada"];
            this.completo = _data["completo"];
            this.secuenciaTrabajoId = _data["secuenciaTrabajoId"];
            this.secuenciaTrabajoParteId = _data["secuenciaTrabajoParteId"];
        }
    }

    static fromJS(data: any): ConsultaDollyDetalleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultaDollyDetalleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["fechaEscaneo"] = this.fechaEscaneo ? this.fechaEscaneo.toISOString() : <any>undefined;
        data["noParte"] = this.noParte;
        data["cantidad"] = this.cantidad;
        data["cantidadEscaneada"] = this.cantidadEscaneada;
        data["completo"] = this.completo;
        data["secuenciaTrabajoId"] = this.secuenciaTrabajoId;
        data["secuenciaTrabajoParteId"] = this.secuenciaTrabajoParteId;
        return data;
    }
}

export interface IConsultaDollyDetalleResponseDto {
    commodity: string | undefined;
    secuencia: string | undefined;
    fechaEscaneo: moment.Moment | undefined;
    noParte: string | undefined;
    cantidad: number;
    cantidadEscaneada: number;
    completo: string | undefined;
    secuenciaTrabajoId: number;
    secuenciaTrabajoParteId: number;
}

export class ConsultaDollyBitacoraResponseDto implements IConsultaDollyBitacoraResponseDto {
    estatus!: string | undefined;
    fechaCambioEstatus!: moment.Moment | undefined;
    usuarioCambioEstatus!: string | undefined;
    observaciones!: string | undefined;

    constructor(data?: IConsultaDollyBitacoraResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estatus = _data["estatus"];
            this.fechaCambioEstatus = _data["fechaCambioEstatus"] ? moment(_data["fechaCambioEstatus"].toString()) : <any>undefined;
            this.usuarioCambioEstatus = _data["usuarioCambioEstatus"];
            this.observaciones = _data["observaciones"];
        }
    }

    static fromJS(data: any): ConsultaDollyBitacoraResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultaDollyBitacoraResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estatus"] = this.estatus;
        data["fechaCambioEstatus"] = this.fechaCambioEstatus ? this.fechaCambioEstatus.toISOString() : <any>undefined;
        data["usuarioCambioEstatus"] = this.usuarioCambioEstatus;
        data["observaciones"] = this.observaciones;
        return data;
    }
}

export interface IConsultaDollyBitacoraResponseDto {
    estatus: string | undefined;
    fechaCambioEstatus: moment.Moment | undefined;
    usuarioCambioEstatus: string | undefined;
    observaciones: string | undefined;
}

@Injectable()
export class FolioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getFolioList(
        sorting?: string | undefined,
        filter?: string | undefined,
        pageSize?: number | undefined,
        pageNumber?: number | undefined,
        startDate?: Date | undefined,
        endDate?: Date | undefined
    ): Observable<PagedResultDtoOfFolioDto> {
        let url_ = this.baseUrl + "/api/folios";
        
        // Construir query parameters
        const params: string[] = [];
        if (sorting !== undefined && sorting !== null) params.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null) params.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null) params.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null) params.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (startDate !== undefined && startDate !== null) params.push("startDate=" + encodeURIComponent(startDate.toISOString()));
        if (endDate !== undefined && endDate !== null) params.push("endDate=" + encodeURIComponent(endDate.toISOString()));
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFolioList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolioList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFolioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFolioDto>;
        }));
    }

    protected processGetFolioList(response: HttpResponseBase): Observable<PagedResultDtoOfFolioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfFolioDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFolioDto>(null as any);
    }

    getList(sorting?: string, filter?: string, pageSize?: number, pageNumber?: number, isPaged?: boolean, folio?: string): Observable<PagedResultDtoOfFolioDetalleDto> {
        if (!folio) {
            throw new Error("folio parameter is required");
        }
        
        let url_ = this.baseUrl + "/api/folios/" + encodeURIComponent("" + folio) + "/partes";
        
        // Construir query parameters (excluyendo folio ya que ahora va en la ruta)
        const params: string[] = [];
        if (sorting !== undefined && sorting !== null) params.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null) params.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null) params.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null) params.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (isPaged !== undefined && isPaged !== null) params.push("isPaged=" + encodeURIComponent("" + isPaged));
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFolioDetalleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFolioDetalleDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfFolioDetalleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfFolioDetalleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFolioDetalleDto>(null as any);
    }

    exportPartesFromFolio(folio: string, sorting?: string, filter?: string): Observable<Blob> {
        if (!folio) {
            throw new Error("folio parameter is required");
        }
        
        let url_ = this.baseUrl + "/api/folios/" + encodeURIComponent("" + folio) + "/partes/export";
        
        // Construir query parameters para filtros
        const params: string[] = [];
        if (sorting !== undefined && sorting !== null) params.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null) params.push("filter=" + encodeURIComponent("" + filter));
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPartesFromFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPartesFromFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportPartesFromFolio(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    uploadFolio(base64Content: string, fileName: string, fileType?: string, almacen?: string): Observable<FolioUploadResultDto> {
        let url_ = this.baseUrl + "/api/folios/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            base64: base64Content,
            fileName: fileName,
            fileType: fileType,
            almacen: almacen 
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FolioUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FolioUploadResultDto>;
        }));
    }

    protected processUploadFolio(response: HttpResponseBase): Observable<FolioUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FolioUploadResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FolioUploadResultDto>(null as any);
    }

    getEtiquetas(folio: string): Observable<EtiquetaFolioDto[]> {
        let url_ = this.baseUrl + "/api/folios/" + encodeURIComponent("" + folio) + "/etiquetas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEtiquetas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEtiquetas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EtiquetaFolioDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EtiquetaFolioDto[]>;
        }));
    }

    protected processGetEtiquetas(response: HttpResponseBase): Observable<EtiquetaFolioDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(EtiquetaFolioDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EtiquetaFolioDto[]>(null as any);
    }

    generarReporteConteoCiego(folio: string): Observable<Blob> {
        let url_ = this.baseUrl + "/api/folios/reporte-conteo-ciego";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ folio: folio });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerarReporteConteoCiego(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerarReporteConteoCiego(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processGenerarReporteConteoCiego(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    createFolio(request: CreateFolioRequestDto): Observable<CreateFolioResponseDto> {
        let url_ = this.baseUrl + "/api/folios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFolioResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFolioResponseDto>;
        }));
    }

    protected processCreateFolio(response: HttpResponseBase): Observable<CreateFolioResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateFolioResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFolioResponseDto>(null as any);
    }

    updateFolioAlmacen(request: UpdateFolioAlmacenRequestDto): Observable<UpdateFolioAlmacenResponseDto> {
        let url_ = this.baseUrl + "/api/folios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFolioAlmacen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFolioAlmacen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFolioAlmacenResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFolioAlmacenResponseDto>;
        }));
    }

    protected processUpdateFolioAlmacen(response: HttpResponseBase): Observable<UpdateFolioAlmacenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateFolioAlmacenResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFolioAlmacenResponseDto>(null as any);
    }

    /**
     * Reinicia un folio específico (DELETE /api/folios/reiniciar/{folio})
     */
    reiniciarFolio(folio: string): Observable<any> {
        let url_ = this.baseUrl + "/api/folios/reiniciar/" + encodeURIComponent("" + folio);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReiniciarFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReiniciarFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processReiniciarFolio(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * Obtiene la fecha de la última carga de folio
     */
    getUltimoFolioFecha(): Observable<UltimoFolioFechaDto> {
        let url_ = this.baseUrl + "/api/folios/ultimo-folio-fecha";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUltimoFolioFecha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUltimoFolioFecha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UltimoFolioFechaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UltimoFolioFechaDto>;
        }));
    }

    protected processGetUltimoFolioFecha(response: HttpResponseBase): Observable<UltimoFolioFechaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UltimoFolioFechaDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UltimoFolioFechaDto>(null as any);
    }

    /**
     * Obtiene la fecha de la última carga de plan de descarga
     */
    getUltimoPlanDescargaFecha(): Observable<UltimoFolioFechaDto> {
        let url_ = this.baseUrl + "/api/folios/ultimo-plan-descarga-fecha";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUltimoPlanDescargaFecha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUltimoPlanDescargaFecha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UltimoFolioFechaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UltimoFolioFechaDto>;
        }));
    }

    protected processGetUltimoPlanDescargaFecha(response: HttpResponseBase): Observable<UltimoFolioFechaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UltimoFolioFechaDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UltimoFolioFechaDto>(null as any);
    }

    /**
     * Exporta folios con filtros aplicados
     */
    exportFolio(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/plandescarga/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportFolio(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

export class PagedResultDtoOfFolioDto implements IPagedResultDtoOfFolioDto {
    totalCount!: number;
    items!: FolioDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFolioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FolioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFolioDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfFolioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFolioDto {
    totalCount: number;
    items: FolioDto[] | undefined;
}

export class FolioDto implements IFolioDto {
    id!: number;
    folio!: string | undefined;
    fechaRegistro!: Date | undefined;
    tipo!: string | undefined;
    almacen!: string | undefined;
    nombreCompleto!: string | undefined;
    contado!: boolean;
    prioridad!: string | undefined;
    estado!: string | undefined;
    fechaGeneracion!: Date | undefined;
    eco!: string | undefined;
    proveedor!: string | undefined;
    ubicacionFisica!: string | undefined;

    constructor(data?: IFolioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folio = _data["folio"];
            this.tipo = _data["tipo"];
            this.almacen = _data["almacen"];
            this.contado = _data["contado"];
            this.nombreCompleto = _data["nombreCompleto"];
            this.fechaRegistro = _data["fechaRegistro"] ? new Date(_data["fechaRegistro"].toString()) : <any>undefined;
            this.prioridad = _data["prioridad"];
            this.estado = _data["estado"];
            this.fechaGeneracion = _data["fechaGeneracion"] ? new Date(_data["fechaGeneracion"].toString()) : <any>undefined;
            this.eco = _data["eco"];
            this.proveedor = _data["proveedor"];
            this.ubicacionFisica = _data["ubicacionFisica"];
        }
    }

    static fromJS(data: any): FolioDto {
        data = typeof data === "object" ? data : {};
        let result = new FolioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["folio"] = this.folio;
        data["tipo"] = this.tipo;
        data["almacen"] = this.almacen;
        data["contado"] = this.contado;
        data["nombreCompleto"] = this.nombreCompleto;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["prioridad"] = this.prioridad;
        data["estado"] = this.estado;
        data["fechaGeneracion"] = this.fechaGeneracion ? this.fechaGeneracion.toISOString() : <any>undefined;
        data["eco"] = this.eco;
        data["proveedor"] = this.proveedor;
        data["ubicacionFisica"] = this.ubicacionFisica;
        return data;
    }
}

export interface IFolioDto {
    id: number;
    folio: string | undefined;
    fechaRegistro: Date | undefined;
    tipo: string | undefined;
    almacen: string | undefined;
    nombreCompleto: string | undefined;
    contado: boolean;
    prioridad: string | undefined;
    estado: string | undefined;
    fechaGeneracion: Date | undefined;
    eco: string | undefined;
    proveedor: string | undefined;
    ubicacionFisica: string | undefined;
}

export class FolioUploadResultDto implements IFolioUploadResultDto {
    success!: boolean;
    message!: string | undefined;
    errorDetails!: string | undefined;
    processedRecords!: number;
    headerValidationPassed!: boolean;

    constructor(data?: IFolioUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.errorDetails = _data["errorDetails"];
            this.processedRecords = _data["processedRecords"];
            this.headerValidationPassed = _data["headerValidationPassed"];
        }
    }

    static fromJS(data: any): FolioUploadResultDto {
        data = typeof data === "object" ? data : {};
        let result = new FolioUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["errorDetails"] = this.errorDetails;
        data["processedRecords"] = this.processedRecords;
        data["headerValidationPassed"] = this.headerValidationPassed;
        return data;
    }
}

export interface IFolioUploadResultDto {
    success: boolean;
    message: string | undefined;
    errorDetails: string | undefined;
    processedRecords: number;
    headerValidationPassed: boolean;
}

export class CreateFolioRequestDto implements ICreateFolioRequestDto {
    almacenOrigenId!: number;
    almacenDestinoId!: number;
    tipoFolio!: string;

    constructor(data?: ICreateFolioRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.almacenOrigenId = _data["almacenOrigenId"];
            this.almacenDestinoId = _data["almacenDestinoId"];
            this.tipoFolio = _data["tipoFolio"];
        }
    }

    static fromJS(data: any): CreateFolioRequestDto {
        data = typeof data === "object" ? data : {};
        let result = new CreateFolioRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["almacenOrigenId"] = this.almacenOrigenId;
        data["almacenDestinoId"] = this.almacenDestinoId;
        data["tipoFolio"] = this.tipoFolio;
        return data;
    }
}

export interface ICreateFolioRequestDto {
    almacenOrigenId: number;
    almacenDestinoId: number;
    tipoFolio: string;
}

export class CreateFolioResponseDto implements ICreateFolioResponseDto {
    id!: number;
    folio!: string;
    mensaje!: string;
    exitoso!: boolean;

    constructor(data?: ICreateFolioResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folio = _data["folio"];
            this.mensaje = _data["mensaje"];
            this.exitoso = _data["exitoso"];
        }
    }

    static fromJS(data: any): CreateFolioResponseDto {
        data = typeof data === "object" ? data : {};
        let result = new CreateFolioResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["folio"] = this.folio;
        data["mensaje"] = this.mensaje;
        data["exitoso"] = this.exitoso;
        return data;
    }
}

export interface ICreateFolioResponseDto {
    id: number;
    folio: string;
    mensaje: string;
    exitoso: boolean;
}

export class UpdateFolioAlmacenRequestDto implements IUpdateFolioAlmacenRequestDto {
    folioId!: number;
    almacenId!: number;

    constructor(data?: IUpdateFolioAlmacenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folioId = _data["folioId"];
            this.almacenId = _data["almacenId"];
        }
    }

    static fromJS(data: any): UpdateFolioAlmacenRequestDto {
        data = typeof data === "object" ? data : {};
        let result = new UpdateFolioAlmacenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["folioId"] = this.folioId;
        data["almacenId"] = this.almacenId;
        return data;
    }
}

export interface IUpdateFolioAlmacenRequestDto {
    folioId: number;
    almacenId: number;
}

export class UpdateFolioAlmacenResponseDto implements IUpdateFolioAlmacenResponseDto {
    mensaje!: string;
    exitoso!: boolean;

    constructor(data?: IUpdateFolioAlmacenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensaje = _data["mensaje"];
            this.exitoso = _data["exitoso"];
        }
    }

    static fromJS(data: any): UpdateFolioAlmacenResponseDto {
        data = typeof data === "object" ? data : {};
        let result = new UpdateFolioAlmacenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["mensaje"] = this.mensaje;
        data["exitoso"] = this.exitoso;
        return data;
    }
}

export interface IUpdateFolioAlmacenResponseDto {
    mensaje: string;
    exitoso: boolean;
}

export class UltimoFolioFechaDto implements IUltimoFolioFechaDto {
    fechaRegistro!: Date | undefined;
    folio!: string | undefined;
    success!: boolean;
    message!: string | undefined;

    constructor(data?: IUltimoFolioFechaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaRegistro = _data["fechaRegistro"] ? new Date(_data["fechaRegistro"]) : undefined;
            this.folio = _data["folio"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UltimoFolioFechaDto {
        data = typeof data === "object" ? data : {};
        let result = new UltimoFolioFechaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : undefined;
        data["folio"] = this.folio;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IUltimoFolioFechaDto {
    fechaRegistro: Date | undefined;
    folio: string | undefined;
    success: boolean;
    message: string | undefined;
}

export class FolioDetalleDto implements IFolioDetalleDto {
    id!: number;
    numeroParte!: string | undefined;
    cantidad!: number;
    um!: string | undefined;
    commodityGrupoDescr!: string | undefined;
    commodityGrupoId!: number;
    cantidadContada!: number;
    estadoDiferencia!: string | undefined;
    tarima!: string | undefined;
    almacen!: string | undefined;
    tieneRequerimiento!: boolean;

    constructor(data?: IFolioDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroParte = _data["numeroParte"];
            this.cantidad = _data["cantidad"];
            this.um = _data["unidadMedida"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
            this.commodityGrupoId = _data["commodityGrupoId"];
            this.cantidadContada = _data["cantidadContada"];
            this.estadoDiferencia = _data["estadoDiferencia"];
            this.tarima = _data["tarima"];
            this.almacen = _data["almacen"];
            this.tieneRequerimiento = _data["tieneRequerimiento"];
        }
    }

    static fromJS(data: any): FolioDetalleDto {
        data = typeof data === "object" ? data : {};
        let result = new FolioDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["unidadMedida"] = this.um;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        data["commodityGrupoId"] = this.commodityGrupoId;
        data["cantidadContada"] = this.cantidadContada;
        data["estadoDiferencia"] = this.estadoDiferencia;
        data["tarima"] = this.tarima;
        data["almacen"] = this.almacen;
        data["tieneRequerimiento"] = this.tieneRequerimiento;
        return data;
    }
}

export interface IFolioDetalleDto {
    id: number;
    numeroParte: string | undefined;
    cantidad: number;
    um: string | undefined;
    commodityGrupoDescr: string | undefined;
    commodityGrupoId: number;
    cantidadContada: number;
    estadoDiferencia: string | undefined;
    tarima: string | undefined;
    almacen: string | undefined;
    tieneRequerimiento: boolean;
}

export class PagedResultDtoOfFolioDetalleDto implements IPagedResultDtoOfFolioDetalleDto {
    totalCount!: number;
    items!: FolioDetalleDto[] | undefined;
    tieneConteo!: boolean;

    constructor(data?: IPagedResultDtoOfFolioDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.tieneConteo = _data["tieneConteo"] !== undefined ? _data["tieneConteo"] : false;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FolioDetalleDto.fromJS(item));
            }
            else {
                this.items = <any>undefined;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFolioDetalleDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfFolioDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        data["tieneConteo"] = this.tieneConteo;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFolioDetalleDto {
    totalCount: number;
    items: FolioDetalleDto[] | undefined;
    tieneConteo: boolean;
}

// ====================
// DynamicSelectOptions Service Proxy
// ====================

@Injectable()
export class DynamicSelectOptionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get dynamic select options using REST API
     * @param tableName (required) The table to query
     * @param searchColumn (required) The column to search
     * @param searchFilter (optional) The filter text to apply
     * @param page (optional) Page number for pagination (default: 0)
     * @param pageSize (optional) Number of items per page (default: 10)
     * @return Success
     */
    getOptions(tableName: string, searchColumn: string, searchFilter?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<DynamicSelectOptionsResponse> {
        let url_ = this.baseUrl + "/api/dynamicselect/opciones?";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined and cannot be null.");
        else
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (searchColumn === undefined || searchColumn === null)
            throw new Error("The parameter 'searchColumn' must be defined and cannot be null.");
        else
            url_ += "searchColumn=" + encodeURIComponent("" + searchColumn) + "&";
        if (searchFilter !== undefined && searchFilter !== null)
            url_ += "searchFilter=" + encodeURIComponent("" + searchFilter) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicSelectOptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicSelectOptionsResponse>;
        }));
    }

    protected processGetOptions(response: HttpResponseBase): Observable<DynamicSelectOptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicSelectOptionsResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}
@Injectable()
export class SecuenciaFaltanteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFaltantes(
        sorting?: string | undefined, 
        numeroParte?: string | undefined,
        pageSize?: number | undefined, 
        pageNumber?: number | undefined,
        commodity?: string | undefined,
        secuencia?: string | undefined,
        causaFaltante?: number | undefined,
        fechaInicio?: moment.Moment | undefined,
        fechaFin?: moment.Moment | undefined,
        programa?: number | undefined
    ): Observable<SecuenciaFaltanteResult> {
        let url_ = this.baseUrl + "/api/secuencias/faltantes";
        url_ = url_.replace(/[?&]$/, "");

        // Construir parámetros de consulta
        const params: string[] = [];
        if (sorting !== undefined && sorting !== null && sorting !== "")
            params.push("Sorting=" + encodeURIComponent("" + sorting));
        if (numeroParte !== undefined && numeroParte !== null && numeroParte !== "")
            params.push("numeroParte=" + encodeURIComponent("" + numeroParte));
        if (pageSize !== undefined && pageSize !== null)
            params.push("PageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            params.push("PageNumber=" + encodeURIComponent("" + pageNumber));
        if (commodity !== undefined && commodity !== null && commodity !== "")
            params.push("commodity=" + encodeURIComponent("" + commodity));
        if (secuencia !== undefined && secuencia !== null && secuencia !== "")
            params.push("secuencia=" + encodeURIComponent("" + secuencia));
        if (causaFaltante !== undefined && causaFaltante !== null)
            params.push("causaFaltante=" + encodeURIComponent("" + causaFaltante));
        if (fechaInicio !== undefined && fechaInicio !== null)
            params.push("fechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            params.push("fechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (programa !== undefined && programa !== null)
            params.push("programa=" + encodeURIComponent("" + programa));

        if (params.length > 0)
            url_ += "?" + params.join("&");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecuenciaFaltanteResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecuenciaFaltanteResult>;
        }));
    }
    
    protected processGetFaltantes(response: HttpResponseBase): Observable<SecuenciaFaltanteResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SecuenciaFaltanteResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFaltantes(sorting?: string | undefined, commodity?: string | undefined, secuencia?: string | undefined, numeroParte?: string | undefined, causaFaltante?: number | undefined, fechaInicio?: moment.Moment | undefined, fechaFin?: moment.Moment | undefined, programa?: number | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/secuencias/faltantes/export";
        url_ = url_.replace(/[?&]$/, "");

        const params: string[] = [];
        if (sorting !== undefined && sorting !== null && sorting !== "")
            params.push("Sorting=" + encodeURIComponent("" + sorting));
        if (commodity !== undefined && commodity !== null && commodity !== "")
            params.push("Commodity=" + encodeURIComponent("" + commodity));
        if (secuencia !== undefined && secuencia !== null && secuencia !== "")
            params.push("Secuencia=" + encodeURIComponent("" + secuencia));
        if (numeroParte !== undefined && numeroParte !== null && numeroParte !== "")
            params.push("NumeroParte=" + encodeURIComponent("" + numeroParte));
        if (causaFaltante !== undefined && causaFaltante !== null)
            params.push("CausaFaltante=" + encodeURIComponent("" + causaFaltante));
        if (fechaInicio !== undefined && fechaInicio !== null)
            params.push("FechaInicio=" + encodeURIComponent(fechaInicio ? "" + fechaInicio.toISOString() : ""));
        if (fechaFin !== undefined && fechaFin !== null)
            params.push("FechaFin=" + encodeURIComponent(fechaFin ? "" + fechaFin.toISOString() : ""));
        if (programa !== undefined && programa !== null)
            params.push("Programa=" + encodeURIComponent("" + programa));
        if (params.length > 0)
            url_ += "?" + params.join("&");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportFaltantes(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return _observableOf(responseBlob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    procesarFaltantes(request: {
        faltantes: {faltanteId: number, cantidad: number}[],
        accion: string,
        comentarios: string,
        usuarioSAF: string
    }): Observable<ProcesarFaltantesResponse> {
        let url_ = this.baseUrl + "/api/secuencias/faltantes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProcesarFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcesarFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcesarFaltantesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcesarFaltantesResponse>;
        }));
    }

    protected processProcesarFaltantes(response: HttpResponseBase): Observable<ProcesarFaltantesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProcesarFaltantesResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Faltantes acotados por estatus del dolly, secuencia más alta alcanzada en ese estatus y programa (GrupoInventario).
     * GET /api/secuencias/faltantes/estatus
     */
    getFaltantesPorEstatus(
        estatus: string,
        secuencia: string,
        programa: string,
        sorting?: string | undefined,
        pageSize?: number | undefined,
        pageNumber?: number | undefined
    ): Observable<FaltantesPorEstatusResult> {
        let url_ = this.baseUrl + "/api/secuencias/faltantes/estatus?";
        if (estatus === undefined || estatus === null)
            throw new Error("The parameter 'estatus' must be defined and cannot be null.");
        else
            url_ += "Estatus=" + encodeURIComponent("" + estatus) + "&";
        if (secuencia === undefined || secuencia === null)
            throw new Error("The parameter 'secuencia' must be defined and cannot be null.");
        else
            url_ += "Secuencia=" + encodeURIComponent("" + secuencia) + "&";
        if (programa === undefined || programa === null)
            throw new Error("The parameter 'programa' must be defined and cannot be null.");
        else
            url_ += "Programa=" + encodeURIComponent("" + programa) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFaltantesPorEstatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaltantesPorEstatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaltantesPorEstatusResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaltantesPorEstatusResult>;
        }));
    }

    protected processGetFaltantesPorEstatus(response: HttpResponseBase): Observable<FaltantesPorEstatusResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FaltantesPorEstatusResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPagedResultDtoOfCausaFaltanteItem {
    totalCount: number;
    items: CausaFaltanteItem[] | undefined;
}


export class DynamicSelectOptionsResponse implements IDynamicSelectOptionsResponse {
    totalCount!: number;
    items!: DynamicSelectOptionItem[] | undefined;

    constructor(data?: IDynamicSelectOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicSelectOptionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicSelectOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSelectOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDynamicSelectOptionsResponse {
    totalCount: number;
    items: DynamicSelectOptionItem[] | undefined;
}

export class DynamicSelectOptionItem implements IDynamicSelectOptionItem {
    value!: string;
    display!: string;
    isLastPage!: boolean;

    constructor(data?: IDynamicSelectOptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.display = _data["display"];
            this.isLastPage = _data["isLastPage"] !== undefined ? _data["isLastPage"] : false;
        }
    }

    static fromJS(data: any): DynamicSelectOptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSelectOptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["display"] = this.display;
        data["isLastPage"] = this.isLastPage;
        return data;
    }
}

export interface IDynamicSelectOptionItem {
    value: string;
    display: string;
    isLastPage: boolean;
}

export interface IEtiquetaFolioDto {
    folio: string;
    numeroParte: string;
    tarima: number;
    almacen: string;
    tipo: string;
    cantidadEnTarima: number;
    usuarioName: string;
}

export class EtiquetaFolioDto implements IEtiquetaFolioDto {
    folio!: string;
    numeroParte!: string;
    tarima!: number;
    almacen!: string;
    tipo!: string;
    cantidadEnTarima!: number;
    usuarioName!: string;

    constructor(data?: IEtiquetaFolioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folio = _data["folio"];
            this.numeroParte = _data["numeroParte"];
            this.tarima = _data["tarima"];
            this.almacen = _data["almacen"];
            this.tipo = _data["tipo"];
            this.usuarioName = _data["usuarioNombre"];
            this.cantidadEnTarima = _data["cantidadEnTarima"];
        }
    }

    static fromJS(data: any): EtiquetaFolioDto {
        data = typeof data === "object" ? data : {};
        let result = new EtiquetaFolioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["folio"] = this.folio;
        data["numeroParte"] = this.numeroParte;
        data["tarima"] = this.tarima;
        data["almacen"] = this.almacen;
        data["tipo"] = this.tipo;
        data["usuarioNombre"] = this.usuarioName;
        data["cantidadEnTarima"] = this.cantidadEnTarima;
        return data;
    }
}

// CausaFaltanteItem DTOs para /api/causas/faltantes
export class CausaFaltanteItem implements ICausaFaltanteItem {
    causaFaltanteId!: number;
    commodity!: string;
    secuencia!: string;
    estatus!: string;
    numeroParte!: string;
    fechaRegistro!: moment.Moment;
    usuarioActualizo!: string | undefined;
    fechaActualizo!: moment.Moment | undefined;
    causaFaltanteDescr!: string;
    escaneoSAF!: string | undefined;

    constructor(data?: ICausaFaltanteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.causaFaltanteId = _data["causaFaltanteId"];
            this.commodity = _data["commodity"];
            this.secuencia = _data["secuencia"];
            this.estatus = _data["estatus"];
            this.numeroParte = _data["numeroParte"];
            this.usuarioActualizo = _data["usuarioActualizo"];
            this.fechaActualizo = _data["fechaActualizo"] ? moment(_data["fechaActualizo"].toString()) : <any>undefined;
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.escaneoSAF = _data["escaneoSAF"];
        }
    }

    static fromJS(data: any): CausaFaltanteItem {
        data = typeof data === 'object' ? data : {};
        let result = new CausaFaltanteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causaFaltanteId"] = this.causaFaltanteId;
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["estatus"] = this.estatus;
        data["numeroParte"] = this.numeroParte;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["usuarioActualizo"] = this.usuarioActualizo;
        data["fechaActualizo"] = this.fechaActualizo ? this.fechaActualizo.toISOString() : <any>undefined;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["escaneoSAF"] = this.escaneoSAF;
        return data;
    }
}

export interface ICausaFaltanteItem {
    causaFaltanteId:number;
    commodity: string;
    secuencia: string;
    estatus: string;
    numeroParte: string;
    fechaRegistro: moment.Moment;
    usuarioActualizo: string | undefined;
    fechaActualizo: moment.Moment | undefined;
    causaFaltanteDescr: string;
    escaneoSAF: string | undefined;
}

export class PagedResultDtoOfCausaFaltanteItem implements IPagedResultDtoOfCausaFaltanteItem {
    totalCount!: number;
    items!: CausaFaltanteItem[] | undefined;

    constructor(data?: IPagedResultDtoOfCausaFaltanteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (_data["items"] && _data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CausaFaltanteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCausaFaltanteItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCausaFaltanteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecuenciaFaltanteItem {
    faltanteId:number;
    commodity: string;
    secuencia: string;
    estatus: string;
    numeroParte: string;
    causaFaltanteDescr: string;
    cantidadFaltante: number;
    cantidadEscaneada: number;
    dpu: boolean;
    fecha: moment.Moment | undefined;
}

export interface ISecuenciaFaltanteResult {
    totalCount: number;
    items: SecuenciaFaltanteItem[] | undefined;
}

export class SecuenciaFaltanteItem implements ISecuenciaFaltanteItem {
    faltanteId!: number;
    commodity!: string;
    secuencia!: string;
    estatus!: string;
    numeroParte!: string;
    causaFaltanteDescr!: string;
    cantidadFaltante!: number;
    cantidadEscaneada!: number;
    dpu!: boolean;
    fecha!: moment.Moment | undefined;

    constructor(data?: ISecuenciaFaltanteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faltanteId = _data["faltanteId"];
            this.commodity = _data["commodity"];
            this.secuencia = _data["secuencia"];
            this.estatus = _data["estatus"];
            this.numeroParte = _data["numeroParte"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.cantidadFaltante = _data["cantidadFaltante"];
            this.cantidadEscaneada = _data["cantidadEscaneada"];
            this.dpu = _data["dpu"];
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuenciaFaltanteItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciaFaltanteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faltanteId"] = this.faltanteId;
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["estatus"] = this.estatus;
        data["numeroParte"] = this.numeroParte;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["cantidadFaltante"] = this.cantidadFaltante;
        data["cantidadEscaneada"] = this.cantidadEscaneada;
        data["dpu"] = this.dpu;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        return data;
    }
}

export class SecuenciaFaltanteResult implements ISecuenciaFaltanteResult {
    totalCount!: number;
    items!: SecuenciaFaltanteItem[] | undefined;

    constructor(data?: ISecuenciaFaltanteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (_data["items"] && _data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SecuenciaFaltanteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecuenciaFaltanteResult {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciaFaltanteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFaltantePorEstatusItem {
    faltanteId: number;
    programa: string;
    commodity: string;
    secuencia: string;
    estatus: string;
    numeroParte: string;
    causaFaltanteDescr: string;
    cantidadFaltante: number;
    dpu: boolean;
    fecha: moment.Moment | undefined;
}

export interface IFaltantesPorEstatusResult {
    totalCount: number;
    items: FaltantePorEstatusItem[] | undefined;
}

export class FaltantePorEstatusItem implements IFaltantePorEstatusItem {
    faltanteId!: number;
    programa!: string;
    commodity!: string;
    secuencia!: string;
    estatus!: string;
    numeroParte!: string;
    causaFaltanteDescr!: string;
    cantidadFaltante!: number;
    dpu!: boolean;
    fecha!: moment.Moment | undefined;

    constructor(data?: IFaltantePorEstatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faltanteId = _data["faltanteId"];
            this.programa = _data["programa"];
            this.commodity = _data["commodity"];
            this.secuencia = _data["secuencia"];
            this.estatus = _data["estatus"];
            this.numeroParte = _data["numeroParte"];
            this.causaFaltanteDescr = _data["causaFaltanteDescr"];
            this.cantidadFaltante = _data["cantidadFaltante"];
            this.dpu = _data["dpu"];
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FaltantePorEstatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new FaltantePorEstatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faltanteId"] = this.faltanteId;
        data["programa"] = this.programa;
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["estatus"] = this.estatus;
        data["numeroParte"] = this.numeroParte;
        data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        data["cantidadFaltante"] = this.cantidadFaltante;
        data["dpu"] = this.dpu;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        return data;
    }
}

export class FaltantesPorEstatusResult implements IFaltantesPorEstatusResult {
    totalCount!: number;
    items!: FaltantePorEstatusItem[] | undefined;

    constructor(data?: IFaltantesPorEstatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (_data["items"] && _data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FaltantePorEstatusItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FaltantesPorEstatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new FaltantesPorEstatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcesarFaltantesResponse {
    success: boolean;
    message: string;
    faltantesRecuperados: number;
    faltantesNoEncontrados: number;
}

export class ProcesarFaltantesResponse implements IProcesarFaltantesResponse {
    success!: boolean;
    message!: string;
    faltantesRecuperados!: number;
    faltantesNoEncontrados!: number;

    constructor(data?: IProcesarFaltantesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.faltantesRecuperados = _data["faltantesRecuperados"];
            this.faltantesNoEncontrados = _data["faltantesNoEncontrados"];
        }
    }

    static fromJS(data: any): ProcesarFaltantesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcesarFaltantesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["faltantesRecuperados"] = this.faltantesRecuperados;
        data["faltantesNoEncontrados"] = this.faltantesNoEncontrados;
        return data;
    }
}

export class BitacoraDetalladoResponse implements IBitacoraDetalladoResponse {
    ranges: BitacoraRangeDto[] | undefined;

    constructor(data?: IBitacoraDetalladoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ranges"] && data["ranges"].constructor === Array) {
                this.ranges = [] as any;
                for (let item of data["ranges"])
                    this.ranges.push(BitacoraRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BitacoraDetalladoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BitacoraDetalladoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ranges && this.ranges.constructor === Array) {
            data["ranges"] = [];
            for (let item of this.ranges)
                data["ranges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBitacoraDetalladoResponse {
    ranges: BitacoraRangeDto[] | undefined;
}

export class BitacoraRangeDto implements IBitacoraRangeDto {
    rangoFecha: string | undefined;
    fechaInicio: moment.Moment | undefined;
    secMinima: string | undefined;
    secMaxima: string | undefined;

    constructor(data?: IBitacoraRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rangoFecha = data["rangoFecha"];
            this.fechaInicio = data["fechaInicio"] ? moment(data["fechaInicio"].toString()) : <any>undefined;
            this.secMinima = data["secMinima"];
            this.secMaxima = data["secMaxima"];
        }
    }

    static fromJS(data: any): BitacoraRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BitacoraRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangoFecha"] = this.rangoFecha;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["secMinima"] = this.secMinima;
        data["secMaxima"] = this.secMaxima;
        return data;
    }
}

export interface IBitacoraRangeDto {
    rangoFecha: string | undefined;
    fechaInicio: moment.Moment | undefined;
    secMinima: string | undefined;
    secMaxima: string | undefined;
}

export class FramesFilteredResponse implements IFramesFilteredResponse {
    totalCount: number | undefined;
    items: FrameItemDto[] | undefined;

    constructor(data?: IFramesFilteredResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FrameItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FramesFilteredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FramesFilteredResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFramesFilteredResponse {
    totalCount: number | undefined;
    items: FrameItemDto[] | undefined;
}

export class FrameItemDto implements IFrameItemDto {
    fecha: moment.Moment | undefined;
    chassis: string | undefined;
    secuencia: string | undefined;
    commodityCode: string | undefined;
    descripcion: string | undefined;
    faldonDescr: string | undefined;
    esReimpresion: boolean | undefined;
    esFantasma: boolean | undefined;

    constructor(data?: IFrameItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fecha = data["fecha"] ? moment(data["fecha"].toString()) : <any>undefined;
            this.chassis = data["chassis"];
            this.secuencia = data["secuencia"];
            this.commodityCode = data["commodityCode"];
            this.descripcion = data["descripcion"];
            this.faldonDescr = data["faldonDescr"];
            this.esReimpresion = data["esReimpresion"];
            this.esFantasma = data["esFantasma"];
        }
    }

    static fromJS(data: any): FrameItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrameItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["chassis"] = this.chassis;
        data["secuencia"] = this.secuencia;
        data["commodityCode"] = this.commodityCode;
        data["descripcion"] = this.descripcion;
        data["faldonDescr"] = this.faldonDescr;
        data["esReimpresion"] = this.esReimpresion;
        data["esFantasma"] = this.esFantasma;
        return data;
    }
}

export interface IFrameItemDto {
    fecha: moment.Moment | undefined;
    chassis: string | undefined;
    secuencia: string | undefined;
    commodityCode: string | undefined;
    descripcion: string | undefined;
    faldonDescr: string | undefined;
    esReimpresion: boolean | undefined;
    esFantasma: boolean | undefined;
}

export class ProgramasSecuenciadosRequest implements IProgramasSecuenciadosRequest {
    fechaInicio: moment.Moment | undefined;
    fechaFin: moment.Moment | undefined;
    chasis: string | undefined;
    codigoCommodity: string | undefined;
    secuenciaDesde: string | undefined;
    secuenciaHasta: string | undefined;
    descripcion: string | undefined;
    noEscaneados: boolean;
    fechaUltimoSecuenciado: moment.Moment | undefined;
    ultimaSecuenciaCargada: string | undefined;
    pagina: number;
    tamanoPagina: number;
    campoOrden: string | undefined;
    direccionOrden: string | undefined;

    constructor(data?: IProgramasSecuenciadosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fechaInicio = data["fechaInicio"] ? moment(data["fechaInicio"].toString()) : <any>undefined;
            this.fechaFin = data["fechaFin"] ? moment(data["fechaFin"].toString()) : <any>undefined;
            this.chasis = data["chasis"];
            this.codigoCommodity = data["codigoCommodity"];
            this.secuenciaDesde = data["secuenciaDesde"];
            this.secuenciaHasta = data["secuenciaHasta"];
            this.descripcion = data["descripcion"];
            this.noEscaneados = data["noEscaneados"];
            this.fechaUltimoSecuenciado = data["fechaUltimoSecuenciado"] ? moment(data["fechaUltimoSecuenciado"].toString()) : <any>undefined;
            this.ultimaSecuenciaCargada = data["ultimaSecuenciaCargada"];
            this.pagina = data["pagina"];
            this.tamanoPagina = data["tamanoPagina"];
            this.campoOrden = data["campoOrden"];
            this.direccionOrden = data["direccionOrden"];
        }
    }

    static fromJS(data: any): ProgramasSecuenciadosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramasSecuenciadosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : null;
        data["fechaFin"] = this.fechaFin ? this.fechaFin.toISOString() : null;
        data["chasis"] = this.chasis || "";
        data["codigoCommodity"] = this.codigoCommodity || "";
        data["secuenciaDesde"] = this.secuenciaDesde || "";
        data["secuenciaHasta"] = this.secuenciaHasta || "";
        data["descripcion"] = this.descripcion || "";
        data["noEscaneados"] = this.noEscaneados || false;
        data["fechaUltimoSecuenciado"] = this.fechaUltimoSecuenciado ? this.fechaUltimoSecuenciado.format('YYYY-MM-DD') : null;
        data["ultimaSecuenciaCargada"] = this.ultimaSecuenciaCargada || "";
        data["pagina"] = this.pagina || 0;
        data["tamanoPagina"] = this.tamanoPagina || 100;
        data["campoOrden"] = this.campoOrden || "";
        data["direccionOrden"] = this.direccionOrden || "";
        return data;
    }
}

export interface IProgramasSecuenciadosRequest {
    fechaInicio: moment.Moment | undefined;
    fechaFin: moment.Moment | undefined;
    chasis: string | undefined;
    codigoCommodity: string | undefined;
    secuenciaDesde: string | undefined;
    secuenciaHasta: string | undefined;
    descripcion: string | undefined;
    noEscaneados: boolean;
    fechaUltimoSecuenciado: moment.Moment | undefined;
    ultimaSecuenciaCargada: string | undefined;
    pagina: number;
    tamanoPagina: number;
    campoOrden: string | undefined;
    direccionOrden: string | undefined;
}

export class ProgramasSecuenciadosResponse implements IProgramasSecuenciadosResponse {
    commodities: ProgramaCommodityDto[] | undefined;
    totalRegistros: number;
    totalPaginas: number;
    paginaActual: number;
    tamanoPagina: number;
    totalCommodities: number;
    commoditiesActivos: number;
    commoditiesCompletos: number;
    commoditiesNoIniciados: number;
    commoditiesEnProceso: number;

    constructor(data?: IProgramasSecuenciadosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["commodities"] && data["commodities"].constructor === Array) {
                this.commodities = [] as any;
                for (let item of data["commodities"])
                    this.commodities.push(ProgramaCommodityDto.fromJS(item));
            }
            this.totalRegistros = data["totalRegistros"];
            this.totalPaginas = data["totalPaginas"];
            this.paginaActual = data["paginaActual"];
            this.tamanoPagina = data["tamanoPagina"];
            this.totalCommodities = data["totalCommodities"];
            this.commoditiesActivos = data["commoditiesActivos"];
            this.commoditiesCompletos = data["commoditiesCompletos"];
            this.commoditiesNoIniciados = data["commoditiesNoIniciados"];
            this.commoditiesEnProceso = data["commoditiesEnProceso"];
        }
    }

    static fromJS(data: any): ProgramasSecuenciadosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramasSecuenciadosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.commodities && this.commodities.constructor === Array) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        data["totalRegistros"] = this.totalRegistros;
        data["totalPaginas"] = this.totalPaginas;
        data["paginaActual"] = this.paginaActual;
        data["tamanoPagina"] = this.tamanoPagina;
        data["totalCommodities"] = this.totalCommodities;
        data["commoditiesActivos"] = this.commoditiesActivos;
        data["commoditiesCompletos"] = this.commoditiesCompletos;
        data["commoditiesNoIniciados"] = this.commoditiesNoIniciados;
        data["commoditiesEnProceso"] = this.commoditiesEnProceso;
        return data;
    }
}

export interface IProgramasSecuenciadosResponse {
    commodities: ProgramaCommodityDto[] | undefined;
    totalRegistros: number;
    totalPaginas: number;
    paginaActual: number;
    tamanoPagina: number;
    totalCommodities: number;
    commoditiesActivos: number;
    commoditiesCompletos: number;
    commoditiesNoIniciados: number;
    commoditiesEnProceso: number;
}

export class ProgramaCommodityDto implements IProgramaCommodityDto {
    commodityCode: string | undefined;
    descripcionCommodity: string | undefined;
    ultimaSecuenciaCargada: string | undefined;
    fecha: moment.Moment | undefined;
    ultimaSecuenciaEscaneada: string | undefined;
    fechaUltimoEscaneo: moment.Moment | undefined;
    secuenciasDisponiblesParaEscanear: number;
    dollysAProducirConSecuenciasDisponibles: number;
    estatus: string | undefined;

    constructor(data?: IProgramaCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityCode = data["commodityCode"];
            this.descripcionCommodity = data["descripcionCommodity"];
            this.ultimaSecuenciaCargada = data["ultimaSecuenciaCargada"];
            this.fecha = data["fecha"] ? moment(data["fecha"].toString()) : <any>undefined;
            this.ultimaSecuenciaEscaneada = data["ultimaSecuenciaEscaneada"];
            this.fechaUltimoEscaneo = data["fechaUltimoEscaneo"] ? moment(data["fechaUltimoEscaneo"].toString()) : <any>undefined;
            this.secuenciasDisponiblesParaEscanear = data["secuenciasDisponiblesParaEscanear"];
            this.dollysAProducirConSecuenciasDisponibles = data["dollysAProducirConSecuenciasDisponibles"];
            this.estatus = data["estatus"];
        }
    }

    static fromJS(data: any): ProgramaCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramaCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityCode"] = this.commodityCode;
        data["descripcionCommodity"] = this.descripcionCommodity;
        data["ultimaSecuenciaCargada"] = this.ultimaSecuenciaCargada;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["ultimaSecuenciaEscaneada"] = this.ultimaSecuenciaEscaneada;
        data["fechaUltimoEscaneo"] = this.fechaUltimoEscaneo ? this.fechaUltimoEscaneo.toISOString() : <any>undefined;
        data["secuenciasDisponiblesParaEscanear"] = this.secuenciasDisponiblesParaEscanear;
        data["dollysAProducirConSecuenciasDisponibles"] = this.dollysAProducirConSecuenciasDisponibles;
        data["estatus"] = this.estatus;
        return data;
    }
}

export interface IProgramaCommodityDto {
    commodityCode: string | undefined;
    descripcionCommodity: string | undefined;
    ultimaSecuenciaCargada: string | undefined;
    fecha: moment.Moment | undefined;
    ultimaSecuenciaEscaneada: string | undefined;
    fechaUltimoEscaneo: moment.Moment | undefined;
    secuenciasDisponiblesParaEscanear: number;
    dollysAProducirConSecuenciasDisponibles: number;
    estatus: string | undefined;
}

@Injectable()
export class ProgramasDetalleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * Obtiene los detalles de un programa por commodity con filtros
     * @param commodity El ID del commodity
     * @param fechaInicio Fecha de inicio del filtro (opcional)
     * @param fechaFin Fecha fin del filtro (opcional)
     * @param secuencia Filtro por secuencia (opcional)
     * @param noParte Filtro por número de parte (opcional)
     * @param descripcionNoParte Filtro por descripción de parte (opcional)
     * @param estatus Filtro por estatus (opcional)
     * @param causaFaltante Filtro por causa faltante (opcional)
     * @returns Observable con la lista de secuencias y sus partes
     */
    obtenerDetallesPorCommodity(
        commodity: string,
        fechaInicio?: Date | null,
        fechaFin?: Date | null,
        secuencia?: string | null,
        noParte?: string | null,
        descripcionNoParte?: string | null,
        estatus?: string | null,
        causaFaltante?: string | null
    ): Observable<SecuenciaDetalleDto[]> {
        let url_ = this.baseUrl + "/api/programas/detalles?commodity=" + encodeURIComponent("" + commodity);
        
        // Agregar parámetros opcionales si están presentes
        if (fechaInicio !== undefined && fechaInicio !== null) {
            url_ += "&fechaInicio=" + encodeURIComponent(fechaInicio.toISOString());
        }
        if (fechaFin !== undefined && fechaFin !== null) {
            url_ += "&fechaFin=" + encodeURIComponent(fechaFin.toISOString());
        }
        if (secuencia !== undefined && secuencia !== null && secuencia !== '') {
            url_ += "&secuencia=" + encodeURIComponent("" + secuencia);
        }
        if (noParte !== undefined && noParte !== null && noParte !== '') {
            url_ += "&noParte=" + encodeURIComponent("" + noParte);
        }
        if (descripcionNoParte !== undefined && descripcionNoParte !== null && descripcionNoParte !== '') {
            url_ += "&descripcionNoParte=" + encodeURIComponent("" + descripcionNoParte);
        }
        if (estatus !== undefined && estatus !== null && estatus !== '') {
            url_ += "&estatus=" + encodeURIComponent("" + estatus);
        }
        if (causaFaltante !== undefined && causaFaltante !== null && causaFaltante !== '') {
            url_ += "&causaFaltante=" + encodeURIComponent("" + causaFaltante);
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processObtenerDetallesPorCommodity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenerDetallesPorCommodity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecuenciaDetalleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecuenciaDetalleDto[]>;
        }));
    }

    protected processObtenerDetallesPorCommodity(response: HttpResponseBase): Observable<SecuenciaDetalleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SecuenciaDetalleDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecuenciaDetalleDto[]>(null as any);
    }

    /**
     * Marca partes como faltantes
     * @param faltantesData Los datos de partes faltantes a marcar
     * @returns Observable con la respuesta del servidor
     */
    marcarPartesComoFaltantes(faltantesData: MarcarFaltantesDto): Observable<void> {
        let url_ = this.baseUrl + "/api/programas/secuenciados/faltantes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(faltantesData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarcarPartesComoFaltantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarcarPartesComoFaltantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarcarPartesComoFaltantes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Reinicia secuencias de trabajo
     * @param reiniciarData Los datos para reiniciar secuencias
     * @returns Observable con la respuesta del servidor
     */
    reiniciarSecuencias(reiniciarData: ReiniciarSecuenciasDto): Observable<void> {
        let url_ = this.baseUrl + "/api/programas/secuencias/reiniciar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reiniciarData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReiniciarSecuencias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReiniciarSecuencias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReiniciarSecuencias(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Elimina una secuencia específica
     * @param commodity El commodity de la secuencia
     * @param secuencia La secuencia a eliminar
     * @returns Observable con la respuesta del servidor
     */
    eliminarSecuencia(commodity: string, secuencia: string): Observable<void> {
        let url_ = this.baseUrl + "/api/programas/secuencias?commodity=" + encodeURIComponent("" + commodity) + "&secuencia=" + encodeURIComponent("" + secuencia);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEliminarSecuencia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEliminarSecuencia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEliminarSecuencia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Cierra secuencias de trabajo
     * @param cierreData Los datos para cerrar secuencias
     * @returns Observable con la respuesta del servidor
     */
    cerrarSecuencias(cierreData: CerrarSecuenciasDto): Observable<void> {
        let url_ = this.baseUrl + "/api/programas/secuencias/cierre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cierreData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCerrarSecuencias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCerrarSecuencias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCerrarSecuencias(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Activa o desactiva una secuencia
     * @param activarDesactivarData Los datos para activar/desactivar la secuencia
     * @returns Observable con la respuesta del servidor
     */
    activarDesactivarSecuencia(activarDesactivarData: any): Observable<void> {
        let url_ = this.baseUrl + "/api/programas/secuencias/activar-desactivar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activarDesactivarData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActivarDesactivarSecuencia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivarDesactivarSecuencia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivarDesactivarSecuencia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class SecuenciaDetalleDto implements ISecuenciaDetalleDto {
    secuencia!: string;
    chasis!: string;
    inicioEscaneo!: string;
    finEscaneo!: string | undefined;
    estatus!: string;
    nombreUsuarioEscaneo!: string;
    secuenciaTrabajoId!: number;
    pausado!: boolean; // Nueva propiedad para controlar pausa/activación
    ppFrames!: boolean; // Nueva propiedad para PP Frames
    partes!: ParteDetalleDto[];

    constructor(data?: ISecuenciaDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuencia = data["secuencia"];
            this.chasis = data["chasis"];
            this.inicioEscaneo = data["inicioEscaneo"];
            this.finEscaneo = data["finEscaneo"];
            this.estatus = data["estatus"];
            this.nombreUsuarioEscaneo = data["nombreUsuarioEscaneo"];
            this.secuenciaTrabajoId = data["secuenciaTrabajoId"];
            this.pausado = data["pausado"] !== undefined ? data["pausado"] : false;
            this.ppFrames = data["ppFrames"] !== undefined ? data["ppFrames"] : false;
            if (Array.isArray(data["partes"])) {
                this.partes = [] as any;
                for (let item of data["partes"])
                    this.partes!.push(ParteDetalleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecuenciaDetalleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciaDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuencia"] = this.secuencia;
        data["chasis"] = this.chasis;
        data["inicioEscaneo"] = this.inicioEscaneo;
        data["finEscaneo"] = this.finEscaneo;
        data["estatus"] = this.estatus;
        data["nombreUsuarioEscaneo"] = this.nombreUsuarioEscaneo;
        data["secuenciaTrabajoId"] = this.secuenciaTrabajoId;
        data["pausado"] = this.pausado;
        data["ppFrames"] = this.ppFrames;
        if (Array.isArray(this.partes)) {
            data["partes"] = [];
            for (let item of this.partes)
                data["partes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecuenciaDetalleDto {
    secuencia: string;
    chasis: string;
    inicioEscaneo: string;
    finEscaneo: string | undefined;
    estatus: string;
    nombreUsuarioEscaneo: string;
    secuenciaTrabajoId: number;
    pausado: boolean; // Nueva propiedad para controlar pausa/activación
    ppFrames: boolean; // Nueva propiedad para PP Frames
    partes: ParteDetalleDto[];
}

export class ParteDetalleDto implements IParteDetalleDto {
    noParte!: string;
    noParteDescr!: string;
    cantidad!: number;
    cantidadEscaneada!: number;
    causaFaltante!: string;

    constructor(data?: IParteDetalleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noParte = data["noParte"];
            this.noParteDescr = data["noParteDescr"];
            this.cantidad = data["cantidad"];
            this.cantidadEscaneada = data["cantidadEscaneada"];
            this.causaFaltante = data["causaFaltante"];
        }
    }

    static fromJS(data: any): ParteDetalleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParteDetalleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noParte"] = this.noParte;
        data["noParteDescr"] = this.noParteDescr;
        data["cantidad"] = this.cantidad;
        data["cantidadEscaneada"] = this.cantidadEscaneada;
        data["causaFaltante"] = this.causaFaltante;
        return data;
    }
}

export interface IParteDetalleDto {
    noParte: string;
    noParteDescr: string;
    cantidad: number;
    cantidadEscaneada: number;
    causaFaltante: string;
}

// ===== DTOs para marcar faltantes =====

export class MarcarFaltantesDto implements IMarcarFaltantesDto {
    faltantes!: FaltanteSecuenciaDto[];

    constructor(data?: IMarcarFaltantesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["faltantes"])) {
                this.faltantes = [] as any;
                for (let item of data["faltantes"])
                    this.faltantes!.push(FaltanteSecuenciaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarcarFaltantesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarcarFaltantesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.faltantes)) {
            data["faltantes"] = [];
            for (let item of this.faltantes)
                data["faltantes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarcarFaltantesDto {
    faltantes: FaltanteSecuenciaDto[];
}

export class FaltanteSecuenciaDto implements IFaltanteSecuenciaDto {
    secuenciaTrabajoId!: number;
    partes!: FaltanteParteDto[];
    /** Bandera que indica si la secuencia está en estado "No Iniciado" */
    esNoIniciado?: boolean;

    constructor(data?: IFaltanteSecuenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuenciaTrabajoId = data["secuenciaTrabajoId"];
            this.esNoIniciado = data["esNoIniciado"];
            if (Array.isArray(data["partes"])) {
                this.partes = [] as any;
                for (let item of data["partes"])
                    this.partes!.push(FaltanteParteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FaltanteSecuenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaltanteSecuenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuenciaTrabajoId"] = this.secuenciaTrabajoId;
        data["esNoIniciado"] = this.esNoIniciado;
        if (Array.isArray(this.partes)) {
            data["partes"] = [];
            for (let item of this.partes)
                data["partes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFaltanteSecuenciaDto {
    secuenciaTrabajoId: number;
    partes: FaltanteParteDto[];
    /** Bandera que indica si la secuencia está en estado "No Iniciado" */
    esNoIniciado?: boolean;
}

export class FaltanteParteDto implements IFaltanteParteDto {
    numeroParte!: string;
    cantidadFaltante!: number;

    constructor(data?: IFaltanteParteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.numeroParte = data["numeroParte"];
            this.cantidadFaltante = data["cantidadFaltante"];
        }
    }

    static fromJS(data: any): FaltanteParteDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaltanteParteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroParte"] = this.numeroParte;
        data["cantidadFaltante"] = this.cantidadFaltante;
        return data;
    }
}

export interface IFaltanteParteDto {
    numeroParte: string;
    cantidadFaltante: number;
}

// ===== DTOs para reiniciar secuencias =====

export class ReiniciarSecuenciasDto implements IReiniciarSecuenciasDto {
    secuenciaTrabajoId?: number;
    secuenciaTrabajoIds?: number[];
    esWeb?: boolean;

    constructor(data?: IReiniciarSecuenciasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuenciaTrabajoId = data["secuenciaTrabajoId"];
            if (Array.isArray(data["secuenciaTrabajoIds"])) {
                this.secuenciaTrabajoIds = [] as any;
                for (let item of data["secuenciaTrabajoIds"])
                    this.secuenciaTrabajoIds!.push(item);
            }
            this.esWeb = data["esWeb"];
        }
    }

    static fromJS(data: any): ReiniciarSecuenciasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReiniciarSecuenciasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.secuenciaTrabajoId !== undefined)
            data["secuenciaTrabajoId"] = this.secuenciaTrabajoId;
        if (Array.isArray(this.secuenciaTrabajoIds)) {
            data["secuenciaTrabajoIds"] = [];
            for (let item of this.secuenciaTrabajoIds)
                data["secuenciaTrabajoIds"].push(item);
        }
        if (this.esWeb !== undefined)
            data["esWeb"] = this.esWeb;
        return data;
    }
}

export interface IReiniciarSecuenciasDto {
    secuenciaTrabajoId?: number;
    secuenciaTrabajoIds?: number[];
    esWeb?: boolean;
}

// ===== DTOs para cerrar secuencias =====

export class CerrarSecuenciasDto implements ICerrarSecuenciasDto {
    secuencias!: CierreSecuenciaDto[];

    constructor(data?: ICerrarSecuenciasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["secuencias"])) {
                this.secuencias = [] as any;
                for (let item of data["secuencias"])
                    this.secuencias!.push(CierreSecuenciaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CerrarSecuenciasDto {
        data = typeof data === 'object' ? data : {};
        let result = new CerrarSecuenciasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secuencias)) {
            data["secuencias"] = [];
            for (let item of this.secuencias)
                data["secuencias"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICerrarSecuenciasDto {
    secuencias: CierreSecuenciaDto[];
}

export class CierreSecuenciaDto implements ICierreSecuenciaDto {
    secuenciaTrabajoId: number | undefined;
    secuencia!: string;
    commodity!: string;
    partes!: CierreParteDto[];
    codigoDolly!: string;

    constructor(data?: ICierreSecuenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuenciaTrabajoId = data["secuenciaTrabajoId"];
            this.secuencia = data["secuencia"];
            this.commodity = data["commodity"];
            this.codigoDolly = data["codigoDolly"];
            if (Array.isArray(data["partes"])) {
                this.partes = [] as any;
                for (let item of data["partes"])
                    this.partes!.push(CierreParteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CierreSecuenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CierreSecuenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuenciaTrabajoId"] = this.secuenciaTrabajoId;
        data["secuencia"] = this.secuencia;
        data["commodity"] = this.commodity;
        data["codigoDolly"] = this.codigoDolly;
        if (Array.isArray(this.partes)) {
            data["partes"] = [];
            for (let item of this.partes)
                data["partes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICierreSecuenciaDto {
    secuenciaTrabajoId: number | undefined;
    secuencia: string;
    commodity: string;
    partes: CierreParteDto[];
    codigoDolly: string;
}

export class CierreParteDto implements ICierreParteDto {
    noParte!: string;
    cantidad!: number;

    constructor(data?: ICierreParteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noParte = data["noParte"];
            this.cantidad = data["cantidad"];
        }
    }

    static fromJS(data: any): CierreParteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CierreParteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noParte"] = this.noParte;
        data["cantidad"] = this.cantidad;
        return data;
    }
}

export interface ICierreParteDto {
    noParte: string;
    cantidad: number;
}

@Injectable()
export class CierreDollyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * Obtiene la lista de dollies para el cierre
     */
    getCierreDollyList(
        sorting: string | undefined,
        filter: string | undefined,
        pageSize: number | undefined,
        pageNumber: number | undefined,
        programa: string | undefined,
        secuencia: string | undefined,
        dolly: string | undefined,
        filterText: string | undefined
    ): Observable<PagedResultDtoOfCierreDollyDto> {
        let url_ = this.baseUrl + "/api/dolly/cierre-dolly";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (sorting !== undefined && sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        if (secuencia !== undefined && secuencia !== null)
            queryParams.push("secuencia=" + encodeURIComponent("" + secuencia));
        if (dolly !== undefined && dolly !== null)
            queryParams.push("dolly=" + encodeURIComponent("" + dolly));
        if (filterText !== undefined && filterText !== null)
            queryParams.push("filterText=" + encodeURIComponent("" + filterText));

        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCierreDollyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCierreDollyList(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processGetCierreDollyList(response: HttpResponseBase): Observable<PagedResultDtoOfCierreDollyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfCierreDollyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCierreDollyDto>(null as any);
    }

    /**
     * Cierra los dollies seleccionados
     */
    cerrarDollies(command: CerrarDolliesCommand): Observable<CierreDollyResultDto> {
        let url_ = this.baseUrl + "/api/dolly/cerrar-dollies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCerrarDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCerrarDollies(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    /**
     * Asigna un Dolly a secuencias ya secuenciadas sin dolly
     */
    asignarDolly(command: CerrarDolliesCommand): Observable<CierreDollyResultDto> {
        let url_ = this.baseUrl + "/api/dollys/asignacion-dolly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAsignarDolly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsignarDolly(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processAsignarDolly(response: HttpResponseBase): Observable<CierreDollyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CierreDollyResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CierreDollyResultDto>(null as any);
    }

    /**
     * Valida la densidad del rango a asignar.
     * Retorna: 0 = supera densidad (error),
     *          1 = igual a densidad (precierre automático),
     *          2 = menor a densidad y hay más disponibles (precierre manual),
     *          3 = menor a densidad pero no hay más disponibles (sin precierre)
     */
    validarDensidad(programa: string, secuenciaInicial: string, secuenciaFinal: string): Observable<number> {
        let url_ = this.baseUrl + "/api/dollys/validar-densidad";
        url_ = url_.replace(/[?&]$/, "");

        url_ += "?programa=" + encodeURIComponent("" + programa);
        url_ += "&secuenciaInicial=" + encodeURIComponent("" + secuenciaInicial);
        url_ += "&secuenciaFinal=" + encodeURIComponent("" + secuenciaFinal);

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidarDensidad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarDensidad(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processValidarDensidad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                const result = _responseText === "" ? 0 : parseInt(_responseText, 10);
                return _observableOf(result);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(0);
    }

    protected processCerrarDollies(response: HttpResponseBase): Observable<CierreDollyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CierreDollyResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CierreDollyResultDto>(null as any);
    }

    /**
     * Obtiene las secuencias disponibles para dollys
     */
    getSequences(programa?: string | undefined, secuencia?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, esAsignacion?: boolean | undefined): Observable<PagedResultDtoOfDollySequenceDto> {
        let url_ = this.baseUrl + "/api/dollys/sequences";
        url_ = url_.replace(/[?&]$/, "");

        let queryParams: string[] = [];
        if (programa !== undefined && programa !== null)
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        
        if (secuencia !== undefined && secuencia !== null && secuencia.trim() !== '')
            queryParams.push("secuencia=" + encodeURIComponent("" + secuencia));

        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));

        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));

        if (esAsignacion !== undefined && esAsignacion !== null)
            queryParams.push("esAsignacion=" + encodeURIComponent("" + esAsignacion));

        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSequences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSequences(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processGetSequences(response: HttpResponseBase): Observable<PagedResultDtoOfDollySequenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedResultDtoOfDollySequenceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDollySequenceDto>(null as any);
    }

    /**
     * Valida configuración de cierre para un programa
     */
    validarCierre(programa: string, esAsignacion: boolean = false): Observable<ValidarCierreDto> {
        let url_ = this.baseUrl + "/api/dollys/validar-cierre";
        url_ = url_.replace(/[?&]$/, "");

        if (programa !== undefined && programa !== null)
            url_ += "?programa=" + encodeURIComponent("" + programa);
        if (esAsignacion) url_ += (programa ? "&" : "?") + "esAsignacion=true";

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidarCierre(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarCierre(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processValidarCierre(response: HttpResponseBase): Observable<ValidarCierreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidarCierreDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidarCierreDto>(null as any);
    }
}

// DTOs para Cierre de Dolly
export class PagedResultDtoOfCierreDollyDto implements IPagedResultDtoOfCierreDollyDto {
    totalCount!: number;
    items!: CierreDollyDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCierreDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CierreDollyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCierreDollyDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfCierreDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCierreDollyDto {
    totalCount: number;
    items: CierreDollyDto[] | undefined;
}

export class CierreDollyDto implements ICierreDollyDto {
    dolly!: string | undefined; // Concatenación de DollyClasificacion.DollyDescr + Dolly.DollyDescr.PadLeft(4, '0')
    programa!: string | undefined; // CommodityGrupo.CommodityGrupoDescr
    secuenciaInicial!: string | undefined; // Anio + ' - ' + primera secuencia del grupo
    secuenciaFinal!: string | undefined; // Anio + ' - ' + última secuencia del grupo
    usuario!: string | undefined; // User.Name + User.Lastname + User.SecondLastname
    fecha!: moment.Moment | undefined; // Última FechaRegistro de DollyEstatus para este DollyId

    constructor(data?: ICierreDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dolly = _data["dolly"];
            this.programa = _data["programa"];
            this.secuenciaInicial = _data["secuenciaInicial"];
            this.secuenciaFinal = _data["secuenciaFinal"];
            this.usuario = _data["usuario"];
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CierreDollyDto {
        data = typeof data === "object" ? data : {};
        let result = new CierreDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["dolly"] = this.dolly;
        data["programa"] = this.programa;
        data["secuenciaInicial"] = this.secuenciaInicial;
        data["secuenciaFinal"] = this.secuenciaFinal;
        data["usuario"] = this.usuario;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICierreDollyDto {
    dolly: string | undefined;
    programa: string | undefined;
    secuenciaInicial: string | undefined;
    secuenciaFinal: string | undefined;
    usuario: string | undefined;
    fecha: moment.Moment | undefined;
}

export class CerrarDolliesCommand implements ICerrarDolliesCommand {
    programa?: string | undefined;
    secuenciaInicial?: string | undefined;
    secuenciaFinal?: string | undefined;
    dollyId?: number | undefined;
    esCierreManual?: boolean | undefined;

    constructor(data?: ICerrarDolliesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programa = _data["programa"];
            this.secuenciaInicial = _data["secuenciaInicial"];
            this.secuenciaFinal = _data["secuenciaFinal"];
            this.dollyId = _data["dollyId"];
            this.esCierreManual = _data["esCierreManual"];
        }
    }

    static fromJS(data: any): CerrarDolliesCommand {
        data = typeof data === "object" ? data : {};
        let result = new CerrarDolliesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["programa"] = this.programa;
        data["secuenciaInicial"] = this.secuenciaInicial;
        data["secuenciaFinal"] = this.secuenciaFinal;
        data["dollyId"] = this.dollyId;
        data["esCierreManual"] = this.esCierreManual;
        return data;
    }
}

export interface ICerrarDolliesCommand {
    programa?: string | undefined;
    secuenciaInicial?: string | undefined;
    secuenciaFinal?: string | undefined;
    dollyId?: number | undefined;
    esCierreManual?: boolean | undefined;
}

export class CierreDollyResultDto implements ICierreDollyResultDto {
    success!: boolean;
    message!: string | undefined;
    updatedCount!: number;

    constructor(data?: ICierreDollyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.updatedCount = _data["updatedCount"];
        }
    }

    static fromJS(data: any): CierreDollyResultDto {
        data = typeof data === "object" ? data : {};
        let result = new CierreDollyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["updatedCount"] = this.updatedCount;
        return data;
    }
}

export interface ICierreDollyResultDto {
    success: boolean;
    message: string | undefined;
    updatedCount: number;
}

export class ValidarCierreDto implements IValidarCierreDto {
    mostrarSecuencia!: boolean;
    secuenciaInicial!: string | undefined;
    secuenciaFinal!: string | undefined;
    dollyRequerido!: string | undefined;
    dollyId!: number | undefined;
    densidad!: number;

    constructor(data?: IValidarCierreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mostrarSecuencia = _data["mostrarSecuencia"];
            this.secuenciaInicial = _data["secuenciaInicial"];
            this.secuenciaFinal = _data["secuenciaFinal"];
            this.dollyRequerido = _data["dollyRequerido"];
            this.dollyId = _data["dollyId"];
            this.densidad = _data["densidad"];
        }
    }

    static fromJS(data: any): ValidarCierreDto {
        data = typeof data === "object" ? data : {};
        let result = new ValidarCierreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["mostrarSecuencia"] = this.mostrarSecuencia;
        data["secuenciaInicial"] = this.secuenciaInicial;
        data["secuenciaFinal"] = this.secuenciaFinal;
        data["dollyRequerido"] = this.dollyRequerido;
        data["dollyId"] = this.dollyId;
        data["densidad"] = this.densidad;
        return data;
    }
}

export interface IValidarCierreDto {
    mostrarSecuencia: boolean;
    secuenciaInicial: string | undefined;
    secuenciaFinal: string | undefined;
    dollyRequerido: string | undefined;
    dollyId: number | undefined;
    densidad: number;
}

// DTOs para Secuencias de Dolly
export class PagedResultDtoOfDollySequenceDto implements IPagedResultDtoOfDollySequenceDto {
    totalCount!: number;
    items!: DollySequenceDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDollySequenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DollySequenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDollySequenceDto {
        data = typeof data === "object" ? data : {};
        let result = new PagedResultDtoOfDollySequenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDollySequenceDto {
    totalCount: number;
    items: DollySequenceDto[] | undefined;
}

export class DollySequenceDto implements IDollySequenceDto {
    secuencia!: string | undefined;

    constructor(data?: IDollySequenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secuencia = _data["secuencia"];
        }
    }

    static fromJS(data: any): DollySequenceDto {
        data = typeof data === "object" ? data : {};
        let result = new DollySequenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["secuencia"] = this.secuencia;
        return data;
    }
}

export interface IDollySequenceDto {
    secuencia: string | undefined;
}

// ===== Cajas Envios Service Proxy =====

@Injectable()
export class CajasEnviosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }


    /**
     * Obtiene la lista de cajas de envios con filtros
     * @param filter Filtro general y de columnas
     * @param pageNumber Número de página
     * @param pageSize Tamaño de página
     * @param sorting Ordenamiento
     */
    getCajasEnviosList(filter: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sorting: string | undefined): Observable<CajasEnviosResponse> {
        let url_ = this.baseUrl + "/api/cajas/envios";
        if (filter !== undefined && filter !== null)
            url_ += "?filter=" + encodeURIComponent("" + filter);
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "&pageNumber=" + encodeURIComponent("" + pageNumber);
        if (pageSize !== undefined && pageSize !== null)
            url_ += "&pageSize=" + encodeURIComponent("" + pageSize);
        if (sorting !== undefined && sorting !== null)
            url_ += "&sorting=" + encodeURIComponent("" + sorting);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCajasEnviosList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCajasEnviosList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CajasEnviosResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CajasEnviosResponse>;
        }));
    }

    protected processGetCajasEnviosList(response: HttpResponseBase): Observable<CajasEnviosResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CajasEnviosResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CajasEnviosResponse>(null as any);
    }

    private blobToText(blob: any): Observable<string> {
        return new Observable<string>((observer: any) => {
            if (!blob) {
                observer.next("");
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        });
    }

    /**
     * Obtiene la lista de cajas descargadas
     * @param searchFilter Filtro de búsqueda
     * @param page Número de página
     * @param pageSize Tamaño de página
     */
    getCajasDescargadas(searchFilter?: string, page?: number, pageSize?: number): Observable<CajasDescargadasResponse> {
        let url_ = this.baseUrl + "/api/cajas/DESCARGADA";
        url_ += "?";
        if (searchFilter !== undefined && searchFilter !== null)
            url_ += "SearchFilter=" + encodeURIComponent("" + searchFilter) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCajasDescargadas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCajasDescargadas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CajasDescargadasResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CajasDescargadasResponse>;
        }));
    }

    protected processGetCajasDescargadas(response: HttpResponseBase): Observable<CajasDescargadasResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CajasDescargadasResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CajasDescargadasResponse>(<any>null);
    }

    /**
     * Obtiene los faltantes de dollies específicos
     * @param dollies Lista de dollies separados por coma
     */
    getFaltantesDollies(dollies: string): Observable<FaltanteDollyItem[]> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/faltantes";
        if (dollies !== undefined && dollies !== null)
            url_ += "?embarqueId=" + encodeURIComponent("" + dollies);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFaltantesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaltantesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaltanteDollyItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaltanteDollyItem[]>;
        }));
    }

    protected processGetFaltantesDollies(response: HttpResponseBase): Observable<FaltanteDollyItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 && resultData200.map ? resultData200.map((item: any) => FaltanteDollyItem.fromJS(item)) : [];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FaltanteDollyItem[]>([]);
    }

    /**
     * Obtiene los datos de embarque de dollies específicos
     * @param dollies Lista de dollies separados por coma
     */
    getEmbarquesDollies(dollies: string): Observable<EmbarqueDollyItem[]> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/embarques";
        if (dollies !== undefined && dollies !== null)
            url_ += "?embarqueId=" + encodeURIComponent("" + dollies);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmbarquesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbarquesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmbarqueDollyItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmbarqueDollyItem[]>;
        }));
    }

    protected processGetEmbarquesDollies(response: HttpResponseBase): Observable<EmbarqueDollyItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 && resultData200.map ? resultData200.map((item: any) => EmbarqueDollyItem.fromJS(item)) : [];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmbarqueDollyItem[]>([]);
    }

    // ===== PUT Embarques en Dolly =====
    updateEmbarquesDollies(request: UpdateEmbarquesRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/embarques";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmbarquesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmbarquesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processUpdateEmbarquesDollies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            response instanceof HttpErrorResponse ? response.error instanceof Blob ? response.error : undefined : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return _observableOf<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    protected throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
        if (result !== null && result !== undefined)
            return _observableThrow(result);
        else
            return _observableThrow(new SwaggerException(message, status, response, headers, null));
    }

    /**
     * Obtiene la información de salida de una caja específica
     * @param codigoCaja Código de la caja
     */
    getSalidaCaja(codigoCaja: string): Observable<SalidaCajaResponse> {
        let url_ = this.baseUrl + "/api/cajas/salidas";
        if (codigoCaja !== undefined && codigoCaja !== null)
            url_ += "?codigoCaja=" + encodeURIComponent("" + codigoCaja);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalidaCaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalidaCaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalidaCajaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalidaCajaResponse>;
        }));
    }

    protected processGetSalidaCaja(response: HttpResponseBase): Observable<SalidaCajaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SalidaCajaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalidaCajaResponse>(<any>null);
    }

    /**
     * Edita los datos de un embarque (tractor, chofer, sello)
     * @param request Datos del embarque a editar
     */
    editarEmbarque(request: EditarEmbarqueRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/cajas/envios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditarEmbarque(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditarEmbarque(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditarEmbarque(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Reenvía manualmente (regenerando siempre el PDF) el correo con la hoja de salida
     * de un embarque ya autorizado.
     * @param embarqueId Id del embarque
     */
    reenviarHojaSalida(embarqueId: number): Observable<ReenviarHojaSalidaResponse> {
        let url_ = this.baseUrl + "/api/cajas/envios/{embarqueId}/reenviar-hoja-salida";
        if (embarqueId === undefined || embarqueId === null)
            throw new Error("The parameter 'embarqueId' must be defined.");
        url_ = url_.replace("{embarqueId}", encodeURIComponent("" + embarqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReenviarHojaSalida(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReenviarHojaSalida(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReenviarHojaSalidaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReenviarHojaSalidaResponse>;
        }));
    }

    protected processReenviarHojaSalida(response: HttpResponseBase): Observable<ReenviarHojaSalidaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReenviarHojaSalidaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReenviarHojaSalidaResponse>(<any>null);
    }

}

export interface IReenviarHojaSalidaResponse {
    success: boolean;
    message: string;
}

export class ReenviarHojaSalidaResponse implements IReenviarHojaSalidaResponse {
    success!: boolean;
    message!: string;

    constructor(data?: IReenviarHojaSalidaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReenviarHojaSalidaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReenviarHojaSalidaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

// ===== Planes Carga Service Proxy =====

@Injectable()
export class PlanesCargaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * Obtiene la lista de planes de carga con filtros
     * @param estado Estado del plan de carga
     * @param planCarga Filtro por plan de carga
     * @param dollies Filtro por dollies
     * @param programa Filtro por programa
     * @param pageNumber Número de página
     * @param pageSize Tamaño de página
     * @param sorting Ordenamiento
     */
    getPlanesCargaList(estado: string | undefined, planCarga: string | undefined, dollies: string | undefined, programa: string | undefined, codigoCaja: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sorting: string | undefined, fechaInicio?: Date | null, fechaFin?: Date | null): Observable<PlanesCargaResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/paginado";
        let firstParam = true;
        
        if (estado !== undefined && estado !== null && estado.trim()) {
            url_ += (firstParam ? "?" : "&") + "estado=" + encodeURIComponent(estado);
            firstParam = false;
        }
        if (planCarga !== undefined && planCarga !== null && planCarga.trim()) {
            url_ += (firstParam ? "?" : "&") + "planCarga=" + encodeURIComponent("" + planCarga);
            firstParam = false;
        }
        if (dollies !== undefined && dollies !== null && dollies.trim()) {
            url_ += (firstParam ? "?" : "&") + "dollies=" + encodeURIComponent("" + dollies);
            firstParam = false;
        }
        if (programa !== undefined && programa !== null && programa.trim()) {
            url_ += (firstParam ? "?" : "&") + "programa=" + encodeURIComponent("" + programa);
            firstParam = false;
        }
        if (codigoCaja !== undefined && codigoCaja !== null && codigoCaja.trim()) {
            url_ += (firstParam ? "?" : "&") + "codigoCaja=" + encodeURIComponent("" + codigoCaja);
            firstParam = false;
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            url_ += (firstParam ? "?" : "&") + "pageNumber=" + encodeURIComponent("" + pageNumber);
            firstParam = false;
        }
        if (pageSize !== undefined && pageSize !== null) {
            url_ += (firstParam ? "?" : "&") + "pageSize=" + encodeURIComponent("" + pageSize);
            firstParam = false;
        }
        if (sorting !== undefined && sorting !== null) {
            url_ += (firstParam ? "?" : "&") + "sorting=" + encodeURIComponent("" + sorting);
            firstParam = false;
        }
        if (fechaInicio !== undefined && fechaInicio !== null) {
            url_ += (firstParam ? "?" : "&") + "fechaInicio=" + encodeURIComponent(fechaInicio.toISOString());
            firstParam = false;
        }
        if (fechaFin !== undefined && fechaFin !== null) {
            const fin = new Date(fechaFin);
            fin.setHours(23, 59, 59, 999);
            url_ += (firstParam ? "?" : "&") + "fechaFin=" + encodeURIComponent(fin.toISOString());
            firstParam = false;
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlanesCargaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanesCargaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanesCargaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanesCargaResponse>;
        }));
    }

    /**
     * Obtiene la lista de planes de carga con filtros (versión optimizada ).
     * Mismo contrato de request/response que getPlanesCargaList; los campos por-dolly
     * estado/programa/secuencias no vienen poblados (no se usan en la grilla).
     * @param estado Estado del plan de carga
     * @param planCarga Filtro por plan de carga
     * @param dollies Filtro por dollies
     * @param programa Filtro por programa
     * @param pageNumber Número de página
     * @param pageSize Tamaño de página
     * @param sorting Ordenamiento
     */
    getPlanesCargaListLight(estado: string | undefined, planCarga: string | undefined, dollies: string | undefined, programa: string | undefined, codigoCaja: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sorting: string | undefined, fechaInicio?: Date | null, fechaFin?: Date | null): Observable<PlanesCargaResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/paginado-op";
        let firstParam = true;

        if (estado !== undefined && estado !== null && estado.trim()) {
            url_ += (firstParam ? "?" : "&") + "estado=" + encodeURIComponent(estado);
            firstParam = false;
        }
        if (planCarga !== undefined && planCarga !== null && planCarga.trim()) {
            url_ += (firstParam ? "?" : "&") + "planCarga=" + encodeURIComponent("" + planCarga);
            firstParam = false;
        }
        if (dollies !== undefined && dollies !== null && dollies.trim()) {
            url_ += (firstParam ? "?" : "&") + "dollies=" + encodeURIComponent("" + dollies);
            firstParam = false;
        }
        if (programa !== undefined && programa !== null && programa.trim()) {
            url_ += (firstParam ? "?" : "&") + "programa=" + encodeURIComponent("" + programa);
            firstParam = false;
        }
        if (codigoCaja !== undefined && codigoCaja !== null && codigoCaja.trim()) {
            url_ += (firstParam ? "?" : "&") + "codigoCaja=" + encodeURIComponent("" + codigoCaja);
            firstParam = false;
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            url_ += (firstParam ? "?" : "&") + "pageNumber=" + encodeURIComponent("" + pageNumber);
            firstParam = false;
        }
        if (pageSize !== undefined && pageSize !== null) {
            url_ += (firstParam ? "?" : "&") + "pageSize=" + encodeURIComponent("" + pageSize);
            firstParam = false;
        }
        if (sorting !== undefined && sorting !== null) {
            url_ += (firstParam ? "?" : "&") + "sorting=" + encodeURIComponent("" + sorting);
            firstParam = false;
        }
        if (fechaInicio !== undefined && fechaInicio !== null) {
            url_ += (firstParam ? "?" : "&") + "fechaInicio=" + encodeURIComponent(fechaInicio.toISOString());
            firstParam = false;
        }
        if (fechaFin !== undefined && fechaFin !== null) {
            const fin = new Date(fechaFin);
            fin.setHours(23, 59, 59, 999);
            url_ += (firstParam ? "?" : "&") + "fechaFin=" + encodeURIComponent(fin.toISOString());
            firstParam = false;
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlanesCargaListLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanesCargaListLight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanesCargaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanesCargaResponse>;
        }));
    }

    /**
     * Reiniciar embarque
     * @param embarqueId ID del embarque a reiniciar
     */
    reiniciarEmbarque(embarqueId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/reinicio";

        const content_ = JSON.stringify({ embarqueId: embarqueId });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReiniciarEmbarque(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReiniciarEmbarque(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processReiniciarEmbarque(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    protected processGetPlanesCargaList(response: HttpResponseBase): Observable<PlanesCargaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanesCargaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanesCargaResponse>(null as any);
    }

    protected processGetPlanesCargaListLight(response: HttpResponseBase): Observable<PlanesCargaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanesCargaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanesCargaResponse>(null as any);
    }

    /**
     * PUT /api/planes-carga/embarques/descarga
     */
    putEmbarqueDescarga(requestBody: any): Observable<any> {
        let url_ = this.baseUrl + "/api/planes-carga/embarques/descarga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEmbarqueDescarga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmbarqueDescarga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processEmbarqueDescarga(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    private blobToText(blob: any): Observable<string> {
        return new Observable<string>((observer: any) => {
            if (!blob) {
                observer.next("");
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        });
    }

    /**
     * Obtiene los faltantes de dollies específicos
     * @param dollies Lista de dollies separados por coma
     */
    getFaltantesDollies(dollies: string): Observable<FaltanteDollyItem[]> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/faltantes";
        if (dollies !== undefined && dollies !== null)
            url_ += "?dollies=" + encodeURIComponent("" + dollies);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFaltantesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaltantesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaltanteDollyItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaltanteDollyItem[]>;
        }));
    }

    protected processGetFaltantesDollies(response: HttpResponseBase): Observable<FaltanteDollyItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 && resultData200.map ? resultData200.map((item: any) => FaltanteDollyItem.fromJS(item)) : [];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FaltanteDollyItem[]>([]);
    }

    /**
     * Obtiene los datos de embarque de dollies específicos
     * @param dollies Lista de dollies separados por coma
     */
    getEmbarquesDollies(dollies: string): Observable<EmbarqueDollyItem[]> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/embarques";
        if (dollies !== undefined && dollies !== null)
            url_ += "?dollies=" + encodeURIComponent("" + dollies);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmbarquesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbarquesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmbarqueDollyItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmbarqueDollyItem[]>;
        }));
    }

    protected processGetEmbarquesDollies(response: HttpResponseBase): Observable<EmbarqueDollyItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 && resultData200.map ? resultData200.map((item: any) => EmbarqueDollyItem.fromJS(item)) : [];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmbarqueDollyItem[]>([]);
    }

    // ===== PUT Embarques en Dolly =====
    updateEmbarquesDollies(request: UpdateEmbarquesRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/cajas/envios/dollies/embarques";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmbarquesDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmbarquesDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processUpdateEmbarquesDollies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            response instanceof HttpErrorResponse ? response.error instanceof Blob ? response.error : undefined : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return _observableOf<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    protected throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
        if (result !== null && result !== undefined)
            return _observableThrow(result);
        else
            return _observableThrow(new SwaggerException(message, status, response, headers, null));
    }

    /**
     * Activar modo edición para un embarque específico
     * @param embarqueId ID del embarque a activar en modo edición
     */
    activarModoEdicion(embarqueId: number, confirmado: boolean = false): Observable<EditModeResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/modoEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ embarqueId: embarqueId, confirmado: confirmado });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActivarModoEdicion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivarModoEdicion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditModeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditModeResponse>;
        }));
    }

    protected processActivarModoEdicion(response: HttpResponseBase): Observable<EditModeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            response instanceof HttpErrorResponse ? response.error instanceof Blob ? response.error : undefined : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditModeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditModeResponse>(null as any);
    }

    /**
     * Resetear modo edición para un embarque específico
     * @param embarqueId ID del embarque a resetear del modo edición
     */
    resetearModoEdicion(embarqueId: number): Observable<EditModeResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/modoEdit/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(embarqueId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetearModoEdicion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetearModoEdicion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditModeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditModeResponse>;
        }));
    }

    protected processResetearModoEdicion(response: HttpResponseBase): Observable<EditModeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            response instanceof HttpErrorResponse ? response.error instanceof Blob ? response.error : undefined : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditModeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditModeResponse>(null as any);
    }

    /**
     * Obtiene los detalles de un embarque específico
     * @param embarqueId ID del embarque
     */
    getPlanesCargaDetalles(embarqueId: string, excluirDescargados?: boolean, mode?: string): Observable<PlanesCargaDetallesResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/detalles";
        if (embarqueId === undefined || embarqueId === null)
            throw new Error("El parámetro 'embarqueId' no puede ser nulo o indefinido.");
        
        if (embarqueId !== undefined)
            url_ += (url_.indexOf('?') >= 0 ? '&' : '?') + 'id=' + encodeURIComponent('' + embarqueId);
        if (excluirDescargados !== undefined)
            url_ += (url_.indexOf('?') >= 0 ? '&' : '?') + 'excluirDescargados=' + encodeURIComponent('' + excluirDescargados);
        if (mode !== undefined)
            url_ += (url_.indexOf('?') >= 0 ? '&' : '?') + 'mode=' + encodeURIComponent('' + mode);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlanesCargaDetalles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanesCargaDetalles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanesCargaDetallesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanesCargaDetallesResponse>;
        }));
    }

    protected processGetPlanesCargaDetalles(response: HttpResponseBase): Observable<PlanesCargaDetallesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanesCargaDetallesResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanesCargaDetallesResponse>(null as any);
    }

    /**
     * Exporta los detalles de plan de carga a Excel
     * @param embarqueId ID del embarque
     */
    exportPlanesCargaDetalle(embarqueId: string): Observable<Blob> {
        let url_ = this.baseUrl + "/api/planes-carga/embarques/" + encodeURIComponent("" + embarqueId) + "/excel";
        if (embarqueId === undefined || embarqueId === null)
            throw new Error("El parámetro 'embarqueId' no puede ser nulo o indefinido.");
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPlanesCargaDetalle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPlanesCargaDetalle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportPlanesCargaDetalle(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return _observableOf(responseBlob as Blob);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    /**
     * Obtiene los planes de descarga por fecha
     * @param fecha Fecha para filtrar (formato YYYY-MM-DD)
     * @param pageNumber Número de página
     * @param pageSize Tamaño de página
     * @param filter Filtro de búsqueda
     * @param sorting Ordenamiento
     */
    getPlanesDescarga(body: any): Observable<boolean> {
        let url_ = this.baseUrl + "/api/planes-descarga";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            body: body,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlanesDescarga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanesDescarga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetPlanesDescarga(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // Si el API retorna un boolean directamente
                result200 = typeof resultData200 === 'boolean' ? resultData200 : !!resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * Cambiar estado de un folio
     * @param folio Folio del cual cambiar el estado
     * @param estado Nuevo estado del folio
     */
    cambiarEstadoFolio(folio: string, estado: string): Observable<CambiarEstadoFolioResponse> {
        let url_ = this.baseUrl + "/api/planes-descarga/estados";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({
            folio: folio,
            estado: estado
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCambiarEstadoFolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCambiarEstadoFolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CambiarEstadoFolioResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CambiarEstadoFolioResponse>;
        }));
    }

    protected processCambiarEstadoFolio(response: HttpResponseBase): Observable<CambiarEstadoFolioResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CambiarEstadoFolioResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CambiarEstadoFolioResponse>(null as any);
    }

    /**
     * Actualiza dollies en el plan de carga
     * @param body Datos de dollies a actualizar
     */
    putDollies(body: PutDolliesRequest): Observable<PutDolliesResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/dollies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutDollies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDollies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PutDolliesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PutDolliesResponse>;
        }));
    }

    protected processPutDollies(response: HttpResponseBase): Observable<PutDolliesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PutDolliesResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PutDolliesResponse>(null as any);
    }
}

// ===== DTOs para Planes Carga =====

export class PlanesCargaResponse implements IPlanesCargaResponse {
    totalCount?: number;
    items?: PlanesCargaItem[];

    constructor(data?: IPlanesCargaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(PlanesCargaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanesCargaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanesCargaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.totalCount !== undefined)
            data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanesCargaResponse {
    totalCount?: number;
    items?: PlanesCargaItem[];
}

export class EditModeResponse implements IEditModeResponse {
    success?: boolean;
    message?: string;
    requiereConfirmacion?: boolean;

    constructor(data?: IEditModeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
            this.requiereConfirmacion = data["requiereConfirmacion"];
        }
    }

    static fromJS(data: any): EditModeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditModeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.success !== undefined)
            data["success"] = this.success;
        if (this.message !== undefined)
            data["message"] = this.message;
        if (this.requiereConfirmacion !== undefined)
            data["requiereConfirmacion"] = this.requiereConfirmacion;
        return data;
    }
}

export interface IEditModeResponse {
    success?: boolean;
    message?: string;
    requiereConfirmacion?: boolean;
}

export class PlanesCargaItem implements IPlanesCargaItem {
    id?: string;
    nombre?: string;
    estado?: string;
    fechaCreacion?: string;
    programas?: string[];
    ubicacion?: string;
    codigoCaja?: string;
    cajaId?: string;
    totalDollies?: number;
    dolliesCargados?: number;
    dollies?: DollyItem[];
    enviado?: boolean;
    estatusAutorizacion?: string;
    secuenciadoDHL?: boolean;

    constructor(data?: IPlanesCargaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.nombre = data["nombre"];
            this.estado = data["estado"];
            this.fechaCreacion = data["fechaCreacion"];
            if (Array.isArray(data["programas"])) {
                this.programas = data["programas"];
            }
            this.ubicacion = data["ubicacion"];
            this.codigoCaja = data["codigoCaja"];
            this.cajaId = data["cajaId"];
            this.totalDollies = data["totalDollies"];
            this.dolliesCargados = data["dolliesCargados"];
            this.enviado = data["enviado"];
            this.estatusAutorizacion = data["estatusAutorizacion"];
            this.secuenciadoDHL = data["secuenciadoDHL"];
            if (Array.isArray(data["dollies"])) {
                this.dollies = [];
                for (let item of data["dollies"])
                    this.dollies.push(DollyItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanesCargaItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlanesCargaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.id !== undefined)
            data["id"] = this.id;
        if (this.nombre !== undefined)
            data["nombre"] = this.nombre;
        if (this.estado !== undefined)
            data["estado"] = this.estado;
        if (this.fechaCreacion !== undefined)
            data["fechaCreacion"] = this.fechaCreacion;
        if (Array.isArray(this.programas)) {
            data["programas"] = this.programas;
        }
        if (this.ubicacion !== undefined)
            data["ubicacion"] = this.ubicacion;
        if (this.codigoCaja !== undefined)
            data["codigoCaja"] = this.codigoCaja;
        if (this.cajaId !== undefined)
            data["cajaId"] = this.cajaId;
        if (this.totalDollies !== undefined)
            data["totalDollies"] = this.totalDollies;
        if (this.dolliesCargados !== undefined)
            data["dolliesCargados"] = this.dolliesCargados;
        if (this.secuenciadoDHL !== undefined)
            data["secuenciadoDHL"] = this.secuenciadoDHL;
        if (Array.isArray(this.dollies)) {
            data["dollies"] = [];
            for (let item of this.dollies)
                data["dollies"].push(item.toJSON());
        }
        if (this.enviado !== undefined)
            data["enviado"] = this.enviado;
        if (this.estatusAutorizacion !== undefined)
            data["estatusAutorizacion"] = this.estatusAutorizacion;
        return data;
    }
}

export interface IPlanesCargaItem {
    id?: string;
    nombre?: string;
    estado?: string;
    fechaCreacion?: string;
    programas?: string[];
    ubicacion?: string;
    codigoCaja?: string;
    cajaId?: string;
    totalDollies?: number;
    dolliesCargados?: number;
    dollies?: DollyItem[];
    enviado?: boolean;
    estatusAutorizacion?: string;
    secuenciadoDHL?: boolean;
}

export class DollyItem implements IDollyItem {
    codigoDolly?: string;
    estado?: string;
    programa?: string;
    fechaCarga?: string;
    secuencias?: string[];

    constructor(data?: IDollyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codigoDolly = data["codigoDolly"];
            this.estado = data["estado"];
            this.programa = data["programa"];
            this.fechaCarga = data["fechaCarga"];
            if (Array.isArray(data["secuencias"])) {
                this.secuencias = data["secuencias"];
            }
        }
    }

    static fromJS(data: any): DollyItem {
        data = typeof data === 'object' ? data : {};
        let result = new DollyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.codigoDolly !== undefined)
            data["codigoDolly"] = this.codigoDolly;
        if (this.estado !== undefined)
            data["estado"] = this.estado;
        if (this.programa !== undefined)
            data["programa"] = this.programa;
        if (this.fechaCarga !== undefined)
            data["fechaCarga"] = this.fechaCarga;
        if (Array.isArray(this.secuencias)) {
            data["secuencias"] = this.secuencias;
        }
        return data;
    }
}

export interface IDollyItem {
    codigoDolly?: string;
    estado?: string;
    programa?: string;
    fechaCarga?: string;
    secuencias?: string[];
}

// ===== DTOs para Put Dollies =====

export class PutDolliesRequest implements IPutDolliesRequest {
    planId!: number;
    codigoDolly!: string;
    codigoDollies!: string[];

    constructor(data?: IPutDolliesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planId = data["planId"];
            this.codigoDolly = data["codigoDolly"];
            if (Array.isArray(data["codigoDollies"])) {
                this.codigoDollies = [] as any;
                for (let item of data["codigoDollies"])
                    this.codigoDollies.push(item);
            }
        }
    }

    static fromJS(data: any): PutDolliesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PutDolliesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["codigoDolly"] = this.codigoDolly;
        if (Array.isArray(this.codigoDollies)) {
            data["codigoDollies"] = [];
            for (let item of this.codigoDollies)
                data["codigoDollies"].push(item);
        }
        return data;
    }
}

export interface IPutDolliesRequest {
    planId: number;
    codigoDolly: string;
    codigoDollies: string[];
}

export class PutDolliesResponse implements IPutDolliesResponse {
    success!: boolean;
    message?: string;
    data?: PutDolliesData;

    constructor(data?: IPutDolliesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
            this.data = data["data"] ? PutDolliesData.fromJS(data["data"]) : undefined;
        }
    }

    static fromJS(data: any): PutDolliesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PutDolliesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPutDolliesResponse {
    success: boolean;
    message?: string;
    data?: PutDolliesData;
}

export class PutDolliesData implements IPutDolliesData {
    dolliesCargados?: number;
    totalDollies?: number;
    progreso?: number;

    constructor(data?: IPutDolliesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dolliesCargados = data["dolliesCargados"];
            this.totalDollies = data["totalDollies"];
            this.progreso = data["progreso"];
        }
    }

    static fromJS(data: any): PutDolliesData {
        data = typeof data === 'object' ? data : {};
        let result = new PutDolliesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dolliesCargados !== undefined)
            data["dolliesCargados"] = this.dolliesCargados;
        if (this.totalDollies !== undefined)
            data["totalDollies"] = this.totalDollies;
        if (this.progreso !== undefined)
            data["progreso"] = this.progreso;
        return data;
    }
}

export interface IPutDolliesData {
    dolliesCargados?: number;
    totalDollies?: number;
    progreso?: number;
}

// ===== DTOs para Cajas Envios =====

export class CajasEnviosResponse implements ICajasEnviosResponse {
    totalCount?: number;
    items?: CajasEnviosItem[];

    constructor(data?: ICajasEnviosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CajasEnviosItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CajasEnviosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CajasEnviosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.totalCount !== undefined)
            data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICajasEnviosResponse {
    totalCount?: number;
    items?: CajasEnviosItem[];
}

export class CajasEnviosItem implements ICajasEnviosItem {
    embarqueId?: string;
    cajaDescripcion?: string;
    dollies?: string;
    programasDescr?: string;
    enviado?: boolean;

    constructor(data?: ICajasEnviosItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.embarqueId = data["embarqueId"];
            this.cajaDescripcion = data["cajaDescripcion"];
            this.dollies = data["dollies"];
            this.programasDescr = data["programasDescr"];
            this.enviado = data["enviado"];
        }
    }

    static fromJS(data: any): CajasEnviosItem {
        data = typeof data === 'object' ? data : {};
        let result = new CajasEnviosItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.embarqueId !== undefined)
            data["embarqueId"] = this.embarqueId;
        if (this.cajaDescripcion !== undefined)
            data["cajaDescripcion"] = this.cajaDescripcion;
        if (this.dollies !== undefined)
            data["dollies"] = this.dollies;
        if (this.programasDescr !== undefined)
            data["programasDescr"] = this.programasDescr;
        if (this.enviado !== undefined)
            data["enviado"] = this.enviado;
        return data;
    }
}

export interface ICajasEnviosItem {
    embarqueId?: string;
    cajaDescripcion?: string;
    dollies?: string;
    programasDescr?: string;
    enviado?: boolean;
}

// ===== DTOs para Cajas Descargadas =====

export class CajasDescargadasResponse implements ICajasDescargadasResponse {
    totalCount?: number;
    items?: CajaDescargadaItem[];

    constructor(data?: ICajasDescargadasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CajaDescargadaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CajasDescargadasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CajasDescargadasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.totalCount !== undefined)
            data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICajasDescargadasResponse {
    totalCount?: number;
    items?: CajaDescargadaItem[];
}

export class CajaDescargadaItem implements ICajaDescargadaItem {
    id?: number;
    value?: string;

    constructor(data?: ICajaDescargadaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): CajaDescargadaItem {
        data = typeof data === 'object' ? data : {};
        let result = new CajaDescargadaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.id !== undefined)
            data["id"] = this.id;
        if (this.value !== undefined)
            data["value"] = this.value;
        return data;
    }
}

export interface ICajaDescargadaItem {
    id?: number;
    value?: string;
}

// ===== DTOs para Faltantes en Dolly =====

export class FaltanteDollyItem implements IFaltanteDollyItem {
    turno?: string;
    fechaRegistro?: string;
    diaNatural?: string;
    numeroParte?: string;
    cantidadFaltante?: number;
    commodity?: string;
    descripcion?: string;
    secuencia?: string;
    dollyCompleto?: string;
    causaFaltanteDescr?: string;

    constructor(data?: IFaltanteDollyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.turno = data["turno"];
            this.fechaRegistro = data["fechaRegistro"];
            this.diaNatural = data["diaNatural"];
            this.numeroParte = data["numeroParte"];
            this.cantidadFaltante = data["cantidadFaltante"];
            this.commodity = data["commodity"];
            this.descripcion = data["descripcion"];
            this.secuencia = data["secuencia"];
            this.dollyCompleto = data["dollyCompleto"];
            this.causaFaltanteDescr = data["causaFaltanteDescr"];
        }
    }

    static fromJS(data: any): FaltanteDollyItem {
        data = typeof data === 'object' ? data : {};
        let result = new FaltanteDollyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.turno !== undefined)
            data["turno"] = this.turno;
        if (this.fechaRegistro !== undefined)
            data["fechaRegistro"] = this.fechaRegistro;
        if (this.diaNatural !== undefined)
            data["diaNatural"] = this.diaNatural;
        if (this.numeroParte !== undefined)
            data["numeroParte"] = this.numeroParte;
        if (this.cantidadFaltante !== undefined)
            data["cantidadFaltante"] = this.cantidadFaltante;
        if (this.commodity !== undefined)
            data["commodity"] = this.commodity;
        if (this.descripcion !== undefined)
            data["descripcion"] = this.descripcion;
        if (this.secuencia !== undefined)
            data["secuencia"] = this.secuencia;
        if (this.dollyCompleto !== undefined)
            data["dollyCompleto"] = this.dollyCompleto;
        if (this.causaFaltanteDescr !== undefined)
            data["causaFaltanteDescr"] = this.causaFaltanteDescr;
        return data;
    }
}

export interface IFaltanteDollyItem {
    turno?: string;
    fechaRegistro?: string;
    diaNatural?: string;
    numeroParte?: string;
    cantidadFaltante?: number;
    commodity?: string;
    descripcion?: string;
    secuencia?: string;
    dollyCompleto?: string;
    causaFaltanteDescr?: string;
}

// ===== DTOs para Embarques en Dolly =====

export class EmbarqueDollyItem implements IEmbarqueDollyItem {
    caja?: string;
    tractor?: string;
    nombreUsuario?: string;
    fechaEnvio?: string;
    nombreCompletoChofer?: string;
    selloEnvio?: string;
    embarque?: EmbarqueDetalle;

    constructor(data?: IEmbarqueDollyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.caja = data["caja"];
            this.tractor = data["tractor"];
            this.nombreUsuario = data["nombreUsuario"];
            this.fechaEnvio = data["fechaEnvio"];
            this.nombreCompletoChofer = data["nombreCompletoChofer"];
            this.selloEnvio = data["selloEnvio"];
            this.embarque = data["embarque"] ? EmbarqueDetalle.fromJS(data["embarque"]) : undefined;
        }
    }

    static fromJS(data: any): EmbarqueDollyItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmbarqueDollyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.caja !== undefined)
            data["caja"] = this.caja;
        if (this.tractor !== undefined)
            data["tractor"] = this.tractor;
        if (this.nombreUsuario !== undefined)
            data["nombreUsuario"] = this.nombreUsuario;
        if (this.fechaEnvio !== undefined)
            data["fechaEnvio"] = this.fechaEnvio;
        if (this.nombreCompletoChofer !== undefined)
            data["nombreCompletoChofer"] = this.nombreCompletoChofer;
        if (this.selloEnvio !== undefined)
            data["selloEnvio"] = this.selloEnvio;
        if (this.embarque !== undefined)
            data["embarque"] = this.embarque.toJSON();
        return data;
    }
}

export interface IEmbarqueDollyItem {
    caja?: string;
    tractor?: string;
    nombreUsuario?: string;
    fechaEnvio?: string;
    nombreCompletoChofer?: string;
    selloEnvio?: string;
    embarque?: EmbarqueDetalle;
}

export class EmbarqueDetalle implements IEmbarqueDetalle {
    programasDescr?: string;
    dollyCompleto?: string;
    secuenciaInicial?: string;
    secuenciaFinal?: string;

    constructor(data?: IEmbarqueDetalle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programasDescr = data["programasDescr"];
            this.dollyCompleto = data["dollyCompleto"];
            this.secuenciaInicial = data["secuenciaInicial"];
            this.secuenciaFinal = data["secuenciaFinal"];
        }
    }

    static fromJS(data: any): EmbarqueDetalle {
        data = typeof data === 'object' ? data : {};
        let result = new EmbarqueDetalle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.programasDescr !== undefined)
            data["programasDescr"] = this.programasDescr;
        if (this.dollyCompleto !== undefined)
            data["dollyCompleto"] = this.dollyCompleto;
        if (this.secuenciaInicial !== undefined)
            data["secuenciaInicial"] = this.secuenciaInicial;
        if (this.secuenciaFinal !== undefined)
            data["secuenciaFinal"] = this.secuenciaFinal;
        return data;
    }
}

export interface IEmbarqueDetalle {
    programasDescr?: string;
    dollyCompleto?: string;
    secuenciaInicial?: string;
    secuenciaFinal?: string;
}

// ===== DTO para Update Embarques Request =====

export class EditarEmbarqueRequest implements IEditarEmbarqueRequest {
    embarqueId!: string;
    modo!: string;
    numeroSello?: string | undefined;
    tractorId?: string | undefined;
    choferId?: string | undefined;

    constructor(data?: IEditarEmbarqueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.embarqueId = _data["embarqueId"];
            this.modo = _data["modo"];
            this.numeroSello = _data["numeroSello"];
            this.tractorId = _data["tractorId"];
            this.choferId = _data["choferId"];
        }
    }

    static fromJS(data: any): EditarEmbarqueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditarEmbarqueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embarqueId"] = this.embarqueId;
        data["modo"] = this.modo;
        data["numeroSello"] = this.numeroSello;
        data["tractorId"] = this.tractorId;
        data["choferId"] = this.choferId;
        return data;
    }
}

export interface IEditarEmbarqueRequest {
    embarqueId: string;
    modo: string;
    numeroSello?: string | undefined;
    tractorId?: string | undefined;
    choferId?: string | undefined;
}

export class UpdateEmbarquesRequest implements IUpdateEmbarquesRequest {
    embarqueId?: string;
    fechaEnvio?: Date;
    numeroSello?: string;
    tractorId?: string;
    choferId?: string;
    authorizeAdvancedSequences?: boolean;

    constructor(data?: IUpdateEmbarquesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.embarqueId = data["embarqueId"];
            this.fechaEnvio = data["fechaEnvio"] ? new Date(data["fechaEnvio"]) : undefined;
            this.numeroSello = data["numeroSello"];
            this.tractorId = data["tractorId"];
            this.choferId = data["choferId"];
            this.authorizeAdvancedSequences = data["authorizeAdvancedSequences"];
        }
    }

    static fromJS(data: any): UpdateEmbarquesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmbarquesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.embarqueId !== undefined)
            data["embarqueId"] = this.embarqueId;
        if (this.fechaEnvio !== undefined)
            data["fechaEnvio"] = this.fechaEnvio ? this.fechaEnvio.toISOString() : undefined;
        if (this.numeroSello !== undefined)
            data["numeroSello"] = this.numeroSello;
        if (this.tractorId !== undefined)
            data["tractorId"] = this.tractorId;
        if (this.choferId !== undefined)
            data["choferId"] = this.choferId;
        if (this.authorizeAdvancedSequences !== undefined)
            data["authorizeAdvancedSequences"] = this.authorizeAdvancedSequences;
        return data;
    }
}

export interface IUpdateEmbarquesRequest {
    embarqueId?: string;
    fechaEnvio?: Date;
    numeroSello?: string;
    tractorId?: string;
    choferId?: string;
    authorizeAdvancedSequences?: boolean;
}

// ===== DTO para Update Causas Faltantes Request =====

export class UpdateCausasFaltantesRequest implements IUpdateCausasFaltantesRequest {
    causaFaltanteIds!: number[];
    nuevaCausaFaltanteId!: number;

    constructor(data?: IUpdateCausasFaltantesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["causaFaltanteIds"])) {
                this.causaFaltanteIds = [] as any;
                for (let item of data["causaFaltanteIds"])
                    this.causaFaltanteIds!.push(item);
            }
            this.nuevaCausaFaltanteId = data["nuevaCausaFaltanteId"];
        }
    }

    static fromJS(data: any): UpdateCausasFaltantesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCausasFaltantesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.causaFaltanteIds)) {
            data["causaFaltanteIds"] = [];
            for (let item of this.causaFaltanteIds)
                data["causaFaltanteIds"].push(item);
        }
        data["nuevaCausaFaltanteId"] = this.nuevaCausaFaltanteId;
        return data;
    }
}

export interface IUpdateCausasFaltantesRequest {
    causaFaltanteIds: number[];
    nuevaCausaFaltanteId: number;
}

export class UpdateCausasFaltantesResponse implements IUpdateCausasFaltantesResponse {
    success!: boolean;
    message?: string;

    constructor(data?: IUpdateCausasFaltantesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): UpdateCausasFaltantesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCausasFaltantesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateCausasFaltantesResponse {
    success: boolean;
    message?: string;
}
// DTOs for Arribo de Cajas
export interface IArriboCajasResponse {
    descripcion?: string | undefined;
    dollys?: ArriboCajasDollyDto[] | undefined;
    programas?: string[] | undefined;
}

export class ArriboCajasResponse implements IArriboCajasResponse {
    descripcion!: string | undefined;
    dollys!: ArriboCajasDollyDto[] | undefined;
    programas!: string[] | undefined;

    constructor(data?: IArriboCajasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            if (Array.isArray(_data["dollys"])) {
                this.dollys = [] as any;
                for (let item of _data["dollys"])
                    this.dollys!.push(ArriboCajasDollyDto.fromJS(item));
            }
            if (Array.isArray(_data["programas"])) {
                this.programas = [] as any;
                for (let item of _data["programas"])
                    this.programas!.push(item);
            }
        }
    }

    static fromJS(data: any): ArriboCajasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArriboCajasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        if (Array.isArray(this.dollys)) {
            data["dollys"] = [];
            for (let item of this.dollys)
                data["dollys"].push(item.toJSON());
        }
        if (Array.isArray(this.programas)) {
            data["programas"] = [];
            for (let item of this.programas)
                data["programas"].push(item);
        }
        return data;
    }
}

export interface IArriboCajasDollyDto {
    caja?: string | undefined;
    dolly?: string | undefined;
    programas?: string[] | undefined;
}

export class ArriboCajasDollyDto implements IArriboCajasDollyDto {
    caja!: string | undefined;
    dolly!: string | undefined;
    programas!: string[] | undefined;

    constructor(data?: IArriboCajasDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caja = _data["caja"];
            this.dolly = _data["dolly"];
            if (Array.isArray(_data["programas"])) {
                this.programas = [] as any;
                for (let item of _data["programas"])
                    this.programas!.push(item);
            }
        }
    }

    static fromJS(data: any): ArriboCajasDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArriboCajasDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caja"] = this.caja;
        data["dolly"] = this.dolly;
        if (Array.isArray(this.programas)) {
            data["programas"] = [];
            for (let item of this.programas)
                data["programas"].push(item);
        }
        return data;
    }
}

export interface IArriboCajasRequest {
    descripcionCaja?: string | undefined;
    embarqueId?: number | undefined;
}

export class ArriboCajasRequest implements IArriboCajasRequest {
    descripcionCaja!: string | undefined;
    embarqueId!: number | undefined;

    constructor(data?: IArriboCajasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcionCaja = _data["descripcionCaja"];
            this.embarqueId = _data["embarqueId"];
        }
    }

    static fromJS(data: any): ArriboCajasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArriboCajasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcionCaja"] = this.descripcionCaja;
        data["embarqueId"] = this.embarqueId;
        return data;
    }
}

export interface IArriboCajasUpdateResponse {
    mensaje?: string | undefined;
    exitoso?: boolean;
    descripcionCaja?: string | undefined;
    embarqueId?: number;
}

export class ArriboCajasUpdateResponse implements IArriboCajasUpdateResponse {
    mensaje!: string | undefined;
    exitoso!: boolean;
    descripcionCaja!: string | undefined;
    embarqueId!: number;

    constructor(data?: IArriboCajasUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensaje = _data["mensaje"];
            this.exitoso = _data["exitoso"];
            this.descripcionCaja = _data["descripcionCaja"];
            this.embarqueId = _data["embarqueId"];
        }
    }

    static fromJS(data: any): ArriboCajasUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArriboCajasUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mensaje"] = this.mensaje;
        data["exitoso"] = this.exitoso;
        data["descripcionCaja"] = this.descripcionCaja;
        data["embarqueId"] = this.embarqueId;
        return data;
    }
}

// Service Proxy for Arribo de Cajas
@Injectable()
export class ArriboCajasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * GET /api/planes-carga/cajas/Arribo
     * @param descripcionCaja Filtro por descripción de caja (opcional)
     * @param codigoDolly Filtro por código de dolly (opcional)
     * @param programa Filtro por programa (opcional)
     */
    getArriboCajas(descripcionCaja?: string | undefined, codigoDolly?: string | undefined, programa?: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/Arribo";
        url_ = url_.replace(/[?&]$/, "");

        // Agregar parámetros como query parameters
        const params: string[] = [];
        if (descripcionCaja !== undefined && descripcionCaja !== null && descripcionCaja.trim() !== '') {
            params.push(`descripcionCaja=${encodeURIComponent(descripcionCaja)}`);
        }
        if (codigoDolly !== undefined && codigoDolly !== null && codigoDolly.trim() !== '') {
            params.push(`codigoDolly=${encodeURIComponent(codigoDolly)}`);
        }
        if (programa !== undefined && programa !== null && programa.trim() !== '') {
            params.push(`programa=${encodeURIComponent(programa)}`);
        }
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }

        // Crear headers base
        let headers = new HttpHeaders({
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArriboCajas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArriboCajas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetArriboCajas(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            // El endpoint devuelve un array directamente, no un objeto wrapeado
            result200 = Array.isArray(resultData200) ? resultData200 : [];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>([]);
    }

    /**
     * PUT /api/planes-carga/cajas/arribo
     * @param request Request con la descripción de la caja a procesar
     */
    putArriboCajas(request: ArriboCajasRequest | undefined): Observable<ArriboCajasUpdateResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/arribo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        // Crear headers base
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.put(url_, content_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutArriboCajas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutArriboCajas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArriboCajasUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArriboCajasUpdateResponse>;
        }));
    }

    protected processPutArriboCajas(response: HttpResponseBase): Observable<ArriboCajasUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArriboCajasUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArriboCajasUpdateResponse>(null as any);
    }
}

// DTOs for Descarga de Cajas
export interface IDescargaCajasResponse {
    descripcion?: string | undefined;
    dollys?: DescargaCajasDollyDto[] | undefined;
    programas?: string[] | undefined;
}

export class DescargaCajasResponse implements IDescargaCajasResponse {
    descripcion!: string | undefined;
    dollys!: DescargaCajasDollyDto[] | undefined;
    programas!: string[] | undefined;

    constructor(data?: IDescargaCajasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            if (Array.isArray(_data["dollys"])) {
                this.dollys = [] as any;
                for (let item of _data["dollys"])
                    this.dollys!.push(DescargaCajasDollyDto.fromJS(item));
            }
            if (Array.isArray(_data["programas"])) {
                this.programas = [] as any;
                for (let item of _data["programas"])
                    this.programas!.push(item);
            }
        }
    }

    static fromJS(data: any): DescargaCajasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaCajasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        if (Array.isArray(this.dollys)) {
            data["dollys"] = [];
            for (let item of this.dollys)
                data["dollys"].push(item.toJSON());
        }
        if (Array.isArray(this.programas)) {
            data["programas"] = [];
            for (let item of this.programas)
                data["programas"].push(item);
        }
        return data;
    }
}

export interface IDescargaCajasDollyDto {
    caja?: string | undefined;
    dolly?: string | undefined;
    programas?: string[] | undefined;
}

export class DescargaCajasDollyDto implements IDescargaCajasDollyDto {
    caja!: string | undefined;
    dolly!: string | undefined;
    programas!: string[] | undefined;

    constructor(data?: IDescargaCajasDollyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caja = _data["caja"];
            this.dolly = _data["dolly"];
            if (Array.isArray(_data["programas"])) {
                this.programas = [] as any;
                for (let item of _data["programas"])
                    this.programas!.push(item);
            }
        }
    }

    static fromJS(data: any): DescargaCajasDollyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaCajasDollyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caja"] = this.caja;
        data["dolly"] = this.dolly;
        if (Array.isArray(this.programas)) {
            data["programas"] = [];
            for (let item of this.programas)
                data["programas"].push(item);
        }
        return data;
    }
}

export interface IDescargaCajasRequest {
    numeroCaja?: number | undefined;
}

export class DescargaCajasRequest implements IDescargaCajasRequest {
    numeroCaja!: number | undefined;

    constructor(data?: IDescargaCajasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCaja = _data["numeroCaja"];
        }
    }

    static fromJS(data: any): DescargaCajasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaCajasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCaja"] = this.numeroCaja;
        return data;
    }
}

export interface IDescargaCajasUpdateResponse {
    status?: string | undefined;
    message?: string | undefined;
}

export class DescargaCajasUpdateResponse implements IDescargaCajasUpdateResponse {
    status!: string | undefined;
    message!: string | undefined;

    constructor(data?: IDescargaCajasUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DescargaCajasUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescargaCajasUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

// Service Proxy for Descarga de Cajas
@Injectable()
export class DescargaCajasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * GET /api/planes-carga/cajas/Descarga
     * @param descripcionCaja Filtro por descripción de caja (opcional)
     * @param codigoDolly Filtro por código de dolly (opcional)
     * @param programa Filtro por programa (opcional)
     */
    getDescargaCajas(descripcionCaja?: string | undefined, codigoDolly?: string | undefined, programa?: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/Descarga";
        
        // Agregar query parameters
        const queryParams: string[] = [];
        if (descripcionCaja !== undefined && descripcionCaja !== null && descripcionCaja !== "") {
            queryParams.push("descripcionCaja=" + encodeURIComponent("" + descripcionCaja));
        }
        if (codigoDolly !== undefined && codigoDolly !== null && codigoDolly !== "") {
            queryParams.push("codigoDolly=" + encodeURIComponent("" + codigoDolly));
        }
        if (programa !== undefined && programa !== null && programa !== "") {
            queryParams.push("programa=" + encodeURIComponent("" + programa));
        }
        
        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }
        
        url_ = url_.replace(/[?&]$/, "");

        // Crear headers base
        let headers = new HttpHeaders({
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescargaCajas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescargaCajas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetDescargaCajas(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            // El endpoint devuelve un array directamente, no un objeto wrapeado
            result200 = Array.isArray(resultData200) ? resultData200 : [];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>([]);
    }

    /**
     * PUT /api/planes-carga/cajas/descarga
     * @param request Request con la descripción de la caja a procesar
     */
    putDescargaCajas(request: DescargaCajasRequest | undefined): Observable<DescargaCajasUpdateResponse> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/descarga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        // Crear headers base
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.put(url_, content_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutDescargaCajas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDescargaCajas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescargaCajasUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescargaCajasUpdateResponse>;
        }));
    }

    protected processPutDescargaCajas(response: HttpResponseBase): Observable<DescargaCajasUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DescargaCajasUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DescargaCajasUpdateResponse>(null as any);
    }
}

// Service Proxy for Cajas en Tránsito
@Injectable()
export class TransitoCajasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * GET /api/planes-carga/cajas/Transito
     * @param descripcionCaja Filtro por descripción de caja (opcional)
     * @param codigoDolly Filtro por código de dolly (opcional)
     * @param programa Filtro por programa (opcional)
     */
    getTransitoCajas(descripcionCaja?: string | undefined, codigoDolly?: string | undefined, programa?: string | undefined): Observable<any[]> {
        let url_ = this.baseUrl + "/api/planes-carga/cajas/Transito";
        url_ = url_.replace(/[?&]$/, "");

        // Agregar parámetros de query si existen
        const params: string[] = [];
        if (descripcionCaja !== undefined && descripcionCaja !== null && descripcionCaja !== "")
            params.push("descripcionCaja=" + encodeURIComponent("" + descripcionCaja));
        if (codigoDolly !== undefined && codigoDolly !== null && codigoDolly !== "")
            params.push("codigoDolly=" + encodeURIComponent("" + codigoDolly));
        if (programa !== undefined && programa !== null && programa !== "")
            params.push("programa=" + encodeURIComponent("" + programa));
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }

        // Crear headers base
        let headers = new HttpHeaders({
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransitoCajas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransitoCajas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetTransitoCajas(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            // El endpoint devuelve un array directamente, no un objeto wrapeado
            result200 = Array.isArray(resultData200) ? resultData200 : [];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>([]);
    }
}

// ===== Inventario Zona Cero Response =====

export interface IInventarioZonaCeroResponse {
    produccionDiaria?: number;
    semaforoAbortanUnidades?: ISemaforoResponse;
    semaforoRestoPrograma?: ISemaforoResponse;
    itemsAbortanUnidades?: IInventarioZonaCeroItemResponse[];
    itemsResto?: IInventarioZonaCeroItemResponse[];
    countAbortanUnidades?: number;
    countResto?: number;
}

export class InventarioZonaCeroResponse implements IInventarioZonaCeroResponse {
    produccionDiaria?: number;
    semaforoAbortanUnidades?: SemaforoResponse;
    semaforoRestoPrograma?: SemaforoResponse;
    itemsAbortanUnidades?: InventarioZonaCeroItemResponse[];
    itemsResto?: InventarioZonaCeroItemResponse[];
    countAbortanUnidades?: number;
    countResto?: number;

    constructor(data?: IInventarioZonaCeroResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.produccionDiaria = data["produccionDiaria"];
            this.semaforoAbortanUnidades = data["semaforoAbortanUnidades"] ? SemaforoResponse.fromJS(data["semaforoAbortanUnidades"]) : undefined;
            this.semaforoRestoPrograma = data["semaforoRestoPrograma"] ? SemaforoResponse.fromJS(data["semaforoRestoPrograma"]) : undefined;
            if (Array.isArray(data["itemsAbortanUnidades"])) {
                this.itemsAbortanUnidades = [] as any;
                for (let item of data["itemsAbortanUnidades"])
                    this.itemsAbortanUnidades.push(InventarioZonaCeroItemResponse.fromJS(item));
            }
            if (Array.isArray(data["itemsResto"])) {
                this.itemsResto = [] as any;
                for (let item of data["itemsResto"])
                    this.itemsResto.push(InventarioZonaCeroItemResponse.fromJS(item));
            }
            this.countAbortanUnidades = data["countAbortanUnidades"];
            this.countResto = data["countResto"];
        }
    }

    static fromJS(data: any): InventarioZonaCeroResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventarioZonaCeroResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.produccionDiaria !== undefined)
            data["produccionDiaria"] = this.produccionDiaria;
        if (this.semaforoAbortanUnidades !== undefined)
            data["semaforoAbortanUnidades"] = this.semaforoAbortanUnidades.toJSON();
        if (this.semaforoRestoPrograma !== undefined)
            data["semaforoRestoPrograma"] = this.semaforoRestoPrograma.toJSON();
        if (Array.isArray(this.itemsAbortanUnidades)) {
            data["itemsAbortanUnidades"] = [];
            for (let item of this.itemsAbortanUnidades)
                data["itemsAbortanUnidades"].push(item.toJSON());
        }
        if (Array.isArray(this.itemsResto)) {
            data["itemsResto"] = [];
            for (let item of this.itemsResto)
                data["itemsResto"].push(item.toJSON());
        }
        if (this.countAbortanUnidades !== undefined)
            data["countAbortanUnidades"] = this.countAbortanUnidades;
        if (this.countResto !== undefined)
            data["countResto"] = this.countResto;
        return data;
    }
}

export interface ISemaforoResponse {
    rojo?: number;
    amarillo?: number;
    verde?: number;
}

export class SemaforoResponse implements ISemaforoResponse {
    rojo?: number;
    amarillo?: number;
    verde?: number;

    constructor(data?: ISemaforoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rojo = data["rojo"];
            this.amarillo = data["amarillo"];
            this.verde = data["verde"];
        }
    }

    static fromJS(data: any): SemaforoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SemaforoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rojo !== undefined)
            data["rojo"] = this.rojo;
        if (this.amarillo !== undefined)
            data["amarillo"] = this.amarillo;
        if (this.verde !== undefined)
            data["verde"] = this.verde;
        return data;
    }
}

export interface IInventarioZonaCeroItemResponse {
    fd?: string;
    fd108?: string;
    embarque?: string;
    caja?: string;
    transito?: string;
    arribo?: string;
    descargado?: string;
    secuencias?: string;
    cobertura?: number;
    limiteDollies?: number;
    descargadoColor?: string;
    coberturaColor?: string;
    commodityGrupoId?: number;
}

export class InventarioZonaCeroItemResponse implements IInventarioZonaCeroItemResponse {
    fd?: string;
    fd108?: string;
    embarque?: string;
    caja?: string;
    transito?: string;
    arribo?: string;
    descargado?: string;
    secuencias?: string;
    cobertura?: number;
    limiteDollies?: number;
    descargadoColor?: string;
    coberturaColor?: string;
    commodityGrupoId?: number;

    constructor(data?: IInventarioZonaCeroItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fd = data["fd"];
            this.fd108 = data["fd108"];
            this.embarque = data["embarque"];
            this.caja = data["caja"];
            this.transito = data["transito"];
            this.arribo = data["arribo"];
            this.descargado = data["descargado"];
            this.secuencias = data["secuencias"];
            this.cobertura = data["cobertura"];
            this.limiteDollies = data["limiteDollies"];
            this.descargadoColor = data["descargadoColor"];
            this.coberturaColor = data["coberturaColor"];
            this.commodityGrupoId = data["commodityGrupoId"];
        }
    }

    static fromJS(data: any): InventarioZonaCeroItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventarioZonaCeroItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fd !== undefined)
            data["fd"] = this.fd;
        if (this.fd108 !== undefined)
            data["fd108"] = this.fd108;
        if (this.embarque !== undefined)
            data["embarque"] = this.embarque;
        if (this.caja !== undefined)
            data["caja"] = this.caja;
        if (this.transito !== undefined)
            data["transito"] = this.transito;
        if (this.arribo !== undefined)
            data["arribo"] = this.arribo;
        if (this.descargado !== undefined)
            data["descargado"] = this.descargado;
        if (this.secuencias !== undefined)
            data["secuencias"] = this.secuencias;
        if (this.cobertura !== undefined)
            data["cobertura"] = this.cobertura;
        if (this.limiteDollies !== undefined)
            data["limiteDollies"] = this.limiteDollies;
        if (this.descargadoColor !== undefined)
            data["descargadoColor"] = this.descargadoColor;
        if (this.coberturaColor !== undefined)
            data["coberturaColor"] = this.coberturaColor;
        if (this.commodityGrupoId !== undefined)
            data["commodityGrupoId"] = this.commodityGrupoId;
        return data;
    }
}

@Injectable()
export class ComandaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Obtiene la lista de comandas con filtros y paginación
     * @param pageNumber Número de página (1-based)
     * @param pageSize Tamaño de página
     * @param estado Estado de la comanda (opcional)
     * @param fechaDesde Fecha desde (opcional)
     * @param fechaHasta Fecha hasta (opcional)
     * @param sorting Ordenamiento (opcional)
     * @param numeroParte Filtro por número de parte (opcional)
     * @returns Observable con la respuesta paginada
     */
    getComandas(
        pageNumber?: number | undefined,
        pageSize?: number | undefined,
        estado?: string[] | undefined,  // CAMBIADO: Ahora recibe array
        fechaDesde?: moment.Moment | undefined,
        fechaHasta?: moment.Moment | undefined,
        sorting?: string | undefined,
        numeroParte?: string | undefined,
        localizacion?: string | undefined,
        area?: string | undefined,
        almacen?: string | undefined
    ): Observable<ComandaPagedResultDto> {
        let url_ = this.baseUrl + "/api/comandas?";
        
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
            
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
            
        // CAMBIADO: Procesar array de estados
        if (estado !== undefined && estado !== null && estado.length > 0) {
            // Opción 1: Enviar como string separado por comas
            url_ += "estado=" + encodeURIComponent(estado.join(',')) + "&";
            // Opción 2 alternativa: Múltiples parámetros estado
            // estados.forEach(estado => url_ += "estado=" + encodeURIComponent(estado) + "&");
        }
            
        if (fechaDesde !== undefined && fechaDesde !== null)
            url_ += "fechaDesde=" + encodeURIComponent(fechaDesde ? "" + fechaDesde.toISOString() : "") + "&";
            
        if (fechaHasta !== undefined && fechaHasta !== null)
            url_ += "fechaHasta=" + encodeURIComponent(fechaHasta ? "" + fechaHasta.toISOString() : "") + "&";
            
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
            
        if (numeroParte !== undefined && numeroParte !== null)
            url_ += "numeroParte=" + encodeURIComponent("" + numeroParte) + "&";
            
        if (localizacion !== undefined && localizacion !== null)
            url_ += "localizacion=" + encodeURIComponent("" + localizacion) + "&";
            
        if (area !== undefined && area !== null)
            url_ += "area=" + encodeURIComponent("" + area) + "&";
            
        if (almacen !== undefined && almacen !== null)
            url_ += "almacen=" + encodeURIComponent("" + almacen) + "&";
            
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetComandas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComandas(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processGetComandas(response: HttpResponseBase): Observable<ComandaPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ComandaPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crea una nueva comanda
     * @param input Datos de la nueva comanda
     * @returns Observable con el resultado
     */
    createComanda(input: CreateComandaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/comandas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComanda(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processCreateComanda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    protected blobToText(blob: any): Observable<string> {
        return new Observable<string>((observer: any) => {
            if (!blob) {
                observer.next("");
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        });
    }

    protected throwException(message: string, status: number, response: string, headers: { [key: string]: any; }): Observable<any> {
        if (response && response.length > 0) {
            const error = JSON.parse(response);
            return _observableThrow(error);
        } else {
            return _observableThrow(new Error(message));
        }
    }

    /**
     * Actualiza el estado de una comanda (atender/embarque)
     * @param input Datos para actualizar el estado
     * @returns Observable con el resultado
     */
    updateComandaStatus(input: UpdateComandaStatusInput): Observable<UpdateComandaStatusResponse> {
        let url_ = this.baseUrl + "/api/comandas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateComandaStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComandaStatus(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processUpdateComandaStatus(response: HttpResponseBase): Observable<UpdateComandaStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateComandaStatusResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    // Método para revertir estado de comanda
    revertirComanda(comandaId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/comandas/revertir";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ comandaId: comandaId });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRevertirComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevertirComanda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevertirComanda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 204) {
            return _observableOf(null as any);
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    // Método para exportar comandas
    exportComandas(estados?: string[] | undefined, numeroParte?: string | undefined, localizacion?: string | undefined, area?: string | undefined, fechaDesde?: moment.Moment | undefined, fechaHasta?: moment.Moment | undefined, almacen?: string | undefined, filter?: string | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/comandas/exportar";
        url_ = url_.replace(/[?&]$/, "");

        // Agregar parámetros como query string
        let params: string[] = [];
        // CAMBIADO: Procesar array de estados
        if (estados !== undefined && estados !== null && estados.length > 0)
            params.push("estado=" + encodeURIComponent(estados.join(',')));
        if (numeroParte !== undefined && numeroParte !== null)
            params.push("numeroParte=" + encodeURIComponent("" + numeroParte));
        if (localizacion !== undefined && localizacion !== null)
            params.push("localizacion=" + encodeURIComponent("" + localizacion));
        if (area !== undefined && area !== null)
            params.push("area=" + encodeURIComponent("" + area));
        if (almacen !== undefined && almacen !== null)
            params.push("almacen=" + encodeURIComponent("" + almacen));
        if (fechaDesde !== undefined && fechaDesde !== null)
            params.push("fechaDesde=" + encodeURIComponent(fechaDesde.toISOString()));
        if (fechaHasta !== undefined && fechaHasta !== null)
            params.push("fechaHasta=" + encodeURIComponent(fechaHasta.toISOString()));
        if (filter !== undefined && filter !== null)
            params.push("filter=" + encodeURIComponent("" + filter));
        
        if (params.length > 0) {
            url_ += "?" + params.join("&");
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportComandas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportComandas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportComandas(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }

    /**
     * Elimina una comanda
     * @param input Datos para eliminar la comanda
     * @returns Observable con la respuesta de eliminación
     */
    deleteComanda(input: DeleteComandaInput): Observable<DeleteComandaResponse> {
        let url_ = this.baseUrl + "/api/comandas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComanda(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processDeleteComanda(response: HttpResponseBase): Observable<DeleteComandaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        
        if (status === 200) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteComandaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this.blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

// DTOs para Comandas
export class ComandaPagedResultDto implements IComandaPagedResultDto {
    totalCount!: number;
    items!: ComandaDto[] | undefined;

    constructor(data?: IComandaPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ComandaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComandaPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComandaPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComandaPagedResultDto {
    totalCount: number;
    items: ComandaDto[] | undefined;
}

export class ComandaDto implements IComandaDto {
    comandaId!: string;
    numeroParte!: string;
    numeroParteDescr!: string;
    cantidad!: number;
    localizacion!: string;
    estadoComanda!: string;
    tiempoEstimado!: string;
    causa?: string | undefined;
    area?: string | undefined;
    almacen?: string | undefined;
    commodity?: string | undefined;
    cancelarComanda?: boolean | undefined;
    ubicaciones?: UbicacionDto[];

    constructor(data?: IComandaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comandaId = _data["comandaId"];
            this.numeroParte = _data["numeroParte"];
            this.numeroParteDescr = _data["numeroParteDescr"];
            this.cantidad = _data["cantidad"];
            this.localizacion = _data["localizacion"];
            this.estadoComanda = _data["estadoComanda"];
            this.tiempoEstimado = _data["tiempoEstimado"];
            this.causa = _data["causa"];
            this.area = _data["area"];
            this.almacen = _data["almacen"];
            this.commodity = _data["commodity"];
            this.cancelarComanda = _data["cancelarComanda"];
            if (Array.isArray(_data["ubicaciones"])) {
                this.ubicaciones = [] as any;
                for (let item of _data["ubicaciones"])
                    this.ubicaciones!.push(UbicacionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComandaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComandaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comandaId"] = this.comandaId;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["localizacion"] = this.localizacion;
        data["estadoComanda"] = this.estadoComanda;
        data["tiempoEstimado"] = this.tiempoEstimado;
        data["causa"] = this.causa;
        data["area"] = this.area;
        data["almacen"] = this.almacen;
        data["commodity"] = this.commodity;
        data["cancelarComanda"] = this.cancelarComanda;
        if (Array.isArray(this.ubicaciones)) {
            data["ubicaciones"] = [];
            for (let item of this.ubicaciones)
                data["ubicaciones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComandaDto {
    comandaId: string;
    numeroParte: string;
    numeroParteDescr: string;
    cantidad: number;
    localizacion: string;
    estadoComanda: string;
    tiempoEstimado: string;
    causa?: string | undefined;
    area?: string | undefined;
    almacen?: string | undefined;
    commodity?: string | undefined;
    cancelarComanda?: boolean | undefined;
    ubicaciones?: UbicacionDto[] | undefined;
}

export class CreateComandaInput implements ICreateComandaInput {
    comandaId!: string;
    numeroParte!: string;
    cantidad!: number;
    causa?: string | undefined;
    area?: string | undefined;
    chassis?: string | undefined;
    secuencia?: string | undefined;

    constructor(data?: ICreateComandaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comandaId = _data["comandaId"];
            this.numeroParte = _data["numeroParte"];
            this.cantidad = _data["cantidad"];
            this.causa = _data["causa"];
            this.area = _data["area"];
            this.chassis = _data["chassis"];
            this.secuencia = _data["secuencia"];
        }
    }

    static fromJS(data: any): CreateComandaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComandaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comandaId"] = this.comandaId;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["causa"] = this.causa;
        data["area"] = this.area;
        data["chassis"] = this.chassis;
        data["secuencia"] = this.secuencia;
        return data;
    }
}

export interface ICreateComandaInput {
    comandaId: string;
    numeroParte: string;
    cantidad: number;
    causa?: string | undefined;
    area?: string | undefined;
    chassis?: string | undefined;
    secuencia?: string | undefined;
}

// DTOs para actualización de estado de comanda
export class UpdateComandaStatusInput implements IUpdateComandaStatusInput {
    comandaId!: string;
    modo!: string;
    wip?: string | undefined;
    comentario?: string | undefined;

    constructor(data?: IUpdateComandaStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comandaId = _data["comandaId"];
            this.modo = _data["modo"];
            this.wip = _data["wip"];
            this.comentario = _data["comentario"];
        }
    }

    static fromJS(data: any): UpdateComandaStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComandaStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comandaId"] = this.comandaId;
        data["modo"] = this.modo;
        data["wip"] = this.wip;
        data["comentario"] = this.comentario;
        return data;
    }
}

export interface IUpdateComandaStatusInput {
    comandaId: string;
    modo: string;
    wip?: string | undefined;
    comentario?: string | undefined;
}

export class UpdateComandaStatusResponse implements IUpdateComandaStatusResponse {
    success!: boolean;
    message!: string;
    comandaId!: number;
    estadoComanda!: string;
    fechaActualizacion!: moment.Moment;

    constructor(data?: IUpdateComandaStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.comandaId = _data["comandaId"];
            this.estadoComanda = _data["estadoComanda"];
            this.fechaActualizacion = _data["fechaActualizacion"] ? moment(_data["fechaActualizacion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateComandaStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComandaStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["comandaId"] = this.comandaId;
        data["estadoComanda"] = this.estadoComanda;
        data["fechaActualizacion"] = this.fechaActualizacion ? this.fechaActualizacion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateComandaStatusResponse {
    success: boolean;
    message: string;
    comandaId: number;
    estadoComanda: string;
    fechaActualizacion: moment.Moment;
}

// DTOs para eliminación de comanda
export class DeleteComandaInput implements IDeleteComandaInput {
    comandaId!: string;

    constructor(data?: IDeleteComandaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comandaId = _data["comandaId"];
        }
    }

    static fromJS(data: any): DeleteComandaInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteComandaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comandaId"] = this.comandaId;
        return data;
    }
}

export interface IDeleteComandaInput {
    comandaId: string;
}

export class DeleteComandaResponse implements IDeleteComandaResponse {
    success!: boolean;
    message!: string;
    comandaId!: string;

    constructor(data?: IDeleteComandaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.comandaId = _data["comandaId"];
        }
    }

    static fromJS(data: any): DeleteComandaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteComandaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["comandaId"] = this.comandaId;
        return data;
    }
}

export interface IDeleteComandaResponse {
    success: boolean;
    message: string;
    comandaId: string;
}


// Interfaces para carga de archivos de inventario general
export interface IInventarioGeneralImportResult {
    success: boolean;
    message: string | undefined;
    errorDetails: string | undefined;
    processedRecords: number;
    headerValidationPassed: boolean;
}

export class InventarioGeneralImportResult implements IInventarioGeneralImportResult {
    success!: boolean;
    message!: string | undefined;
    errorDetails!: string | undefined;
    processedRecords!: number;
    headerValidationPassed!: boolean;

    constructor(data?: IInventarioGeneralImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.errorDetails = _data["errorDetails"];
            this.processedRecords = _data["processedRecords"];
            this.headerValidationPassed = _data["headerValidationPassed"];
        }
    }

    static fromJS(data: any): InventarioGeneralImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new InventarioGeneralImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["errorDetails"] = this.errorDetails;
        data["processedRecords"] = this.processedRecords;
        data["headerValidationPassed"] = this.headerValidationPassed;
        return data;
    }
}

// Interface para respuesta específica del endpoint 401
export interface IArchivo401ImportResult {
    message: string | undefined;
    uniqueCode: string | undefined;
    processStartTime: Date;
    success: boolean;
}

export class Archivo401ImportResult implements IArchivo401ImportResult {
    message!: string | undefined;
    uniqueCode!: string | undefined;
    processStartTime!: Date;
    success!: boolean;

    constructor(data?: IArchivo401ImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.uniqueCode = _data["uniqueCode"];
            this.processStartTime = _data["processStartTime"] ? new Date(_data["processStartTime"].toString()) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Archivo401ImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new Archivo401ImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["uniqueCode"] = this.uniqueCode;
        data["processStartTime"] = this.processStartTime ? this.processStartTime.toISOString() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

// Interface para respuesta del endpoint lastUpdates
export interface ILastUpdatesResultDto {
    success: boolean;
    errorMessage?: string;
    fechaAlertasNumeroPartes?: Date;
    fechaInventarioGeneral?: Date;
    fechaInventarioProveedores?: Date;
    fechaLocacionDestino?: Date;
}

export class LastUpdatesResultDto implements ILastUpdatesResultDto {
    success!: boolean;
    errorMessage?: string | undefined;
    fechaAlertasNumeroPartes?: Date | undefined;
    fechaInventarioGeneral?: Date | undefined;
    fechaInventarioProveedores?: Date | undefined;
    fechaLocacionDestino?: Date | undefined;

    constructor(data?: ILastUpdatesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.fechaAlertasNumeroPartes = _data["fechaAlertasNumeroPartes"] ? new Date(_data["fechaAlertasNumeroPartes"].toString()) : <any>undefined;
            this.fechaInventarioGeneral = _data["fechaInventarioGeneral"] ? new Date(_data["fechaInventarioGeneral"].toString()) : <any>undefined;
            this.fechaInventarioProveedores = _data["fechaInventarioProveedores"] ? new Date(_data["fechaInventarioProveedores"].toString()) : <any>undefined;
            this.fechaLocacionDestino = _data["fechaLocacionDestino"] ? new Date(_data["fechaLocacionDestino"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LastUpdatesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastUpdatesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["fechaAlertasNumeroPartes"] = this.fechaAlertasNumeroPartes ? this.fechaAlertasNumeroPartes.toISOString() : <any>undefined;
        data["fechaInventarioGeneral"] = this.fechaInventarioGeneral ? this.fechaInventarioGeneral.toISOString() : <any>undefined;
        data["fechaInventarioProveedores"] = this.fechaInventarioProveedores ? this.fechaInventarioProveedores.toISOString() : <any>undefined;
        data["fechaLocacionDestino"] = this.fechaLocacionDestino ? this.fechaLocacionDestino.toISOString() : <any>undefined;
        return data;
    }
}

// Servicio proxy para carga de archivos de inventario general
@Injectable()
export class InventarioGeneralServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    // POST /api/inventariogeneral/AlertasNumeroPartes/carga
    uploadAlertasNumeroPartes(base64Content: string, fileName: string): Observable<InventarioGeneralImportResult> {
        let url_ = this.baseUrl + "/api/inventariogeneral/AlertasNumeroPartes/carga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000 // 20 minutos para archivos grandes
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInventarioGeneralResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventarioGeneralResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventarioGeneralImportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventarioGeneralImportResult>;
        }));
    }

    // POST /api/inventariogeneral/401/carga
    upload401(base64Content: string, fileName: string): Observable<Archivo401ImportResult> {
        let url_ = this.baseUrl + "/api/inventariogeneral/401/carga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000 // 20 minutos para archivos grandes
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.process401Response(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process401Response(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Archivo401ImportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Archivo401ImportResult>;
        }));
    }

    // POST /api/inventariogeneral/locacionDestino/carga
    uploadLocacionDestino(base64Content: string, fileName: string): Observable<InventarioGeneralImportResult> {
        let url_ = this.baseUrl + "/api/inventariogeneral/locacionDestino/carga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000 // 20 minutos para archivos grandes
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInventarioGeneralResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventarioGeneralResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventarioGeneralImportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventarioGeneralImportResult>;
        }));
    }

    // POST /api/inventariogeneral/InventarioGeneral/carga
    uploadInventarioGeneral(base64Content: string, fileName: string): Observable<InventarioGeneralImportResult> {
        let url_ = this.baseUrl + "/api/inventariogeneral/InventarioGeneral/carga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000 // 20 minutos para archivos grandes
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInventarioGeneralResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventarioGeneralResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventarioGeneralImportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventarioGeneralImportResult>;
        }));
    }

    // GET /api/inventariogeneral/lastUpdates
    getLastUpdates(): Observable<LastUpdatesResultDto> {
        let url_ = this.baseUrl + "/api/inventariogeneral/lastUpdates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLastUpdatesResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLastUpdatesResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastUpdatesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastUpdatesResultDto>;
        }));
    }

    // Procesadores de respuesta
    protected processInventarioGeneralResponse(response: HttpResponseBase): Observable<InventarioGeneralImportResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? InventarioGeneralImportResult.fromJS(resultData200) : new InventarioGeneralImportResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventarioGeneralImportResult>(<any>null);
    }

    protected process401Response(response: HttpResponseBase): Observable<Archivo401ImportResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? Archivo401ImportResult.fromJS(resultData200) : new Archivo401ImportResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Archivo401ImportResult>(<any>null);
    }

    protected processLastUpdatesResponse(response: HttpResponseBase): Observable<LastUpdatesResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LastUpdatesResultDto.fromJS(resultData200) : new LastUpdatesResultDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastUpdatesResultDto>(<any>null);
    }
}

// ===== PARTES EN RECUPERACION =====

@Injectable()
export class PartesRecuperacionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    /**
     * GET /api/partesenrecuperacion
     * @param numeroParte Filtro por número de parte (opcional)
     * @param usuario Filtro por usuario (opcional)
     */
    getPartesEnRecuperacion(numeroParte?: string | undefined, usuario?: string | undefined): Observable<PartesEnRecuperacionResponse> {
        let url_ = this.baseUrl + "/api/partesenrecuperacion";
        
        // Agregar query parameters
        const queryParams: string[] = [];
        if (numeroParte !== undefined && numeroParte !== null && numeroParte !== "") {
            queryParams.push("NumeroParte=" + encodeURIComponent("" + numeroParte));
        }
        if (usuario !== undefined && usuario !== null && usuario !== "") {
            queryParams.push("Usuario=" + encodeURIComponent("" + usuario));
        }
        
        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }
        
        url_ = url_.replace(/[?&]$/, "");

        // Crear headers base
        let headers = new HttpHeaders({
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartesEnRecuperacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartesEnRecuperacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartesEnRecuperacionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartesEnRecuperacionResponse>;
        }));
    }

    protected processGetPartesEnRecuperacion(response: HttpResponseBase): Observable<PartesEnRecuperacionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartesEnRecuperacionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartesEnRecuperacionResponse>(<any>null);
    }

    /**
     * PUT /api/partesenrecuperacion
     * @param request Request con el ID de la parte a reiniciar
     */
    putPartesEnRecuperacion(request: ReiniciarParteRequest | undefined): Observable<ReiniciarParteResponse> {
        let url_ = this.baseUrl + "/api/partesenrecuperacion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        // Crear headers base
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.put(url_, content_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutPartesEnRecuperacion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPartesEnRecuperacion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReiniciarParteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReiniciarParteResponse>;
        }));
    }

    protected processPutPartesEnRecuperacion(response: HttpResponseBase): Observable<ReiniciarParteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReiniciarParteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReiniciarParteResponse>(<any>null);
    }
}

// DTOs and Interfaces for Partes en Recuperacion

export interface IPartesEnRecuperacionResponse {
    partesEnRecuperacion?: ParteEnRecuperacionItem[] | undefined;
    totalCount?: number;
    success?: boolean;
    message?: string | undefined;
}

export interface IParteEnRecuperacionItem {
    parteEnRecuperacionId?: number;
    numeroParte?: string | undefined;
    secuencia?: string | undefined;
    tenantId?: number;
    usuarioRegistroId?: number;
    nombreUsuario?: string | undefined;
    fechaRegistro?: Date;
    isActive?: boolean;
}

export interface IReiniciarParteRequest {
    id?: number;
}

export interface IReiniciarParteResponse {
    success?: boolean;
    message?: string | undefined;
}

export class PartesEnRecuperacionResponse implements IPartesEnRecuperacionResponse {
    partesEnRecuperacion?: ParteEnRecuperacionItem[] | undefined;
    totalCount?: number;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IPartesEnRecuperacionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partesEnRecuperacion"])) {
                this.partesEnRecuperacion = [] as any;
                for (let item of _data["partesEnRecuperacion"])
                    this.partesEnRecuperacion!.push(ParteEnRecuperacionItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PartesEnRecuperacionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartesEnRecuperacionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partesEnRecuperacion)) {
            data["partesEnRecuperacion"] = [];
            for (let item of this.partesEnRecuperacion)
                data["partesEnRecuperacion"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export class ParteEnRecuperacionItem implements IParteEnRecuperacionItem {
    parteEnRecuperacionId?: number;
    numeroParte?: string | undefined;
    secuencia?: string | undefined;
    tenantId?: number;
    usuarioRegistroId?: number;
    nombreUsuario?: string | undefined;
    fechaRegistro?: Date;
    isActive?: boolean;

    constructor(data?: IParteEnRecuperacionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parteEnRecuperacionId = _data["parteEnRecuperacionId"];
            this.numeroParte = _data["numeroParte"];
            this.secuencia = _data["secuencia"];
            this.tenantId = _data["tenantId"];
            this.usuarioRegistroId = _data["usuarioRegistroId"];
            this.nombreUsuario = _data["nombreUsuario"];
            this.fechaRegistro = _data["fechaRegistro"] ? new Date(_data["fechaRegistro"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ParteEnRecuperacionItem {
        data = typeof data === 'object' ? data : {};
        let result = new ParteEnRecuperacionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parteEnRecuperacionId"] = this.parteEnRecuperacionId;
        data["numeroParte"] = this.numeroParte;
        data["secuencia"] = this.secuencia;
        data["tenantId"] = this.tenantId;
        data["usuarioRegistroId"] = this.usuarioRegistroId;
        data["nombreUsuario"] = this.nombreUsuario;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class ReiniciarParteRequest implements IReiniciarParteRequest {
    id?: number;

    constructor(data?: IReiniciarParteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReiniciarParteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReiniciarParteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export class ReiniciarParteResponse implements IReiniciarParteResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IReiniciarParteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReiniciarParteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReiniciarParteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

@Injectable()
export class CargaInventarioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    uploadCargaInventarioFile(base64Content: string, fileName: string): Observable<CargaInventarioUploadResultDto> {
        let url_ = this.baseUrl + "/api/carga-inventario/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCargaInventarioFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCargaInventarioFile(<any>response_);
                } catch (e) {
                    return <Observable<CargaInventarioUploadResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CargaInventarioUploadResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCargaInventarioFile(response: HttpResponseBase): Observable<CargaInventarioUploadResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CargaInventarioUploadResultDto.fromJS(resultData200) : new CargaInventarioUploadResultDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CargaInventarioUploadResultDto>(<any>null);
    }
}

@Injectable()
export class CargaSICServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    uploadCargaSICFile(base64Content: string, fileName: string): Observable<CargaSICUploadResultDto> {
        let url_ = this.baseUrl + "/api/carga-sic/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ 
            base64: base64Content,
            fileName: fileName
        });

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            timeout: 1200000
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCargaSICFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCargaSICFile(<any>response_);
                } catch (e) {
                    return <Observable<CargaSICUploadResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CargaSICUploadResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCargaSICFile(response: HttpResponseBase): Observable<CargaSICUploadResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; 
        if (response.headers) { 
            for (let key of response.headers.keys()) { 
                _headers[key] = response.headers.get(key); 
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CargaSICUploadResultDto.fromJS(resultData200) : new CargaSICUploadResultDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CargaSICUploadResultDto>(<any>null);
    }
}

export class CargaInventarioUploadResultDto implements ICargaInventarioUploadResultDto {
    success!: boolean;
    message!: string | undefined;
    errorDetails!: string | undefined;
    totalRecords!: number;
    processedRecords!: number;
    errorRecords!: number;
    errors!: string[] | undefined;
    warnings!: string[] | undefined;

    constructor(data?: ICargaInventarioUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.errorDetails = _data["errorDetails"];
            this.totalRecords = _data["totalRecords"];
            this.processedRecords = _data["processedRecords"];
            this.errorRecords = _data["errorRecords"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): CargaInventarioUploadResultDto {
        data = typeof data === "object" ? data : {};
        let result = new CargaInventarioUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["errorDetails"] = this.errorDetails;
        data["totalRecords"] = this.totalRecords;
        data["processedRecords"] = this.processedRecords;
        data["errorRecords"] = this.errorRecords;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface ICargaInventarioUploadResultDto {
    success: boolean;
    message: string | undefined;
    errorDetails: string | undefined;
    totalRecords: number;
    processedRecords: number;
    errorRecords: number;
    errors: string[] | undefined;
    warnings: string[] | undefined;
}

export class CargaSICUploadResultDto implements ICargaSICUploadResultDto {
    success!: boolean;
    message!: string | undefined;
    errorDetails!: string | undefined;
    totalRecords!: number;
    processedRecords!: number;
    errorRecords!: number;
    errors!: string[] | undefined;
    warnings!: string[] | undefined;

    constructor(data?: ICargaSICUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.errorDetails = _data["errorDetails"];
            this.totalRecords = _data["totalRecords"];
            this.processedRecords = _data["processedRecords"];
            this.errorRecords = _data["errorRecords"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): CargaSICUploadResultDto {
        data = typeof data === "object" ? data : {};
        let result = new CargaSICUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["errorDetails"] = this.errorDetails;
        data["totalRecords"] = this.totalRecords;
        data["processedRecords"] = this.processedRecords;
        data["errorRecords"] = this.errorRecords;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface ICargaSICUploadResultDto {
    success: boolean;
    message: string | undefined;
    errorDetails: string | undefined;
    totalRecords: number;
    processedRecords: number;
    errorRecords: number;
    errors: string[] | undefined;
    warnings: string[] | undefined;
}

// ConfigPickList Service Proxy
@Injectable()
export class ConfigPickListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getConfigList(pageNumber: number | undefined, pageSize: number | undefined, sorting: string | undefined, filter: string | undefined, descripcion: string | undefined, wip: string | undefined, ordenPorCommodity: boolean | undefined, ultimaSecuenciaCargada: string | undefined, modelo: string | undefined): Observable<PagedResultDtoOfConfigPickListForListResponse> {
        let url_ = this.baseUrl + "/api/PickList/GetList/config?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (descripcion !== undefined)
            url_ += "Descripcion=" + encodeURIComponent("" + descripcion) + "&";
        if (wip !== undefined)
            url_ += "WIP=" + encodeURIComponent("" + wip) + "&";
        if (ordenPorCommodity !== undefined)
            url_ += "OrdenPorCommodity=" + encodeURIComponent("" + ordenPorCommodity) + "&";
        if (ultimaSecuenciaCargada !== undefined)
            url_ += "UltimaSecuenciaCargada=" + encodeURIComponent("" + ultimaSecuenciaCargada) + "&";
        if (modelo !== undefined)
            url_ += "Modelo=" + encodeURIComponent("" + modelo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfConfigPickListForListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfConfigPickListForListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfigList(response: HttpResponseBase): Observable<PagedResultDtoOfConfigPickListForListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            // Handle the result wrapper from API response
            const actualData = resultData200?.result || resultData200;
            result200 = PagedResultDtoOfConfigPickListForListResponse.fromJS(actualData);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfConfigPickListForListResponse>(<any>null);
    }

    /**
     * @param command (optional) 
     * @return Success
     */
    createConfig(command: CreateConfigPickListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PickList/Create/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id 
     * @param command (optional) 
     * @return Success
     */
    updateConfig(id: number, command: UpdateConfigPickListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PickList/Update/config/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id 
     * @return Success
     */
    deleteConfig(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PickList/Delete/config/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id 
     * @param command (optional) 
     * @return Success
     */
    toggleCoordinates(id: number, command: ToggleCoordinatesConfigPickListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PickList/ToggleCoordinates/config/{id}/toggle-coordinates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleCoordinates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleCoordinates(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processToggleCoordinates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param importRequest (optional) 
     * @return Success
     */
    importConfigPickList(importRequest: ImportConfigPickListRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PickList/ImportConfigPickList/config/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportConfigPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportConfigPickList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportConfigPickList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param exportRequest (optional) 
     * @return Success
     */
    exportConfigPickList(exportRequest: ExportConfigPickListRequest | undefined): Observable<Blob> {
        let url_ = this.baseUrl + "/api/PickList/ExportConfigPickList/config/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportConfigPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportConfigPickList(<any>response_);
                } catch (e) {
                    return <Observable<Blob>><any>_observableThrow(e);
                }
            } else
                return <Observable<Blob>><any>_observableThrow(response_);
        }));
    }

    protected processExportConfigPickList(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(<any>null);
    }
}

// DTOs for ConfigPickList
export class PagedResultDtoOfConfigPickListForListResponse implements IPagedResultDtoOfConfigPickListForListResponse {
    totalCount!: number;
    items!: ConfigPickListForListResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfConfigPickListForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConfigPickListForListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfConfigPickListForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfConfigPickListForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfConfigPickListForListResponse {
    totalCount: number;
    items: ConfigPickListForListResponse[] | undefined;
}

export class ConfigPickListForListResponse implements IConfigPickListForListResponse {
    id!: number;
    descripcion!: string | undefined;
    wip!: string | undefined;
    ordenPorCommodity!: boolean;
    ultimaSecuenciaCargada!: string | undefined;
    modelo!: string | undefined;
    userName!: string | undefined;
    registerDate!: moment.Moment;
    isActive!: boolean;

    constructor(data?: IConfigPickListForListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.wip = _data["wip"];
            this.ordenPorCommodity = _data["ordenPorCommodity"];
            this.ultimaSecuenciaCargada = _data["ultimaSecuenciaCargada"];
            this.modelo = _data["modelo"];
            this.userName = _data["userName"];
            this.registerDate = _data["registerDate"] ? moment(_data["registerDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ConfigPickListForListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigPickListForListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["wip"] = this.wip;
        data["ordenPorCommodity"] = this.ordenPorCommodity;
        data["ultimaSecuenciaCargada"] = this.ultimaSecuenciaCargada;
        data["modelo"] = this.modelo;
        data["userName"] = this.userName;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IConfigPickListForListResponse {
    id: number;
    descripcion: string | undefined;
    wip: string | undefined;
    ordenPorCommodity: boolean;
    ultimaSecuenciaCargada: string | undefined;
    modelo: string | undefined;
    userName: string | undefined;
    registerDate: moment.Moment;
    isActive: boolean;
}

export class CreateConfigPickListCommand implements ICreateConfigPickListCommand {
    descripcion!: string | undefined;
    wip!: string | undefined;
    ordenPorCommodity!: boolean;

    constructor(data?: ICreateConfigPickListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descripcion = _data["descripcion"];
            this.wip = _data["wip"];
            this.ordenPorCommodity = _data["ordenPorCommodity"];
        }
    }

    static fromJS(data: any): CreateConfigPickListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigPickListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descripcion"] = this.descripcion;
        data["wip"] = this.wip;
        data["ordenPorCommodity"] = this.ordenPorCommodity;
        return data;
    }
}

export interface ICreateConfigPickListCommand {
    descripcion: string | undefined;
    wip: string | undefined;
    ordenPorCommodity: boolean;
}

export class UpdateConfigPickListCommand implements IUpdateConfigPickListCommand {
    id!: number;
    descripcion!: string | undefined;
    wip!: string | undefined;
    ordenPorCommodity!: boolean;

    constructor(data?: IUpdateConfigPickListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descripcion = _data["descripcion"];
            this.wip = _data["wip"];
            this.ordenPorCommodity = _data["ordenPorCommodity"];
        }
    }

    static fromJS(data: any): UpdateConfigPickListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigPickListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descripcion"] = this.descripcion;
        data["wip"] = this.wip;
        data["ordenPorCommodity"] = this.ordenPorCommodity;
        return data;
    }
}

export interface IUpdateConfigPickListCommand {
    id: number;
    descripcion: string | undefined;
    wip: string | undefined;
    ordenPorCommodity: boolean;
}

export class ToggleCoordinatesConfigPickListCommand implements IToggleCoordinatesConfigPickListCommand {
    id!: number;
    ordenPorCommodity!: boolean;

    constructor(data?: IToggleCoordinatesConfigPickListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ordenPorCommodity = _data["ordenPorCommodity"];
        }
    }

    static fromJS(data: any): ToggleCoordinatesConfigPickListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleCoordinatesConfigPickListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordenPorCommodity"] = this.ordenPorCommodity;
        return data;
    }
}

export interface IToggleCoordinatesConfigPickListCommand {
    id: number;
    ordenPorCommodity: boolean;
}

export class ImportConfigPickListRequest implements IImportConfigPickListRequest {
    base64!: string | undefined;
    fileName!: string | undefined;

    constructor(data?: IImportConfigPickListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ImportConfigPickListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportConfigPickListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IImportConfigPickListRequest {
    base64: string | undefined;
    fileName: string | undefined;
}

export class ExportConfigPickListRequest implements IExportConfigPickListRequest {
    filter!: string | undefined;

    constructor(data?: IExportConfigPickListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ExportConfigPickListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportConfigPickListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IExportConfigPickListRequest {
    filter: string | undefined;
}

@Injectable()
export class PlanTrabajoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:63197";
    }

    getPlanTrabajo(): Observable<IPlanTrabajoResponse> {
        let url_ = this.baseUrl + "/api/plan-trabajo";
        url_ = url_.replace(/[?&]$/, "");
        
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlanTrabajo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanTrabajo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanTrabajoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanTrabajoResponse>;
        }));
    }

    getConfig(): Observable<IPlanTrabajoConfigResponse> {
        let url_ = this.baseUrl + "/api/plan-trabajo/config";
        url_ = url_.replace(/[?&]$/, "");
        
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanTrabajoConfigResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanTrabajoConfigResponse>;
        }));
    }

    saveConfig(config: PlanTrabajoConfigDto): Observable<IPlanTrabajoConfigSaveResponse> {
        let url_ = this.baseUrl + "/api/plan-trabajo/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanTrabajoConfigSaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanTrabajoConfigSaveResponse>;
        }));
    }

    protected processGetPlanTrabajo(response: HttpResponseBase): Observable<IPlanTrabajoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanTrabajoResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IPlanTrabajoResponse>(null as any);
    }

    protected processGetConfig(response: HttpResponseBase): Observable<IPlanTrabajoConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanTrabajoConfigResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IPlanTrabajoConfigResponse>(null as any);
    }

    protected processSaveConfig(response: HttpResponseBase): Observable<IPlanTrabajoConfigSaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlanTrabajoConfigSaveResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IPlanTrabajoConfigSaveResponse>(null as any);
    }

    exportPlanTrabajo(query?: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/plan-trabajo/export";
        
        // Agregar parámetros de query si se proporcionan
        if (query) {
            const queryParams = new URLSearchParams();
            Object.keys(query).forEach(key => {
                if (query[key] !== null && query[key] !== undefined) {
                    queryParams.append(key, query[key]);
                }
            });
            if (queryParams.toString()) {
                url_ += "?" + queryParams.toString();
            }
        }
        
        url_ = url_.replace(/[?&]$/, "");
        
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPlanTrabajo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPlanTrabajo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportPlanTrabajo(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

export class PlanTrabajoResponse implements IPlanTrabajoResponse {
    success!: boolean;
    data!: PlanTrabajoData;
    message!: string;

    constructor(data?: IPlanTrabajoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.data = data["data"] ? PlanTrabajoData.fromJS(data["data"]) : <any>undefined;
            this.message = data["message"];
        }
    }

    static fromJS(data: any): PlanTrabajoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlanTrabajoResponse {
    success: boolean;
    data: PlanTrabajoData;
    message: string;
}

export class PlanTrabajoData implements IPlanTrabajoData {
    secuencias!: SecuenciasDiaData[];
    modelos!: ModelosDiaData[];

    constructor(data?: IPlanTrabajoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["secuencias"])) {
                this.secuencias = [] as any;
                for (let item of data["secuencias"])
                    this.secuencias!.push(SecuenciasDiaData.fromJS(item));
            }
            if (Array.isArray(data["modelos"])) {
                this.modelos = [] as any;
                for (let item of data["modelos"])
                    this.modelos!.push(ModelosDiaData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanTrabajoData {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secuencias)) {
            data["secuencias"] = [];
            for (let item of this.secuencias)
                data["secuencias"].push(item.toJSON());
        }
        if (Array.isArray(this.modelos)) {
            data["modelos"] = [];
            for (let item of this.modelos)
                data["modelos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanTrabajoData {
    secuencias: SecuenciasDiaData[];
    modelos: ModelosDiaData[];
}

export class SecuenciasDiaData implements ISecuenciasDiaData {
    dia!: string;
    inicioTrimPB!: string | undefined;
    finTrimPB!: string | undefined;
    inicioConsolas!: string | undefined;
    finConsolas!: string | undefined;
    inicioCabinas!: string | undefined;
    finCabinas!: string | undefined;
    inicioFaldon!: string | undefined;
    finFaldon!: string | undefined;
    inicioPreparacion!: string | undefined;
    finPreparacion!: string | undefined;
    inicioKitCobre!: string | undefined;
    finKitCobre!: string | undefined;
    inicioTransmision!: string | undefined;
    finTransmision!: string | undefined;

    constructor(data?: ISecuenciasDiaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dia = data["dia"];
            this.inicioTrimPB = data["inicioTrimPB"];
            this.finTrimPB = data["finTrimPB"];
            this.inicioConsolas = data["inicioConsolas"];
            this.finConsolas = data["finConsolas"];
            this.inicioCabinas = data["inicioCabinas"];
            this.finCabinas = data["finCabinas"];
            this.inicioFaldon = data["inicioFaldon"];
            this.finFaldon = data["finFaldon"];
            this.inicioPreparacion = data["inicioPreparacion"];
            this.finPreparacion = data["finPreparacion"];
            this.inicioKitCobre = data["inicioKitCobre"];
            this.finKitCobre = data["finKitCobre"];
            this.inicioTransmision = data["inicioTransmision"];
            this.finTransmision = data["finTransmision"];
        }
    }

    static fromJS(data: any): SecuenciasDiaData {
        data = typeof data === 'object' ? data : {};
        let result = new SecuenciasDiaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dia"] = this.dia;
        data["inicioTrimPB"] = this.inicioTrimPB;
        data["finTrimPB"] = this.finTrimPB;
        data["inicioConsolas"] = this.inicioConsolas;
        data["finConsolas"] = this.finConsolas;
        data["inicioCabinas"] = this.inicioCabinas;
        data["finCabinas"] = this.finCabinas;
        data["inicioFaldon"] = this.inicioFaldon;
        data["finFaldon"] = this.finFaldon;
        data["inicioPreparacion"] = this.inicioPreparacion;
        data["finPreparacion"] = this.finPreparacion;
        data["inicioKitCobre"] = this.inicioKitCobre;
        data["finKitCobre"] = this.finKitCobre;
        data["inicioTransmision"] = this.inicioTransmision;
        data["finTransmision"] = this.finTransmision;
        return data;
    }
}

export interface ISecuenciasDiaData {
    dia: string;
    inicioTrimPB: string | undefined;
    finTrimPB: string | undefined;
    inicioConsolas: string | undefined;
    finConsolas: string | undefined;
    inicioCabinas: string | undefined;
    finCabinas: string | undefined;
    inicioFaldon: string | undefined;
    finFaldon: string | undefined;
    inicioPreparacion: string | undefined;
    finPreparacion: string | undefined;
    inicioKitCobre: string | undefined;
    finKitCobre: string | undefined;
    inicioTransmision: string | undefined;
    finTransmision: string | undefined;
}

export class ModelosDiaData implements IModelosDiaData {
    dia!: string;
    modelos!: ModeloData[];

    constructor(data?: IModelosDiaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dia = data["dia"];
            if (Array.isArray(data["modelos"])) {
                this.modelos = [] as any;
                for (let item of data["modelos"])
                    this.modelos!.push(ModeloData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelosDiaData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelosDiaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dia"] = this.dia;
        if (Array.isArray(this.modelos)) {
            data["modelos"] = [];
            for (let item of this.modelos)
                data["modelos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelosDiaData {
    dia: string;
    modelos: ModeloData[];
}

export class ModeloData implements IModeloData {
    modelodescr!: string;
    markets!: MarketData[];

    constructor(data?: IModeloData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelodescr = data["modelodescr"];
            if (Array.isArray(data["markets"])) {
                this.markets = [] as any;
                for (let item of data["markets"])
                    this.markets!.push(MarketData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModeloData {
        data = typeof data === 'object' ? data : {};
        let result = new ModeloData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelodescr"] = this.modelodescr;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModeloData {
    modelodescr: string;
    markets: MarketData[];
}

export class MarketData implements IMarketData {
    market!: string;
    secuencias!: string[];

    constructor(data?: IMarketData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.market = data["market"];
            if (Array.isArray(data["secuencias"])) {
                this.secuencias = [] as any;
                for (let item of data["secuencias"])
                    this.secuencias!.push(item);
            }
        }
    }

    static fromJS(data: any): MarketData {
        data = typeof data === 'object' ? data : {};
        let result = new MarketData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["market"] = this.market;
        if (Array.isArray(this.secuencias)) {
            data["secuencias"] = [];
            for (let item of this.secuencias)
                data["secuencias"].push(item);
        }
        return data;
    }
}

export interface IMarketData {
    market: string;
    secuencias: string[];
}

// Plan Trabajo Config interfaces and classes
export class PlanTrabajoConfigResponse implements IPlanTrabajoConfigResponse {
    success!: boolean;
    message!: string;
    data!: PlanTrabajoConfigData;

    constructor(data?: IPlanTrabajoConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
            this.data = data["data"] ? PlanTrabajoConfigData.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlanTrabajoConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlanTrabajoConfigResponse {
    success: boolean;
    message: string;
    data: PlanTrabajoConfigData;
}

export class PlanTrabajoConfigData implements IPlanTrabajoConfigData {
    id!: number;
    secuenciasLunes!: number;
    secuenciasMartes!: number;
    secuenciasMiercoles!: number;
    secuenciasJueves!: number;
    secuenciasViernes!: number;
    secuenciasSabado!: number;
    secuenciasPBLunes!: number;
    secuenciasPBMartes!: number;
    secuenciasPBMiercoles!: number;
    secuenciasPBJueves!: number;
    secuenciasPBViernes!: number;
    secuenciasPBSabado!: number;
    fechaRegistro!: Date;

    constructor(data?: IPlanTrabajoConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.secuenciasLunes = data["secuenciasLunes"];
            this.secuenciasMartes = data["secuenciasMartes"];
            this.secuenciasMiercoles = data["secuenciasMiercoles"];
            this.secuenciasJueves = data["secuenciasJueves"];
            this.secuenciasViernes = data["secuenciasViernes"];
            this.secuenciasSabado = data["secuenciasSabado"];
            this.secuenciasPBLunes = data["secuenciasPBLunes"];
            this.secuenciasPBMartes = data["secuenciasPBMartes"];
            this.secuenciasPBMiercoles = data["secuenciasPBMiercoles"];
            this.secuenciasPBJueves = data["secuenciasPBJueves"];
            this.secuenciasPBViernes = data["secuenciasPBViernes"];
            this.secuenciasPBSabado = data["secuenciasPBSabado"];
            this.fechaRegistro = data["fechaRegistro"] ? new Date(data["fechaRegistro"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlanTrabajoConfigData {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["secuenciasLunes"] = this.secuenciasLunes;
        data["secuenciasMartes"] = this.secuenciasMartes;
        data["secuenciasMiercoles"] = this.secuenciasMiercoles;
        data["secuenciasJueves"] = this.secuenciasJueves;
        data["secuenciasViernes"] = this.secuenciasViernes;
        data["secuenciasSabado"] = this.secuenciasSabado;
        data["secuenciasPBLunes"] = this.secuenciasPBLunes;
        data["secuenciasPBMartes"] = this.secuenciasPBMartes;
        data["secuenciasPBMiercoles"] = this.secuenciasPBMiercoles;
        data["secuenciasPBJueves"] = this.secuenciasPBJueves;
        data["secuenciasPBViernes"] = this.secuenciasPBViernes;
        data["secuenciasPBSabado"] = this.secuenciasPBSabado;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlanTrabajoConfigData {
    id: number;
    secuenciasLunes: number;
    secuenciasMartes: number;
    secuenciasMiercoles: number;
    secuenciasJueves: number;
    secuenciasViernes: number;
    secuenciasSabado: number;
    secuenciasPBLunes: number;
    secuenciasPBMartes: number;
    secuenciasPBMiercoles: number;
    secuenciasPBJueves: number;
    secuenciasPBViernes: number;
    secuenciasPBSabado: number;
    fechaRegistro: Date;
}

export class PlanTrabajoConfigDto implements IPlanTrabajoConfigDto {
    secuenciasLunes!: number;
    secuenciasMartes!: number;
    secuenciasMiercoles!: number;
    secuenciasJueves!: number;
    secuenciasViernes!: number;
    secuenciasSabado!: number;
    secuenciasPBLunes!: number;
    secuenciasPBMartes!: number;
    secuenciasPBMiercoles!: number;
    secuenciasPBJueves!: number;
    secuenciasPBViernes!: number;
    secuenciasPBSabado!: number;

    constructor(data?: IPlanTrabajoConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuenciasLunes = data["secuenciasLunes"];
            this.secuenciasMartes = data["secuenciasMartes"];
            this.secuenciasMiercoles = data["secuenciasMiercoles"];
            this.secuenciasJueves = data["secuenciasJueves"];
            this.secuenciasViernes = data["secuenciasViernes"];
            this.secuenciasSabado = data["secuenciasSabado"];
            this.secuenciasPBLunes = data["secuenciasPBLunes"];
            this.secuenciasPBMartes = data["secuenciasPBMartes"];
            this.secuenciasPBMiercoles = data["secuenciasPBMiercoles"];
            this.secuenciasPBJueves = data["secuenciasPBJueves"];
            this.secuenciasPBViernes = data["secuenciasPBViernes"];
            this.secuenciasPBSabado = data["secuenciasPBSabado"];
        }
    }

    static fromJS(data: any): PlanTrabajoConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuenciasLunes"] = this.secuenciasLunes;
        data["secuenciasMartes"] = this.secuenciasMartes;
        data["secuenciasMiercoles"] = this.secuenciasMiercoles;
        data["secuenciasJueves"] = this.secuenciasJueves;
        data["secuenciasViernes"] = this.secuenciasViernes;
        data["secuenciasSabado"] = this.secuenciasSabado;
        data["secuenciasPBLunes"] = this.secuenciasPBLunes;
        data["secuenciasPBMartes"] = this.secuenciasPBMartes;
        data["secuenciasPBMiercoles"] = this.secuenciasPBMiercoles;
        data["secuenciasPBJueves"] = this.secuenciasPBJueves;
        data["secuenciasPBViernes"] = this.secuenciasPBViernes;
        data["secuenciasPBSabado"] = this.secuenciasPBSabado;
        return data;
    }
}

export interface IPlanTrabajoConfigDto {
    secuenciasLunes: number;
    secuenciasMartes: number;
    secuenciasMiercoles: number;
    secuenciasJueves: number;
    secuenciasViernes: number;
    secuenciasSabado: number;
    secuenciasPBLunes: number;
    secuenciasPBMartes: number;
    secuenciasPBMiercoles: number;
    secuenciasPBJueves: number;
    secuenciasPBViernes: number;
    secuenciasPBSabado: number;
}

export class PlanTrabajoConfigSaveResponse implements IPlanTrabajoConfigSaveResponse {
    success!: boolean;
    id!: number;
    message!: string;

    constructor(data?: IPlanTrabajoConfigSaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.id = data["id"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): PlanTrabajoConfigSaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTrabajoConfigSaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlanTrabajoConfigSaveResponse {
    success: boolean;
    id: number;
    message: string;
}

// ===== Faltantes Dolly Response =====

export interface IFaltantesDollyResponse {
    items?: IFaltantesDollyItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FaltantesDollyResponse implements IFaltantesDollyResponse {
    items?: FaltantesDollyItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IFaltantesDollyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FaltantesDollyItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.currentPage = data["currentPage"];
            this.pageSize = data["pageSize"];
            this.totalPages = data["totalPages"];
            this.hasPreviousPage = data["hasPreviousPage"];
            this.hasNextPage = data["hasNextPage"];
        }
    }

    static fromJS(data: any): FaltantesDollyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FaltantesDollyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IFaltantesDollyItem {
    turno?: string;
    fecha?: Date;
    diaNatural?: string;
    numeroParte?: string;
    cantidad?: number;
    commodity?: string;
    commodityGrupo?: string;
    secuencia?: string;
    secEstatus?: string;
    causaFaltante?: string;
    dpu?: number;
    recuperado?: number;
    dpuTexto?: string;
    recuperadoTexto?: string;
    usuario?: string;
    usuarioR?: string;
    fechaR?: Date;
    cantidadR?: number;
    total?: number;
}

export class FaltantesDollyItem implements IFaltantesDollyItem {
    turno?: string;
    fecha?: Date;
    diaNatural?: string;
    numeroParte?: string;
    cantidad?: number;
    commodity?: string;
    commodityGrupo?: string;
    secuencia?: string;
    secEstatus?: string;
    causaFaltante?: string;
    dpu?: number;
    recuperado?: number;
    dpuTexto?: string;
    recuperadoTexto?: string;
    usuario?: string;
    usuarioR?: string;
    fechaR?: Date;
    cantidadR?: number;
    total?: number;

    constructor(data?: IFaltantesDollyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.turno = data["turno"];
            this.fecha = data["fecha"] ? new Date(data["fecha"]) : undefined;
            this.diaNatural = data["diaNatural"];
            this.numeroParte = data["numeroParte"];
            this.cantidad = data["cantidad"];
            this.commodity = data["commodity"];
            this.commodityGrupo = data["commodityGrupo"];
            this.secuencia = data["secuencia"];
            this.secEstatus = data["secEstatus"];
            this.causaFaltante = data["causaFaltante"];
            this.dpu = data["dpu"];
            this.recuperado = data["recuperado"];
            this.dpuTexto = data["dpuTexto"];
            this.recuperadoTexto = data["recuperadoTexto"];
            this.usuario = data["usuario"];
            this.usuarioR = data["usuarioR"];
            this.fechaR = data["fechaR"] ? new Date(data["fechaR"]) : undefined;
            this.cantidadR = data["cantidadR"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): FaltantesDollyItem {
        data = typeof data === 'object' ? data : {};
        let result = new FaltantesDollyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turno"] = this.turno;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["diaNatural"] = this.diaNatural;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["commodity"] = this.commodity;
        data["commodityGrupo"] = this.commodityGrupo;
        data["secuencia"] = this.secuencia;
        data["secEstatus"] = this.secEstatus;
        data["causaFaltante"] = this.causaFaltante;
        data["dpu"] = this.dpu;
        data["recuperado"] = this.recuperado;
        data["dpuTexto"] = this.dpuTexto;
        data["recuperadoTexto"] = this.recuperadoTexto;
        data["usuario"] = this.usuario;
        data["usuarioR"] = this.usuarioR;
        data["fechaR"] = this.fechaR ? this.fechaR.toISOString() : <any>undefined;
        data["cantidadR"] = this.cantidadR;
        data["total"] = this.total;
        return data;
    }
}

export interface IFaltantesDollyExportQuery {
    fechaInicio: string;
    fechaFin: string;
    secuenciaInicio?: string;
    secuenciaFin?: string;
    causaFaltanteId?: number;
    numeroParte?: string;
    commodity?: string;
    programa?: number;
}

export class FaltantesDollyExportQuery implements IFaltantesDollyExportQuery {
    fechaInicio!: string;
    fechaFin!: string;
    secuenciaInicio?: string;
    secuenciaFin?: string;
    causaFaltanteId?: number;
    numeroParte?: string;
    commodity?: string;
    programa?: number;

    constructor(data?: IFaltantesDollyExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fechaInicio = data["fechaInicio"];
            this.fechaFin = data["fechaFin"];
            this.secuenciaInicio = data["secuenciaInicio"];
            this.secuenciaFin = data["secuenciaFin"];
            this.causaFaltanteId = data["causaFaltanteId"];
            this.numeroParte = data["numeroParte"];
            this.commodity = data["commodity"];
            this.programa = data["programa"];
        }
    }

    static fromJS(data: any): FaltantesDollyExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FaltantesDollyExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaInicio"] = this.fechaInicio;
        data["fechaFin"] = this.fechaFin;
        data["secuenciaInicio"] = this.secuenciaInicio;
        data["secuenciaFin"] = this.secuenciaFin;
        data["causaFaltanteId"] = this.causaFaltanteId;
        data["numeroParte"] = this.numeroParte;
        data["commodity"] = this.commodity;
        data["programa"] = this.programa;
        return data;
    }
}

// ===== Planes Carga Detalles DTOs =====

export class PlanesCargaDetallesResponse implements IPlanesCargaDetallesResponse {
    success?: boolean;
    data?: PlanesCargaDetallesData;
    message?: string;

    constructor(data?: IPlanesCargaDetallesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.data = data["data"] ? PlanesCargaDetallesData.fromJS(data["data"]) : undefined;
            this.message = data["message"];
        }
    }

    static fromJS(data: any): PlanesCargaDetallesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanesCargaDetallesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlanesCargaDetallesResponse {
    success?: boolean;
    data?: PlanesCargaDetallesData;
    message?: string;
}

export class PlanesCargaDetallesData implements IPlanesCargaDetallesData {
    id?: string;
    embarqueDescripcion?: string;
    estatus?: string;
    fechaRegistro?: Date;
    usuarioId?: number;
    usuarioNombre?: string;
    descripcionCaja?: string;
    dollies?: PlanesCargaDollyItem[];
    alertasEmbarque?: AlertaEmbarqueItem[];
    imprimir?: boolean;

    constructor(data?: IPlanesCargaDetallesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.embarqueDescripcion = data["embarqueDescripcion"];
            this.estatus = data["estatus"];
            this.fechaRegistro = data["fechaRegistro"] ? new Date(data["fechaRegistro"]) : undefined;
            this.usuarioId = data["usuarioId"];
            this.usuarioNombre = data["usuarioNombre"];
            this.descripcionCaja = data["descripcionCaja"];
            this.imprimir = data["imprimir"];
            if (data["dollies"] && data["dollies"].constructor === Array) {
                this.dollies = [] as any;
                for (let item of data["dollies"])
                    this.dollies.push(PlanesCargaDollyItem.fromJS(item));
            }
            if (data["alertasEmbarque"] && data["alertasEmbarque"].constructor === Array) {
                this.alertasEmbarque = [] as any;
                for (let item of data["alertasEmbarque"])
                    this.alertasEmbarque.push(AlertaEmbarqueItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanesCargaDetallesData {
        data = typeof data === 'object' ? data : {};
        let result = new PlanesCargaDetallesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["embarqueDescripcion"] = this.embarqueDescripcion;
        data["estatus"] = this.estatus;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["usuarioId"] = this.usuarioId;
        data["usuarioNombre"] = this.usuarioNombre;
        data["descripcionCaja"] = this.descripcionCaja;
        data["imprimir"] = this.imprimir;
        if (this.dollies && this.dollies.constructor === Array) {
            data["dollies"] = [];
            for (let item of this.dollies)
                data["dollies"].push(item.toJSON());
        }
        if (this.alertasEmbarque && this.alertasEmbarque.constructor === Array) {
            data["alertasEmbarque"] = [];
            for (let item of this.alertasEmbarque)
                data["alertasEmbarque"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanesCargaDetallesData {
    id?: string;
    embarqueDescripcion?: string;
    estatus?: string;
    fechaRegistro?: Date;
    usuarioId?: number;
    usuarioNombre?: string;
    descripcionCaja?: string;
    dollies?: PlanesCargaDollyItem[];
    alertasEmbarque?: AlertaEmbarqueItem[];
    imprimir?: boolean;
}

export class PlanesCargaDollyItem implements IPlanesCargaDollyItem {
    id?: number;
    codigoDolly?: string;
    tipoDolly?: string;
    estadoDolly?: string;
    fechaCarga?: string;
    nombrePrograma?: string;
    secuenciaInicial?: string;
    secuenciaFinal?: string;

    constructor(data?: IPlanesCargaDollyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.codigoDolly = data["codigoDolly"];
            this.tipoDolly = data["tipoDolly"];
            this.estadoDolly = data["estadoDolly"];
            this.fechaCarga = data["fechaCarga"];
            this.nombrePrograma = data["nombrePrograma"];
            this.secuenciaInicial = data["secuenciaInicial"];
            this.secuenciaFinal = data["secuenciaFinal"];
        }
    }

    static fromJS(data: any): PlanesCargaDollyItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlanesCargaDollyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codigoDolly"] = this.codigoDolly;
        data["tipoDolly"] = this.tipoDolly;
        data["estadoDolly"] = this.estadoDolly;
        data["fechaCarga"] = this.fechaCarga;
        data["nombrePrograma"] = this.nombrePrograma;
        data["secuenciaInicial"] = this.secuenciaInicial;
        data["secuenciaFinal"] = this.secuenciaFinal;
        return data;
    }
}

export interface IPlanesCargaDollyItem {
    id?: number;
    codigoDolly?: string;
    tipoDolly?: string;
    estadoDolly?: string;
    fechaCarga?: string;
    nombrePrograma?: string;
    secuenciaInicial?: string;
    secuenciaFinal?: string;
}

export class AlertaEmbarqueItem implements IAlertaEmbarqueItem {
    alertaEmbarqueId?: number;
    descripcionAlerta?: string;
    tituloAlerta?: string;
    fechaRegistro?: Date;
    usuarioRegistroNombre?: string;

    constructor(data?: IAlertaEmbarqueItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alertaEmbarqueId = data["alertaEmbarqueId"];
            this.descripcionAlerta = data["descripcionAlerta"];
            this.tituloAlerta = data["tituloAlerta"];
            this.fechaRegistro = data["fechaRegistro"] ? new Date(data["fechaRegistro"]) : undefined;
            this.usuarioRegistroNombre = data["usuarioRegistroNombre"];
        }
    }

    static fromJS(data: any): AlertaEmbarqueItem {
        data = typeof data === 'object' ? data : {};
        let result = new AlertaEmbarqueItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertaEmbarqueId"] = this.alertaEmbarqueId;
        data["descripcionAlerta"] = this.descripcionAlerta;
        data["tituloAlerta"] = this.tituloAlerta;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["usuarioRegistroNombre"] = this.usuarioRegistroNombre;
        return data;
    }
}

export interface IAlertaEmbarqueItem {
    alertaEmbarqueId?: number;
    descripcionAlerta?: string;
    tituloAlerta?: string;
    fechaRegistro?: Date;
    usuarioRegistroNombre?: string;
}

// ===== DTOs para Salida de Cajas =====

export class SalidaCajaResponse implements ISalidaCajaResponse {
    status?: string;
    message?: string;
    data?: SalidaCajaData;
    timestamp?: string;

    constructor(data?: ISalidaCajaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.message = data["message"];
            this.data = data["data"] ? SalidaCajaData.fromJS(data["data"]) : undefined;
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): SalidaCajaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalidaCajaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.status !== undefined)
            data["status"] = this.status;
        if (this.message !== undefined)
            data["message"] = this.message;
        if (this.data !== undefined)
            data["data"] = this.data ? this.data.toJSON() : undefined;
        if (this.timestamp !== undefined)
            data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ISalidaCajaResponse {
    status?: string;
    message?: string;
    data?: SalidaCajaData;
    timestamp?: string;
}

export class SalidaCajaData implements ISalidaCajaData {
    codigoCaja?: string;
    estatusSalida?: boolean;
    tractorId?: number;
    numeroTracto?: string;
    choferId?: number;
    nombreChofer?: string;
    numeroSello?: string;
    estatusAutorizacion?: string;

    constructor(data?: ISalidaCajaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codigoCaja = data["codigoCaja"];
            this.estatusSalida = data["estatusSalida"];
            this.tractorId = data["tractorId"];
            this.numeroTracto = data["numeroTracto"];
            this.choferId = data["choferId"];
            this.nombreChofer = data["nombreChofer"];
            this.numeroSello = data["numeroSello"];
            this.estatusAutorizacion = data["estatusAutorizacion"];
        }
    }

    static fromJS(data: any): SalidaCajaData {
        data = typeof data === 'object' ? data : {};
        let result = new SalidaCajaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.codigoCaja !== undefined)
            data["codigoCaja"] = this.codigoCaja;
        if (this.estatusSalida !== undefined)
            data["estatusSalida"] = this.estatusSalida;
        if (this.tractorId !== undefined)
            data["tractorId"] = this.tractorId;
        if (this.choferId !== undefined)
            data["choferId"] = this.choferId;
        if (this.numeroTracto !== undefined)
            data["numeroTracto"] = this.numeroTracto;
        if (this.nombreChofer !== undefined)
            data["nombreChofer"] = this.nombreChofer;
        if (this.numeroSello !== undefined)
            data["numeroSello"] = this.numeroSello;
        if (this.estatusAutorizacion !== undefined)
            data["estatusAutorizacion"] = this.estatusAutorizacion;
        return data;
    }
}

export interface ISalidaCajaData {
    codigoCaja?: string;
    estatusSalida?: boolean;
    tractorId?: number;
    choferId?: number;
    numeroTracto?: string;
    nombreChofer?: string;
    numeroSello?: string;
    estatusAutorizacion?: string;
}

// Service Proxy for Reporte KPI
@Injectable()
export class ReporteKpiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Obtiene el resumen de KPIs
     */
    getResumen(tipoKPI?: number, aniosAtras?: number): Observable<ReporteKpiResumenResponse> {
        let url_ = this.baseUrl + "/api/reportes/kpi/resumen?";
        if (tipoKPI !== undefined && tipoKPI !== null)
            url_ += "tipoKPI=" + encodeURIComponent("" + tipoKPI) + "&";
        if (aniosAtras !== undefined && aniosAtras !== null)
            url_ += "aniosAtras=" + encodeURIComponent("" + aniosAtras) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetResumen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResumen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReporteKpiResumenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReporteKpiResumenResponse>;
        }));
    }

    protected processGetResumen(response: HttpResponseBase): Observable<ReporteKpiResumenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReporteKpiResumenResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReporteKpiResumenResponse>(null as any);
    }

    /**
     * Obtiene el detalle de KPIs por tipo de causa faltante
     */
    getDetalle(tipoCausaFaltante: string, tipoKPI?: number, aniosAtras?: number): Observable<ReporteKpiDetalleResponse> {
        let url_ = this.baseUrl + "/api/reportes/kpi/detalle?";
        if (tipoCausaFaltante !== undefined && tipoCausaFaltante !== null)
            url_ += "tipoCausaFaltante=" + encodeURIComponent("" + tipoCausaFaltante) + "&";
        if (tipoKPI !== undefined && tipoKPI !== null)
            url_ += "tipoKPI=" + encodeURIComponent("" + tipoKPI) + "&";
        if (aniosAtras !== undefined && aniosAtras !== null)
            url_ += "aniosAtras=" + encodeURIComponent("" + aniosAtras) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetalle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetalle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReporteKpiDetalleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReporteKpiDetalleResponse>;
        }));
    }

    protected processGetDetalle(response: HttpResponseBase): Observable<ReporteKpiDetalleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReporteKpiDetalleResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReporteKpiDetalleResponse>(null as any);
    }

    /**
     * Exporta el reporte KPI a Excel
     */
    exportKpi(): Observable<ArrayBuffer> {
        let url_ = this.baseUrl + "/api/reportes/kpi/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "arraybuffer",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportKpi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportKpi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArrayBuffer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArrayBuffer>;
        }));
    }

    protected processExportKpi(response: HttpResponseBase): Observable<ArrayBuffer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof ArrayBuffer ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return _observableOf(responseBlob);
        } else if (status !== 200 && status !== 204) {
            return _observableThrow("Error al exportar el reporte KPI");
        }
        return _observableOf<ArrayBuffer>(null as any);
    }
}

// Response classes for Reporte KPI
export class ReporteKpiResumenResponse implements IReporteKpiResumenResponse {
    success!: boolean;
    data!: ReporteKpiResumenData;
    message!: string;

    constructor(data?: IReporteKpiResumenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.data = _data["data"] ? ReporteKpiResumenData.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReporteKpiResumenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReporteKpiResumenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IReporteKpiResumenResponse {
    success: boolean;
    data: ReporteKpiResumenData;
    message: string;
}

export class ReporteKpiResumenData implements IReporteKpiResumenData {
    encabezado!: string;
    totalFaltanteDiscrepante!: number;
    totalFaltanteNatural!: number;
    totalFaltanteKenworth!: number;
    totalFaltanteDHL!: number;
    totalFaltanteDaniado!: number;
    totalFaltanteOtros!: number;
    total!: number;

    constructor(data?: IReporteKpiResumenData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encabezado = _data["encabezado"];
            this.totalFaltanteDiscrepante = _data["totalFaltanteDiscrepante"];
            this.totalFaltanteNatural = _data["totalFaltanteNatural"];
            this.totalFaltanteKenworth = _data["totalFaltanteKenworth"];
            this.totalFaltanteDHL = _data["totalFaltanteDHL"];
            this.totalFaltanteDaniado = _data["totalFaltanteDaniado"];
            this.totalFaltanteOtros = _data["totalFaltanteOtros"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ReporteKpiResumenData {
        data = typeof data === 'object' ? data : {};
        let result = new ReporteKpiResumenData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encabezado"] = this.encabezado;
        data["totalFaltanteDiscrepante"] = this.totalFaltanteDiscrepante;
        data["totalFaltanteNatural"] = this.totalFaltanteNatural;
        data["totalFaltanteKenworth"] = this.totalFaltanteKenworth;
        data["totalFaltanteDHL"] = this.totalFaltanteDHL;
        data["totalFaltanteDaniado"] = this.totalFaltanteDaniado;
        data["totalFaltanteOtros"] = this.totalFaltanteOtros;
        data["total"] = this.total;
        return data;
    }
}

export interface IReporteKpiResumenData {
    encabezado: string;
    totalFaltanteDiscrepante: number;
    totalFaltanteNatural: number;
    totalFaltanteKenworth: number;
    totalFaltanteDHL: number;
    totalFaltanteDaniado: number;
    totalFaltanteOtros: number;
    total: number;
}

export class ReporteKpiDetalleResponse implements IReporteKpiDetalleResponse {
    success!: boolean;
    data!: ReporteKpiDetalleItem[];
    message!: string;

    constructor(data?: IReporteKpiDetalleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReporteKpiDetalleItem.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReporteKpiDetalleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReporteKpiDetalleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IReporteKpiDetalleResponse {
    success: boolean;
    data: ReporteKpiDetalleItem[];
    message: string;
}

export class ReporteKpiDetalleItem implements IReporteKpiDetalleItem {
    noParte!: string | undefined;
    descripcion!: string | undefined;
    secuencia!: string | undefined;
    causaFaltante!: string | undefined;
    commodity!: string | undefined;
    programa!: string | undefined;
    cantidadFaltante!: number;
    fechaRegistro!: moment.Moment;
    estatus!: string | undefined;
    commodityDescripcion!: string | undefined;
    commodityGrupoDescr!: string | undefined;

    constructor(data?: IReporteKpiDetalleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noParte = _data["noParte"];
            this.descripcion = _data["descripcion"];
            this.secuencia = _data["secuencia"];
            this.causaFaltante = _data["causaFaltante"];
            this.commodity = _data["commodity"];
            this.programa = _data["programa"];
            this.cantidadFaltante = _data["cantidadFaltante"];
            this.fechaRegistro = _data["fechaRegistro"] ? moment(_data["fechaRegistro"].toString()) : <any>undefined;
            this.estatus = _data["estatus"];
            this.commodityDescripcion = _data["commodityDescripcion"];
            this.commodityGrupoDescr = _data["commodityGrupoDescr"];
        }
    }

    static fromJS(data: any): ReporteKpiDetalleItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReporteKpiDetalleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noParte"] = this.noParte;
        data["descripcion"] = this.descripcion;
        data["secuencia"] = this.secuencia;
        data["causaFaltante"] = this.causaFaltante;
        data["commodity"] = this.commodity;
        data["programa"] = this.programa;
        data["cantidadFaltante"] = this.cantidadFaltante;
        data["fechaRegistro"] = this.fechaRegistro ? this.fechaRegistro.toISOString() : <any>undefined;
        data["estatus"] = this.estatus;
        data["commodityDescripcion"] = this.commodityDescripcion;
        data["commodityGrupoDescr"] = this.commodityGrupoDescr;
        return data;
    }
}

export interface IReporteKpiDetalleItem {
    noParte: string | undefined;
    descripcion: string | undefined;
    secuencia: string | undefined;
    causaFaltante: string | undefined;
    commodity: string | undefined;
    programa: string | undefined;
    cantidadFaltante: number;
    fechaRegistro: moment.Moment;
    estatus: string | undefined;
    commodityDescripcion: string | undefined;
    commodityGrupoDescr: string | undefined;
}

export class CambiarEstadoFolioResponse implements ICambiarEstadoFolioResponse {
    success?: boolean;
    message?: string;
    folio?: string;
    estadoAnterior?: string;
    estadoNuevo?: string;

    constructor(data?: ICambiarEstadoFolioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
            this.folio = data["folio"];
            this.estadoAnterior = data["estadoAnterior"];
            this.estadoNuevo = data["estadoNuevo"];
        }
    }

    static fromJS(data: any): CambiarEstadoFolioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CambiarEstadoFolioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.success !== undefined)
            data["success"] = this.success;
        if (this.message !== undefined)
            data["message"] = this.message;
        if (this.folio !== undefined)
            data["folio"] = this.folio;
        if (this.estadoAnterior !== undefined)
            data["estadoAnterior"] = this.estadoAnterior;
        if (this.estadoNuevo !== undefined)
            data["estadoNuevo"] = this.estadoNuevo;
        return data;
    }
}

export interface ICambiarEstadoFolioResponse {
    success?: boolean;
    message?: string;
    folio?: string;
    estadoAnterior?: string;
    estadoNuevo?: string;
}

@Injectable()
export class AdministrarPruebasServiceProxy {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Optional() @Inject(API_BASE_URL) private baseUrl?: string
    ) {
        this.baseUrl = this.baseUrl ?? '';
    }

    /**
     * Eliminar todos los embarques de prueba
     * @return Success
     */
    deleteEmbarques(): Observable<{ message: string }> {
        let url_ = this.baseUrl + "/api/administrarpruebas/embarques";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEmbarques(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmbarques(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ message: string }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ message: string }>;
        }));
    }

    protected processDeleteEmbarques(response: HttpResponseBase): Observable<{ message: string }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ message: string }>(<any>null);
    }

    /**
     * Eliminar todos los folios de prueba
     * @return Success
     */
    deleteFolios(): Observable<{ message: string }> {
        let url_ = this.baseUrl + "/api/administrarpruebas/folios";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            body: JSON.stringify({}),
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Content-Type": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFolios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFolios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ message: string }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ message: string }>;
        }));
    }

    protected processDeleteFolios(response: HttpResponseBase): Observable<{ message: string }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ message: string }>(<any>null);
    }

    /**
     * Eliminar folio específico por ID
     * @param idFolio ID del folio a eliminar
     * @return Success
     */
    deleteFolioById(idFolio: number): Observable<{ message: string }> {
        let url_ = this.baseUrl + "/api/administrarpruebas/folios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ IdFolio: idFolio });

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFolioById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFolioById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ message: string }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ message: string }>;
        }));
    }

    protected processDeleteFolioById(response: HttpResponseBase): Observable<{ message: string }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ message: string }>(<any>null);
    }
}

export class AuthenticationCodeSentTimeByUserIdRequest implements IAuthenticationCodeSentTimeByUserIdRequest {
    userId!: number;
    identificator?: string | undefined;
    origin!: AuthenticationCodeOrigin;
    userName?: string | undefined;
    tenancyName?: string | undefined;

    constructor(data?: IAuthenticationCodeSentTimeByUserIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.identificator = _data["identificator"];
            this.origin = _data["origin"];
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): AuthenticationCodeSentTimeByUserIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationCodeSentTimeByUserIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["identificator"] = this.identificator;
        data["origin"] = this.origin;
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IAuthenticationCodeSentTimeByUserIdRequest {
    userId: number;
    identificator?: string | undefined;
    origin: AuthenticationCodeOrigin;
    userName?: string | undefined;
    tenancyName?: string | undefined;
}

export class AuthenticationCodeSentTimeResponse implements IAuthenticationCodeSentTimeResponse {
    formattedSentTime?: string | undefined;

    constructor(data?: IAuthenticationCodeSentTimeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formattedSentTime = _data["formattedSentTime"];
        }
    }

    static fromJS(data: any): AuthenticationCodeSentTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationCodeSentTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formattedSentTime"] = this.formattedSentTime;
        return data;
    }
}

export interface IAuthenticationCodeSentTimeResponse {
    formattedSentTime?: string | undefined;
}

export interface IPagedResultOfCommodityMexiForListResponse {
    items: ICommodityMexiForListResponse[];
    totalCount: number;
}

export interface ICommodityMexiForListResponse {
    id: number;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    esBuffer: boolean;
    noSecuenciadoDHL: boolean;
    esReferenciaInventario: boolean;
    uncovered: boolean;
    estatus: boolean;
    grupoDescripcion?: string | undefined;
    almacenDescripcion?: string | undefined;
    ordenPorCommodity: boolean;
    descripcionPickList?: string | undefined;
    wip?: string | undefined;
}

export interface ICommodityMexiForEditResponse {
    id: number;
    codigo?: string | undefined;
    descripcion?: string | undefined;
    buffer?: string | undefined;
    esBuffer: boolean;
    noSecuenciadoDHL: boolean;
    esReferenciaInventario: boolean;
    uncovered: boolean;
    secInvertida: boolean;
    estatus: boolean;
    grupoID: number;
    almacenID: number;
    grupoDescripcion?: string | undefined;
    almacenDescripcion?: string | undefined;
    pickListId?: number | undefined;
}

export interface ICommodityMexiCreateDto {
    codigo: string;
    descripcion: string;
    buffer?: string | undefined;
    esBuffer: boolean;
    noSecuenciadoDHL: boolean;
    esReferenciaInventario: boolean;
    uncovered: boolean;
    secInvertida: boolean;
    estatus: boolean;
    grupoID: number;
    almacenID: number;
    pickListId?: number | undefined;
}

export interface ICommodityMexiUpdateDto {
    id: number;
    codigo: string;
    descripcion: string;
    buffer?: string | undefined;
    esBuffer: boolean;
    noSecuenciadoDHL: boolean;
    esReferenciaInventario: boolean;
    uncovered: boolean;
    secInvertida: boolean;
    estatus: boolean;
    grupoID: number;
    almacenID: number;
    pickListId?: number | undefined;
}

// CausaComanda Service Proxy
@Injectable()
export class CausaComandaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Obtiene la lista de causas de comandas con filtros y paginación
     */
    getCausaComandas(
        causa?: string | undefined,
        sorting?: string | undefined,
        filter?: string | undefined,
        pageSize?: number | undefined,
        pageNumber?: number | undefined,
        isPaged?: boolean | undefined
    ): Observable<CausaComandaPagedResultDto> {
        let url_ = this.baseUrl + "/api/causacomandas";
        let queryParams: string[] = [];

        if (causa !== undefined && causa !== null)
            queryParams.push("causa=" + encodeURIComponent("" + causa));
        if (sorting !== undefined && sorting !== null)
            queryParams.push("sorting=" + encodeURIComponent("" + sorting));
        if (filter !== undefined && filter !== null)
            queryParams.push("filter=" + encodeURIComponent("" + filter));
        if (pageSize !== undefined && pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + pageSize));
        if (pageNumber !== undefined && pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + pageNumber));
        if (isPaged !== undefined && isPaged !== null)
            queryParams.push("isPaged=" + encodeURIComponent("" + isPaged));

        if (queryParams.length > 0) {
            url_ += "?" + queryParams.join("&");
        }

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCausaComandas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCausaComandas(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processGetCausaComandas(response: HttpResponseBase): Observable<CausaComandaPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CausaComandaPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crea una nueva causa de comanda
     */
    createCausaComanda(input: CreateCausaComandaDto): Observable<void> {
        let url_ = this.baseUrl + "/api/causacomandas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCausaComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCausaComanda(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processCreateCausaComanda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualiza una causa de comanda existente
     */
    updateCausaComanda(id: number, input: UpdateCausaComandaDto): Observable<void> {
        let url_ = this.baseUrl + "/api/causacomandas/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCausaComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCausaComanda(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processUpdateCausaComanda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Elimina una causa de comanda
     */
    deleteCausaComanda(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/causacomandas/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCausaComanda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCausaComanda(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processDeleteCausaComanda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200 || status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

// DTOs para CausaComanda
export class CausaComandaDto implements ICausaComandaDto {
    id!: number;
    causa!: string;

    constructor(data?: ICausaComandaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.causa = _data["causa"];
        }
    }

    static fromJS(data: any): CausaComandaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CausaComandaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["causa"] = this.causa;
        return data;
    }
}

export interface ICausaComandaDto {
    id: number;
    causa: string;
}

export class CreateCausaComandaDto implements ICreateCausaComandaDto {
    causa!: string;

    constructor(data?: ICreateCausaComandaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.causa = _data["causa"];
        }
    }

    static fromJS(data: any): CreateCausaComandaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCausaComandaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causa"] = this.causa;
        return data;
    }
}

export interface ICreateCausaComandaDto {
    causa: string;
}

export class UpdateCausaComandaDto implements IUpdateCausaComandaDto {
    id!: number;
    causa!: string;

    constructor(data?: IUpdateCausaComandaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.causa = _data["causa"];
        }
    }

    static fromJS(data: any): UpdateCausaComandaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCausaComandaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["causa"] = this.causa;
        return data;
    }
}

export interface IUpdateCausaComandaDto {
    id: number;
    causa: string;
}

export class CausaComandaPagedResultDto implements ICausaComandaPagedResultDto {
    totalRecords!: number;
    items!: CausaComandaDto[];

    constructor(data?: ICausaComandaPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CausaComandaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CausaComandaPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CausaComandaPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICausaComandaPagedResultDto {
    totalRecords: number;
    items: CausaComandaDto[];
}

export class CantidadSecuenciasProduccionResponse implements ICantidadSecuenciasProduccionResponse {
    success!: boolean;
    cantidadSecuenciasProduccion!: number;
    errorMessage?: string;

    constructor(data?: ICantidadSecuenciasProduccionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.cantidadSecuenciasProduccion = _data["cantidadSecuenciasProduccion"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CantidadSecuenciasProduccionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CantidadSecuenciasProduccionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["cantidadSecuenciasProduccion"] = this.cantidadSecuenciasProduccion;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICantidadSecuenciasProduccionResponse {
    success: boolean;
    cantidadSecuenciasProduccion: number;
    errorMessage?: string;
}

export class RangoAlertaDto implements IRangoAlertaDto {
    rangoAlertaId!: number;
    rangoAlertaInicio!: number;
    rangoAlertaFin!: number;

    constructor(data?: IRangoAlertaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rangoAlertaId = _data["rangoAlertaId"];
            this.rangoAlertaInicio = _data["rangoAlertaInicio"];
            this.rangoAlertaFin = _data["rangoAlertaFin"];
        }
    }

    static fromJS(data: any): RangoAlertaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RangoAlertaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangoAlertaId"] = this.rangoAlertaId;
        data["rangoAlertaInicio"] = this.rangoAlertaInicio;
        data["rangoAlertaFin"] = this.rangoAlertaFin;
        return data;
    }
}

export interface IRangoAlertaDto {
    rangoAlertaId: number;
    rangoAlertaInicio: number;
    rangoAlertaFin: number;
}

export class UpdateRangoAlertaRequest implements IUpdateRangoAlertaRequest {
    rangos!: RangoAlertaDto[];

    constructor(data?: IUpdateRangoAlertaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rangos"])) {
                this.rangos = [] as any;
                for (let item of _data["rangos"])
                    this.rangos!.push(RangoAlertaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRangoAlertaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRangoAlertaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rangos)) {
            data["rangos"] = [];
            for (let item of this.rangos)
                data["rangos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateRangoAlertaRequest {
    rangos: RangoAlertaDto[];
}

@Injectable()
export class OjoBufferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    protected processActualizarSecuenciaPrograma(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Obtener Lista Paginada
    getOjoBufferList(query: any): Observable<any> {
        let url_ = this.baseUrl + "/api/ojobuffers";
        url_ = url_.replace(/[?&]$/, "");

        // Construir query params basado en el objeto query
        let queryParams: string[] = [];
        if (query.pageNumber !== undefined && query.pageNumber !== null)
            queryParams.push("pageNumber=" + encodeURIComponent("" + query.pageNumber));
        if (query.pageSize !== undefined && query.pageSize !== null)
            queryParams.push("pageSize=" + encodeURIComponent("" + query.pageSize));
        if (query.sorting !== undefined && query.sorting !== null && query.sorting !== "")
            queryParams.push("sorting=" + encodeURIComponent("" + query.sorting));
        if (query.filter !== undefined && query.filter !== null && query.filter !== "")
            queryParams.push("filter=" + encodeURIComponent("" + query.filter));
        if (query.codigoPrograma !== undefined && query.codigoPrograma !== null && query.codigoPrograma !== "")
            queryParams.push("codigoPrograma=" + encodeURIComponent("" + query.codigoPrograma));
        if (query.secuenciaActual !== undefined && query.secuenciaActual !== null && query.secuenciaActual !== "")
            queryParams.push("secuenciaActual=" + encodeURIComponent("" + query.secuenciaActual));
        if (query.nombreUsuario !== undefined && query.nombreUsuario !== null && query.nombreUsuario !== "")
            queryParams.push("nombreUsuario=" + encodeURIComponent("" + query.nombreUsuario));
        if (query.estatus !== undefined && query.estatus !== null)
            queryParams.push("estatus=" + encodeURIComponent("" + query.estatus));
        if (query.fechaDesde !== undefined && query.fechaDesde !== null && query.fechaDesde !== "")
            queryParams.push("fechaDesde=" + encodeURIComponent("" + query.fechaDesde));
        if (query.fechaHasta !== undefined && query.fechaHasta !== null && query.fechaHasta !== "")
            queryParams.push("fechaHasta=" + encodeURIComponent("" + query.fechaHasta));

        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOjoBufferList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOjoBufferList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetOjoBufferList(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Obtener por ID
    getOjoBufferById(id: number): Observable<any> {
        let url_ = this.baseUrl + `/api/ojobuffers/${encodeURIComponent(id)}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOjoBufferById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOjoBufferById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetOjoBufferById(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Actualizar Secuencia de Registro
    updateOjoBufferSecuencia(dto: any): Observable<any> {
        let url_ = this.baseUrl + "/api/ojobuffers/secuencia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOjoBufferSecuencia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOjoBufferSecuencia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateOjoBufferSecuencia(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Cambiar Estado (Activar/Desactivar)
    deleteOjoBuffer(id: number): Observable<any> {
        let url_ = this.baseUrl + `/api/ojobuffers/${encodeURIComponent(id)}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOjoBuffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOjoBuffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteOjoBuffer(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Create
    createOjoBuffer(dto: any): Observable<any> {
        let url_ = this.baseUrl + "/api/ojobuffers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOjoBuffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOjoBuffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCreateOjoBuffer(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    // Export
    exportOjoBuffer(query: any): Observable<Blob> {
        let url_ = this.baseUrl + "/api/ojobuffers/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportOjoBuffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOjoBuffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Blob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Blob>;
        }));
    }

    protected processExportOjoBuffer(response: HttpResponseBase): Observable<Blob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return _observableOf(responseBlob as any);
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Blob>(null as any);
    }
}

@Injectable()
export class SesionesDispositivosMovilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    /**
     * POST /api/mobile/sessions/active
     * @param request Request body con parámetros de paginación y filtros
     */
    getSesionesActivas(request?: SesionesActivasRequest | undefined): Observable<SesionesActivasResponse> {
        let url_ = this.baseUrl + "/api/mobile/sessions/active";
        url_ = url_.replace(/[?&]$/, "");

        // Crear headers base
        let headers = new HttpHeaders({
            "Accept": "application/json",
            "Content-Type": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        const content_ = JSON.stringify(request ? request.toJSON() : {});

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSesionesActivas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSesionesActivas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SesionesActivasResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SesionesActivasResponse>;
        }));
    }

    protected processGetSesionesActivas(response: HttpResponseBase): Observable<SesionesActivasResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SesionesActivasResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SesionesActivasResponse>(null as any);
    }

    /**
     * POST /api/mobile/sessions/force-logout
     * @param request Request con sessionId para cerrar sesión
     */
    postForceLogout(request: ForceLogoutRequest): Observable<ForceLogoutResponse> {
        let url_ = this.baseUrl + "/api/mobile/sessions/force-logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "Accept": "application/json"
        });

        // Agregar token de autorización si está disponible
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', `Bearer ${currentUser.token}`);
        }

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: headers
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostForceLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostForceLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForceLogoutResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForceLogoutResponse>;
        }));
    }

    protected processPostForceLogout(response: HttpResponseBase): Observable<ForceLogoutResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForceLogoutResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForceLogoutResponse>(null as any);
    }
}

// DTOs and Interfaces for Sesiones Dispositivos Moviles

export interface ISesionesActivasRequest {
    pageNumber?: number;
    pageSize?: number;
    filterUserName?: string | undefined;
    filterDeviceIMEI?: string | undefined;
    sorting?: string | undefined;
}

export interface ISesionesActivasResponse {
    totalCount?: number;
    items?: SesionMovilItem[] | undefined;
}

export interface ISesionMovilItem {
    sessionId?: number;
    usuario?: string | undefined;
    userName?: string | undefined;
    movil?: number;
    deviceIMEI?: string | undefined;
    fechaInicio?: Date;
    lastActivity?: Date;
    fullName?: string | undefined;
}

export interface IForceLogoutRequest {
    sessionId?: number;
}

export interface IForceLogoutResponse {
    success?: boolean;
    message?: string | undefined;
}

export class SesionesActivasResponse implements ISesionesActivasResponse {
    totalCount?: number;
    items?: SesionMovilItem[] | undefined;

    constructor(data?: ISesionesActivasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SesionMovilItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SesionesActivasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SesionesActivasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export class SesionMovilItem implements ISesionMovilItem {
    sessionId?: number;
    usuario?: string | undefined;
    userName?: string | undefined;
    movil?: number;
    deviceIMEI?: string | undefined;
    fechaInicio?: Date;
    lastActivity?: Date;
    fullName?: string | undefined;

    constructor(data?: ISesionMovilItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.usuario = _data["usuario"];
            this.userName = _data["userName"];
            this.movil = _data["movil"];
            this.deviceIMEI = _data["deviceIMEI"];
            this.fechaInicio = _data["fechaInicio"] ? new Date(_data["fechaInicio"].toString()) : <any>undefined;
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SesionMovilItem {
        data = typeof data === 'object' ? data : {};
        let result = new SesionMovilItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["usuario"] = this.usuario;
        data["userName"] = this.userName;
        data["movil"] = this.movil;
        data["deviceIMEI"] = this.deviceIMEI;
        data["fechaInicio"] = this.fechaInicio ? this.fechaInicio.toISOString() : <any>undefined;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        return data;
    }
}

export class SesionesActivasRequest implements ISesionesActivasRequest {
    pageNumber?: number;
    pageSize?: number;
    filterUserName?: string | undefined;
    filterDeviceIMEI?: string | undefined;
    sorting?: string | undefined;

    constructor(data?: ISesionesActivasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.filterUserName = _data["filterUserName"];
            this.filterDeviceIMEI = _data["filterDeviceIMEI"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): SesionesActivasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SesionesActivasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["filterUserName"] = this.filterUserName;
        data["filterDeviceIMEI"] = this.filterDeviceIMEI;
        data["sorting"] = this.sorting;
        return data;
    }
}

export class ForceLogoutRequest implements IForceLogoutRequest {
    sessionId?: number;

    constructor(data?: IForceLogoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): ForceLogoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForceLogoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export class ForceLogoutResponse implements IForceLogoutResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IForceLogoutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ForceLogoutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForceLogoutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

// Servicio para Tiempo Efectivo por Secuencia y Programa
@Injectable()
export class TiempoEfectivoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Optional() @Inject(API_BASE_URL) baseUrl?: string
    ) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:60618";
    }

    getTiempoEfectivoSecuenciaList(query: TiempoEfectivoSecuenciaGetListQuery): Observable<TiempoEfectivoSecuenciaForListResponse[]> {
        let url_ = this.baseUrl + "/api/Report/GetTiempoEfectivoSecuenciaList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTiempoEfectivoSecuenciaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiempoEfectivoSecuenciaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiempoEfectivoSecuenciaForListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiempoEfectivoSecuenciaForListResponse[]>;
        }));
    }

    private processGetTiempoEfectivoSecuenciaList(response: HttpResponseBase): Observable<TiempoEfectivoSecuenciaForListResponse[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiempoEfectivoSecuenciaForListResponse[]>(null as any);
    }

    private jsonParseReviver: ((key: string, value: any) => any) | undefined = (key, value) => {
        return value;
    };
}

// DTOs para Tiempo Efectivo por Secuencia y Programa
export interface TiempoEfectivoSecuenciaGetListQuery {
    fechaInicio?: Date | null;
    fechaFin?: Date | null;
    programaId?: string | null;
    commodityCode?: string | null;
    secuencia?: string | null;
}

export interface TiempoEfectivoParteResponse {
    noParte: string;
    cantidad: number;
    cantidadEscaneada: number;
    completo: number;
    causaFaltanteDescr?: string | null;
    usuarioIdEmpleado?: string | null;
    esRecuperado?: boolean;
    secuenciaReal?: string | null;
}

export interface TiempoEfectivoSecuenciaResponse {
    secuencia: string;
    estadoSecuencia: string;
    turno: string;
    horaInicio: string;
    horaTermino?: string | null;
    tiempoEfectivo?: string | null;
    fechaEscaneo: string;
    totalPartes: number;
    partes: TiempoEfectivoParteResponse[];
}

export interface TiempoEfectivoCommodityResponse {
    commodityCode: string;
    totalSecuencias: number;
    totalPartes: number;
    secuencias: TiempoEfectivoSecuenciaResponse[];
}

export interface TiempoEfectivoSecuenciaForListResponse {
    programaId: number;
    programaNombre: string;
    totalPartes: number;
    totalSecuencias: number;
    totalCommodities: number;
    commodities: TiempoEfectivoCommodityResponse[];
}

export class DetalladoDataDto implements IDetalladoDataDto {
    secuencia!: string | undefined;
    chassis!: string | undefined;
    numeroParte!: string | undefined;
    cantidad!: number | undefined;
    commodity!: string | undefined;
    commodityCode!: string | undefined;
    descripcion!: string | undefined;

    constructor(data?: IDetalladoDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secuencia = _data["secuencia"];
            this.chassis = _data["chassis"];
            this.numeroParte = _data["numeroParte"];
            this.cantidad = _data["cantidad"];
            this.commodity = _data["commodity"];
            this.commodityCode = _data["commodityCode"];
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): DetalladoDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetalladoDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuencia"] = this.secuencia;
        data["chassis"] = this.chassis;
        data["numeroParte"] = this.numeroParte;
        data["cantidad"] = this.cantidad;
        data["commodity"] = this.commodity;
        data["commodityCode"] = this.commodityCode;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

export interface IDetalladoDataDto {
    secuencia: string | undefined;
    chassis: string | undefined;
    numeroParte: string | undefined;
    cantidad: number | undefined;
    commodity: string | undefined;
    commodityCode: string | undefined;
    descripcion: string | undefined;
}

// FileList interfaces and classes
export class PagedResultDtoOfFileListItem implements IPagedResultDtoOfFileListItem {
    totalCount!: number;
    items!: FileListItem[] | undefined;

    constructor(data?: IPagedResultDtoOfFileListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FileListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFileListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFileListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFileListItem {
    totalCount: number;
    items: FileListItem[] | undefined;
}

export class FileListItem implements IFileListItem {
    id!: string;
    fileName!: string;
    tenantId!: number;
    descripcion!: string;
    createdAt!: string | undefined;

    constructor(data?: IFileListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.tenantId = _data["tenantId"];
            this.descripcion = _data["descripcion"];
            this.createdAt = _data["createdAt"] ? _data["createdAt"].toString() : undefined;
        }
    }

    static fromJS(data: any): FileListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["tenantId"] = this.tenantId;
        data["descripcion"] = this.descripcion;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IFileListItem {
    id: string;
    fileName: string;
    tenantId: number;
    descripcion: string;
    createdAt: string | undefined;
}

export class PagedResultDtoOfTipoArchivoItem implements IPagedResultDtoOfTipoArchivoItem {
    totalCount!: number;
    items!: TipoArchivoItem[] | undefined;

    constructor(data?: IPagedResultDtoOfTipoArchivoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TipoArchivoItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTipoArchivoItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTipoArchivoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTipoArchivoItem {
    totalCount: number;
    items: TipoArchivoItem[] | undefined;
}

export class TipoArchivoItem implements ITipoArchivoItem {
    id!: number;
    nombre!: string;
    descripcion!: string;

    constructor(data?: ITipoArchivoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
        }
    }

    static fromJS(data: any): TipoArchivoItem {
        data = typeof data === 'object' ? data : {};
        let result = new TipoArchivoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        return data;
    }
}

export interface ITipoArchivoItem {
    id: number;
    nombre: string;
    descripcion: string;
}

export interface ISabanaDollysResponse {
    items?: ISabanaDollysItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SabanaDollysResponse implements ISabanaDollysResponse {
    items?: SabanaDollysItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: ISabanaDollysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SabanaDollysItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.currentPage = data["currentPage"];
            this.pageSize = data["pageSize"];
            this.totalPages = data["totalPages"];
            this.hasPreviousPage = data["hasPreviousPage"];
            this.hasNextPage = data["hasNextPage"];
        }
    }

    static fromJS(data: any): SabanaDollysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface ISabanaDollysItem {
    programa?: string;
    dolly?: string;
    commodity?: string;
    secuencia?: string;
    fechaEscaneo?: string;
    noParte?: string;
    cantidad?: number;
    cantidadEscaneada?: number;
    completo?: number;
    causaFaltante?: string;
    usuarioRegistro?: string;
    recuperado?: number;
    usuarioRecuperacion?: string;
    fechaRecuperacion?: string;
}

export class SabanaDollysItem implements ISabanaDollysItem {
    programa?: string;
    dolly?: string;
    commodity?: string;
    secuencia?: string;
    fechaEscaneo?: string;
    noParte?: string;
    cantidad?: number;
    cantidadEscaneada?: number;
    completo?: number;
    causaFaltante?: string;
    usuarioRegistro?: string;
    recuperado?: number;
    usuarioRecuperacion?: string;
    fechaRecuperacion?: string;

    constructor(data?: ISabanaDollysItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programa = data["programa"];
            this.dolly = data["dolly"];
            this.commodity = data["commodity"];
            this.secuencia = data["secuencia"];
            this.fechaEscaneo = data["fechaEscaneo"];
            this.noParte = data["noParte"];
            this.cantidad = data["cantidad"];
            this.cantidadEscaneada = data["cantidadEscaneada"];
            this.completo = data["completo"];
            this.causaFaltante = data["causaFaltante"];
            this.usuarioRegistro = data["usuarioRegistro"];
            this.recuperado = data["recuperado"];
            this.usuarioRecuperacion = data["usuarioRecuperacion"];
            this.fechaRecuperacion = data["fechaRecuperacion"];
        }
    }

    static fromJS(data: any): SabanaDollysItem {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programa"] = this.programa;
        data["dolly"] = this.dolly;
        data["commodity"] = this.commodity;
        data["secuencia"] = this.secuencia;
        data["fechaEscaneo"] = this.fechaEscaneo;
        data["noParte"] = this.noParte;
        data["cantidad"] = this.cantidad;
        data["cantidadEscaneada"] = this.cantidadEscaneada;
        data["completo"] = this.completo;
        data["causaFaltante"] = this.causaFaltante;
        data["usuarioRegistro"] = this.usuarioRegistro;
        data["recuperado"] = this.recuperado;
        data["usuarioRecuperacion"] = this.usuarioRecuperacion;
        data["fechaRecuperacion"] = this.fechaRecuperacion;
        return data;
    }
}

export interface ISabanaDollysExportQuery {
    commodityInventarioId?: number;
    codigoDolly?: string;
    fechaInicio?: string;
    fechaFin?: string;
    secuenciaInicio?: string;
    secuenciaFin?: string;
    commodity?: string;
    pageNumber?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
}

export class SabanaDollysExportQuery implements ISabanaDollysExportQuery {
    commodityInventarioId?: number;
    codigoDolly?: string;
    fechaInicio?: string;
    fechaFin?: string;
    secuenciaInicio?: string;
    secuenciaFin?: string;
    commodity?: string;
    pageNumber?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;

    constructor(data?: ISabanaDollysExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityInventarioId = data["commodityInventarioId"];
            this.codigoDolly = data["codigoDolly"];
            this.fechaInicio = data["fechaInicio"];
            this.fechaFin = data["fechaFin"];
            this.secuenciaInicio = data["secuenciaInicio"];
            this.secuenciaFin = data["secuenciaFin"];
            this.commodity = data["commodity"];
            this.pageNumber = data["pageNumber"];
            this.pageSize = data["pageSize"];
            this.sortBy = data["sortBy"];
            this.sortDirection = data["sortDirection"];
        }
    }

    static fromJS(data: any): SabanaDollysExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityInventarioId"] = this.commodityInventarioId;
        data["codigoDolly"] = this.codigoDolly;
        data["fechaInicio"] = this.fechaInicio;
        data["fechaFin"] = this.fechaFin;
        data["secuenciaInicio"] = this.secuenciaInicio;
        data["secuenciaFin"] = this.secuenciaFin;
        data["commodity"] = this.commodity;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface ISabanaDollysResumenItem {
    secuencia?: string;
    noParte?: string | null;
    completo?: number;
    causaFaltante?: string | null;
    programa?: string;
    commodity?: string;
    dolly?: string;
}

export class SabanaDollysResumenItem implements ISabanaDollysResumenItem {
    secuencia?: string;
    noParte?: string | null;
    completo?: number;
    causaFaltante?: string | null;
    programa?: string;
    commodity?: string;
    dolly?: string;

    constructor(data?: ISabanaDollysResumenItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secuencia = data["secuencia"];
            this.noParte = data["noParte"];
            this.completo = data["completo"];
            this.causaFaltante = data["causaFaltante"];
            this.programa = data["programa"];
            this.commodity = data["commodity"];
            this.dolly = data["dolly"];
        }
    }

    static fromJS(data: any): SabanaDollysResumenItem {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysResumenItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secuencia"] = this.secuencia;
        data["noParte"] = this.noParte;
        data["completo"] = this.completo;
        data["causaFaltante"] = this.causaFaltante;
        data["programa"] = this.programa;
        data["commodity"] = this.commodity;
        data["dolly"] = this.dolly;
        return data;
    }
}

export interface ISabanaDollysResumenResponse {
    items?: SabanaDollysResumenItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SabanaDollysResumenResponse implements ISabanaDollysResumenResponse {
    items?: SabanaDollysResumenItem[];
    totalCount?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: ISabanaDollysResumenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SabanaDollysResumenItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.currentPage = data["currentPage"];
            this.pageSize = data["pageSize"];
            this.totalPages = data["totalPages"];
            this.hasPreviousPage = data["hasPreviousPage"];
            this.hasNextPage = data["hasNextPage"];
        }
    }

    static fromJS(data: any): SabanaDollysResumenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysResumenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface ISabanaDollysResumenExportQuery {
    grupoInventarioId?: number | null;
    commodityCode?: string | null;
    codigoDolly?: string | null;
    fechaInicio?: string | null;
    fechaFin?: string | null;
    secuenciaInicio?: string | null;
    secuenciaFin?: string | null;
}

export class SabanaDollysResumenExportQuery implements ISabanaDollysResumenExportQuery {
    grupoInventarioId?: number | null;
    commodityCode?: string | null;
    codigoDolly?: string | null;
    fechaInicio?: string | null;
    fechaFin?: string | null;
    secuenciaInicio?: string | null;
    secuenciaFin?: string | null;

    constructor(data?: ISabanaDollysResumenExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grupoInventarioId = data["grupoInventarioId"];
            this.commodityCode = data["commodityCode"];
            this.codigoDolly = data["codigoDolly"];
            this.fechaInicio = data["fechaInicio"];
            this.fechaFin = data["fechaFin"];
            this.secuenciaInicio = data["secuenciaInicio"];
            this.secuenciaFin = data["secuenciaFin"];
        }
    }

    static fromJS(data: any): SabanaDollysResumenExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SabanaDollysResumenExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupoInventarioId"] = this.grupoInventarioId;
        data["commodityCode"] = this.commodityCode;
        data["codigoDolly"] = this.codigoDolly;
        data["fechaInicio"] = this.fechaInicio;
        data["fechaFin"] = this.fechaFin;
        data["secuenciaInicio"] = this.secuenciaInicio;
        data["secuenciaFin"] = this.secuenciaFin;
        return data;
    }
}

// ValidacionConfiguracion Service Proxy
@Injectable()
export class ValidacionConfiguracionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Obtiene la lista de validaciones de negocio configurables del tenant
     */
    getValidaciones(): Observable<ValidacionConfiguracionListResponse[]> {
        let url_ = this.baseUrl + "/api/validaciones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetValidaciones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidaciones(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processGetValidaciones(response: HttpResponseBase): Observable<ValidacionConfiguracionListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ValidacionConfiguracionListResponse.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualiza una o más validaciones de negocio configurables, identificadas por Codigo
     */
    updateValidaciones(input: ValidacionConfiguracionUpdateCommand): Observable<ValidacionConfiguracionUpdateResponse> {
        let url_ = this.baseUrl + "/api/validaciones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input.toJSON());

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateValidaciones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValidaciones(response_);
                } catch (e) {
                    return _observableThrow(e);
                }
            } else
                return _observableThrow(response_);
        }));
    }

    protected processUpdateValidaciones(response: HttpResponseBase): Observable<ValidacionConfiguracionUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        // El backend responde 200 (éxito) o 400 (validación fallida) con el mismo shape { success, message }
        if (status === 200 || status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result: any = null;
                let resultData = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result = ValidacionConfiguracionUpdateResponse.fromJS(resultData);
                return _observableOf(result);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ValidacionConfiguracionListResponse implements IValidacionConfiguracionListResponse {
    validacionConfiguracionId!: number;
    codigo!: string;
    nombre!: string;
    activa!: boolean;
    modo!: string;
    aplicaModo!: boolean;

    constructor(data?: IValidacionConfiguracionListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validacionConfiguracionId = _data["validacionConfiguracionId"];
            this.codigo = _data["codigo"];
            this.nombre = _data["nombre"];
            this.activa = _data["activa"];
            this.modo = _data["modo"];
            this.aplicaModo = _data["aplicaModo"];
        }
    }

    static fromJS(data: any): ValidacionConfiguracionListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidacionConfiguracionListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validacionConfiguracionId"] = this.validacionConfiguracionId;
        data["codigo"] = this.codigo;
        data["nombre"] = this.nombre;
        data["activa"] = this.activa;
        data["modo"] = this.modo;
        data["aplicaModo"] = this.aplicaModo;
        return data;
    }
}

export interface IValidacionConfiguracionListResponse {
    validacionConfiguracionId: number;
    codigo: string;
    nombre: string;
    activa: boolean;
    modo: string;
    aplicaModo: boolean;
}

export class ValidacionConfiguracionUpdateItem implements IValidacionConfiguracionUpdateItem {
    codigo!: string;
    activa!: boolean;
    modo!: string;

    constructor(data?: IValidacionConfiguracionUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.activa = _data["activa"];
            this.modo = _data["modo"];
        }
    }

    static fromJS(data: any): ValidacionConfiguracionUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ValidacionConfiguracionUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["activa"] = this.activa;
        data["modo"] = this.modo;
        return data;
    }
}

export interface IValidacionConfiguracionUpdateItem {
    codigo: string;
    activa: boolean;
    modo: string;
}

export class ValidacionConfiguracionUpdateCommand implements IValidacionConfiguracionUpdateCommand {
    validaciones: ValidacionConfiguracionUpdateItem[] = [];

    constructor(data?: IValidacionConfiguracionUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validaciones"])) {
                this.validaciones = [] as any;
                for (let item of _data["validaciones"])
                    this.validaciones!.push(ValidacionConfiguracionUpdateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidacionConfiguracionUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidacionConfiguracionUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validaciones)) {
            data["validaciones"] = [];
            for (let item of this.validaciones)
                data["validaciones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidacionConfiguracionUpdateCommand {
    validaciones: ValidacionConfiguracionUpdateItem[];
}

export class ValidacionConfiguracionUpdateResponse implements IValidacionConfiguracionUpdateResponse {
    success!: boolean;
    message!: string;

    constructor(data?: IValidacionConfiguracionUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidacionConfiguracionUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidacionConfiguracionUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IValidacionConfiguracionUpdateResponse {
    success: boolean;
    message: string;
}
